
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7VAO1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $grQe4 = parcelRequire("grQe4");

var $BB9MH = parcelRequire("BB9MH");

var $grT8q = parcelRequire("grT8q");

var $jOdAy = parcelRequire("jOdAy");

var $hNE9t = parcelRequire("hNE9t");

var $g0XVK = parcelRequire("g0XVK");

var $jLFhR = parcelRequire("jLFhR");

var $i9ydA = parcelRequire("i9ydA");

var $gb6F8 = parcelRequire("gb6F8");

var $O0YWs = parcelRequire("O0YWs");

var $51ra4 = parcelRequire("51ra4");

var $ei9kR = parcelRequire("ei9kR");

var $5Wkkl = parcelRequire("5Wkkl");

var $cCYFf = parcelRequire("cCYFf");

var $1XEa4 = parcelRequire("1XEa4");

var $9BwS8 = parcelRequire("9BwS8");

var $2Ea8V = parcelRequire("2Ea8V");

var $5xgnw = parcelRequire("5xgnw");

var $gg0a2 = parcelRequire("gg0a2");

var $hGRvQ = parcelRequire("hGRvQ");

var $eBvnD = parcelRequire("eBvnD");

var $kkRyJ = parcelRequire("kkRyJ");

var $eheGM = parcelRequire("eheGM");

var $1tZyf = parcelRequire("1tZyf");

var $btD8f = parcelRequire("btD8f");

var $eCpC3 = parcelRequire("eCpC3");

var $1yl4T = parcelRequire("1yl4T");

var $dPksP = parcelRequire("dPksP");

var $41JP2 = parcelRequire("41JP2");

var $4qhFj = parcelRequire("4qhFj");

var $c7Eb1 = parcelRequire("c7Eb1");

var $hh7n5 = parcelRequire("hh7n5");

var $8cgLj = parcelRequire("8cgLj");

var $fMJf2 = parcelRequire("fMJf2");

var $lvT7Y = parcelRequire("lvT7Y");

var $dh5pl = parcelRequire("dh5pl");

var $2CihR = parcelRequire("2CihR");

var $h6ffH = parcelRequire("h6ffH");

var $70O3a = parcelRequire("70O3a");

var $1Fdvb = parcelRequire("1Fdvb");

var $hSLhA = parcelRequire("hSLhA");

var $awmvd = parcelRequire("awmvd");

var $cmHh9 = parcelRequire("cmHh9");

var $8aQht = parcelRequire("8aQht");

var $enEvJ = parcelRequire("enEvJ");

var $9b9g3 = parcelRequire("9b9g3");

var $8fPtC = parcelRequire("8fPtC");

var $6s9LI = parcelRequire("6s9LI");

var $kH0lu = parcelRequire("kH0lu");

var $5WHdC = parcelRequire("5WHdC");

var $lTL01 = parcelRequire("lTL01");

var $lRxbk = parcelRequire("lRxbk");

var $03X1l = parcelRequire("03X1l");

var $l5EER = parcelRequire("l5EER");

var $fJV5C = parcelRequire("fJV5C");

var $4wj4l = parcelRequire("4wj4l");

var $iGuNe = parcelRequire("iGuNe");

var $aCZfw = parcelRequire("aCZfw");

var $afcYt = parcelRequire("afcYt");

var $gJqHH = parcelRequire("gJqHH");

var $bImKj = parcelRequire("bImKj");

var $jRDJO = parcelRequire("jRDJO");

var $4xiyx = parcelRequire("4xiyx");

var $h8Rq6 = parcelRequire("h8Rq6");

var $3SQuT = parcelRequire("3SQuT");

var $f5Oic = parcelRequire("f5Oic");

var $3FYnD = parcelRequire("3FYnD");

var $bSbnj = parcelRequire("bSbnj");

var $ddFNn = parcelRequire("ddFNn");

var $Z850u = parcelRequire("Z850u");

var $dJ4s3 = parcelRequire("dJ4s3");

var $ijdSf = parcelRequire("ijdSf");

var $bDtT1 = parcelRequire("bDtT1");

var $9bAWT = parcelRequire("9bAWT");

var $143wD = parcelRequire("143wD");

var $dhVZQ = parcelRequire("dhVZQ");

var $35EDI = parcelRequire("35EDI");

var $8H4WL = parcelRequire("8H4WL");

var $7ZJmt = parcelRequire("7ZJmt");

var $iXGvj = parcelRequire("iXGvj");

var $9Pp7A = parcelRequire("9Pp7A");

var $dPhDf = parcelRequire("dPhDf");

var $aIsqw = parcelRequire("aIsqw");

var $fwX2D = parcelRequire("fwX2D");

var $h89U9 = parcelRequire("h89U9");

var $1Henj = parcelRequire("1Henj");

var $ctNgl = parcelRequire("ctNgl");

var $h1zhX = parcelRequire("h1zhX");

var $8t4TU = parcelRequire("8t4TU");

var $kD0JT = parcelRequire("kD0JT");

var $ggJiZ = parcelRequire("ggJiZ");

var $J7Vkx = parcelRequire("J7Vkx");

var $aXwQY = parcelRequire("aXwQY");

var $akELB = parcelRequire("akELB");

var $lsSpE = parcelRequire("lsSpE");

var $9UYvI = parcelRequire("9UYvI");

var $4GhEv = parcelRequire("4GhEv");

var $cSoH4 = parcelRequire("cSoH4");

var $9FnMD = parcelRequire("9FnMD");

var $dbwDf = parcelRequire("dbwDf");

var $4onm8 = parcelRequire("4onm8");

var $444pX = parcelRequire("444pX");

var $bGovw = parcelRequire("bGovw");

var $lunNL = parcelRequire("lunNL");

var $h2aZ4 = parcelRequire("h2aZ4");

var $4SNSv = parcelRequire("4SNSv");

var $8wdL3 = parcelRequire("8wdL3");

var $93iOd = parcelRequire("93iOd");

var $8xCk9 = parcelRequire("8xCk9");

var $dHx3C = parcelRequire("dHx3C");

var $kUcj7 = parcelRequire("kUcj7");

var $7iTWP = parcelRequire("7iTWP");

var $2Ufnj = parcelRequire("2Ufnj");

var $3cmyB = parcelRequire("3cmyB");

var $17WZH = parcelRequire("17WZH");

var $fcqT7 = parcelRequire("fcqT7");

var $iaBGl = parcelRequire("iaBGl");

var $3ycrv = parcelRequire("3ycrv");

var $cZaOW = parcelRequire("cZaOW");

var $5IHEa = parcelRequire("5IHEa");

var $5iQrB = parcelRequire("5iQrB");

var $j8mWA = parcelRequire("j8mWA");

var $b4MOa = parcelRequire("b4MOa");

var $1fk7K = parcelRequire("1fk7K");

var $SMVsN = parcelRequire("SMVsN");

var $ixmfD = parcelRequire("ixmfD");

var $5tgpu = parcelRequire("5tgpu");

var $ezFpK = parcelRequire("ezFpK");

var $2Y94s = parcelRequire("2Y94s");

var $cBvXe = parcelRequire("cBvXe");

var $dmdSl = parcelRequire("dmdSl");

var $iBLjN = parcelRequire("iBLjN");

var $gJrb6 = parcelRequire("gJrb6");

var $1OlQS = parcelRequire("1OlQS");

var $6TngG = parcelRequire("6TngG");

var $3UXib = parcelRequire("3UXib");

var $g26pf = parcelRequire("g26pf");

var $dCNfD = parcelRequire("dCNfD");

var $7iVdf = parcelRequire("7iVdf");
module.exports.registerSpanErrorInstrumentation = $grQe4.registerSpanErrorInstrumentation;
module.exports.getCapturedScopesOnSpan = $BB9MH.getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $BB9MH.setCapturedScopesOnSpan;
module.exports.TRACING_DEFAULTS = $grT8q.TRACING_DEFAULTS;
module.exports.startIdleSpan = $grT8q.startIdleSpan;
module.exports.SentrySpan = $jOdAy.SentrySpan;
module.exports.SentryNonRecordingSpan = $hNE9t.SentryNonRecordingSpan;
module.exports.SPAN_STATUS_ERROR = $g0XVK.SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $g0XVK.SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $g0XVK.SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $g0XVK.getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $g0XVK.setHttpStatus;
module.exports.SUPPRESS_TRACING_KEY = $jLFhR.SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $jLFhR.continueTrace;
module.exports.startInactiveSpan = $jLFhR.startInactiveSpan;
module.exports.startNewTrace = $jLFhR.startNewTrace;
module.exports.startSpan = $jLFhR.startSpan;
module.exports.startSpanManual = $jLFhR.startSpanManual;
module.exports.suppressTracing = $jLFhR.suppressTracing;
module.exports.withActiveSpan = $jLFhR.withActiveSpan;
module.exports.getDynamicSamplingContextFromClient = $i9ydA.getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $i9ydA.getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $i9ydA.getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $i9ydA.spanToBaggageHeader;
module.exports.setMeasurement = $gb6F8.setMeasurement;
module.exports.timedEventsToMeasurements = $gb6F8.timedEventsToMeasurements;
module.exports.sampleSpan = $O0YWs.sampleSpan;
module.exports.logSpanEnd = $51ra4.logSpanEnd;
module.exports.logSpanStart = $51ra4.logSpanStart;
module.exports.captureSpan = $ei9kR.captureSpan;
module.exports.safeSetSpanJSONAttributes = $ei9kR.safeSetSpanJSONAttributes;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $5Wkkl.GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $5Wkkl.SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $5Wkkl.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $5Wkkl.SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $5Wkkl.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $5Wkkl.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $5Wkkl.SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $5Wkkl.SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $5Wkkl.SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $5Wkkl.SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $5Wkkl.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $5Wkkl.SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $5Wkkl.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;
module.exports.createEventEnvelope = $cCYFf.createEventEnvelope;
module.exports.createSessionEnvelope = $cCYFf.createSessionEnvelope;
module.exports.createSpanEnvelope = $cCYFf.createSpanEnvelope;
module.exports.addEventProcessor = $1XEa4.addEventProcessor;
module.exports.captureCheckIn = $1XEa4.captureCheckIn;
module.exports.captureEvent = $1XEa4.captureEvent;
module.exports.captureException = $1XEa4.captureException;
module.exports.captureMessage = $1XEa4.captureMessage;
module.exports.captureSession = $1XEa4.captureSession;
module.exports.close = $1XEa4.close;
module.exports.endSession = $1XEa4.endSession;
module.exports.flush = $1XEa4.flush;
module.exports.isEnabled = $1XEa4.isEnabled;
module.exports.isInitialized = $1XEa4.isInitialized;
module.exports.lastEventId = $1XEa4.lastEventId;
module.exports.setContext = $1XEa4.setContext;
module.exports.setConversationId = $1XEa4.setConversationId;
module.exports.setExtra = $1XEa4.setExtra;
module.exports.setExtras = $1XEa4.setExtras;
module.exports.setTag = $1XEa4.setTag;
module.exports.setTags = $1XEa4.setTags;
module.exports.setUser = $1XEa4.setUser;
module.exports.startSession = $1XEa4.startSession;
module.exports.withMonitor = $1XEa4.withMonitor;
module.exports.getClient = $9BwS8.getClient;
module.exports.getCurrentScope = $9BwS8.getCurrentScope;
module.exports.getExternalPropagationContext = $9BwS8.getExternalPropagationContext;
module.exports.getGlobalScope = $9BwS8.getGlobalScope;
module.exports.getIsolationScope = $9BwS8.getIsolationScope;
module.exports.getTraceContextFromScope = $9BwS8.getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $9BwS8.hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $9BwS8.registerExternalPropagationContext;
module.exports.withIsolationScope = $9BwS8.withIsolationScope;
module.exports.withScope = $9BwS8.withScope;
module.exports.getDefaultCurrentScope = $2Ea8V.getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $2Ea8V.getDefaultIsolationScope;
module.exports.setAsyncContextStrategy = $5xgnw.setAsyncContextStrategy;
module.exports.getGlobalSingleton = $gg0a2.getGlobalSingleton;
module.exports.getMainCarrier = $gg0a2.getMainCarrier;
module.exports.closeSession = $hGRvQ.closeSession;
module.exports.makeSession = $hGRvQ.makeSession;
module.exports.updateSession = $hGRvQ.updateSession;
module.exports.Scope = $eBvnD.Scope;
module.exports.notifyEventProcessors = $kkRyJ.notifyEventProcessors;
module.exports.SENTRY_API_VERSION = $eheGM.SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $eheGM.getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $eheGM.getReportDialogEndpoint;
module.exports.Client = $1tZyf.Client;
module.exports.initAndBind = $btD8f.initAndBind;
module.exports.setCurrentClient = $btD8f.setCurrentClient;
module.exports.createTransport = $eCpC3.createTransport;
module.exports.makeOfflineTransport = $1yl4T.makeOfflineTransport;
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $dPksP.MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.makeMultiplexedTransport = $dPksP.makeMultiplexedTransport;
module.exports.addIntegration = $41JP2.addIntegration;
module.exports.defineIntegration = $41JP2.defineIntegration;
module.exports.getIntegrationsToSetup = $41JP2.getIntegrationsToSetup;
module.exports.installedIntegrations = $41JP2.installedIntegrations;
module.exports._INTERNAL_clearAiProviderSkips = $4qhFj._INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $4qhFj._INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $4qhFj._INTERNAL_skipAiProviderWrapping;
module.exports.envToBool = $c7Eb1.envToBool;
module.exports.applyScopeDataToEvent = $hh7n5.applyScopeDataToEvent;
module.exports.getCombinedScopeData = $hh7n5.getCombinedScopeData;
module.exports.mergeScopeData = $hh7n5.mergeScopeData;
module.exports.prepareEvent = $8cgLj.prepareEvent;
module.exports.createCheckInEnvelope = $fMJf2.createCheckInEnvelope;
module.exports.hasSpansEnabled = $lvT7Y.hasSpansEnabled;
module.exports.isStreamedBeforeSendSpanCallback = $dh5pl.isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $dh5pl.withStreamedSpan;
module.exports.isSentryRequestUrl = $2CihR.isSentryRequestUrl;
module.exports.handleCallbackErrors = $h6ffH.handleCallbackErrors;
module.exports.fmt = $70O3a.fmt;
module.exports.parameterize = $70O3a.parameterize;
module.exports.handleTunnelRequest = $1Fdvb.handleTunnelRequest;
module.exports.addAutoIpAddressToSession = $hSLhA.addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $hSLhA.addAutoIpAddressToUser;
module.exports.INTERNAL_getSegmentSpan = $awmvd.INTERNAL_getSegmentSpan;
module.exports.addChildSpanToSpan = $awmvd.addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $awmvd.convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $awmvd.getActiveSpan;
module.exports.getRootSpan = $awmvd.getRootSpan;
module.exports.getSpanDescendants = $awmvd.getSpanDescendants;
module.exports.getStatusMessage = $awmvd.getStatusMessage;
module.exports.spanIsSampled = $awmvd.spanIsSampled;
module.exports.spanTimeInputToSeconds = $awmvd.spanTimeInputToSeconds;
module.exports.spanToJSON = $awmvd.spanToJSON;
module.exports.spanToStreamedSpanJSON = $awmvd.spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $awmvd.spanToTraceContext;
module.exports.spanToTraceHeader = $awmvd.spanToTraceHeader;
module.exports.updateSpanName = $awmvd.updateSpanName;
module.exports._INTERNAL_setSpanForScope = $cmHh9._setSpanForScope;
module.exports.parseSampleRate = $8aQht.parseSampleRate;
module.exports.applySdkMetadata = $enEvJ.applySdkMetadata;
module.exports.getTraceData = $9b9g3.getTraceData;
module.exports.shouldPropagateTraceForUrl = $8fPtC.shouldPropagateTraceForUrl;
module.exports.getTraceMetaTags = $6s9LI.getTraceMetaTags;
module.exports.debounce = $kH0lu.debounce;
module.exports.derefWeakRef = $5WHdC.derefWeakRef;
module.exports.makeWeakRef = $5WHdC.makeWeakRef;
module.exports.shouldIgnoreSpan = $lTL01.shouldIgnoreSpan;
module.exports.MAX_BODY_BYTE_LENGTH = $lRxbk.MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $lRxbk.captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $lRxbk.extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $lRxbk.getMaxBodyByteLength;
module.exports.headersToDict = $lRxbk.headersToDict;
module.exports.httpHeadersToSpanAttributes = $lRxbk.httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $lRxbk.httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $lRxbk.winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $lRxbk.winterCGRequestToRequestData;
module.exports.DEFAULT_ENVIRONMENT = $03X1l.DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $03X1l.DEV_ENVIRONMENT;
module.exports.addBreadcrumb = $l5EER.addBreadcrumb;
module.exports.functionToStringIntegration = $fJV5C.functionToStringIntegration;
module.exports.eventFiltersIntegration = $4wj4l.eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $4wj4l.inboundFiltersIntegration;
module.exports.linkedErrorsIntegration = $iGuNe.linkedErrorsIntegration;
module.exports.moduleMetadataIntegration = $aCZfw.moduleMetadataIntegration;
module.exports.requestDataIntegration = $afcYt.requestDataIntegration;
module.exports.captureConsoleIntegration = $gJqHH.captureConsoleIntegration;
module.exports.dedupeIntegration = $bImKj.dedupeIntegration;
module.exports.extraErrorDataIntegration = $jRDJO.extraErrorDataIntegration;
module.exports.rewriteFramesIntegration = $4xiyx.rewriteFramesIntegration;
module.exports.instrumentSupabaseClient = $h8Rq6.instrumentSupabaseClient;
module.exports.supabaseIntegration = $h8Rq6.supabaseIntegration;
module.exports.zodErrorsIntegration = $3SQuT.zodErrorsIntegration;
module.exports.thirdPartyErrorFilterIntegration = $f5Oic.thirdPartyErrorFilterIntegration;
module.exports.consoleIntegration = $3FYnD.consoleIntegration;
module.exports.featureFlagsIntegration = $bSbnj.featureFlagsIntegration;
module.exports.growthbookIntegration = $ddFNn.growthbookIntegration;
module.exports.conversationIdIntegration = $Z850u.conversationIdIntegration;
module.exports.profiler = $dJ4s3.profiler;
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $ijdSf._INTERNAL_getTracingHeadersForFetchRequest;
module.exports.instrumentFetchRequest = $ijdSf.instrumentFetchRequest;
module.exports.captureFeedback = $bDtT1.captureFeedback;
module.exports._INTERNAL_captureLog = $9bAWT._INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $9bAWT._INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $9bAWT._INTERNAL_flushLogsBuffer;
module.exports.logger = $143wD;
module.exports.consoleLoggingIntegration = $dhVZQ.consoleLoggingIntegration;
module.exports._INTERNAL_captureMetric = $35EDI._INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $35EDI._INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $35EDI._INTERNAL_flushMetricsBuffer;
module.exports.metrics = $8H4WL;
module.exports.createConsolaReporter = $7ZJmt.createConsolaReporter;
module.exports.addVercelAiProcessors = $iXGvj.addVercelAiProcessors;
module.exports._INTERNAL_cleanupToolCallSpanContext = $9Pp7A._INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $9Pp7A._INTERNAL_getSpanContextForToolCallId;
module.exports._INTERNAL_toolCallSpanContextMap = $dPhDf.toolCallSpanContextMap;
module.exports.instrumentOpenAiClient = $aIsqw.instrumentOpenAiClient;
module.exports.OPENAI_INTEGRATION_NAME = $fwX2D.OPENAI_INTEGRATION_NAME;
module.exports.instrumentAnthropicAiClient = $h89U9.instrumentAnthropicAiClient;
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $1Henj.ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.instrumentGoogleGenAIClient = $ctNgl.instrumentGoogleGenAIClient;
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $h1zhX.GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.createLangChainCallbackHandler = $8t4TU.createLangChainCallbackHandler;
module.exports.LANGCHAIN_INTEGRATION_NAME = $kD0JT.LANGCHAIN_INTEGRATION_NAME;
module.exports.instrumentCreateReactAgent = $ggJiZ.instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $ggJiZ.instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $ggJiZ.instrumentStateGraphCompile;
module.exports.LANGGRAPH_INTEGRATION_NAME = $J7Vkx.LANGGRAPH_INTEGRATION_NAME;
module.exports.SpanBuffer = $aXwQY.SpanBuffer;
module.exports.hasSpanStreamingEnabled = $akELB.hasSpanStreamingEnabled;
module.exports.spanStreamingIntegration = $lsSpE.spanStreamingIntegration;
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $9UYvI._INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $9UYvI._INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $9UYvI._INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $9UYvI._INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $9UYvI._INTERNAL_insertFlagToScope;
module.exports.applyAggregateErrorsToEvent = $4GhEv.applyAggregateErrorsToEvent;
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $cSoH4.getBreadcrumbLogLevelFromHttpStatusCode;
module.exports.dsnFromString = $9FnMD.dsnFromString;
module.exports.dsnToString = $9FnMD.dsnToString;
module.exports.makeDsn = $9FnMD.makeDsn;
module.exports.SentryError = $dbwDf.SentryError;
module.exports.GLOBAL_OBJ = $4onm8.GLOBAL_OBJ;
module.exports.addConsoleInstrumentationFilter = $444pX.addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $444pX.addConsoleInstrumentationHandler;
module.exports.addFetchEndInstrumentationHandler = $bGovw.addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $bGovw.addFetchInstrumentationHandler;
module.exports.addGlobalErrorInstrumentationHandler = $lunNL.addGlobalErrorInstrumentationHandler;
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $h2aZ4.addGlobalUnhandledRejectionInstrumentationHandler;
module.exports.addHandler = $4SNSv.addHandler;
module.exports.maybeInstrument = $4SNSv.maybeInstrument;
module.exports.resetInstrumentationHandlers = $4SNSv.resetInstrumentationHandlers;
module.exports.triggerHandlers = $4SNSv.triggerHandlers;
module.exports.isDOMError = $8wdL3.isDOMError;
module.exports.isDOMException = $8wdL3.isDOMException;
module.exports.isElement = $8wdL3.isElement;
module.exports.isError = $8wdL3.isError;
module.exports.isErrorEvent = $8wdL3.isErrorEvent;
module.exports.isEvent = $8wdL3.isEvent;
module.exports.isInstanceOf = $8wdL3.isInstanceOf;
module.exports.isParameterizedString = $8wdL3.isParameterizedString;
module.exports.isPlainObject = $8wdL3.isPlainObject;
module.exports.isPrimitive = $8wdL3.isPrimitive;
module.exports.isRegExp = $8wdL3.isRegExp;
module.exports.isString = $8wdL3.isString;
module.exports.isSyntheticEvent = $8wdL3.isSyntheticEvent;
module.exports.isThenable = $8wdL3.isThenable;
module.exports.isVueViewModel = $8wdL3.isVueViewModel;
module.exports.isBrowser = $93iOd.isBrowser;
module.exports.CONSOLE_LEVELS = $8xCk9.CONSOLE_LEVELS;
module.exports.consoleSandbox = $8xCk9.consoleSandbox;
module.exports.debug = $8xCk9.debug;
module.exports.originalConsoleMethods = $8xCk9.originalConsoleMethods;
module.exports.addContextToFrame = $dHx3C.addContextToFrame;
module.exports.addExceptionMechanism = $dHx3C.addExceptionMechanism;
module.exports.addExceptionTypeValue = $dHx3C.addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $dHx3C.checkOrSetAlreadyCaught;
module.exports.getEventDescription = $dHx3C.getEventDescription;
module.exports.isAlreadyCaptured = $dHx3C.isAlreadyCaptured;
module.exports.parseSemver = $dHx3C.parseSemver;
module.exports.uuid4 = $dHx3C.uuid4;
module.exports.normalize = $kUcj7.normalize;
module.exports.normalizeToSize = $kUcj7.normalizeToSize;
module.exports.normalizeUrlToBase = $kUcj7.normalizeUrlToBase;
module.exports.setNormalizationDepthOverrideHint = $7iTWP.setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $7iTWP.setSkipNormalizationHint;
module.exports.addNonEnumerableProperty = $2Ufnj.addNonEnumerableProperty;
module.exports.convertToPlainObject = $2Ufnj.convertToPlainObject;
module.exports.dropUndefinedKeys = $2Ufnj.dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $2Ufnj.extractExceptionKeysForMessage;
module.exports.fill = $2Ufnj.fill;
module.exports.getOriginalFunction = $2Ufnj.getOriginalFunction;
module.exports.markFunctionWrapped = $2Ufnj.markFunctionWrapped;
module.exports.objectify = $2Ufnj.objectify;
module.exports.basename = $3cmyB.basename;
module.exports.dirname = $3cmyB.dirname;
module.exports.isAbsolute = $3cmyB.isAbsolute;
module.exports.join = $3cmyB.join;
module.exports.normalizePath = $3cmyB.normalizePath;
module.exports.relative = $3cmyB.relative;
module.exports.resolve = $3cmyB.resolve;
module.exports.SENTRY_BUFFER_FULL_ERROR = $17WZH.SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $17WZH.makePromiseBuffer;
module.exports.severityLevelFromString = $fcqT7.severityLevelFromString;
module.exports.replaceExports = $iaBGl.replaceExports;
module.exports.UNKNOWN_FUNCTION = $3ycrv.UNKNOWN_FUNCTION;
module.exports.createStackParser = $3ycrv.createStackParser;
module.exports.getFramesFromEvent = $3ycrv.getFramesFromEvent;
module.exports.getFunctionName = $3ycrv.getFunctionName;
module.exports.stackParserFromStackParserOptions = $3ycrv.stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $3ycrv.stripSentryFramesAndReverse;
module.exports.isMatchingPattern = $cZaOW.isMatchingPattern;
module.exports.safeJoin = $cZaOW.safeJoin;
module.exports.snipLine = $cZaOW.snipLine;
module.exports.stringMatchesSomePattern = $cZaOW.stringMatchesSomePattern;
module.exports.truncate = $cZaOW.truncate;
module.exports.isNativeFunction = $5IHEa.isNativeFunction;
module.exports.supportsDOMError = $5IHEa.supportsDOMError;
module.exports.supportsDOMException = $5IHEa.supportsDOMException;
module.exports.supportsErrorEvent = $5IHEa.supportsErrorEvent;
module.exports.supportsFetch = $5IHEa.supportsFetch;
module.exports.supportsHistory = $5IHEa.supportsHistory;
module.exports.supportsNativeFetch = $5IHEa.supportsNativeFetch;
module.exports.supportsReferrerPolicy = $5IHEa.supportsReferrerPolicy;
module.exports.supportsReportingObserver = $5IHEa.supportsReportingObserver;
module.exports.SyncPromise = $5iQrB.SyncPromise;
module.exports.rejectedSyncPromise = $5iQrB.rejectedSyncPromise;
module.exports.resolvedSyncPromise = $5iQrB.resolvedSyncPromise;
module.exports.browserPerformanceTimeOrigin = $j8mWA.browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $j8mWA.dateTimestampInSeconds;
module.exports.timestampInSeconds = $j8mWA.timestampInSeconds;
module.exports.TRACEPARENT_REGEXP = $b4MOa.TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $b4MOa.extractTraceparentData;
module.exports.generateSentryTraceHeader = $b4MOa.generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $b4MOa.generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $b4MOa.propagationContextFromHeaders;
module.exports.shouldContinueTrace = $b4MOa.shouldContinueTrace;
module.exports.getSDKSource = $1fk7K.getSDKSource;
module.exports.isBrowserBundle = $1fk7K.isBrowserBundle;
module.exports.addItemToEnvelope = $SMVsN.addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $SMVsN.createAttachmentEnvelopeItem;
module.exports.createEnvelope = $SMVsN.createEnvelope;
module.exports.createEventEnvelopeHeaders = $SMVsN.createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $SMVsN.createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $SMVsN.envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $SMVsN.envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $SMVsN.forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $SMVsN.getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $SMVsN.parseEnvelope;
module.exports.serializeEnvelope = $SMVsN.serializeEnvelope;
module.exports.createClientReportEnvelope = $ixmfD.createClientReportEnvelope;
module.exports.DEFAULT_RETRY_AFTER = $5tgpu.DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $5tgpu.disabledUntil;
module.exports.isRateLimited = $5tgpu.isRateLimited;
module.exports.parseRetryAfterHeader = $5tgpu.parseRetryAfterHeader;
module.exports.updateRateLimits = $5tgpu.updateRateLimits;
module.exports.MAX_BAGGAGE_STRING_LENGTH = $ezFpK.MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $ezFpK.SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $ezFpK.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $ezFpK.baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $ezFpK.dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $ezFpK.mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $ezFpK.objectToBaggageHeader;
module.exports.parseBaggageHeader = $ezFpK.parseBaggageHeader;
module.exports.getHttpSpanDetailsFromUrlObject = $2Y94s.getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $2Y94s.getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $2Y94s.getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $2Y94s.isURLObjectRelative;
module.exports.parseStringToURLObject = $2Y94s.parseStringToURLObject;
module.exports.parseUrl = $2Y94s.parseUrl;
module.exports.stripDataUrlContent = $2Y94s.stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $2Y94s.stripUrlQueryAndFragment;
module.exports._INTERNAL_enhanceErrorWithSentryInfo = $cBvXe._enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $cBvXe.eventFromMessage;
module.exports.eventFromUnknownInput = $cBvXe.eventFromUnknownInput;
module.exports.exceptionFromError = $cBvXe.exceptionFromError;
module.exports.parseStackFrames = $cBvXe.parseStackFrames;
module.exports.LRUMap = $dmdSl.LRUMap;
module.exports.generateSpanId = $iBLjN.generateSpanId;
module.exports.generateTraceId = $iBLjN.generateTraceId;
module.exports.SDK_VERSION = $gJrb6.SDK_VERSION;
module.exports.getDebugImagesForResources = $1OlQS.getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $1OlQS.getFilenameToDebugIdMap;
module.exports.getFilenameToMetadataMap = $6TngG.getFilenameToMetadataMap;
module.exports.escapeStringForRegex = $3UXib.escapeStringForRegex;
module.exports._INTERNAL_safeDateNow = $g26pf.safeDateNow;
module.exports._INTERNAL_safeMathRandom = $g26pf.safeMathRandom;
module.exports._INTERNAL_withRandomSafeContext = $g26pf.withRandomSafeContext;
module.exports.getComponentName = $dCNfD.getComponentName;
module.exports.getLocationHref = $dCNfD.getLocationHref;
module.exports.htmlTreeAsString = $dCNfD.htmlTreeAsString;
module.exports.instrumentLangChainEmbeddings = $7iVdf.instrumentLangChainEmbeddings;

});
parcelRegister("grQe4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $lunNL = parcelRequire("lunNL");

var $h2aZ4 = parcelRequire("h2aZ4");

var $8xCk9 = parcelRequire("8xCk9");

var $awmvd = parcelRequire("awmvd");

var $g0XVK = parcelRequire("g0XVK");
let $bf97adf1d4cd75d4$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $bf97adf1d4cd75d4$var$registerSpanErrorInstrumentation() {
    if ($bf97adf1d4cd75d4$var$errorsInstrumented) return;
    /**
   * If an error or unhandled promise occurs, we mark the active root span as failed
   */ function errorCallback() {
        const activeSpan = $awmvd.getActiveSpan();
        const rootSpan = activeSpan && $awmvd.getRootSpan(activeSpan);
        if (rootSpan) {
            const message = 'internal_error';
            $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`[Tracing] Root span: ${message} -> Global error occurred`);
            rootSpan.setStatus({
                code: $g0XVK.SPAN_STATUS_ERROR,
                message: message
            });
        }
    }
    // The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
    // node.js default exit behaviour
    errorCallback.tag = 'sentry_tracingErrorCallback';
    $bf97adf1d4cd75d4$var$errorsInstrumented = true;
    $lunNL.addGlobalErrorInstrumentationHandler(errorCallback);
    $h2aZ4.addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}
module.exports.registerSpanErrorInstrumentation = $bf97adf1d4cd75d4$var$registerSpanErrorInstrumentation;

});
parcelRegister("kcA99", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $eb50f79b2bd91623$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports.DEBUG_BUILD = $eb50f79b2bd91623$var$DEBUG_BUILD;

});

parcelRegister("lunNL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4onm8 = parcelRequire("4onm8");

var $4SNSv = parcelRequire("4SNSv");
let $fa4edcd3298511b6$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $fa4edcd3298511b6$var$addGlobalErrorInstrumentationHandler(handler) {
    const type = 'error';
    $4SNSv.addHandler(type, handler);
    $4SNSv.maybeInstrument(type, $fa4edcd3298511b6$var$instrumentError);
}
function $fa4edcd3298511b6$var$instrumentError() {
    $fa4edcd3298511b6$var$_oldOnErrorHandler = $4onm8.GLOBAL_OBJ.onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    $4onm8.GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        $4SNSv.triggerHandlers('error', handlerData);
        if ($fa4edcd3298511b6$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $fa4edcd3298511b6$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $4onm8.GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalErrorInstrumentationHandler = $fa4edcd3298511b6$var$addGlobalErrorInstrumentationHandler;

});
parcelRegister("4onm8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $332b855b72b9648f$var$GLOBAL_OBJ = globalThis;
module.exports.GLOBAL_OBJ = $332b855b72b9648f$var$GLOBAL_OBJ;

});

parcelRegister("4SNSv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $3ycrv = parcelRequire("3ycrv");
// We keep the handlers globally
const $38e2e558f2bc39e4$var$handlers = {};
const $38e2e558f2bc39e4$var$instrumented = {};
/** Add a handler function. Returns a function to remove the handler. */ function $38e2e558f2bc39e4$var$addHandler(type, handler) {
    $38e2e558f2bc39e4$var$handlers[type] = $38e2e558f2bc39e4$var$handlers[type] || [];
    $38e2e558f2bc39e4$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $38e2e558f2bc39e4$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $38e2e558f2bc39e4$var$resetInstrumentationHandlers() {
    Object.keys($38e2e558f2bc39e4$var$handlers).forEach((key)=>{
        $38e2e558f2bc39e4$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $38e2e558f2bc39e4$var$maybeInstrument(type, instrumentFn) {
    if (!$38e2e558f2bc39e4$var$instrumented[type]) {
        $38e2e558f2bc39e4$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $38e2e558f2bc39e4$var$triggerHandlers(type, data) {
    const typeHandlers = type && $38e2e558f2bc39e4$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${$3ycrv.getFunctionName(handler)}\nError:`, e);
    }
}
module.exports.addHandler = $38e2e558f2bc39e4$var$addHandler;
module.exports.maybeInstrument = $38e2e558f2bc39e4$var$maybeInstrument;
module.exports.resetInstrumentationHandlers = $38e2e558f2bc39e4$var$resetInstrumentationHandlers;
module.exports.triggerHandlers = $38e2e558f2bc39e4$var$triggerHandlers;

});
parcelRegister("8xCk9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gg0a2 = parcelRequire("gg0a2");

var $kcA99 = parcelRequire("kcA99");

var $4onm8 = parcelRequire("4onm8");
const $637f222517952f9a$var$CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $637f222517952f9a$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $637f222517952f9a$var$originalConsoleMethods = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $637f222517952f9a$var$consoleSandbox(callback) {
    if (!('console' in $4onm8.GLOBAL_OBJ)) return callback();
    const console = $4onm8.GLOBAL_OBJ.console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($637f222517952f9a$var$originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $637f222517952f9a$var$originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $637f222517952f9a$var$enable() {
    $637f222517952f9a$var$_getLoggerSettings().enabled = true;
}
function $637f222517952f9a$var$disable() {
    $637f222517952f9a$var$_getLoggerSettings().enabled = false;
}
function $637f222517952f9a$var$isEnabled() {
    return $637f222517952f9a$var$_getLoggerSettings().enabled;
}
function $637f222517952f9a$var$log(...args) {
    $637f222517952f9a$var$_maybeLog('log', ...args);
}
function $637f222517952f9a$var$warn(...args) {
    $637f222517952f9a$var$_maybeLog('warn', ...args);
}
function $637f222517952f9a$var$error(...args) {
    $637f222517952f9a$var$_maybeLog('error', ...args);
}
function $637f222517952f9a$var$_maybeLog(level, ...args) {
    if (!$kcA99.DEBUG_BUILD) return;
    if ($637f222517952f9a$var$isEnabled()) $637f222517952f9a$var$consoleSandbox(()=>{
        $4onm8.GLOBAL_OBJ.console[level](`${$637f222517952f9a$var$PREFIX}[${level}]:`, ...args);
    });
}
function $637f222517952f9a$var$_getLoggerSettings() {
    if (!$kcA99.DEBUG_BUILD) return {
        enabled: false
    };
    return $gg0a2.getGlobalSingleton('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $637f222517952f9a$var$debug = {
    enable: /** Enable logging. */ $637f222517952f9a$var$enable,
    disable: /** Disable logging. */ $637f222517952f9a$var$disable,
    isEnabled: /** Check if logging is enabled. */ $637f222517952f9a$var$isEnabled,
    log: /** Log a message. */ $637f222517952f9a$var$log,
    warn: /** Log a warning. */ $637f222517952f9a$var$warn,
    error: /** Log an error. */ $637f222517952f9a$var$error
};
module.exports.CONSOLE_LEVELS = $637f222517952f9a$var$CONSOLE_LEVELS;
module.exports.consoleSandbox = $637f222517952f9a$var$consoleSandbox;
module.exports.debug = $637f222517952f9a$var$debug;
module.exports.originalConsoleMethods = $637f222517952f9a$var$originalConsoleMethods;

});
parcelRegister("gg0a2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gJrb6 = parcelRequire("gJrb6");

var $4onm8 = parcelRequire("4onm8");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $bd5e43ec4075617f$var$getMainCarrier() {
    // This ensures a Sentry carrier exists
    $bd5e43ec4075617f$var$getSentryCarrier($4onm8.GLOBAL_OBJ);
    return $4onm8.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $bd5e43ec4075617f$var$getSentryCarrier(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || $gJrb6.SDK_VERSION;
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[$gJrb6.SDK_VERSION] = __SENTRY__[$gJrb6.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $bd5e43ec4075617f$var$getGlobalSingleton(name, creator, obj = $4onm8.GLOBAL_OBJ) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[$gJrb6.SDK_VERSION] = __SENTRY__[$gJrb6.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}
module.exports.getGlobalSingleton = $bd5e43ec4075617f$var$getGlobalSingleton;
module.exports.getMainCarrier = $bd5e43ec4075617f$var$getMainCarrier;
module.exports.getSentryCarrier = $bd5e43ec4075617f$var$getSentryCarrier;

});
parcelRegister("gJrb6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// This is a magic string replaced by rollup
const $c2e5ee55678f196e$var$SDK_VERSION = "10.53.1";
module.exports.SDK_VERSION = $c2e5ee55678f196e$var$SDK_VERSION;

});



parcelRegister("3ycrv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $295e32f2f8e5a281$var$STACKTRACE_FRAME_LIMIT = 50;
const $295e32f2f8e5a281$var$UNKNOWN_FUNCTION = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $295e32f2f8e5a281$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $295e32f2f8e5a281$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $295e32f2f8e5a281$var$createStackParser(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $295e32f2f8e5a281$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($295e32f2f8e5a281$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            // Using includes() instead of a regex to avoid O(n²) backtracking on long lines
            // https://github.com/getsentry/sentry-javascript/issues/20052
            if (cleanedLine.includes('Error: ')) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $295e32f2f8e5a281$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $295e32f2f8e5a281$var$stripSentryFramesAndReverse(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $295e32f2f8e5a281$var$stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return $295e32f2f8e5a281$var$createStackParser(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $295e32f2f8e5a281$var$stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($295e32f2f8e5a281$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($295e32f2f8e5a281$var$STRIP_FRAME_REGEXP.test($295e32f2f8e5a281$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($295e32f2f8e5a281$var$STRIP_FRAME_REGEXP.test($295e32f2f8e5a281$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $295e32f2f8e5a281$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $295e32f2f8e5a281$var$getLastStackFrame(localStack).filename,
            function: frame.function || $295e32f2f8e5a281$var$UNKNOWN_FUNCTION
        }));
}
function $295e32f2f8e5a281$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $295e32f2f8e5a281$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $295e32f2f8e5a281$var$getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $295e32f2f8e5a281$var$defaultFunctionName;
        return fn.name || $295e32f2f8e5a281$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $295e32f2f8e5a281$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $295e32f2f8e5a281$var$getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function $295e32f2f8e5a281$var$getVueInternalName(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function $295e32f2f8e5a281$var$normalizeStackTracePath(path) {
    let filename = path?.startsWith('file://') ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}
module.exports.UNKNOWN_FUNCTION = $295e32f2f8e5a281$var$UNKNOWN_FUNCTION;
module.exports.createStackParser = $295e32f2f8e5a281$var$createStackParser;
module.exports.getFramesFromEvent = $295e32f2f8e5a281$var$getFramesFromEvent;
module.exports.getFunctionName = $295e32f2f8e5a281$var$getFunctionName;
module.exports.getVueInternalName = $295e32f2f8e5a281$var$getVueInternalName;
module.exports.normalizeStackTracePath = $295e32f2f8e5a281$var$normalizeStackTracePath;
module.exports.stackParserFromStackParserOptions = $295e32f2f8e5a281$var$stackParserFromStackParserOptions;
module.exports.stripSentryFramesAndReverse = $295e32f2f8e5a281$var$stripSentryFramesAndReverse;

});



parcelRegister("h2aZ4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4onm8 = parcelRequire("4onm8");

var $4SNSv = parcelRequire("4SNSv");
let $c66b24c6e5ba4f44$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c66b24c6e5ba4f44$var$addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    const type = 'unhandledrejection';
    $4SNSv.addHandler(type, handler);
    $4SNSv.maybeInstrument(type, $c66b24c6e5ba4f44$var$instrumentUnhandledRejection);
}
function $c66b24c6e5ba4f44$var$instrumentUnhandledRejection() {
    $c66b24c6e5ba4f44$var$_oldOnUnhandledRejectionHandler = $4onm8.GLOBAL_OBJ.onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    $4onm8.GLOBAL_OBJ.onunhandledrejection = function(e) {
        const handlerData = e;
        $4SNSv.triggerHandlers('unhandledrejection', handlerData);
        if ($c66b24c6e5ba4f44$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $c66b24c6e5ba4f44$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $4onm8.GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
module.exports.addGlobalUnhandledRejectionInstrumentationHandler = $c66b24c6e5ba4f44$var$addGlobalUnhandledRejectionInstrumentationHandler;

});

parcelRegister("awmvd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xgnw = parcelRequire("5xgnw");

var $i1sH5 = parcelRequire("i1sH5");

var $gg0a2 = parcelRequire("gg0a2");

var $9BwS8 = parcelRequire("9BwS8");

var $5Wkkl = parcelRequire("5Wkkl");

var $g0XVK = parcelRequire("g0XVK");

var $BB9MH = parcelRequire("BB9MH");

var $2Ufnj = parcelRequire("2Ufnj");

var $iBLjN = parcelRequire("iBLjN");

var $j8mWA = parcelRequire("j8mWA");

var $b4MOa = parcelRequire("b4MOa");

var $8xCk9 = parcelRequire("8xCk9");

var $cmHh9 = parcelRequire("cmHh9");
// These are aligned with OpenTelemetry trace flags
const $7a8e590eab93ebdd$var$TRACE_FLAG_NONE = 0x0;
const $7a8e590eab93ebdd$var$TRACE_FLAG_SAMPLED = 0x1;
let $7a8e590eab93ebdd$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $7a8e590eab93ebdd$var$spanToTransactionTraceContext(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $7a8e590eab93ebdd$var$spanToJSON(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $7a8e590eab93ebdd$var$spanToTraceContext(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $7a8e590eab93ebdd$var$spanToJSON(span).parent_span_id;
    const scope = $BB9MH.getCapturedScopesOnSpan(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || $iBLjN.generateSpanId() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $7a8e590eab93ebdd$var$spanToTraceHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $7a8e590eab93ebdd$var$spanIsSampled(span);
    return $b4MOa.generateSentryTraceHeader(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function $7a8e590eab93ebdd$var$spanToTraceparentHeader(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $7a8e590eab93ebdd$var$spanIsSampled(span);
    return $b4MOa.generateTraceparentHeader(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $7a8e590eab93ebdd$var$convertSpanLinksForEnvelope(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $7a8e590eab93ebdd$var$TRACE_FLAG_SAMPLED,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Converts the span links array to a flattened version with serialized attributes for V2 spans.
 *
 * If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $7a8e590eab93ebdd$var$getStreamedSpanLinks(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $7a8e590eab93ebdd$var$TRACE_FLAG_SAMPLED,
            attributes: attributes
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $7a8e590eab93ebdd$var$spanTimeInputToSeconds(input) {
    if (typeof input === 'number') return $7a8e590eab93ebdd$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $7a8e590eab93ebdd$var$ensureTimestampInSeconds(input.getTime());
    return $j8mWA.timestampInSeconds();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $7a8e590eab93ebdd$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $7a8e590eab93ebdd$var$spanToJSON(span) {
    if ($7a8e590eab93ebdd$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($7a8e590eab93ebdd$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $7a8e590eab93ebdd$var$getOtelParentSpanId(span),
            start_timestamp: $7a8e590eab93ebdd$var$spanTimeInputToSeconds(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $7a8e590eab93ebdd$var$spanTimeInputToSeconds(endTime) || undefined,
            status: $7a8e590eab93ebdd$var$getStatusMessage(status),
            op: attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $7a8e590eab93ebdd$var$convertSpanLinksForEnvelope(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
/**
 * Convert a span to the intermediate {@link StreamedSpanJSON} representation.
 */ function $7a8e590eab93ebdd$var$spanToStreamedSpanJSON(span) {
    if ($7a8e590eab93ebdd$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($7a8e590eab93ebdd$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $7a8e590eab93ebdd$var$getOtelParentSpanId(span),
            start_timestamp: $7a8e590eab93ebdd$var$spanTimeInputToSeconds(startTime),
            end_timestamp: $7a8e590eab93ebdd$var$spanTimeInputToSeconds(endTime),
            is_segment: span === $7a8e590eab93ebdd$var$INTERNAL_getSegmentSpan(span),
            status: $7a8e590eab93ebdd$var$getSimpleStatusMessage(status),
            attributes: attributes,
            links: $7a8e590eab93ebdd$var$getStreamedSpanLinks(links)
        };
    }
    // Finally, as a fallback, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: '',
        end_timestamp: 0,
        status: 'ok',
        is_segment: span === $7a8e590eab93ebdd$var$INTERNAL_getSegmentSpan(span)
    };
}
/**
 * In preparation for the next major of OpenTelemetry, we want to support
 * looking up the parent span id according to the new API
 * In OTel v1, the parent span id is accessed as `parentSpanId`
 * In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
 */ function $7a8e590eab93ebdd$var$getOtelParentSpanId(span) {
    return 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
}
/**
 * Converts a {@link StreamedSpanJSON} to a {@link SerializedSpan}.
 * This is the final serialized span format that is sent to Sentry.
 * The returned serilaized spans must not be consumed by users or SDK integrations.
 */ function $7a8e590eab93ebdd$var$streamedSpanJsonToSerializedSpan(spanJson) {
    return {
        ...spanJson,
        attributes: $i1sH5.serializeAttributes(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: $i1sH5.serializeAttributes(link.attributes)
            }))
    };
}
function $7a8e590eab93ebdd$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $7a8e590eab93ebdd$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $7a8e590eab93ebdd$var$spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $7a8e590eab93ebdd$var$TRACE_FLAG_SAMPLED;
}
/** Get the status message to use for a JSON representation of a span. */ function $7a8e590eab93ebdd$var$getStatusMessage(status) {
    if (!status || status.code === $g0XVK.SPAN_STATUS_UNSET) return undefined;
    if (status.code === $g0XVK.SPAN_STATUS_OK) return 'ok';
    return status.message || 'internal_error';
}
/**
 * Convert the various statuses to the simple ones expected by Sentry for streamed spans ('ok' is default).
 */ function $7a8e590eab93ebdd$var$getSimpleStatusMessage(status) {
    return !status || status.code === $g0XVK.SPAN_STATUS_OK || status.code === $g0XVK.SPAN_STATUS_UNSET || status.message === 'cancelled' ? 'ok' : 'error';
}
const $7a8e590eab93ebdd$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $7a8e590eab93ebdd$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $7a8e590eab93ebdd$var$addChildSpanToSpan(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$7a8e590eab93ebdd$var$ROOT_SPAN_FIELD] || span;
    $2Ufnj.addNonEnumerableProperty(childSpan, $7a8e590eab93ebdd$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$7a8e590eab93ebdd$var$CHILD_SPANS_FIELD]) span[$7a8e590eab93ebdd$var$CHILD_SPANS_FIELD].add(childSpan);
    else $2Ufnj.addNonEnumerableProperty(span, $7a8e590eab93ebdd$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $7a8e590eab93ebdd$var$removeChildSpanFromSpan(span, childSpan) {
    if (span[$7a8e590eab93ebdd$var$CHILD_SPANS_FIELD]) span[$7a8e590eab93ebdd$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $7a8e590eab93ebdd$var$getSpanDescendants(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($7a8e590eab93ebdd$var$spanIsSampled(span)) {
            resultSet.add(span);
            const childSpans = span[$7a8e590eab93ebdd$var$CHILD_SPANS_FIELD] ? Array.from(span[$7a8e590eab93ebdd$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ const $7a8e590eab93ebdd$var$getRootSpan = $7a8e590eab93ebdd$var$INTERNAL_getSegmentSpan;
/**
 * Returns the segment span of a given span.
 */ function $7a8e590eab93ebdd$var$INTERNAL_getSegmentSpan(span) {
    return span[$7a8e590eab93ebdd$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $7a8e590eab93ebdd$var$getActiveSpan() {
    const carrier$1 = $gg0a2.getMainCarrier();
    const acs = $5xgnw.getAsyncContextStrategy(carrier$1);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return $cmHh9._getSpanForScope($9BwS8.getCurrentScope());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $7a8e590eab93ebdd$var$showSpanDropWarning() {
    if (!$7a8e590eab93ebdd$var$hasShownSpanDropWarning) {
        $8xCk9.consoleSandbox(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        $7a8e590eab93ebdd$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $7a8e590eab93ebdd$var$updateSpanName(span, name) {
    span.updateName(name);
    span.setAttributes({
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'custom',
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME]: name
    });
}
module.exports.INTERNAL_getSegmentSpan = $7a8e590eab93ebdd$var$INTERNAL_getSegmentSpan;
module.exports.TRACE_FLAG_NONE = $7a8e590eab93ebdd$var$TRACE_FLAG_NONE;
module.exports.TRACE_FLAG_SAMPLED = $7a8e590eab93ebdd$var$TRACE_FLAG_SAMPLED;
module.exports.addChildSpanToSpan = $7a8e590eab93ebdd$var$addChildSpanToSpan;
module.exports.convertSpanLinksForEnvelope = $7a8e590eab93ebdd$var$convertSpanLinksForEnvelope;
module.exports.getActiveSpan = $7a8e590eab93ebdd$var$getActiveSpan;
module.exports.getRootSpan = $7a8e590eab93ebdd$var$getRootSpan;
module.exports.getSimpleStatusMessage = $7a8e590eab93ebdd$var$getSimpleStatusMessage;
module.exports.getSpanDescendants = $7a8e590eab93ebdd$var$getSpanDescendants;
module.exports.getStatusMessage = $7a8e590eab93ebdd$var$getStatusMessage;
module.exports.getStreamedSpanLinks = $7a8e590eab93ebdd$var$getStreamedSpanLinks;
module.exports.removeChildSpanFromSpan = $7a8e590eab93ebdd$var$removeChildSpanFromSpan;
module.exports.showSpanDropWarning = $7a8e590eab93ebdd$var$showSpanDropWarning;
module.exports.spanIsSampled = $7a8e590eab93ebdd$var$spanIsSampled;
module.exports.spanTimeInputToSeconds = $7a8e590eab93ebdd$var$spanTimeInputToSeconds;
module.exports.spanToJSON = $7a8e590eab93ebdd$var$spanToJSON;
module.exports.spanToStreamedSpanJSON = $7a8e590eab93ebdd$var$spanToStreamedSpanJSON;
module.exports.spanToTraceContext = $7a8e590eab93ebdd$var$spanToTraceContext;
module.exports.spanToTraceHeader = $7a8e590eab93ebdd$var$spanToTraceHeader;
module.exports.spanToTraceparentHeader = $7a8e590eab93ebdd$var$spanToTraceparentHeader;
module.exports.spanToTransactionTraceContext = $7a8e590eab93ebdd$var$spanToTransactionTraceContext;
module.exports.streamedSpanJsonToSerializedSpan = $7a8e590eab93ebdd$var$streamedSpanJsonToSerializedSpan;
module.exports.updateSpanName = $7a8e590eab93ebdd$var$updateSpanName;

});
parcelRegister("5xgnw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gg0a2 = parcelRequire("gg0a2");

var $kYkfp = parcelRequire("kYkfp");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $407cbd35c3e2d22c$var$setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    const registry = $gg0a2.getMainCarrier();
    const sentry = $gg0a2.getSentryCarrier(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $407cbd35c3e2d22c$var$getAsyncContextStrategy(carrier$1) {
    const sentry = $gg0a2.getSentryCarrier(carrier$1);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return $kYkfp.getStackAsyncContextStrategy();
}
module.exports.getAsyncContextStrategy = $407cbd35c3e2d22c$var$getAsyncContextStrategy;
module.exports.setAsyncContextStrategy = $407cbd35c3e2d22c$var$setAsyncContextStrategy;

});
parcelRegister("kYkfp", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Ea8V = parcelRequire("2Ea8V");

var $eBvnD = parcelRequire("eBvnD");

var $2Q5Le = parcelRequire("2Q5Le");

var $8wdL3 = parcelRequire("8wdL3");

var $gg0a2 = parcelRequire("gg0a2");
/**
 * This is an object that holds a stack of scopes.
 */ class $f4491df88670c533$var$AsyncContextStack {
    constructor(scope$1, isolationScope){
        let assignedScope;
        if (!scope$1) assignedScope = new $eBvnD.Scope();
        else assignedScope = scope$1;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new $eBvnD.Scope();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ($8wdL3.isThenable(maybePromiseResult)) return $2Q5Le.chainAndCopyPromiseLike(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $f4491df88670c533$var$getAsyncContextStack() {
    const registry = $gg0a2.getMainCarrier();
    const sentry = $gg0a2.getSentryCarrier(registry);
    return sentry.stack = sentry.stack || new $f4491df88670c533$var$AsyncContextStack($2Ea8V.getDefaultCurrentScope(), $2Ea8V.getDefaultIsolationScope());
}
function $f4491df88670c533$var$withScope(callback) {
    return $f4491df88670c533$var$getAsyncContextStack().withScope(callback);
}
function $f4491df88670c533$var$withSetScope(scope, callback) {
    const stack = $f4491df88670c533$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $f4491df88670c533$var$withIsolationScope(callback) {
    return $f4491df88670c533$var$getAsyncContextStack().withScope(()=>{
        return callback($f4491df88670c533$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $f4491df88670c533$var$getStackAsyncContextStrategy() {
    return {
        withIsolationScope: $f4491df88670c533$var$withIsolationScope,
        withScope: $f4491df88670c533$var$withScope,
        withSetScope: $f4491df88670c533$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $f4491df88670c533$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$f4491df88670c533$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$f4491df88670c533$var$getAsyncContextStack().getIsolationScope()
    };
}
module.exports.AsyncContextStack = $f4491df88670c533$var$AsyncContextStack;
module.exports.getStackAsyncContextStrategy = $f4491df88670c533$var$getStackAsyncContextStrategy;

});
parcelRegister("2Ea8V", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gg0a2 = parcelRequire("gg0a2");

var $eBvnD = parcelRequire("eBvnD");
/** Get the default current scope. */ function $1ed72f65341de4cc$var$getDefaultCurrentScope() {
    return $gg0a2.getGlobalSingleton('defaultCurrentScope', ()=>new $eBvnD.Scope());
}
/** Get the default isolation scope. */ function $1ed72f65341de4cc$var$getDefaultIsolationScope() {
    return $gg0a2.getGlobalSingleton('defaultIsolationScope', ()=>new $eBvnD.Scope());
}
module.exports.getDefaultCurrentScope = $1ed72f65341de4cc$var$getDefaultCurrentScope;
module.exports.getDefaultIsolationScope = $1ed72f65341de4cc$var$getDefaultIsolationScope;

});
parcelRegister("eBvnD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $hGRvQ = parcelRequire("hGRvQ");

var $8xCk9 = parcelRequire("8xCk9");

var $8wdL3 = parcelRequire("8wdL3");

var $6BF4X = parcelRequire("6BF4X");

var $dHx3C = parcelRequire("dHx3C");

var $iBLjN = parcelRequire("iBLjN");

var $g26pf = parcelRequire("g26pf");

var $cmHh9 = parcelRequire("cmHh9");

var $cZaOW = parcelRequire("cZaOW");

var $j8mWA = parcelRequire("j8mWA");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $aa1cdcd93a2770f8$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $aa1cdcd93a2770f8$var$Scope {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Attributes */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ /** Conversation ID */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: $iBLjN.generateTraceId(),
            sampleRand: $g26pf.safeMathRandom()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $aa1cdcd93a2770f8$var$Scope();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        $cmHh9._setSpanForScope(newScope, $cmHh9._getSpanForScope(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) $hGRvQ.updateSession(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || undefined;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $aa1cdcd93a2770f8$var$Scope ? scopeToMerge.getScopeData() : $8wdL3.isPlainObject(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        this._conversationId = undefined;
        $cmHh9._setSpanForScope(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: $iBLjN.generateTraceId(),
            sampleRand: $g26pf.safeMathRandom()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $aa1cdcd93a2770f8$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: $j8mWA.dateTimestampInSeconds(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? $cZaOW.truncate(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: $cmHh9._getSpanForScope(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = $6BF4X.merge(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || $dHx3C.uuid4();
        if (!this._client) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || $dHx3C.uuid4();
        if (!this._client) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || $dHx3C.uuid4();
        if (!this._client) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
module.exports.Scope = $aa1cdcd93a2770f8$var$Scope;

});
parcelRegister("hGRvQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dHx3C = parcelRequire("dHx3C");

var $j8mWA = parcelRequire("j8mWA");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ce0fde6c801aebb8$var$makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = $j8mWA.timestampInSeconds();
    const session = {
        sid: $dHx3C.uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ce0fde6c801aebb8$var$sessionToJSON(session)
    };
    if (context) $ce0fde6c801aebb8$var$updateSession(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ce0fde6c801aebb8$var$updateSession(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || $j8mWA.timestampInSeconds();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : $dHx3C.uuid4();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ce0fde6c801aebb8$var$closeSession(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $ce0fde6c801aebb8$var$updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ce0fde6c801aebb8$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}
module.exports.closeSession = $ce0fde6c801aebb8$var$closeSession;
module.exports.makeSession = $ce0fde6c801aebb8$var$makeSession;
module.exports.updateSession = $ce0fde6c801aebb8$var$updateSession;

});
parcelRegister("dHx3C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Ufnj = parcelRequire("2Ufnj");

var $g26pf = parcelRequire("g26pf");

var $cZaOW = parcelRequire("cZaOW");

var $4onm8 = parcelRequire("4onm8");
function $9f98ef0288427ce1$var$getCrypto() {
    const gbl = $4onm8.GLOBAL_OBJ;
    return gbl.crypto || gbl.msCrypto;
}
let $9f98ef0288427ce1$var$emptyUuid;
function $9f98ef0288427ce1$var$getRandomByte() {
    return $g26pf.safeMathRandom() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $9f98ef0288427ce1$var$uuid4(crypto = $9f98ef0288427ce1$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $g26pf.withRandomSafeContext(()=>crypto.randomUUID()).replace(/-/g, '');
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$9f98ef0288427ce1$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $9f98ef0288427ce1$var$emptyUuid = "10000000100040008000100000000000";
    return $9f98ef0288427ce1$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($9f98ef0288427ce1$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $9f98ef0288427ce1$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $9f98ef0288427ce1$var$getEventDescription(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $9f98ef0288427ce1$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $9f98ef0288427ce1$var$addExceptionTypeValue(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $9f98ef0288427ce1$var$addExceptionMechanism(event, newMechanism) {
    const firstException = $9f98ef0288427ce1$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $9f98ef0288427ce1$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $9f98ef0288427ce1$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $9f98ef0288427ce1$var$parseSemver(input) {
    const match = input.match($9f98ef0288427ce1$var$SEMVER_REGEXP) || [];
    const major = $9f98ef0288427ce1$var$_parseInt(match[1]);
    const minor = $9f98ef0288427ce1$var$_parseInt(match[2]);
    const patch = $9f98ef0288427ce1$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $9f98ef0288427ce1$var$addContextToFrame(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>$cZaOW.snipLine(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = $cZaOW.snipLine(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>$cZaOW.snipLine(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $9f98ef0288427ce1$var$checkOrSetAlreadyCaught(exception) {
    if ($9f98ef0288427ce1$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        $2Ufnj.addNonEnumerableProperty(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether we've already captured the given exception (note: not an identical exception - the very object).
 * It is considered already captured if it has the `__sentry_captured__` property set to `true`.
 *
 * @internal Only considered for internal usage
 */ function $9f98ef0288427ce1$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}
module.exports.addContextToFrame = $9f98ef0288427ce1$var$addContextToFrame;
module.exports.addExceptionMechanism = $9f98ef0288427ce1$var$addExceptionMechanism;
module.exports.addExceptionTypeValue = $9f98ef0288427ce1$var$addExceptionTypeValue;
module.exports.checkOrSetAlreadyCaught = $9f98ef0288427ce1$var$checkOrSetAlreadyCaught;
module.exports.getEventDescription = $9f98ef0288427ce1$var$getEventDescription;
module.exports.isAlreadyCaptured = $9f98ef0288427ce1$var$isAlreadyCaptured;
module.exports.parseSemver = $9f98ef0288427ce1$var$parseSemver;
module.exports.uuid4 = $9f98ef0288427ce1$var$uuid4;

});
parcelRegister("2Ufnj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $dCNfD = parcelRequire("dCNfD");

var $8xCk9 = parcelRequire("8xCk9");

var $8wdL3 = parcelRequire("8wdL3");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $21dcbce3687ebb94$var$fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $21dcbce3687ebb94$var$markFunctionWrapped(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $21dcbce3687ebb94$var$addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $21dcbce3687ebb94$var$markFunctionWrapped(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $21dcbce3687ebb94$var$addNonEnumerableProperty(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * Wrap a method on an object by name, only if it is not already wrapped.
 *
 * Note: to set the wrapped method as a non-enumerable property, pass
 * false as the `enumerable` argument. This could be detected, but only
 * by either walking up the prototype chain, or iterating over all fields
 * in a `for(in)` loop. Neither are an acceptable performance impact for
 * the rare case where we might patch a non-enumerable method.
 */ function $21dcbce3687ebb94$var$wrapMethod(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== 'function') throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($21dcbce3687ebb94$var$getOriginalFunction(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $21dcbce3687ebb94$var$markFunctionWrapped(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $21dcbce3687ebb94$var$getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $21dcbce3687ebb94$var$convertToPlainObject(value) {
    if ($8wdL3.isError(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$21dcbce3687ebb94$var$getOwnProperties(value)
    };
    else if ($8wdL3.isEvent(value)) {
        const newObj = {
            type: value.type,
            target: $21dcbce3687ebb94$var$serializeEventTarget(value.target),
            currentTarget: $21dcbce3687ebb94$var$serializeEventTarget(value.currentTarget),
            ...$21dcbce3687ebb94$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && $8wdL3.isInstanceOf(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $21dcbce3687ebb94$var$serializeEventTarget(target) {
    try {
        return $8wdL3.isElement(target) ? $dCNfD.htmlTreeAsString(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $21dcbce3687ebb94$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $21dcbce3687ebb94$var$extractExceptionKeysForMessage(exception) {
    const keys = Object.keys($21dcbce3687ebb94$var$convertToPlainObject(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $21dcbce3687ebb94$var$dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $21dcbce3687ebb94$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $21dcbce3687ebb94$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($21dcbce3687ebb94$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($21dcbce3687ebb94$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $21dcbce3687ebb94$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $21dcbce3687ebb94$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $21dcbce3687ebb94$var$objectify(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case $8wdL3.isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports.addNonEnumerableProperty = $21dcbce3687ebb94$var$addNonEnumerableProperty;
module.exports.convertToPlainObject = $21dcbce3687ebb94$var$convertToPlainObject;
module.exports.dropUndefinedKeys = $21dcbce3687ebb94$var$dropUndefinedKeys;
module.exports.extractExceptionKeysForMessage = $21dcbce3687ebb94$var$extractExceptionKeysForMessage;
module.exports.fill = $21dcbce3687ebb94$var$fill;
module.exports.getOriginalFunction = $21dcbce3687ebb94$var$getOriginalFunction;
module.exports.markFunctionWrapped = $21dcbce3687ebb94$var$markFunctionWrapped;
module.exports.objectify = $21dcbce3687ebb94$var$objectify;
module.exports.wrapMethod = $21dcbce3687ebb94$var$wrapMethod;

});
parcelRegister("dCNfD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8wdL3 = parcelRequire("8wdL3");

var $4onm8 = parcelRequire("4onm8");
const $9eb5073cb219ce3c$var$WINDOW = $4onm8.GLOBAL_OBJ;
const $9eb5073cb219ce3c$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $9eb5073cb219ce3c$var$htmlTreeAsString(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $9eb5073cb219ce3c$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $9eb5073cb219ce3c$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $9eb5073cb219ce3c$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($9eb5073cb219ce3c$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && $8wdL3.isString(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $9eb5073cb219ce3c$var$getLocationHref() {
    try {
        return $9eb5073cb219ce3c$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $9eb5073cb219ce3c$var$getComponentName(elem, maxTraverseHeight = 5) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$9eb5073cb219ce3c$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
module.exports.getComponentName = $9eb5073cb219ce3c$var$getComponentName;
module.exports.getLocationHref = $9eb5073cb219ce3c$var$getLocationHref;
module.exports.htmlTreeAsString = $9eb5073cb219ce3c$var$htmlTreeAsString;

});
parcelRegister("8wdL3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// eslint-disable-next-line @typescript-eslint/unbound-method
const $633bfbf021550d65$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isError(wat) {
    switch($633bfbf021550d65$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $633bfbf021550d65$var$isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isBuiltin(wat, className) {
    return $633bfbf021550d65$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isErrorEvent(wat) {
    return $633bfbf021550d65$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isDOMError(wat) {
    return $633bfbf021550d65$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isDOMException(wat) {
    return $633bfbf021550d65$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isString(wat) {
    return $633bfbf021550d65$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isParameterizedString(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isPrimitive(wat) {
    return wat === null || $633bfbf021550d65$var$isParameterizedString(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isPlainObject(wat) {
    return $633bfbf021550d65$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isEvent(wat) {
    return typeof Event !== 'undefined' && $633bfbf021550d65$var$isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isElement(wat) {
    return typeof Element !== 'undefined' && $633bfbf021550d65$var$isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isRegExp(wat) {
    return $633bfbf021550d65$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $633bfbf021550d65$var$isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isSyntheticEvent(wat) {
    return $633bfbf021550d65$var$isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function $633bfbf021550d65$var$isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $633bfbf021550d65$var$isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $633bfbf021550d65$var$isRequest(request) {
    return typeof Request !== 'undefined' && $633bfbf021550d65$var$isInstanceOf(request, Request);
}
module.exports.isDOMError = $633bfbf021550d65$var$isDOMError;
module.exports.isDOMException = $633bfbf021550d65$var$isDOMException;
module.exports.isElement = $633bfbf021550d65$var$isElement;
module.exports.isError = $633bfbf021550d65$var$isError;
module.exports.isErrorEvent = $633bfbf021550d65$var$isErrorEvent;
module.exports.isEvent = $633bfbf021550d65$var$isEvent;
module.exports.isInstanceOf = $633bfbf021550d65$var$isInstanceOf;
module.exports.isParameterizedString = $633bfbf021550d65$var$isParameterizedString;
module.exports.isPlainObject = $633bfbf021550d65$var$isPlainObject;
module.exports.isPrimitive = $633bfbf021550d65$var$isPrimitive;
module.exports.isRegExp = $633bfbf021550d65$var$isRegExp;
module.exports.isRequest = $633bfbf021550d65$var$isRequest;
module.exports.isString = $633bfbf021550d65$var$isString;
module.exports.isSyntheticEvent = $633bfbf021550d65$var$isSyntheticEvent;
module.exports.isThenable = $633bfbf021550d65$var$isThenable;
module.exports.isVueViewModel = $633bfbf021550d65$var$isVueViewModel;

});



parcelRegister("g26pf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4onm8 = parcelRequire("4onm8");
// undefined = not yet resolved, null = no runner found, function = runner found
let $bac1cd694e3c1886$var$RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function $bac1cd694e3c1886$var$withRandomSafeContext(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if ($bac1cd694e3c1886$var$RESOLVED_RUNNER !== undefined) return $bac1cd694e3c1886$var$RESOLVED_RUNNER ? $bac1cd694e3c1886$var$RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for('__SENTRY_SAFE_RANDOM_ID_WRAPPER__');
    const globalWithSymbol = $4onm8.GLOBAL_OBJ;
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === 'function') {
        $bac1cd694e3c1886$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $bac1cd694e3c1886$var$RESOLVED_RUNNER(cb);
    }
    $bac1cd694e3c1886$var$RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function $bac1cd694e3c1886$var$safeMathRandom() {
    return $bac1cd694e3c1886$var$withRandomSafeContext(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function $bac1cd694e3c1886$var$safeDateNow() {
    return $bac1cd694e3c1886$var$withRandomSafeContext(()=>Date.now());
}
module.exports.safeDateNow = $bac1cd694e3c1886$var$safeDateNow;
module.exports.safeMathRandom = $bac1cd694e3c1886$var$safeMathRandom;
module.exports.withRandomSafeContext = $bac1cd694e3c1886$var$withRandomSafeContext;

});

parcelRegister("cZaOW", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8wdL3 = parcelRequire("8wdL3");

var $3ycrv = parcelRequire("3ycrv");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $9743934af68eda1b$var$truncate(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $9743934af68eda1b$var$snipLine(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $9743934af68eda1b$var$safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line typescript/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ($8wdL3.isVueViewModel(value)) output.push($3ycrv.getVueInternalName(value));
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $9743934af68eda1b$var$isMatchingPattern(value, pattern, requireExactStringMatch = false) {
    if (!$8wdL3.isString(value)) return false;
    if ($8wdL3.isRegExp(pattern)) return pattern.test(value);
    if ($8wdL3.isString(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === 'function') return pattern(value);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $9743934af68eda1b$var$stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($9743934af68eda1b$var$isMatchingPattern(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}
module.exports.isMatchingPattern = $9743934af68eda1b$var$isMatchingPattern;
module.exports.safeJoin = $9743934af68eda1b$var$safeJoin;
module.exports.snipLine = $9743934af68eda1b$var$snipLine;
module.exports.stringMatchesSomePattern = $9743934af68eda1b$var$stringMatchesSomePattern;
module.exports.truncate = $9743934af68eda1b$var$truncate;

});


parcelRegister("j8mWA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g26pf = parcelRequire("g26pf");

var $4onm8 = parcelRequire("4onm8");
const $dee08fe2ba9c5c49$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $dee08fe2ba9c5c49$var$dateTimestampInSeconds() {
    return $g26pf.safeDateNow() / $dee08fe2ba9c5c49$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $dee08fe2ba9c5c49$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = $4onm8.GLOBAL_OBJ;
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $dee08fe2ba9c5c49$var$dateTimestampInSeconds;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + $g26pf.withRandomSafeContext(()=>performance.now())) / $dee08fe2ba9c5c49$var$ONE_SECOND_IN_MS;
    };
}
let $dee08fe2ba9c5c49$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $dee08fe2ba9c5c49$var$timestampInSeconds() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $dee08fe2ba9c5c49$var$_cachedTimestampInSeconds ?? ($dee08fe2ba9c5c49$var$_cachedTimestampInSeconds = $dee08fe2ba9c5c49$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $dee08fe2ba9c5c49$var$cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function $dee08fe2ba9c5c49$var$getBrowserTimeOrigin() {
    const { performance: performance } = $4onm8.GLOBAL_OBJ;
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = $g26pf.withRandomSafeContext(()=>performance.now());
    const dateNow = $g26pf.safeDateNow();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === 'number') {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === 'number') {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $dee08fe2ba9c5c49$var$browserPerformanceTimeOrigin() {
    if ($dee08fe2ba9c5c49$var$cachedTimeOrigin === null) $dee08fe2ba9c5c49$var$cachedTimeOrigin = $dee08fe2ba9c5c49$var$getBrowserTimeOrigin();
    return $dee08fe2ba9c5c49$var$cachedTimeOrigin;
}
module.exports.browserPerformanceTimeOrigin = $dee08fe2ba9c5c49$var$browserPerformanceTimeOrigin;
module.exports.dateTimestampInSeconds = $dee08fe2ba9c5c49$var$dateTimestampInSeconds;
module.exports.timestampInSeconds = $dee08fe2ba9c5c49$var$timestampInSeconds;

});


parcelRegister("6BF4X", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $4cf61030e5ca06d2$var$merge(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $4cf61030e5ca06d2$var$merge(output[key], mergeObj[key], levels - 1);
    return output;
}
module.exports.merge = $4cf61030e5ca06d2$var$merge;

});

parcelRegister("iBLjN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $dHx3C = parcelRequire("dHx3C");
/**
 * Generate a random, valid trace ID.
 */ function $d8c0631c23c39298$var$generateTraceId() {
    return $dHx3C.uuid4();
}
/**
 * Generate a random, valid span ID.
 */ function $d8c0631c23c39298$var$generateSpanId() {
    return $dHx3C.uuid4().substring(16);
}
module.exports.generateSpanId = $d8c0631c23c39298$var$generateSpanId;
module.exports.generateTraceId = $d8c0631c23c39298$var$generateTraceId;

});

parcelRegister("cmHh9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Ufnj = parcelRequire("2Ufnj");
const $90091bc107ace46f$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $90091bc107ace46f$var$_setSpanForScope(scope, span) {
    if (span) $2Ufnj.addNonEnumerableProperty(scope, $90091bc107ace46f$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$90091bc107ace46f$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $90091bc107ace46f$var$_getSpanForScope(scope) {
    return scope[$90091bc107ace46f$var$SCOPE_SPAN_FIELD];
}
module.exports._getSpanForScope = $90091bc107ace46f$var$_getSpanForScope;
module.exports._setSpanForScope = $90091bc107ace46f$var$_setSpanForScope;

});



parcelRegister("2Q5Le", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $2114e81756a4d1fa$var$isActualPromise = (p)=>p instanceof Promise && !p[$2114e81756a4d1fa$var$kChainedCopy];
const $2114e81756a4d1fa$var$kChainedCopy = Symbol('chained PromiseLike');
/**
 * Copy the properties from a decorated promiselike object onto its chained
 * actual promise.
 */ const $2114e81756a4d1fa$var$chainAndCopyPromiseLike = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    // if we're just dealing with "normal" Promise objects, return the chain
    return $2114e81756a4d1fa$var$isActualPromise(chained) && $2114e81756a4d1fa$var$isActualPromise(original) ? chained : $2114e81756a4d1fa$var$copyProps(original, chained);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2114e81756a4d1fa$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    //oxlint-disable-next-line guard-for-in
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === 'function') Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$2114e81756a4d1fa$var$kChainedCopy]: true
    });
    return chained;
};
module.exports.chainAndCopyPromiseLike = $2114e81756a4d1fa$var$chainAndCopyPromiseLike;

});



parcelRegister("i1sH5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8wdL3 = parcelRequire("8wdL3");
/**
 * Type-guard: The attribute object has the shape the official attribute object (value, type, unit).
 * https://develop.sentry.dev/sdk/telemetry/scopes/#setting-attributes
 */ function $d1ee94015d348ecb$var$isAttributeObject(maybeObj) {
    return typeof maybeObj === 'object' && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes('value');
}
/**
 * Converts an attribute value to a typed attribute value.
 *
 * For now, we intentionally only support primitive values and attribute objects with primitive values.
 * If @param useFallback is true, we stringify non-primitive values to a string attribute value. Otherwise
 * we return `undefined` for unsupported values.
 *
 * @param value - The value of the passed attribute.
 * @param useFallback - If true, unsupported values will be stringified to a string attribute value.
 *                      Defaults to false. In this case, `undefined` is returned for unsupported values.
 * @returns The typed attribute.
 */ function $d1ee94015d348ecb$var$attributeValueToTypedAttributeValue(rawValue, useFallback) {
    const { value: value, unit: unit } = $d1ee94015d348ecb$var$isAttributeObject(rawValue) ? rawValue : {
        value: rawValue,
        unit: undefined
    };
    const attributeValue = $d1ee94015d348ecb$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === 'string' ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === 'skip-undefined' && value === undefined) return;
    // Fallback: stringify the value
    // TODO(v11): be smarter here and use String constructor if stringify fails
    // (this is a breaking change for already existing attribute values)
    let stringValue = '';
    try {
        stringValue = JSON.stringify(value) ?? '';
    } catch  {
    // Do nothing
    }
    return {
        value: stringValue,
        type: 'string',
        ...checkedUnit
    };
}
/**
 * Serializes raw attributes to typed attributes as expected in our envelopes.
 *
 * @param attributes The raw attributes to serialize.
 * @param fallback   If true, unsupported values will be stringified to a string attribute value.
 *                   Defaults to false. In this case, `undefined` is returned for unsupported values.
 *
 * @returns The serialized attributes.
 */ function $d1ee94015d348ecb$var$serializeAttributes(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $d1ee94015d348ecb$var$attributeValueToTypedAttributeValue(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
/**
 * Estimates the serialized byte size of {@link Attributes},
 * with a couple of heuristics for performance.
 */ function $d1ee94015d348ecb$var$estimateTypedAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) // Assumption: Individual array items have the same type and roughly the same size
        // probably not always true but allows us to cut down on runtime
        weight += $d1ee94015d348ecb$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ($8wdL3.isPrimitive(val)) weight += $d1ee94015d348ecb$var$estimatePrimitiveSizeInBytes(val);
        else // default fallback for anything else (objects)
        weight += 100;
    }
    return weight;
}
function $d1ee94015d348ecb$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'boolean') return 4;
    else if (typeof value === 'number') return 8;
    return 0;
}
/**
 * NOTE: We intentionally do not return anything for non-primitive values:
 *  - array support will come in the future but if we stringify arrays now,
 *    sending arrays (unstringified) later will be a subtle breaking change.
 *  - Objects are not supported yet and product support is still TBD.
 *  - We still keep the type signature for TypedAttributeValue wider to avoid a
 *    breaking change once we add support for non-primitive values.
 *  - Once we go back to supporting arrays and stringifying all other values,
 *    we already implemented the serialization logic here:
 *    https://github.com/getsentry/sentry-javascript/pull/18165
 */ function $d1ee94015d348ecb$var$getTypedAttributeValue(value) {
    const primitiveType = typeof value === 'string' ? 'string' : typeof value === 'boolean' ? 'boolean' : typeof value === 'number' && !Number.isNaN(value) ? Number.isInteger(value) ? 'integer' : 'double' : null;
    if (primitiveType) // @ts-expect-error - TS complains because {@link TypedAttributeValue} is strictly typed to
    // avoid setting the wrong `type` on the attribute value.
    // In this case, getPrimitiveType already does the check but TS doesn't know that.
    // The "clean" alternative is to return an object per `typeof value` case
    // but that would require more bundle size
    // Therefore, we ignore it.
    return {
        value: value,
        type: primitiveType
    };
}
module.exports.attributeValueToTypedAttributeValue = $d1ee94015d348ecb$var$attributeValueToTypedAttributeValue;
module.exports.estimateTypedAttributesSizeInBytes = $d1ee94015d348ecb$var$estimateTypedAttributesSizeInBytes;
module.exports.isAttributeObject = $d1ee94015d348ecb$var$isAttributeObject;
module.exports.serializeAttributes = $d1ee94015d348ecb$var$serializeAttributes;

});

parcelRegister("9BwS8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xgnw = parcelRequire("5xgnw");

var $gg0a2 = parcelRequire("gg0a2");

var $eBvnD = parcelRequire("eBvnD");

var $iBLjN = parcelRequire("iBLjN");
let $6fe1117b9528475b$var$_externalPropagationContextProvider;
/**
 * Register an external propagation context provider function.
 * When registered, trace context will be read from the external source (e.g. OpenTelemetry)
 * instead of from the Sentry scope's propagation context.
 */ function $6fe1117b9528475b$var$registerExternalPropagationContext(fn) {
    $6fe1117b9528475b$var$_externalPropagationContextProvider = fn;
}
/**
 * Get the external propagation context, if a provider has been registered.
 */ function $6fe1117b9528475b$var$getExternalPropagationContext() {
    return $6fe1117b9528475b$var$_externalPropagationContextProvider?.();
}
/**
 * Check if an external propagation context provider has been registered.
 */ function $6fe1117b9528475b$var$hasExternalPropagationContext() {
    return $6fe1117b9528475b$var$_externalPropagationContextProvider !== undefined;
}
/**
 * Get the currently active scope.
 */ function $6fe1117b9528475b$var$getCurrentScope() {
    const carrier$1 = $gg0a2.getMainCarrier();
    const acs = $5xgnw.getAsyncContextStrategy(carrier$1);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $6fe1117b9528475b$var$getIsolationScope() {
    const carrier$1 = $gg0a2.getMainCarrier();
    const acs = $5xgnw.getAsyncContextStrategy(carrier$1);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $6fe1117b9528475b$var$getGlobalScope() {
    return $gg0a2.getGlobalSingleton('globalScope', ()=>new $eBvnD.Scope());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $6fe1117b9528475b$var$withScope(...rest) {
    const carrier$1 = $gg0a2.getMainCarrier();
    const acs = $5xgnw.getAsyncContextStrategy(carrier$1);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $6fe1117b9528475b$var$withIsolationScope(...rest) {
    const carrier$1 = $gg0a2.getMainCarrier();
    const acs = $5xgnw.getAsyncContextStrategy(carrier$1);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $6fe1117b9528475b$var$getClient() {
    return $6fe1117b9528475b$var$getCurrentScope().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $6fe1117b9528475b$var$getTraceContextFromScope(scope) {
    const externalContext = $6fe1117b9528475b$var$getExternalPropagationContext();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext$1 = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext$1;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || $iBLjN.generateSpanId()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}
module.exports.getClient = $6fe1117b9528475b$var$getClient;
module.exports.getCurrentScope = $6fe1117b9528475b$var$getCurrentScope;
module.exports.getExternalPropagationContext = $6fe1117b9528475b$var$getExternalPropagationContext;
module.exports.getGlobalScope = $6fe1117b9528475b$var$getGlobalScope;
module.exports.getIsolationScope = $6fe1117b9528475b$var$getIsolationScope;
module.exports.getTraceContextFromScope = $6fe1117b9528475b$var$getTraceContextFromScope;
module.exports.hasExternalPropagationContext = $6fe1117b9528475b$var$hasExternalPropagationContext;
module.exports.registerExternalPropagationContext = $6fe1117b9528475b$var$registerExternalPropagationContext;
module.exports.withIsolationScope = $6fe1117b9528475b$var$withIsolationScope;
module.exports.withScope = $6fe1117b9528475b$var$withScope;

});

parcelRegister("5Wkkl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Use this attribute to represent the source of a span name.
 * Must be one of: custom, url, route, view, component, task
 * TODO(v11): rename this to sentry.span.source'
 */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';
/** The reason why an idle span finished. */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = 'sentry.measurement_value';
/** The release version of the application */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = 'sentry.release';
/** The environment name (e.g., "production", "staging", "development") */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = 'sentry.environment';
/** The segment name (e.g., "GET /users") */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = 'sentry.segment.name';
/** The id of the segment that this span belongs to. */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = 'sentry.segment.id';
/** The name of the Sentry SDK (e.g., "sentry.php", "sentry.javascript") */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = 'sentry.sdk.name';
/** The version of the Sentry SDK */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = 'sentry.sdk.version';
/** The user ID */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_USER_ID = 'user.id';
/** The user email */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_USER_EMAIL = 'user.email';
/** The user IP address */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = 'user.ip_address';
/** The user username */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_USER_USERNAME = 'user.name';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_PROFILE_ID = 'sentry.profile_id';
const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = 'sentry.exclusive_time';
const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_CACHE_HIT = 'cache.hit';
const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_CACHE_KEY = 'cache.key';
const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = 'http.request.method';
const $45322317e51497db$var$SEMANTIC_ATTRIBUTE_URL_FULL = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $45322317e51497db$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = 'sentry.link.type';
/**
 * =============================================================================
 * GEN AI ATTRIBUTES
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 * =============================================================================
 */ /**
 * The conversation ID for linking messages across API calls.
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $45322317e51497db$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = 'gen_ai.conversation.id';
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $45322317e51497db$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_HIT = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_CACHE_HIT;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE;
module.exports.SEMANTIC_ATTRIBUTE_CACHE_KEY = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_CACHE_KEY;
module.exports.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME;
module.exports.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
module.exports.SEMANTIC_ATTRIBUTE_PROFILE_ID = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_PROFILE_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_OP = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_OP;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_RELEASE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME;
module.exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
module.exports.SEMANTIC_ATTRIBUTE_URL_FULL = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_URL_FULL;
module.exports.SEMANTIC_ATTRIBUTE_USER_EMAIL = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_USER_EMAIL;
module.exports.SEMANTIC_ATTRIBUTE_USER_ID = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_USER_ID;
module.exports.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS;
module.exports.SEMANTIC_ATTRIBUTE_USER_USERNAME = $45322317e51497db$var$SEMANTIC_ATTRIBUTE_USER_USERNAME;
module.exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = $45322317e51497db$var$SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE;

});

parcelRegister("g0XVK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $ba8b225a2b9fb76a$var$SPAN_STATUS_UNSET = 0;
const $ba8b225a2b9fb76a$var$SPAN_STATUS_OK = 1;
const $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $ba8b225a2b9fb76a$var$getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $ba8b225a2b9fb76a$var$SPAN_STATUS_OK
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'not_found'
            };
        case 409:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'cancelled'
            };
        default:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
                message: 'internal_error'
            };
    }
    return {
        code: $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $ba8b225a2b9fb76a$var$setHttpStatus(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $ba8b225a2b9fb76a$var$getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}
module.exports.SPAN_STATUS_ERROR = $ba8b225a2b9fb76a$var$SPAN_STATUS_ERROR;
module.exports.SPAN_STATUS_OK = $ba8b225a2b9fb76a$var$SPAN_STATUS_OK;
module.exports.SPAN_STATUS_UNSET = $ba8b225a2b9fb76a$var$SPAN_STATUS_UNSET;
module.exports.getSpanStatusFromHttpCode = $ba8b225a2b9fb76a$var$getSpanStatusFromHttpCode;
module.exports.setHttpStatus = $ba8b225a2b9fb76a$var$setHttpStatus;

});

parcelRegister("BB9MH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Ufnj = parcelRequire("2Ufnj");

var $5WHdC = parcelRequire("5WHdC");
const $07104762966692c0$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $07104762966692c0$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $07104762966692c0$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        $2Ufnj.addNonEnumerableProperty(span, $07104762966692c0$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $5WHdC.makeWeakRef(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        $2Ufnj.addNonEnumerableProperty(span, $07104762966692c0$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function $07104762966692c0$var$getCapturedScopesOnSpan(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$07104762966692c0$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $5WHdC.derefWeakRef(spanWithScopes[$07104762966692c0$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
module.exports.getCapturedScopesOnSpan = $07104762966692c0$var$getCapturedScopesOnSpan;
module.exports.setCapturedScopesOnSpan = $07104762966692c0$var$setCapturedScopesOnSpan;

});
parcelRegister("5WHdC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4onm8 = parcelRequire("4onm8");
/**
 * Interface representing a weak reference to an object.
 * This matches the standard WeakRef interface but is defined here
 * because WeakRef is not available in ES2020 type definitions.
 */ /**
 * Creates a weak reference to an object if WeakRef is available,
 * otherwise returns the object directly.
 *
 * This is useful for breaking circular references while maintaining
 * compatibility with environments that don't support WeakRef (e.g., older browsers).
 *
 * @param value - The object to create a weak reference to
 * @returns A WeakRef wrapper if available, or the original object as fallback
 */ function $4543e4d818b546d1$var$makeWeakRef(value) {
    try {
        // @ts-expect-error - WeakRef may not be in the type definitions for older TS targets
        const WeakRefImpl = $4onm8.GLOBAL_OBJ.WeakRef;
        if (typeof WeakRefImpl === 'function') return new WeakRefImpl(value);
    } catch  {
    // WeakRef not available or construction failed
    }
    return value;
}
/**
 * Resolves a potentially weak reference, returning the underlying object
 * or undefined if the reference has been garbage collected.
 *
 * @param ref - A MaybeWeakRef or undefined
 * @returns The referenced object, or undefined if GC'd or ref was undefined
 */ function $4543e4d818b546d1$var$derefWeakRef(ref) {
    if (!ref) return undefined;
    // Check if this is a WeakRef (has deref method)
    if (typeof ref === 'object' && 'deref' in ref && typeof ref.deref === 'function') try {
        return ref.deref();
    } catch  {
        // deref() failed - treat as GC'd
        return undefined;
    }
    // Direct reference fallback
    return ref;
}
module.exports.derefWeakRef = $4543e4d818b546d1$var$derefWeakRef;
module.exports.makeWeakRef = $4543e4d818b546d1$var$makeWeakRef;

});


parcelRegister("b4MOa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8xCk9 = parcelRequire("8xCk9");

var $ezFpK = parcelRequire("ezFpK");

var $9FnMD = parcelRequire("9FnMD");

var $8aQht = parcelRequire("8aQht");

var $iBLjN = parcelRequire("iBLjN");

var $g26pf = parcelRequire("g26pf");
// oxlint-disable-next-line sdk/no-regexp-constructor -- RegExp is used for readability here
const $8105edb5a9c709be$var$TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $8105edb5a9c709be$var$extractTraceparentData(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($8105edb5a9c709be$var$TRACEPARENT_REGEXP);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $8105edb5a9c709be$var$propagationContextFromHeaders(sentryTrace, baggage$1) {
    const traceparentData = $8105edb5a9c709be$var$extractTraceparentData(sentryTrace);
    const dynamicSamplingContext = $ezFpK.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (!traceparentData?.traceId) return {
        traceId: $iBLjN.generateTraceId(),
        sampleRand: $g26pf.safeMathRandom()
    };
    const sampleRand = $8105edb5a9c709be$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $8105edb5a9c709be$var$generateSentryTraceHeader(traceId = $iBLjN.generateTraceId(), spanId = $iBLjN.generateSpanId(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function $8105edb5a9c709be$var$generateTraceparentHeader(traceId = $iBLjN.generateTraceId(), spanId = $iBLjN.generateSpanId(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? '01' : '00'}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $8105edb5a9c709be$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = $8aQht.parseSampleRate(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = $8aQht.parseSampleRate(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? $g26pf.safeMathRandom() * parsedSampleRate : parsedSampleRate + $g26pf.safeMathRandom() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return $g26pf.safeMathRandom();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $8105edb5a9c709be$var$shouldContinueTrace(client, baggageOrgId) {
    const clientOrgId = $9FnMD.extractOrgIdFromClient(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        $8xCk9.debug.log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            $8xCk9.debug.log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}
module.exports.TRACEPARENT_REGEXP = $8105edb5a9c709be$var$TRACEPARENT_REGEXP;
module.exports.extractTraceparentData = $8105edb5a9c709be$var$extractTraceparentData;
module.exports.generateSentryTraceHeader = $8105edb5a9c709be$var$generateSentryTraceHeader;
module.exports.generateTraceparentHeader = $8105edb5a9c709be$var$generateTraceparentHeader;
module.exports.propagationContextFromHeaders = $8105edb5a9c709be$var$propagationContextFromHeaders;
module.exports.shouldContinueTrace = $8105edb5a9c709be$var$shouldContinueTrace;

});
parcelRegister("ezFpK", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $8wdL3 = parcelRequire("8wdL3");
const $a9c4759696451701$var$SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';
const $a9c4759696451701$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $a9c4759696451701$var$MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $a9c4759696451701$var$baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $a9c4759696451701$var$parseBaggageHeader(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($a9c4759696451701$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
            const nonPrefixedKey = key.slice($a9c4759696451701$var$SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $a9c4759696451701$var$dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$a9c4759696451701$var$SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $a9c4759696451701$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $a9c4759696451701$var$parseBaggageHeader(baggageHeader) {
    if (!baggageHeader || !$8wdL3.isString(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $a9c4759696451701$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $a9c4759696451701$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $a9c4759696451701$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $a9c4759696451701$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $a9c4759696451701$var$MAX_BAGGAGE_STRING_LENGTH) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}
/**
 * Merge two baggage headers into one.
 * - Sentry-specific entries (keys starting with "sentry-") from the new
 *   baggage take precedence
 * - Non-Sentry entries from existing baggage take precedence
 *
 * The order of the existing baggage will be preserved, and new entries will
 * be added to the end.
 *
 * This matches the behavior of OTEL's propagation.inject() which uses
 * `baggage.setEntry()`  to overwrite existing entries with the same key.
 */ function $a9c4759696451701$var$mergeBaggageHeaders(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $a9c4759696451701$var$parseBaggageHeader(existing);
    const incomingEntries = $a9c4759696451701$var$parseBaggageHeader(incoming);
    if (!incomingEntries) return existing;
    // 1. All non-sentry entries from existing are kept
    // 2. All sentry- entries from the new baggage are retained
    // 3. If sentry- entries present in new, ignore from old, else keep from old.
    // 4. Non-sentry entries from new are only kept if not in existing.
    const merged = {};
    // partition incoming entries into sentry and non-sentry prefixed
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($a9c4759696451701$var$SENTRY_BAGGAGE_KEY_PREFIX)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    // If new baggage contains at least one sentry- value, we remove all old
    // sentry- values otherwise, we keep old sentry- values. If we don't remove
    // old sentry- values, we end up with an inconsistent dynamic sampling
    // context propagation.
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($a9c4759696451701$var$SENTRY_BAGGAGE_KEY_PREFIX)) merged[key] = value;
    }
    // Assign new sentry fields.
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    // assign new non-sentry fields not found on existing object.
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ??= value;
    return $a9c4759696451701$var$objectToBaggageHeader(merged);
}
module.exports.MAX_BAGGAGE_STRING_LENGTH = $a9c4759696451701$var$MAX_BAGGAGE_STRING_LENGTH;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX = $a9c4759696451701$var$SENTRY_BAGGAGE_KEY_PREFIX;
module.exports.SENTRY_BAGGAGE_KEY_PREFIX_REGEX = $a9c4759696451701$var$SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
module.exports.baggageHeaderToDynamicSamplingContext = $a9c4759696451701$var$baggageHeaderToDynamicSamplingContext;
module.exports.dynamicSamplingContextToSentryBaggageHeader = $a9c4759696451701$var$dynamicSamplingContextToSentryBaggageHeader;
module.exports.mergeBaggageHeaders = $a9c4759696451701$var$mergeBaggageHeaders;
module.exports.objectToBaggageHeader = $a9c4759696451701$var$objectToBaggageHeader;
module.exports.parseBaggageHeader = $a9c4759696451701$var$parseBaggageHeader;

});

parcelRegister("9FnMD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");
/** Regular expression used to extract org ID from a DSN host. */ const $709a644c66369598$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $709a644c66369598$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $709a644c66369598$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $709a644c66369598$var$dsnToString(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $709a644c66369598$var$dsnFromString(str) {
    const match = $709a644c66369598$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        $8xCk9.consoleSandbox(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $709a644c66369598$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $709a644c66369598$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $709a644c66369598$var$validateDsn(dsn) {
    if (!$kcA99.DEBUG_BUILD) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            $8xCk9.debug.error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        $8xCk9.debug.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$709a644c66369598$var$isValidProtocol(protocol)) {
        $8xCk9.debug.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        $8xCk9.debug.error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $709a644c66369598$var$extractOrgIdFromDsnHost(host) {
    const match = host.match($709a644c66369598$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $709a644c66369598$var$extractOrgIdFromClient(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $709a644c66369598$var$extractOrgIdFromDsnHost(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $709a644c66369598$var$makeDsn(from) {
    const components = typeof from === 'string' ? $709a644c66369598$var$dsnFromString(from) : $709a644c66369598$var$dsnFromComponents(from);
    if (!components || !$709a644c66369598$var$validateDsn(components)) return undefined;
    return components;
}
module.exports.dsnFromString = $709a644c66369598$var$dsnFromString;
module.exports.dsnToString = $709a644c66369598$var$dsnToString;
module.exports.extractOrgIdFromClient = $709a644c66369598$var$extractOrgIdFromClient;
module.exports.extractOrgIdFromDsnHost = $709a644c66369598$var$extractOrgIdFromDsnHost;
module.exports.makeDsn = $709a644c66369598$var$makeDsn;

});

parcelRegister("8aQht", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $5f37cfcef08b1d1f$var$parseSampleRate(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}
module.exports.parseSampleRate = $5f37cfcef08b1d1f$var$parseSampleRate;

});




parcelRegister("grT8q", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $5Wkkl = parcelRequire("5Wkkl");

var $8xCk9 = parcelRequire("8xCk9");

var $lvT7Y = parcelRequire("lvT7Y");

var $lTL01 = parcelRequire("lTL01");

var $cmHh9 = parcelRequire("cmHh9");

var $awmvd = parcelRequire("awmvd");

var $j8mWA = parcelRequire("j8mWA");

var $i9ydA = parcelRequire("i9ydA");

var $hNE9t = parcelRequire("hNE9t");

var $jOdAy = parcelRequire("jOdAy");

var $g0XVK = parcelRequire("g0XVK");

var $jLFhR = parcelRequire("jLFhR");
const $bf99ef989581e732$var$TRACING_DEFAULTS = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $bf99ef989581e732$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $bf99ef989581e732$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $bf99ef989581e732$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $bf99ef989581e732$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $bf99ef989581e732$var$startIdleSpan(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $bf99ef989581e732$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $bf99ef989581e732$var$TRACING_DEFAULTS.idleTimeout, finalTimeout: finalTimeout = $bf99ef989581e732$var$TRACING_DEFAULTS.finalTimeout, childSpanTimeout: childSpanTimeout = $bf99ef989581e732$var$TRACING_DEFAULTS.childSpanTimeout, beforeSpanEnd: beforeSpanEnd, trimIdleSpanEndTimestamp: trimIdleSpanEndTimestamp = true } = options;
    const client = $9BwS8.getClient();
    if (!client || !$lvT7Y.hasSpansEnabled()) {
        const span = new $hNE9t.SentryNonRecordingSpan();
        const dsc = {
            sample_rate: '0',
            sampled: 'false',
            ...$i9ydA.getDynamicSamplingContextFromSpan(span)
        };
        $i9ydA.freezeDscOnSpan(span, dsc);
        return span;
    }
    const scope = $9BwS8.getCurrentScope();
    const previousActiveSpan = $awmvd.getActiveSpan();
    const span = $bf99ef989581e732$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof $hNE9t.SentryNonRecordingSpan) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || $j8mWA.timestampInSeconds();
            const spanEndTimestamp = $awmvd.spanTimeInputToSeconds(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = $awmvd.getSpanDescendants(span).filter((child)=>child !== span);
            const spanJson = $awmvd.spanToJSON(span);
            // If we have no spans, we just end, nothing else to do here
            // Likewise, if users explicitly ended the span, we simply end the span without timestamp adjustment
            if (!spans.length || !trimIdleSpanEndTimestamp) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const ignoreSpans = client.getOptions().ignoreSpans;
            const latestSpanEndTimestamp = spans?.reduce((acc, current)=>{
                const currentSpanJson = $awmvd.spanToJSON(current);
                if (!currentSpanJson.timestamp) return acc;
                // Ignored spans will get dropped later (in the client) but since we already adjust
                // the idle span end timestamp here, we can already take to-be-ignored spans out of
                // the calculation here.
                if (ignoreSpans && $lTL01.shouldIgnoreSpan({
                    description: currentSpanJson.description,
                    op: currentSpanJson.op,
                    attributes: currentSpanJson.data
                }, ignoreSpans)) return acc;
                return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
            }, undefined);
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = spanJson.start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $bf99ef989581e732$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $bf99ef989581e732$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = $j8mWA.timestampInSeconds();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = $j8mWA.timestampInSeconds();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        $cmHh9._setSpanForScope(scope, previousActiveSpan);
        const spanJSON = $awmvd.spanToJSON(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute($5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON, _finishReason);
        // Set span status to 'ok' if it hasn't been explicitly set to an error status
        const currentStatus = spanJSON.status;
        if (!currentStatus || currentStatus === 'unknown') span.setStatus({
            code: $g0XVK.SPAN_STATUS_OK
        });
        $8xCk9.debug.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = $awmvd.getSpanDescendants(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: $g0XVK.SPAN_STATUS_ERROR,
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                $kcA99.DEBUG_BUILD && $8xCk9.debug.log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = $awmvd.spanToJSON(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if ($kcA99.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) $8xCk9.debug.log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) $8xCk9.debug.log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                $awmvd.removeChildSpanFromSpan(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    _cleanupHooks.push(client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!$awmvd.spanToJSON(startedSpan).timestamp || startedSpan instanceof $jOdAy.SentrySpan && startedSpan.isStandaloneSpan()) return;
        const allSpans = $awmvd.getSpanDescendants(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: $g0XVK.SPAN_STATUS_ERROR,
                message: 'deadline_exceeded'
            });
            _finishReason = $bf99ef989581e732$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $bf99ef989581e732$var$_startIdleSpan(options) {
    const span = $jLFhR.startInactiveSpan(options);
    $cmHh9._setSpanForScope($9BwS8.getCurrentScope(), span);
    $kcA99.DEBUG_BUILD && $8xCk9.debug.log('[Tracing] Started span is an idle span');
    return span;
}
module.exports.TRACING_DEFAULTS = $bf99ef989581e732$var$TRACING_DEFAULTS;
module.exports.startIdleSpan = $bf99ef989581e732$var$startIdleSpan;

});
parcelRegister("lvT7Y", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $fa97416501dd5a30$var$hasSpansEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $9BwS8.getClient()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
module.exports.hasSpansEnabled = $fa97416501dd5a30$var$hasSpansEnabled;

});

parcelRegister("lTL01", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $cZaOW = parcelRequire("cZaOW");
function $041d36782adc11dc$var$logIgnoredSpan(droppedSpan) {
    $8xCk9.debug.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $041d36782adc11dc$var$shouldIgnoreSpan(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($041d36782adc11dc$var$isStringOrRegExp(pattern)) {
            if (span.description && $cZaOW.isMatchingPattern(span.description, pattern)) {
                $kcA99.DEBUG_BUILD && $041d36782adc11dc$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && $cZaOW.isMatchingPattern(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && $cZaOW.isMatchingPattern(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$041d36782adc11dc$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches`, `opMatches`, or `attrsMatch`. So in contrary to how this looks,
        // not all of op, name, and attributes actually have to match. This is the most efficient way to check
        // for all combinations of name, op, and attribute patterns.
        if (nameMatches && opMatches && attrsMatch) {
            $kcA99.DEBUG_BUILD && $041d36782adc11dc$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $041d36782adc11dc$var$_matchesAttributeValue(actual, pat) {
    // String values support pattern matching
    if (typeof actual === 'string' && (typeof pat === 'string' || pat instanceof RegExp)) return $cZaOW.isMatchingPattern(actual, pat);
    // Arrays: element-wise strict equality
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    // Primitives: strict equality
    return actual === pat;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $041d36782adc11dc$var$reparentChildSpans(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $041d36782adc11dc$var$isStringOrRegExp(value) {
    return typeof value === 'string' || value instanceof RegExp;
}
module.exports.reparentChildSpans = $041d36782adc11dc$var$reparentChildSpans;
module.exports.shouldIgnoreSpan = $041d36782adc11dc$var$shouldIgnoreSpan;

});

parcelRegister("i9ydA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $03X1l = parcelRequire("03X1l");

var $9BwS8 = parcelRequire("9BwS8");

var $5Wkkl = parcelRequire("5Wkkl");

var $ezFpK = parcelRequire("ezFpK");

var $9FnMD = parcelRequire("9FnMD");

var $lvT7Y = parcelRequire("lvT7Y");

var $2Ufnj = parcelRequire("2Ufnj");

var $awmvd = parcelRequire("awmvd");

var $BB9MH = parcelRequire("BB9MH");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $d3739c48b9eaba64$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $d3739c48b9eaba64$var$freezeDscOnSpan(span, dsc) {
    const spanWithMaybeDsc = span;
    $2Ufnj.addNonEnumerableProperty(spanWithMaybeDsc, $d3739c48b9eaba64$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $d3739c48b9eaba64$var$getDynamicSamplingContextFromClient(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || $03X1l.DEFAULT_ENVIRONMENT,
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: $9FnMD.extractOrgIdFromClient(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $d3739c48b9eaba64$var$getDynamicSamplingContextFromScope(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $d3739c48b9eaba64$var$getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $d3739c48b9eaba64$var$getDynamicSamplingContextFromSpan(span) {
    const client = $9BwS8.getClient();
    if (!client) return {};
    const rootSpan = $awmvd.getRootSpan(span);
    const rootSpanJson = $awmvd.spanToJSON(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$d3739c48b9eaba64$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && $ezFpK.baggageHeaderToDynamicSamplingContext(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $d3739c48b9eaba64$var$getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    // TODO(v11): Only read `SEMANTIC_ATTRIBUTE_SENTRY_SOURCE` again, once we renamed it to `sentry.span.source`
    const source = rootSpanAttributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ?? rootSpanAttributes['sentry.span.source'];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ($lvT7Y.hasSpansEnabled()) {
        dsc.sampled = String($awmvd.spanIsSampled(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        $BB9MH.getCapturedScopesOnSpan(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $d3739c48b9eaba64$var$spanToBaggageHeader(span) {
    const dsc = $d3739c48b9eaba64$var$getDynamicSamplingContextFromSpan(span);
    return $ezFpK.dynamicSamplingContextToSentryBaggageHeader(dsc);
}
module.exports.freezeDscOnSpan = $d3739c48b9eaba64$var$freezeDscOnSpan;
module.exports.getDynamicSamplingContextFromClient = $d3739c48b9eaba64$var$getDynamicSamplingContextFromClient;
module.exports.getDynamicSamplingContextFromScope = $d3739c48b9eaba64$var$getDynamicSamplingContextFromScope;
module.exports.getDynamicSamplingContextFromSpan = $d3739c48b9eaba64$var$getDynamicSamplingContextFromSpan;
module.exports.spanToBaggageHeader = $d3739c48b9eaba64$var$spanToBaggageHeader;

});
parcelRegister("03X1l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $00be10343182b3da$var$DEFAULT_ENVIRONMENT = 'production';
const $00be10343182b3da$var$DEV_ENVIRONMENT = 'development';
module.exports.DEFAULT_ENVIRONMENT = $00be10343182b3da$var$DEFAULT_ENVIRONMENT;
module.exports.DEV_ENVIRONMENT = $00be10343182b3da$var$DEV_ENVIRONMENT;

});


parcelRegister("hNE9t", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $iBLjN = parcelRequire("iBLjN");

var $awmvd = parcelRequire("awmvd");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $cf562891ed4ecced$var$SentryNonRecordingSpan {
    /**
   * Reason why this span was dropped, if applicable ('ignored' or 'sample_rate').
   * Used to propagate the correct client report outcome to descendant spans
   * when span streaming is enabled.
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $iBLjN.generateTraceId();
        this._spanId = spanContext.spanId || $iBLjN.generateSpanId();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: $awmvd.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}
module.exports.SentryNonRecordingSpan = $cf562891ed4ecced$var$SentryNonRecordingSpan;

});

parcelRegister("jOdAy", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $cCYFf = parcelRequire("cCYFf");

var $5Wkkl = parcelRequire("5Wkkl");

var $8xCk9 = parcelRequire("8xCk9");

var $iBLjN = parcelRequire("iBLjN");

var $awmvd = parcelRequire("awmvd");

var $j8mWA = parcelRequire("j8mWA");

var $i9ydA = parcelRequire("i9ydA");

var $51ra4 = parcelRequire("51ra4");

var $gb6F8 = parcelRequire("gb6F8");

var $akELB = parcelRequire("akELB");

var $BB9MH = parcelRequire("BB9MH");
/* eslint-disable max-lines */ const $e6bd3a3bea0da618$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $e6bd3a3bea0da618$var$SentrySpan {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || $iBLjN.generateTraceId();
        this._spanId = spanContext.spanId || $iBLjN.generateSpanId();
        this._startTime = spanContext.startTimestamp || $j8mWA.timestampInSeconds();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'manual',
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? $awmvd.TRACE_FLAG_SAMPLED : $awmvd.TRACE_FLAG_NONE
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = $awmvd.spanTimeInputToSeconds(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute($5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = $awmvd.spanTimeInputToSeconds(endTimestamp);
        $51ra4.logSpanEnd(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: $awmvd.getStatusMessage(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: $gb6F8.timedEventsToMeasurements(this._events),
            is_segment: this._isStandaloneSpan && $awmvd.getRootSpan(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? $awmvd.getRootSpan(this).spanContext().spanId : undefined,
            links: $awmvd.convertSpanLinksForEnvelope(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? '',
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === $awmvd.getRootSpan(this),
            status: $awmvd.getSimpleStatusMessage(this._status),
            attributes: this._attributes,
            links: $awmvd.getStreamedSpanLinks(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log('[Tracing] Adding an event to span:', name);
        const time$1 = $e6bd3a3bea0da618$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || $j8mWA.timestampInSeconds();
        const attributes = $e6bd3a3bea0da618$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: $awmvd.spanTimeInputToSeconds(time$1),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = $9BwS8.getClient();
        if (client) {
            client.emit('spanEnd', this);
            // Guarding sending standalone v1 spans as v2 streamed spans for now.
            // Otherwise they'd be sent once as v1 spans and again as streamed spans.
            // We'll migrate CLS and LCP spans to streamed spans in a later PR and
            // INP spans in the next major of the SDK. At that point, we can fully remove
            // standalone v1 spans <3
            if (!this._isStandaloneSpan) client.emit('afterSpanEnd', this);
        }
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === $awmvd.getRootSpan(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $e6bd3a3bea0da618$var$sendSpanEnvelope($cCYFf.createSpanEnvelope([
                this
            ], client));
            else {
                $kcA99.DEBUG_BUILD && $8xCk9.debug.log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        } else if (client && $akELB.hasSpanStreamingEnabled(client)) {
            // TODO (spans): Remove standalone span custom logic in favor of sending simple v2 web vital spans
            client.emit('afterSegmentSpanEnd', this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = $BB9MH.getCapturedScopesOnSpan(this).scope || $9BwS8.getCurrentScope();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$e6bd3a3bea0da618$var$isFullFinishedSpan($awmvd.spanToJSON(this))) return undefined;
        if (!this._name) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = $BB9MH.getCapturedScopesOnSpan(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = $awmvd.getSpanDescendants(this).filter((span)=>span !== this && !$e6bd3a3bea0da618$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>$awmvd.spanToJSON(span)).filter($e6bd3a3bea0da618$var$isFullFinishedSpan);
        const source = this._attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
            if (span.op?.startsWith('gen_ai.')) hasGenAiSpans = true;
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: $awmvd.spanToTransactionTraceContext(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $e6bd3a3bea0da618$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $e6bd3a3bea0da618$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: $i9ydA.getDynamicSamplingContextFromSpan(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = $gb6F8.timedEventsToMeasurements(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $e6bd3a3bea0da618$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $e6bd3a3bea0da618$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $e6bd3a3bea0da618$var$isStandaloneSpan(span) {
    return span instanceof $e6bd3a3bea0da618$var$SentrySpan && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $e6bd3a3bea0da618$var$sendSpanEnvelope(envelope) {
    const client = $9BwS8.getClient();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
module.exports.SentrySpan = $e6bd3a3bea0da618$var$SentrySpan;

});
parcelRegister("cCYFf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i9ydA = parcelRequire("i9ydA");

var $dh5pl = parcelRequire("dh5pl");

var $9FnMD = parcelRequire("9FnMD");

var $SMVsN = parcelRequire("SMVsN");

var $lTL01 = parcelRequire("lTL01");

var $awmvd = parcelRequire("awmvd");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $9318174ef6c08d39$var$_enhanceEventWithSdkInfo(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function $9318174ef6c08d39$var$createSessionEnvelope(session, dsn$1, metadata, tunnel) {
    const sdkInfo = $SMVsN.getSdkMetadataForEnvelopeHeader(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $9FnMD.dsnToString(dsn$1)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return $SMVsN.createEnvelope(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $9318174ef6c08d39$var$createEventEnvelope(event, dsn, metadata, tunnel) {
    const sdkInfo = $SMVsN.getSdkMetadataForEnvelopeHeader(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $9318174ef6c08d39$var$_enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = $SMVsN.createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return $SMVsN.createEnvelope(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $9318174ef6c08d39$var$createSpanEnvelope(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = $i9ydA.getDynamicSamplingContextFromSpan(spans[0]);
    const dsn$1 = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn$1 && {
            dsn: $9FnMD.dsnToString(dsn$1)
        }
    };
    const { beforeSendSpan: beforeSendSpan$1, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = $awmvd.spanToJSON(span);
        return !$lTL01.shouldIgnoreSpan({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent('before_send', 'span', droppedSpans);
    const convertToSpanJSON = beforeSendSpan$1 ? (span)=>{
        const spanJson = $awmvd.spanToJSON(span);
        const processedSpan = !$dh5pl.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? beforeSendSpan$1(spanJson) : spanJson;
        if (!processedSpan) {
            $awmvd.showSpanDropWarning();
            return spanJson;
        }
        return processedSpan;
    } : $awmvd.spanToJSON;
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push($SMVsN.createSpanEnvelopeItem(spanJson));
    }
    return $SMVsN.createEnvelope(headers, items);
}
module.exports._enhanceEventWithSdkInfo = $9318174ef6c08d39$var$_enhanceEventWithSdkInfo;
module.exports.createEventEnvelope = $9318174ef6c08d39$var$createEventEnvelope;
module.exports.createSessionEnvelope = $9318174ef6c08d39$var$createSessionEnvelope;
module.exports.createSpanEnvelope = $9318174ef6c08d39$var$createSpanEnvelope;

});
parcelRegister("dh5pl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Ufnj = parcelRequire("2Ufnj");
/**
 * A wrapper to use the new span format in your `beforeSendSpan` callback.
 *
 * When using `traceLifecycle: 'stream'`, wrap your callback with this function
 * to receive and return {@link StreamedSpanJSON} instead of the standard {@link SpanJSON}.
 *
 * @example
 *
 * Sentry.init({
 *   traceLifecycle: 'stream',
 *   beforeSendSpan: withStreamedSpan((span) => {
 *     // span is of type StreamedSpanJSON
 *     return span;
 *   }),
 * });
 *
 * @param callback - The callback function that receives and returns a {@link StreamedSpanJSON}.
 * @returns A callback that is compatible with the `beforeSendSpan` option when using `traceLifecycle: 'stream'`.
 */ function $9aa10ec80e1d57af$var$withStreamedSpan(callback) {
    $2Ufnj.addNonEnumerableProperty(callback, '_streamed', true);
    return callback;
}
/**
 * Typesafe check to identify if a `beforeSendSpan` callback expects the streamed span JSON format.
 *
 * @param callback - The `beforeSendSpan` callback to check.
 * @returns `true` if the callback was wrapped with {@link withStreamedSpan}.
 */ function $9aa10ec80e1d57af$var$isStreamedBeforeSendSpanCallback(callback) {
    return !!callback && typeof callback === 'function' && '_streamed' in callback && !!callback._streamed;
}
module.exports.isStreamedBeforeSendSpanCallback = $9aa10ec80e1d57af$var$isStreamedBeforeSendSpanCallback;
module.exports.withStreamedSpan = $9aa10ec80e1d57af$var$withStreamedSpan;

});

parcelRegister("SMVsN", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gg0a2 = parcelRequire("gg0a2");

var $9FnMD = parcelRequire("9FnMD");

var $kUcj7 = parcelRequire("kUcj7");

var $4onm8 = parcelRequire("4onm8");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $0a4afee946308752$var$createEnvelope(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $0a4afee946308752$var$addItemToEnvelope(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $0a4afee946308752$var$forEachEnvelopeItem(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $0a4afee946308752$var$envelopeContainsItemType(envelope, types) {
    return $0a4afee946308752$var$forEachEnvelopeItem(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $0a4afee946308752$var$encodeUTF8(input) {
    const carrier$1 = $gg0a2.getSentryCarrier($4onm8.GLOBAL_OBJ);
    return carrier$1.encodePolyfill ? carrier$1.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $0a4afee946308752$var$decodeUTF8(input) {
    const carrier$1 = $gg0a2.getSentryCarrier($4onm8.GLOBAL_OBJ);
    return carrier$1.decodePolyfill ? carrier$1.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $0a4afee946308752$var$serializeEnvelope(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $0a4afee946308752$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $0a4afee946308752$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify($kUcj7.normalize(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $0a4afee946308752$var$concatBuffers(parts);
}
function $0a4afee946308752$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $0a4afee946308752$var$parseEnvelope(env) {
    let buffer = typeof env === 'string' ? $0a4afee946308752$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($0a4afee946308752$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $0a4afee946308752$var$createSpanEnvelopeItem(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $0a4afee946308752$var$createAttachmentEnvelopeItem(attachment) {
    const buffer = typeof attachment.data === 'string' ? $0a4afee946308752$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
// Map of envelope item types to data categories where the category differs from the type.
// Types that map to themselves (session, attachment, transaction, profile, feedback, span, metric) fall through.
const $0a4afee946308752$var$DATA_CATEGORY_OVERRIDES = {
    sessions: 'session',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    raw_security: 'security',
    log: 'log_item',
    trace_metric: 'metric'
};
function $0a4afee946308752$var$_isOverriddenType(type) {
    return type in $0a4afee946308752$var$DATA_CATEGORY_OVERRIDES;
}
/**
 * Maps the type of an envelope item to a data category.
 */ function $0a4afee946308752$var$envelopeItemTypeToDataCategory(type) {
    return $0a4afee946308752$var$_isOverriddenType(type) ? $0a4afee946308752$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
/** Extracts the minimal SDK info from the metadata or an events */ function $0a4afee946308752$var$getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $0a4afee946308752$var$createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn$1) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn$1 && {
            dsn: $9FnMD.dsnToString(dsn$1)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}
module.exports.addItemToEnvelope = $0a4afee946308752$var$addItemToEnvelope;
module.exports.createAttachmentEnvelopeItem = $0a4afee946308752$var$createAttachmentEnvelopeItem;
module.exports.createEnvelope = $0a4afee946308752$var$createEnvelope;
module.exports.createEventEnvelopeHeaders = $0a4afee946308752$var$createEventEnvelopeHeaders;
module.exports.createSpanEnvelopeItem = $0a4afee946308752$var$createSpanEnvelopeItem;
module.exports.envelopeContainsItemType = $0a4afee946308752$var$envelopeContainsItemType;
module.exports.envelopeItemTypeToDataCategory = $0a4afee946308752$var$envelopeItemTypeToDataCategory;
module.exports.forEachEnvelopeItem = $0a4afee946308752$var$forEachEnvelopeItem;
module.exports.getSdkMetadataForEnvelopeHeader = $0a4afee946308752$var$getSdkMetadataForEnvelopeHeader;
module.exports.parseEnvelope = $0a4afee946308752$var$parseEnvelope;
module.exports.serializeEnvelope = $0a4afee946308752$var$serializeEnvelope;

});
parcelRegister("kUcj7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8wdL3 = parcelRequire("8wdL3");

var $7iTWP = parcelRequire("7iTWP");

var $2Ufnj = parcelRequire("2Ufnj");

var $3ycrv = parcelRequire("3ycrv");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f38295941527d947$var$normalize(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $f38295941527d947$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $f38295941527d947$var$normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $f38295941527d947$var$normalize(object, depth);
    if ($f38295941527d947$var$jsonSize(normalized) > maxSize) return $f38295941527d947$var$normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $f38295941527d947$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $f38295941527d947$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $f38295941527d947$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. Hints use internal symbols
    // (see normalizationHints.ts) so user-controlled JSON cannot spoof them.
    if ($7iTWP.hasSkipNormalizationHint(value)) return value;
    // Override remaining depth from this node (e.g. Redux / Pinia state). Set via setNormalizationDepthOverrideHint.
    const overrideDepth = $7iTWP.getNormalizationDepthOverrideHint(value);
    const remainingDepth = overrideDepth !== undefined ? overrideDepth : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $f38295941527d947$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = $2Ufnj.convertToPlainObject(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $f38295941527d947$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $f38295941527d947$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ($8wdL3.isVueViewModel(value)) return $3ycrv.getVueInternalName(value);
        // React's SyntheticEvent thingy
        if ($8wdL3.isSyntheticEvent(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${$3ycrv.getFunctionName(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $f38295941527d947$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $f38295941527d947$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $f38295941527d947$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f38295941527d947$var$jsonSize(value) {
    return $f38295941527d947$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $f38295941527d947$var$normalizeUrlToBase(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // oxlint-disable-next-line sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $f38295941527d947$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports.normalize = $f38295941527d947$var$normalize;
module.exports.normalizeToSize = $f38295941527d947$var$normalizeToSize;
module.exports.normalizeUrlToBase = $f38295941527d947$var$normalizeUrlToBase;

});
parcelRegister("7iTWP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Ufnj = parcelRequire("2Ufnj");
/**
 * Internal symbols for normalization behavior. JSON and other structured user payloads cannot
 * carry these keys, so they cannot spoof SDK-only normalization hints.
 * We use Symbol.for to ensure that the symbols are the same across different modules/files.
 */ const $55159ce5e457b7d0$var$SENTRY_SKIP_NORMALIZATION = Symbol.for('sentry.skipNormalization');
const $55159ce5e457b7d0$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = Symbol.for('sentry.overrideNormalizationDepth');
/** Marks an object so `normalize` returns it unchanged (already-normalized SDK data). */ function $55159ce5e457b7d0$var$setSkipNormalizationHint(obj) {
    $2Ufnj.addNonEnumerableProperty(obj, $55159ce5e457b7d0$var$SENTRY_SKIP_NORMALIZATION, true);
}
/** Overrides remaining normalization depth from this object downward (e.g. Redux / Pinia state). */ function $55159ce5e457b7d0$var$setNormalizationDepthOverrideHint(obj, depth) {
    $2Ufnj.addNonEnumerableProperty(obj, $55159ce5e457b7d0$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
/** @internal */ function $55159ce5e457b7d0$var$hasSkipNormalizationHint(value) {
    return Boolean(value[$55159ce5e457b7d0$var$SENTRY_SKIP_NORMALIZATION]);
}
/** @internal */ function $55159ce5e457b7d0$var$getNormalizationDepthOverrideHint(value) {
    const v = value[$55159ce5e457b7d0$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === 'number' ? v : undefined;
}
module.exports.getNormalizationDepthOverrideHint = $55159ce5e457b7d0$var$getNormalizationDepthOverrideHint;
module.exports.hasSkipNormalizationHint = $55159ce5e457b7d0$var$hasSkipNormalizationHint;
module.exports.setNormalizationDepthOverrideHint = $55159ce5e457b7d0$var$setNormalizationDepthOverrideHint;
module.exports.setSkipNormalizationHint = $55159ce5e457b7d0$var$setSkipNormalizationHint;

});




parcelRegister("51ra4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $awmvd = parcelRequire("awmvd");
/**
 * Print a log message for a started span.
 */ function $3a821d7162786759$var$logSpanStart(span) {
    if (!$kcA99.DEBUG_BUILD) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = $awmvd.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = $awmvd.spanIsSampled(span);
    const rootSpan = $awmvd.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = $awmvd.spanToJSON(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    $8xCk9.debug.log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $3a821d7162786759$var$logSpanEnd(span) {
    if (!$kcA99.DEBUG_BUILD) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = $awmvd.spanToJSON(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = $awmvd.getRootSpan(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    $8xCk9.debug.log(msg);
}
module.exports.logSpanEnd = $3a821d7162786759$var$logSpanEnd;
module.exports.logSpanStart = $3a821d7162786759$var$logSpanStart;

});

parcelRegister("gb6F8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $5Wkkl = parcelRequire("5Wkkl");

var $8xCk9 = parcelRequire("8xCk9");

var $awmvd = parcelRequire("awmvd");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $bc72d77618f157e0$var$setMeasurement(name, value, unit, activeSpan = $awmvd.getActiveSpan()) {
    const rootSpan = activeSpan && $awmvd.getRootSpan(activeSpan);
    if (rootSpan) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $bc72d77618f157e0$var$timedEventsToMeasurements(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}
module.exports.setMeasurement = $bc72d77618f157e0$var$setMeasurement;
module.exports.timedEventsToMeasurements = $bc72d77618f157e0$var$timedEventsToMeasurements;

});

parcelRegister("akELB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Determines if span streaming is enabled for the given client
 */ function $785b6513e884fb51$var$hasSpanStreamingEnabled(client) {
    return client.getOptions().traceLifecycle === 'stream';
}
module.exports.hasSpanStreamingEnabled = $785b6513e884fb51$var$hasSpanStreamingEnabled;

});


parcelRegister("jLFhR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xgnw = parcelRequire("5xgnw");

var $gg0a2 = parcelRequire("gg0a2");

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $5Wkkl = parcelRequire("5Wkkl");

var $ezFpK = parcelRequire("ezFpK");

var $8xCk9 = parcelRequire("8xCk9");

var $h6ffH = parcelRequire("h6ffH");

var $lvT7Y = parcelRequire("lvT7Y");

var $lTL01 = parcelRequire("lTL01");

var $akELB = parcelRequire("akELB");

var $8aQht = parcelRequire("8aQht");

var $iBLjN = parcelRequire("iBLjN");

var $g26pf = parcelRequire("g26pf");

var $cmHh9 = parcelRequire("cmHh9");

var $awmvd = parcelRequire("awmvd");

var $b4MOa = parcelRequire("b4MOa");

var $i9ydA = parcelRequire("i9ydA");

var $51ra4 = parcelRequire("51ra4");

var $O0YWs = parcelRequire("O0YWs");

var $hNE9t = parcelRequire("hNE9t");

var $jOdAy = parcelRequire("jOdAy");

var $g0XVK = parcelRequire("g0XVK");

var $BB9MH = parcelRequire("BB9MH");
/* eslint-disable max-lines */ const $e6426edebff9841e$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $e6426edebff9841e$var$startSpan(options, callback) {
    const acs = $e6426edebff9841e$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $e6426edebff9841e$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return $9BwS8.withScope(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $e6426edebff9841e$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $9BwS8.getCurrentScope();
            const parentSpan = $e6426edebff9841e$var$getParentSpan(scope, customParentSpan);
            const client = $9BwS8.getClient();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $hNE9t.SentryNonRecordingSpan() : $e6426edebff9841e$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent('no_parent_span', 'span');
            // Ignored root spans still need to be set on scope so that `getActiveSpan()` returns them
            // and descendants are also non-recording. Ignored child spans don't need this because
            // the parent span is already on scope.
            if (!$e6426edebff9841e$var$_isIgnoredSpan(activeSpan) || !parentSpan) $cmHh9._setSpanForScope(scope, activeSpan);
            return $h6ffH.handleCallbackErrors(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = $awmvd.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: $g0XVK.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $e6426edebff9841e$var$startSpanManual(options, callback) {
    const acs = $e6426edebff9841e$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $e6426edebff9841e$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return $9BwS8.withScope(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $e6426edebff9841e$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = $9BwS8.getCurrentScope();
            const parentSpan = $e6426edebff9841e$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new $hNE9t.SentryNonRecordingSpan() : $e6426edebff9841e$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) $9BwS8.getClient()?.recordDroppedEvent('no_parent_span', 'span');
            // We don't set ignored child spans onto the scope because there likely is an active,
            // unignored span on the scope already.
            if (!$e6426edebff9841e$var$_isIgnoredSpan(activeSpan) || !parentSpan) $cmHh9._setSpanForScope(scope, activeSpan);
            return $h6ffH.handleCallbackErrors(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = $awmvd.spanToJSON(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: $g0XVK.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $e6426edebff9841e$var$startInactiveSpan(options) {
    const acs = $e6426edebff9841e$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $e6426edebff9841e$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>$9BwS8.withScope(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$e6426edebff9841e$var$withActiveSpan(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = $9BwS8.getCurrentScope();
        const parentSpan = $e6426edebff9841e$var$getParentSpan(scope, customParentSpan);
        const client = $9BwS8.getClient();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent('no_parent_span', 'span');
            return new $hNE9t.SentryNonRecordingSpan();
        }
        return $e6426edebff9841e$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $e6426edebff9841e$var$continueTrace = (options, callback)=>{
    const carrier$1 = $gg0a2.getMainCarrier();
    const acs = $5xgnw.getAsyncContextStrategy(carrier$1);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage$1 } = options;
    const client = $9BwS8.getClient();
    const incomingDsc = $ezFpK.baggageHeaderToDynamicSamplingContext(baggage$1);
    if (client && !$b4MOa.shouldContinueTrace(client, incomingDsc?.org_id)) return $e6426edebff9841e$var$startNewTrace(callback);
    return $9BwS8.withScope((scope)=>{
        const propagationContext = $b4MOa.propagationContextFromHeaders(sentryTrace, baggage$1);
        scope.setPropagationContext(propagationContext);
        $cmHh9._setSpanForScope(scope, undefined);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $e6426edebff9841e$var$withActiveSpan(span, callback) {
    const acs = $e6426edebff9841e$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return $9BwS8.withScope((scope)=>{
        $cmHh9._setSpanForScope(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $e6426edebff9841e$var$suppressTracing(callback) {
    const acs = $e6426edebff9841e$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return $9BwS8.withScope((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$e6426edebff9841e$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$e6426edebff9841e$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $e6426edebff9841e$var$startNewTrace(callback) {
    const acs = $e6426edebff9841e$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return $9BwS8.withScope((scope)=>{
        scope.setPropagationContext({
            traceId: $iBLjN.generateTraceId(),
            sampleRand: $g26pf.safeMathRandom()
        });
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $e6426edebff9841e$var$withActiveSpan(null, callback);
    });
}
function $e6426edebff9841e$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!$lvT7Y.hasSpansEnabled()) {
        const span = new $hNE9t.SentryNonRecordingSpan();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...$i9ydA.getDynamicSamplingContextFromSpan(span)
            };
            $i9ydA.freezeDscOnSpan(span, dsc);
        }
        return span;
    }
    const client = $9BwS8.getClient();
    if ($e6426edebff9841e$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$e6426edebff9841e$var$_isTracingSuppressed(scope)) // if tracing is actively suppressed (Sentry.suppressTracing(...)),
        // we don't want to record a client outcome for the ignored span
        client?.recordDroppedEvent('ignored', 'span');
        return new $hNE9t.SentryNonRecordingSpan({
            dropReason: 'ignored',
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = $9BwS8.getIsolationScope();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $e6426edebff9841e$var$_startChildSpan(parentSpan, scope, spanArguments);
        $awmvd.addChildSpanToSpan(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = $i9ydA.getDynamicSamplingContextFromSpan(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = $awmvd.spanIsSampled(parentSpan);
        span = $e6426edebff9841e$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        $i9ydA.freezeDscOnSpan(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $e6426edebff9841e$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) $i9ydA.freezeDscOnSpan(span, dsc);
    }
    $51ra4.logSpanStart(span);
    $BB9MH.setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $e6426edebff9841e$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = $awmvd.spanTimeInputToSeconds(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $e6426edebff9841e$var$getAcs() {
    const carrier$1 = $gg0a2.getMainCarrier();
    return $5xgnw.getAsyncContextStrategy(carrier$1);
}
function $e6426edebff9841e$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = $9BwS8.getClient();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $e6426edebff9841e$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : $O0YWs.sampleSpan(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: $8aQht.parseSampleRate(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new $jOdAy.SentrySpan({
        ...spanArguments,
        attributes: {
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'custom',
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', $akELB.hasSpanStreamingEnabled(client) ? 'span' : 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $e6426edebff9841e$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $e6426edebff9841e$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : $awmvd.spanIsSampled(parentSpan);
    const childSpan = sampled ? new $jOdAy.SentrySpan({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new $hNE9t.SentryNonRecordingSpan({
        traceId: traceId
    });
    $awmvd.addChildSpanToSpan(parentSpan, childSpan);
    const client = $9BwS8.getClient();
    if (!client) return childSpan;
    if ($akELB.hasSpanStreamingEnabled(client) && childSpan instanceof $hNE9t.SentryNonRecordingSpan) {
        if (parentSpan instanceof $hNE9t.SentryNonRecordingSpan && parentSpan.dropReason) {
            // We land here if the parent span was a segment span that was ignored (`ignoreSpans`).
            // In this case, the child was also ignored (see `sampled` above) but we need to
            // record a client outcome for the child.
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, 'span');
        } else if (!isTracingSuppressed) {
            // Otherwise, the child is not sampled due to sampling of the parent span,
            // hence we record a sample_rate client outcome for the child.
            childSpan.dropReason = 'sample_rate';
            client.recordDroppedEvent('sample_rate', 'span');
        }
    }
    client.emit('spanStart', childSpan);
    // If it has an endTimestamp, it's already ended
    if (spanArguments.endTimestamp) {
        client.emit('spanEnd', childSpan);
        client.emit('afterSpanEnd', childSpan);
    }
    return childSpan;
}
function $e6426edebff9841e$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = $cmHh9._getSpanForScope(scope);
    if (!span) return undefined;
    const client = $9BwS8.getClient();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return $awmvd.getRootSpan(span);
    return span;
}
function $e6426edebff9841e$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $e6426edebff9841e$var$withActiveSpan(parentSpan, callback);
    } : (callback)=>callback();
}
/* Checks if `ignoreSpans` applies (extracted for bundle size)*/ function $e6426edebff9841e$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !$akELB.hasSpanStreamingEnabled(client) || !ignoreSpans?.length) return false;
    return $lTL01.shouldIgnoreSpan({
        description: spanArguments.name || '',
        op: spanArguments.attributes?.[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $e6426edebff9841e$var$_isIgnoredSpan(span) {
    return span instanceof $hNE9t.SentryNonRecordingSpan && span.dropReason === 'ignored';
}
function $e6426edebff9841e$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$e6426edebff9841e$var$SUPPRESS_TRACING_KEY] === true;
}
module.exports.SUPPRESS_TRACING_KEY = $e6426edebff9841e$var$SUPPRESS_TRACING_KEY;
module.exports.continueTrace = $e6426edebff9841e$var$continueTrace;
module.exports.startInactiveSpan = $e6426edebff9841e$var$startInactiveSpan;
module.exports.startNewTrace = $e6426edebff9841e$var$startNewTrace;
module.exports.startSpan = $e6426edebff9841e$var$startSpan;
module.exports.startSpanManual = $e6426edebff9841e$var$startSpanManual;
module.exports.suppressTracing = $e6426edebff9841e$var$suppressTracing;
module.exports.withActiveSpan = $e6426edebff9841e$var$withActiveSpan;

});
parcelRegister("h6ffH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Q5Le = parcelRequire("2Q5Le");

var $8wdL3 = parcelRequire("8wdL3");
/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $c72ed3f74f30877e$var$handleCallbackErrors(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $c72ed3f74f30877e$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 *
 * For thenable objects with extra methods (like jQuery's jqXHR),
 * this function preserves those methods by wrapping the original thenable in a Proxy
 * that intercepts .then() calls to apply error handling while forwarding all other
 * properties to the original object.
 * This allows code like `startSpan(() => $.ajax(...)).abort()` to work correctly.
 */ function $c72ed3f74f30877e$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ($8wdL3.isThenable(value)) return $2Q5Le.chainAndCopyPromiseLike(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    // Non-thenable value - call callbacks immediately and return as-is
    onFinally();
    onSuccess(value);
    return value;
}
module.exports.handleCallbackErrors = $c72ed3f74f30877e$var$handleCallbackErrors;

});

parcelRegister("O0YWs", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $lvT7Y = parcelRequire("lvT7Y");

var $8aQht = parcelRequire("8aQht");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $09656e9e44d06987$var$sampleSpan(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!$lvT7Y.hasSpansEnabled(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = $8aQht.parseSampleRate(sampleRate);
    if (parsedSampleRate === undefined) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}
module.exports.sampleSpan = $09656e9e44d06987$var$sampleSpan;

});



parcelRegister("ei9kR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5Wkkl = parcelRequire("5Wkkl");

var $hh7n5 = parcelRequire("hh7n5");

var $2Y94s = parcelRequire("2Y94s");

var $awmvd = parcelRequire("awmvd");

var $BB9MH = parcelRequire("BB9MH");

var $dh5pl = parcelRequire("dh5pl");
/**
 * Captures a span and returns a JSON representation to be enqueued for sending.
 *
 * IMPORTANT: This function converts the span to JSON immediately to avoid writing
 * to an already-ended OTel span instance (which is blocked by the OTel Span class).
 *
 * @returns the final serialized span with a reference to its segment span. This reference
 * is needed later on to compute the DSC for the span envelope.
 */ function $a679fcf07cd4f55b$var$captureSpan(span, client) {
    // Convert to JSON FIRST - we cannot write to an already-ended span
    const spanJSON = $awmvd.spanToStreamedSpanJSON(span);
    const segmentSpan = $awmvd.INTERNAL_getSegmentSpan(span);
    const serializedSegmentSpan = $awmvd.spanToStreamedSpanJSON(segmentSpan);
    const { isolationScope: spanIsolationScope, scope: spanScope } = $BB9MH.getCapturedScopesOnSpan(span);
    const finalScopeData = $hh7n5.getCombinedScopeData(spanIsolationScope, spanScope);
    $a679fcf07cd4f55b$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
    // Backfill span data from OTel semantic conventions when not explicitly set.
    // OTel-originated spans don't have sentry.op, description, etc. — the non-streamed path
    // infers these in the SentrySpanExporter, but streamed spans skip the exporter entirely.
    // Access `kind` via duck-typing — OTel span objects have this property but it's not on Sentry's Span type.
    // This must run before all hooks and beforeSendSpan so that user callbacks can see and override inferred values.
    const spanKind = span.kind;
    $a679fcf07cd4f55b$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind);
    if (spanJSON.is_segment) // Allow hook subscribers to mutate the segment span JSON
    // This also invokes the `processSegmentSpan` hook of all integrations
    client.emit('processSegmentSpan', spanJSON);
    // This allows hook subscribers to mutate the span JSON
    // This also invokes the `processSpan` hook of all integrations
    client.emit('processSpan', spanJSON);
    const { beforeSendSpan: beforeSendSpan$1 } = client.getOptions();
    const processedSpan = beforeSendSpan$1 && $dh5pl.isStreamedBeforeSendSpanCallback(beforeSendSpan$1) ? $a679fcf07cd4f55b$var$applyBeforeSendSpanCallback(spanJSON, beforeSendSpan$1) : spanJSON;
    // Backfill sentry.span.source from sentry.source. Only `sentry.span.source` is respected by Sentry.
    // TODO(v11): Remove this backfill once we renamed SEMANTIC_ATTRIBUTE_SENTRY_SOURCE to sentry.span.source
    const spanNameSource = processedSpan.attributes?.[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    if (spanNameSource) $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(processedSpan, {
        // Purposefully not using a constant defined here like in other attributes:
        // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
        'sentry.span.source': spanNameSource
    });
    return {
        ...$awmvd.streamedSpanJsonToSerializedSpan(processedSpan),
        _segmentSpan: segmentSpan
    };
}
/**
 * Safely set attributes on a span JSON.
 * If an attribute already exists, it will not be overwritten.
 */ function $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, newAttributes) {
    const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
    Object.entries(newAttributes).forEach(([key, value])=>{
        if (value != null && !(key in originalAttributes)) originalAttributes[key] = value;
    });
}
function $a679fcf07cd4f55b$var$applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
    const sdk = client.getSdkMetadata();
    const { release: release, environment: environment } = client.getOptions();
    // avoid overwriting any previously set attributes (from users or potentially our SDK instrumentation)
    $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, {
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_RELEASE]: release,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT]: environment,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME]: serializedSegmentSpan.name,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID]: serializedSegmentSpan.span_id,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME]: sdk?.sdk?.name,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION]: sdk?.sdk?.version,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_USER_ID]: scopeData.user?.id,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_USER_EMAIL]: scopeData.user?.email,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: scopeData.user?.ip_address,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_USER_USERNAME]: scopeData.user?.username,
        ...scopeData.attributes
    });
}
/**
 * Apply a user-provided beforeSendSpan callback to a span JSON.
 */ function $a679fcf07cd4f55b$var$applyBeforeSendSpanCallback(span, beforeSendSpan) {
    const modifedSpan = beforeSendSpan(span);
    if (!modifedSpan) {
        $awmvd.showSpanDropWarning();
        return span;
    }
    return modifedSpan;
}
// OTel SpanKind values (numeric to avoid importing from @opentelemetry/api)
const $a679fcf07cd4f55b$var$SPAN_KIND_SERVER = 1;
const $a679fcf07cd4f55b$var$SPAN_KIND_CLIENT = 2;
/**
 * Infer and backfill span data from OTel semantic conventions.
 * This mirrors what the `SentrySpanExporter` does for non-streamed spans via `getSpanData`/`inferSpanData`.
 * Streamed spans skip the exporter, so we do the inference here during capture.
 *
 * Backfills: `sentry.op`, `sentry.source`, and `name` (description).
 * Uses `safeSetSpanJSONAttributes` so explicitly set attributes are never overwritten.
 */ /** Exported only for tests. */ function $a679fcf07cd4f55b$var$inferSpanDataFromOtelAttributes(spanJSON, spanKind) {
    const attributes = spanJSON.attributes;
    if (!attributes) return;
    const httpMethod = attributes['http.request.method'] || attributes['http.method'];
    if (httpMethod) {
        $a679fcf07cd4f55b$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod);
        return;
    }
    const dbSystem = attributes['db.system.name'] || attributes['db.system'];
    const opIsCache = typeof attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP] === 'string' && `${attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]}`.startsWith('cache.');
    if (dbSystem && !opIsCache) {
        $a679fcf07cd4f55b$var$inferDbSpanData(spanJSON, attributes);
        return;
    }
    if (attributes['rpc.service']) {
        $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, {
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'rpc'
        });
        return;
    }
    if (attributes['messaging.system']) {
        $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, {
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'message'
        });
        return;
    }
    const faasTrigger = attributes['faas.trigger'];
    if (faasTrigger) $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, {
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: `${faasTrigger}`
    });
}
function $a679fcf07cd4f55b$var$inferHttpSpanData(spanJSON, attributes, spanKind, httpMethod) {
    // Infer op: http.client, http.server, or just http
    const opParts = [
        'http'
    ];
    if (spanKind === $a679fcf07cd4f55b$var$SPAN_KIND_CLIENT) opParts.push('client');
    else if (spanKind === $a679fcf07cd4f55b$var$SPAN_KIND_SERVER) opParts.push('server');
    if (attributes['sentry.http.prefetch']) opParts.push('prefetch');
    $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, {
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: opParts.join('.')
    });
    // If the user set a custom span name via updateSpanName(), apply it — OTel instrumentation
    // may have overwritten span.name after the user set it, so we restore from the attribute.
    const customName = attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === 'string') {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === 'custom') return;
    const httpRoute = attributes['http.route'];
    if (typeof httpRoute === 'string') {
        spanJSON.name = `${httpMethod} ${httpRoute}`;
        $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, {
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'route'
        });
    } else {
        // Infer span name from URL attributes, matching the non-streamed exporter's behavior.
        // Only overwrite the name for OTel spans (known spanKind)
        if (spanKind === $a679fcf07cd4f55b$var$SPAN_KIND_CLIENT || spanKind === $a679fcf07cd4f55b$var$SPAN_KIND_SERVER) {
            const urlPath = $a679fcf07cd4f55b$var$getUrlPath(attributes, spanKind);
            if (urlPath) spanJSON.name = `${httpMethod} ${urlPath}`;
        }
        $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, {
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'url'
        });
    }
}
/**
 * Extract a URL path from span attributes for use in the span name.
 * Mirrors the logic in the non-streamed exporter's `getSanitizedUrl`.
 */ function $a679fcf07cd4f55b$var$getUrlPath(attributes, spanKind) {
    const httpUrl = attributes['http.url'] || attributes['url.full'];
    const httpTarget = attributes['http.target'];
    const parsedUrl = typeof httpUrl === 'string' ? $2Y94s.parseUrl(httpUrl) : undefined;
    const sanitizedUrl = parsedUrl ? $2Y94s.getSanitizedUrlString(parsedUrl) : undefined;
    // For server spans, prefer the relative target path
    if (spanKind === $a679fcf07cd4f55b$var$SPAN_KIND_SERVER && typeof httpTarget === 'string') return $2Y94s.stripUrlQueryAndFragment(httpTarget);
    // For client spans (and others), use the full sanitized URL
    if (sanitizedUrl) return sanitizedUrl;
    // Fall back to target if no full URL is available
    if (typeof httpTarget === 'string') return $2Y94s.stripUrlQueryAndFragment(httpTarget);
    return undefined;
}
function $a679fcf07cd4f55b$var$inferDbSpanData(spanJSON, attributes) {
    $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, {
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'db'
    });
    // If the user set a custom span name via updateSpanName(), apply it.
    const customName = attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
    if (typeof customName === 'string') {
        spanJSON.name = customName;
        return;
    }
    if (attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] === 'custom') return;
    const statement = attributes['db.statement'];
    if (statement) {
        spanJSON.name = `${statement}`;
        $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes(spanJSON, {
            [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'task'
        });
    }
}
module.exports.applyBeforeSendSpanCallback = $a679fcf07cd4f55b$var$applyBeforeSendSpanCallback;
module.exports.captureSpan = $a679fcf07cd4f55b$var$captureSpan;
module.exports.inferSpanDataFromOtelAttributes = $a679fcf07cd4f55b$var$inferSpanDataFromOtelAttributes;
module.exports.safeSetSpanJSONAttributes = $a679fcf07cd4f55b$var$safeSetSpanJSONAttributes;

});
parcelRegister("hh7n5", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $i9ydA = parcelRequire("i9ydA");

var $6BF4X = parcelRequire("6BF4X");

var $awmvd = parcelRequire("awmvd");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $c939bdfde6ec8c3f$var$applyScopeDataToEvent(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $c939bdfde6ec8c3f$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $c939bdfde6ec8c3f$var$applySpanToEvent(event, span);
    $c939bdfde6ec8c3f$var$applyFingerprintToEvent(event, fingerprint);
    $c939bdfde6ec8c3f$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $c939bdfde6ec8c3f$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $c939bdfde6ec8c3f$var$mergeScopeData(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $c939bdfde6ec8c3f$var$mergeAndOverwriteScopeData(data, 'extra', extra);
    $c939bdfde6ec8c3f$var$mergeAndOverwriteScopeData(data, 'tags', tags);
    $c939bdfde6ec8c3f$var$mergeAndOverwriteScopeData(data, 'attributes', attributes);
    $c939bdfde6ec8c3f$var$mergeAndOverwriteScopeData(data, 'user', user);
    $c939bdfde6ec8c3f$var$mergeAndOverwriteScopeData(data, 'contexts', contexts);
    data.sdkProcessingMetadata = $6BF4X.merge(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $c939bdfde6ec8c3f$var$mergeAndOverwriteScopeData(data, prop, mergeVal) {
    data[prop] = $6BF4X.merge(data[prop], mergeVal, 1);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $c939bdfde6ec8c3f$var$getCombinedScopeData(isolationScope, currentScope) {
    const scopeData = $9BwS8.getGlobalScope().getScopeData();
    isolationScope && $c939bdfde6ec8c3f$var$mergeScopeData(scopeData, isolationScope.getScopeData());
    currentScope && $c939bdfde6ec8c3f$var$mergeScopeData(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $c939bdfde6ec8c3f$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $c939bdfde6ec8c3f$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $c939bdfde6ec8c3f$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $c939bdfde6ec8c3f$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: $awmvd.spanToTraceContext(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: $i9ydA.getDynamicSamplingContextFromSpan(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = $awmvd.getRootSpan(span);
    const transactionName = $awmvd.spanToJSON(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $c939bdfde6ec8c3f$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}
module.exports.applyScopeDataToEvent = $c939bdfde6ec8c3f$var$applyScopeDataToEvent;
module.exports.getCombinedScopeData = $c939bdfde6ec8c3f$var$getCombinedScopeData;
module.exports.mergeAndOverwriteScopeData = $c939bdfde6ec8c3f$var$mergeAndOverwriteScopeData;
module.exports.mergeScopeData = $c939bdfde6ec8c3f$var$mergeScopeData;

});

parcelRegister("2Y94s", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5Wkkl = parcelRequire("5Wkkl");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $229838a33aa56a08$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $229838a33aa56a08$var$isURLObjectRelative(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $229838a33aa56a08$var$parseStringToURLObject(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $229838a33aa56a08$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $229838a33aa56a08$var$getSanitizedUrlStringFromUrlObject(url) {
    if ($229838a33aa56a08$var$isURLObjectRelative(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $229838a33aa56a08$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $229838a33aa56a08$var$getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $229838a33aa56a08$var$getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request?.method) attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$229838a33aa56a08$var$isURLObjectRelative(urlObject)) {
            attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $229838a33aa56a08$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $229838a33aa56a08$var$parseUrl(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $229838a33aa56a08$var$stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $229838a33aa56a08$var$getSanitizedUrlString(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}
/**
 * Strips the content from a data URL, returning a placeholder with the MIME type.
 *
 * Data URLs can be very long (e.g. base64 encoded scripts for Web Workers),
 * with little valuable information, often leading to envelopes getting dropped due
 * to size limit violations. Therefore, we strip data URLs and replace them with a
 * placeholder.
 *
 * @param url - The URL to process
 * @param includeDataPrefix - If true, includes the first 10 characters of the data stream
 *                            for debugging (e.g., to identify magic bytes like WASM's AGFzbQ).
 *                            Defaults to true.
 * @returns For data URLs, returns a short format like `data:text/javascript;base64,SGVsbG8gV2... [truncated]`.
 *          For non-data URLs, returns the original URL unchanged.
 */ function $229838a33aa56a08$var$stripDataUrlContent(url, includeDataPrefix = true) {
    if (url.startsWith('data:')) {
        // Match the MIME type (everything after 'data:' until the first ';' or ',')
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : 'text/plain';
        const isBase64 = url.includes(';base64,');
        // Find where the actual data starts (after the comma)
        const dataStart = url.indexOf(',');
        let dataPrefix = '';
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            // Include first 10 chars of data to help identify content (e.g., magic bytes)
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ',base64' : ''}${dataPrefix ? `,${dataPrefix}` : ''}`;
    }
    return url;
}
module.exports.getHttpSpanDetailsFromUrlObject = $229838a33aa56a08$var$getHttpSpanDetailsFromUrlObject;
module.exports.getSanitizedUrlString = $229838a33aa56a08$var$getSanitizedUrlString;
module.exports.getSanitizedUrlStringFromUrlObject = $229838a33aa56a08$var$getSanitizedUrlStringFromUrlObject;
module.exports.isURLObjectRelative = $229838a33aa56a08$var$isURLObjectRelative;
module.exports.parseStringToURLObject = $229838a33aa56a08$var$parseStringToURLObject;
module.exports.parseUrl = $229838a33aa56a08$var$parseUrl;
module.exports.stripDataUrlContent = $229838a33aa56a08$var$stripDataUrlContent;
module.exports.stripUrlQueryAndFragment = $229838a33aa56a08$var$stripUrlQueryAndFragment;

});


parcelRegister("1XEa4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $hGRvQ = parcelRequire("hGRvQ");

var $jLFhR = parcelRequire("jLFhR");

var $8xCk9 = parcelRequire("8xCk9");

var $8wdL3 = parcelRequire("8wdL3");

var $dHx3C = parcelRequire("dHx3C");

var $8cgLj = parcelRequire("8cgLj");

var $hh7n5 = parcelRequire("hh7n5");

var $j8mWA = parcelRequire("j8mWA");

var $4onm8 = parcelRequire("4onm8");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $16da745e280a83c3$var$captureException(exception, hint) {
    return $9BwS8.getCurrentScope().captureException(exception, $8cgLj.parseEventHintOrCaptureContext(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $16da745e280a83c3$var$captureMessage(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const hint = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $9BwS8.getCurrentScope().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $16da745e280a83c3$var$captureEvent(event, hint) {
    return $9BwS8.getCurrentScope().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $16da745e280a83c3$var$setContext(name, context) {
    $9BwS8.getIsolationScope().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $16da745e280a83c3$var$setExtras(extras) {
    $9BwS8.getIsolationScope().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $16da745e280a83c3$var$setExtra(key, extra) {
    $9BwS8.getIsolationScope().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $16da745e280a83c3$var$setTags(tags) {
    $9BwS8.getIsolationScope().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $16da745e280a83c3$var$setTag(key, value) {
    $9BwS8.getIsolationScope().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $16da745e280a83c3$var$setUser(user) {
    $9BwS8.getIsolationScope().setUser(user);
}
/**
 * Sets the conversation ID for the current isolation scope.
 *
 * @param conversationId The conversation ID to set. Pass `null` or `undefined` to unset the conversation ID.
 */ function $16da745e280a83c3$var$setConversationId(conversationId) {
    $9BwS8.getIsolationScope().setConversationId(conversationId);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $16da745e280a83c3$var$lastEventId() {
    return $9BwS8.getIsolationScope().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $16da745e280a83c3$var$captureCheckIn(checkIn, upsertMonitorConfig) {
    const scope = $9BwS8.getCurrentScope();
    const client = $9BwS8.getClient();
    if (!client) $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return $dHx3C.uuid4();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $16da745e280a83c3$var$withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $16da745e280a83c3$var$captureCheckIn({
            monitorSlug: monitorSlug,
            status: 'in_progress'
        }, upsertMonitorConfig);
        const now = $j8mWA.timestampInSeconds();
        function finishCheckIn(status) {
            $16da745e280a83c3$var$captureCheckIn({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: $j8mWA.timestampInSeconds() - now
            });
        }
        // Default behavior without isolateTrace
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ($8wdL3.isThenable(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    }
    return $9BwS8.withIsolationScope(()=>upsertMonitorConfig?.isolateTrace ? $jLFhR.startNewTrace(runCallback) : runCallback());
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $16da745e280a83c3$var$flush(timeout) {
    const client = $9BwS8.getClient();
    if (client) return client.flush(timeout);
    $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $16da745e280a83c3$var$close(timeout) {
    const client = $9BwS8.getClient();
    if (client) return client.close(timeout);
    $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $16da745e280a83c3$var$isInitialized() {
    return !!$9BwS8.getClient();
}
/** If the SDK is initialized & enabled. */ function $16da745e280a83c3$var$isEnabled() {
    const client = $9BwS8.getClient();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $16da745e280a83c3$var$addEventProcessor(callback) {
    $9BwS8.getIsolationScope().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $16da745e280a83c3$var$startSession(context) {
    const isolationScope = $9BwS8.getIsolationScope();
    const { user: user } = $hh7n5.getCombinedScopeData(isolationScope, $9BwS8.getCurrentScope());
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = $4onm8.GLOBAL_OBJ.navigator || {};
    const session$1 = $hGRvQ.makeSession({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') $hGRvQ.updateSession(currentSession, {
        status: 'exited'
    });
    $16da745e280a83c3$var$endSession();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session$1);
    return session$1;
}
/**
 * End the session on the current isolation scope.
 */ function $16da745e280a83c3$var$endSession() {
    const isolationScope = $9BwS8.getIsolationScope();
    const currentScope = $9BwS8.getCurrentScope();
    const session$1 = currentScope.getSession() || isolationScope.getSession();
    if (session$1) $hGRvQ.closeSession(session$1);
    $16da745e280a83c3$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $16da745e280a83c3$var$_sendSessionUpdate() {
    const isolationScope = $9BwS8.getIsolationScope();
    const client = $9BwS8.getClient();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $16da745e280a83c3$var$captureSession(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $16da745e280a83c3$var$endSession();
        return;
    }
    // only send the update
    $16da745e280a83c3$var$_sendSessionUpdate();
}
module.exports.addEventProcessor = $16da745e280a83c3$var$addEventProcessor;
module.exports.captureCheckIn = $16da745e280a83c3$var$captureCheckIn;
module.exports.captureEvent = $16da745e280a83c3$var$captureEvent;
module.exports.captureException = $16da745e280a83c3$var$captureException;
module.exports.captureMessage = $16da745e280a83c3$var$captureMessage;
module.exports.captureSession = $16da745e280a83c3$var$captureSession;
module.exports.close = $16da745e280a83c3$var$close;
module.exports.endSession = $16da745e280a83c3$var$endSession;
module.exports.flush = $16da745e280a83c3$var$flush;
module.exports.isEnabled = $16da745e280a83c3$var$isEnabled;
module.exports.isInitialized = $16da745e280a83c3$var$isInitialized;
module.exports.lastEventId = $16da745e280a83c3$var$lastEventId;
module.exports.setContext = $16da745e280a83c3$var$setContext;
module.exports.setConversationId = $16da745e280a83c3$var$setConversationId;
module.exports.setExtra = $16da745e280a83c3$var$setExtra;
module.exports.setExtras = $16da745e280a83c3$var$setExtras;
module.exports.setTag = $16da745e280a83c3$var$setTag;
module.exports.setTags = $16da745e280a83c3$var$setTags;
module.exports.setUser = $16da745e280a83c3$var$setUser;
module.exports.startSession = $16da745e280a83c3$var$startSession;
module.exports.withMonitor = $16da745e280a83c3$var$withMonitor;

});
parcelRegister("8cgLj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $03X1l = parcelRequire("03X1l");

var $kkRyJ = parcelRequire("kkRyJ");

var $eBvnD = parcelRequire("eBvnD");

var $1OlQS = parcelRequire("1OlQS");

var $dHx3C = parcelRequire("dHx3C");

var $kUcj7 = parcelRequire("kUcj7");

var $hh7n5 = parcelRequire("hh7n5");

var $cZaOW = parcelRequire("cZaOW");

var $5iQrB = parcelRequire("5iQrB");

var $j8mWA = parcelRequire("j8mWA");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $5f7c724dae632e52$var$prepareEvent(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || $dHx3C.uuid4(),
        timestamp: event.timestamp || $j8mWA.dateTimestampInSeconds()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $5f7c724dae632e52$var$applyClientOptions(prepared, options);
    $5f7c724dae632e52$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $5f7c724dae632e52$var$applyDebugIds(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $5f7c724dae632e52$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) $dHx3C.addExceptionMechanism(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = $hh7n5.getCombinedScopeData(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    $hh7n5.applyScopeDataToEvent(prepared, data);
    const eventProcessors$1 = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    // Skip event processors for internal exceptions to prevent recursion
    // oxlint-disable-next-line typescript/prefer-optional-chain
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? $5iQrB.resolvedSyncPromise(prepared) : $kkRyJ.notifyEventProcessors(eventProcessors$1, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $5f7c724dae632e52$var$applyDebugMeta(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $5f7c724dae632e52$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $5f7c724dae632e52$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || $03X1l.DEFAULT_ENVIRONMENT;
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = $cZaOW.truncate(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) // Truncates error messages
        exception.value = $cZaOW.truncate(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $5f7c724dae632e52$var$applyDebugIds(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = $1OlQS.getFilenameToDebugIdMap(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $5f7c724dae632e52$var$applyDebugMeta(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $5f7c724dae632e52$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $5f7c724dae632e52$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: $kUcj7.normalize(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: $kUcj7.normalize(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: $kUcj7.normalize(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: $kUcj7.normalize(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = $kUcj7.normalize(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: $kUcj7.normalize(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = $kUcj7.normalize(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $5f7c724dae632e52$var$getFinalScope(scope$1, captureContext) {
    if (!captureContext) return scope$1;
    const finalScope = scope$1 ? scope$1.clone() : new $eBvnD.Scope();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $5f7c724dae632e52$var$parseEventHintOrCaptureContext(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($5f7c724dae632e52$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($5f7c724dae632e52$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $5f7c724dae632e52$var$hintIsScopeOrFunction(hint) {
    return hint instanceof $eBvnD.Scope || typeof hint === 'function';
}
const $5f7c724dae632e52$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $5f7c724dae632e52$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$5f7c724dae632e52$var$captureContextKeys.includes(key));
}
module.exports.applyClientOptions = $5f7c724dae632e52$var$applyClientOptions;
module.exports.applyDebugIds = $5f7c724dae632e52$var$applyDebugIds;
module.exports.applyDebugMeta = $5f7c724dae632e52$var$applyDebugMeta;
module.exports.parseEventHintOrCaptureContext = $5f7c724dae632e52$var$parseEventHintOrCaptureContext;
module.exports.prepareEvent = $5f7c724dae632e52$var$prepareEvent;

});
parcelRegister("kkRyJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $8wdL3 = parcelRequire("8wdL3");

var $5iQrB = parcelRequire("5iQrB");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $ecdf38a5796f62f0$var$notifyEventProcessors(processors, event, hint, index = 0) {
    try {
        const result = $ecdf38a5796f62f0$var$_notifyEventProcessors(event, hint, processors, index);
        return $8wdL3.isThenable(result) ? result : $5iQrB.resolvedSyncPromise(result);
    } catch (error) {
        return $5iQrB.rejectedSyncPromise(error);
    }
}
function $ecdf38a5796f62f0$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    $kcA99.DEBUG_BUILD && result === null && $8xCk9.debug.log(`Event processor "${processor.id || '?'}" dropped event`);
    if ($8wdL3.isThenable(result)) return result.then((final)=>$ecdf38a5796f62f0$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $ecdf38a5796f62f0$var$_notifyEventProcessors(result, hint, processors, index + 1);
}
module.exports.notifyEventProcessors = $ecdf38a5796f62f0$var$notifyEventProcessors;

});
parcelRegister("5iQrB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8wdL3 = parcelRequire("8wdL3");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $3dc75084fa48d07e$var$STATE_PENDING = 0;
const $3dc75084fa48d07e$var$STATE_RESOLVED = 1;
const $3dc75084fa48d07e$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $3dc75084fa48d07e$var$resolvedSyncPromise(value) {
    return new $3dc75084fa48d07e$var$SyncPromise((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $3dc75084fa48d07e$var$rejectedSyncPromise(reason) {
    return new $3dc75084fa48d07e$var$SyncPromise((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $3dc75084fa48d07e$var$SyncPromise {
    constructor(executor){
        this._state = $3dc75084fa48d07e$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $3dc75084fa48d07e$var$SyncPromise((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $3dc75084fa48d07e$var$SyncPromise((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $3dc75084fa48d07e$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $3dc75084fa48d07e$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $3dc75084fa48d07e$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $3dc75084fa48d07e$var$STATE_PENDING) return;
            if ($8wdL3.isThenable(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($3dc75084fa48d07e$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($3dc75084fa48d07e$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}
module.exports.SyncPromise = $3dc75084fa48d07e$var$SyncPromise;
module.exports.rejectedSyncPromise = $3dc75084fa48d07e$var$rejectedSyncPromise;
module.exports.resolvedSyncPromise = $3dc75084fa48d07e$var$resolvedSyncPromise;

});


parcelRegister("1OlQS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $3ycrv = parcelRequire("3ycrv");

var $4onm8 = parcelRequire("4onm8");
let $151b69490036d7d7$var$parsedStackResults;
let $151b69490036d7d7$var$lastSentryKeysCount;
let $151b69490036d7d7$var$lastNativeKeysCount;
let $151b69490036d7d7$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function $151b69490036d7d7$var$getFilenameToDebugIdMap(stackParser) {
    const sentryDebugIdMap = $4onm8.GLOBAL_OBJ._sentryDebugIds;
    const nativeDebugIdMap = $4onm8.GLOBAL_OBJ._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($151b69490036d7d7$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $151b69490036d7d7$var$lastSentryKeysCount && nativeDebugIdKeys.length === $151b69490036d7d7$var$lastNativeKeysCount) return $151b69490036d7d7$var$cachedFilenameDebugIds;
    $151b69490036d7d7$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $151b69490036d7d7$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    $151b69490036d7d7$var$cachedFilenameDebugIds = {};
    if (!$151b69490036d7d7$var$parsedStackResults) $151b69490036d7d7$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $151b69490036d7d7$var$parsedStackResults?.[key];
            if (result && $151b69490036d7d7$var$cachedFilenameDebugIds && debugId) {
                // Use cached filename but update with current debug ID
                $151b69490036d7d7$var$cachedFilenameDebugIds[result[0]] = debugId;
                // Update cached result with new debug ID
                if ($151b69490036d7d7$var$parsedStackResults) $151b69490036d7d7$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $151b69490036d7d7$var$cachedFilenameDebugIds && $151b69490036d7d7$var$parsedStackResults) {
                        $151b69490036d7d7$var$cachedFilenameDebugIds[filename] = debugId;
                        $151b69490036d7d7$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $151b69490036d7d7$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $151b69490036d7d7$var$getDebugImagesForResources(stackParser, resource_paths) {
    const filenameDebugIdMap = $151b69490036d7d7$var$getFilenameToDebugIdMap(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = $3ycrv.normalizeStackTracePath(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: 'sourcemap',
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}
module.exports.getDebugImagesForResources = $151b69490036d7d7$var$getDebugImagesForResources;
module.exports.getFilenameToDebugIdMap = $151b69490036d7d7$var$getFilenameToDebugIdMap;

});



parcelRegister("eheGM", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9FnMD = parcelRequire("9FnMD");
const $a64e0c22ee7b91a5$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a64e0c22ee7b91a5$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $a64e0c22ee7b91a5$var$_getIngestEndpoint(dsn) {
    return `${$a64e0c22ee7b91a5$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a64e0c22ee7b91a5$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $a64e0c22ee7b91a5$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $a64e0c22ee7b91a5$var$getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$a64e0c22ee7b91a5$var$_getIngestEndpoint(dsn)}?${$a64e0c22ee7b91a5$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $a64e0c22ee7b91a5$var$getReportDialogEndpoint(dsnLike, dialogOptions) {
    const dsn$1 = $9FnMD.makeDsn(dsnLike);
    if (!dsn$1) return '';
    const endpoint = `${$a64e0c22ee7b91a5$var$getBaseApiEndpoint(dsn$1)}embed/error-page/`;
    let encodedOptions = `dsn=${$9FnMD.dsnToString(dsn$1)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}
module.exports.SENTRY_API_VERSION = $a64e0c22ee7b91a5$var$SENTRY_API_VERSION;
module.exports.getEnvelopeEndpointWithUrlEncodedAuth = $a64e0c22ee7b91a5$var$getEnvelopeEndpointWithUrlEncodedAuth;
module.exports.getReportDialogEndpoint = $a64e0c22ee7b91a5$var$getReportDialogEndpoint;

});

parcelRegister("1tZyf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eheGM = parcelRequire("eheGM");

var $03X1l = parcelRequire("03X1l");

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $cCYFf = parcelRequire("cCYFf");

var $41JP2 = parcelRequire("41JP2");

var $9bAWT = parcelRequire("9bAWT");

var $35EDI = parcelRequire("35EDI");

var $hGRvQ = parcelRequire("hGRvQ");

var $i9ydA = parcelRequire("i9ydA");

var $dh5pl = parcelRequire("dh5pl");

var $j0dcw = parcelRequire("j0dcw");

var $eCpC3 = parcelRequire("eCpC3");

var $ixmfD = parcelRequire("ixmfD");

var $8xCk9 = parcelRequire("8xCk9");

var $9FnMD = parcelRequire("9FnMD");

var $SMVsN = parcelRequire("SMVsN");

var $l0hZo = parcelRequire("l0hZo");

var $8wdL3 = parcelRequire("8wdL3");

var $6BF4X = parcelRequire("6BF4X");

var $dHx3C = parcelRequire("dHx3C");

var $8aQht = parcelRequire("8aQht");

var $8cgLj = parcelRequire("8cgLj");

var $17WZH = parcelRequire("17WZH");

var $g26pf = parcelRequire("g26pf");

var $lTL01 = parcelRequire("lTL01");

var $awmvd = parcelRequire("awmvd");

var $5iQrB = parcelRequire("5iQrB");

var $8RtxL = parcelRequire("8RtxL");

var $EPOmb = parcelRequire("EPOmb");
/* eslint-disable max-lines */ const $11483eb3ccbcdbbf$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $11483eb3ccbcdbbf$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $11483eb3ccbcdbbf$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $11483eb3ccbcdbbf$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
// Default interval for flushing logs and metrics (5 seconds)
const $11483eb3ccbcdbbf$var$DEFAULT_FLUSH_INTERVAL = 5000;
function $11483eb3ccbcdbbf$var$_makeInternalError(message) {
    return {
        message: message,
        [$11483eb3ccbcdbbf$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $11483eb3ccbcdbbf$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$11483eb3ccbcdbbf$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $11483eb3ccbcdbbf$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $11483eb3ccbcdbbf$var$INTERNAL_ERROR_SYMBOL in error;
}
function $11483eb3ccbcdbbf$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $11483eb3ccbcdbbf$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after timeout period from the first item
 *
 * Uses closure variables to track weight and timeout state.
 */ function $11483eb3ccbcdbbf$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else if (!isTimerActive) {
            // Only start timer if one isn't already running.
            // This prevents flushing being delayed by items that arrive close to the timeout limit
            // and thus resetting the flushing timeout and delaying items being flushed.
            isTimerActive = true;
            // Use safeUnref so the timer doesn't prevent the process from exiting
            flushTimeout = $8RtxL.safeUnref(setTimeout(()=>{
                flushFn(client);
            // Note: isTimerActive is reset by the flushHook handler above, not here,
            // to avoid race conditions when new items arrive during the flush.
            }, $11483eb3ccbcdbbf$var$DEFAULT_FLUSH_INTERVAL));
        }
    });
    client.on('flush', ()=>{
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $11483eb3ccbcdbbf$var$Client {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = $17WZH.makePromiseBuffer(options.transportOptions?.bufferSize ?? $eCpC3.DEFAULT_TRANSPORT_BUFFER_SIZE);
        if (options.dsn) this._dsn = $9FnMD.makeDsn(options.dsn);
        else $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = $eheGM.getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // Backfill enableLogs option from _experiments.enableLogs
        // TODO(v11): Remove or change default value
        // eslint-disable-next-line deprecation/deprecation
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) $11483eb3ccbcdbbf$var$setupWeightBasedFlushing(this, 'afterCaptureLog', 'flushLogs', $11483eb3ccbcdbbf$var$estimateLogSizeInBytes, $9bAWT._INTERNAL_flushLogsBuffer);
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        // Setup metric flushing with weight and timeout tracking
        if (enableMetrics) $11483eb3ccbcdbbf$var$setupWeightBasedFlushing(this, 'afterCaptureMetric', 'flushMetrics', $11483eb3ccbcdbbf$var$estimateMetricSizeInBytes, $35EDI._INTERNAL_flushMetricsBuffer);
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = $dHx3C.uuid4();
        // ensure we haven't captured this very object before
        if ($dHx3C.checkOrSetAlreadyCaught(exception)) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.log($11483eb3ccbcdbbf$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: $dHx3C.uuid4(),
            ...hint
        };
        const eventMessage = $8wdL3.isParameterizedString(message) ? message : String(message);
        const isMessage = $8wdL3.isPrimitive(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? 'unknown' : 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = $dHx3C.uuid4();
        // ensure we haven't captured this very object before
        if (hint?.originalException && $dHx3C.checkOrSetAlreadyCaught(hint.originalException)) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.log($11483eb3ccbcdbbf$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $11483eb3ccbcdbbf$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session$1) {
        this.sendSession(session$1);
        // After sending, we set init false to indicate it's not the first occurrence
        $hGRvQ.updateSession(session$1, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        // Emit `flush` unconditionally so weight-based log/metric flushers drain
        // their buffers and clear their idle timers, even when no transport is
        // configured (e.g. no DSN).
        this.emit('flush');
        if (!transport) return true;
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        $9bAWT._INTERNAL_flushLogsBuffer(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit('close');
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration$1) {
        const isAlreadyInstalled = this._integrations[integration$1.name];
        if (!isAlreadyInstalled && integration$1.beforeSetup) integration$1.beforeSetup(this);
        // This hook takes care of only installing if not already installed
        $41JP2.setupIntegration(this, integration$1, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) $41JP2.afterSetupIntegrations(this, [
            integration$1
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        // Extract gen_ai spans from transaction and convert to span v2 format.
        // This mutates event.spans to remove the extracted spans.
        const genAiSpanItem = $j0dcw.extractGenAiSpansFromEvent(event, this);
        let env = $cCYFf.createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = $SMVsN.addItemToEnvelope(env, $SMVsN.createAttachmentEnvelopeItem(attachment));
        if (genAiSpanItem) env = $SMVsN.addItemToEnvelope(env, genAiSpanItem);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env).then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = $03X1l.DEFAULT_ENVIRONMENT } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                $kcA99.DEBUG_BUILD && $8xCk9.debug.warn($11483eb3ccbcdbbf$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                $kcA99.DEBUG_BUILD && $8xCk9.debug.warn($11483eb3ccbcdbbf$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = $cCYFf.createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
        // Wrap the callback in a function so that registering the same callback instance multiple
        // times results in the callback being called multiple times.
        // @ts-expect-error - The `callback` type is correct and must be a function due to the
        // individual, specific overloads of this function.
        // eslint-disable-next-line @typescript-eslint/ban-types
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.error('Error while sending envelope:', reason);
            return {};
        }
        $kcA99.DEBUG_BUILD && $8xCk9.debug.error('Transport disabled');
        return {};
    }
    /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerCleanup(callback) {
    // No-op in base class - subclasses override to implement cleanup registration
    }
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {
    // Base class has no cleanup logic - subclasses implement their own
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = $41JP2.setupIntegrations(this, integrations);
        $41JP2.afterSetupIntegrations(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session$1, event) {
        // initially, set `crashed` based on the event level and update from exceptions if there are any later on
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            // reset crashed to false if there are exceptions, to ensure `mechanism.handled` is respected.
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session$1.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session$1.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            $hGRvQ.updateSession(session$1, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session$1.errors || Number(errored || crashed)
            });
            this.captureSession(session$1);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return $8cgLj.prepareEvent(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...$9BwS8.getTraceContextFromScope(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext$1 = $i9ydA.getDynamicSamplingContextFromScope(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext$1,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = $9BwS8.getCurrentScope(), isolationScope = $9BwS8.getIsolationScope()) {
        if ($kcA99.DEBUG_BUILD && $11483eb3ccbcdbbf$var$isErrorEvent(event)) $8xCk9.debug.log(`Captured error event \`${$l0hZo.getPossibleEventMessages(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if ($kcA99.DEBUG_BUILD) {
                if ($11483eb3ccbcdbbf$var$_isDoNotSendEventError(reason)) $8xCk9.debug.log(reason.message);
                else if ($11483eb3ccbcdbbf$var$_isInternalError(reason)) $8xCk9.debug.warn(reason.message);
                else $8xCk9.debug.warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $11483eb3ccbcdbbf$var$isTransactionEvent(event);
        const isError = $11483eb3ccbcdbbf$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : $8aQht.parseSampleRate(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && $g26pf.safeMathRandom() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return $5iQrB.rejectedSyncPromise($11483eb3ccbcdbbf$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $11483eb3ccbcdbbf$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $11483eb3ccbcdbbf$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $11483eb3ccbcdbbf$var$processBeforeSend(this, options, prepared, hint);
            return $11483eb3ccbcdbbf$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $11483eb3ccbcdbbf$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($11483eb3ccbcdbbf$var$_isDoNotSendEventError(reason) || $11483eb3ccbcdbbf$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: 'internal'
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $11483eb3ccbcdbbf$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === $17WZH.SENTRY_BUFFER_FULL_ERROR) this.recordDroppedEvent('queue_overflow', dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.log('No dsn provided, will not send outcomes');
            return;
        }
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log('Sending outcomes:', outcomes);
        const envelope = $ixmfD.createClientReportEnvelope(outcomes, this._options.tunnel && $9FnMD.dsnToString(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
function $11483eb3ccbcdbbf$var$getDataCategoryByType(type) {
    return type === 'replay_event' ? 'replay' : type || 'error';
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $11483eb3ccbcdbbf$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ($8wdL3.isThenable(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!$8wdL3.isPlainObject(event) && event !== null) throw $11483eb3ccbcdbbf$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $11483eb3ccbcdbbf$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!$8wdL3.isPlainObject(beforeSendResult) && beforeSendResult !== null) throw $11483eb3ccbcdbbf$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $11483eb3ccbcdbbf$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan$1 = !$dh5pl.isStreamedBeforeSendSpanCallback(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($11483eb3ccbcdbbf$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($11483eb3ccbcdbbf$var$isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan$1 || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = $EPOmb.convertTransactionEventToSpanJson(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if (ignoreSpans?.length && $lTL01.shouldIgnoreSpan({
                description: rootSpanJson.description,
                op: rootSpanJson.op,
                attributes: rootSpanJson.data
            }, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan$1) {
                const processedRootSpanJson = beforeSendSpan$1(rootSpanJson);
                if (!processedRootSpanJson) $awmvd.showSpanDropWarning();
                else // update event with processed root span values
                processedEvent = $6BF4X.merge(event, $EPOmb.convertSpanJsonToTransactionEvent(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if (ignoreSpans?.length && $lTL01.shouldIgnoreSpan({
                        description: span.description,
                        op: span.op,
                        attributes: span.data
                    }, ignoreSpans)) {
                        $lTL01.reparentChildSpans(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan$1) {
                        const processedSpan = beforeSendSpan$1(span);
                        if (!processedSpan) {
                            $awmvd.showSpanDropWarning();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent('before_send', 'span', droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $11483eb3ccbcdbbf$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $11483eb3ccbcdbbf$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function $11483eb3ccbcdbbf$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for number
    weight += 8;
    return weight + $11483eb3ccbcdbbf$var$estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function $11483eb3ccbcdbbf$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + $11483eb3ccbcdbbf$var$estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function $11483eb3ccbcdbbf$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $11483eb3ccbcdbbf$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ($8wdL3.isPrimitive(value)) weight += $11483eb3ccbcdbbf$var$estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function $11483eb3ccbcdbbf$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'number') return 8;
    else if (typeof value === 'boolean') return 4;
    return 0;
}
module.exports.Client = $11483eb3ccbcdbbf$var$Client;

});
parcelRegister("41JP2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");
const $2eeaccbd25d87b4e$var$installedIntegrations = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $2eeaccbd25d87b4e$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $2eeaccbd25d87b4e$var$getIntegrationsToSetup(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $2eeaccbd25d87b4e$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $2eeaccbd25d87b4e$var$setupIntegrations(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $2eeaccbd25d87b4e$var$setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $2eeaccbd25d87b4e$var$afterSetupIntegrations(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $2eeaccbd25d87b4e$var$setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (!$2eeaccbd25d87b4e$var$installedIntegrations.includes(integration.name) && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $2eeaccbd25d87b4e$var$installedIntegrations.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        'processSpan',
        'processSegmentSpan'
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === 'function') // The cast is needed because TS can't resolve overloads when the discriminant is a union type.
        // Both overloads have the same callback signature so this is safe.
        client.on(hook, (span)=>callback.call(integration, span, client));
    });
    $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $2eeaccbd25d87b4e$var$addIntegration(integration) {
    const client = $9BwS8.getClient();
    if (!client) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $2eeaccbd25d87b4e$var$defineIntegration(fn) {
    return fn;
}
module.exports.addIntegration = $2eeaccbd25d87b4e$var$addIntegration;
module.exports.afterSetupIntegrations = $2eeaccbd25d87b4e$var$afterSetupIntegrations;
module.exports.defineIntegration = $2eeaccbd25d87b4e$var$defineIntegration;
module.exports.getIntegrationsToSetup = $2eeaccbd25d87b4e$var$getIntegrationsToSetup;
module.exports.installedIntegrations = $2eeaccbd25d87b4e$var$installedIntegrations;
module.exports.setupIntegration = $2eeaccbd25d87b4e$var$setupIntegration;
module.exports.setupIntegrations = $2eeaccbd25d87b4e$var$setupIntegrations;

});

parcelRegister("9bAWT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i1sH5 = parcelRequire("i1sH5");

var $gg0a2 = parcelRequire("gg0a2");

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $8wdL3 = parcelRequire("8wdL3");

var $hh7n5 = parcelRequire("hh7n5");

var $cmHh9 = parcelRequire("cmHh9");

var $j8mWA = parcelRequire("j8mWA");

var $8H9dZ = parcelRequire("8H9dZ");

var $8VKPg = parcelRequire("8VKPg");

var $aEjZJ = parcelRequire("aEjZJ");

var $idouS = parcelRequire("idouS");
const $6b01cd6b67d87635$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $6b01cd6b67d87635$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $6b01cd6b67d87635$var$_INTERNAL_captureSerializedLog(client, serializedLog) {
    const bufferMap = $6b01cd6b67d87635$var$_getBufferMap();
    const logBuffer = $6b01cd6b67d87635$var$_INTERNAL_getLogBuffer(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $6b01cd6b67d87635$var$MAX_LOG_BUFFER_SIZE) {
        $6b01cd6b67d87635$var$_INTERNAL_flushLogsBuffer(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $6b01cd6b67d87635$var$_INTERNAL_captureLog(beforeLog, currentScope = $9BwS8.getCurrentScope(), captureSerializedLog = $6b01cd6b67d87635$var$_INTERNAL_captureSerializedLog) {
    const client = currentScope?.getClient() ?? $9BwS8.getClient();
    if (!client) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('No client available to capture log.');
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = $8VKPg._getTraceInfoFromScope(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = $hh7n5.getCombinedScopeData($9BwS8.getIsolationScope(), currentScope);
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'sentry._internal.replay_is_buffering', true);
    const beforeLogMessage = beforeLog.message;
    if ($8wdL3.isParameterizedString(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = $cmHh9._getSpanForScope(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $6b01cd6b67d87635$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? $8xCk9.consoleSandbox(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = $j8mWA.timestampInSeconds();
    const sequenceAttr = $8H9dZ.getSequenceAttribute(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? $aEjZJ.SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
        attributes: {
            ...$i1sH5.serializeAttributes(scopeAttributes),
            ...$i1sH5.serializeAttributes(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $6b01cd6b67d87635$var$_INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $6b01cd6b67d87635$var$_INTERNAL_getLogBuffer(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $idouS.createLogEnvelope(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), clientOptions.sendDefaultPii);
    // Clear the log buffer after envelopes have been constructed.
    $6b01cd6b67d87635$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope$1);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $6b01cd6b67d87635$var$_INTERNAL_getLogBuffer(client) {
    return $6b01cd6b67d87635$var$_getBufferMap().get(client);
}
function $6b01cd6b67d87635$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return $gg0a2.getGlobalSingleton('clientToLogBufferMap', ()=>new WeakMap());
}
module.exports._INTERNAL_captureLog = $6b01cd6b67d87635$var$_INTERNAL_captureLog;
module.exports._INTERNAL_captureSerializedLog = $6b01cd6b67d87635$var$_INTERNAL_captureSerializedLog;
module.exports._INTERNAL_flushLogsBuffer = $6b01cd6b67d87635$var$_INTERNAL_flushLogsBuffer;
module.exports._INTERNAL_getLogBuffer = $6b01cd6b67d87635$var$_INTERNAL_getLogBuffer;

});
parcelRegister("8H9dZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $65497eb6cd471471$var$SEQUENCE_ATTR_KEY = 'sentry.timestamp.sequence';
let $65497eb6cd471471$var$_sequenceNumber = 0;
let $65497eb6cd471471$var$_previousTimestampMs;
/**
 * Returns the `sentry.timestamp.sequence` attribute entry for a serialized telemetry item.
 *
 * The sequence number starts at 0 and increments by 1 for each item captured.
 * It resets to 0 when the current item's integer millisecond timestamp differs
 * from the previous item's integer millisecond timestamp.
 *
 * @param timestampInSeconds - The timestamp of the telemetry item in seconds.
 */ function $65497eb6cd471471$var$getSequenceAttribute(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1000);
    if ($65497eb6cd471471$var$_previousTimestampMs !== undefined && nowMs !== $65497eb6cd471471$var$_previousTimestampMs) $65497eb6cd471471$var$_sequenceNumber = 0;
    const value = $65497eb6cd471471$var$_sequenceNumber;
    $65497eb6cd471471$var$_sequenceNumber++;
    $65497eb6cd471471$var$_previousTimestampMs = nowMs;
    return {
        key: $65497eb6cd471471$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: 'integer'
        }
    };
}
module.exports.getSequenceAttribute = $65497eb6cd471471$var$getSequenceAttribute;

});

parcelRegister("8VKPg", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $i9ydA = parcelRequire("i9ydA");

var $awmvd = parcelRequire("awmvd");
/** Extract trace information from scope */ function $6807f83fbb7b0725$var$_getTraceInfoFromScope(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return $9BwS8.withScope(scope, ()=>{
        const span = $awmvd.getActiveSpan();
        const traceContext = span ? $awmvd.spanToTraceContext(span) : $9BwS8.getTraceContextFromScope(scope);
        const dynamicSamplingContext$1 = span ? $i9ydA.getDynamicSamplingContextFromSpan(span) : $i9ydA.getDynamicSamplingContextFromScope(client, scope);
        return [
            dynamicSamplingContext$1,
            traceContext
        ];
    });
}
module.exports._getTraceInfoFromScope = $6807f83fbb7b0725$var$_getTraceInfoFromScope;

});

parcelRegister("aEjZJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $7c0d26584f122df2$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};
module.exports.SEVERITY_TEXT_TO_SEVERITY_NUMBER = $7c0d26584f122df2$var$SEVERITY_TEXT_TO_SEVERITY_NUMBER;

});

parcelRegister("idouS", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9FnMD = parcelRequire("9FnMD");

var $SMVsN = parcelRequire("SMVsN");

var $93iOd = parcelRequire("93iOd");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @param inferUserData - If true, tells Relay to infer the end-user IP and User-Agent from the incoming request.
 *                        Only emitted as `ingest_settings` in browser environments.
 * @returns The created log container envelope item.
 */ function $d42c717bddbe9ac5$var$createLogContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? 'auto' : 'never';
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            version: 2,
            ...$93iOd.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @param inferUserData - If true, tells Relay to infer the end-user IP and User-Agent from the incoming request.
 * @returns The created envelope.
 */ function $d42c717bddbe9ac5$var$createLogEnvelope(logs, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $9FnMD.dsnToString(dsn$1);
    return $SMVsN.createEnvelope(headers, [
        $d42c717bddbe9ac5$var$createLogContainerEnvelopeItem(logs, inferUserData)
    ]);
}
module.exports.createLogContainerEnvelopeItem = $d42c717bddbe9ac5$var$createLogContainerEnvelopeItem;
module.exports.createLogEnvelope = $d42c717bddbe9ac5$var$createLogEnvelope;

});
parcelRegister("93iOd", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $cU6mk = parcelRequire("cU6mk");

var $4onm8 = parcelRequire("4onm8");
/**
 * Returns true if we are in the browser.
 */ function $6972fbe825864211$var$isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!$cU6mk.isNodeEnv() || $6972fbe825864211$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $6972fbe825864211$var$isElectronNodeRenderer() {
    const process = $4onm8.GLOBAL_OBJ.process;
    return process?.type === 'renderer';
}
module.exports.isBrowser = $6972fbe825864211$var$isBrowser;

});
parcelRegister("cU6mk", function(module, exports) {
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1fk7K = parcelRequire("1fk7K");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the `debug` singleton, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !$1fk7K.isBrowserBundle() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {
    // no-empty
    }
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, 'process');
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {
    // no-empty
    }
    return mod;
}
exports.isNodeEnv = isNodeEnv;
exports.loadModule = loadModule;

});
parcelRegister("1fk7K", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0e86cd5dd086fe3f$var$isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0e86cd5dd086fe3f$var$getSDKSource() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}
module.exports.getSDKSource = $0e86cd5dd086fe3f$var$getSDKSource;
module.exports.isBrowserBundle = $0e86cd5dd086fe3f$var$isBrowserBundle;

});





parcelRegister("35EDI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i1sH5 = parcelRequire("i1sH5");

var $gg0a2 = parcelRequire("gg0a2");

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $hh7n5 = parcelRequire("hh7n5");

var $cmHh9 = parcelRequire("cmHh9");

var $j8mWA = parcelRequire("j8mWA");

var $8H9dZ = parcelRequire("8H9dZ");

var $8VKPg = parcelRequire("8VKPg");

var $empt2 = parcelRequire("empt2");
const $24015ce4a599162e$var$MAX_METRIC_BUFFER_SIZE = 1000;
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $24015ce4a599162e$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $24015ce4a599162e$var$_INTERNAL_captureSerializedMetric(client, serializedMetric) {
    const bufferMap = $24015ce4a599162e$var$_getBufferMap();
    const metricBuffer = $24015ce4a599162e$var$_INTERNAL_getMetricBuffer(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $24015ce4a599162e$var$MAX_METRIC_BUFFER_SIZE) {
        $24015ce4a599162e$var$_INTERNAL_flushMetricsBuffer(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Enriches metric with all contextual attributes (user, SDK metadata, replay, etc.)
 */ function $24015ce4a599162e$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    // Add user attributes
    $24015ce4a599162e$var$setMetricAttribute(processedMetricAttributes, 'user.id', user.id, false);
    $24015ce4a599162e$var$setMetricAttribute(processedMetricAttributes, 'user.email', user.email, false);
    $24015ce4a599162e$var$setMetricAttribute(processedMetricAttributes, 'user.name', user.username, false);
    // Add Sentry metadata
    $24015ce4a599162e$var$setMetricAttribute(processedMetricAttributes, 'sentry.release', release);
    $24015ce4a599162e$var$setMetricAttribute(processedMetricAttributes, 'sentry.environment', environment);
    // Add SDK metadata
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $24015ce4a599162e$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.name', name);
    $24015ce4a599162e$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.version', version);
    // Add replay metadata
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $24015ce4a599162e$var$setMetricAttribute(processedMetricAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') $24015ce4a599162e$var$setMetricAttribute(processedMetricAttributes, 'sentry._internal.replay_is_buffering', true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
/**
 * Creates a serialized metric ready to be sent to Sentry.
 */ function $24015ce4a599162e$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    // Get trace context
    const [, traceContext] = $8VKPg._getTraceInfoFromScope(client, currentScope);
    const span = $cmHh9._getSpanForScope(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : undefined;
    const timestamp = $j8mWA.timestampInSeconds();
    const sequenceAttr = $8H9dZ.getSequenceAttribute(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? '',
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...$i1sH5.serializeAttributes(scopeAttributes),
            ...$i1sH5.serializeAttributes(metric.attributes, 'skip-undefined'),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
/**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $24015ce4a599162e$var$_INTERNAL_captureMetric(beforeMetric, options) {
    const currentScope = options?.scope ?? $9BwS8.getCurrentScope();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $24015ce4a599162e$var$_INTERNAL_captureSerializedMetric;
    const client = currentScope?.getClient() ?? $9BwS8.getClient();
    if (!client) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('No client available to capture metric.');
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    // todo(v11): Remove the experimental flag
    // eslint-disable-next-line deprecation/deprecation
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('metrics option not enabled, metric will not be captured.');
        return;
    }
    // Enrich metric with contextual attributes
    const { user: user, attributes: scopeAttributes } = $hh7n5.getCombinedScopeData($9BwS8.getIsolationScope(), currentScope);
    const enrichedMetric = $24015ce4a599162e$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit('processMetric', enrichedMetric);
    // todo(v11): Remove the experimental `beforeSendMetric`
    // eslint-disable-next-line deprecation/deprecation
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log('`beforeSendMetric` returned `null`, will not send metric.');
        return;
    }
    const serializedMetric = $24015ce4a599162e$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    $kcA99.DEBUG_BUILD && $8xCk9.debug.log('[Metric]', serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit('afterCaptureMetric', processedMetric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $24015ce4a599162e$var$_INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $24015ce4a599162e$var$_INTERNAL_getMetricBuffer(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope$1 = $empt2.createMetricEnvelope(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn(), clientOptions.sendDefaultPii);
    // Clear the metric buffer after envelopes have been constructed.
    $24015ce4a599162e$var$_getBufferMap().set(client, []);
    client.emit('flushMetrics');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope$1);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function $24015ce4a599162e$var$_INTERNAL_getMetricBuffer(client) {
    return $24015ce4a599162e$var$_getBufferMap().get(client);
}
function $24015ce4a599162e$var$_getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return $gg0a2.getGlobalSingleton('clientToMetricBufferMap', ()=>new WeakMap());
}
module.exports._INTERNAL_captureMetric = $24015ce4a599162e$var$_INTERNAL_captureMetric;
module.exports._INTERNAL_captureSerializedMetric = $24015ce4a599162e$var$_INTERNAL_captureSerializedMetric;
module.exports._INTERNAL_flushMetricsBuffer = $24015ce4a599162e$var$_INTERNAL_flushMetricsBuffer;
module.exports._INTERNAL_getMetricBuffer = $24015ce4a599162e$var$_INTERNAL_getMetricBuffer;

});
parcelRegister("empt2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9FnMD = parcelRequire("9FnMD");

var $SMVsN = parcelRequire("SMVsN");

var $93iOd = parcelRequire("93iOd");
/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @param inferUserData - If true, tells Relay to infer the end-user IP and User-Agent from the incoming request.
 *                        Only emitted as `ingest_settings` in browser environments.
 * @returns The created metric container envelope item.
 */ function $a746e00ef92438e3$var$createMetricContainerEnvelopeItem(items, inferUserData) {
    const inferSetting = inferUserData ? 'auto' : 'never';
    return [
        {
            type: 'trace_metric',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.trace-metric+json'
        },
        {
            version: 2,
            ...$93iOd.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @param inferUserData - If true, tells Relay to infer the end-user IP and User-Agent from the incoming request.
 * @returns The created envelope.
 */ function $a746e00ef92438e3$var$createMetricEnvelope(metrics, metadata, tunnel, dsn$1, inferUserData) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $9FnMD.dsnToString(dsn$1);
    return $SMVsN.createEnvelope(headers, [
        $a746e00ef92438e3$var$createMetricContainerEnvelopeItem(metrics, inferUserData)
    ]);
}
module.exports.createMetricContainerEnvelopeItem = $a746e00ef92438e3$var$createMetricContainerEnvelopeItem;
module.exports.createMetricEnvelope = $a746e00ef92438e3$var$createMetricEnvelope;

});


parcelRegister("j0dcw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $93iOd = parcelRequire("93iOd");

var $akELB = parcelRequire("akELB");

var $lxsTI = parcelRequire("lxsTI");
/**
 * Extracts gen_ai spans from a transaction event, converts them to span v2 format,
 * and returns them as a SpanContainerItem.
 *
 * Only applies to static mode (non-streaming) transactions.
 *
 * WARNING: This function mutates `event.spans` by removing the extracted gen_ai spans
 * from the array. Call this before creating the event envelope so the transaction
 * item does not include the extracted spans.
 */ function $dd5841ddd2fe52f2$var$extractGenAiSpansFromEvent(event, client) {
    if (event.type !== 'transaction' || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || !client.getOptions().streamGenAiSpans || $akELB.hasSpanStreamingEnabled(client)) return undefined;
    const genAiSpans = [];
    const remainingSpans = [];
    for (const span of event.spans)if (span.op?.startsWith('gen_ai.')) genAiSpans.push($lxsTI.spanJsonToSerializedStreamedSpan(span));
    else remainingSpans.push(span);
    if (genAiSpans.length === 0) return undefined;
    event.spans = remainingSpans;
    const inferSetting = client.getOptions().sendDefaultPii ? 'auto' : 'never';
    return [
        {
            type: 'span',
            item_count: genAiSpans.length,
            content_type: 'application/vnd.sentry.items.span.v2+json'
        },
        {
            version: 2,
            ...$93iOd.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: genAiSpans
        }
    ];
}
module.exports.extractGenAiSpansFromEvent = $dd5841ddd2fe52f2$var$extractGenAiSpansFromEvent;

});
parcelRegister("lxsTI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $awmvd = parcelRequire("awmvd");
/**
 * Converts a v1 SpanJSON (from a legacy transaction) to a serialized v2 StreamedSpan.
 */ function $fae3188215c6edf3$var$spanJsonToSerializedStreamedSpan(span) {
    const streamedSpan = {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        name: span.description || '',
        start_timestamp: span.start_timestamp,
        end_timestamp: span.timestamp || span.start_timestamp,
        status: !span.status || span.status === 'ok' || span.status === 'cancelled' ? 'ok' : 'error',
        is_segment: false,
        attributes: {
            ...span.data
        },
        links: span.links
    };
    return $awmvd.streamedSpanJsonToSerializedSpan(streamedSpan);
}
module.exports.spanJsonToSerializedStreamedSpan = $fae3188215c6edf3$var$spanJsonToSerializedStreamedSpan;

});


parcelRegister("eCpC3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $SMVsN = parcelRequire("SMVsN");

var $17WZH = parcelRequire("17WZH");

var $5tgpu = parcelRequire("5tgpu");
const $aa487b7b5049811c$var$DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $aa487b7b5049811c$var$createTransport(options, makeRequest, buffer = $17WZH.makePromiseBuffer(options.bufferSize || $aa487b7b5049811c$var$DEFAULT_TRANSPORT_BUFFER_SIZE)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope$1) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        $SMVsN.forEachEnvelopeItem(envelope$1, (item, type)=>{
            const dataCategory = $SMVsN.envelopeItemTypeToDataCategory(type);
            if ($5tgpu.isRateLimited(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = $SMVsN.createEnvelope(envelope$1[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            // Don't record outcomes for client reports - we don't want to create a feedback loop if client reports themselves fail to send
            if ($SMVsN.envelopeContainsItemType(filteredEnvelope, [
                'client_report'
            ])) {
                $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            $SMVsN.forEachEnvelopeItem(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, $SMVsN.envelopeItemTypeToDataCategory(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: $SMVsN.serializeEnvelope(filteredEnvelope)
            }).then((response)=>{
                // Handle 413 Content Too Large
                // Loss of envelope content is expected so we record a send_error client report
                // https://develop.sentry.dev/sdk/expected-features/#dealing-with-network-failures
                if (response.statusCode === 413) {
                    $kcA99.DEBUG_BUILD && $8xCk9.debug.error('Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.');
                    recordEnvelopeLoss('send_error');
                    return response;
                }
                // We don't want to throw on NOK responses, but we want to at least log them
                if ($kcA99.DEBUG_BUILD && response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) $8xCk9.debug.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = $5tgpu.updateRateLimits(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                $kcA99.DEBUG_BUILD && $8xCk9.debug.error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === $17WZH.SENTRY_BUFFER_FULL_ERROR) {
                $kcA99.DEBUG_BUILD && $8xCk9.debug.error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
module.exports.DEFAULT_TRANSPORT_BUFFER_SIZE = $aa487b7b5049811c$var$DEFAULT_TRANSPORT_BUFFER_SIZE;
module.exports.createTransport = $aa487b7b5049811c$var$createTransport;

});
parcelRegister("17WZH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5iQrB = parcelRequire("5iQrB");

var $8RtxL = parcelRequire("8RtxL");
const $0d2434e9d4926a08$var$SENTRY_BUFFER_FULL_ERROR = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $0d2434e9d4926a08$var$makePromiseBuffer(limit = 100) {
    const buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return $5iQrB.rejectedSyncPromise($0d2434e9d4926a08$var$SENTRY_BUFFER_FULL_ERROR);
        // start the task and add its promise to the queue
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return $5iQrB.resolvedSyncPromise(true);
        // We want to resolve even if one of the promises rejects
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>$8RtxL.safeUnref(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}
module.exports.SENTRY_BUFFER_FULL_ERROR = $0d2434e9d4926a08$var$SENTRY_BUFFER_FULL_ERROR;
module.exports.makePromiseBuffer = $0d2434e9d4926a08$var$makePromiseBuffer;

});
parcelRegister("8RtxL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Calls `unref` on a timer, if the method is available on @param timer.
 *
 * `unref()` is used to allow processes to exit immediately, even if the timer
 * is still running and hasn't resolved yet.
 *
 * Use this in places where code can run on browser or server, since browsers
 * do not support `unref`.
 */ function $673a30b74665263b$var$safeUnref(timer) {
    if (typeof timer === 'object' && typeof timer.unref === 'function') timer.unref();
    return timer;
}
module.exports.safeUnref = $673a30b74665263b$var$safeUnref;

});


parcelRegister("5tgpu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $g26pf = parcelRequire("g26pf");
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $3fbc63e4ccddb6b9$var$DEFAULT_RETRY_AFTER = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $3fbc63e4ccddb6b9$var$parseRetryAfterHeader(header, now = $g26pf.safeDateNow()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $3fbc63e4ccddb6b9$var$DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $3fbc63e4ccddb6b9$var$disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $3fbc63e4ccddb6b9$var$isRateLimited(limits, dataCategory, now = $g26pf.safeDateNow()) {
    return $3fbc63e4ccddb6b9$var$disabledUntil(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $3fbc63e4ccddb6b9$var$updateRateLimits(limits, { statusCode: statusCode, headers: headers }, now = $g26pf.safeDateNow()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $3fbc63e4ccddb6b9$var$parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}
module.exports.DEFAULT_RETRY_AFTER = $3fbc63e4ccddb6b9$var$DEFAULT_RETRY_AFTER;
module.exports.disabledUntil = $3fbc63e4ccddb6b9$var$disabledUntil;
module.exports.isRateLimited = $3fbc63e4ccddb6b9$var$isRateLimited;
module.exports.parseRetryAfterHeader = $3fbc63e4ccddb6b9$var$parseRetryAfterHeader;
module.exports.updateRateLimits = $3fbc63e4ccddb6b9$var$updateRateLimits;

});


parcelRegister("ixmfD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $SMVsN = parcelRequire("SMVsN");

var $j8mWA = parcelRequire("j8mWA");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $d7ec91a9417927a7$var$createClientReportEnvelope(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || $j8mWA.dateTimestampInSeconds(),
            discarded_events: discarded_events
        }
    ];
    return $SMVsN.createEnvelope(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}
module.exports.createClientReportEnvelope = $d7ec91a9417927a7$var$createClientReportEnvelope;

});

parcelRegister("l0hZo", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $f4a78d592f95e578$var$getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}
module.exports.getPossibleEventMessages = $f4a78d592f95e578$var$getPossibleEventMessages;

});

parcelRegister("EPOmb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5Wkkl = parcelRequire("5Wkkl");
/**
 * Converts a transaction event to a span JSON object.
 */ function $07abed2b0461973d$var$convertTransactionEventToSpanJson(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[$5Wkkl.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[$5Wkkl.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $07abed2b0461973d$var$convertSpanJsonToTransactionEvent(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [$5Wkkl.SEMANTIC_ATTRIBUTE_PROFILE_ID]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [$5Wkkl.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}
module.exports.convertSpanJsonToTransactionEvent = $07abed2b0461973d$var$convertSpanJsonToTransactionEvent;
module.exports.convertTransactionEventToSpanJson = $07abed2b0461973d$var$convertTransactionEventToSpanJson;

});


parcelRegister("btD8f", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $85b0c1f805d02a28$var$initAndBind(clientClass, options) {
    if (options.debug === true) {
        if ($kcA99.DEBUG_BUILD) $8xCk9.debug.enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        $8xCk9.consoleSandbox(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = $9BwS8.getCurrentScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $85b0c1f805d02a28$var$setCurrentClient(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $85b0c1f805d02a28$var$setCurrentClient(client) {
    $9BwS8.getCurrentScope().setClient(client);
}
module.exports.initAndBind = $85b0c1f805d02a28$var$initAndBind;
module.exports.setCurrentClient = $85b0c1f805d02a28$var$setCurrentClient;

});

parcelRegister("1yl4T", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $SMVsN = parcelRequire("SMVsN");

var $5tgpu = parcelRequire("5tgpu");

var $8RtxL = parcelRequire("8RtxL");
const $1219510ff670cefd$var$MIN_DELAY = 100; // 100 ms
const $1219510ff670cefd$var$START_DELAY = 5000; // 5 seconds
const $1219510ff670cefd$var$MAX_DELAY = 3.6e6; // 1 hour
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function $1219510ff670cefd$var$makeOfflineTransport(createTransport) {
    function log(...args) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log('[Offline]:', ...args);
    }
    return (options)=>{
        const transport = createTransport(options);
        if (!options.createStore) throw new Error('No `createStore` function was provided');
        const store = options.createStore(options);
        let retryDelay = $1219510ff670cefd$var$START_DELAY;
        let flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We want to drop client reports because they can be generated when we retry sending events while offline.
            if ($SMVsN.envelopeContainsItemType(env, [
                'client_report'
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (flushTimer) clearTimeout(flushTimer);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            flushTimer = $8RtxL.safeUnref(setTimeout(async ()=>{
                flushTimer = undefined;
                const found = await store.shift();
                if (found) {
                    log('Attempting to send previously queued event');
                    // We should to update the sent_at timestamp to the current time.
                    found[0].sent_at = new Date().toISOString();
                    send(found, true).catch((e)=>{
                        log('Failed to retry sending', e);
                    });
                }
            }, delay));
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, $1219510ff670cefd$var$MAX_DELAY);
        }
        async function send(envelope$1, isRetry = false) {
            // We queue all replay envelopes to avoid multiple replay envelopes being sent at the same time. If one fails, we
            // need to retry them in order.
            if (!isRetry && $SMVsN.envelopeContainsItemType(envelope$1, [
                'replay_event',
                'replay_recording'
            ])) {
                await store.push(envelope$1);
                flushIn($1219510ff670cefd$var$MIN_DELAY);
                return {};
            }
            try {
                if (options.shouldSend && await options.shouldSend(envelope$1) === false) throw new Error('Envelope not sent because `shouldSend` callback returned false');
                const result = await transport.send(envelope$1);
                let delay = $1219510ff670cefd$var$MIN_DELAY;
                if (result) {
                    // If there's a retry-after header, use that as the next delay.
                    if (result.headers?.['retry-after']) delay = $5tgpu.parseRetryAfterHeader(result.headers['retry-after']);
                    else if (result.headers?.['x-sentry-rate-limits']) delay = 60000; // 60 seconds
                    else if ((result.statusCode || 0) >= 400) return result;
                }
                flushIn(delay);
                retryDelay = $1219510ff670cefd$var$START_DELAY;
                return result;
            } catch (e) {
                if (await shouldQueue(envelope$1, e, retryDelay)) {
                    // If this envelope was a retry, we want to add it to the front of the queue so it's retried again first.
                    if (isRetry) await store.unshift(envelope$1);
                    else await store.push(envelope$1);
                    flushWithBackOff();
                    log('Error sending. Event queued.', e);
                    return {};
                } else throw e;
            }
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: (timeout)=>{
                // If there's no timeout, we should attempt to flush the offline queue.
                if (timeout === undefined) {
                    retryDelay = $1219510ff670cefd$var$START_DELAY;
                    flushIn($1219510ff670cefd$var$MIN_DELAY);
                }
                return transport.flush(timeout);
            }
        };
    };
}
module.exports.MIN_DELAY = $1219510ff670cefd$var$MIN_DELAY;
module.exports.START_DELAY = $1219510ff670cefd$var$START_DELAY;
module.exports.makeOfflineTransport = $1219510ff670cefd$var$makeOfflineTransport;

});

parcelRegister("dPksP", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eheGM = parcelRequire("eheGM");

var $9FnMD = parcelRequire("9FnMD");

var $SMVsN = parcelRequire("SMVsN");
/**
 * Key used in event.extra to provide routing information for the multiplexed transport.
 * Should contain an array of `{ dsn: string, release?: string }` objects.
 */ const $a10fe9863963964e$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY = 'MULTIPLEXED_TRANSPORT_EXTRA_KEY';
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function $a10fe9863963964e$var$eventFromEnvelope(env, types) {
    let event;
    $SMVsN.forEachEnvelopeItem(env, (item, type)=>{
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function $a10fe9863963964e$var$makeOverrideReleaseTransport(createTransport, release) {
    return (options)=>{
        const transport = createTransport(options);
        return {
            ...transport,
            send: async (envelope)=>{
                const event = $a10fe9863963964e$var$eventFromEnvelope(envelope, [
                    'event',
                    'transaction',
                    'profile',
                    'replay_event'
                ]);
                if (event) event.release = release;
                return transport.send(envelope);
            }
        };
    };
}
/** Overrides the DSN in the envelope header  */ function $a10fe9863963964e$var$overrideDsn(envelope$1, dsn) {
    return $SMVsN.createEnvelope(dsn ? {
        ...envelope$1[0],
        dsn: dsn
    } : envelope$1[0], envelope$1[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 *
 * If no matcher is provided, the transport will look for routing information in
 * `event.extra[MULTIPLEXED_TRANSPORT_EXTRA_KEY]`, which should contain
 * an array of `{ dsn: string, release?: string }` objects.
 */ function $a10fe9863963964e$var$makeMultiplexedTransport(createTransport, matcher) {
    return (options)=>{
        const fallbackTransport = createTransport(options);
        const otherTransports = new Map();
        // Use provided matcher or default to simple multiplexed transport behavior
        const actualMatcher = matcher || ((args)=>{
            const event = args.getEvent();
            if (event?.extra?.[$a10fe9863963964e$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY] && Array.isArray(event.extra[$a10fe9863963964e$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY])) return event.extra[$a10fe9863963964e$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY];
            return [];
        });
        function getTransport(dsn$1, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            const key = release ? `${dsn$1}:${release}` : dsn$1;
            let transport = otherTransports.get(key);
            if (!transport) {
                const validatedDsn = $9FnMD.dsnFromString(dsn$1);
                if (!validatedDsn) return undefined;
                const url = $eheGM.getEnvelopeEndpointWithUrlEncodedAuth(validatedDsn, options.tunnel);
                transport = release ? $a10fe9863963964e$var$makeOverrideReleaseTransport(createTransport, release)({
                    ...options,
                    url: url
                }) : createTransport({
                    ...options,
                    url: url
                });
                otherTransports.set(key, transport);
            }
            return [
                dsn$1,
                transport
            ];
        }
        async function send(envelope) {
            function getEvent(types) {
                const eventTypes = types?.length ? types : [
                    'event'
                ];
                return $a10fe9863963964e$var$eventFromEnvelope(envelope, eventTypes);
            }
            const transports = actualMatcher({
                envelope: envelope,
                getEvent: getEvent
            }).map((result)=>{
                if (typeof result === 'string') return getTransport(result, undefined);
                else return getTransport(result.dsn, result.release);
            }).filter((t)=>!!t);
            // If we have no transports to send to, use the fallback transport
            // Don't override the DSN in the header for the fallback transport. '' is falsy
            const transportsWithFallback = transports.length ? transports : [
                [
                    '',
                    fallbackTransport
                ]
            ];
            const results = await Promise.all(transportsWithFallback.map(([dsn, transport])=>transport.send($a10fe9863963964e$var$overrideDsn(envelope, dsn))));
            return results[0];
        }
        async function flush(timeout) {
            const allTransports = [
                ...otherTransports.values(),
                fallbackTransport
            ];
            const results = await Promise.all(allTransports.map((transport)=>transport.flush(timeout)));
            return results.every((r)=>r);
        }
        return {
            send: send,
            flush: flush
        };
    };
}
module.exports.MULTIPLEXED_TRANSPORT_EXTRA_KEY = $a10fe9863963964e$var$MULTIPLEXED_TRANSPORT_EXTRA_KEY;
module.exports.eventFromEnvelope = $a10fe9863963964e$var$eventFromEnvelope;
module.exports.makeMultiplexedTransport = $a10fe9863963964e$var$makeMultiplexedTransport;

});

parcelRegister("4qhFj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");
/**
 * Registry tracking which AI provider modules should skip instrumentation wrapping.
 *
 * This prevents duplicate spans when a higher-level integration (like LangChain)
 * already instruments AI providers at a higher abstraction level.
 */ const $33874b18411f3a15$var$SKIPPED_AI_PROVIDERS = new Set();
/**
 * Mark AI provider modules to skip instrumentation wrapping.
 *
 * This prevents duplicate spans when a higher-level integration (like LangChain)
 * already instruments AI providers at a higher abstraction level.
 *
 * @internal
 * @param modules - Array of npm module names to skip (e.g., '@anthropic-ai/sdk', 'openai')
 *
 * @example
 * ```typescript
 * // In LangChain integration
 * _INTERNAL_skipAiProviderWrapping(['@anthropic-ai/sdk', 'openai', '@google/generative-ai']);
 * ```
 */ function $33874b18411f3a15$var$_INTERNAL_skipAiProviderWrapping(modules) {
    modules.forEach((module)=>{
        $33874b18411f3a15$var$SKIPPED_AI_PROVIDERS.add(module);
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`AI provider "${module}" wrapping will be skipped`);
    });
}
/**
 * Check if an AI provider module should skip instrumentation wrapping.
 *
 * @internal
 * @param module - The npm module name (e.g., '@anthropic-ai/sdk', 'openai')
 * @returns true if wrapping should be skipped
 *
 * @example
 * ```typescript
 * // In AI provider instrumentation
 * if (_INTERNAL_shouldSkipAiProviderWrapping('@anthropic-ai/sdk')) {
 *   return Reflect.construct(Original, args); // Don't instrument
 * }
 * ```
 */ function $33874b18411f3a15$var$_INTERNAL_shouldSkipAiProviderWrapping(module) {
    return $33874b18411f3a15$var$SKIPPED_AI_PROVIDERS.has(module);
}
/**
 * Clear all AI provider skip registrations.
 *
 * This is automatically called at the start of Sentry.init() to ensure a clean state
 * between different client initializations.
 *
 * @internal
 */ function $33874b18411f3a15$var$_INTERNAL_clearAiProviderSkips() {
    $33874b18411f3a15$var$SKIPPED_AI_PROVIDERS.clear();
    $kcA99.DEBUG_BUILD && $8xCk9.debug.log('Cleared AI provider skip registrations');
}
module.exports._INTERNAL_clearAiProviderSkips = $33874b18411f3a15$var$_INTERNAL_clearAiProviderSkips;
module.exports._INTERNAL_shouldSkipAiProviderWrapping = $33874b18411f3a15$var$_INTERNAL_shouldSkipAiProviderWrapping;
module.exports._INTERNAL_skipAiProviderWrapping = $33874b18411f3a15$var$_INTERNAL_skipAiProviderWrapping;

});

parcelRegister("c7Eb1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $8d354dc3d7e38c30$var$FALSY_ENV_VALUES = new Set([
    'false',
    'f',
    'n',
    'no',
    'off',
    '0'
]);
const $8d354dc3d7e38c30$var$TRUTHY_ENV_VALUES = new Set([
    'true',
    't',
    'y',
    'yes',
    'on',
    '1'
]);
/**
 * A helper function which casts an ENV variable value to `true` or `false` using the constants defined above.
 * In strict mode, it may return `null` if the value doesn't match any of the predefined values.
 *
 * @param value The value of the env variable
 * @param options -- Only has `strict` key for now, which requires a strict match for `true` in TRUTHY_ENV_VALUES
 * @returns true/false if the lowercase value matches the predefined values above. If not, null in strict mode,
 *          and Boolean(value) in loose mode.
 */ function $8d354dc3d7e38c30$var$envToBool(value, options) {
    const normalized = String(value).toLowerCase();
    if ($8d354dc3d7e38c30$var$FALSY_ENV_VALUES.has(normalized)) return false;
    if ($8d354dc3d7e38c30$var$TRUTHY_ENV_VALUES.has(normalized)) return true;
    return options?.strict ? null : Boolean(value);
}
module.exports.FALSY_ENV_VALUES = $8d354dc3d7e38c30$var$FALSY_ENV_VALUES;
module.exports.TRUTHY_ENV_VALUES = $8d354dc3d7e38c30$var$TRUTHY_ENV_VALUES;
module.exports.envToBool = $8d354dc3d7e38c30$var$envToBool;

});

parcelRegister("fMJf2", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9FnMD = parcelRequire("9FnMD");

var $SMVsN = parcelRequire("SMVsN");
/**
 * Create envelope from check in item.
 */ function $b7de6ec20504a053$var$createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn$1) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn$1) headers.dsn = $9FnMD.dsnToString(dsn$1);
    if (dynamicSamplingContext) headers.trace = dynamicSamplingContext;
    const item = $b7de6ec20504a053$var$createCheckInEnvelopeItem(checkIn);
    return $SMVsN.createEnvelope(headers, [
        item
    ]);
}
function $b7de6ec20504a053$var$createCheckInEnvelopeItem(checkIn) {
    const checkInHeaders = {
        type: 'check_in'
    };
    return [
        checkInHeaders,
        checkIn
    ];
}
module.exports.createCheckInEnvelope = $b7de6ec20504a053$var$createCheckInEnvelope;

});

parcelRegister("2CihR", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $2Y94s = parcelRequire("2Y94s");
/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $1e7d50d41b00462e$var$isSentryRequestUrl(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $1e7d50d41b00462e$var$checkDsn(url, dsn) || $1e7d50d41b00462e$var$checkTunnel(url, tunnel);
}
function $1e7d50d41b00462e$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $1e7d50d41b00462e$var$removeTrailingSlash(url) === $1e7d50d41b00462e$var$removeTrailingSlash(tunnel);
}
function $1e7d50d41b00462e$var$checkDsn(url$1, dsn) {
    // Requests to Sentry's ingest endpoint must have a `sentry_key` in the query string
    // This is equivalent to the public_key which is required in the DSN
    // see https://develop.sentry.dev/sdk/overview/#parsing-the-dsn
    // Therefore, a request to the same host and with a `sentry_key` in the query string
    // can be considered a request to the ingest endpoint.
    const urlParts = $2Y94s.parseStringToURLObject(url$1);
    if (!urlParts || $2Y94s.isURLObjectRelative(urlParts)) return false;
    if (!dsn) return false;
    return $1e7d50d41b00462e$var$hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function $1e7d50d41b00462e$var$hostnameMatchesDsnHost(hostname, dsnHost) {
    return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function $1e7d50d41b00462e$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}
module.exports.isSentryRequestUrl = $1e7d50d41b00462e$var$isSentryRequestUrl;

});

parcelRegister("70O3a", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Tagged template function which returns parameterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 *
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ function $51af5b603e887e6f$var$parameterize(strings, ...values) {
    const formatted = new String(String.raw(strings, ...values));
    formatted.__sentry_template_string__ = strings.join('\x00').replace(/%/g, '%%').replace(/\0/g, '%s');
    formatted.__sentry_template_values__ = values;
    return formatted;
}
/**
 * Tagged template function which returns parameterized representation of the message.
 *
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns A `ParameterizedString` object that can be passed into `captureMessage` or Sentry.logger.X methods.
 */ const $51af5b603e887e6f$var$fmt = $51af5b603e887e6f$var$parameterize;
module.exports.fmt = $51af5b603e887e6f$var$fmt;
module.exports.parameterize = $51af5b603e887e6f$var$parameterize;

});

parcelRegister("1Fdvb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $eheGM = parcelRequire("eheGM");

var $8xCk9 = parcelRequire("8xCk9");

var $9FnMD = parcelRequire("9FnMD");

var $SMVsN = parcelRequire("SMVsN");
/**
 * Core Sentry tunnel handler - framework agnostic.
 *
 * Validates the envelope DSN against allowed DSNs, then forwards the
 * envelope to the Sentry ingest endpoint.
 *
 * @returns A `Response` — either the upstream Sentry response on success, or an error response.
 */ async function $136417faa8297382$var$handleTunnelRequest(options) {
    const { request: request, allowedDsns: allowedDsns } = options;
    if (allowedDsns.length === 0) return new Response('Tunnel not configured', {
        status: 500
    });
    const body = new Uint8Array(await request.arrayBuffer());
    let envelopeHeader;
    try {
        [envelopeHeader] = $SMVsN.parseEnvelope(body);
    } catch  {
        return new Response('Invalid envelope', {
            status: 400
        });
    }
    if (!envelopeHeader) return new Response('Invalid envelope: missing header', {
        status: 400
    });
    const dsn$1 = envelopeHeader.dsn;
    if (!dsn$1) return new Response('Invalid envelope: missing DSN', {
        status: 400
    });
    // SECURITY: Validate that the envelope DSN matches one of the allowed DSNs
    // This prevents SSRF attacks where attackers send crafted envelopes
    // with malicious DSNs pointing to arbitrary hosts
    const isAllowed = allowedDsns.some((allowed)=>allowed === dsn$1);
    if (!isAllowed) {
        $8xCk9.debug.warn(`Sentry tunnel: rejected request with unauthorized DSN (${dsn$1})`);
        return new Response('DSN not allowed', {
            status: 403
        });
    }
    const dsnComponents = $9FnMD.makeDsn(dsn$1);
    if (!dsnComponents) {
        $8xCk9.debug.warn(`Could not extract DSN Components from: ${dsn$1}`);
        return new Response('Invalid DSN', {
            status: 403
        });
    }
    const sentryIngestUrl = $eheGM.getEnvelopeEndpointWithUrlEncodedAuth(dsnComponents);
    try {
        return await fetch(sentryIngestUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-sentry-envelope'
            },
            body: body
        });
    } catch (error) {
        $8xCk9.debug.error('Sentry tunnel: failed to forward envelope', error);
        return new Response('Failed to forward envelope to Sentry', {
            status: 500
        });
    }
}
module.exports.handleTunnelRequest = $136417faa8297382$var$handleTunnelRequest;

});

parcelRegister("hSLhA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ function $d04c2829bcf89072$var$addAutoIpAddressToUser(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $d04c2829bcf89072$var$addAutoIpAddressToSession(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}
module.exports.addAutoIpAddressToSession = $d04c2829bcf89072$var$addAutoIpAddressToSession;
module.exports.addAutoIpAddressToUser = $d04c2829bcf89072$var$addAutoIpAddressToUser;

});

parcelRegister("enEvJ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gJrb6 = parcelRequire("gJrb6");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $a782a34ba027764f$var$applySdkMetadata(options, name, names = [
    name
], source = 'npm') {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: $gJrb6.SDK_VERSION
            }));
        sdk.version = $gJrb6.SDK_VERSION;
    }
}
module.exports.applySdkMetadata = $a782a34ba027764f$var$applySdkMetadata;

});

parcelRegister("9b9g3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5xgnw = parcelRequire("5xgnw");

var $gg0a2 = parcelRequire("gg0a2");

var $9BwS8 = parcelRequire("9BwS8");

var $1XEa4 = parcelRequire("1XEa4");

var $8xCk9 = parcelRequire("8xCk9");

var $awmvd = parcelRequire("awmvd");

var $i9ydA = parcelRequire("i9ydA");

var $ezFpK = parcelRequire("ezFpK");

var $b4MOa = parcelRequire("b4MOa");
/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * When an external propagation context is registered (e.g. via the OTLP integration) and there is no active
 * Sentry span, this function returns an empty object to defer outgoing request propagation to the external
 * propagator (e.g. an OpenTelemetry propagator).
 *
 * If (@param options.propagateTraceparent) is `true`, the function will also generate a `traceparent` value,
 * following the W3C traceparent header format.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $6aec5294ec1689f6$var$getTraceData(options = {}) {
    const client = options.client || $9BwS8.getClient();
    if (!$1XEa4.isEnabled() || !client) return {};
    const carrier$1 = $gg0a2.getMainCarrier();
    const acs = $5xgnw.getAsyncContextStrategy(carrier$1);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = options.scope || $9BwS8.getCurrentScope();
    const span = options.span || $awmvd.getActiveSpan();
    // When no active span and external propagation context is registered (e.g. OTLP integration),
    // return empty to let the OTel propagator handle outgoing request propagation.
    if (!span && $9BwS8.hasExternalPropagationContext()) return {};
    const sentryTrace = span ? $awmvd.spanToTraceHeader(span) : $6aec5294ec1689f6$var$scopeToTraceHeader(scope);
    const dsc = span ? $i9ydA.getDynamicSamplingContextFromSpan(span) : $i9ydA.getDynamicSamplingContextFromScope(client, scope);
    const baggage$1 = $ezFpK.dynamicSamplingContextToSentryBaggageHeader(dsc);
    const isValidSentryTraceHeader = $b4MOa.TRACEPARENT_REGEXP.test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        $8xCk9.debug.warn('Invalid sentry-trace data. Cannot generate trace data');
        return {};
    }
    const traceData = {
        'sentry-trace': sentryTrace,
        baggage: baggage$1
    };
    if (options.propagateTraceparent) traceData.traceparent = span ? $awmvd.spanToTraceparentHeader(span) : $6aec5294ec1689f6$var$scopeToTraceparentHeader(scope);
    return traceData;
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $6aec5294ec1689f6$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $b4MOa.generateSentryTraceHeader(traceId, propagationSpanId, sampled);
}
function $6aec5294ec1689f6$var$scopeToTraceparentHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return $b4MOa.generateTraceparentHeader(traceId, propagationSpanId, sampled);
}
module.exports.getTraceData = $6aec5294ec1689f6$var$getTraceData;

});

parcelRegister("8fPtC", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $cZaOW = parcelRequire("cZaOW");
const $6027a7a7f99aef1f$var$NOT_PROPAGATED_MESSAGE = '[Tracing] Not injecting trace data for url because it does not match tracePropagationTargets:';
/**
 * Check if a given URL should be propagated to or not.
 * If no url is defined, or no trace propagation targets are defined, this will always return `true`.
 * You can also optionally provide a decision map, to cache decisions and avoid repeated regex lookups.
 */ function $6027a7a7f99aef1f$var$shouldPropagateTraceForUrl(url, tracePropagationTargets, decisionMap) {
    if (typeof url !== 'string' || !tracePropagationTargets) return true;
    const cachedDecision = decisionMap?.get(url);
    if (cachedDecision !== undefined) {
        $kcA99.DEBUG_BUILD && !cachedDecision && $8xCk9.debug.log($6027a7a7f99aef1f$var$NOT_PROPAGATED_MESSAGE, url);
        return cachedDecision;
    }
    const decision = $cZaOW.stringMatchesSomePattern(url, tracePropagationTargets);
    decisionMap?.set(url, decision);
    $kcA99.DEBUG_BUILD && !decision && $8xCk9.debug.log($6027a7a7f99aef1f$var$NOT_PROPAGATED_MESSAGE, url);
    return decision;
}
module.exports.shouldPropagateTraceForUrl = $6027a7a7f99aef1f$var$shouldPropagateTraceForUrl;

});

parcelRegister("6s9LI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9b9g3 = parcelRequire("9b9g3");
/**
 * Returns a string of meta tags that represent the current trace data.
 *
 * You can use this to propagate a trace from your server-side rendered Html to the browser.
 * This function returns up to two meta tags, `sentry-trace` and `baggage`, depending on the
 * current trace data state.
 *
 * @example
 * Usage example:
 *
 * ```js
 * function renderHtml() {
 *   return `
 *     <head>
 *       ${getTraceMetaTags()}
 *     </head>
 *   `;
 * }
 * ```
 *
 */ function $4b2cef6e18162470$var$getTraceMetaTags(traceData$1) {
    return Object.entries(traceData$1 || $9b9g3.getTraceData()).map(([key, value])=>`<meta name="${key}" content="${value}"/>`).join('\n');
}
module.exports.getTraceMetaTags = $4b2cef6e18162470$var$getTraceMetaTags;

});

parcelRegister("kH0lu", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $f1081772700dde33$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
    const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeoutImpl(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
module.exports.debounce = $f1081772700dde33$var$debounce;

});

parcelRegister("lRxbk", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $8RtxL = parcelRequire("8RtxL");
/* eslint-disable max-lines-per-function */ /**
 * Maximum size of incoming HTTP request bodies attached to events.
 *
 * - `'none'`: No request bodies will be attached
 * - `'small'`: Request bodies up to 1,000 bytes will be attached
 * - `'medium'`: Request bodies up to 10,000 bytes will be attached
 * - `'always'`: Request bodies will always be attached (up to 1MB hard cap)
 */ /** Hard cap on captured body size, even when `maxRequestBodySize` is `'always'`. */ const $fea84965bacdbb2b$var$MAX_BODY_BYTE_LENGTH = 1048576;
/** Content types that are safe to capture as text. */ const $fea84965bacdbb2b$var$TEXT_CONTENT_TYPES = [
    'text/',
    'application/json',
    'application/x-www-form-urlencoded',
    'application/xml',
    'application/graphql'
];
/**
 * Convert a `maxRequestBodySize` setting to a maximum byte length.
 */ function $fea84965bacdbb2b$var$getMaxBodyByteLength(maxRequestBodySize) {
    if (maxRequestBodySize === 'small') return 1000;
    if (maxRequestBodySize === 'medium') return 10000;
    return $fea84965bacdbb2b$var$MAX_BODY_BYTE_LENGTH;
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ function $fea84965bacdbb2b$var$winterCGHeadersToDict(winterCGHeaders) {
    const headers = {};
    try {
        winterCGHeaders.forEach((value, key)=>{
            if (typeof value === 'string') // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch  {
    // just return the empty headers
    }
    return headers;
}
/**
 * Convert common request headers to a simple dictionary.
 */ function $fea84965bacdbb2b$var$headersToDict(reqHeaders) {
    const headers = Object.create(null);
    try {
        Object.entries(reqHeaders).forEach(([key, value])=>{
            if (typeof value === 'string') headers[key] = value;
        });
    } catch  {
    // just return the empty headers
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function $fea84965bacdbb2b$var$winterCGRequestToRequestData(req) {
    const headers = $fea84965bacdbb2b$var$winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        query_string: $fea84965bacdbb2b$var$extractQueryParamsFromUrl(req.url),
        headers: headers
    };
}
/**
 * Checks if the content type is textual and safe to capture.
 */ function $fea84965bacdbb2b$var$isTextualContentType(contentType) {
    if (!contentType) return false;
    const lowerContentType = contentType.toLowerCase();
    return $fea84965bacdbb2b$var$TEXT_CONTENT_TYPES.some((type)=>lowerContentType.includes(type));
}
/**
 * Captures the body from a Web Fetch API Request and adds it to the isolation scope.
 *
 * This function clones the request to read the body without affecting the original.
 * Only textual content types are captured - binary data is skipped.
 *
 * This is used by WinterCG-compatible runtimes (Cloudflare Workers, Deno, Bun, Vercel Edge, etc.)
 * that use the Web Fetch API Request object.
 *
 * @param request - The incoming Web Fetch API Request
 * @param isolationScope - The isolation scope to add the body to
 * @param maxRequestBodySize - The maximum size of the request body to capture ('small' = 1KB, 'medium' = 10KB, 'always' = 1MB)
 */ async function $fea84965bacdbb2b$var$captureBodyFromWinterCGRequest(request, isolationScope, maxRequestBodySize) {
    try {
        const contentType = request.headers.get('content-type');
        if (!$fea84965bacdbb2b$var$isTextualContentType(contentType)) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.log('Skipping body capture for non-textual content type:', contentType);
            return;
        }
        if (!request.body) return;
        const contentLength = request.headers.get('content-length');
        const maxBodySize = $fea84965bacdbb2b$var$getMaxBodyByteLength(maxRequestBodySize);
        if (contentLength) {
            const length = parseInt(contentLength, 10);
            if (!isNaN(length) && length > $fea84965bacdbb2b$var$MAX_BODY_BYTE_LENGTH) {
                $kcA99.DEBUG_BUILD && $8xCk9.debug.log('Skipping body capture: body too large', length);
                return;
            }
        }
        const clonedRequest = request.clone();
        const bodyPromise = clonedRequest.text();
        const timeoutPromise = new Promise((resolve)=>{
            $8RtxL.safeUnref(setTimeout(()=>resolve(null), 2000));
        });
        const body = await Promise.race([
            bodyPromise,
            timeoutPromise
        ]);
        if (body === null) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.log('Timeout reading request body');
            return;
        }
        if (!body) return;
        // Using TextEncoder to get byte length for UTF-8 strings
        const encoder = new TextEncoder();
        const bytes = encoder.encode(body);
        const bodyByteLength = bytes.length;
        let truncatedBody;
        if (bodyByteLength > maxBodySize) {
            const decoder = new TextDecoder();
            truncatedBody = `${decoder.decode(bytes.slice(0, maxBodySize - 3))}...`;
        } else truncatedBody = body;
        isolationScope.setSDKProcessingMetadata({
            normalizedRequest: {
                data: truncatedBody
            }
        });
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log('Captured request body:', bodyByteLength, 'bytes');
    } catch (error) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.error('Error capturing request body:', error);
    }
}
/**
 * Convert a HTTP request object to RequestEventData to be passed as normalizedRequest.
 * Instead of allowing `PolymorphicRequest` to be passed,
 * we want to be more specific and generally require a http.IncomingMessage-like object.
 */ function $fea84965bacdbb2b$var$httpRequestToRequestData(request) {
    const headers = request.headers || {};
    // Check for x-forwarded-host first, then fall back to host header
    const forwardedHost = typeof headers['x-forwarded-host'] === 'string' ? headers['x-forwarded-host'] : undefined;
    const host = forwardedHost || (typeof headers.host === 'string' ? headers.host : undefined);
    // Check for x-forwarded-proto first, then fall back to existing protocol detection
    const forwardedProto = typeof headers['x-forwarded-proto'] === 'string' ? headers['x-forwarded-proto'] : undefined;
    const protocol = forwardedProto || request.protocol || (request.socket?.encrypted ? 'https' : 'http');
    const url = request.url || '';
    const absoluteUrl = $fea84965bacdbb2b$var$getAbsoluteUrl({
        url: url,
        host: host,
        protocol: protocol
    });
    // This is non-standard, but may be sometimes set
    // It may be overwritten later by our own body handling
    const data = request.body || undefined;
    // This is non-standard, but may be set on e.g. Next.js or Express requests
    const cookies = request.cookies;
    return {
        url: absoluteUrl,
        method: request.method,
        query_string: $fea84965bacdbb2b$var$extractQueryParamsFromUrl(url),
        headers: $fea84965bacdbb2b$var$headersToDict(headers),
        cookies: cookies,
        data: data
    };
}
function $fea84965bacdbb2b$var$getAbsoluteUrl({ url: url, protocol: protocol, host: host }) {
    if (url?.startsWith('http')) return url;
    if (url && host) return `${protocol}://${host}${url}`;
    return undefined;
}
const $fea84965bacdbb2b$var$SENSITIVE_HEADER_SNIPPETS = [
    'auth',
    'token',
    'secret',
    'session',
    'password',
    'passwd',
    'pwd',
    'key',
    'jwt',
    'bearer',
    'sso',
    'saml',
    'csrf',
    'xsrf',
    'credentials',
    // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
    'set-cookie',
    'cookie'
];
/**
 * Extra substrings matched only against individual Cookie / Set-Cookie **names** (not header names),
 * so we can cover common session secrets that do not match {@link SENSITIVE_HEADER_SNIPPETS}
 * (e.g. `connect.sid` does not contain `session`) without false positives on arbitrary HTTP headers.
 *
 * Cookie names are checked with the same `includes()` list as headers plus these entries; omit redundant
 * cookie-only snippets that are already implied by a header match (e.g. `oauth` → `auth`, `id_token` → `token`,
 * `next-auth` → `auth`).
 */ const $fea84965bacdbb2b$var$SENSITIVE_COOKIE_NAME_SNIPPETS = [
    // Express / Connect default session cookie
    '.sid',
    // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
    'sessid',
    // Laravel etc. "remember me" tokens
    'remember',
    // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
    'oidc',
    'pkce',
    'nonce',
    // RFC 6265bis high-security cookie name prefixes
    '__secure-',
    '__host-',
    // Load balancer / CDN sticky-session cookies (opaque routing tokens)
    'awsalb',
    'awselb',
    'akamai',
    // BaaS / IdP session cookies (names often omit "session")
    '__stripe',
    'cognito',
    'firebase',
    'supabase',
    'sb-',
    // Step-up / MFA cookies
    'mfa',
    '2fa'
];
const $fea84965bacdbb2b$var$PII_HEADER_SNIPPETS = [
    'x-forwarded-',
    '-user'
];
/**
 * Converts incoming HTTP request or response headers to OpenTelemetry span attributes following semantic conventions.
 * Header names are converted to the format: http.<request|response>.header.<key>
 * where <key> is the header name in lowercase with dashes converted to underscores.
 *
 * @param lifecycle - The lifecycle of the headers, either 'request' or 'response'
 *
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/http/#http-request-header
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/http/#http-response-header
 *
 * @see https://getsentry.github.io/sentry-conventions/attributes/http/#http-request-header-key
 * @see https://getsentry.github.io/sentry-conventions/attributes/http/#http-response-header-key
 */ function $fea84965bacdbb2b$var$httpHeadersToSpanAttributes(headers, sendDefaultPii = false, lifecycle = 'request') {
    const spanAttributes = {};
    try {
        Object.entries(headers).forEach(([key, value])=>{
            if (value == null) return;
            const lowerCasedHeaderKey = key.toLowerCase();
            const isCookieHeader = lowerCasedHeaderKey === 'cookie' || lowerCasedHeaderKey === 'set-cookie';
            if (isCookieHeader && typeof value === 'string' && value !== '') {
                // Set-Cookie: single cookie with attributes ("name=value; HttpOnly; Secure")
                // Cookie: multiple cookies separated by "; " ("cookie1=value1; cookie2=value2")
                const isSetCookie = lowerCasedHeaderKey === 'set-cookie';
                const semicolonIndex = value.indexOf(';');
                const cookieString = isSetCookie && semicolonIndex !== -1 ? value.substring(0, semicolonIndex) : value;
                const cookies = isSetCookie ? [
                    cookieString
                ] : cookieString.split('; ');
                for (const cookie of cookies){
                    // Split only at the first '=' to preserve '=' characters in cookie values
                    const equalSignIndex = cookie.indexOf('=');
                    const cookieKey = equalSignIndex !== -1 ? cookie.substring(0, equalSignIndex) : cookie;
                    const cookieValue = equalSignIndex !== -1 ? cookie.substring(equalSignIndex + 1) : '';
                    const lowerCasedCookieKey = cookieKey.toLowerCase();
                    $fea84965bacdbb2b$var$addSpanAttribute({
                        spanAttributes: spanAttributes,
                        headerKey: lowerCasedHeaderKey,
                        cookieKey: lowerCasedCookieKey,
                        value: cookieValue,
                        sendDefaultPii: sendDefaultPii,
                        lifecycle: lifecycle
                    });
                }
            } else $fea84965bacdbb2b$var$addSpanAttribute({
                spanAttributes: spanAttributes,
                headerKey: lowerCasedHeaderKey,
                value: value,
                sendDefaultPii: sendDefaultPii,
                lifecycle: lifecycle
            });
        });
    } catch  {
    // Return empty object if there's an error
    }
    return spanAttributes;
}
function $fea84965bacdbb2b$var$normalizeAttributeKey(key) {
    return key.replace(/-/g, '_');
}
function $fea84965bacdbb2b$var$addSpanAttribute({ spanAttributes: spanAttributes, headerKey: headerKey, cookieKey: cookieKey, value: value, sendDefaultPii: sendDefaultPii, lifecycle: lifecycle }) {
    const isCookieSubKey = Boolean(cookieKey);
    const nameForSensitivity = cookieKey || headerKey;
    const headerValue = $fea84965bacdbb2b$var$handleHttpHeader(nameForSensitivity, value, sendDefaultPii, isCookieSubKey);
    if (headerValue == null) return;
    const normalizedKey = `http.${lifecycle}.header.${$fea84965bacdbb2b$var$normalizeAttributeKey(headerKey)}${cookieKey ? `.${$fea84965bacdbb2b$var$normalizeAttributeKey(cookieKey)}` : ''}`;
    spanAttributes[normalizedKey] = headerValue;
}
function $fea84965bacdbb2b$var$handleHttpHeader(lowerCasedKey, value, sendPii, isCookieSubKey = false) {
    const snippetsForSensitivity = isCookieSubKey ? [
        ...$fea84965bacdbb2b$var$SENSITIVE_HEADER_SNIPPETS,
        ...$fea84965bacdbb2b$var$SENSITIVE_COOKIE_NAME_SNIPPETS
    ] : $fea84965bacdbb2b$var$SENSITIVE_HEADER_SNIPPETS;
    const isSensitive = sendPii ? snippetsForSensitivity.some((snippet)=>lowerCasedKey.includes(snippet)) : [
        ...$fea84965bacdbb2b$var$PII_HEADER_SNIPPETS,
        ...snippetsForSensitivity
    ].some((snippet)=>lowerCasedKey.includes(snippet));
    if (isSensitive) return '[Filtered]';
    else if (Array.isArray(value)) return value.map((v)=>v != null ? String(v) : v).join(';');
    else if (typeof value === 'string') return value;
    return undefined;
}
/** Extract the query params from an URL. */ function $fea84965bacdbb2b$var$extractQueryParamsFromUrl(url) {
    // url is path and query string
    if (!url) return;
    try {
        // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
        // hostname as the base. Since the point here is just to grab the query string, it doesn't matter what we use.
        const queryParams = new URL(url, 'http://s.io').search.slice(1);
        return queryParams.length ? queryParams : undefined;
    } catch  {
        return undefined;
    }
}
module.exports.MAX_BODY_BYTE_LENGTH = $fea84965bacdbb2b$var$MAX_BODY_BYTE_LENGTH;
module.exports.captureBodyFromWinterCGRequest = $fea84965bacdbb2b$var$captureBodyFromWinterCGRequest;
module.exports.extractQueryParamsFromUrl = $fea84965bacdbb2b$var$extractQueryParamsFromUrl;
module.exports.getMaxBodyByteLength = $fea84965bacdbb2b$var$getMaxBodyByteLength;
module.exports.headersToDict = $fea84965bacdbb2b$var$headersToDict;
module.exports.httpHeadersToSpanAttributes = $fea84965bacdbb2b$var$httpHeadersToSpanAttributes;
module.exports.httpRequestToRequestData = $fea84965bacdbb2b$var$httpRequestToRequestData;
module.exports.winterCGHeadersToDict = $fea84965bacdbb2b$var$winterCGHeadersToDict;
module.exports.winterCGRequestToRequestData = $fea84965bacdbb2b$var$winterCGRequestToRequestData;

});

parcelRegister("l5EER", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $8xCk9 = parcelRequire("8xCk9");

var $j8mWA = parcelRequire("j8mWA");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $f5a99a6cec472821$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $f5a99a6cec472821$var$addBreadcrumb(breadcrumb, hint) {
    const client = $9BwS8.getClient();
    const isolationScope = $9BwS8.getIsolationScope();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $f5a99a6cec472821$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = $j8mWA.dateTimestampInSeconds();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? $8xCk9.consoleSandbox(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}
module.exports.addBreadcrumb = $f5a99a6cec472821$var$addBreadcrumb;

});

parcelRegister("fJV5C", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $41JP2 = parcelRequire("41JP2");

var $2Ufnj = parcelRequire("2Ufnj");
let $b75757c8264d1448$var$originalFunctionToString;
const $b75757c8264d1448$var$INTEGRATION_NAME = 'FunctionToString';
const $b75757c8264d1448$var$SETUP_CLIENTS = new WeakMap();
const $b75757c8264d1448$var$_functionToStringIntegration = ()=>{
    return {
        name: $b75757c8264d1448$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $b75757c8264d1448$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = $2Ufnj.getOriginalFunction(this);
                    const context = $b75757c8264d1448$var$SETUP_CLIENTS.has($9BwS8.getClient()) && originalFunction !== undefined ? originalFunction : this;
                    return $b75757c8264d1448$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $b75757c8264d1448$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $b75757c8264d1448$var$functionToStringIntegration = $41JP2.defineIntegration($b75757c8264d1448$var$_functionToStringIntegration);
module.exports.functionToStringIntegration = $b75757c8264d1448$var$functionToStringIntegration;

});

parcelRegister("4wj4l", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $41JP2 = parcelRequire("41JP2");

var $8xCk9 = parcelRequire("8xCk9");

var $l0hZo = parcelRequire("l0hZo");

var $dHx3C = parcelRequire("dHx3C");

var $cZaOW = parcelRequire("cZaOW");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $34a8f15010063b6b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    /can't redefine non-configurable property "solana"/,
    /vv\(\)\.getRestrictions is not a function/,
    /Can't find variable: _AutofillCallbackHandler/,
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $34a8f15010063b6b$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $34a8f15010063b6b$var$eventFiltersIntegration = $41JP2.defineIntegration((options = {})=>{
    let mergedOptions;
    return {
        name: $34a8f15010063b6b$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $34a8f15010063b6b$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $34a8f15010063b6b$var$_mergeOptions(options, clientOptions);
            }
            return $34a8f15010063b6b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $34a8f15010063b6b$var$inboundFiltersIntegration = $41JP2.defineIntegration((options = {})=>{
    return {
        ...$34a8f15010063b6b$var$eventFiltersIntegration(options),
        name: 'InboundFilters'
    };
});
function $34a8f15010063b6b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $34a8f15010063b6b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $34a8f15010063b6b$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($34a8f15010063b6b$var$_isIgnoredError(event, options.ignoreErrors)) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${$dHx3C.getEventDescription(event)}`);
            return true;
        }
        if ($34a8f15010063b6b$var$_isUselessError(event)) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${$dHx3C.getEventDescription(event)}`);
            return true;
        }
        if ($34a8f15010063b6b$var$_isDeniedUrl(event, options.denyUrls)) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${$dHx3C.getEventDescription(event)}.\nUrl: ${$34a8f15010063b6b$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$34a8f15010063b6b$var$_isAllowedUrl(event, options.allowUrls)) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${$dHx3C.getEventDescription(event)}.\nUrl: ${$34a8f15010063b6b$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($34a8f15010063b6b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${$dHx3C.getEventDescription(event)}`);
            return true;
        }
    }
    return false;
}
function $34a8f15010063b6b$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return $l0hZo.getPossibleEventMessages(event).some((message)=>$cZaOW.stringMatchesSomePattern(message, ignoreErrors));
}
function $34a8f15010063b6b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? $cZaOW.stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function $34a8f15010063b6b$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $34a8f15010063b6b$var$_getEventFilterUrl(event);
    return !url ? false : $cZaOW.stringMatchesSomePattern(url, denyUrls);
}
function $34a8f15010063b6b$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $34a8f15010063b6b$var$_getEventFilterUrl(event);
    return !url ? true : $cZaOW.stringMatchesSomePattern(url, allowUrls);
}
function $34a8f15010063b6b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $34a8f15010063b6b$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $34a8f15010063b6b$var$_getLastValidUrl(frames) : null;
    } catch  {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.error(`Cannot extract url for event ${$dHx3C.getEventDescription(event)}`);
        return null;
    }
}
function $34a8f15010063b6b$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}
module.exports.eventFiltersIntegration = $34a8f15010063b6b$var$eventFiltersIntegration;
module.exports.inboundFiltersIntegration = $34a8f15010063b6b$var$inboundFiltersIntegration;

});

parcelRegister("iGuNe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $41JP2 = parcelRequire("41JP2");

var $4GhEv = parcelRequire("4GhEv");

var $cBvXe = parcelRequire("cBvXe");
const $d9a4091b3d8ba296$var$DEFAULT_KEY = 'cause';
const $d9a4091b3d8ba296$var$DEFAULT_LIMIT = 5;
const $d9a4091b3d8ba296$var$INTEGRATION_NAME = 'LinkedErrors';
const $d9a4091b3d8ba296$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $d9a4091b3d8ba296$var$DEFAULT_LIMIT;
    const key = options.key || $d9a4091b3d8ba296$var$DEFAULT_KEY;
    return {
        name: $d9a4091b3d8ba296$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            $4GhEv.applyAggregateErrorsToEvent($cBvXe.exceptionFromError, options.stackParser, key, limit, event, hint);
        }
    };
};
const $d9a4091b3d8ba296$var$linkedErrorsIntegration = $41JP2.defineIntegration($d9a4091b3d8ba296$var$_linkedErrorsIntegration);
module.exports.linkedErrorsIntegration = $d9a4091b3d8ba296$var$linkedErrorsIntegration;

});
parcelRegister("4GhEv", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8wdL3 = parcelRequire("8wdL3");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $3688c709b6077b82$var$applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !$8wdL3.isInstanceOf(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $3688c709b6077b82$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $3688c709b6077b82$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ($8wdL3.isInstanceOf(error[key], Error)) {
        $3688c709b6077b82$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $3688c709b6077b82$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $3688c709b6077b82$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if ($3688c709b6077b82$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ($8wdL3.isInstanceOf(childError, Error)) {
            $3688c709b6077b82$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $3688c709b6077b82$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $3688c709b6077b82$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $3688c709b6077b82$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $3688c709b6077b82$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: 'auto.core.linked_errors',
        ...$3688c709b6077b82$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $3688c709b6077b82$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
module.exports.applyAggregateErrorsToEvent = $3688c709b6077b82$var$applyAggregateErrorsToEvent;

});

parcelRegister("cBvXe", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8wdL3 = parcelRequire("8wdL3");

var $dHx3C = parcelRequire("dHx3C");

var $kUcj7 = parcelRequire("kUcj7");

var $2Ufnj = parcelRequire("2Ufnj");
/**
 * Extracts stack frames from the error.stack string
 */ function $92d1ba386c2734bf$var$parseStackFrames(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
function $92d1ba386c2734bf$var$hasSentryFetchUrlHost(error) {
    return $8wdL3.isError(error) && '__sentry_fetch_url_host__' in error && typeof error.__sentry_fetch_url_host__ === 'string';
}
/**
 * Enhances the error message with the hostname for better Sentry error reporting.
 * This allows third-party packages to still match on the original error message,
 * while Sentry gets the enhanced version with context.
 *
 * Only used internally
 * @hidden
 */ function $92d1ba386c2734bf$var$_enhanceErrorWithSentryInfo(error) {
    // If the error has a __sentry_fetch_url_host__ property (added by fetch instrumentation),
    // enhance the error message with the hostname.
    if ($92d1ba386c2734bf$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $92d1ba386c2734bf$var$exceptionFromError(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $92d1ba386c2734bf$var$_enhanceErrorWithSentryInfo(error)
    };
    const frames = $92d1ba386c2734bf$var$parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
/** If a plain object has a property that is an `Error`, return this error. */ function $92d1ba386c2734bf$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}
function $92d1ba386c2734bf$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    const keys = $2Ufnj.extractExceptionKeysForMessage(exception);
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ($8wdL3.isErrorEvent(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $92d1ba386c2734bf$var$getObjectClassName(exception);
    return `${className && className !== 'Object' ? `'${className}'` : 'Object'} captured as exception with keys: ${keys}`;
}
function $92d1ba386c2734bf$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
function $92d1ba386c2734bf$var$getException(client, mechanism, exception, hint) {
    if ($8wdL3.isError(exception)) return [
        exception,
        undefined
    ];
    // Mutate this!
    mechanism.synthetic = true;
    if ($8wdL3.isPlainObject(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ['__serialized__']: $kUcj7.normalizeToSize(exception, normalizeDepth)
        };
        const errorFromProp = $92d1ba386c2734bf$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $92d1ba386c2734bf$var$getMessageForObject(exception);
        const ex = hint?.syntheticException || new Error(message);
        ex.message = message;
        return [
            ex,
            extras
        ];
    }
    // This handles when someone does: `throw "something awesome";`
    // We use synthesized Error here so we can extract a (rough) stack trace.
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        undefined
    ];
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function $92d1ba386c2734bf$var$eventFromUnknownInput(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    const [ex, extras] = $92d1ba386c2734bf$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $92d1ba386c2734bf$var$exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    $dHx3C.addExceptionTypeValue(event, undefined, undefined);
    $dHx3C.addExceptionMechanism(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $92d1ba386c2734bf$var$eventFromMessage(stackParser, message, level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $92d1ba386c2734bf$var$parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            $dHx3C.addExceptionMechanism(event, {
                synthetic: true
            });
        }
    }
    if ($8wdL3.isParameterizedString(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
module.exports._enhanceErrorWithSentryInfo = $92d1ba386c2734bf$var$_enhanceErrorWithSentryInfo;
module.exports.eventFromMessage = $92d1ba386c2734bf$var$eventFromMessage;
module.exports.eventFromUnknownInput = $92d1ba386c2734bf$var$eventFromUnknownInput;
module.exports.exceptionFromError = $92d1ba386c2734bf$var$exceptionFromError;
module.exports.parseStackFrames = $92d1ba386c2734bf$var$parseStackFrames;

});


parcelRegister("aCZfw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $41JP2 = parcelRequire("41JP2");

var $6TngG = parcelRequire("6TngG");

var $SMVsN = parcelRequire("SMVsN");
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 */ const $7bccf6dafbd1b6f7$var$moduleMetadataIntegration = $41JP2.defineIntegration(()=>{
    return {
        name: 'ModuleMetadata',
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', (envelope$1)=>{
                $SMVsN.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === 'event') {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            $6TngG.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on('applyFrameMetadata', (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $6TngG.addMetadataToStackFrames(stackParser, event);
            });
        }
    };
});
module.exports.moduleMetadataIntegration = $7bccf6dafbd1b6f7$var$moduleMetadataIntegration;

});
parcelRegister("6TngG", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $4onm8 = parcelRequire("4onm8");
/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5049edaa4332e6cb$var$filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ const $5049edaa4332e6cb$var$parsedStacks = new Set();
/**
 * Builds a map of filenames to module metadata from the global _sentryModuleMetadata object.
 * This is useful for forwarding metadata from web workers to the main thread.
 *
 * @param parser - Stack parser to use for extracting filenames from stack traces
 * @returns A map of filename to metadata object
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5049edaa4332e6cb$var$getFilenameToMetadataMap(parser) {
    if (!$4onm8.GLOBAL_OBJ._sentryModuleMetadata) return {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filenameMap = {};
    for (const stack of Object.keys($4onm8.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $4onm8.GLOBAL_OBJ._sentryModuleMetadata[stack];
        const frames = parser(stack);
        for (const frame of frames.reverse())if (frame.filename) {
            filenameMap[frame.filename] = metadata;
            break;
        }
    }
    return filenameMap;
}
function $5049edaa4332e6cb$var$ensureMetadataStacksAreParsed(parser) {
    if (!$4onm8.GLOBAL_OBJ._sentryModuleMetadata) return;
    for (const stack of Object.keys($4onm8.GLOBAL_OBJ._sentryModuleMetadata)){
        const metadata = $4onm8.GLOBAL_OBJ._sentryModuleMetadata[stack];
        if ($5049edaa4332e6cb$var$parsedStacks.has(stack)) continue;
        // Ensure this stack doesn't get parsed again
        $5049edaa4332e6cb$var$parsedStacks.add(stack);
        const frames = parser(stack);
        // Go through the frames starting from the top of the stack and find the first one with a filename
        for (const frame of frames.reverse())if (frame.filename) {
            // Save the metadata for this filename
            $5049edaa4332e6cb$var$filenameMetadataMap.set(frame.filename, metadata);
            break;
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5049edaa4332e6cb$var$getMetadataForUrl(parser, filename) {
    $5049edaa4332e6cb$var$ensureMetadataStacksAreParsed(parser);
    return $5049edaa4332e6cb$var$filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function $5049edaa4332e6cb$var$addMetadataToStackFrames(parser, event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (!frame.filename || frame.module_metadata) return;
            const metadata = $5049edaa4332e6cb$var$getMetadataForUrl(parser, frame.filename);
            if (metadata) frame.module_metadata = metadata;
        });
    });
}
/**
 * Strips metadata from stack frames.
 */ function $5049edaa4332e6cb$var$stripMetadataFromStackFrames(event) {
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            delete frame.module_metadata;
        });
    });
}
module.exports.addMetadataToStackFrames = $5049edaa4332e6cb$var$addMetadataToStackFrames;
module.exports.getFilenameToMetadataMap = $5049edaa4332e6cb$var$getFilenameToMetadataMap;
module.exports.getMetadataForUrl = $5049edaa4332e6cb$var$getMetadataForUrl;
module.exports.stripMetadataFromStackFrames = $5049edaa4332e6cb$var$stripMetadataFromStackFrames;

});


parcelRegister("afcYt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $41JP2 = parcelRequire("41JP2");

var $5Wkkl = parcelRequire("5Wkkl");

var $l8sDZ = parcelRequire("l8sDZ");

var $lRxbk = parcelRequire("lRxbk");

var $3y9yz = parcelRequire("3y9yz");

var $ei9kR = parcelRequire("ei9kR");
// TODO(v11): Change defaults based on `sendDefaultPii`
const $77555e893950952b$var$DEFAULT_INCLUDE = {
    cookies: true,
    data: true,
    headers: true,
    query_string: true,
    url: true
};
const $77555e893950952b$var$INTEGRATION_NAME = 'RequestData';
const $77555e893950952b$var$_requestDataIntegration = (options = {})=>{
    const include = {
        ...$77555e893950952b$var$DEFAULT_INCLUDE,
        ...options.include
    };
    return {
        name: $77555e893950952b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = event;
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            const includeWithDefaultPiiApplied = {
                ...include,
                ip: include.ip ?? client.getOptions().sendDefaultPii
            };
            if (normalizedRequest) $77555e893950952b$var$addNormalizedRequestDataToEvent(event, normalizedRequest, {
                ipAddress: ipAddress
            }, includeWithDefaultPiiApplied);
            return event;
        },
        processSegmentSpan (span, client) {
            const { sdkProcessingMetadata: sdkProcessingMetadata = {} } = $9BwS8.getIsolationScope().getScopeData();
            const { normalizedRequest: normalizedRequest, ipAddress: ipAddress } = sdkProcessingMetadata;
            if (!normalizedRequest) return;
            const { sendDefaultPii: sendDefaultPii } = client.getOptions();
            const includeWithDefaultPiiApplied = {
                ...include,
                ip: include.ip ?? sendDefaultPii
            };
            $77555e893950952b$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, includeWithDefaultPiiApplied, sendDefaultPii);
        }
    };
};
/**
 * Add data about a request to an event. Primarily for use in Node-based SDKs, but included in `@sentry/core`
 * so it can be used in cross-platform SDKs like `@sentry/nextjs`.
 */ const $77555e893950952b$var$requestDataIntegration = $41JP2.defineIntegration($77555e893950952b$var$_requestDataIntegration);
/**
 * Add already normalized request data to an event.
 * This mutates the passed in event.
 */ function $77555e893950952b$var$addNormalizedRequestDataToEvent(event, req, // Data that should not go into `event.request` but is somehow related to requests
additionalData, include) {
    event.request = {
        ...event.request,
        ...$77555e893950952b$var$extractNormalizedRequestData(req, include)
    };
    if (include.ip) {
        const ip = req.headers && $3y9yz.getClientIPAddress(req.headers) || additionalData.ipAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
}
function $77555e893950952b$var$addNormalizedRequestDataToSpan(span, normalizedRequest, ipAddress, include, sendDefaultPii) {
    const requestData = $77555e893950952b$var$extractNormalizedRequestData(normalizedRequest, include);
    const attributes = {};
    if (requestData.url) attributes['url.full'] = requestData.url;
    if (requestData.method) attributes['http.request.method'] = requestData.method;
    if (requestData.query_string) attributes['url.query'] = $77555e893950952b$var$normalizeQueryString(requestData.query_string);
    $ei9kR.safeSetSpanJSONAttributes(span, attributes);
    // Process cookies before headers so normalizedRequest.cookies takes precedence
    // over the raw cookie header (matching the processEvent path).
    if (requestData.cookies && Object.keys(requestData.cookies).length > 0) {
        const cookieString = Object.entries(requestData.cookies).map(([name, value])=>`${name}=${value}`).join('; ');
        const cookieAttributes = $lRxbk.httpHeadersToSpanAttributes({
            cookie: cookieString
        }, sendDefaultPii ?? false, 'request');
        $ei9kR.safeSetSpanJSONAttributes(span, cookieAttributes);
    }
    if (requestData.headers) {
        const headerAttributes = $lRxbk.httpHeadersToSpanAttributes(requestData.headers, sendDefaultPii ?? false, 'request');
        $ei9kR.safeSetSpanJSONAttributes(span, headerAttributes);
    }
    if (requestData.data != null) {
        const serialized = typeof requestData.data === 'string' ? requestData.data : JSON.stringify(requestData.data);
        if (serialized) $ei9kR.safeSetSpanJSONAttributes(span, {
            'http.request.body.data': serialized
        });
    }
    if (include.ip) {
        const ip = normalizedRequest.headers && $3y9yz.getClientIPAddress(normalizedRequest.headers) || ipAddress || undefined;
        if (ip) $ei9kR.safeSetSpanJSONAttributes(span, {
            [$5Wkkl.SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS]: ip
        });
    }
}
function $77555e893950952b$var$extractNormalizedRequestData(normalizedRequest, include) {
    const requestData = {};
    const headers = {
        ...normalizedRequest.headers
    };
    if (include.headers) {
        requestData.headers = headers;
        if (!include.cookies) delete headers.cookie;
        if (!include.ip) {
            const ipHeaderNamesLower = new Set($3y9yz.ipHeaderNames.map((name)=>name.toLowerCase()));
            for (const key of Object.keys(headers))if (ipHeaderNamesLower.has(key.toLowerCase())) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete headers[key];
        }
    }
    requestData.method = normalizedRequest.method;
    if (include.url) requestData.url = normalizedRequest.url;
    if (include.cookies) {
        const cookies = normalizedRequest.cookies || (headers?.cookie ? $l8sDZ.parseCookie(headers.cookie) : undefined);
        requestData.cookies = cookies || {};
    }
    if (include.query_string) requestData.query_string = normalizedRequest.query_string;
    if (include.data) requestData.data = normalizedRequest.data;
    return requestData;
}
function $77555e893950952b$var$normalizeQueryString(queryString) {
    if (typeof queryString === 'string') return queryString || undefined;
    const pairs = Array.isArray(queryString) ? queryString : Object.entries(queryString);
    const result = pairs.map(([key, value])=>`${key}=${value}`).join('&');
    return result || undefined;
}
module.exports.requestDataIntegration = $77555e893950952b$var$requestDataIntegration;

});
parcelRegister("l8sDZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ function $f6309069dfe03517$var$parseCookie(str) {
    const obj = {};
    let index = 0;
    while(index < str.length){
        const eqIdx = str.indexOf('=', index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        let endIdx = str.indexOf(';', index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(';', eqIdx - 1) + 1;
            continue;
        }
        const key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            let val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf('%') !== -1 ? decodeURIComponent(val) : val;
            } catch  {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}
module.exports.parseCookie = $f6309069dfe03517$var$parseCookie;

});

parcelRegister("3y9yz", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Vendored / modified from @sergiodxa/remix-utils
// https://github.com/sergiodxa/remix-utils/blob/02af80e12829a53696bfa8f3c2363975cf59f55e/src/server/get-client-ip-address.ts
// MIT License
// Copyright (c) 2021 Sergio Xalambrí
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// The headers to check, in priority order
const $295bf5cf39155470$var$ipHeaderNames = [
    'X-Client-IP',
    'X-Forwarded-For',
    'Fly-Client-IP',
    'CF-Connecting-IP',
    'Fastly-Client-Ip',
    'True-Client-Ip',
    'X-Real-IP',
    'X-Cluster-Client-IP',
    'X-Forwarded',
    'Forwarded-For',
    'Forwarded',
    'X-Vercel-Forwarded-For'
];
/**
 * Get the IP address of the client sending a request.
 *
 * It receives a Request headers object and use it to get the
 * IP address from one of the following headers in order.
 *
 * If the IP address is valid, it will be returned. Otherwise, null will be
 * returned.
 *
 * If the header values contains more than one IP address, the first valid one
 * will be returned.
 */ function $295bf5cf39155470$var$getClientIPAddress(headers) {
    // Build a map of lowercase header names to their values for case-insensitive lookup
    // This is needed because headers from different sources may have different casings
    const lowerCaseHeaders = {};
    for (const key of Object.keys(headers))lowerCaseHeaders[key.toLowerCase()] = headers[key];
    // This will end up being Array<string | string[] | undefined | null> because of the various possible values a header
    // can take
    const headerValues = $295bf5cf39155470$var$ipHeaderNames.map((headerName)=>{
        const rawValue = lowerCaseHeaders[headerName.toLowerCase()];
        const value = Array.isArray(rawValue) ? rawValue.join(';') : rawValue;
        if (headerName === 'Forwarded') return $295bf5cf39155470$var$parseForwardedHeader(value);
        return value?.split(',').map((v)=>v.trim());
    });
    // Flatten the array and filter out any falsy entries
    const flattenedHeaderValues = headerValues.reduce((acc, val)=>{
        if (!val) return acc;
        return acc.concat(val);
    }, []);
    // Find the first value which is a valid IP address, if any
    const ipAddress = flattenedHeaderValues.find((ip)=>ip !== null && $295bf5cf39155470$var$isIP(ip));
    return ipAddress || null;
}
function $295bf5cf39155470$var$parseForwardedHeader(value) {
    if (!value) return null;
    for (const part of value.split(';')){
        if (part.startsWith('for=')) return part.slice(4);
    }
    return null;
}
//
/**
 * Custom method instead of importing this from `net` package, as this only exists in node
 * Accepts:
 * 127.0.0.1
 * 192.168.1.1
 * 192.168.1.255
 * 255.255.255.255
 * 10.1.1.1
 * 0.0.0.0
 * 2b01:cb19:8350:ed00:d0dd:fa5b:de31:8be5
 *
 * Rejects:
 * 1.1.1.01
 * 30.168.1.255.1
 * 127.1
 * 192.168.1.256
 * -1.2.3.4
 * 1.1.1.1.
 * 3...3
 * 192.168.1.099
 */ function $295bf5cf39155470$var$isIP(str) {
    const regex = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-fA-F\d]{1,4}:){7}(?:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-fA-F\d]{1,4}|:)|(?:[a-fA-F\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,2}|:)|(?:[a-fA-F\d]{1,4}:){4}(?:(?::[a-fA-F\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,3}|:)|(?:[a-fA-F\d]{1,4}:){3}(?:(?::[a-fA-F\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,4}|:)|(?:[a-fA-F\d]{1,4}:){2}(?:(?::[a-fA-F\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,5}|:)|(?:[a-fA-F\d]{1,4}:){1}(?:(?::[a-fA-F\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,6}|:)|(?::(?:(?::[a-fA-F\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-fA-F\d]{1,4}){1,7}|:)))(?:%[0-9a-zA-Z]{1,})?$)/;
    return regex.test(str);
}
module.exports.getClientIPAddress = $295bf5cf39155470$var$getClientIPAddress;
module.exports.ipHeaderNames = $295bf5cf39155470$var$ipHeaderNames;

});


parcelRegister("gJqHH", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $1XEa4 = parcelRequire("1XEa4");

var $444pX = parcelRequire("444pX");

var $41JP2 = parcelRequire("41JP2");

var $8xCk9 = parcelRequire("8xCk9");

var $dHx3C = parcelRequire("dHx3C");

var $fcqT7 = parcelRequire("fcqT7");

var $cZaOW = parcelRequire("cZaOW");

var $4onm8 = parcelRequire("4onm8");
const $c2e5901d2fcac210$var$INTEGRATION_NAME = 'CaptureConsole';
const $c2e5901d2fcac210$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || $8xCk9.CONSOLE_LEVELS;
    const handled = options.handled ?? true;
    return {
        name: $c2e5901d2fcac210$var$INTEGRATION_NAME,
        setup (client) {
            if (!('console' in $4onm8.GLOBAL_OBJ)) return;
            $444pX.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($9BwS8.getClient() !== client || !levels.includes(level)) return;
                $c2e5901d2fcac210$var$consoleHandler(args, level, handled);
            });
        }
    };
};
/**
 * Send Console API calls as Sentry Events.
 */ const $c2e5901d2fcac210$var$captureConsoleIntegration = $41JP2.defineIntegration($c2e5901d2fcac210$var$_captureConsoleIntegration);
function $c2e5901d2fcac210$var$consoleHandler(args, level, handled) {
    const severityLevel = $fcqT7.severityLevelFromString(level);
    /*
    We create this error here already to attach a stack trace to captured messages,
    if users set `attachStackTrace` to `true` in Sentry.init.
    We do this here already because we want to minimize the number of Sentry SDK stack frames
    within the error. Technically, Client.captureMessage will also do it but this happens several
    stack frames deeper.
  */ const syntheticException = new Error();
    const captureContext = {
        level: $fcqT7.severityLevelFromString(level),
        extra: {
            arguments: args
        }
    };
    $9BwS8.withScope((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            $dHx3C.addExceptionMechanism(event, {
                handled: handled,
                type: 'auto.core.capture_console'
            });
            return event;
        });
        if (level === 'assert') {
            if (!args[0]) {
                const message = `Assertion failed: ${$cZaOW.safeJoin(args.slice(1), ' ') || 'console.assert'}`;
                scope.setExtra('arguments', args.slice(1));
                scope.captureMessage(message, severityLevel, {
                    captureContext: captureContext,
                    syntheticException: syntheticException
                });
            }
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (error) {
            $1XEa4.captureException(error, captureContext);
            return;
        }
        const message = $cZaOW.safeJoin(args, ' ');
        scope.captureMessage(message, severityLevel, {
            captureContext: captureContext,
            syntheticException: syntheticException
        });
    });
}
module.exports.captureConsoleIntegration = $c2e5901d2fcac210$var$captureConsoleIntegration;

});
parcelRegister("444pX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $2Ufnj = parcelRequire("2Ufnj");

var $cZaOW = parcelRequire("cZaOW");

var $4onm8 = parcelRequire("4onm8");

var $4SNSv = parcelRequire("4SNSv");
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/ban-types */ /**
 * Filter out console messages that match the given strings or regular expressions.
 * These will neither be passed to the handler, and they will also not be logged to the user, unless they have debug enabled.
 * This is a set to avoid duplicate integration setups to add the same filter multiple times.
 */ const $2f5af66ccc40442e$var$_filter = new Set([]);
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 * Returns a function to remove the handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2f5af66ccc40442e$var$addConsoleInstrumentationHandler(handler) {
    const type = 'console';
    const removeHandler = $4SNSv.addHandler(type, handler);
    $4SNSv.maybeInstrument(type, $2f5af66ccc40442e$var$instrumentConsole);
    return removeHandler;
}
/**
 * Add a filter to the console instrumentation to filter out console messages that match the given strings or regular expressions.
 * Returns a function to remove the filter.
 */ function $2f5af66ccc40442e$var$addConsoleInstrumentationFilter(filter) {
    for (const f of filter)$2f5af66ccc40442e$var$_filter.add(f);
    return ()=>{
        for (const f of filter)$2f5af66ccc40442e$var$_filter.delete(f);
    };
}
function $2f5af66ccc40442e$var$instrumentConsole() {
    if (!('console' in $4onm8.GLOBAL_OBJ)) return;
    $8xCk9.CONSOLE_LEVELS.forEach(function(level) {
        if (!(level in $4onm8.GLOBAL_OBJ.console)) return;
        $2Ufnj.fill($4onm8.GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            $8xCk9.originalConsoleMethods[level] = originalConsoleMethod;
            return function(...args) {
                const firstArg = args[0];
                const log = $8xCk9.originalConsoleMethods[level];
                const isFiltered = $2f5af66ccc40442e$var$_filter.size && typeof firstArg === 'string' && $cZaOW.stringMatchesSomePattern(firstArg, $2f5af66ccc40442e$var$_filter);
                // Only trigger handlers for non-filtered messages
                if (!isFiltered) $4SNSv.triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // Only log filtered messages in debug mode
                if (!isFiltered || $kcA99.DEBUG_BUILD && $8xCk9.debug.isEnabled()) // Call original console method
                log?.apply($4onm8.GLOBAL_OBJ.console, args);
            };
        });
    });
}
module.exports.addConsoleInstrumentationFilter = $2f5af66ccc40442e$var$addConsoleInstrumentationFilter;
module.exports.addConsoleInstrumentationHandler = $2f5af66ccc40442e$var$addConsoleInstrumentationHandler;

});

parcelRegister("fcqT7", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $b10cd56987ae8954$var$severityLevelFromString(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}
module.exports.severityLevelFromString = $b10cd56987ae8954$var$severityLevelFromString;

});


parcelRegister("bImKj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $41JP2 = parcelRequire("41JP2");

var $8xCk9 = parcelRequire("8xCk9");

var $3ycrv = parcelRequire("3ycrv");
const $887572a39a0e1471$var$INTEGRATION_NAME = 'Dedupe';
const $887572a39a0e1471$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $887572a39a0e1471$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($887572a39a0e1471$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $887572a39a0e1471$var$dedupeIntegration = $41JP2.defineIntegration($887572a39a0e1471$var$_dedupeIntegration);
/** only exported for tests. */ function $887572a39a0e1471$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($887572a39a0e1471$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($887572a39a0e1471$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $887572a39a0e1471$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$887572a39a0e1471$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$887572a39a0e1471$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $887572a39a0e1471$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $887572a39a0e1471$var$_getExceptionFromEvent(previousEvent);
    const currentException = $887572a39a0e1471$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$887572a39a0e1471$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$887572a39a0e1471$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $887572a39a0e1471$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $3ycrv.getFramesFromEvent(currentEvent);
    let previousFrames = $3ycrv.getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $887572a39a0e1471$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch  {
        return false;
    }
}
function $887572a39a0e1471$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}
module.exports._shouldDropEvent = $887572a39a0e1471$var$_shouldDropEvent;
module.exports.dedupeIntegration = $887572a39a0e1471$var$dedupeIntegration;

});

parcelRegister("jRDJO", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $41JP2 = parcelRequire("41JP2");

var $8xCk9 = parcelRequire("8xCk9");

var $8wdL3 = parcelRequire("8wdL3");

var $kUcj7 = parcelRequire("kUcj7");

var $7iTWP = parcelRequire("7iTWP");

var $cZaOW = parcelRequire("cZaOW");
const $e761caac4eb84848$var$INTEGRATION_NAME = 'ExtraErrorData';
/**
 * Extract additional data for from original exceptions.
 */ const $e761caac4eb84848$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $e761caac4eb84848$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength } = client.getOptions();
            return $e761caac4eb84848$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $e761caac4eb84848$var$extraErrorDataIntegration = $41JP2.defineIntegration($e761caac4eb84848$var$_extraErrorDataIntegration);
function $e761caac4eb84848$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !$8wdL3.isError(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $e761caac4eb84848$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = $kUcj7.normalize(errorData, depth);
        if ($8wdL3.isPlainObject(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            $7iTWP.setSkipNormalizationHint(normalizedErrorData);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $e761caac4eb84848$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = $8wdL3.isError(value) || typeof value === 'string' ? maxValueLength ? $cZaOW.truncate(`${value}`, maxValueLength) : `${value}` : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) {
            if ($8wdL3.isError(error.cause)) {
                const errorName = error.cause.name || error.cause.constructor.name;
                extraErrorInfo.cause = {
                    [errorName]: $e761caac4eb84848$var$_extractErrorData(error.cause, false, maxValueLength)
                };
            } else extraErrorInfo.cause = error.cause;
        }
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = $8wdL3.isError(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}
module.exports.extraErrorDataIntegration = $e761caac4eb84848$var$extraErrorDataIntegration;

});

parcelRegister("4xiyx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $41JP2 = parcelRequire("41JP2");

var $3cmyB = parcelRequire("3cmyB");

var $4onm8 = parcelRequire("4onm8");
const $34d8a350e5174f44$var$INTEGRATION_NAME = 'RewriteFrames';
/**
 * Rewrite event frames paths.
 */ const $34d8a350e5174f44$var$rewriteFramesIntegration = $41JP2.defineIntegration((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || 'app:///';
    const isBrowser = 'window' in $4onm8.GLOBAL_OBJ && !!$4onm8.GLOBAL_OBJ.window;
    const iteratee = options.iteratee || $34d8a350e5174f44$var$generateIteratee({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch  {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace?.frames?.map((f)=>iteratee(f))
        };
    }
    return {
        name: $34d8a350e5174f44$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
/**
 * Exported only for tests.
 */ function $34d8a350e5174f44$var$generateIteratee({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? $3cmyB.relative(root, filename) : $3cmyB.basename(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}
module.exports.generateIteratee = $34d8a350e5174f44$var$generateIteratee;
module.exports.rewriteFramesIntegration = $34d8a350e5174f44$var$rewriteFramesIntegration;

});
parcelRegister("3cmyB", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $2543fd76a0cf4dba$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $2543fd76a0cf4dba$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $2543fd76a0cf4dba$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $2543fd76a0cf4dba$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $2543fd76a0cf4dba$var$resolve(...args) {
    let resolvedPath = '';
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $2543fd76a0cf4dba$var$normalizeArray(resolvedPath.split('/').filter((p)=>!!p), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $2543fd76a0cf4dba$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $2543fd76a0cf4dba$var$relative(from, to) {
    /* eslint-disable no-param-reassign */ from = $2543fd76a0cf4dba$var$resolve(from).slice(1);
    to = $2543fd76a0cf4dba$var$resolve(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $2543fd76a0cf4dba$var$trim(from.split('/'));
    const toParts = $2543fd76a0cf4dba$var$trim(to.split('/'));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function $2543fd76a0cf4dba$var$normalizePath(path) {
    const isPathAbsolute = $2543fd76a0cf4dba$var$isAbsolute(path);
    const trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    let normalizedPath = $2543fd76a0cf4dba$var$normalizeArray(path.split('/').filter((p)=>!!p), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function $2543fd76a0cf4dba$var$isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function $2543fd76a0cf4dba$var$join(...args) {
    return $2543fd76a0cf4dba$var$normalizePath(args.join('/'));
}
/** JSDoc */ function $2543fd76a0cf4dba$var$dirname(path) {
    const result = $2543fd76a0cf4dba$var$splitPath(path);
    const root = result[0] || '';
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $2543fd76a0cf4dba$var$basename(path, ext) {
    let f = $2543fd76a0cf4dba$var$splitPath(path)[2] || '';
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}
module.exports.basename = $2543fd76a0cf4dba$var$basename;
module.exports.dirname = $2543fd76a0cf4dba$var$dirname;
module.exports.isAbsolute = $2543fd76a0cf4dba$var$isAbsolute;
module.exports.join = $2543fd76a0cf4dba$var$join;
module.exports.normalizePath = $2543fd76a0cf4dba$var$normalizePath;
module.exports.relative = $2543fd76a0cf4dba$var$relative;
module.exports.resolve = $2543fd76a0cf4dba$var$resolve;

});


parcelRegister("h8Rq6", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $l5EER = parcelRequire("l5EER");

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $1XEa4 = parcelRequire("1XEa4");

var $41JP2 = parcelRequire("41JP2");

var $5Wkkl = parcelRequire("5Wkkl");

var $8xCk9 = parcelRequire("8xCk9");

var $dHx3C = parcelRequire("dHx3C");

var $8wdL3 = parcelRequire("8wdL3");

var $g0XVK = parcelRequire("g0XVK");

var $jLFhR = parcelRequire("jLFhR");
// Based on Kamil Ogórek's work on:
// https://github.com/supabase-community/sentry-integration-js
const $c7ac9f245a424cd5$var$AUTH_OPERATIONS_TO_INSTRUMENT = [
    'reauthenticate',
    'signInAnonymously',
    'signInWithOAuth',
    'signInWithIdToken',
    'signInWithOtp',
    'signInWithPassword',
    'signInWithSSO',
    'signOut',
    'signUp',
    'verifyOtp'
];
const $c7ac9f245a424cd5$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT = [
    'createUser',
    'deleteUser',
    'listUsers',
    'getUserById',
    'updateUserById',
    'inviteUserByEmail'
];
const $c7ac9f245a424cd5$var$FILTER_MAPPINGS = {
    eq: 'eq',
    neq: 'neq',
    gt: 'gt',
    gte: 'gte',
    lt: 'lt',
    lte: 'lte',
    like: 'like',
    'like(all)': 'likeAllOf',
    'like(any)': 'likeAnyOf',
    ilike: 'ilike',
    'ilike(all)': 'ilikeAllOf',
    'ilike(any)': 'ilikeAnyOf',
    is: 'is',
    in: 'in',
    cs: 'contains',
    cd: 'containedBy',
    sr: 'rangeGt',
    nxl: 'rangeGte',
    sl: 'rangeLt',
    nxr: 'rangeLte',
    adj: 'rangeAdjacent',
    ov: 'overlaps',
    fts: '',
    plfts: 'plain',
    phfts: 'phrase',
    wfts: 'websearch',
    not: 'not'
};
const $c7ac9f245a424cd5$var$DB_OPERATIONS_TO_INSTRUMENT = [
    'select',
    'insert',
    'upsert',
    'update',
    'delete'
];
function $c7ac9f245a424cd5$var$markAsInstrumented(fn) {
    try {
        fn.__SENTRY_INSTRUMENTED__ = true;
    } catch  {
    // ignore errors here
    }
}
function $c7ac9f245a424cd5$var$isInstrumented(fn) {
    try {
        return fn.__SENTRY_INSTRUMENTED__;
    } catch  {
        return false;
    }
}
/**
 * Plain-object bodies are copied into `plainBody`; array inserts (and other non-plain shapes) stay only on `rawBody`.
 * Returns a payload suitable for span attributes / breadcrumbs when the client has `sendDefaultPii` enabled.
 */ function $c7ac9f245a424cd5$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) {
    if (Object.keys(plainBody).length > 0) return plainBody;
    if (Array.isArray(rawBody) && rawBody.length > 0) return rawBody;
    return undefined;
}
/** True when the PostgREST builder carries a mutation body (for `insert(...)`, etc. in span descriptions). */ function $c7ac9f245a424cd5$var$hasMutationBodyForDescription(rawBody, plainBody) {
    return $c7ac9f245a424cd5$var$getMutationBodyPayloadForTelemetry(rawBody, plainBody) !== undefined;
}
/**
 * Extracts the database operation type from the HTTP method and headers
 * @param method - The HTTP method of the request
 * @param headers - The request headers
 * @returns The database operation type ('select', 'insert', 'upsert', 'update', or 'delete')
 */ function $c7ac9f245a424cd5$var$extractOperation(method, headers = {}) {
    switch(method){
        case 'GET':
            return 'select';
        case 'POST':
            if (headers['Prefer']?.includes('resolution=')) return 'upsert';
            else return 'insert';
        case 'PATCH':
            return 'update';
        case 'DELETE':
            return 'delete';
        default:
            return '<unknown-op>';
    }
}
/**
 * Translates Supabase filter parameters into readable method names for tracing
 * @param key - The filter key from the URL search parameters
 * @param query - The filter value from the URL search parameters
 * @returns A string representation of the filter as a method call
 */ function $c7ac9f245a424cd5$var$translateFiltersIntoMethods(key, query) {
    if (query === '' || query === '*') return 'select(*)';
    if (key === 'select') return `select(${query})`;
    if (key === 'or' || key.endsWith('.or')) return `${key}${query}`;
    const [filter, ...value] = query.split('.');
    let method;
    // Handle optional `configPart` of the filter
    if (filter?.startsWith('fts')) method = 'textSearch';
    else if (filter?.startsWith('plfts')) method = 'textSearch[plain]';
    else if (filter?.startsWith('phfts')) method = 'textSearch[phrase]';
    else if (filter?.startsWith('wfts')) method = 'textSearch[websearch]';
    else method = filter && $c7ac9f245a424cd5$var$FILTER_MAPPINGS[filter] || 'filter';
    return `${method}(${key}, ${value.join('.')})`;
}
function $c7ac9f245a424cd5$var$instrumentAuthOperation(operation, isAdmin = false) {
    return new Proxy(operation, {
        apply (target, thisArg, argumentsList) {
            return $jLFhR.startSpan({
                name: `auth ${isAdmin ? '(admin) ' : ''}${operation.name}`,
                attributes: {
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.db.supabase',
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'db',
                    'db.system': 'postgresql',
                    'db.operation': `auth.${isAdmin ? 'admin.' : ''}${operation.name}`
                }
            }, (span)=>{
                return Reflect.apply(target, thisArg, argumentsList).then((res)=>{
                    if (res && typeof res === 'object' && 'error' in res && res.error) {
                        span.setStatus({
                            code: $g0XVK.SPAN_STATUS_ERROR
                        });
                        $1XEa4.captureException(res.error, {
                            mechanism: {
                                handled: false,
                                type: 'auto.db.supabase.auth'
                            }
                        });
                    } else span.setStatus({
                        code: $g0XVK.SPAN_STATUS_OK
                    });
                    span.end();
                    return res;
                }).catch((err)=>{
                    span.setStatus({
                        code: $g0XVK.SPAN_STATUS_ERROR
                    });
                    span.end();
                    $1XEa4.captureException(err, {
                        mechanism: {
                            handled: false,
                            type: 'auto.db.supabase.auth'
                        }
                    });
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
}
function $c7ac9f245a424cd5$var$instrumentSupabaseAuthClient(supabaseClientInstance) {
    const auth = supabaseClientInstance.auth;
    if (!auth || $c7ac9f245a424cd5$var$isInstrumented(supabaseClientInstance.auth)) return;
    for (const operation of $c7ac9f245a424cd5$var$AUTH_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth[operation] === 'function') supabaseClientInstance.auth[operation] = $c7ac9f245a424cd5$var$instrumentAuthOperation(authOperation);
    }
    for (const operation of $c7ac9f245a424cd5$var$AUTH_ADMIN_OPERATIONS_TO_INSTRUMENT){
        const authOperation = auth.admin[operation];
        if (!authOperation) continue;
        if (typeof supabaseClientInstance.auth.admin[operation] === 'function') supabaseClientInstance.auth.admin[operation] = $c7ac9f245a424cd5$var$instrumentAuthOperation(authOperation, true);
    }
    $c7ac9f245a424cd5$var$markAsInstrumented(supabaseClientInstance.auth);
}
function $c7ac9f245a424cd5$var$instrumentSupabaseClientConstructor(SupabaseClient) {
    if ($c7ac9f245a424cd5$var$isInstrumented(SupabaseClient.prototype.from)) return;
    SupabaseClient.prototype.from = new Proxy(SupabaseClient.prototype.from, {
        apply (target, thisArg, argumentsList) {
            const rv = Reflect.apply(target, thisArg, argumentsList);
            const PostgRESTQueryBuilder = rv.constructor;
            $c7ac9f245a424cd5$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder);
            return rv;
        }
    });
    $c7ac9f245a424cd5$var$markAsInstrumented(SupabaseClient.prototype.from);
}
function $c7ac9f245a424cd5$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder) {
    if ($c7ac9f245a424cd5$var$isInstrumented(PostgRESTFilterBuilder.prototype.then)) return;
    PostgRESTFilterBuilder.prototype.then = new Proxy(PostgRESTFilterBuilder.prototype.then, {
        apply (target, thisArg, argumentsList) {
            const operations = $c7ac9f245a424cd5$var$DB_OPERATIONS_TO_INSTRUMENT;
            const typedThis = thisArg;
            const operation = $c7ac9f245a424cd5$var$extractOperation(typedThis.method, typedThis.headers);
            if (!operations.includes(operation)) return Reflect.apply(target, thisArg, argumentsList);
            if (!typedThis?.url?.pathname || typeof typedThis.url.pathname !== 'string') return Reflect.apply(target, thisArg, argumentsList);
            const pathParts = typedThis.url.pathname.split('/');
            const table = pathParts.length > 0 ? pathParts[pathParts.length - 1] : '';
            const queryItems = [];
            for (const [key, value] of typedThis.url.searchParams.entries())// It's possible to have multiple entries for the same key, eg. `id=eq.7&id=eq.3`,
            // so we need to use array instead of object to collect them.
            queryItems.push($c7ac9f245a424cd5$var$translateFiltersIntoMethods(key, value));
            const body = Object.create(null);
            if ($8wdL3.isPlainObject(typedThis.body)) for (const [key, value] of Object.entries(typedThis.body))body[key] = value;
            const sendDefaultPii = Boolean($9BwS8.getClient()?.getOptions().sendDefaultPii);
            const bodyPayload = $c7ac9f245a424cd5$var$getMutationBodyPayloadForTelemetry(typedThis.body, body);
            // Adding operation to the beginning of the description if it's not a `select` operation
            // For example, it can be an `insert` or `update` operation but the query can be `select(...)`
            // For `select` operations, we don't need repeat it in the description
            const mutationPart = operation === 'select' ? '' : `${operation}${$c7ac9f245a424cd5$var$hasMutationBodyForDescription(typedThis.body, body) ? '(...) ' : ''}`;
            const queryPart = sendDefaultPii ? queryItems.join(' ') : queryItems.length > 0 ? '[redacted]' : '';
            const descriptionMiddle = [
                mutationPart.trimEnd(),
                queryPart
            ].filter(Boolean).join(' ');
            const description = descriptionMiddle ? `${descriptionMiddle} from(${table})` : `from(${table})`;
            const attributes = {
                'db.table': table,
                'db.schema': typedThis.schema,
                'db.url': typedThis.url.origin,
                'db.sdk': typedThis.headers['X-Client-Info'],
                'db.system': 'postgresql',
                'db.operation': operation,
                [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.db.supabase',
                [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'db'
            };
            if (queryItems.length && sendDefaultPii) attributes['db.query'] = queryItems;
            if (bodyPayload !== undefined && sendDefaultPii) attributes['db.body'] = bodyPayload;
            return $jLFhR.startSpan({
                name: description,
                attributes: attributes
            }, (span)=>{
                return Reflect.apply(target, thisArg, []).then((res)=>{
                    if (span) {
                        if (res && typeof res === 'object' && 'status' in res) $g0XVK.setHttpStatus(span, res.status || 500);
                        span.end();
                    }
                    if (res?.error) {
                        const err = new Error(res.error.message);
                        if (res.error.code) err.code = res.error.code;
                        if (res.error.details) err.details = res.error.details;
                        const supabaseContext = {};
                        if (queryItems.length && sendDefaultPii) supabaseContext.query = queryItems;
                        if (bodyPayload !== undefined && sendDefaultPii) supabaseContext.body = bodyPayload;
                        $1XEa4.captureException(err, (scope)=>{
                            scope.addEventProcessor((e)=>{
                                $dHx3C.addExceptionMechanism(e, {
                                    handled: false,
                                    type: 'auto.db.supabase.postgres'
                                });
                                return e;
                            });
                            scope.setContext('supabase', supabaseContext);
                            return scope;
                        });
                    }
                    const breadcrumb = {
                        type: 'supabase',
                        category: `db.${operation}`,
                        message: description
                    };
                    const data = {};
                    if (queryItems.length && sendDefaultPii) data.query = queryItems;
                    if (bodyPayload !== undefined && sendDefaultPii) data.body = bodyPayload;
                    if (Object.keys(data).length) breadcrumb.data = data;
                    $l5EER.addBreadcrumb(breadcrumb);
                    return res;
                }, (err)=>{
                    // TODO: shouldn't we capture this error?
                    if (span) {
                        $g0XVK.setHttpStatus(span, 500);
                        span.end();
                    }
                    throw err;
                }).then(...argumentsList);
            });
        }
    });
    $c7ac9f245a424cd5$var$markAsInstrumented(PostgRESTFilterBuilder.prototype.then);
}
function $c7ac9f245a424cd5$var$instrumentPostgRESTQueryBuilder(PostgRESTQueryBuilder) {
    // We need to wrap _all_ operations despite them sharing the same `PostgRESTFilterBuilder`
    // constructor, as we don't know which method will be called first, and we don't want to miss any calls.
    for (const operation of $c7ac9f245a424cd5$var$DB_OPERATIONS_TO_INSTRUMENT){
        if ($c7ac9f245a424cd5$var$isInstrumented(PostgRESTQueryBuilder.prototype[operation])) continue;
        PostgRESTQueryBuilder.prototype[operation] = new Proxy(PostgRESTQueryBuilder.prototype[operation], {
            apply (target, thisArg, argumentsList) {
                const rv = Reflect.apply(target, thisArg, argumentsList);
                const PostgRESTFilterBuilder = rv.constructor;
                $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`Instrumenting ${operation} operation's PostgRESTFilterBuilder`);
                $c7ac9f245a424cd5$var$instrumentPostgRESTFilterBuilder(PostgRESTFilterBuilder);
                return rv;
            }
        });
        $c7ac9f245a424cd5$var$markAsInstrumented(PostgRESTQueryBuilder.prototype[operation]);
    }
}
const $c7ac9f245a424cd5$var$instrumentSupabaseClient = (supabaseClient)=>{
    if (!supabaseClient) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Supabase integration was not installed because no Supabase client was provided.');
        return;
    }
    const SupabaseClientConstructor = supabaseClient.constructor === Function ? supabaseClient : supabaseClient.constructor;
    $c7ac9f245a424cd5$var$instrumentSupabaseClientConstructor(SupabaseClientConstructor);
    $c7ac9f245a424cd5$var$instrumentSupabaseAuthClient(supabaseClient);
};
const $c7ac9f245a424cd5$var$INTEGRATION_NAME = 'Supabase';
const $c7ac9f245a424cd5$var$_supabaseIntegration = (supabaseClient)=>{
    return {
        setupOnce () {
            $c7ac9f245a424cd5$var$instrumentSupabaseClient(supabaseClient);
        },
        name: $c7ac9f245a424cd5$var$INTEGRATION_NAME
    };
};
const $c7ac9f245a424cd5$var$supabaseIntegration = $41JP2.defineIntegration((options)=>{
    return $c7ac9f245a424cd5$var$_supabaseIntegration(options.supabaseClient);
});
module.exports.DB_OPERATIONS_TO_INSTRUMENT = $c7ac9f245a424cd5$var$DB_OPERATIONS_TO_INSTRUMENT;
module.exports.FILTER_MAPPINGS = $c7ac9f245a424cd5$var$FILTER_MAPPINGS;
module.exports.extractOperation = $c7ac9f245a424cd5$var$extractOperation;
module.exports.instrumentSupabaseClient = $c7ac9f245a424cd5$var$instrumentSupabaseClient;
module.exports.supabaseIntegration = $c7ac9f245a424cd5$var$supabaseIntegration;
module.exports.translateFiltersIntoMethods = $c7ac9f245a424cd5$var$translateFiltersIntoMethods;

});

parcelRegister("3SQuT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $41JP2 = parcelRequire("41JP2");

var $8wdL3 = parcelRequire("8wdL3");

var $cZaOW = parcelRequire("cZaOW");
const $2d3f2316a7b57d41$var$DEFAULT_LIMIT = 10;
const $2d3f2316a7b57d41$var$INTEGRATION_NAME = 'ZodErrors';
/**
 * Simplified ZodIssue type definition
 */ function $2d3f2316a7b57d41$var$originalExceptionIsZodError(originalException) {
    return $8wdL3.isError(originalException) && originalException.name === 'ZodError' && Array.isArray(originalException.issues);
}
/**
 * Formats child objects or arrays to a string
 * that is preserved when sent to Sentry.
 *
 * Without this, we end up with something like this in Sentry:
 *
 * [
 *  [Object],
 *  [Object],
 *  [Object],
 *  [Object]
 * ]
 */ function $2d3f2316a7b57d41$var$flattenIssue(issue) {
    return {
        ...issue,
        path: 'path' in issue && Array.isArray(issue.path) ? issue.path.join('.') : undefined,
        keys: 'keys' in issue ? JSON.stringify(issue.keys) : undefined,
        unionErrors: 'unionErrors' in issue ? JSON.stringify(issue.unionErrors) : undefined
    };
}
/**
 * Takes ZodError issue path array and returns a flattened version as a string.
 * This makes it easier to display paths within a Sentry error message.
 *
 * Array indexes are normalized to reduce duplicate entries
 *
 * @param path ZodError issue path
 * @returns flattened path
 *
 * @example
 * flattenIssuePath([0, 'foo', 1, 'bar']) // -> '<array>.foo.<array>.bar'
 */ function $2d3f2316a7b57d41$var$flattenIssuePath(path) {
    return path.map((p)=>{
        if (typeof p === 'number') return '<array>';
        else return p;
    }).join('.');
}
/**
 * Zod error message is a stringified version of ZodError.issues
 * This doesn't display well in the Sentry UI. Replace it with something shorter.
 */ function $2d3f2316a7b57d41$var$formatIssueMessage(zodError) {
    const errorKeyMap = new Set();
    for (const iss of zodError.issues){
        const issuePath = $2d3f2316a7b57d41$var$flattenIssuePath(iss.path);
        if (issuePath.length > 0) errorKeyMap.add(issuePath);
    }
    const errorKeys = Array.from(errorKeyMap);
    if (errorKeys.length === 0) {
        // If there are no keys, then we're likely validating the root
        // variable rather than a key within an object. This attempts
        // to extract what type it was that failed to validate.
        // For example, z.string().parse(123) would return "string" here.
        let rootExpectedType = 'variable';
        if (zodError.issues.length > 0) {
            const iss = zodError.issues[0];
            if (iss !== undefined && 'expected' in iss && typeof iss.expected === 'string') rootExpectedType = iss.expected;
        }
        return `Failed to validate ${rootExpectedType}`;
    }
    return `Failed to validate keys: ${$cZaOW.truncate(errorKeys.join(', '), 100)}`;
}
/**
 * Applies ZodError issues to an event extra and replaces the error message
 */ function $2d3f2316a7b57d41$var$applyZodErrorsToEvent(limit, saveZodIssuesAsAttachment = false, event, hint) {
    if (!event.exception?.values || !hint.originalException || !$2d3f2316a7b57d41$var$originalExceptionIsZodError(hint.originalException) || hint.originalException.issues.length === 0) return event;
    try {
        const issuesToFlatten = saveZodIssuesAsAttachment ? hint.originalException.issues : hint.originalException.issues.slice(0, limit);
        const flattenedIssues = issuesToFlatten.map($2d3f2316a7b57d41$var$flattenIssue);
        if (saveZodIssuesAsAttachment) {
            // Sometimes having the full error details can be helpful.
            // Attachments have much higher limits, so we can include the full list of issues.
            if (!Array.isArray(hint.attachments)) hint.attachments = [];
            hint.attachments.push({
                filename: 'zod_issues.json',
                data: JSON.stringify({
                    issues: flattenedIssues
                })
            });
        }
        return {
            ...event,
            exception: {
                ...event.exception,
                values: [
                    {
                        ...event.exception.values[0],
                        value: $2d3f2316a7b57d41$var$formatIssueMessage(hint.originalException)
                    },
                    ...event.exception.values.slice(1)
                ]
            },
            extra: {
                ...event.extra,
                'zoderror.issues': flattenedIssues.slice(0, limit)
            }
        };
    } catch (e) {
        // Hopefully we never throw errors here, but record it
        // with the event just in case.
        return {
            ...event,
            extra: {
                ...event.extra,
                'zoderrors sentry integration parse error': {
                    message: 'an exception was thrown while processing ZodError within applyZodErrorsToEvent()',
                    error: e instanceof Error ? `${e.name}: ${e.message}\n${e.stack}` : 'unknown'
                }
            }
        };
    }
}
const $2d3f2316a7b57d41$var$_zodErrorsIntegration = (options = {})=>{
    const limit = options.limit ?? $2d3f2316a7b57d41$var$DEFAULT_LIMIT;
    return {
        name: $2d3f2316a7b57d41$var$INTEGRATION_NAME,
        processEvent (originalEvent, hint) {
            const processedEvent = $2d3f2316a7b57d41$var$applyZodErrorsToEvent(limit, options.saveZodIssuesAsAttachment, originalEvent, hint);
            return processedEvent;
        }
    };
};
/**
 * Sentry integration to process Zod errors, making them easier to work with in Sentry.
 */ const $2d3f2316a7b57d41$var$zodErrorsIntegration = $41JP2.defineIntegration($2d3f2316a7b57d41$var$_zodErrorsIntegration);
module.exports.applyZodErrorsToEvent = $2d3f2316a7b57d41$var$applyZodErrorsToEvent;
module.exports.flattenIssue = $2d3f2316a7b57d41$var$flattenIssue;
module.exports.flattenIssuePath = $2d3f2316a7b57d41$var$flattenIssuePath;
module.exports.formatIssueMessage = $2d3f2316a7b57d41$var$formatIssueMessage;
module.exports.zodErrorsIntegration = $2d3f2316a7b57d41$var$zodErrorsIntegration;

});

parcelRegister("f5Oic", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $41JP2 = parcelRequire("41JP2");

var $6TngG = parcelRequire("6TngG");

var $SMVsN = parcelRequire("SMVsN");

var $3ycrv = parcelRequire("3ycrv");
/**
 * This integration allows you to filter out, or tag error events that do not come from user code marked with a bundle key via the Sentry bundler plugins.
 */ const $afce55b14a5be69c$var$thirdPartyErrorFilterIntegration = $41JP2.defineIntegration((options)=>{
    return {
        name: 'ThirdPartyErrorsFilter',
        setup (client) {
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', (envelope$1)=>{
                $SMVsN.forEachEnvelopeItem(envelope$1, (item, type)=>{
                    if (type === 'event') {
                        const event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            $6TngG.stripMetadataFromStackFrames(event);
                            item[1] = event;
                        }
                    }
                });
            });
            client.on('applyFrameMetadata', (event)=>{
                // Only apply stack frame metadata to error events
                if (event.type) return;
                const stackParser = client.getOptions().stackParser;
                $6TngG.addMetadataToStackFrames(stackParser, event);
            });
        },
        processEvent (event) {
            const frameKeys = $afce55b14a5be69c$var$getBundleKeysForAllFramesWithFilenames(event, options.ignoreSentryInternalFrames);
            if (frameKeys) {
                const arrayMethod = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'apply-tag-if-contains-third-party-frames' ? 'some' : 'every';
                const behaviourApplies = frameKeys[arrayMethod]((keys)=>!keys.some((key)=>options.filterKeys.includes(key)));
                if (behaviourApplies) {
                    const shouldDrop = options.behaviour === 'drop-error-if-contains-third-party-frames' || options.behaviour === 'drop-error-if-exclusively-contains-third-party-frames';
                    if (shouldDrop) return null;
                    else event.tags = {
                        ...event.tags,
                        third_party_code: true
                    };
                }
            }
            return event;
        }
    };
});
/**
 * Checks if a stack frame is a Sentry internal frame by strictly matching:
 * 1. The frame must be the last frame in the stack
 * 2. The filename must indicate the internal helpers file
 * 3. The context_line must contain the exact pattern "fn.apply(this, wrappedArguments)"
 * 4. The comment pattern "Attempt to invoke user-land function" must be present in pre_context
 *
 */ function $afce55b14a5be69c$var$isSentryInternalFrame(frame, frameIndex) {
    // Only match the last frame (index 0 in reversed stack)
    if (frameIndex !== 0 || !frame.context_line || !frame.filename) return false;
    if (!frame.filename.includes('sentry') || !frame.filename.includes('helpers') || // Filename would look something like this: 'node_modules/@sentry/browser/build/npm/esm/helpers.js'
    !frame.context_line.includes($afce55b14a5be69c$var$SENTRY_INTERNAL_FN_APPLY) // Must have context_line with the exact fn.apply pattern
    ) return false;
    // Check pre_context array for comment pattern
    if (frame.pre_context) {
        const len = frame.pre_context.length;
        for(let i = 0; i < len; i++){
            if (frame.pre_context[i]?.includes($afce55b14a5be69c$var$SENTRY_INTERNAL_COMMENT)) return true;
        }
    }
    return false;
}
function $afce55b14a5be69c$var$getBundleKeysForAllFramesWithFilenames(event, ignoreSentryInternalFrames) {
    const frames = $3ycrv.getFramesFromEvent(event);
    if (!frames) return undefined;
    return frames.filter((frame, index)=>{
        // Exclude frames without a filename
        if (!frame.filename) return false;
        // Exclude frames without location info, since these are likely native code or built-ins.
        // JS frames have lineno/colno, WASM frames have instruction_addr instead.
        if (frame.lineno == null && frame.colno == null && frame.instruction_addr == null) return false;
        // Optionally ignore Sentry internal frames
        return !ignoreSentryInternalFrames || !$afce55b14a5be69c$var$isSentryInternalFrame(frame, index);
    }).map((frame)=>{
        if (!frame.module_metadata) return [];
        return Object.keys(frame.module_metadata).filter((key)=>key.startsWith($afce55b14a5be69c$var$BUNDLER_PLUGIN_APP_KEY_PREFIX)).map((key)=>key.slice($afce55b14a5be69c$var$BUNDLER_PLUGIN_APP_KEY_PREFIX.length));
    });
}
const $afce55b14a5be69c$var$BUNDLER_PLUGIN_APP_KEY_PREFIX = '_sentryBundlerPluginAppKey:';
const $afce55b14a5be69c$var$SENTRY_INTERNAL_COMMENT = 'Attempt to invoke user-land function';
const $afce55b14a5be69c$var$SENTRY_INTERNAL_FN_APPLY = 'fn.apply(this, wrappedArguments)';
module.exports.thirdPartyErrorFilterIntegration = $afce55b14a5be69c$var$thirdPartyErrorFilterIntegration;

});

parcelRegister("3FYnD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $l5EER = parcelRequire("l5EER");

var $9BwS8 = parcelRequire("9BwS8");

var $444pX = parcelRequire("444pX");

var $41JP2 = parcelRequire("41JP2");

var $8xCk9 = parcelRequire("8xCk9");

var $fcqT7 = parcelRequire("fcqT7");

var $cZaOW = parcelRequire("cZaOW");

var $4onm8 = parcelRequire("4onm8");
const $2ad409ad502135df$var$INTEGRATION_NAME = 'Console';
/**
 * Captures calls to the `console` API as breadcrumbs in Sentry.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```js
 * Sentry.init({
 *   integrations: [Sentry.consoleIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */ const $2ad409ad502135df$var$consoleIntegration = $41JP2.defineIntegration((options = {})=>{
    const levels = new Set(options.levels || $8xCk9.CONSOLE_LEVELS);
    return {
        name: $2ad409ad502135df$var$INTEGRATION_NAME,
        setup (client) {
            const unsubscribe = $444pX.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($9BwS8.getClient() !== client || !levels.has(level)) return;
                $2ad409ad502135df$var$addConsoleBreadcrumb(level, args);
            });
            client.registerCleanup(unsubscribe);
            if (options.filter) {
                const unsubscribe = $444pX.addConsoleInstrumentationFilter(options.filter);
                client.registerCleanup(unsubscribe);
            }
        }
    };
});
/**
 * Capture a console breadcrumb.
 *
 * Exported just for tests.
 */ function $2ad409ad502135df$var$addConsoleBreadcrumb(level, args) {
    const breadcrumb = {
        category: 'console',
        data: {
            arguments: args,
            logger: 'console'
        },
        level: $fcqT7.severityLevelFromString(level),
        message: $2ad409ad502135df$var$formatConsoleArgs(args)
    };
    if (level === 'assert') {
        if (args[0] === false) {
            const assertionArgs = args.slice(1);
            breadcrumb.message = assertionArgs.length > 0 ? `Assertion failed: ${$2ad409ad502135df$var$formatConsoleArgs(assertionArgs)}` : 'Assertion failed';
            breadcrumb.data.arguments = assertionArgs;
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    $l5EER.addBreadcrumb(breadcrumb, {
        input: args,
        level: level
    });
}
function $2ad409ad502135df$var$formatConsoleArgs(values) {
    return 'util' in $4onm8.GLOBAL_OBJ && typeof $4onm8.GLOBAL_OBJ.util.format === 'function' ? $4onm8.GLOBAL_OBJ.util.format(...values) : $cZaOW.safeJoin(values, ' ');
}
module.exports.addConsoleBreadcrumb = $2ad409ad502135df$var$addConsoleBreadcrumb;
module.exports.consoleIntegration = $2ad409ad502135df$var$consoleIntegration;

});

parcelRegister("bSbnj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $41JP2 = parcelRequire("41JP2");

var $9UYvI = parcelRequire("9UYvI");
/**
 * Sentry integration for buffering feature flag evaluations manually with an API, and
 * capturing them on error events and spans.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import { type FeatureFlagsIntegration } from '@sentry/browser';
 *
 * // Setup
 * Sentry.init(..., integrations: [Sentry.featureFlagsIntegration()])
 *
 * // Verify
 * const flagsIntegration = Sentry.getClient()?.getIntegrationByName<FeatureFlagsIntegration>('FeatureFlags');
 * if (flagsIntegration) {
 *   flagsIntegration.addFeatureFlag('my-flag', true);
 * } else {
 *   // check your setup
 * }
 * Sentry.captureException(Exception('broke')); // 'my-flag' should be captured to this Sentry event.
 * ```
 */ const $8a4d8fae2dc97adb$var$featureFlagsIntegration = $41JP2.defineIntegration(()=>{
    return {
        name: 'FeatureFlags',
        processEvent (event, _hint, _client) {
            return $9UYvI._INTERNAL_copyFlagsFromScopeToEvent(event);
        },
        addFeatureFlag (name, value) {
            $9UYvI._INTERNAL_insertFlagToScope(name, value);
            $9UYvI._INTERNAL_addFeatureFlagToActiveSpan(name, value);
        }
    };
});
module.exports.featureFlagsIntegration = $8a4d8fae2dc97adb$var$featureFlagsIntegration;

});
parcelRegister("9UYvI", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $awmvd = parcelRequire("awmvd");
/**
 * Ordered LRU cache for storing feature flags in the scope context. The name
 * of each flag in the buffer is unique, and the output of getAll() is ordered
 * from oldest to newest.
 */ /**
 * Max size of the LRU flag buffer stored in Sentry scope and event contexts.
 */ const $7388482377f4d8e8$var$_INTERNAL_FLAG_BUFFER_SIZE = 100;
/**
 * Max number of flag evaluations to record per span.
 */ const $7388482377f4d8e8$var$_INTERNAL_MAX_FLAGS_PER_SPAN = 10;
const $7388482377f4d8e8$var$SPAN_FLAG_ATTRIBUTE_PREFIX = 'flag.evaluation.';
/**
 * Copies feature flags that are in current scope context to the event context
 */ function $7388482377f4d8e8$var$_INTERNAL_copyFlagsFromScopeToEvent(event) {
    if (event.type) // No need to add the flags context to transaction events.
    // Spans already get the flag.evaluation attributes.
    return event;
    const scope = $9BwS8.getCurrentScope();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === undefined) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
/**
 * Inserts a flag into the current scope's context while maintaining ordered LRU properties.
 * Not thread-safe. After inserting:
 * - The flag buffer is sorted in order of recency, with the newest evaluation at the end.
 * - The names in the buffer are always unique.
 * - The length of the buffer never exceeds `maxSize`.
 *
 * @param name     Name of the feature flag to insert.
 * @param value    Value of the feature flag.
 * @param maxSize  Max number of flags the buffer should store. Default value should always be used in production.
 */ function $7388482377f4d8e8$var$_INTERNAL_insertFlagToScope(name, value, maxSize = $7388482377f4d8e8$var$_INTERNAL_FLAG_BUFFER_SIZE) {
    const scopeContexts = $9BwS8.getCurrentScope().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $7388482377f4d8e8$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize);
}
/**
 * Exported for tests only. Currently only accepts boolean values (otherwise no-op).
 * Inserts a flag into a FeatureFlag array while maintaining the following properties:
 * - Flags are sorted in order of recency, with the newest evaluation at the end.
 * - The flag names are always unique.
 * - The length of the array never exceeds `maxSize`.
 *
 * @param flags      The buffer to insert the flag into.
 * @param name       Name of the feature flag to insert.
 * @param value      Value of the feature flag.
 * @param maxSize    Max number of flags the buffer should store. Default value should always be used in production.
 */ function $7388482377f4d8e8$var$_INTERNAL_insertToFlagBuffer(flags, name, value, maxSize) {
    if (typeof value !== 'boolean') return;
    if (flags.length > maxSize) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    // Check if the flag is already in the buffer - O(n)
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) // The flag was found, remove it from its current position - O(n)
    flags.splice(index, 1);
    if (flags.length === maxSize) // If at capacity, pop the earliest flag - O(n)
    flags.shift();
    // Push the flag to the end - O(1)
    flags.push({
        flag: name,
        result: value
    });
}
/**
 * Records a feature flag evaluation for the active span. This is a no-op for non-boolean values.
 * The flag and its value is stored in span attributes with the `flag.evaluation` prefix. Once the
 * unique flags for a span reaches maxFlagsPerSpan, subsequent flags are dropped.
 *
 * @param name             Name of the feature flag.
 * @param value            Value of the feature flag. Non-boolean values are ignored.
 * @param maxFlagsPerSpan  Max number of flags a buffer should store. Default value should always be used in production.
 */ function $7388482377f4d8e8$var$_INTERNAL_addFeatureFlagToActiveSpan(name, value, maxFlagsPerSpan = $7388482377f4d8e8$var$_INTERNAL_MAX_FLAGS_PER_SPAN) {
    if (typeof value !== 'boolean') return;
    const span = $awmvd.getActiveSpan();
    if (!span) return;
    const attributes = $awmvd.spanToJSON(span).data;
    // If the flag already exists, always update it
    if (`${$7388482377f4d8e8$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}` in attributes) {
        span.setAttribute(`${$7388482377f4d8e8$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
        return;
    }
    // Else, add the flag to the span if we have not reached the max number of flags
    const numOfAddedFlags = Object.keys(attributes).filter((key)=>key.startsWith($7388482377f4d8e8$var$SPAN_FLAG_ATTRIBUTE_PREFIX)).length;
    if (numOfAddedFlags < maxFlagsPerSpan) span.setAttribute(`${$7388482377f4d8e8$var$SPAN_FLAG_ATTRIBUTE_PREFIX}${name}`, value);
}
module.exports._INTERNAL_FLAG_BUFFER_SIZE = $7388482377f4d8e8$var$_INTERNAL_FLAG_BUFFER_SIZE;
module.exports._INTERNAL_MAX_FLAGS_PER_SPAN = $7388482377f4d8e8$var$_INTERNAL_MAX_FLAGS_PER_SPAN;
module.exports._INTERNAL_addFeatureFlagToActiveSpan = $7388482377f4d8e8$var$_INTERNAL_addFeatureFlagToActiveSpan;
module.exports._INTERNAL_copyFlagsFromScopeToEvent = $7388482377f4d8e8$var$_INTERNAL_copyFlagsFromScopeToEvent;
module.exports._INTERNAL_insertFlagToScope = $7388482377f4d8e8$var$_INTERNAL_insertFlagToScope;
module.exports._INTERNAL_insertToFlagBuffer = $7388482377f4d8e8$var$_INTERNAL_insertToFlagBuffer;

});


parcelRegister("ddFNn", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $41JP2 = parcelRequire("41JP2");

var $9UYvI = parcelRequire("9UYvI");

var $2Ufnj = parcelRequire("2Ufnj");
/**
 * Sentry integration for capturing feature flag evaluations from GrowthBook.
 *
 * Only boolean results are captured at this time.
 *
 * @example
 * ```typescript
 * import { GrowthBook } from '@growthbook/growthbook';
 * import * as Sentry from '@sentry/browser'; // or '@sentry/node'
 *
 * Sentry.init({
 *   dsn: 'your-dsn',
 *   integrations: [
 *     Sentry.growthbookIntegration({ growthbookClass: GrowthBook })
 *   ]
 * });
 * ```
 */ const $99fce8fa8e578586$var$growthbookIntegration = $41JP2.defineIntegration(({ growthbookClass: growthbookClass })=>{
    return {
        name: 'GrowthBook',
        setupOnce () {
            const proto = growthbookClass.prototype;
            // Type guard and wrap isOn
            if (typeof proto.isOn === 'function') $2Ufnj.fill(proto, 'isOn', $99fce8fa8e578586$var$_wrapAndCaptureBooleanResult);
            // Type guard and wrap getFeatureValue
            if (typeof proto.getFeatureValue === 'function') $2Ufnj.fill(proto, 'getFeatureValue', $99fce8fa8e578586$var$_wrapAndCaptureBooleanResult);
        },
        processEvent (event, _hint, _client) {
            return $9UYvI._INTERNAL_copyFlagsFromScopeToEvent(event);
        }
    };
});
function $99fce8fa8e578586$var$_wrapAndCaptureBooleanResult(original) {
    return function(...args) {
        const flagName = args[0];
        const result = original.apply(this, args);
        if (typeof flagName === 'string' && typeof result === 'boolean') {
            $9UYvI._INTERNAL_insertFlagToScope(flagName, result);
            $9UYvI._INTERNAL_addFeatureFlagToActiveSpan(flagName, result);
        }
        return result;
    };
}
module.exports.growthbookIntegration = $99fce8fa8e578586$var$growthbookIntegration;

});

parcelRegister("Z850u", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $41JP2 = parcelRequire("41JP2");

var $5Wkkl = parcelRequire("5Wkkl");

var $awmvd = parcelRequire("awmvd");
const $0b7bf71749c06fe1$var$INTEGRATION_NAME = 'ConversationId';
const $0b7bf71749c06fe1$var$_conversationIdIntegration = ()=>{
    return {
        name: $0b7bf71749c06fe1$var$INTEGRATION_NAME,
        setup (client) {
            client.on('spanStart', (span)=>{
                const scopeData = $9BwS8.getCurrentScope().getScopeData();
                const isolationScopeData = $9BwS8.getIsolationScope().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = $awmvd.spanToJSON(span);
                    // Only apply conversation ID to gen_ai spans.
                    // We also check for Vercel AI spans (ai.operationId attribute or ai.* span name)
                    // because the Vercel AI integration sets the gen_ai.* op in its own spanStart handler
                    // which fires after this, so the op is not yet available at this point.
                    if (!op?.startsWith('gen_ai.') && !attributes['ai.operationId'] && !name?.startsWith('ai.')) return;
                    span.setAttribute($5Wkkl.GEN_AI_CONVERSATION_ID_ATTRIBUTE, conversationId);
                }
            });
        }
    };
};
/**
 * Automatically applies conversation ID from scope to spans.
 *
 * This integration reads the conversation ID from the current or isolation scope
 * and applies it to spans when they start. This ensures the conversation ID is
 * available for all AI-related operations.
 */ const $0b7bf71749c06fe1$var$conversationIdIntegration = $41JP2.defineIntegration($0b7bf71749c06fe1$var$_conversationIdIntegration);
module.exports.conversationIdIntegration = $0b7bf71749c06fe1$var$conversationIdIntegration;

});

parcelRegister("dJ4s3", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");
function $9fe2ee4fbcca30b2$var$isProfilingIntegrationWithProfiler(integration) {
    return !!integration && typeof integration['_profiler'] !== 'undefined' && typeof integration['_profiler']['start'] === 'function' && typeof integration['_profiler']['stop'] === 'function';
}
/**
 * Starts the Sentry continuous profiler.
 * This mode is exclusive with the transaction profiler and will only work if the profilesSampleRate is set to a falsy value.
 * In continuous profiling mode, the profiler will keep reporting profile chunks to Sentry until it is stopped, which allows for continuous profiling of the application.
 */ function $9fe2ee4fbcca30b2$var$startProfiler() {
    const client = $9BwS8.getClient();
    if (!client) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('No Sentry client available, profiling is not started');
        return;
    }
    const integration = client.getIntegrationByName('ProfilingIntegration');
    if (!integration) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('ProfilingIntegration is not available');
        return;
    }
    if (!$9fe2ee4fbcca30b2$var$isProfilingIntegrationWithProfiler(integration)) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Profiler is not available on profiling integration.');
        return;
    }
    integration._profiler.start();
}
/**
 * Stops the Sentry continuous profiler.
 * Calls to stop will stop the profiler and flush the currently collected profile data to Sentry.
 */ function $9fe2ee4fbcca30b2$var$stopProfiler() {
    const client = $9BwS8.getClient();
    if (!client) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('No Sentry client available, profiling is not started');
        return;
    }
    const integration = client.getIntegrationByName('ProfilingIntegration');
    if (!integration) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('ProfilingIntegration is not available');
        return;
    }
    if (!$9fe2ee4fbcca30b2$var$isProfilingIntegrationWithProfiler(integration)) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Profiler is not available on profiling integration.');
        return;
    }
    integration._profiler.stop();
}
/**
 * Profiler namespace for controlling the profiler in 'manual' mode.
 *
 * Requires the `nodeProfilingIntegration` from the `@sentry/profiling-node` package.
 */ const $9fe2ee4fbcca30b2$var$profiler = {
    startProfiler: $9fe2ee4fbcca30b2$var$startProfiler,
    stopProfiler: $9fe2ee4fbcca30b2$var$stopProfiler
};
module.exports.profiler = $9fe2ee4fbcca30b2$var$profiler;

});

parcelRegister("ijdSf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $5Wkkl = parcelRequire("5Wkkl");

var $awmvd = parcelRequire("awmvd");

var $g0XVK = parcelRequire("g0XVK");

var $8wdL3 = parcelRequire("8wdL3");

var $lvT7Y = parcelRequire("lvT7Y");

var $ezFpK = parcelRequire("ezFpK");

var $hNE9t = parcelRequire("hNE9t");

var $akELB = parcelRequire("akELB");

var $jLFhR = parcelRequire("jLFhR");

var $2Y94s = parcelRequire("2Y94s");

var $9b9g3 = parcelRequire("9b9g3");
/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $d544c36924a27f34$var$instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
    if (!handlerData.fetchData) return undefined;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = $lvT7Y.hasSpansEnabled() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            // Only end the span and call hooks if we're actually recording
            if (shouldCreateSpanResult) {
                $d544c36924a27f34$var$endSpan(span, handlerData);
                $d544c36924a27f34$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions);
            }
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    // Backwards-compatible with the old signature. Needed to introduce the combined optional parameter
    // to avoid API breakage for anyone calling this function with the optional spanOrigin parameter
    // TODO (v11): remove this backwards-compatible code and only accept the options parameter
    const { spanOrigin: spanOrigin = 'auto.http.browser', propagateTraceparent: propagateTraceparent = false } = typeof spanOriginOrOptions === 'object' ? spanOriginOrOptions : {
        spanOrigin: spanOriginOrOptions
    };
    const client = $9BwS8.getClient();
    const hasParent = !!$awmvd.getActiveSpan();
    // With span streaming, we always emit http.client spans, even without a parent span
    const shouldEmitSpan = hasParent || !!client && $akELB.hasSpanStreamingEnabled(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? $jLFhR.startInactiveSpan($d544c36924a27f34$var$getSpanStartOptions(url, method, spanOrigin)) : new $hNE9t.SentryNonRecordingSpan();
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent('no_parent_span', 'span');
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        // Shallow clone the options object to avoid mutating the original user-provided object
        // Examples: users re-using same options object for multiple fetch calls, frozen objects
        const options = {
            ...handlerData.args[1] || {}
        };
        const headers = $d544c36924a27f34$var$_INTERNAL_getTracingHeadersForFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        $lvT7Y.hasSpansEnabled() && shouldEmitSpan ? span : undefined, propagateTraceparent);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit('beforeOutgoingRequestSpan', span, fetchHint);
    }
    return span;
}
/**
 * Calls the onRequestSpanEnd callback if it is defined.
 */ function $d544c36924a27f34$var$_callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
    const onRequestSpanEnd = typeof spanOriginOrOptions === 'object' && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : undefined;
    onRequestSpanEnd?.(span, {
        headers: handlerData.response?.headers,
        error: handlerData.error
    });
}
/**
 * Builds merged fetch headers that include `sentry-trace` and `baggage` (and optionally `traceparent`)
 * for the given request and init, without mutating the original request or options.
 * Returns `undefined` when there is no `sentry-trace` value to attach.
 *
 * @internal Exported for cross-package instrumentation (for example Cloudflare Workers fetcher bindings)
 * and unit tests
 *
 * Baggage handling:
 * 1. No previous baggage header → include Sentry baggage
 * 2. Previous baggage has no Sentry entries → merge Sentry baggage in
 * 3. Previous baggage already has Sentry entries → leave as-is (may be user-defined)
 */ // eslint-disable-next-line complexity -- yup it's this complicated :(
function $d544c36924a27f34$var$_INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
    const traceHeaders = $9b9g3.getTraceData({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    const sentryTrace = traceHeaders['sentry-trace'];
    const baggage = traceHeaders.baggage;
    const traceparent = traceHeaders.traceparent;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const originalHeaders = fetchOptionsObj.headers || ($8wdL3.isRequest(request) ? request.headers : undefined);
    if (!originalHeaders) return {
        ...traceHeaders
    };
    else if ($d544c36924a27f34$var$isHeaders(originalHeaders)) {
        const newHeaders = new Headers(originalHeaders);
        // We don't want to override manually added sentry headers
        if (!newHeaders.get('sentry-trace')) newHeaders.set('sentry-trace', sentryTrace);
        if (propagateTraceparent && traceparent && !newHeaders.get('traceparent')) newHeaders.set('traceparent', traceparent);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get('baggage');
            if (!prevBaggageHeader) newHeaders.set('baggage', baggage);
            else if (!$d544c36924a27f34$var$baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) newHeaders.set('baggage', `${prevBaggageHeader},${baggage}`);
        }
        return newHeaders;
    } else if ($d544c36924a27f34$var$isHeadersInitTupleArray(originalHeaders)) {
        const newHeaders = [
            ...originalHeaders
        ];
        if (!newHeaders.find((header)=>header[0] === 'sentry-trace')) newHeaders.push([
            'sentry-trace',
            sentryTrace
        ]);
        if (propagateTraceparent && traceparent && !newHeaders.find((header)=>header[0] === 'traceparent')) newHeaders.push([
            'traceparent',
            traceparent
        ]);
        const prevBaggageHeaderWithSentryValues = originalHeaders.find((header)=>header[0] === 'baggage' && typeof header[1] === 'string' && $d544c36924a27f34$var$baggageHeaderHasSentryBaggageValues(header[1]));
        if (baggage && !prevBaggageHeaderWithSentryValues) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            'baggage',
            baggage
        ]);
        return newHeaders;
    } else {
        const existingSentryTraceHeader = 'sentry-trace' in originalHeaders ? originalHeaders['sentry-trace'] : undefined;
        const existingTraceparentHeader = 'traceparent' in originalHeaders ? originalHeaders.traceparent : undefined;
        const existingBaggageHeader = 'baggage' in originalHeaders ? originalHeaders.baggage : undefined;
        const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [
            ...existingBaggageHeader
        ] : [
            existingBaggageHeader
        ] : [];
        const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem)=>$d544c36924a27f34$var$baggageHeaderHasSentryBaggageValues(headerItem)) : $d544c36924a27f34$var$baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
        if (baggage && !prevBaggageHeaderWithSentryValues) newBaggageHeaders.push(baggage);
        const newHeaders = Object.assign({}, originalHeaders, {
            'sentry-trace': existingSentryTraceHeader ?? sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        });
        if (propagateTraceparent && traceparent && !existingTraceparentHeader) newHeaders.traceparent = traceparent;
        return newHeaders;
    }
}
function $d544c36924a27f34$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        $g0XVK.setHttpStatus(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers?.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: $g0XVK.SPAN_STATUS_ERROR,
        message: 'internal_error'
    });
    span.end();
}
function $d544c36924a27f34$var$baggageHeaderHasSentryBaggageValues(baggageHeader) {
    if (typeof baggageHeader !== 'string') return false;
    return baggageHeader.split(',').some((baggageEntry)=>baggageEntry.trim().startsWith($ezFpK.SENTRY_BAGGAGE_KEY_PREFIX));
}
function $d544c36924a27f34$var$isHeaders(headers) {
    return typeof Headers !== 'undefined' && $8wdL3.isInstanceOf(headers, Headers);
}
/** `HeadersInit` array form: each entry is a [name, value] pair of strings. */ function $d544c36924a27f34$var$isHeadersInitTupleArray(headers) {
    if (!Array.isArray(headers)) return false;
    return headers.every((item)=>Array.isArray(item) && item.length === 2 && typeof item[0] === 'string');
}
function $d544c36924a27f34$var$getSpanStartOptions(url$1, method, spanOrigin) {
    // Data URLs need special handling because parseStringToURLObject treats them as "relative"
    // (no "://"), causing getSanitizedUrlStringFromUrlObject to return just the pathname
    // without the "data:" prefix, making later stripDataUrlContent calls ineffective.
    // So for data URLs, we strip the content first and use that directly.
    if (url$1.startsWith('data:')) {
        const sanitizedUrl = $2Y94s.stripDataUrlContent(url$1);
        return {
            name: `${method} ${sanitizedUrl}`,
            attributes: $d544c36924a27f34$var$getFetchSpanAttributes(url$1, undefined, method, spanOrigin)
        };
    }
    const parsedUrl = $2Y94s.parseStringToURLObject(url$1);
    const sanitizedUrl = parsedUrl ? $2Y94s.getSanitizedUrlStringFromUrlObject(parsedUrl) : url$1;
    return {
        name: `${method} ${sanitizedUrl}`,
        attributes: $d544c36924a27f34$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin)
    };
}
function $d544c36924a27f34$var$getFetchSpanAttributes(url$1, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: $2Y94s.stripDataUrlContent(url$1),
        type: 'fetch',
        'http.method': method,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'http.client'
    };
    if (parsedUrl) {
        if (!$2Y94s.isURLObjectRelative(parsedUrl)) {
            attributes['http.url'] = $2Y94s.stripDataUrlContent(parsedUrl.href);
            attributes['server.address'] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes['http.query'] = parsedUrl.search;
        if (parsedUrl.hash) attributes['http.fragment'] = parsedUrl.hash;
    }
    return attributes;
}
module.exports._INTERNAL_getTracingHeadersForFetchRequest = $d544c36924a27f34$var$_INTERNAL_getTracingHeadersForFetchRequest;
module.exports._callOnRequestSpanEnd = $d544c36924a27f34$var$_callOnRequestSpanEnd;
module.exports.instrumentFetchRequest = $d544c36924a27f34$var$instrumentFetchRequest;

});

parcelRegister("bDtT1", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");
/**
 * Send user feedback to Sentry.
 */ function $878a850b4220f137$var$captureFeedback(params, hint = {}, scope = $9BwS8.getCurrentScope()) {
    const { message: message, name: name, email: email, url: url, source: source, associatedEventId: associatedEventId, tags: tags } = params;
    const feedbackEvent = {
        contexts: {
            feedback: {
                contact_email: email,
                name: name,
                message: message,
                url: url,
                source: source,
                associated_event_id: associatedEventId
            }
        },
        type: 'feedback',
        level: 'info',
        tags: tags
    };
    const client = scope?.getClient() || $9BwS8.getClient();
    if (client) client.emit('beforeSendFeedback', feedbackEvent, hint);
    const eventId = scope.captureEvent(feedbackEvent, hint);
    return eventId;
}
module.exports.captureFeedback = $878a850b4220f137$var$captureFeedback;

});

parcelRegister("143wD", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9bAWT = parcelRequire("9bAWT");

var $70O3a = parcelRequire("70O3a");
/**
 * Capture a log with the given level.
 *
 * @param level - The level of the log.
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., userId: 100.
 * @param scope - The scope to capture the log with.
 * @param severityNumber - The severity number of the log.
 */ function $0c68e63ea96f30ed$var$captureLog(level, message, attributes, scope, severityNumber) {
    $9bAWT._INTERNAL_captureLog({
        level: level,
        message: message,
        attributes: attributes,
        severityNumber: severityNumber
    }, scope);
}
/**
 * Additional metadata to capture the log with.
 */ /**
 * @summary Capture a log with the `trace` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { userId: 100, route: '/dashboard' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.trace('User clicked submit button', {
 *   buttonId: 'submit-form',
 *   formId: 'user-profile',
 *   timestamp: Date.now()
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.trace(Sentry.logger.fmt`User ${user} navigated to ${page}`, {
 *   userId: '123',
 *   sessionId: 'abc-xyz'
 * });
 * ```
 */ function $0c68e63ea96f30ed$var$trace(message, attributes, { scope: scope } = {}) {
    $0c68e63ea96f30ed$var$captureLog('trace', message, attributes, scope);
}
/**
 * @summary Capture a log with the `debug` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { component: 'Header', state: 'loading' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.debug('Component mounted', {
 *   component: 'UserProfile',
 *   props: { userId: 123 },
 *   renderTime: 150
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.debug(Sentry.logger.fmt`API request to ${endpoint} failed`, {
 *   statusCode: 404,
 *   requestId: 'req-123',
 *   duration: 250
 * });
 * ```
 */ function $0c68e63ea96f30ed$var$debug(message, attributes, { scope: scope } = {}) {
    $0c68e63ea96f30ed$var$captureLog('debug', message, attributes, scope);
}
/**
 * @summary Capture a log with the `info` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { feature: 'checkout', status: 'completed' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.info('User completed checkout', {
 *   orderId: 'order-123',
 *   amount: 99.99,
 *   paymentMethod: 'credit_card'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.info(Sentry.logger.fmt`User ${user} updated profile picture`, {
 *   userId: 'user-123',
 *   imageSize: '2.5MB',
 *   timestamp: Date.now()
 * });
 * ```
 */ function $0c68e63ea96f30ed$var$info(message, attributes, { scope: scope } = {}) {
    $0c68e63ea96f30ed$var$captureLog('info', message, attributes, scope);
}
/**
 * @summary Capture a log with the `warn` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { browser: 'Chrome', version: '91.0' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.warn('Browser compatibility issue detected', {
 *   browser: 'Safari',
 *   version: '14.0',
 *   feature: 'WebRTC',
 *   fallback: 'enabled'
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.warn(Sentry.logger.fmt`API endpoint ${endpoint} is deprecated`, {
 *   recommendedEndpoint: '/api/v2/users',
 *   sunsetDate: '2024-12-31',
 *   clientVersion: '1.2.3'
 * });
 * ```
 */ function $0c68e63ea96f30ed$var$warn(message, attributes, { scope: scope } = {}) {
    $0c68e63ea96f30ed$var$captureLog('warn', message, attributes, scope);
}
/**
 * @summary Capture a log with the `error` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { error: 'NetworkError', url: '/api/data' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.error('Failed to load user data', {
 *   error: 'NetworkError',
 *   url: '/api/users/123',
 *   statusCode: 500,
 *   retryCount: 3
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.error(Sentry.logger.fmt`Payment processing failed for order ${orderId}`, {
 *   error: 'InsufficientFunds',
 *   amount: 100.00,
 *   currency: 'USD',
 *   userId: 'user-456'
 * });
 * ```
 */ function $0c68e63ea96f30ed$var$error(message, attributes, { scope: scope } = {}) {
    $0c68e63ea96f30ed$var$captureLog('error', message, attributes, scope);
}
/**
 * @summary Capture a log with the `fatal` level. Requires the `enableLogs` option to be enabled.
 *
 * @param message - The message to log.
 * @param attributes - Arbitrary structured data that stores information about the log - e.g., { appState: 'corrupted', sessionId: 'abc-123' }.
 * @param metadata - additional metadata to capture the log with.
 *
 * @example
 *
 * ```
 * Sentry.logger.fatal('Application state corrupted', {
 *   lastKnownState: 'authenticated',
 *   sessionId: 'session-123',
 *   timestamp: Date.now(),
 *   recoveryAttempted: true
 * });
 * ```
 *
 * @example With template strings
 *
 * ```
 * Sentry.logger.fatal(Sentry.logger.fmt`Critical system failure in ${service}`, {
 *   service: 'payment-processor',
 *   errorCode: 'CRITICAL_FAILURE',
 *   affectedUsers: 150,
 *   timestamp: Date.now()
 * });
 * ```
 */ function $0c68e63ea96f30ed$var$fatal(message, attributes, { scope: scope } = {}) {
    $0c68e63ea96f30ed$var$captureLog('fatal', message, attributes, scope);
}
module.exports.fmt = $70O3a.fmt;
module.exports.debug = $0c68e63ea96f30ed$var$debug;
module.exports.error = $0c68e63ea96f30ed$var$error;
module.exports.fatal = $0c68e63ea96f30ed$var$fatal;
module.exports.info = $0c68e63ea96f30ed$var$info;
module.exports.trace = $0c68e63ea96f30ed$var$trace;
module.exports.warn = $0c68e63ea96f30ed$var$warn;

});

parcelRegister("dhVZQ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $kcA99 = parcelRequire("kcA99");

var $444pX = parcelRequire("444pX");

var $41JP2 = parcelRequire("41JP2");

var $5Wkkl = parcelRequire("5Wkkl");

var $8xCk9 = parcelRequire("8xCk9");

var $9bAWT = parcelRequire("9bAWT");

var $lEQzb = parcelRequire("lEQzb");
const $9ac9d9c4a2059e83$var$INTEGRATION_NAME = 'ConsoleLogs';
const $9ac9d9c4a2059e83$var$DEFAULT_ATTRIBUTES = {
    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.log.console'
};
const $9ac9d9c4a2059e83$var$_consoleLoggingIntegration = (options = {})=>{
    const levels = options.levels || $8xCk9.CONSOLE_LEVELS;
    return {
        name: $9ac9d9c4a2059e83$var$INTEGRATION_NAME,
        setup (client) {
            const { enableLogs: enableLogs, normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = client.getOptions();
            if (!enableLogs) {
                $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('`enableLogs` is not enabled, ConsoleLogs integration disabled');
                return;
            }
            const unsubscribe = $444pX.addConsoleInstrumentationHandler(({ args: args, level: level })=>{
                if ($9BwS8.getClient() !== client || !levels.includes(level)) return;
                const firstArg = args[0];
                const followingArgs = args.slice(1);
                if (level === 'assert') {
                    if (!firstArg) {
                        const assertionMessage = followingArgs.length > 0 ? `Assertion failed: ${$lEQzb.formatConsoleArgs(followingArgs, normalizeDepth, normalizeMaxBreadth)}` : 'Assertion failed';
                        $9bAWT._INTERNAL_captureLog({
                            level: 'error',
                            message: assertionMessage,
                            attributes: $9ac9d9c4a2059e83$var$DEFAULT_ATTRIBUTES
                        });
                    }
                    return;
                }
                const isLevelLog = level === 'log';
                const shouldGenerateTemplate = args.length > 1 && typeof args[0] === 'string' && !$lEQzb.hasConsoleSubstitutions(args[0]);
                const attributes = {
                    ...$9ac9d9c4a2059e83$var$DEFAULT_ATTRIBUTES,
                    ...shouldGenerateTemplate ? $lEQzb.createConsoleTemplateAttributes(firstArg, followingArgs) : {}
                };
                $9bAWT._INTERNAL_captureLog({
                    level: isLevelLog ? 'info' : level,
                    message: $lEQzb.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth),
                    severityNumber: isLevelLog ? 10 : undefined,
                    attributes: attributes
                });
            });
            client.registerCleanup(unsubscribe);
        }
    };
};
/**
 * Captures calls to the `console` API as logs in Sentry. Requires the `enableLogs` option to be enabled.
 *
 * @experimental This feature is experimental and may be changed or removed in future versions.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```ts
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   enableLogs: true,
 *   integrations: [Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */ const $9ac9d9c4a2059e83$var$consoleLoggingIntegration = $41JP2.defineIntegration($9ac9d9c4a2059e83$var$_consoleLoggingIntegration);
module.exports.consoleLoggingIntegration = $9ac9d9c4a2059e83$var$consoleLoggingIntegration;

});
parcelRegister("lEQzb", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $8wdL3 = parcelRequire("8wdL3");

var $kUcj7 = parcelRequire("kUcj7");

var $4onm8 = parcelRequire("4onm8");
/**
 * Formats the given values into a string.
 *
 * @param values - The values to format.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The formatted string.
 */ function $fc461bfd763f5550$var$formatConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return 'util' in $4onm8.GLOBAL_OBJ && typeof $4onm8.GLOBAL_OBJ.util.format === 'function' ? $4onm8.GLOBAL_OBJ.util.format(...values) : $fc461bfd763f5550$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth);
}
/**
 * Joins the given values into a string.
 *
 * @param values - The values to join.
 * @param normalizeDepth - The depth to normalize the values.
 * @param normalizeMaxBreadth - The max breadth to normalize the values.
 * @returns The joined string.
 */ function $fc461bfd763f5550$var$safeJoinConsoleArgs(values, normalizeDepth, normalizeMaxBreadth) {
    return values.map((value)=>$8wdL3.isPrimitive(value) ? String(value) : JSON.stringify($kUcj7.normalize(value, normalizeDepth, normalizeMaxBreadth))).join(' ');
}
/**
 * Checks if a string contains console substitution patterns like %s, %d, %i, %f, %o, %O, %c.
 *
 * @param str - The string to check
 * @returns true if the string contains console substitution patterns
 */ function $fc461bfd763f5550$var$hasConsoleSubstitutions(str) {
    // Match console substitution patterns: %s, %d, %i, %f, %o, %O, %c
    return /%[sdifocO]/.test(str);
}
/**
 * Creates template attributes for multiple console arguments.
 *
 * @param args - The console arguments
 * @returns An object with template and parameter attributes
 */ function $fc461bfd763f5550$var$createConsoleTemplateAttributes(firstArg, followingArgs) {
    const attributes = {};
    // Create template with placeholders for each argument
    const template = new Array(followingArgs.length).fill('{}').join(' ');
    attributes['sentry.message.template'] = `${firstArg} ${template}`;
    // Add each argument as a parameter
    followingArgs.forEach((arg, index)=>{
        attributes[`sentry.message.parameter.${index}`] = arg;
    });
    return attributes;
}
module.exports.createConsoleTemplateAttributes = $fc461bfd763f5550$var$createConsoleTemplateAttributes;
module.exports.formatConsoleArgs = $fc461bfd763f5550$var$formatConsoleArgs;
module.exports.hasConsoleSubstitutions = $fc461bfd763f5550$var$hasConsoleSubstitutions;
module.exports.safeJoinConsoleArgs = $fc461bfd763f5550$var$safeJoinConsoleArgs;

});


parcelRegister("8H4WL", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $35EDI = parcelRequire("35EDI");
/**
 * Options for capturing a metric.
 */ /**
 * Capture a metric with the given type, name, and value.
 *
 * @param type - The type of the metric.
 * @param name - The name of the metric.
 * @param value - The value of the metric.
 * @param options - Options for capturing the metric.
 */ function $65462d3d2170c447$var$captureMetric(type, name, value, options) {
    $35EDI._INTERNAL_captureMetric({
        type: type,
        name: name,
        value: value,
        unit: options?.unit,
        attributes: options?.attributes
    }, {
        scope: options?.scope
    });
}
/**
 * @summary Increment a counter metric.
 *
 * @param name - The name of the counter metric.
 * @param value - The value to increment by (defaults to 1).
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.count('api.requests', 1, {
 *   attributes: {
 *     endpoint: '/api/users',
 *     method: 'GET',
 *     status: 200
 *   }
 * });
 * ```
 *
 * @example With custom value
 *
 * ```
 * Sentry.metrics.count('items.processed', 5, {
 *   attributes: {
 *     processor: 'batch-processor',
 *     queue: 'high-priority'
 *   }
 * });
 * ```
 */ function $65462d3d2170c447$var$count(name, value = 1, options) {
    $65462d3d2170c447$var$captureMetric('counter', name, value, options);
}
/**
 * @summary Set a gauge metric to a specific value.
 *
 * @param name - The name of the gauge metric.
 * @param value - The current value of the gauge.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.gauge('memory.usage', 1024, {
 *   unit: 'megabyte',
 *   attributes: {
 *     process: 'web-server',
 *     region: 'us-east-1'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.gauge('active.connections', 42, {
 *   attributes: {
 *     server: 'api-1',
 *     protocol: 'websocket'
 *   }
 * });
 * ```
 */ function $65462d3d2170c447$var$gauge(name, value, options) {
    $65462d3d2170c447$var$captureMetric('gauge', name, value, options);
}
/**
 * @summary Record a value in a distribution metric.
 *
 * @param name - The name of the distribution metric.
 * @param value - The value to record in the distribution.
 * @param options - Options for capturing the metric.
 *
 * @example
 *
 * ```
 * Sentry.metrics.distribution('task.duration', 500, {
 *   unit: 'millisecond',
 *   attributes: {
 *     task: 'data-processing',
 *     priority: 'high'
 *   }
 * });
 * ```
 *
 * @example Without unit
 *
 * ```
 * Sentry.metrics.distribution('batch.size', 100, {
 *   attributes: {
 *     processor: 'batch-1',
 *     type: 'async'
 *   }
 * });
 * ```
 */ function $65462d3d2170c447$var$distribution(name, value, options) {
    $65462d3d2170c447$var$captureMetric('distribution', name, value, options);
}
module.exports.count = $65462d3d2170c447$var$count;
module.exports.distribution = $65462d3d2170c447$var$distribution;
module.exports.gauge = $65462d3d2170c447$var$gauge;

});

parcelRegister("7ZJmt", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $9bAWT = parcelRequire("9bAWT");

var $lEQzb = parcelRequire("lEQzb");

var $8wdL3 = parcelRequire("8wdL3");

var $kUcj7 = parcelRequire("kUcj7");
/**
 * Result of extracting structured attributes from console arguments.
 */ const $5d216ac336bca585$var$DEFAULT_CAPTURED_LEVELS = [
    'trace',
    'debug',
    'info',
    'warn',
    'error',
    'fatal'
];
/**
 * Creates a new Sentry reporter for Consola that forwards logs to Sentry. Requires the `enableLogs` option to be enabled.
 *
 * **Note: This integration supports Consola v3.x only.** The reporter interface and log object structure
 * may differ in other versions of Consola.
 *
 * @param options - Configuration options for the reporter.
 * @returns A Consola reporter that can be added to consola instances.
 *
 * @example
 * ```ts
 * import * as Sentry from '@sentry/node';
 * import { consola } from 'consola';
 *
 * Sentry.init({
 *   enableLogs: true,
 * });
 *
 * const sentryReporter = Sentry.createConsolaReporter({
 *   // Optional: filter levels to capture
 *   levels: ['error', 'warn', 'info'],
 * });
 *
 * consola.addReporter(sentryReporter);
 *
 * // Now consola logs will be captured by Sentry
 * consola.info('This will be sent to Sentry');
 * consola.error('This error will also be sent to Sentry');
 * ```
 */ function $5d216ac336bca585$var$createConsolaReporter(options = {}) {
    const levels = new Set(options.levels ?? $5d216ac336bca585$var$DEFAULT_CAPTURED_LEVELS);
    const providedClient = options.client;
    return {
        log (logObj) {
            // We need to exclude certain known properties from being added as additional attributes
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { type: type, level: level, message: consolaMessage, args: args, tag: tag, date: _date, ...rest } = logObj;
            // Get client - use provided client or current client
            const client = providedClient || $9BwS8.getClient();
            if (!client) return;
            // Determine the log severity level
            const logSeverityLevel = $5d216ac336bca585$var$getLogSeverityLevel(type, level);
            // Early exit if this level should not be captured
            if (!levels.has(logSeverityLevel)) return;
            const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = client.getOptions();
            const attributes = {};
            // Build attributes
            for (const [key, value] of Object.entries(rest))attributes[key] = $kUcj7.normalize(value, normalizeDepth, normalizeMaxBreadth);
            attributes['sentry.origin'] = 'auto.log.consola';
            if (tag) attributes['consola.tag'] = tag;
            if (type) attributes['consola.type'] = type;
            // Only add level if it's a valid number (not null/undefined)
            if (level != null && typeof level === 'number') attributes['consola.level'] = level;
            const extractionResult = $5d216ac336bca585$var$processExtractedAttributes($5d216ac336bca585$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth), normalizeDepth, normalizeMaxBreadth);
            if (extractionResult?.attributes) Object.assign(attributes, extractionResult.attributes);
            $9bAWT._INTERNAL_captureLog({
                level: logSeverityLevel,
                message: extractionResult?.message || consolaMessage || args && $lEQzb.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth) || '',
                attributes: attributes
            });
        }
    };
}
// Mapping from consola log types to Sentry log severity levels
const $5d216ac336bca585$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP = {
    // Consola built-in types
    silent: 'trace',
    fatal: 'fatal',
    error: 'error',
    warn: 'warn',
    log: 'info',
    info: 'info',
    success: 'info',
    fail: 'error',
    ready: 'info',
    start: 'info',
    box: 'info',
    debug: 'debug',
    trace: 'trace',
    verbose: 'debug',
    // Custom types that might exist
    critical: 'fatal',
    notice: 'info'
};
// Mapping from consola log levels (numbers) to Sentry log severity levels
const $5d216ac336bca585$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP = {
    0: 'fatal',
    1: 'warn',
    2: 'info',
    3: 'info',
    4: 'debug',
    5: 'trace'
};
/**
 * Determines the log severity level from Consola type and level.
 *
 * @param type - The Consola log type (e.g., 'error', 'warn', 'info')
 * @param level - The Consola numeric log level (0-5) or null for some types like 'verbose'
 * @returns The corresponding Sentry log severity level
 */ function $5d216ac336bca585$var$getLogSeverityLevel(type, level) {
    // Handle special case for verbose logs (level can be null with infinite level in Consola)
    if (type === 'verbose') return 'debug';
    // Handle silent logs - these should be at trace level
    if (type === 'silent') return 'trace';
    // First try to map by type (more specific)
    if (type) {
        const mappedLevel = $5d216ac336bca585$var$CONSOLA_TYPE_TO_LOG_SEVERITY_LEVEL_MAP[type];
        if (mappedLevel) return mappedLevel;
    }
    // Fallback to level mapping (handle null level)
    if (typeof level === 'number') {
        const mappedLevel = $5d216ac336bca585$var$CONSOLA_LEVEL_TO_LOG_SEVERITY_LEVEL_MAP[level];
        if (mappedLevel) return mappedLevel;
    }
    // Default fallback
    return 'info';
}
/**
 * Extracts structured attributes from console arguments. If the first argument is a plain object, its properties are extracted as attributes.
 */ function $5d216ac336bca585$var$defaultExtractAttributes(args, normalizeDepth, normalizeMaxBreadth) {
    if (!args?.length) return {
        message: ''
    };
    // Message looks like how consola logs the message to the console (all args stringified and joined)
    const message = $lEQzb.formatConsoleArgs(args, normalizeDepth, normalizeMaxBreadth);
    const firstArg = args[0];
    if ($8wdL3.isPlainObject(firstArg)) {
        // Remaining args start from index 2 i f we used second arg as message, otherwise from index 1
        const remainingArgsStartIndex = typeof args[1] === 'string' ? 2 : 1;
        const remainingArgs = args.slice(remainingArgsStartIndex);
        return {
            message: message,
            // Object content from first arg is added as attributes
            attributes: firstArg,
            // Add remaining args as message parameters
            messageParameters: remainingArgs
        };
    } else {
        const followingArgs = args.slice(1);
        const shouldAddTemplateAttr = followingArgs.length > 0 && typeof firstArg === 'string' && !$lEQzb.hasConsoleSubstitutions(firstArg);
        return {
            message: message,
            messageTemplate: shouldAddTemplateAttr ? firstArg : undefined,
            messageParameters: shouldAddTemplateAttr ? followingArgs : undefined
        };
    }
}
/**
 * Processes extracted attributes by normalizing them and preparing message parameter attributes if a template is present.
 */ function $5d216ac336bca585$var$processExtractedAttributes(extractionResult, normalizeDepth, normalizeMaxBreadth) {
    const { message: message, attributes: attributes, messageTemplate: messageTemplate, messageParameters: messageParameters } = extractionResult;
    const messageParamAttributes = {};
    if (messageTemplate && messageParameters) {
        const templateAttrs = $lEQzb.createConsoleTemplateAttributes(messageTemplate, messageParameters);
        for (const [key, value] of Object.entries(templateAttrs))messageParamAttributes[key] = key.startsWith('sentry.message.parameter.') ? $kUcj7.normalize(value, normalizeDepth, normalizeMaxBreadth) : value;
    } else if (messageParameters && messageParameters.length > 0) messageParameters.forEach((arg, index)=>{
        messageParamAttributes[`sentry.message.parameter.${index}`] = $kUcj7.normalize(arg, normalizeDepth, normalizeMaxBreadth);
    });
    return {
        message: message,
        attributes: {
            ...$kUcj7.normalize(attributes, normalizeDepth, normalizeMaxBreadth),
            ...messageParamAttributes
        }
    };
}
module.exports.createConsolaReporter = $5d216ac336bca585$var$createConsolaReporter;

});

parcelRegister("iXGvj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $5Wkkl = parcelRequire("5Wkkl");

var $jZcA4 = parcelRequire("jZcA4");

var $awmvd = parcelRequire("awmvd");

var $fxLy8 = parcelRequire("fxLy8");

var $dPhDf = parcelRequire("dPhDf");

var $akELB = parcelRequire("akELB");

var $9Pp7A = parcelRequire("9Pp7A");

var $f8l98 = parcelRequire("f8l98");
/**
 * Post-process spans emitted by the Vercel AI SDK.
 * This is supposed to be used in `client.on('spanStart', ...)
 */ function $dcdeb51eb739eac7$var$onVercelAiSpanStart(span) {
    const { data: attributes, description: name } = $awmvd.spanToJSON(span);
    if (!name) return;
    // Tool call spans
    // https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
    if (attributes[$f8l98.AI_TOOL_CALL_NAME_ATTRIBUTE] && attributes[$f8l98.AI_TOOL_CALL_ID_ATTRIBUTE] && name === 'ai.toolCall') {
        $dcdeb51eb739eac7$var$processToolCallSpan(span, attributes);
        return;
    }
    // V6+ Check if this is a Vercel AI span by checking if the operation ID attribute is present.
    // V5+ Check if this is a Vercel AI span by name pattern.
    if (!attributes[$f8l98.AI_OPERATION_ID_ATTRIBUTE] && !name.startsWith('ai.')) return;
    const client = $9BwS8.getClient();
    const integration = client?.getIntegrationByName('VercelAI');
    const enableTruncation = $jZcA4.shouldEnableTruncation(integration?.options?.enableTruncation);
    $dcdeb51eb739eac7$var$processGenerateSpan(span, name, attributes, enableTruncation);
}
function $dcdeb51eb739eac7$var$vercelAiEventProcessor(event) {
    if (event.type === 'transaction' && event.spans) {
        // Map to accumulate token data by parent span ID
        const tokenAccumulator = new Map();
        // First pass: process all spans and accumulate token data
        for (const span of event.spans){
            $dcdeb51eb739eac7$var$processEndedVercelAiSpan(span);
            // Accumulate token data for parent spans
            $9Pp7A.accumulateTokensForParent(span, tokenAccumulator);
        }
        // Second pass: apply tool descriptions and accumulated tokens
        $9Pp7A.applyToolDescriptionsAndTokens(event.spans, tokenAccumulator);
        // Also apply to root when it is the invoke_agent pipeline
        const trace = event.contexts?.trace;
        if (trace?.op === 'gen_ai.invoke_agent') $9Pp7A.applyAccumulatedTokens(trace, tokenAccumulator);
    }
    return event;
}
/**
 * Tool call structure from Vercel AI SDK
 * Note: V5/V6 use 'input' for arguments, V4 and earlier use 'args'
 */ /**
 * Normalize finish reason to match OpenTelemetry semantic conventions.
 * Valid values: "stop", "length", "content_filter", "tool_call", "error"
 *
 * Vercel AI SDK uses "tool-calls" (plural, with hyphen) which we map to "tool_call".
 */ function $dcdeb51eb739eac7$var$normalizeFinishReason(finishReason) {
    if (typeof finishReason !== 'string') return 'stop';
    // Map Vercel AI SDK finish reasons to OpenTelemetry semantic convention values
    switch(finishReason){
        case 'tool-calls':
            return 'tool_call';
        case 'stop':
        case 'length':
        case 'content_filter':
        case 'error':
            return finishReason;
        default:
            // For unknown values, return as-is (schema allows arbitrary strings)
            return finishReason;
    }
}
/**
 * Build gen_ai.output.messages from ai.response.text and/or ai.response.toolCalls
 *
 * Format follows OpenTelemetry semantic conventions:
 * [{"role": "assistant", "parts": [...], "finish_reason": "stop"}]
 *
 * Parts can be:
 * - {"type": "text", "content": "..."}
 * - {"type": "tool_call", "id": "...", "name": "...", "arguments": "..."}
 */ function $dcdeb51eb739eac7$var$buildOutputMessages(attributes) {
    const responseText = attributes[$f8l98.AI_RESPONSE_TEXT_ATTRIBUTE];
    const responseToolCalls = attributes[$f8l98.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
    const finishReason = attributes[$f8l98.AI_RESPONSE_FINISH_REASON_ATTRIBUTE];
    // Skip if neither text nor tool calls are present
    if (responseText == null && responseToolCalls == null) return;
    const parts = [];
    // Add text part if present
    if (typeof responseText === 'string' && responseText.length > 0) parts.push({
        type: 'text',
        content: responseText
    });
    // Add tool call parts if present
    if (responseToolCalls != null) try {
        // Tool calls can be a string (JSON) or already parsed array
        const toolCalls = typeof responseToolCalls === 'string' ? JSON.parse(responseToolCalls) : responseToolCalls;
        if (Array.isArray(toolCalls)) {
            for (const toolCall of toolCalls){
                // V5/V6 use 'input', V4 and earlier use 'args'
                const args = toolCall.input ?? toolCall.args;
                parts.push({
                    type: 'tool_call',
                    id: toolCall.toolCallId,
                    name: toolCall.toolName,
                    // Handle undefined args: JSON.stringify(undefined) returns undefined, not a string,
                    // which would cause the property to be omitted from the final JSON output
                    arguments: typeof args === 'string' ? args : JSON.stringify(args ?? {})
                });
            }
            // Only delete tool calls attribute if we successfully processed them
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete attributes[$f8l98.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE];
        }
    } catch  {
    // Ignore parsing errors - tool calls attribute is preserved
    }
    // Only set output messages and delete text attribute if we have parts
    if (parts.length > 0) {
        const outputMessage = {
            role: 'assistant',
            parts: parts,
            finish_reason: $dcdeb51eb739eac7$var$normalizeFinishReason(finishReason)
        };
        attributes[$fxLy8.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE] = JSON.stringify([
            outputMessage
        ]);
        // Remove the text attribute since it's now captured in gen_ai.output.messages
        // Note: tool calls attribute is deleted above only if successfully parsed
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete attributes[$f8l98.AI_RESPONSE_TEXT_ATTRIBUTE];
    }
}
/**
 * Post-process spans emitted by the Vercel AI SDK.
 */ /**
 * Rename and normalize Vercel AI SDK attributes to OpenTelemetry semantic conventions.
 * This is the shared attribute processing logic used by both the legacy event processor
 * path (SpanJSON) and the streamed span path (StreamedSpanJSON).
 */ function $dcdeb51eb739eac7$var$processVercelAiSpanAttributes(attributes) {
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE, $fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE);
    // Parent spans (ai.streamText, ai.streamObject, etc.) use inputTokens/outputTokens instead of promptTokens/completionTokens
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, 'ai.usage.inputTokens', $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, 'ai.usage.outputTokens', $fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE);
    // Embedding spans use ai.usage.tokens instead of promptTokens/completionTokens
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_USAGE_TOKENS_ATTRIBUTE, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE);
    // AI SDK uses avgOutputTokensPerSecond, map to our expected attribute name
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, 'ai.response.avgOutputTokensPerSecond', 'ai.response.avgCompletionTokensPerSecond');
    // Input tokens is the sum of prompt tokens and cached input tokens
    if (typeof attributes[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === 'number' && typeof attributes[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE] === 'number') attributes[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = attributes[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] + attributes[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE];
    // Compute total tokens from input + output (embeddings may only have input tokens)
    if (typeof attributes[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] === 'number') {
        const outputTokens = typeof attributes[$fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] === 'number' ? attributes[$fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] : 0;
        attributes[$fxLy8.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = outputTokens + attributes[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    }
    // Convert the available tools array to a JSON string
    if (attributes[$f8l98.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$f8l98.AI_PROMPT_TOOLS_ATTRIBUTE])) attributes[$f8l98.AI_PROMPT_TOOLS_ATTRIBUTE] = $9Pp7A.convertAvailableToolsToJsonString(attributes[$f8l98.AI_PROMPT_TOOLS_ATTRIBUTE]);
    // Rename AI SDK attributes to standardized gen_ai attributes
    // Map operation.name to OpenTelemetry semantic convention values
    if (attributes[$f8l98.OPERATION_NAME_ATTRIBUTE]) {
        // V6+ sets ai.operationId to the bare operation (e.g. "ai.streamText") while
        // operation.name appends functionId (e.g. "ai.streamText myAgent").
        // When ai.operationId is present, use it for correct mapping.
        const rawOperationName = attributes[$f8l98.AI_OPERATION_ID_ATTRIBUTE] ? attributes[$f8l98.AI_OPERATION_ID_ATTRIBUTE] : attributes[$f8l98.OPERATION_NAME_ATTRIBUTE];
        const operationName = $dPhDf.SPAN_TO_OPERATION_NAME.get(rawOperationName) ?? rawOperationName;
        attributes[$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE] = operationName;
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete attributes[$f8l98.OPERATION_NAME_ATTRIBUTE];
    }
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_PROMPT_MESSAGES_ATTRIBUTE, $fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE);
    // Build gen_ai.output.messages from response text and/or tool calls
    // Note: buildOutputMessages also removes the source attributes when output is successfully generated
    $dcdeb51eb739eac7$var$buildOutputMessages(attributes);
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_RESPONSE_OBJECT_ATTRIBUTE, 'gen_ai.response.object');
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_PROMPT_TOOLS_ATTRIBUTE, 'gen_ai.request.available_tools');
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_TOOL_CALL_ARGS_ATTRIBUTE, $fxLy8.GEN_AI_TOOL_INPUT_ATTRIBUTE);
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_TOOL_CALL_RESULT_ATTRIBUTE, $fxLy8.GEN_AI_TOOL_OUTPUT_ATTRIBUTE);
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_SCHEMA_ATTRIBUTE, 'gen_ai.request.schema');
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_MODEL_ID_ATTRIBUTE, $fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE);
    // Map embedding input: ai.values → gen_ai.embeddings.input
    // Vercel AI SDK JSON-stringifies each value individually, so we parse each element back.
    // Single embed gets unwrapped to a plain value; batch embedMany stays as a JSON array.
    if (Array.isArray(attributes[$f8l98.AI_VALUES_ATTRIBUTE])) {
        const parsed = attributes[$f8l98.AI_VALUES_ATTRIBUTE].map((v)=>{
            try {
                return JSON.parse(v);
            } catch  {
                return v;
            }
        });
        attributes[$fxLy8.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = parsed.length === 1 ? parsed[0] : JSON.stringify(parsed);
    }
    $dcdeb51eb739eac7$var$addProviderMetadataToAttributes(attributes);
    for (const key of Object.keys(attributes)){
        // JSON-stringify any array-valued attributes so they survive v2 span serialization.
        // Can be removed once span streaming supports arrays natively.
        if (Array.isArray(attributes[key])) attributes[key] = JSON.stringify(attributes[key]);
        // Change attributes namespaced with `ai.X` to `vercel.ai.X`
        if (key.startsWith('ai.')) $dcdeb51eb739eac7$var$renameAttributeKey(attributes, key, `vercel.${key}`);
    }
}
function $dcdeb51eb739eac7$var$processEndedVercelAiSpan(span) {
    const { data: attributes, origin: origin } = span;
    if (origin !== 'auto.vercelai.otel') return;
    // The Vercel AI SDK sets span status to raw error message strings.
    // Any such value should be normalized to a SpanStatusType value. We pick internal_error as it is the most generic.
    if (span.status && span.status !== 'ok') span.status = 'internal_error';
    $dcdeb51eb739eac7$var$processVercelAiSpanAttributes(attributes);
}
function $dcdeb51eb739eac7$var$processVercelAiStreamedSpan(span) {
    const attributes = span.attributes;
    if (attributes?.[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] !== 'auto.vercelai.otel') return;
    $dcdeb51eb739eac7$var$processVercelAiSpanAttributes(attributes);
    // Look up tool description from the toolDescriptionMap for execute_tool spans
    if (attributes[$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP] === 'gen_ai.execute_tool' && span.parent_span_id) {
        const descriptions = $dPhDf.toolDescriptionMap.get(span.parent_span_id);
        if (descriptions) {
            const toolName = attributes[$fxLy8.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === 'string') {
                const desc = descriptions.get(toolName);
                if (desc) attributes[$fxLy8.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = desc;
            }
        }
    }
    // Clean up tool descriptions when the parent span ends
    $dPhDf.toolDescriptionMap.delete(span.span_id);
}
/**
 * Renames an attribute key in the provided attributes object if the old key exists.
 * This function safely handles null and undefined values.
 */ function $dcdeb51eb739eac7$var$renameAttributeKey(attributes, oldKey, newKey) {
    if (attributes[oldKey] != null) {
        attributes[newKey] = attributes[oldKey];
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete attributes[oldKey];
    }
}
function $dcdeb51eb739eac7$var$processToolCallSpan(span, attributes) {
    span.setAttribute($5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.vercelai.otel');
    span.setAttribute($5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP, 'gen_ai.execute_tool');
    span.setAttribute($fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE, 'execute_tool');
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_TOOL_CALL_NAME_ATTRIBUTE, $fxLy8.GEN_AI_TOOL_NAME_ATTRIBUTE);
    $dcdeb51eb739eac7$var$renameAttributeKey(attributes, $f8l98.AI_TOOL_CALL_ID_ATTRIBUTE, $fxLy8.GEN_AI_TOOL_CALL_ID_ATTRIBUTE);
    // Store the span context in our global map using the tool call ID.
    // This allows us to capture tool errors and link them to the correct span
    // without retaining the full Span object in memory.
    const toolCallId = attributes[$fxLy8.GEN_AI_TOOL_CALL_ID_ATTRIBUTE];
    if (typeof toolCallId === 'string') $dPhDf.toolCallSpanContextMap.set(toolCallId, span.spanContext());
    // https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-tool-type
    if (!attributes[$fxLy8.GEN_AI_TOOL_TYPE_ATTRIBUTE]) span.setAttribute($fxLy8.GEN_AI_TOOL_TYPE_ATTRIBUTE, 'function');
    const toolName = attributes[$fxLy8.GEN_AI_TOOL_NAME_ATTRIBUTE];
    if (toolName) span.updateName(`execute_tool ${toolName}`);
}
function $dcdeb51eb739eac7$var$processGenerateSpan(span, name, attributes, enableTruncation) {
    span.setAttribute($5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, 'auto.vercelai.otel');
    const nameWthoutAi = name.replace('ai.', '');
    span.setAttribute('ai.pipeline.name', nameWthoutAi);
    span.updateName(nameWthoutAi);
    const functionId = attributes[$f8l98.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE];
    if (functionId && typeof functionId === 'string') span.setAttribute('gen_ai.function_id', functionId);
    $9Pp7A.requestMessagesFromPrompt(span, attributes, enableTruncation);
    if (attributes[$f8l98.AI_MODEL_ID_ATTRIBUTE] && !attributes[$fxLy8.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]) span.setAttribute($fxLy8.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, attributes[$f8l98.AI_MODEL_ID_ATTRIBUTE]);
    span.setAttribute('ai.streaming', name.includes('stream'));
    // Set the op based on the operation name registry
    const operationName = $dPhDf.SPAN_TO_OPERATION_NAME.get(name);
    if (operationName) span.setAttribute($5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP, `gen_ai.${operationName}`);
    else if (name.startsWith('ai.stream')) span.setAttribute($5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP, 'ai.run');
    // For invoke_agent pipeline spans, use 'invoke_agent' as the description
    // to be consistent with other AI integrations (e.g. LangGraph)
    if (operationName === 'invoke_agent') {
        if (functionId && typeof functionId === 'string') span.updateName(`invoke_agent ${functionId}`);
        else span.updateName('invoke_agent');
        return;
    }
    const modelId = attributes[$f8l98.AI_MODEL_ID_ATTRIBUTE];
    if (modelId && operationName) span.updateName(`${operationName} ${modelId}`);
    // Store tool descriptions in the toolDescriptionMap so processSpan can apply them to execute_tool spans.
    // This is only needed for span streaming (transaction path handles this separately)
    const client = $9BwS8.getClient();
    if (client && $akELB.hasSpanStreamingEnabled(client) && attributes[$f8l98.AI_PROMPT_TOOLS_ATTRIBUTE] && Array.isArray(attributes[$f8l98.AI_PROMPT_TOOLS_ATTRIBUTE])) {
        const descriptions = new Map();
        // parse tool names and descriptions from tool string array
        for (const toolStr of attributes[$f8l98.AI_PROMPT_TOOLS_ATTRIBUTE])try {
            const parsed = typeof toolStr === 'string' ? JSON.parse(toolStr) : toolStr;
            if (parsed?.name && parsed?.description) descriptions.set(parsed.name, parsed.description);
        } catch  {
        // ignore parse errors
        }
        if (descriptions.size > 0) {
            // Tool call spans are siblings of doGenerate (both children of invoke_agent),
            // so we key by the parent span ID (the invoke_agent span).
            const parentSpanId = $awmvd.spanToJSON(span).parent_span_id;
            if (parentSpanId) $dPhDf.toolDescriptionMap.set(parentSpanId, descriptions);
        }
    }
}
/**
 * Add event processors to the given client to process Vercel AI spans.
 */ function $dcdeb51eb739eac7$var$addVercelAiProcessors(client) {
    client.on('spanStart', $dcdeb51eb739eac7$var$onVercelAiSpanStart);
    // Note: We cannot do this on `spanEnd`, because the span cannot be mutated anymore at this point
    client.addEventProcessor(Object.assign($dcdeb51eb739eac7$var$vercelAiEventProcessor, {
        id: 'VercelAiEventProcessor'
    }));
    client.on('processSpan', (span)=>{
        $dcdeb51eb739eac7$var$processVercelAiStreamedSpan(span);
    });
}
function $dcdeb51eb739eac7$var$addProviderMetadataToAttributes(attributes) {
    const providerMetadata = attributes[$f8l98.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE];
    if (providerMetadata) try {
        const providerMetadataObject = JSON.parse(providerMetadata);
        // Handle OpenAI metadata (v5 uses 'openai', v6 Azure Responses API uses 'azure')
        const openaiMetadata = providerMetadataObject.openai ?? providerMetadataObject.azure;
        if (openaiMetadata) {
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, openaiMetadata.cachedPromptTokens);
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, 'gen_ai.usage.output_tokens.reasoning', openaiMetadata.reasoningTokens);
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, 'gen_ai.usage.output_tokens.prediction_accepted', openaiMetadata.acceptedPredictionTokens);
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, 'gen_ai.usage.output_tokens.prediction_rejected', openaiMetadata.rejectedPredictionTokens);
            if (!attributes['gen_ai.conversation.id']) $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, 'gen_ai.conversation.id', openaiMetadata.responseId);
        }
        if (providerMetadataObject.anthropic) {
            const cachedInputTokens = providerMetadataObject.anthropic.usage?.cache_read_input_tokens ?? providerMetadataObject.anthropic.cacheReadInputTokens;
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, cachedInputTokens);
            const cacheWriteInputTokens = providerMetadataObject.anthropic.usage?.cache_creation_input_tokens ?? providerMetadataObject.anthropic.cacheCreationInputTokens;
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, cacheWriteInputTokens);
        }
        if (providerMetadataObject.bedrock?.usage) {
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheReadInputTokens);
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE, providerMetadataObject.bedrock.usage.cacheWriteInputTokens);
        }
        if (providerMetadataObject.deepseek) {
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE, providerMetadataObject.deepseek.promptCacheHitTokens);
            $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, 'gen_ai.usage.input_tokens.cache_miss', providerMetadataObject.deepseek.promptCacheMissTokens);
        }
    } catch  {
    // Ignore
    }
}
/**
 * Sets an attribute only if the value is not null or undefined.
 */ function $dcdeb51eb739eac7$var$setAttributeIfDefined(attributes, key, value) {
    if (value != null) attributes[key] = value;
}
module.exports.addVercelAiProcessors = $dcdeb51eb739eac7$var$addVercelAiProcessors;
module.exports.processVercelAiSpanAttributes = $dcdeb51eb739eac7$var$processVercelAiSpanAttributes;

});
parcelRegister("jZcA4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $9BwS8 = parcelRequire("9BwS8");

var $akELB = parcelRequire("akELB");

var $8wdL3 = parcelRequire("8wdL3");

var $fxLy8 = parcelRequire("fxLy8");

var $4DVoi = parcelRequire("4DVoi");
/**
 * Shared utils for AI integrations (OpenAI, Anthropic, Verce.AI, etc.)
 */ /**
 * Resolves AI recording options by falling back to the client's `sendDefaultPii` setting.
 * Precedence: explicit option > sendDefaultPii > false
 */ function $e8cd791c687add43$var$resolveAIRecordingOptions(options) {
    const sendDefaultPii = Boolean($9BwS8.getClient()?.getOptions().sendDefaultPii);
    return {
        ...options,
        recordInputs: options?.recordInputs ?? sendDefaultPii,
        recordOutputs: options?.recordOutputs ?? sendDefaultPii
    };
}
/**
 * Resolves whether truncation should be enabled.
 * If the user explicitly set `enableTruncation`, that value is used.
 * Otherwise, truncation is disabled when span streaming is active.
 */ function $e8cd791c687add43$var$shouldEnableTruncation(enableTruncation) {
    const client = $9BwS8.getClient();
    return enableTruncation ?? !(client && $akELB.hasSpanStreamingEnabled(client));
}
/**
 * Build method path from current traversal
 */ function $e8cd791c687add43$var$buildMethodPath(currentPath, prop) {
    return currentPath ? `${currentPath}.${prop}` : prop;
}
/**
 * Set token usage attributes
 * @param span - The span to add attributes to
 * @param promptTokens - The number of prompt tokens
 * @param completionTokens - The number of completion tokens
 * @param cachedInputTokens - The number of cached input tokens
 * @param cachedOutputTokens - The number of cached output tokens
 */ function $e8cd791c687add43$var$setTokenUsageAttributes(span, promptTokens, completionTokens, cachedInputTokens, cachedOutputTokens) {
    if (promptTokens !== undefined) span.setAttributes({
        [$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: promptTokens
    });
    if (completionTokens !== undefined) span.setAttributes({
        [$fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: completionTokens
    });
    if (promptTokens !== undefined || completionTokens !== undefined || cachedInputTokens !== undefined || cachedOutputTokens !== undefined) {
        /**
     * Total input tokens in a request is the summation of `input_tokens`,
     * `cache_creation_input_tokens`, and `cache_read_input_tokens`.
     */ const totalTokens = (promptTokens ?? 0) + (completionTokens ?? 0) + (cachedInputTokens ?? 0) + (cachedOutputTokens ?? 0);
        span.setAttributes({
            [$fxLy8.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: totalTokens
        });
    }
}
/**
 * Ends a streaming span by setting all accumulated response attributes and ending the span.
 * Shared across OpenAI, Anthropic, and Google GenAI streaming implementations.
 */ function $e8cd791c687add43$var$endStreamSpan(span, state, recordOutputs) {
    if (!span.isRecording()) return;
    const attrs = {
        [$fxLy8.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE]: true
    };
    if (state.responseId) attrs[$fxLy8.GEN_AI_RESPONSE_ID_ATTRIBUTE] = state.responseId;
    if (state.responseModel) attrs[$fxLy8.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = state.responseModel;
    if (state.promptTokens !== undefined) attrs[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = state.promptTokens;
    if (state.completionTokens !== undefined) attrs[$fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = state.completionTokens;
    // Use explicit total if provided (OpenAI, Google), otherwise compute from cache tokens (Anthropic)
    if (state.totalTokens !== undefined) attrs[$fxLy8.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = state.totalTokens;
    else if (state.promptTokens !== undefined || state.completionTokens !== undefined || state.cacheCreationInputTokens !== undefined || state.cacheReadInputTokens !== undefined) attrs[$fxLy8.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = (state.promptTokens ?? 0) + (state.completionTokens ?? 0) + (state.cacheCreationInputTokens ?? 0) + (state.cacheReadInputTokens ?? 0);
    if (state.finishReasons.length) attrs[$fxLy8.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(state.finishReasons);
    if (recordOutputs && state.responseTexts.length) attrs[$fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = state.responseTexts.join('');
    if (recordOutputs && state.toolCalls.length) attrs[$fxLy8.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(state.toolCalls);
    span.setAttributes(attrs);
    span.end();
}
/**
 * Serialize a value to a JSON string without truncation.
 * Strings are returned as-is, arrays and objects are JSON-stringified.
 */ function $e8cd791c687add43$var$getJsonString(value) {
    if (typeof value === 'string') return value;
    return JSON.stringify(value);
}
/**
 * Get the truncated JSON string for a string or array of strings.
 *
 * @param value - The string or array of strings to truncate
 * @returns The truncated JSON string
 */ function $e8cd791c687add43$var$getTruncatedJsonString(value) {
    if (typeof value === 'string') // Some values are already JSON strings, so we don't need to duplicate the JSON parsing
    return $4DVoi.truncateGenAiStringInput(value);
    if (Array.isArray(value)) {
        // truncateGenAiMessages returns an array of strings, so we need to stringify it
        const truncatedMessages = $4DVoi.truncateGenAiMessages(value);
        return JSON.stringify(truncatedMessages);
    }
    // value is an object, so we need to stringify it
    return JSON.stringify(value);
}
/**
 * Extract system instructions from messages array.
 * Finds the first system message and formats it according to OpenTelemetry semantic conventions.
 *
 * @param messages - Array of messages to extract system instructions from
 * @returns systemInstructions (JSON string) and filteredMessages (without system message)
 */ function $e8cd791c687add43$var$extractSystemInstructions(messages) {
    if (!Array.isArray(messages)) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemMessageIndex = messages.findIndex((msg)=>msg && typeof msg === 'object' && 'role' in msg && msg.role === 'system');
    if (systemMessageIndex === -1) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemMessage = messages[systemMessageIndex];
    const systemContent = typeof systemMessage.content === 'string' ? systemMessage.content : systemMessage.content !== undefined ? JSON.stringify(systemMessage.content) : undefined;
    if (!systemContent) return {
        systemInstructions: undefined,
        filteredMessages: messages
    };
    const systemInstructions = JSON.stringify([
        {
            type: 'text',
            content: systemContent
        }
    ]);
    const filteredMessages = [
        ...messages.slice(0, systemMessageIndex),
        ...messages.slice(systemMessageIndex + 1)
    ];
    return {
        systemInstructions: systemInstructions,
        filteredMessages: filteredMessages
    };
}
/**
 * Creates a wrapped version of .withResponse() that replaces the data field
 * with the instrumented result while preserving metadata (response, request_id).
 */ async function $e8cd791c687add43$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType) {
    // Attach catch handler to originalWithResponse immediately to prevent unhandled rejection
    // If instrumentedPromise rejects first, we still need this handled
    const safeOriginalWithResponse = originalWithResponse.catch((error)=>{
        $1XEa4.captureException(error, {
            mechanism: {
                handled: false,
                type: mechanismType
            }
        });
        throw error;
    });
    const instrumentedResult = await instrumentedPromise;
    const originalWrapper = await safeOriginalWithResponse;
    // Combine instrumented result with original metadata
    if (originalWrapper && typeof originalWrapper === 'object' && 'data' in originalWrapper) return {
        ...originalWrapper,
        data: instrumentedResult
    };
    return instrumentedResult;
}
/**
 * Wraps a promise-like object to preserve additional methods (like .withResponse())
 * that AI SDK clients (OpenAI, Anthropic) attach to their APIPromise return values.
 *
 * Standard Promise methods (.then, .catch, .finally) are routed to the instrumented
 * promise to preserve Sentry's span instrumentation, while custom SDK methods are
 * forwarded to the original promise to maintain the SDK's API surface.
 */ function $e8cd791c687add43$var$wrapPromiseWithMethods(originalPromiseLike, instrumentedPromise, mechanismType) {
    // If the original result is not thenable, return the instrumented promise
    if (!$8wdL3.isThenable(originalPromiseLike)) return instrumentedPromise;
    // Create a proxy that forwards Promise methods to instrumentedPromise
    // and preserves additional methods from the original result
    return new Proxy(originalPromiseLike, {
        get (target, prop) {
            // For standard Promise methods (.then, .catch, .finally, Symbol.toStringTag),
            // use instrumentedPromise to preserve Sentry instrumentation.
            // For custom methods (like .withResponse()), use the original target.
            const useInstrumentedPromise = prop in Promise.prototype || prop === Symbol.toStringTag;
            const source = useInstrumentedPromise ? instrumentedPromise : target;
            const value = Reflect.get(source, prop);
            // Special handling for .withResponse() to preserve instrumentation
            // .withResponse() returns { data: T, response: Response, request_id: string }
            if (prop === 'withResponse' && typeof value === 'function') return function wrappedWithResponse() {
                const originalWithResponse = value.call(target);
                return $e8cd791c687add43$var$createWithResponseWrapper(originalWithResponse, instrumentedPromise, mechanismType);
            };
            return typeof value === 'function' ? value.bind(source) : value;
        }
    });
}
module.exports.buildMethodPath = $e8cd791c687add43$var$buildMethodPath;
module.exports.endStreamSpan = $e8cd791c687add43$var$endStreamSpan;
module.exports.extractSystemInstructions = $e8cd791c687add43$var$extractSystemInstructions;
module.exports.getJsonString = $e8cd791c687add43$var$getJsonString;
module.exports.getTruncatedJsonString = $e8cd791c687add43$var$getTruncatedJsonString;
module.exports.resolveAIRecordingOptions = $e8cd791c687add43$var$resolveAIRecordingOptions;
module.exports.setTokenUsageAttributes = $e8cd791c687add43$var$setTokenUsageAttributes;
module.exports.shouldEnableTruncation = $e8cd791c687add43$var$shouldEnableTruncation;
module.exports.wrapPromiseWithMethods = $e8cd791c687add43$var$wrapPromiseWithMethods;

});
parcelRegister("fxLy8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * OpenAI Integration Telemetry Attributes
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 */ // =============================================================================
// OPENTELEMETRY SEMANTIC CONVENTIONS FOR GENAI
// =============================================================================
/**
 * The input messages sent to the model
 */ const $b50ed26cf29b35bd$var$GEN_AI_PROMPT_ATTRIBUTE = 'gen_ai.prompt';
/**
 * The Generative AI system being used
 * For OpenAI, this should always be "openai"
 */ const $b50ed26cf29b35bd$var$GEN_AI_SYSTEM_ATTRIBUTE = 'gen_ai.system';
/**
 * The name of the model as requested
 * Examples: "gpt-4", "gpt-3.5-turbo"
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE = 'gen_ai.request.model';
/**
 * Whether streaming was enabled for the request
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE = 'gen_ai.request.stream';
/**
 * The temperature setting for the model request
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = 'gen_ai.request.temperature';
/**
 * The maximum number of tokens requested
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = 'gen_ai.request.max_tokens';
/**
 * The frequency penalty setting for the model request
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = 'gen_ai.request.frequency_penalty';
/**
 * The presence penalty setting for the model request
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = 'gen_ai.request.presence_penalty';
/**
 * The top_p (nucleus sampling) setting for the model request
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE = 'gen_ai.request.top_p';
/**
 * The top_k setting for the model request
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE = 'gen_ai.request.top_k';
/**
 * The encoding format for the model request
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = 'gen_ai.request.encoding_format';
/**
 * The dimensions for the model request
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = 'gen_ai.request.dimensions';
/**
 * Array of reasons why the model stopped generating tokens
 */ const $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = 'gen_ai.response.finish_reasons';
/**
 * The name of the model that generated the response
 */ const $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE = 'gen_ai.response.model';
/**
 * The unique identifier for the response
 */ const $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_ID_ATTRIBUTE = 'gen_ai.response.id';
/**
 * The reason why the model stopped generating tokens
 */ const $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = 'gen_ai.response.stop_reason';
/**
 * The number of tokens used in the prompt
 */ const $b50ed26cf29b35bd$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.input_tokens';
/**
 * The number of tokens used in the response
 */ const $b50ed26cf29b35bd$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.output_tokens';
/**
 * The total number of tokens used (input + output)
 */ const $b50ed26cf29b35bd$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = 'gen_ai.usage.total_tokens';
/**
 * The operation name
 */ const $b50ed26cf29b35bd$var$GEN_AI_OPERATION_NAME_ATTRIBUTE = 'gen_ai.operation.name';
/**
 * Original length of messages array, used to indicate truncations had occured
 */ const $b50ed26cf29b35bd$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = 'sentry.sdk_meta.gen_ai.input.messages.original_length';
/**
 * The prompt messages
 * Only recorded when recordInputs is enabled
 */ const $b50ed26cf29b35bd$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE = 'gen_ai.input.messages';
/**
 * The model's response messages including text and tool calls
 * Only recorded when recordOutputs is enabled
 * Format: stringified array of message objects with role, parts, and finish_reason
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-output-messages
 */ const $b50ed26cf29b35bd$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = 'gen_ai.output.messages';
/**
 * The system instructions extracted from system messages
 * Only recorded when recordInputs is enabled
 * According to OpenTelemetry spec: https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-system-instructions
 */ const $b50ed26cf29b35bd$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = 'gen_ai.system_instructions';
/**
 * The response text
 * Only recorded when recordOutputs is enabled
 */ const $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE = 'gen_ai.response.text';
/**
 * The available tools from incoming request
 * Only recorded when recordInputs is enabled
 */ const $b50ed26cf29b35bd$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = 'gen_ai.request.available_tools';
/**
 * Whether the response is a streaming response
 */ const $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = 'gen_ai.response.streaming';
/**
 * The tool calls from the response
 * Only recorded when recordOutputs is enabled
 */ const $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = 'gen_ai.response.tool_calls';
/**
 * The agent name
 */ const $b50ed26cf29b35bd$var$GEN_AI_AGENT_NAME_ATTRIBUTE = 'gen_ai.agent.name';
/**
 * The pipeline name
 */ const $b50ed26cf29b35bd$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE = 'gen_ai.pipeline.name';
/**
 * The conversation ID for linking messages across API calls
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $b50ed26cf29b35bd$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE = 'gen_ai.conversation.id';
/**
 * The number of cache creation input tokens used
 */ const $b50ed26cf29b35bd$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.cache_creation_input_tokens';
/**
 * The number of cache read input tokens used
 */ const $b50ed26cf29b35bd$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = 'gen_ai.usage.cache_read_input_tokens';
/**
 * The number of cache write input tokens used
 */ const $b50ed26cf29b35bd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = 'gen_ai.usage.input_tokens.cache_write';
/**
 * The number of cached input tokens that were used
 */ const $b50ed26cf29b35bd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = 'gen_ai.usage.input_tokens.cached';
/**
 * The span operation name for invoking an agent
 */ const $b50ed26cf29b35bd$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = 'gen_ai.invoke_agent';
/**
 * The embeddings input
 * Only recorded when recordInputs is enabled
 */ const $b50ed26cf29b35bd$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = 'gen_ai.embeddings.input';
/**
 * The span operation for embeddings
 */ const $b50ed26cf29b35bd$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = 'gen_ai.embeddings';
/**
 * The span operation name for executing a tool
 */ const $b50ed26cf29b35bd$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = 'gen_ai.execute_tool';
/**
 * The tool name for tool call spans
 */ const $b50ed26cf29b35bd$var$GEN_AI_TOOL_NAME_ATTRIBUTE = 'gen_ai.tool.name';
/**
 * The tool call ID
 */ const $b50ed26cf29b35bd$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE = 'gen_ai.tool.call.id';
/**
 * The tool type (e.g., 'function')
 */ const $b50ed26cf29b35bd$var$GEN_AI_TOOL_TYPE_ATTRIBUTE = 'gen_ai.tool.type';
/**
 * The tool input/arguments
 */ const $b50ed26cf29b35bd$var$GEN_AI_TOOL_INPUT_ATTRIBUTE = 'gen_ai.tool.input';
/**
 * The tool output/result
 */ const $b50ed26cf29b35bd$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE = 'gen_ai.tool.output';
/**
 * The description of the tool being used
 * @see https://opentelemetry.io/docs/specs/semconv/registry/attributes/gen-ai/#gen-ai-tool-description
 */ const $b50ed26cf29b35bd$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = 'gen_ai.tool.description';
module.exports.GEN_AI_AGENT_NAME_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_AGENT_NAME_ATTRIBUTE;
module.exports.GEN_AI_CONVERSATION_ID_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_CONVERSATION_ID_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE;
module.exports.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_INPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE;
module.exports.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE;
module.exports.GEN_AI_OPERATION_NAME_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_OPERATION_NAME_ATTRIBUTE;
module.exports.GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_OUTPUT_MESSAGES_ATTRIBUTE;
module.exports.GEN_AI_PIPELINE_NAME_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_PIPELINE_NAME_ATTRIBUTE;
module.exports.GEN_AI_PROMPT_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_PROMPT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_MODEL_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_MODEL_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_STREAM_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_STREAM_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_K_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_TOP_K_ATTRIBUTE;
module.exports.GEN_AI_REQUEST_TOP_P_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_REQUEST_TOP_P_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_ID_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_ID_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_MODEL_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_MODEL_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_STREAMING_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_STREAMING_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TEXT_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_SYSTEM_ATTRIBUTE;
module.exports.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE;
module.exports.GEN_AI_TOOL_CALL_ID_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE;
module.exports.GEN_AI_TOOL_INPUT_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_TOOL_INPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_NAME_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_TOOL_NAME_ATTRIBUTE;
module.exports.GEN_AI_TOOL_OUTPUT_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_TOOL_OUTPUT_ATTRIBUTE;
module.exports.GEN_AI_TOOL_TYPE_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_TOOL_TYPE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHED_ATTRIBUTE;
module.exports.GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_USAGE_INPUT_TOKENS_CACHE_WRITE_ATTRIBUTE;
module.exports.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE;
module.exports.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE = $b50ed26cf29b35bd$var$GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE;

});

parcelRegister("4DVoi", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $gGt5m = parcelRequire("gGt5m");
/**
 * Default maximum size in bytes for GenAI messages.
 * Messages exceeding this limit will be truncated.
 */ const $36175297be6ecf9a$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = 20000;
/**
 * Message format used by OpenAI and Anthropic APIs.
 */ /**
 * Calculate the UTF-8 byte length of a string.
 */ const $36175297be6ecf9a$var$utf8Bytes = (text)=>{
    return new TextEncoder().encode(text).length;
};
/**
 * Calculate the UTF-8 byte length of a value's JSON representation.
 */ const $36175297be6ecf9a$var$jsonBytes = (value)=>{
    return $36175297be6ecf9a$var$utf8Bytes(JSON.stringify(value));
};
/**
 * Truncate a string to fit within maxBytes (inclusive) when encoded as UTF-8.
 * Uses binary search for efficiency with multi-byte characters.
 *
 * @param text - The string to truncate
 * @param maxBytes - Maximum byte length (inclusive, UTF-8 encoded)
 * @returns Truncated string whose UTF-8 byte length is at most maxBytes
 */ function $36175297be6ecf9a$var$truncateTextByBytes(text, maxBytes) {
    if ($36175297be6ecf9a$var$utf8Bytes(text) <= maxBytes) return text;
    let low = 0;
    let high = text.length;
    let bestFit = '';
    while(low <= high){
        const mid = Math.floor((low + high) / 2);
        const candidate = text.slice(0, mid);
        const byteSize = $36175297be6ecf9a$var$utf8Bytes(candidate);
        if (byteSize <= maxBytes) {
            bestFit = candidate;
            low = mid + 1;
        } else high = mid - 1;
    }
    return bestFit;
}
/**
 * Extract text content from a message item.
 * Handles plain strings and objects with a text property.
 *
 * @returns The text content
 */ function $36175297be6ecf9a$var$getItemText(item) {
    if (typeof item === 'string') return item;
    if ('text' in item && typeof item.text === 'string') return item.text;
    return '';
}
/**
 * Create a new item with updated text content while preserving the original structure.
 *
 * @param item - Original item (string or object)
 * @param text - New text content
 * @returns New item with updated text
 */ function $36175297be6ecf9a$var$withItemText(item, text) {
    if (typeof item === 'string') return text;
    return {
        ...item,
        text: text
    };
}
/**
 * Check if a message has the OpenAI/Anthropic content format.
 */ function $36175297be6ecf9a$var$isContentMessage(message) {
    return message !== null && typeof message === 'object' && 'content' in message && typeof message.content === 'string';
}
/**
 * Check if a message has the OpenAI/Anthropic content array format.
 */ function $36175297be6ecf9a$var$isContentArrayMessage(message) {
    return message !== null && typeof message === 'object' && 'content' in message && Array.isArray(message.content);
}
/**
 * Check if a message has the Google GenAI parts format.
 */ function $36175297be6ecf9a$var$isPartsMessage(message) {
    return message !== null && typeof message === 'object' && 'parts' in message && Array.isArray(message.parts) && message.parts.length > 0;
}
/**
 * Truncate a message with `content: string` format (OpenAI/Anthropic).
 *
 * @param message - Message with content property
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function $36175297be6ecf9a$var$truncateContentMessage(message, maxBytes) {
    // Calculate overhead (message structure without content)
    const emptyMessage = {
        ...message,
        content: ''
    };
    const overhead = $36175297be6ecf9a$var$jsonBytes(emptyMessage);
    const availableForContent = maxBytes - overhead;
    if (availableForContent <= 0) return [];
    const truncatedContent = $36175297be6ecf9a$var$truncateTextByBytes(message.content, availableForContent);
    return [
        {
            ...message,
            content: truncatedContent
        }
    ];
}
/**
 * Extracts the array items and their key from an array-based message.
 * Returns `null` key if neither `parts` nor `content` is a valid array.
 */ function $36175297be6ecf9a$var$getArrayItems(message) {
    if ('parts' in message && Array.isArray(message.parts)) return {
        key: 'parts',
        items: message.parts
    };
    if ('content' in message && Array.isArray(message.content)) return {
        key: 'content',
        items: message.content
    };
    return {
        key: null,
        items: []
    };
}
/**
 * Truncate a message with an array-based format.
 * Handles both `parts: [...]` (Google GenAI) and `content: [...]` (OpenAI/Anthropic multimodal).
 * Keeps as many complete items as possible, only truncating the first item if needed.
 *
 * @param message - Message with parts or content array
 * @param maxBytes - Maximum byte limit
 * @returns Array with truncated message, or empty array if it doesn't fit
 */ function $36175297be6ecf9a$var$truncateArrayMessage(message, maxBytes) {
    const { key: key, items: items } = $36175297be6ecf9a$var$getArrayItems(message);
    if (key === null || items.length === 0) return [];
    // Calculate overhead by creating empty text items
    const emptyItems = items.map((item)=>$36175297be6ecf9a$var$withItemText(item, ''));
    const overhead = $36175297be6ecf9a$var$jsonBytes({
        ...message,
        [key]: emptyItems
    });
    let remainingBytes = maxBytes - overhead;
    if (remainingBytes <= 0) return [];
    // Include items until we run out of space
    const includedItems = [];
    for (const item of items){
        const text = $36175297be6ecf9a$var$getItemText(item);
        const textSize = $36175297be6ecf9a$var$utf8Bytes(text);
        if (textSize <= remainingBytes) {
            // Item fits: include it as-is
            includedItems.push(item);
            remainingBytes -= textSize;
        } else if (includedItems.length === 0) {
            // First item doesn't fit: truncate it
            const truncated = $36175297be6ecf9a$var$truncateTextByBytes(text, remainingBytes);
            if (truncated) includedItems.push($36175297be6ecf9a$var$withItemText(item, truncated));
            break;
        } else break;
    }
    /* c8 ignore start
   * for type safety only, algorithm guarantees SOME text included */ if (includedItems.length <= 0) return [];
    else /* c8 ignore stop */ return [
        {
            ...message,
            [key]: includedItems
        }
    ];
}
/**
 * Truncate a single message to fit within maxBytes.
 *
 * Supports three message formats:
 * - OpenAI/Anthropic: `{ ..., content: string }`
 * - Vercel AI/OpenAI multimodal: `{ ..., content: Array<{type, text?, ...}> }`
 * - Google GenAI: `{ ..., parts: Array<string | {text: string} | non-text> }`
 *
 * @param message - The message to truncate
 * @param maxBytes - Maximum byte limit for the message
 * @returns Array containing the truncated message, or empty array if truncation fails
 */ function $36175297be6ecf9a$var$truncateSingleMessage(message, maxBytes) {
    if (!message) return [];
    // Handle plain strings (e.g., embeddings input)
    if (typeof message === 'string') {
        const truncated = $36175297be6ecf9a$var$truncateTextByBytes(message, maxBytes);
        return truncated ? [
            truncated
        ] : [];
    }
    if (typeof message !== 'object') return [];
    if ($36175297be6ecf9a$var$isContentMessage(message)) return $36175297be6ecf9a$var$truncateContentMessage(message, maxBytes);
    if ($36175297be6ecf9a$var$isContentArrayMessage(message) || $36175297be6ecf9a$var$isPartsMessage(message)) return $36175297be6ecf9a$var$truncateArrayMessage(message, maxBytes);
    // Unknown message format: cannot truncate safely
    return [];
}
/**
 * Strip the inline media from message arrays.
 *
 * This returns a stripped message. We do NOT want to mutate the data in place,
 * because of course we still want the actual API/client to handle the media.
 */ function $36175297be6ecf9a$var$stripInlineMediaFromMessages(messages) {
    const stripped = messages.map((message)=>{
        let newMessage = undefined;
        if (!!message && typeof message === 'object') {
            if ($36175297be6ecf9a$var$isContentArrayMessage(message)) newMessage = {
                ...message,
                content: $36175297be6ecf9a$var$stripInlineMediaFromMessages(message.content)
            };
            else if ('content' in message && $gGt5m.isContentMedia(message.content)) newMessage = {
                ...message,
                content: $gGt5m.stripInlineMediaFromSingleMessage(message.content)
            };
            if ($36175297be6ecf9a$var$isPartsMessage(message)) newMessage = {
                // might have to strip content AND parts
                ...newMessage ?? message,
                parts: $36175297be6ecf9a$var$stripInlineMediaFromMessages(message.parts)
            };
            if ($gGt5m.isContentMedia(newMessage)) newMessage = $gGt5m.stripInlineMediaFromSingleMessage(newMessage);
            else if ($gGt5m.isContentMedia(message)) newMessage = $gGt5m.stripInlineMediaFromSingleMessage(message);
        }
        return newMessage ?? message;
    });
    return stripped;
}
/**
 * Truncate an array of messages to fit within a byte limit.
 *
 * Strategy:
 * - Always keeps only the last (newest) message
 * - Strips inline media from the message
 * - Truncates the message content if it exceeds the byte limit
 *
 * @param messages - Array of messages to truncate
 * @param maxBytes - Maximum total byte limit for the message
 * @returns Array containing only the last message (possibly truncated)
 *
 * @example
 * ```ts
 * const messages = [msg1, msg2, msg3, msg4]; // newest is msg4
 * const truncated = truncateMessagesByBytes(messages, 10000);
 * // Returns [msg4] (truncated if needed)
 * ```
 */ function $36175297be6ecf9a$var$truncateMessagesByBytes(messages, maxBytes) {
    // Early return for empty or invalid input
    if (!Array.isArray(messages) || messages.length === 0) return messages;
    // The result is always a single-element array that callers wrap with
    // JSON.stringify([message]), so subtract the 2-byte array wrapper ("["  and "]")
    // to ensure the final serialized value stays under the limit.
    const effectiveMaxBytes = maxBytes - 2;
    // Always keep only the last message
    const lastMessage = messages[messages.length - 1];
    // Strip inline media from the single message
    const stripped = $36175297be6ecf9a$var$stripInlineMediaFromMessages([
        lastMessage
    ]);
    const strippedMessage = stripped[0];
    // Check if it fits
    const messageBytes = $36175297be6ecf9a$var$jsonBytes(strippedMessage);
    if (messageBytes <= effectiveMaxBytes) return stripped;
    // Truncate the single message if needed
    return $36175297be6ecf9a$var$truncateSingleMessage(strippedMessage, effectiveMaxBytes);
}
/**
 * Truncate GenAI messages using the default byte limit.
 *
 * Convenience wrapper around `truncateMessagesByBytes` with the default limit.
 *
 * @param messages - Array of messages to truncate
 * @returns Truncated array of messages
 */ function $36175297be6ecf9a$var$truncateGenAiMessages(messages) {
    return $36175297be6ecf9a$var$truncateMessagesByBytes(messages, $36175297be6ecf9a$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
/**
 * Truncate GenAI string input using the default byte limit.
 *
 * @param input - The string to truncate
 * @returns Truncated string
 */ function $36175297be6ecf9a$var$truncateGenAiStringInput(input) {
    return $36175297be6ecf9a$var$truncateTextByBytes(input, $36175297be6ecf9a$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT);
}
module.exports.DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT = $36175297be6ecf9a$var$DEFAULT_GEN_AI_MESSAGES_BYTE_LIMIT;
module.exports.truncateGenAiMessages = $36175297be6ecf9a$var$truncateGenAiMessages;
module.exports.truncateGenAiStringInput = $36175297be6ecf9a$var$truncateGenAiStringInput;

});
parcelRegister("gGt5m", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Inline media content source, with a potentially very large base64
 * blob or data: uri.
 */ /**
 * Check if a content part is an OpenAI/Anthropic media source
 */ function $c2572155bfc48925$var$isContentMedia(part) {
    if (!part || typeof part !== 'object') return false;
    return $c2572155bfc48925$var$isContentMediaSource(part) || $c2572155bfc48925$var$hasInlineData(part) || $c2572155bfc48925$var$hasImageUrl(part) || $c2572155bfc48925$var$hasInputAudio(part) || $c2572155bfc48925$var$hasFileData(part) || $c2572155bfc48925$var$hasMediaTypeData(part) || $c2572155bfc48925$var$hasVercelFileData(part) || $c2572155bfc48925$var$hasVercelImageData(part) || $c2572155bfc48925$var$hasBlobOrBase64Type(part) || $c2572155bfc48925$var$hasB64Json(part) || $c2572155bfc48925$var$hasImageGenerationResult(part) || $c2572155bfc48925$var$hasDataUri(part);
}
function $c2572155bfc48925$var$hasImageUrl(part) {
    if (!('image_url' in part)) return false;
    if (typeof part.image_url === 'string') return part.image_url.startsWith('data:');
    return $c2572155bfc48925$var$hasNestedImageUrl(part);
}
function $c2572155bfc48925$var$hasNestedImageUrl(part) {
    return 'image_url' in part && !!part.image_url && typeof part.image_url === 'object' && 'url' in part.image_url && typeof part.image_url.url === 'string' && part.image_url.url.startsWith('data:');
}
function $c2572155bfc48925$var$isContentMediaSource(part) {
    return 'type' in part && typeof part.type === 'string' && 'source' in part && $c2572155bfc48925$var$isContentMedia(part.source);
}
function $c2572155bfc48925$var$hasInlineData(part) {
    return 'inlineData' in part && !!part.inlineData && typeof part.inlineData === 'object' && 'data' in part.inlineData && typeof part.inlineData.data === 'string';
}
function $c2572155bfc48925$var$hasInputAudio(part) {
    return 'type' in part && part.type === 'input_audio' && 'input_audio' in part && !!part.input_audio && typeof part.input_audio === 'object' && 'data' in part.input_audio && typeof part.input_audio.data === 'string';
}
function $c2572155bfc48925$var$hasFileData(part) {
    return 'type' in part && part.type === 'file' && 'file' in part && !!part.file && typeof part.file === 'object' && 'file_data' in part.file && typeof part.file.file_data === 'string';
}
function $c2572155bfc48925$var$hasMediaTypeData(part) {
    return 'media_type' in part && typeof part.media_type === 'string' && 'data' in part;
}
/**
 * Check for Vercel AI SDK file format: { type: "file", mediaType: "...", data: "..." }
 * Only matches base64/binary data, not HTTP/HTTPS URLs (which should be preserved).
 */ function $c2572155bfc48925$var$hasVercelFileData(part) {
    return 'type' in part && part.type === 'file' && 'mediaType' in part && typeof part.mediaType === 'string' && 'data' in part && typeof part.data === 'string' && // Only strip base64/binary data, not HTTP/HTTPS URLs which should be preserved as references
    !part.data.startsWith('http://') && !part.data.startsWith('https://');
}
/**
 * Check for Vercel AI SDK image format: { type: "image", image: "base64...", mimeType?: "..." }
 * Only matches base64/data URIs, not HTTP/HTTPS URLs (which should be preserved).
 * Note: mimeType is optional in Vercel AI SDK image parts.
 */ function $c2572155bfc48925$var$hasVercelImageData(part) {
    return 'type' in part && part.type === 'image' && 'image' in part && typeof part.image === 'string' && // Only strip base64/data URIs, not HTTP/HTTPS URLs which should be preserved as references
    !part.image.startsWith('http://') && !part.image.startsWith('https://');
}
function $c2572155bfc48925$var$hasBlobOrBase64Type(part) {
    return 'type' in part && (part.type === 'blob' || part.type === 'base64');
}
function $c2572155bfc48925$var$hasB64Json(part) {
    return 'b64_json' in part;
}
function $c2572155bfc48925$var$hasImageGenerationResult(part) {
    return 'type' in part && 'result' in part && part.type === 'image_generation';
}
function $c2572155bfc48925$var$hasDataUri(part) {
    return 'uri' in part && typeof part.uri === 'string' && part.uri.startsWith('data:');
}
const $c2572155bfc48925$var$REMOVED_STRING = '[Blob substitute]';
const $c2572155bfc48925$var$MEDIA_FIELDS = [
    'image_url',
    'data',
    'content',
    'b64_json',
    'result',
    'uri',
    'image'
];
/**
 * Replace inline binary data in a single media content part with a placeholder.
 */ function $c2572155bfc48925$var$stripInlineMediaFromSingleMessage(part) {
    const strip = {
        ...part
    };
    if ($c2572155bfc48925$var$isContentMedia(strip.source)) strip.source = $c2572155bfc48925$var$stripInlineMediaFromSingleMessage(strip.source);
    if ($c2572155bfc48925$var$hasInlineData(part)) strip.inlineData = {
        ...part.inlineData,
        data: $c2572155bfc48925$var$REMOVED_STRING
    };
    if ($c2572155bfc48925$var$hasNestedImageUrl(part)) strip.image_url = {
        ...part.image_url,
        url: $c2572155bfc48925$var$REMOVED_STRING
    };
    if ($c2572155bfc48925$var$hasInputAudio(part)) strip.input_audio = {
        ...part.input_audio,
        data: $c2572155bfc48925$var$REMOVED_STRING
    };
    if ($c2572155bfc48925$var$hasFileData(part)) strip.file = {
        ...part.file,
        file_data: $c2572155bfc48925$var$REMOVED_STRING
    };
    for (const field of $c2572155bfc48925$var$MEDIA_FIELDS)if (typeof strip[field] === 'string') strip[field] = $c2572155bfc48925$var$REMOVED_STRING;
    return strip;
}
module.exports.isContentMedia = $c2572155bfc48925$var$isContentMedia;
module.exports.stripInlineMediaFromSingleMessage = $c2572155bfc48925$var$stripInlineMediaFromSingleMessage;

});



parcelRegister("dPhDf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Global map to track tool call IDs to their corresponding span contexts.
// This allows us to capture tool errors and link them to the correct span
// without keeping full Span objects (and their potentially large attributes) alive.
const $a10db7256f20b543$var$toolCallSpanContextMap = new Map();
// Used to make tool descriptions available to execute_tool spans in the span streaming path.
// Streamed spans are processed individually, so execute_tool spans cannot look up descriptions
// from their sibling doGenerate span on span end (as we do for transactions).
// Instead we store descriptions at spanStart and apply them in the processSpan hook.
// Stores parent_span_id -> Map<toolName, description>
const $a10db7256f20b543$var$toolDescriptionMap = new Map();
/** Maps Vercel AI span names to standardized OpenTelemetry operation names. */ const $a10db7256f20b543$var$SPAN_TO_OPERATION_NAME = new Map([
    [
        'ai.generateText',
        'invoke_agent'
    ],
    [
        'ai.streamText',
        'invoke_agent'
    ],
    [
        'ai.generateObject',
        'invoke_agent'
    ],
    [
        'ai.streamObject',
        'invoke_agent'
    ],
    [
        'ai.generateText.doGenerate',
        'generate_content'
    ],
    [
        'ai.streamText.doStream',
        'generate_content'
    ],
    [
        'ai.generateObject.doGenerate',
        'generate_content'
    ],
    [
        'ai.streamObject.doStream',
        'generate_content'
    ],
    [
        'ai.embed.doEmbed',
        'embeddings'
    ],
    [
        'ai.embedMany.doEmbed',
        'embeddings'
    ],
    [
        'ai.rerank.doRerank',
        'rerank'
    ],
    [
        'ai.toolCall',
        'execute_tool'
    ]
]);
module.exports.SPAN_TO_OPERATION_NAME = $a10db7256f20b543$var$SPAN_TO_OPERATION_NAME;
module.exports.toolCallSpanContextMap = $a10db7256f20b543$var$toolCallSpanContextMap;
module.exports.toolDescriptionMap = $a10db7256f20b543$var$toolDescriptionMap;

});

parcelRegister("9Pp7A", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fxLy8 = parcelRequire("fxLy8");

var $jZcA4 = parcelRequire("jZcA4");

var $dPhDf = parcelRequire("dPhDf");

var $f8l98 = parcelRequire("f8l98");
/**
 * Accumulates token data from a span to its parent in the token accumulator map.
 * This function extracts token usage from the current span and adds it to the
 * accumulated totals for its parent span.
 */ function $727c5d0ed1ae4d64$var$accumulateTokensForParent(span, tokenAccumulator) {
    const parentSpanId = span.parent_span_id;
    if (!parentSpanId) return;
    const inputTokens = span.data[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE];
    const outputTokens = span.data[$fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE];
    if (typeof inputTokens === 'number' || typeof outputTokens === 'number') {
        const existing = tokenAccumulator.get(parentSpanId) || {
            inputTokens: 0,
            outputTokens: 0
        };
        if (typeof inputTokens === 'number') existing.inputTokens += inputTokens;
        if (typeof outputTokens === 'number') existing.outputTokens += outputTokens;
        tokenAccumulator.set(parentSpanId, existing);
    }
}
/**
 * Applies accumulated token data to the `gen_ai.invoke_agent` span.
 * Only immediate children of the `gen_ai.invoke_agent` span are considered,
 * since aggregation will automatically occur for each parent span.
 */ function $727c5d0ed1ae4d64$var$applyAccumulatedTokens(spanOrTrace, tokenAccumulator) {
    const accumulated = tokenAccumulator.get(spanOrTrace.span_id);
    if (!accumulated || !spanOrTrace.data) return;
    if (accumulated.inputTokens > 0) spanOrTrace.data[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = accumulated.inputTokens;
    if (accumulated.outputTokens > 0) spanOrTrace.data[$fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = accumulated.outputTokens;
    if (accumulated.inputTokens > 0 || accumulated.outputTokens > 0) spanOrTrace.data['gen_ai.usage.total_tokens'] = accumulated.inputTokens + accumulated.outputTokens;
}
/**
 * Builds a map of tool name -> description from all spans with available_tools.
 * This avoids O(n²) iteration and repeated JSON parsing.
 */ function $727c5d0ed1ae4d64$var$buildToolDescriptionMap(spans) {
    const toolDescriptions = new Map();
    for (const span of spans){
        const availableTools = span.data[$fxLy8.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE];
        if (typeof availableTools !== 'string') continue;
        try {
            const tools = JSON.parse(availableTools);
            for (const tool of tools)if (tool.name && tool.description && !toolDescriptions.has(tool.name)) toolDescriptions.set(tool.name, tool.description);
        } catch  {
        // ignore parse errors
        }
    }
    return toolDescriptions;
}
/**
 * Applies tool descriptions and accumulated tokens to spans in a single pass.
 *
 * - For `gen_ai.execute_tool` spans: looks up tool description from
 *   `gen_ai.request.available_tools` on sibling spans
 * - For `gen_ai.invoke_agent` spans: applies accumulated token data from children
 */ function $727c5d0ed1ae4d64$var$applyToolDescriptionsAndTokens(spans, tokenAccumulator) {
    // Build lookup map once to avoid O(n²) iteration and repeated JSON parsing
    const toolDescriptions = $727c5d0ed1ae4d64$var$buildToolDescriptionMap(spans);
    for (const span of spans){
        if (span.op === 'gen_ai.execute_tool') {
            const toolName = span.data[$fxLy8.GEN_AI_TOOL_NAME_ATTRIBUTE];
            if (typeof toolName === 'string') {
                const description = toolDescriptions.get(toolName);
                if (description) span.data[$fxLy8.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = description;
            }
        }
        if (span.op === 'gen_ai.invoke_agent') $727c5d0ed1ae4d64$var$applyAccumulatedTokens(span, tokenAccumulator);
    }
}
/**
 * Get the span context associated with a tool call ID.
 */ function $727c5d0ed1ae4d64$var$_INTERNAL_getSpanContextForToolCallId(toolCallId) {
    return $dPhDf.toolCallSpanContextMap.get(toolCallId);
}
/**
 * Clean up the span mapping for a tool call ID
 */ function $727c5d0ed1ae4d64$var$_INTERNAL_cleanupToolCallSpanContext(toolCallId) {
    $dPhDf.toolCallSpanContextMap.delete(toolCallId);
}
/**
 * Convert an array of tool strings to a JSON string
 */ function $727c5d0ed1ae4d64$var$convertAvailableToolsToJsonString(tools) {
    const toolObjects = tools.map((tool)=>{
        if (typeof tool === 'string') try {
            return JSON.parse(tool);
        } catch  {
            return tool;
        }
        return tool;
    });
    return JSON.stringify(toolObjects);
}
/**
 * Filter out invalid entries in messages array
 * @param input - The input array to filter
 * @returns The filtered array
 */ function $727c5d0ed1ae4d64$var$filterMessagesArray(input) {
    return input.filter((m)=>!!m && typeof m === 'object' && 'role' in m && 'content' in m);
}
/**
 * Normalize the user input (stringified object with prompt, system, messages) to messages array
 */ function $727c5d0ed1ae4d64$var$convertUserInputToMessagesFormat(userInput) {
    try {
        const p = JSON.parse(userInput);
        if (!!p && typeof p === 'object') {
            let { messages: messages } = p;
            const { prompt: prompt, system: system } = p;
            const result = [];
            // prepend top-level system instruction if present
            if (typeof system === 'string') result.push({
                role: 'system',
                content: system
            });
            // stringified messages array
            if (typeof messages === 'string') try {
                messages = JSON.parse(messages);
            } catch  {
            // ignore parse errors
            }
            // messages array format: { messages: [...] }
            if (Array.isArray(messages)) {
                result.push(...$727c5d0ed1ae4d64$var$filterMessagesArray(messages));
                return result;
            }
            // prompt array format: { prompt: [...] }
            if (Array.isArray(prompt)) {
                result.push(...$727c5d0ed1ae4d64$var$filterMessagesArray(prompt));
                return result;
            }
            // prompt string format: { prompt: "..." }
            if (typeof prompt === 'string') result.push({
                role: 'user',
                content: prompt
            });
            if (result.length > 0) return result;
        }
    // eslint-disable-next-line no-empty
    } catch  {}
    return [];
}
/**
 * Generate a request.messages JSON array from the prompt field in the
 * invoke_agent op
 */ function $727c5d0ed1ae4d64$var$requestMessagesFromPrompt(span, attributes, enableTruncation) {
    if (typeof attributes[$f8l98.AI_PROMPT_ATTRIBUTE] === 'string' && !attributes[$fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE] && !attributes[$f8l98.AI_PROMPT_MESSAGES_ATTRIBUTE]) {
        // No messages array is present, so we need to convert the prompt to the proper messages format
        // This is the case for ai.generateText spans
        // The ai.prompt attribute is a stringified object with prompt, system, messages attributes
        // The format of these is described in the vercel docs, for instance: https://ai-sdk.dev/docs/reference/ai-sdk-core/stream-object#parameters
        const userInput = attributes[$f8l98.AI_PROMPT_ATTRIBUTE];
        const messages = $727c5d0ed1ae4d64$var$convertUserInputToMessagesFormat(userInput);
        if (messages.length) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $jZcA4.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($fxLy8.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $jZcA4.getTruncatedJsonString(filteredMessages) : $jZcA4.getJsonString(filteredMessages);
            span.setAttributes({
                [$f8l98.AI_PROMPT_ATTRIBUTE]: messagesJson,
                [$fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$fxLy8.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    } else if (typeof attributes[$f8l98.AI_PROMPT_MESSAGES_ATTRIBUTE] === 'string') // In this case we already get a properly formatted messages array, this is the preferred way to get the messages
    // This is the case for ai.generateText.doGenerate spans
    try {
        const messages = JSON.parse(attributes[$f8l98.AI_PROMPT_MESSAGES_ATTRIBUTE]);
        if (Array.isArray(messages)) {
            const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $jZcA4.extractSystemInstructions(messages);
            if (systemInstructions) span.setAttribute($fxLy8.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
            const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
            const messagesJson = enableTruncation ? $jZcA4.getTruncatedJsonString(filteredMessages) : $jZcA4.getJsonString(filteredMessages);
            span.setAttributes({
                [$f8l98.AI_PROMPT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: messagesJson,
                [$fxLy8.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
            });
        }
    // eslint-disable-next-line no-empty
    } catch  {}
}
module.exports._INTERNAL_cleanupToolCallSpanContext = $727c5d0ed1ae4d64$var$_INTERNAL_cleanupToolCallSpanContext;
module.exports._INTERNAL_getSpanContextForToolCallId = $727c5d0ed1ae4d64$var$_INTERNAL_getSpanContextForToolCallId;
module.exports.accumulateTokensForParent = $727c5d0ed1ae4d64$var$accumulateTokensForParent;
module.exports.applyAccumulatedTokens = $727c5d0ed1ae4d64$var$applyAccumulatedTokens;
module.exports.applyToolDescriptionsAndTokens = $727c5d0ed1ae4d64$var$applyToolDescriptionsAndTokens;
module.exports.convertAvailableToolsToJsonString = $727c5d0ed1ae4d64$var$convertAvailableToolsToJsonString;
module.exports.convertUserInputToMessagesFormat = $727c5d0ed1ae4d64$var$convertUserInputToMessagesFormat;
module.exports.requestMessagesFromPrompt = $727c5d0ed1ae4d64$var$requestMessagesFromPrompt;

});
parcelRegister("f8l98", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * AI SDK Telemetry Attributes
 * Based on https://ai-sdk.dev/docs/ai-sdk-core/telemetry#collected-data
 */ // =============================================================================
// COMMON ATTRIBUTES
// =============================================================================
/**
 * Common attribute for operation name across all functions and spans
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#collected-data
 */ const $b048019508614e47$var$OPERATION_NAME_ATTRIBUTE = 'operation.name';
/**
 * Common attribute for AI operation ID across all functions and spans
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#collected-data
 */ const $b048019508614e47$var$AI_OPERATION_ID_ATTRIBUTE = 'ai.operationId';
// =============================================================================
// SHARED ATTRIBUTES
// =============================================================================
/**
 * `generateText` function - `ai.generateText` span
 * `streamText` function - `ai.streamText` span
 *
 * The prompt that was used when calling the function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#streamtext-function
 */ const $b048019508614e47$var$AI_PROMPT_ATTRIBUTE = 'ai.prompt';
/**
 * `generateObject` function - `ai.generateObject` span
 * `streamObject` function - `ai.streamObject` span
 *
 * The JSON schema version of the schema that was passed into the function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generateobject-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#streamobject-function
 */ const $b048019508614e47$var$AI_SCHEMA_ATTRIBUTE = 'ai.schema';
/**
 * `generateObject` function - `ai.generateObject` span
 * `streamObject` function - `ai.streamObject` span
 *
 * The object that was generated (stringified JSON)
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generateobject-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#streamobject-function
 */ const $b048019508614e47$var$AI_RESPONSE_OBJECT_ATTRIBUTE = 'ai.response.object';
/**
 * `embed` function - `ai.embed.doEmbed` span
 * `embedMany` function - `ai.embedMany` span
 *
 * The values that were passed into the function (array)
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#embed-function
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#embedmany-function
 */ const $b048019508614e47$var$AI_VALUES_ATTRIBUTE = 'ai.values';
// =============================================================================
// GENERATETEXT FUNCTION - UNIQUE ATTRIBUTES
// =============================================================================
/**
 * `generateText` function - `ai.generateText` span
 *
 * The text that was generated
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $b048019508614e47$var$AI_RESPONSE_TEXT_ATTRIBUTE = 'ai.response.text';
/**
 * `generateText` function - `ai.generateText` span
 *
 * The tool calls that were made as part of the generation (stringified JSON)
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $b048019508614e47$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = 'ai.response.toolCalls';
/**
 * `generateText` function - `ai.generateText` span
 *
 * The reason why the generation finished
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $b048019508614e47$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE = 'ai.response.finishReason';
/**
 * `generateText` function - `ai.generateText.doGenerate` span
 *
 * The messages that were passed into the provider
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $b048019508614e47$var$AI_PROMPT_MESSAGES_ATTRIBUTE = 'ai.prompt.messages';
/**
 * `generateText` function - `ai.generateText.doGenerate` span
 *
 * Array of stringified tool definitions
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#generatetext-function
 */ const $b048019508614e47$var$AI_PROMPT_TOOLS_ATTRIBUTE = 'ai.prompt.tools';
// =============================================================================
// BASIC LLM SPAN INFORMATION
// =============================================================================
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The id of the model
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $b048019508614e47$var$AI_MODEL_ID_ATTRIBUTE = 'ai.model.id';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * Provider specific metadata returned with the generation response
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $b048019508614e47$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = 'ai.response.providerMetadata';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The number of cached input tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $b048019508614e47$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = 'ai.usage.cachedInputTokens';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The functionId that was set through `telemetry.functionId`
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $b048019508614e47$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = 'ai.telemetry.functionId';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The number of completion tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $b048019508614e47$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = 'ai.usage.completionTokens';
/**
 * Basic LLM span information
 * Multiple spans
 *
 * The number of prompt tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-llm-span-information
 */ const $b048019508614e47$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = 'ai.usage.promptTokens';
// =============================================================================
// BASIC EMBEDDING SPAN INFORMATION
// =============================================================================
/**
 * Basic embedding span information
 * Embedding spans
 *
 * The number of tokens that were used
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#basic-embedding-span-information
 */ const $b048019508614e47$var$AI_USAGE_TOKENS_ATTRIBUTE = 'ai.usage.tokens';
// =============================================================================
// TOOL CALL SPANS
// =============================================================================
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The name of the tool
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ const $b048019508614e47$var$AI_TOOL_CALL_NAME_ATTRIBUTE = 'ai.toolCall.name';
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The id of the tool call
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ const $b048019508614e47$var$AI_TOOL_CALL_ID_ATTRIBUTE = 'ai.toolCall.id';
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The parameters of the tool call
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ const $b048019508614e47$var$AI_TOOL_CALL_ARGS_ATTRIBUTE = 'ai.toolCall.args';
/**
 * Tool call spans
 * `ai.toolCall` span
 *
 * The result of the tool call
 * @see https://ai-sdk.dev/docs/ai-sdk-core/telemetry#tool-call-spans
 */ const $b048019508614e47$var$AI_TOOL_CALL_RESULT_ATTRIBUTE = 'ai.toolCall.result';
// =============================================================================
// PROVIDER METADATA
// =============================================================================
/**
 * OpenAI Provider Metadata
 * @see https://ai-sdk.dev/providers/ai-sdk-providers/openai
 * @see https://github.com/vercel/ai/blob/65e042afde6aad4da9d7a62526ece839eb34f9a5/packages/openai/src/openai-chat-language-model.ts#L397-L416
 * @see https://github.com/vercel/ai/blob/65e042afde6aad4da9d7a62526ece839eb34f9a5/packages/openai/src/responses/openai-responses-language-model.ts#L377C7-L384
 */ module.exports.AI_MODEL_ID_ATTRIBUTE = $b048019508614e47$var$AI_MODEL_ID_ATTRIBUTE;
module.exports.AI_OPERATION_ID_ATTRIBUTE = $b048019508614e47$var$AI_OPERATION_ID_ATTRIBUTE;
module.exports.AI_PROMPT_ATTRIBUTE = $b048019508614e47$var$AI_PROMPT_ATTRIBUTE;
module.exports.AI_PROMPT_MESSAGES_ATTRIBUTE = $b048019508614e47$var$AI_PROMPT_MESSAGES_ATTRIBUTE;
module.exports.AI_PROMPT_TOOLS_ATTRIBUTE = $b048019508614e47$var$AI_PROMPT_TOOLS_ATTRIBUTE;
module.exports.AI_RESPONSE_FINISH_REASON_ATTRIBUTE = $b048019508614e47$var$AI_RESPONSE_FINISH_REASON_ATTRIBUTE;
module.exports.AI_RESPONSE_OBJECT_ATTRIBUTE = $b048019508614e47$var$AI_RESPONSE_OBJECT_ATTRIBUTE;
module.exports.AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE = $b048019508614e47$var$AI_RESPONSE_PROVIDER_METADATA_ATTRIBUTE;
module.exports.AI_RESPONSE_TEXT_ATTRIBUTE = $b048019508614e47$var$AI_RESPONSE_TEXT_ATTRIBUTE;
module.exports.AI_RESPONSE_TOOL_CALLS_ATTRIBUTE = $b048019508614e47$var$AI_RESPONSE_TOOL_CALLS_ATTRIBUTE;
module.exports.AI_SCHEMA_ATTRIBUTE = $b048019508614e47$var$AI_SCHEMA_ATTRIBUTE;
module.exports.AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE = $b048019508614e47$var$AI_TELEMETRY_FUNCTION_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ARGS_ATTRIBUTE = $b048019508614e47$var$AI_TOOL_CALL_ARGS_ATTRIBUTE;
module.exports.AI_TOOL_CALL_ID_ATTRIBUTE = $b048019508614e47$var$AI_TOOL_CALL_ID_ATTRIBUTE;
module.exports.AI_TOOL_CALL_NAME_ATTRIBUTE = $b048019508614e47$var$AI_TOOL_CALL_NAME_ATTRIBUTE;
module.exports.AI_TOOL_CALL_RESULT_ATTRIBUTE = $b048019508614e47$var$AI_TOOL_CALL_RESULT_ATTRIBUTE;
module.exports.AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE = $b048019508614e47$var$AI_USAGE_CACHED_INPUT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE = $b048019508614e47$var$AI_USAGE_COMPLETION_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_PROMPT_TOKENS_ATTRIBUTE = $b048019508614e47$var$AI_USAGE_PROMPT_TOKENS_ATTRIBUTE;
module.exports.AI_USAGE_TOKENS_ATTRIBUTE = $b048019508614e47$var$AI_USAGE_TOKENS_ATTRIBUTE;
module.exports.AI_VALUES_ATTRIBUTE = $b048019508614e47$var$AI_VALUES_ATTRIBUTE;
module.exports.OPERATION_NAME_ATTRIBUTE = $b048019508614e47$var$OPERATION_NAME_ATTRIBUTE;

});



parcelRegister("aIsqw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $1XEa4 = parcelRequire("1XEa4");

var $5Wkkl = parcelRequire("5Wkkl");

var $8xCk9 = parcelRequire("8xCk9");

var $g0XVK = parcelRequire("g0XVK");

var $jLFhR = parcelRequire("jLFhR");

var $fxLy8 = parcelRequire("fxLy8");

var $jZcA4 = parcelRequire("jZcA4");

var $fwX2D = parcelRequire("fwX2D");

var $8jlSx = parcelRequire("8jlSx");

var $ezw0a = parcelRequire("ezw0a");
/**
 * Extract available tools from request parameters
 */ function $7cd4106a954e2a0a$var$extractAvailableTools(params) {
    const tools = Array.isArray(params.tools) ? params.tools : [];
    const hasWebSearchOptions = params.web_search_options && typeof params.web_search_options === 'object';
    const webSearchOptions = hasWebSearchOptions ? [
        {
            type: 'web_search_options',
            ...params.web_search_options
        }
    ] : [];
    const availableTools = [
        ...tools,
        ...webSearchOptions
    ];
    if (availableTools.length === 0) return undefined;
    try {
        return JSON.stringify(availableTools);
    } catch (error) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.error('Failed to serialize OpenAI tools:', error);
        return undefined;
    }
}
/**
 * Extract request attributes from method arguments
 */ function $7cd4106a954e2a0a$var$extractRequestAttributes(args, operationName) {
    const attributes = {
        [$fxLy8.GEN_AI_SYSTEM_ATTRIBUTE]: 'openai',
        [$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.ai.openai'
    };
    if (args.length > 0 && typeof args[0] === 'object' && args[0] !== null) {
        const params = args[0];
        const availableTools = $7cd4106a954e2a0a$var$extractAvailableTools(params);
        if (availableTools) attributes[$fxLy8.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = availableTools;
        Object.assign(attributes, $ezw0a.extractRequestParameters(params));
    } else attributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = 'unknown';
    return attributes;
}
// Extract and record AI request inputs, if present. This is intentionally separate from response attributes.
function $7cd4106a954e2a0a$var$addRequestAttributes(span, params, operationName, enableTruncation) {
    // Store embeddings input on a separate attribute and do not truncate it
    if (operationName === 'embeddings' && 'input' in params) {
        const input = params.input;
        // No input provided
        if (input == null) return;
        // Empty input string
        if (typeof input === 'string' && input.length === 0) return;
        // Empty array input
        if (Array.isArray(input) && input.length === 0) return;
        // Store strings as-is, arrays/objects as JSON
        span.setAttribute($fxLy8.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof input === 'string' ? input : JSON.stringify(input));
        return;
    }
    const src = 'input' in params ? params.input : 'messages' in params ? params.messages : undefined;
    if (!src) return;
    if (Array.isArray(src) && src.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $jZcA4.extractSystemInstructions(src);
    if (systemInstructions) span.setAttribute($fxLy8.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
    span.setAttribute($fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $jZcA4.getTruncatedJsonString(filteredMessages) : $jZcA4.getJsonString(filteredMessages));
    if (Array.isArray(filteredMessages)) span.setAttribute($fxLy8.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredMessages.length);
    else span.setAttribute($fxLy8.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, 1);
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function $7cd4106a954e2a0a$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return function instrumentedCall(...args) {
        const operationName = instrumentedMethod.operation || 'unknown';
        const requestAttributes = $7cd4106a954e2a0a$var$extractRequestAttributes(args, operationName);
        const model = requestAttributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || 'unknown';
        const params = args[0];
        const isStreamRequested = params && typeof params === 'object' && params.stream === true;
        const spanConfig = {
            name: `${operationName} ${model}`,
            op: `gen_ai.${operationName}`,
            attributes: requestAttributes
        };
        if (isStreamRequested) {
            let originalResult;
            const instrumentedPromise = $jLFhR.startSpanManual(spanConfig, (span)=>{
                originalResult = originalMethod.apply(context, args);
                if (options.recordInputs && params) $7cd4106a954e2a0a$var$addRequestAttributes(span, params, operationName, $jZcA4.shouldEnableTruncation(options.enableTruncation));
                // Return async processing
                return (async ()=>{
                    try {
                        const result = await originalResult;
                        return $8jlSx.instrumentStream(result, span, options.recordOutputs ?? false);
                    } catch (error) {
                        span.setStatus({
                            code: $g0XVK.SPAN_STATUS_ERROR,
                            message: 'internal_error'
                        });
                        $1XEa4.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: 'auto.ai.openai.stream',
                                data: {
                                    function: methodPath
                                }
                            }
                        });
                        span.end();
                        throw error;
                    }
                })();
            });
            return $jZcA4.wrapPromiseWithMethods(originalResult, instrumentedPromise, 'auto.ai.openai');
        }
        // Non-streaming
        let originalResult;
        const instrumentedPromise = $jLFhR.startSpan(spanConfig, (span)=>{
            // Call synchronously to capture the promise
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $7cd4106a954e2a0a$var$addRequestAttributes(span, params, operationName, $jZcA4.shouldEnableTruncation(options.enableTruncation));
            return originalResult.then((result)=>{
                $ezw0a.addResponseAttributes(span, result, options.recordOutputs);
                return result;
            }, (error)=>{
                $1XEa4.captureException(error, {
                    mechanism: {
                        handled: false,
                        type: 'auto.ai.openai',
                        data: {
                            function: methodPath
                        }
                    }
                });
                throw error;
            });
        });
        return $jZcA4.wrapPromiseWithMethods(originalResult, instrumentedPromise, 'auto.ai.openai');
    };
}
/**
 * Create a deep proxy for OpenAI client instrumentation
 */ function $7cd4106a954e2a0a$var$createDeepProxy(target, currentPath = '', options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $jZcA4.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $fwX2D.OPENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === 'function' && instrumentedMethod) return $7cd4106a954e2a0a$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context,
            // which is required for accessing private class fields (e.g. #baseURL) in OpenAI SDK v5.
            return value.bind(obj);
            if (value && typeof value === 'object') return $7cd4106a954e2a0a$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an OpenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 */ function $7cd4106a954e2a0a$var$instrumentOpenAiClient(client, options) {
    return $7cd4106a954e2a0a$var$createDeepProxy(client, '', $jZcA4.resolveAIRecordingOptions(options));
}
module.exports.instrumentOpenAiClient = $7cd4106a954e2a0a$var$instrumentOpenAiClient;

});
parcelRegister("fwX2D", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $b4e7a49a69aed54d$var$OPENAI_INTEGRATION_NAME = 'OpenAI';
// https://platform.openai.com/docs/quickstart?api-mode=responses
// https://platform.openai.com/docs/quickstart?api-mode=chat
// https://platform.openai.com/docs/api-reference/conversations
const $b4e7a49a69aed54d$var$OPENAI_METHOD_REGISTRY = {
    'responses.create': {
        operation: 'chat'
    },
    'chat.completions.create': {
        operation: 'chat'
    },
    'embeddings.create': {
        operation: 'embeddings'
    },
    // Conversations API - for conversation state management
    // https://platform.openai.com/docs/guides/conversation-state
    'conversations.create': {
        operation: 'chat'
    }
};
const $b4e7a49a69aed54d$var$RESPONSES_TOOL_CALL_EVENT_TYPES = [
    'response.output_item.added',
    'response.function_call_arguments.delta',
    'response.function_call_arguments.done',
    'response.output_item.done'
];
const $b4e7a49a69aed54d$var$RESPONSE_EVENT_TYPES = [
    'response.created',
    'response.in_progress',
    'response.failed',
    'response.completed',
    'response.incomplete',
    'response.queued',
    'response.output_text.delta',
    ...$b4e7a49a69aed54d$var$RESPONSES_TOOL_CALL_EVENT_TYPES
];
module.exports.OPENAI_INTEGRATION_NAME = $b4e7a49a69aed54d$var$OPENAI_INTEGRATION_NAME;
module.exports.OPENAI_METHOD_REGISTRY = $b4e7a49a69aed54d$var$OPENAI_METHOD_REGISTRY;
module.exports.RESPONSES_TOOL_CALL_EVENT_TYPES = $b4e7a49a69aed54d$var$RESPONSES_TOOL_CALL_EVENT_TYPES;
module.exports.RESPONSE_EVENT_TYPES = $b4e7a49a69aed54d$var$RESPONSE_EVENT_TYPES;

});

parcelRegister("8jlSx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $g0XVK = parcelRequire("g0XVK");

var $jZcA4 = parcelRequire("jZcA4");

var $fwX2D = parcelRequire("fwX2D");

var $ezw0a = parcelRequire("ezw0a");
/**
 * State object used to accumulate information from a stream of OpenAI events/chunks.
 */ /**
 * Processes tool calls from a chat completion chunk delta.
 * Follows the pattern: accumulate by index, then convert to array at the end.
 *
 * @param toolCalls - Array of tool calls from the delta.
 * @param state - The current streaming state to update.
 *
 *  @see https://platform.openai.com/docs/guides/function-calling#streaming
 */ function $60d111bd07beaecf$var$processChatCompletionToolCalls(toolCalls, state) {
    for (const toolCall of toolCalls){
        const index = toolCall.index;
        if (index === undefined || !toolCall.function) continue;
        // Initialize tool call if this is the first chunk for this index
        if (!(index in state.chatCompletionToolCalls)) state.chatCompletionToolCalls[index] = {
            ...toolCall,
            function: {
                name: toolCall.function.name,
                arguments: toolCall.function.arguments || ''
            }
        };
        else {
            // Accumulate function arguments from subsequent chunks
            const existingToolCall = state.chatCompletionToolCalls[index];
            if (toolCall.function.arguments && existingToolCall?.function) existingToolCall.function.arguments += toolCall.function.arguments;
        }
    }
}
/**
 * Processes a single OpenAI ChatCompletionChunk event, updating the streaming state.
 *
 * @param chunk - The ChatCompletionChunk event to process.
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 */ function $60d111bd07beaecf$var$processChatCompletionChunk(chunk, state, recordOutputs) {
    state.responseId = chunk.id ?? state.responseId;
    state.responseModel = chunk.model ?? state.responseModel;
    if (chunk.usage) {
        // For stream responses, the input tokens remain constant across all events in the stream.
        // Output tokens, however, are only finalized in the last event.
        // Since we can't guarantee that the last event will include usage data or even be a typed event,
        // we update the output token values on every event that includes them.
        // This ensures that output token usage is always set, even if the final event lacks it.
        state.promptTokens = chunk.usage.prompt_tokens;
        state.completionTokens = chunk.usage.completion_tokens;
        state.totalTokens = chunk.usage.total_tokens;
    }
    for (const choice of chunk.choices ?? []){
        if (recordOutputs) {
            if (choice.delta?.content) state.responseTexts.push(choice.delta.content);
            // Handle tool calls from delta
            if (choice.delta?.tool_calls) $60d111bd07beaecf$var$processChatCompletionToolCalls(choice.delta.tool_calls, state);
        }
        if (choice.finish_reason) state.finishReasons.push(choice.finish_reason);
    }
}
/**
 * Processes a single OpenAI Responses API streaming event, updating the streaming state and span.
 *
 * @param streamEvent - The event to process (may be an error or unknown object).
 * @param state - The current streaming state to update.
 * @param recordOutputs - Whether to record output text fragments.
 * @param span - The span to update with error status if needed.
 */ function $60d111bd07beaecf$var$processResponsesApiEvent(streamEvent, state, recordOutputs, span) {
    if (!(streamEvent && typeof streamEvent === 'object')) {
        state.eventTypes.push('unknown:non-object');
        return;
    }
    if (streamEvent instanceof Error) {
        span.setStatus({
            code: $g0XVK.SPAN_STATUS_ERROR,
            message: 'internal_error'
        });
        $1XEa4.captureException(streamEvent, {
            mechanism: {
                handled: false,
                type: 'auto.ai.openai.stream-response'
            }
        });
        return;
    }
    if (!('type' in streamEvent)) return;
    const event = streamEvent;
    if (!$fwX2D.RESPONSE_EVENT_TYPES.includes(event.type)) {
        state.eventTypes.push(event.type);
        return;
    }
    // Handle output text delta
    if (recordOutputs) {
        // Handle tool call events for Responses API
        if (event.type === 'response.output_item.done' && 'item' in event) state.responsesApiToolCalls.push(event.item);
        if (event.type === 'response.output_text.delta' && 'delta' in event && event.delta) {
            state.responseTexts.push(event.delta);
            return;
        }
    }
    if ('response' in event) {
        const { response: response } = event;
        state.responseId = response.id ?? state.responseId;
        state.responseModel = response.model ?? state.responseModel;
        if (response.usage) {
            // For stream responses, the input tokens remain constant across all events in the stream.
            // Output tokens, however, are only finalized in the last event.
            // Since we can't guarantee that the last event will include usage data or even be a typed event,
            // we update the output token values on every event that includes them.
            // This ensures that output token usage is always set, even if the final event lacks it.
            state.promptTokens = response.usage.input_tokens;
            state.completionTokens = response.usage.output_tokens;
            state.totalTokens = response.usage.total_tokens;
        }
        if (response.status) state.finishReasons.push(response.status);
        if (recordOutputs && response.output_text) state.responseTexts.push(response.output_text);
    }
}
/**
 * Instruments a stream of OpenAI events, updating the provided span with relevant attributes and
 * optionally recording output text. This function yields each event from the input stream as it is processed.
 *
 * @template T - The type of events in the stream.
 * @param stream - The async iterable stream of events to instrument.
 * @param span - The span to add attributes to and to finish at the end of the stream.
 * @param recordOutputs - Whether to record output text fragments in the span.
 * @returns An async generator yielding each event from the input stream.
 */ async function* $60d111bd07beaecf$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        eventTypes: [],
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        promptTokens: undefined,
        completionTokens: undefined,
        totalTokens: undefined,
        chatCompletionToolCalls: {},
        responsesApiToolCalls: []
    };
    try {
        for await (const event of stream){
            if ($ezw0a.isChatCompletionChunk(event)) $60d111bd07beaecf$var$processChatCompletionChunk(event, state, recordOutputs);
            else if ($ezw0a.isResponsesApiStreamEvent(event)) $60d111bd07beaecf$var$processResponsesApiEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        const allToolCalls = [
            ...Object.values(state.chatCompletionToolCalls),
            ...state.responsesApiToolCalls
        ];
        $jZcA4.endStreamSpan(span, {
            ...state,
            toolCalls: allToolCalls
        }, recordOutputs);
    }
}
module.exports.instrumentStream = $60d111bd07beaecf$var$instrumentStream;

});
parcelRegister("ezw0a", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $fxLy8 = parcelRequire("fxLy8");
/**
 * Check if streaming event is from the Responses API
 */ function $a9bd28763e586950$var$isResponsesApiStreamEvent(event) {
    return event !== null && typeof event === 'object' && 'type' in event && typeof event.type === 'string' && event.type.startsWith('response.');
}
/**
 * Check if streaming event is a chat completion chunk
 */ function $a9bd28763e586950$var$isChatCompletionChunk(event) {
    return event !== null && typeof event === 'object' && 'object' in event && event.object === 'chat.completion.chunk';
}
/**
 * Add response attributes to a span using duck-typing.
 * Works for Chat Completions, Responses API, Embeddings, and Conversations API responses.
 */ function $a9bd28763e586950$var$addResponseAttributes(span, result, recordOutputs) {
    if (!result || typeof result !== 'object') return;
    const response = result;
    const attrs = {};
    // Response ID
    if (typeof response.id === 'string') attrs[$fxLy8.GEN_AI_RESPONSE_ID_ATTRIBUTE] = response.id;
    // Response model
    if (typeof response.model === 'string') attrs[$fxLy8.GEN_AI_RESPONSE_MODEL_ATTRIBUTE] = response.model;
    // Conversation ID (conversation objects use id as conversation link)
    if (response.object === 'conversation' && typeof response.id === 'string') attrs[$fxLy8.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = response.id;
    // Token usage — supports both naming conventions (chat: prompt_tokens/completion_tokens, responses: input_tokens/output_tokens)
    if (response.usage && typeof response.usage === 'object') {
        const usage = response.usage;
        const inputTokens = usage.prompt_tokens ?? usage.input_tokens;
        if (typeof inputTokens === 'number') attrs[$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE] = inputTokens;
        const outputTokens = usage.completion_tokens ?? usage.output_tokens;
        if (typeof outputTokens === 'number') attrs[$fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE] = outputTokens;
        if (typeof usage.total_tokens === 'number') attrs[$fxLy8.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE] = usage.total_tokens;
    }
    // Finish reasons from choices (chat completions)
    if (Array.isArray(response.choices)) {
        const choices = response.choices;
        const finishReasons = choices.map((choice)=>choice.finish_reason).filter((reason)=>typeof reason === 'string');
        if (finishReasons.length > 0) attrs[$fxLy8.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify(finishReasons);
        if (recordOutputs) {
            // Response text from choices
            const responseTexts = choices.map((choice)=>{
                const message = choice.message;
                return message?.content || '';
            });
            attrs[$fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = JSON.stringify(responseTexts);
            // Tool calls from choices
            const toolCalls = choices.map((choice)=>{
                const message = choice.message;
                return message?.tool_calls;
            }).filter((calls)=>Array.isArray(calls) && calls.length > 0).flat();
            if (toolCalls.length > 0) attrs[$fxLy8.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(toolCalls);
        }
    }
    // Finish reason from status (responses API)
    if (typeof response.status === 'string') // Only set if not already set from choices
    {
        if (!attrs[$fxLy8.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE]) attrs[$fxLy8.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE] = JSON.stringify([
            response.status
        ]);
    }
    if (recordOutputs) {
        // Response text from output_text (responses API)
        if (typeof response.output_text === 'string' && !attrs[$fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]) attrs[$fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE] = response.output_text;
        // Tool calls from output array (responses API)
        if (Array.isArray(response.output) && response.output.length > 0 && !attrs[$fxLy8.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]) {
            const functionCalls = response.output.filter((item)=>item?.type === 'function_call');
            if (functionCalls.length > 0) attrs[$fxLy8.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE] = JSON.stringify(functionCalls);
        }
    }
    span.setAttributes(attrs);
}
/**
 * Extract conversation ID from request parameters
 * Supports both Conversations API and previous_response_id chaining
 * @see https://platform.openai.com/docs/guides/conversation-state
 */ function $a9bd28763e586950$var$extractConversationId(params) {
    // Conversations API: conversation parameter (e.g., "conv_...")
    if ('conversation' in params && typeof params.conversation === 'string') return params.conversation;
    // Responses chaining: previous_response_id links to parent response
    if ('previous_response_id' in params && typeof params.previous_response_id === 'string') return params.previous_response_id;
    return undefined;
}
/**
 * Extract request parameters including model settings and conversation context
 */ function $a9bd28763e586950$var$extractRequestParameters(params) {
    const attributes = {
        [$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: params.model ?? 'unknown'
    };
    if ('temperature' in params) attributes[$fxLy8.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
    if ('top_p' in params) attributes[$fxLy8.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
    if ('frequency_penalty' in params) attributes[$fxLy8.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
    if ('presence_penalty' in params) attributes[$fxLy8.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = params.presence_penalty;
    if ('stream' in params) attributes[$fxLy8.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
    if ('encoding_format' in params) attributes[$fxLy8.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = params.encoding_format;
    if ('dimensions' in params) attributes[$fxLy8.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = params.dimensions;
    // Capture conversation ID for linking messages across API calls
    const conversationId = $a9bd28763e586950$var$extractConversationId(params);
    if (conversationId) attributes[$fxLy8.GEN_AI_CONVERSATION_ID_ATTRIBUTE] = conversationId;
    return attributes;
}
module.exports.addResponseAttributes = $a9bd28763e586950$var$addResponseAttributes;
module.exports.extractRequestParameters = $a9bd28763e586950$var$extractRequestParameters;
module.exports.isChatCompletionChunk = $a9bd28763e586950$var$isChatCompletionChunk;
module.exports.isResponsesApiStreamEvent = $a9bd28763e586950$var$isResponsesApiStreamEvent;

});



parcelRegister("h89U9", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $5Wkkl = parcelRequire("5Wkkl");

var $g0XVK = parcelRequire("g0XVK");

var $jLFhR = parcelRequire("jLFhR");

var $fxLy8 = parcelRequire("fxLy8");

var $jZcA4 = parcelRequire("jZcA4");

var $1Henj = parcelRequire("1Henj");

var $4ucK8 = parcelRequire("4ucK8");

var $2Rpm0 = parcelRequire("2Rpm0");
/**
 * Extract request attributes from method arguments
 */ function $c78adde7a0c2955d$var$extractRequestAttributes(args, methodPath, operationName) {
    const attributes = {
        [$fxLy8.GEN_AI_SYSTEM_ATTRIBUTE]: 'anthropic',
        [$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.ai.anthropic'
    };
    if (args.length > 0 && typeof args[0] === 'object' && args[0] !== null) {
        const params = args[0];
        if (params.tools && Array.isArray(params.tools)) attributes[$fxLy8.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(params.tools);
        attributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = params.model ?? 'unknown';
        if ('temperature' in params) attributes[$fxLy8.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = params.temperature;
        if ('top_p' in params) attributes[$fxLy8.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = params.top_p;
        if ('stream' in params) attributes[$fxLy8.GEN_AI_REQUEST_STREAM_ATTRIBUTE] = params.stream;
        if ('top_k' in params) attributes[$fxLy8.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = params.top_k;
        if ('frequency_penalty' in params) attributes[$fxLy8.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = params.frequency_penalty;
        if ('max_tokens' in params) attributes[$fxLy8.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = params.max_tokens;
    } else if (methodPath === 'models.retrieve' || methodPath === 'models.get') // models.retrieve(model-id) and models.get(model-id)
    attributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = args[0];
    else attributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = 'unknown';
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 */ function $c78adde7a0c2955d$var$addPrivateRequestAttributes(span, params, enableTruncation) {
    const messages = $2Rpm0.messagesFromParams(params);
    $2Rpm0.setMessagesAttribute(span, messages, enableTruncation);
    if ('prompt' in params) span.setAttributes({
        [$fxLy8.GEN_AI_PROMPT_ATTRIBUTE]: JSON.stringify(params.prompt)
    });
}
/**
 * Add content attributes when recordOutputs is enabled
 */ function $c78adde7a0c2955d$var$addContentAttributes(span, response) {
    // Messages.create
    if ('content' in response) {
        if (Array.isArray(response.content)) {
            span.setAttributes({
                [$fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.content.map((item)=>item.text).filter((text)=>!!text).join('')
            });
            const toolCalls = [];
            for (const item of response.content)if (item.type === 'tool_use' || item.type === 'server_tool_use') toolCalls.push(item);
            if (toolCalls.length > 0) span.setAttributes({
                [$fxLy8.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(toolCalls)
            });
        }
    }
    // Completions.create
    if ('completion' in response) span.setAttributes({
        [$fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: response.completion
    });
    // Models.countTokens
    if ('input_tokens' in response) span.setAttributes({
        [$fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: JSON.stringify(response.input_tokens)
    });
}
/**
 * Add basic metadata attributes from the response
 */ function $c78adde7a0c2955d$var$addMetadataAttributes(span, response) {
    if ('id' in response && 'model' in response) {
        span.setAttributes({
            [$fxLy8.GEN_AI_RESPONSE_ID_ATTRIBUTE]: response.id,
            [$fxLy8.GEN_AI_RESPONSE_MODEL_ATTRIBUTE]: response.model
        });
        if ('usage' in response && response.usage) $jZcA4.setTokenUsageAttributes(span, response.usage.input_tokens, response.usage.output_tokens, response.usage.cache_creation_input_tokens, response.usage.cache_read_input_tokens);
    }
}
/**
 * Add response attributes to spans
 */ function $c78adde7a0c2955d$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== 'object') return;
    // capture error, do not add attributes if error (they shouldn't exist)
    if ('type' in response && response.type === 'error') {
        $2Rpm0.handleResponseError(span, response);
        return;
    }
    // Private response attributes that are only recorded if recordOutputs is true.
    if (recordOutputs) $c78adde7a0c2955d$var$addContentAttributes(span, response);
    // Add basic metadata attributes
    $c78adde7a0c2955d$var$addMetadataAttributes(span, response);
}
/**
 * Handle common error catching and reporting for streaming requests
 */ function $c78adde7a0c2955d$var$handleStreamingError(error, span, methodPath) {
    $1XEa4.captureException(error, {
        mechanism: {
            handled: false,
            type: 'auto.ai.anthropic',
            data: {
                function: methodPath
            }
        }
    });
    if (span.isRecording()) {
        span.setStatus({
            code: $g0XVK.SPAN_STATUS_ERROR,
            message: 'internal_error'
        });
        span.end();
    }
    throw error;
}
/**
 * Handle streaming cases with common logic
 */ function $c78adde7a0c2955d$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod) {
    const model = requestAttributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? 'unknown';
    const spanConfig = {
        name: `${operationName} ${model}`,
        op: `gen_ai.${operationName}`,
        attributes: requestAttributes
    };
    // messages.stream() always returns a sync MessageStream, even with stream: true param
    if (isStreamRequested && !isStreamingMethod) {
        let originalResult;
        const instrumentedPromise = $jLFhR.startSpanManual(spanConfig, (span)=>{
            originalResult = originalMethod.apply(context, args);
            if (options.recordInputs && params) $c78adde7a0c2955d$var$addPrivateRequestAttributes(span, params, $jZcA4.shouldEnableTruncation(options.enableTruncation));
            return (async ()=>{
                try {
                    const result = await originalResult;
                    return $4ucK8.instrumentAsyncIterableStream(result, span, options.recordOutputs ?? false);
                } catch (error) {
                    return $c78adde7a0c2955d$var$handleStreamingError(error, span, methodPath);
                }
            })();
        });
        return $jZcA4.wrapPromiseWithMethods(originalResult, instrumentedPromise, 'auto.ai.anthropic');
    } else return $jLFhR.startSpanManual(spanConfig, (span)=>{
        try {
            if (options.recordInputs && params) $c78adde7a0c2955d$var$addPrivateRequestAttributes(span, params, $jZcA4.shouldEnableTruncation(options.enableTruncation));
            const messageStream = target.apply(context, args);
            return $4ucK8.instrumentMessageStream(messageStream, span, options.recordOutputs ?? false);
        } catch (error) {
            return $c78adde7a0c2955d$var$handleStreamingError(error, span, methodPath);
        }
    });
}
/**
 * Instrument a method with Sentry spans
 * Following Sentry AI Agents Manual Instrumentation conventions
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function $c78adde7a0c2955d$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const operationName = instrumentedMethod.operation || 'unknown';
            const requestAttributes = $c78adde7a0c2955d$var$extractRequestAttributes(args, methodPath, operationName);
            const model = requestAttributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? 'unknown';
            const params = typeof args[0] === 'object' ? args[0] : undefined;
            const isStreamRequested = Boolean(params?.stream);
            const isStreamingMethod = instrumentedMethod.streaming === true;
            if (isStreamRequested || isStreamingMethod) return $c78adde7a0c2955d$var$handleStreamingRequest(originalMethod, target, context, args, requestAttributes, operationName, methodPath, params, options, isStreamRequested, isStreamingMethod);
            let originalResult;
            const instrumentedPromise = $jLFhR.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                originalResult = target.apply(context, args);
                if (options.recordInputs && params) $c78adde7a0c2955d$var$addPrivateRequestAttributes(span, params, $jZcA4.shouldEnableTruncation(options.enableTruncation));
                return originalResult.then((result)=>{
                    $c78adde7a0c2955d$var$addResponseAttributes(span, result, options.recordOutputs);
                    return result;
                }, (error)=>{
                    $1XEa4.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.anthropic',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    throw error;
                });
            });
            return $jZcA4.wrapPromiseWithMethods(originalResult, instrumentedPromise, 'auto.ai.anthropic');
        }
    });
}
/**
 * Create a deep proxy for Anthropic AI client instrumentation
 */ function $c78adde7a0c2955d$var$createDeepProxy(target, currentPath = '', options) {
    return new Proxy(target, {
        get (obj, prop) {
            const value = obj[prop];
            const methodPath = $jZcA4.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $1Henj.ANTHROPIC_METHOD_REGISTRY[methodPath];
            if (typeof value === 'function' && instrumentedMethod) return $c78adde7a0c2955d$var$instrumentMethod(value, methodPath, instrumentedMethod, obj, options);
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context,
            return value.bind(obj);
            if (value && typeof value === 'object') return $c78adde7a0c2955d$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument an Anthropic AI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends object
 * @param client - The Anthropic AI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 */ function $c78adde7a0c2955d$var$instrumentAnthropicAiClient(anthropicAiClient, options) {
    return $c78adde7a0c2955d$var$createDeepProxy(anthropicAiClient, '', $jZcA4.resolveAIRecordingOptions(options));
}
module.exports.instrumentAnthropicAiClient = $c78adde7a0c2955d$var$instrumentAnthropicAiClient;

});
parcelRegister("1Henj", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $13c4f532b9c864ec$var$ANTHROPIC_AI_INTEGRATION_NAME = 'Anthropic_AI';
// https://docs.anthropic.com/en/api/messages
// https://docs.anthropic.com/en/api/models-list
const $13c4f532b9c864ec$var$ANTHROPIC_METHOD_REGISTRY = {
    'messages.create': {
        operation: 'chat'
    },
    'messages.stream': {
        operation: 'chat',
        streaming: true
    },
    'messages.countTokens': {
        operation: 'chat'
    },
    'models.get': {
        operation: 'models'
    },
    'completions.create': {
        operation: 'chat'
    },
    'models.retrieve': {
        operation: 'models'
    },
    'beta.messages.create': {
        operation: 'chat'
    }
};
module.exports.ANTHROPIC_AI_INTEGRATION_NAME = $13c4f532b9c864ec$var$ANTHROPIC_AI_INTEGRATION_NAME;
module.exports.ANTHROPIC_METHOD_REGISTRY = $13c4f532b9c864ec$var$ANTHROPIC_METHOD_REGISTRY;

});

parcelRegister("4ucK8", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $g0XVK = parcelRequire("g0XVK");

var $jZcA4 = parcelRequire("jZcA4");

var $2Rpm0 = parcelRequire("2Rpm0");
/**
 * State object used to accumulate information from a stream of Anthropic AI events.
 */ /**
 * Checks if an event is an error event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 * @returns Whether an error occurred
 */ function $3443d94d2b8b8995$var$isErrorEvent(event, span) {
    if ('type' in event && typeof event.type === 'string') // If the event is an error, set the span status and capture the error
    // These error events are not rejected by the API by default, but are sent as metadata of the response
    {
        if (event.type === 'error') {
            span.setStatus({
                code: $g0XVK.SPAN_STATUS_ERROR,
                message: $2Rpm0.mapAnthropicErrorToStatusMessage(event.error?.type)
            });
            $1XEa4.captureException(event.error, {
                mechanism: {
                    handled: false,
                    type: 'auto.ai.anthropic.anthropic_error'
                }
            });
            return true;
        }
    }
    return false;
}
/**
 * Processes the message metadata of an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 */ function $3443d94d2b8b8995$var$handleMessageMetadata(event, state) {
    // The token counts shown in the usage field of the message_delta event are cumulative.
    // @see https://docs.anthropic.com/en/docs/build-with-claude/streaming#event-types
    if (event.type === 'message_delta' && event.usage) {
        if ('output_tokens' in event.usage && typeof event.usage.output_tokens === 'number') state.completionTokens = event.usage.output_tokens;
    }
    if (event.message) {
        const message = event.message;
        if (message.id) state.responseId = message.id;
        if (message.model) state.responseModel = message.model;
        if (message.stop_reason) state.finishReasons.push(message.stop_reason);
        if (message.usage) {
            if (typeof message.usage.input_tokens === 'number') state.promptTokens = message.usage.input_tokens;
            if (typeof message.usage.cache_creation_input_tokens === 'number') state.cacheCreationInputTokens = message.usage.cache_creation_input_tokens;
            if (typeof message.usage.cache_read_input_tokens === 'number') state.cacheReadInputTokens = message.usage.cache_read_input_tokens;
        }
    }
}
/**
 * Handle start of a content block (e.g., tool_use)
 */ function $3443d94d2b8b8995$var$handleContentBlockStart(event, state) {
    if (event.type !== 'content_block_start' || typeof event.index !== 'number' || !event.content_block) return;
    if (event.content_block.type === 'tool_use' || event.content_block.type === 'server_tool_use') state.activeToolBlocks[event.index] = {
        id: event.content_block.id,
        name: event.content_block.name,
        inputJsonParts: []
    };
}
/**
 * Handle deltas of a content block, including input_json_delta for tool_use
 */ function $3443d94d2b8b8995$var$handleContentBlockDelta(event, state, recordOutputs) {
    if (event.type !== 'content_block_delta' || !event.delta) return;
    // Accumulate tool_use input JSON deltas only when we have an index and an active tool block
    if (typeof event.index === 'number' && 'partial_json' in event.delta && typeof event.delta.partial_json === 'string') {
        const active = state.activeToolBlocks[event.index];
        if (active) active.inputJsonParts.push(event.delta.partial_json);
    }
    // Accumulate streamed response text regardless of index
    if (recordOutputs && typeof event.delta.text === 'string') state.responseTexts.push(event.delta.text);
}
/**
 * Handle stop of a content block; finalize tool_use entries
 */ function $3443d94d2b8b8995$var$handleContentBlockStop(event, state) {
    if (event.type !== 'content_block_stop' || typeof event.index !== 'number') return;
    const active = state.activeToolBlocks[event.index];
    if (!active) return;
    const raw = active.inputJsonParts.join('');
    let parsedInput;
    try {
        parsedInput = raw ? JSON.parse(raw) : {};
    } catch  {
        parsedInput = {
            __unparsed: raw
        };
    }
    state.toolCalls.push({
        type: 'tool_use',
        id: active.id,
        name: active.name,
        input: parsedInput
    });
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete state.activeToolBlocks[event.index];
}
/**
 * Processes an event
 * @param event - The event to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function $3443d94d2b8b8995$var$processEvent(event, state, recordOutputs, span) {
    if (!(event && typeof event === 'object')) return;
    const isError = $3443d94d2b8b8995$var$isErrorEvent(event, span);
    if (isError) return;
    $3443d94d2b8b8995$var$handleMessageMetadata(event, state);
    // Tool call events are sent via 3 separate events:
    // - content_block_start (start of the tool call)
    // - content_block_delta (delta aka input of the tool call)
    // - content_block_stop (end of the tool call)
    // We need to handle them all to capture the full tool call.
    $3443d94d2b8b8995$var$handleContentBlockStart(event, state);
    $3443d94d2b8b8995$var$handleContentBlockDelta(event, state, recordOutputs);
    $3443d94d2b8b8995$var$handleContentBlockStop(event, state);
}
/**
 * Instruments an async iterable stream of Anthropic events, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each event from the input stream unchanged.
 */ async function* $3443d94d2b8b8995$var$instrumentAsyncIterableStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        promptTokens: undefined,
        completionTokens: undefined,
        cacheCreationInputTokens: undefined,
        cacheReadInputTokens: undefined,
        toolCalls: [],
        activeToolBlocks: {}
    };
    try {
        for await (const event of stream){
            $3443d94d2b8b8995$var$processEvent(event, state, recordOutputs, span);
            yield event;
        }
    } finally{
        $jZcA4.endStreamSpan(span, state, recordOutputs);
    }
}
/**
 * Instruments a MessageStream by registering event handlers and preserving the original stream API.
 */ function $3443d94d2b8b8995$var$instrumentMessageStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        responseId: '',
        responseModel: '',
        promptTokens: undefined,
        completionTokens: undefined,
        cacheCreationInputTokens: undefined,
        cacheReadInputTokens: undefined,
        toolCalls: [],
        activeToolBlocks: {}
    };
    stream.on('streamEvent', (event)=>{
        $3443d94d2b8b8995$var$processEvent(event, state, recordOutputs, span);
    });
    // The event fired when a message is done being streamed by the API. Corresponds to the message_stop SSE event.
    // @see https://github.com/anthropics/anthropic-sdk-typescript/blob/d3be31f5a4e6ebb4c0a2f65dbb8f381ae73a9166/helpers.md?plain=1#L42-L44
    stream.on('message', ()=>{
        $jZcA4.endStreamSpan(span, state, recordOutputs);
    });
    stream.on('error', (error)=>{
        $1XEa4.captureException(error, {
            mechanism: {
                handled: false,
                type: 'auto.ai.anthropic.stream_error'
            }
        });
        if (span.isRecording()) {
            span.setStatus({
                code: $g0XVK.SPAN_STATUS_ERROR,
                message: 'internal_error'
            });
            span.end();
        }
    });
    return stream;
}
module.exports.instrumentAsyncIterableStream = $3443d94d2b8b8995$var$instrumentAsyncIterableStream;
module.exports.instrumentMessageStream = $3443d94d2b8b8995$var$instrumentMessageStream;

});
parcelRegister("2Rpm0", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $g0XVK = parcelRequire("g0XVK");

var $fxLy8 = parcelRequire("fxLy8");

var $jZcA4 = parcelRequire("jZcA4");
/**
 * Set the messages and messages original length attributes.
 * Extracts system instructions before truncation.
 */ function $215432bf6973dd62$var$setMessagesAttribute(span, messages, enableTruncation) {
    if (Array.isArray(messages) && messages.length === 0) return;
    const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $jZcA4.extractSystemInstructions(messages);
    if (systemInstructions) span.setAttributes({
        [$fxLy8.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE]: systemInstructions
    });
    const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 1;
    span.setAttributes({
        [$fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $jZcA4.getTruncatedJsonString(filteredMessages) : $jZcA4.getJsonString(filteredMessages),
        [$fxLy8.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
    });
}
const $215432bf6973dd62$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS = {
    invalid_request_error: 'invalid_argument',
    authentication_error: 'unauthenticated',
    permission_error: 'permission_denied',
    not_found_error: 'not_found',
    request_too_large: 'failed_precondition',
    rate_limit_error: 'resource_exhausted',
    api_error: 'internal_error',
    overloaded_error: 'unavailable'
};
/**
 * Map an Anthropic API error type to a SpanStatusType value.
 * @see https://docs.anthropic.com/en/api/errors#error-shapes
 */ function $215432bf6973dd62$var$mapAnthropicErrorToStatusMessage(errorType) {
    if (!errorType) return 'internal_error';
    return $215432bf6973dd62$var$ANTHROPIC_ERROR_TYPE_TO_SPAN_STATUS[errorType] || 'internal_error';
}
/**
 * Capture error information from the response
 * @see https://docs.anthropic.com/en/api/errors#error-shapes
 */ function $215432bf6973dd62$var$handleResponseError(span, response) {
    if (response.error) {
        span.setStatus({
            code: $g0XVK.SPAN_STATUS_ERROR,
            message: $215432bf6973dd62$var$mapAnthropicErrorToStatusMessage(response.error.type)
        });
        $1XEa4.captureException(response.error, {
            mechanism: {
                handled: false,
                type: 'auto.ai.anthropic.anthropic_error'
            }
        });
    }
}
/**
 * Include the system prompt in the messages list, if available
 */ function $215432bf6973dd62$var$messagesFromParams(params) {
    const { system: system, messages: messages, input: input } = params;
    const systemMessages = typeof system === 'string' ? [
        {
            role: 'system',
            content: params.system
        }
    ] : [];
    const inputParamMessages = Array.isArray(input) ? input : input != null ? [
        input
    ] : undefined;
    const messagesParamMessages = Array.isArray(messages) ? messages : messages != null ? [
        messages
    ] : [];
    const userMessages = inputParamMessages ?? messagesParamMessages;
    return [
        ...systemMessages,
        ...userMessages
    ];
}
module.exports.handleResponseError = $215432bf6973dd62$var$handleResponseError;
module.exports.mapAnthropicErrorToStatusMessage = $215432bf6973dd62$var$mapAnthropicErrorToStatusMessage;
module.exports.messagesFromParams = $215432bf6973dd62$var$messagesFromParams;
module.exports.setMessagesAttribute = $215432bf6973dd62$var$setMessagesAttribute;

});



parcelRegister("ctNgl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $5Wkkl = parcelRequire("5Wkkl");

var $g0XVK = parcelRequire("g0XVK");

var $jLFhR = parcelRequire("jLFhR");

var $h6ffH = parcelRequire("h6ffH");

var $fxLy8 = parcelRequire("fxLy8");

var $jZcA4 = parcelRequire("jZcA4");

var $h1zhX = parcelRequire("h1zhX");

var $l8ZaA = parcelRequire("l8ZaA");

var $h3uMY = parcelRequire("h3uMY");
/* eslint-disable max-lines */ /**
 * Extract model from parameters or chat context object
 * For chat instances, the model is available on the chat object as 'model' (older versions) or 'modelVersion' (newer versions)
 */ function $915e680427f052de$var$extractModel(params, context) {
    if ('model' in params && typeof params.model === 'string') return params.model;
    // Try to get model from chat context object (chat instance has model property)
    if (context && typeof context === 'object') {
        const contextObj = context;
        // Check for 'model' property (older versions, and streaming)
        if ('model' in contextObj && typeof contextObj.model === 'string') return contextObj.model;
        // Check for 'modelVersion' property (newer versions)
        if ('modelVersion' in contextObj && typeof contextObj.modelVersion === 'string') return contextObj.modelVersion;
    }
    return 'unknown';
}
/**
 * Extract generation config parameters
 */ function $915e680427f052de$var$extractConfigAttributes(config) {
    const attributes = {};
    if ('temperature' in config && typeof config.temperature === 'number') attributes[$fxLy8.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE] = config.temperature;
    if ('topP' in config && typeof config.topP === 'number') attributes[$fxLy8.GEN_AI_REQUEST_TOP_P_ATTRIBUTE] = config.topP;
    if ('topK' in config && typeof config.topK === 'number') attributes[$fxLy8.GEN_AI_REQUEST_TOP_K_ATTRIBUTE] = config.topK;
    if ('maxOutputTokens' in config && typeof config.maxOutputTokens === 'number') attributes[$fxLy8.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE] = config.maxOutputTokens;
    if ('frequencyPenalty' in config && typeof config.frequencyPenalty === 'number') attributes[$fxLy8.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE] = config.frequencyPenalty;
    if ('presencePenalty' in config && typeof config.presencePenalty === 'number') attributes[$fxLy8.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE] = config.presencePenalty;
    return attributes;
}
/**
 * Extract request attributes from method arguments
 * Builds the base attributes for span creation including system info, model, and config
 */ function $915e680427f052de$var$extractRequestAttributes(operationName, params, context) {
    const attributes = {
        [$fxLy8.GEN_AI_SYSTEM_ATTRIBUTE]: $h1zhX.GOOGLE_GENAI_SYSTEM_NAME,
        [$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE]: operationName,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.ai.google_genai'
    };
    if (params) {
        attributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $915e680427f052de$var$extractModel(params, context);
        // Extract generation config parameters
        if ('config' in params && typeof params.config === 'object' && params.config) {
            const config = params.config;
            Object.assign(attributes, $915e680427f052de$var$extractConfigAttributes(config));
            // Extract available tools from config
            if ('tools' in config && Array.isArray(config.tools)) {
                const functionDeclarations = config.tools.flatMap((tool)=>tool.functionDeclarations);
                attributes[$fxLy8.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = JSON.stringify(functionDeclarations);
            }
        }
    } else attributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] = $915e680427f052de$var$extractModel({}, context);
    return attributes;
}
/**
 * Add private request attributes to spans.
 * This is only recorded if recordInputs is true.
 * Handles different parameter formats for different Google GenAI methods.
 */ function $915e680427f052de$var$addPrivateRequestAttributes(span, params, isEmbeddings, enableTruncation) {
    if (isEmbeddings) {
        const contents = params.contents;
        if (contents != null) span.setAttribute($fxLy8.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE, typeof contents === 'string' ? contents : JSON.stringify(contents));
        return;
    }
    const messages = [];
    // config.systemInstruction: ContentUnion
    if ('config' in params && params.config && typeof params.config === 'object' && 'systemInstruction' in params.config && params.config.systemInstruction) messages.push(...$h3uMY.contentUnionToMessages(params.config.systemInstruction, 'system'));
    // For chats.create: history contains the conversation history
    if ('history' in params) messages.push(...$h3uMY.contentUnionToMessages(params.history, 'user'));
    // For models.generateContent: ContentListUnion
    if ('contents' in params) messages.push(...$h3uMY.contentUnionToMessages(params.contents, 'user'));
    // For chat.sendMessage: message can be PartListUnion
    if ('message' in params) messages.push(...$h3uMY.contentUnionToMessages(params.message, 'user'));
    if (Array.isArray(messages) && messages.length) {
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $jZcA4.extractSystemInstructions(messages);
        if (systemInstructions) span.setAttribute($fxLy8.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        span.setAttributes({
            [$fxLy8.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength,
            [$fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $jZcA4.getTruncatedJsonString(filteredMessages) : $jZcA4.getJsonString(filteredMessages)
        });
    }
}
/**
 * Add response attributes from the Google GenAI response
 * @see https://github.com/googleapis/js-genai/blob/v1.19.0/src/types.ts#L2313
 */ function $915e680427f052de$var$addResponseAttributes(span, response, recordOutputs) {
    if (!response || typeof response !== 'object') return;
    if (response.modelVersion) span.setAttribute($fxLy8.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, response.modelVersion);
    // Add usage metadata if present
    if (response.usageMetadata && typeof response.usageMetadata === 'object') {
        const usage = response.usageMetadata;
        if (typeof usage.promptTokenCount === 'number') span.setAttributes({
            [$fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE]: usage.promptTokenCount
        });
        if (typeof usage.candidatesTokenCount === 'number') span.setAttributes({
            [$fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE]: usage.candidatesTokenCount
        });
        if (typeof usage.totalTokenCount === 'number') span.setAttributes({
            [$fxLy8.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE]: usage.totalTokenCount
        });
    }
    // Add response text if recordOutputs is enabled
    if (recordOutputs && Array.isArray(response.candidates) && response.candidates.length > 0) {
        const responseTexts = response.candidates.map((candidate)=>{
            if (candidate.content?.parts && Array.isArray(candidate.content.parts)) return candidate.content.parts.map((part)=>typeof part.text === 'string' ? part.text : '').filter((text)=>text.length > 0).join('');
            return '';
        }).filter((text)=>text.length > 0);
        if (responseTexts.length > 0) span.setAttributes({
            [$fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE]: responseTexts.join('')
        });
    }
    // Add tool calls if recordOutputs is enabled
    if (recordOutputs && response.functionCalls) {
        const functionCalls = response.functionCalls;
        if (Array.isArray(functionCalls) && functionCalls.length > 0) span.setAttributes({
            [$fxLy8.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE]: JSON.stringify(functionCalls)
        });
    }
}
/**
 * Instrument any async or synchronous genai method with Sentry spans
 * Handles operations like models.generateContent and chat.sendMessage and chats.create
 * @see https://docs.sentry.io/platforms/javascript/guides/node/tracing/instrumentation/ai-agents-module/#manual-instrumentation
 */ function $915e680427f052de$var$instrumentMethod(originalMethod, methodPath, instrumentedMethod, context, options) {
    const isEmbeddings = instrumentedMethod.operation === 'embeddings';
    return new Proxy(originalMethod, {
        apply (target, _, args) {
            const operationName = instrumentedMethod.operation || 'unknown';
            const params = args[0];
            const requestAttributes = $915e680427f052de$var$extractRequestAttributes(operationName, params, context);
            const model = requestAttributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] ?? 'unknown';
            // Check if this is a streaming method
            if (instrumentedMethod.streaming) // Use startSpanManual for streaming methods to control span lifecycle
            return $jLFhR.startSpanManual({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, async (span)=>{
                try {
                    if (options.recordInputs && params) $915e680427f052de$var$addPrivateRequestAttributes(span, params, isEmbeddings, $jZcA4.shouldEnableTruncation(options.enableTruncation));
                    const stream = await target.apply(context, args);
                    return $l8ZaA.instrumentStream(stream, span, Boolean(options.recordOutputs));
                } catch (error) {
                    span.setStatus({
                        code: $g0XVK.SPAN_STATUS_ERROR,
                        message: 'internal_error'
                    });
                    $1XEa4.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.google_genai',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                    span.end();
                    throw error;
                }
            });
            // Single span for both sync and async operations
            return $jLFhR.startSpan({
                name: `${operationName} ${model}`,
                op: `gen_ai.${operationName}`,
                attributes: requestAttributes
            }, (span)=>{
                if (options.recordInputs && params) $915e680427f052de$var$addPrivateRequestAttributes(span, params, isEmbeddings, $jZcA4.shouldEnableTruncation(options.enableTruncation));
                return $h6ffH.handleCallbackErrors(()=>target.apply(context, args), (error)=>{
                    $1XEa4.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.google_genai',
                            data: {
                                function: methodPath
                            }
                        }
                    });
                }, ()=>{}, (result)=>{
                    // Only add response attributes for content-producing methods, not for embeddings
                    if (!isEmbeddings) $915e680427f052de$var$addResponseAttributes(span, result, options.recordOutputs);
                });
            });
        }
    });
}
/**
 * Create a deep proxy for Google GenAI client instrumentation
 * Recursively instruments methods and handles special cases like chats.create
 */ function $915e680427f052de$var$createDeepProxy(target, currentPath = '', options) {
    return new Proxy(target, {
        get: (t, prop, receiver)=>{
            const value = Reflect.get(t, prop, receiver);
            const methodPath = $jZcA4.buildMethodPath(currentPath, String(prop));
            const instrumentedMethod = $h1zhX.GOOGLE_GENAI_METHOD_REGISTRY[methodPath];
            if (typeof value === 'function' && instrumentedMethod) {
                // If an operation is specified, we need to instrument the method itself
                const wrappedMethod = instrumentedMethod.operation ? $915e680427f052de$var$instrumentMethod(value, methodPath, instrumentedMethod, t, options) : value.bind(t);
                if (!instrumentedMethod.proxyResultPath) return wrappedMethod;
                // If a proxyResultPath is specified, we need to proxy the result of the method.
                // Note: This currently only properly handles synchronous methods. For async methods,
                // the Promise itself would be proxied instead of the resolved value. Currently we
                // don't have a case where this is needed, so I'll keep it simple for now.
                return function(...args) {
                    const result = wrappedMethod(...args);
                    if (result && typeof result === 'object') return $915e680427f052de$var$createDeepProxy(result, instrumentedMethod.proxyResultPath, options);
                    return result;
                };
            }
            if (typeof value === 'function') // Bind non-instrumented functions to preserve the original `this` context
            return value.bind(t);
            if (value && typeof value === 'object') return $915e680427f052de$var$createDeepProxy(value, methodPath, options);
            return value;
        }
    });
}
/**
 * Instrument a Google GenAI client with Sentry tracing
 * Can be used across Node.js, Cloudflare Workers, and Vercel Edge
 *
 * @template T - The type of the client that extends client object
 * @param client - The Google GenAI client to instrument
 * @param options - Optional configuration for recording inputs and outputs
 * @returns The instrumented client with the same type as the input
 *
 * @example
 * ```typescript
 * import { GoogleGenAI } from '@google/genai';
 * import { instrumentGoogleGenAIClient } from '@sentry/core';
 *
 * const genAI = new GoogleGenAI({ apiKey: process.env.GOOGLE_GENAI_API_KEY });
 * const instrumentedClient = instrumentGoogleGenAIClient(genAI);
 *
 * // Now both chats.create and sendMessage will be instrumented
 * const chat = instrumentedClient.chats.create({ model: 'gemini-1.5-pro' });
 * const response = await chat.sendMessage({ message: 'Hello' });
 * ```
 */ function $915e680427f052de$var$instrumentGoogleGenAIClient(client, options) {
    return $915e680427f052de$var$createDeepProxy(client, '', $jZcA4.resolveAIRecordingOptions(options));
}
module.exports.extractModel = $915e680427f052de$var$extractModel;
module.exports.instrumentGoogleGenAIClient = $915e680427f052de$var$instrumentGoogleGenAIClient;

});
parcelRegister("h1zhX", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $c64de73a15f1a606$var$GOOGLE_GENAI_INTEGRATION_NAME = 'Google_GenAI';
// https://ai.google.dev/api/rest/v1/models/generateContent
// https://ai.google.dev/api/rest/v1/chats/sendMessage
// https://googleapis.github.io/js-genai/release_docs/classes/models.Models.html#generatecontentstream
// https://googleapis.github.io/js-genai/release_docs/classes/chats.Chat.html#sendmessagestream
const $c64de73a15f1a606$var$GOOGLE_GENAI_METHOD_REGISTRY = {
    'models.generateContent': {
        operation: 'generate_content'
    },
    'models.generateContentStream': {
        operation: 'generate_content',
        streaming: true
    },
    'models.embedContent': {
        operation: 'embeddings'
    },
    'chats.create': {
        proxyResultPath: 'chat'
    },
    'chat.sendMessage': {
        operation: 'chat'
    },
    'chat.sendMessageStream': {
        operation: 'chat',
        streaming: true
    }
};
// Constants for internal use
const $c64de73a15f1a606$var$GOOGLE_GENAI_SYSTEM_NAME = 'google_genai';
module.exports.GOOGLE_GENAI_INTEGRATION_NAME = $c64de73a15f1a606$var$GOOGLE_GENAI_INTEGRATION_NAME;
module.exports.GOOGLE_GENAI_METHOD_REGISTRY = $c64de73a15f1a606$var$GOOGLE_GENAI_METHOD_REGISTRY;
module.exports.GOOGLE_GENAI_SYSTEM_NAME = $c64de73a15f1a606$var$GOOGLE_GENAI_SYSTEM_NAME;

});

parcelRegister("l8ZaA", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $g0XVK = parcelRequire("g0XVK");

var $jZcA4 = parcelRequire("jZcA4");
/**
 * State object used to accumulate information from a stream of Google GenAI events.
 */ /**
 * Checks if a response chunk contains an error
 * @param chunk - The response chunk to check
 * @param span - The span to update if error is found
 * @returns Whether an error occurred
 */ function $f649cb60d826fc1a$var$isErrorChunk(chunk, span) {
    const feedback = chunk?.promptFeedback;
    if (feedback?.blockReason) {
        const message = feedback.blockReasonMessage ?? feedback.blockReason;
        span.setStatus({
            code: $g0XVK.SPAN_STATUS_ERROR,
            message: 'internal_error'
        });
        $1XEa4.captureException(`Content blocked: ${message}`, {
            mechanism: {
                handled: false,
                type: 'auto.ai.google_genai'
            }
        });
        return true;
    }
    return false;
}
/**
 * Processes response metadata from a chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 */ function $f649cb60d826fc1a$var$handleResponseMetadata(chunk, state) {
    if (typeof chunk.responseId === 'string') state.responseId = chunk.responseId;
    if (typeof chunk.modelVersion === 'string') state.responseModel = chunk.modelVersion;
    const usage = chunk.usageMetadata;
    if (usage) {
        if (typeof usage.promptTokenCount === 'number') state.promptTokens = usage.promptTokenCount;
        if (typeof usage.candidatesTokenCount === 'number') state.completionTokens = usage.candidatesTokenCount;
        if (typeof usage.totalTokenCount === 'number') state.totalTokens = usage.totalTokenCount;
    }
}
/**
 * Processes candidate content from a response chunk
 * @param chunk - The response chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 */ function $f649cb60d826fc1a$var$handleCandidateContent(chunk, state, recordOutputs) {
    if (Array.isArray(chunk.functionCalls)) state.toolCalls.push(...chunk.functionCalls);
    for (const candidate of chunk.candidates ?? []){
        if (candidate?.finishReason && !state.finishReasons.includes(candidate.finishReason)) state.finishReasons.push(candidate.finishReason);
        for (const part of candidate?.content?.parts ?? []){
            if (recordOutputs && part.text) state.responseTexts.push(part.text);
            if (part.functionCall) state.toolCalls.push({
                type: 'function',
                id: part.functionCall.id,
                name: part.functionCall.name,
                arguments: part.functionCall.args
            });
        }
    }
}
/**
 * Processes a single chunk from the Google GenAI stream
 * @param chunk - The chunk to process
 * @param state - The state of the streaming process
 * @param recordOutputs - Whether to record outputs
 * @param span - The span to update
 */ function $f649cb60d826fc1a$var$processChunk(chunk, state, recordOutputs, span) {
    if (!chunk || $f649cb60d826fc1a$var$isErrorChunk(chunk, span)) return;
    $f649cb60d826fc1a$var$handleResponseMetadata(chunk, state);
    $f649cb60d826fc1a$var$handleCandidateContent(chunk, state, recordOutputs);
}
/**
 * Instruments an async iterable stream of Google GenAI response chunks, updates the span with
 * streaming attributes and (optionally) the aggregated output text, and yields
 * each chunk from the input stream unchanged.
 */ async function* $f649cb60d826fc1a$var$instrumentStream(stream, span, recordOutputs) {
    const state = {
        responseTexts: [],
        finishReasons: [],
        toolCalls: []
    };
    try {
        for await (const chunk of stream){
            $f649cb60d826fc1a$var$processChunk(chunk, state, recordOutputs, span);
            yield chunk;
        }
    } finally{
        $jZcA4.endStreamSpan(span, state, recordOutputs);
    }
}
module.exports.instrumentStream = $f649cb60d826fc1a$var$instrumentStream;

});

parcelRegister("h3uMY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Copied from https://googleapis.github.io/js-genai/release_docs/index.html
/**
 *
 */ function $c6aa9989709d9ee9$var$contentUnionToMessages(content, role = 'user') {
    if (typeof content === 'string') return [
        {
            role: role,
            content: content
        }
    ];
    if (Array.isArray(content)) return content.flatMap((content)=>$c6aa9989709d9ee9$var$contentUnionToMessages(content, role));
    if (typeof content !== 'object' || !content) return [];
    if ('role' in content && typeof content.role === 'string') return [
        content
    ];
    if ('parts' in content) return [
        {
            ...content,
            role: role
        }
    ];
    return [
        {
            role: role,
            content: content
        }
    ];
}
module.exports.contentUnionToMessages = $c6aa9989709d9ee9$var$contentUnionToMessages;

});


parcelRegister("8t4TU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $5Wkkl = parcelRequire("5Wkkl");

var $g0XVK = parcelRequire("g0XVK");

var $jLFhR = parcelRequire("jLFhR");

var $fxLy8 = parcelRequire("fxLy8");

var $jZcA4 = parcelRequire("jZcA4");

var $kD0JT = parcelRequire("kD0JT");

var $jkIwU = parcelRequire("jkIwU");
/* eslint-disable max-lines */ /**
 * Creates a Sentry callback handler for LangChain
 * Returns a plain object that LangChain will call via duck-typing
 *
 * This is a stateful handler that tracks spans across multiple LangChain executions.
 */ function $62a4d55e6ed60e04$var$createLangChainCallbackHandler(options = {}) {
    const { recordInputs: recordInputs, recordOutputs: recordOutputs } = $jZcA4.resolveAIRecordingOptions(options);
    const enableTruncation = $jZcA4.shouldEnableTruncation(options.enableTruncation);
    // Internal state - single instance tracks all spans
    const spanMap = new Map();
    /**
   * Exit a span and clean up
   */ const exitSpan = (runId)=>{
        const span = spanMap.get(runId);
        if (span?.isRecording()) {
            span.end();
            spanMap.delete(runId);
        }
    };
    /**
   * Handler for LLM Start
   * This handler will be called by LangChain's callback handler when an LLM event is detected.
   */ const handler = {
        // Required LangChain BaseCallbackHandler properties
        lc_serializable: false,
        lc_namespace: [
            'langchain_core',
            'callbacks',
            'sentry'
        ],
        lc_secrets: undefined,
        lc_attributes: undefined,
        lc_aliases: undefined,
        lc_serializable_keys: undefined,
        lc_id: [
            'langchain_core',
            'callbacks',
            'sentry'
        ],
        lc_kwargs: {},
        name: 'SentryCallbackHandler',
        // BaseCallbackHandlerInput boolean flags
        ignoreLLM: false,
        ignoreChain: false,
        ignoreAgent: false,
        ignoreRetriever: false,
        ignoreCustomEvent: false,
        raiseError: false,
        awaitHandlers: true,
        handleLLMStart (llm, prompts, runId, _parentRunId, _extraParams, tags, metadata, _runName) {
            const invocationParams = $jkIwU.getInvocationParams(tags);
            const attributes = $jkIwU.extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, metadata);
            const modelName = attributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $jLFhR.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: 'gen_ai.chat',
                attributes: {
                    ...$jkIwU.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.chat'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chat Model Start Handler
        handleChatModelStart (llm, messages, runId, _parentRunId, extraParams, tags, metadata, _runName) {
            const invocationParams = $jkIwU.getInvocationParams(tags);
            const attributes = $jkIwU.extractChatModelRequestAttributes(llm, messages, recordInputs, enableTruncation, invocationParams, metadata);
            const toolDefsJson = $jkIwU.extractToolDefinitions(extraParams);
            if (toolDefsJson) attributes[$fxLy8.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE] = toolDefsJson;
            const modelName = attributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE];
            const operationName = attributes[$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE];
            $jLFhR.startSpanManual({
                name: `${operationName} ${modelName}`,
                op: 'gen_ai.chat',
                attributes: {
                    ...$jkIwU.getAgentNameFromMetadata(metadata),
                    ...attributes,
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.chat'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // LLM End Handler - note: handleLLMEnd with capital LLM (used by both LLMs and chat models!)
        handleLLMEnd (output, runId, _parentRunId, _tags, _extraParams) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                const attributes = $jkIwU.extractLlmResponseAttributes(output, recordOutputs);
                if (attributes) span.setAttributes(attributes);
                exitSpan(runId);
            }
        },
        // LLM Error Handler - note: handleLLMError with capital LLM
        handleLLMError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $g0XVK.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
                exitSpan(runId);
            }
            $1XEa4.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$kD0JT.LANGCHAIN_ORIGIN}.llm_error_handler`
                }
            });
        },
        // Chain Start Handler
        handleChainStart (chain, inputs, runId, _parentRunId, _tags, metadata, _runType, runName) {
            // Skip chain spans when inside an agent context (createReactAgent).
            // The agent already creates an invoke_agent span; internal chain steps
            // (ChannelWrite, Branch, prompt, etc.) are noise.
            if (metadata?.__sentry_langgraph__) return;
            const chainName = runName || chain.name || 'unknown_chain';
            const attributes = {
                [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.ai.langchain',
                'langchain.chain.name': chainName
            };
            if (recordInputs) attributes['langchain.chain.inputs'] = JSON.stringify(inputs);
            $jLFhR.startSpanManual({
                name: `chain ${chainName}`,
                op: 'gen_ai.invoke_agent',
                attributes: {
                    ...attributes,
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.invoke_agent'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Chain End Handler
        handleChainEnd (outputs, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                // Add outputs if recordOutputs is enabled
                if (recordOutputs) span.setAttributes({
                    'langchain.chain.outputs': JSON.stringify(outputs)
                });
                exitSpan(runId);
            }
        },
        // Chain Error Handler
        handleChainError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $g0XVK.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
                exitSpan(runId);
            }
            $1XEa4.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$kD0JT.LANGCHAIN_ORIGIN}.chain_error_handler`
                }
            });
        },
        // Tool Start Handler
        handleToolStart (tool, input, runId, _parentRunId, _tags, metadata, runName) {
            // Skip tool spans when inside an agent context (createReactAgent).
            // Tool spans are created by wrapToolsWithSpans with richer attributes.
            if (metadata?.__sentry_langgraph__) return;
            // runName is set to tool.name by LangChain's StructuredTool.call()
            const toolName = runName || tool.name || 'unknown_tool';
            const attributes = {
                ...$jkIwU.getAgentNameFromMetadata(metadata),
                [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $kD0JT.LANGCHAIN_ORIGIN,
                [$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'execute_tool',
                [$fxLy8.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName
            };
            if (recordInputs) attributes[$fxLy8.GEN_AI_TOOL_INPUT_ATTRIBUTE] = input;
            $jLFhR.startSpanManual({
                name: `execute_tool ${toolName}`,
                op: 'gen_ai.execute_tool',
                attributes: {
                    ...attributes,
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.execute_tool'
                }
            }, (span)=>{
                spanMap.set(runId, span);
                return span;
            });
        },
        // Tool End Handler
        handleToolEnd (output, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                if (recordOutputs) {
                    // LangChain tools may return ToolMessage objects — extract the content
                    const outputObj = output;
                    const content = outputObj && typeof outputObj === 'object' && 'content' in outputObj ? outputObj.content : output;
                    span.setAttributes({
                        [$fxLy8.GEN_AI_TOOL_OUTPUT_ATTRIBUTE]: typeof content === 'string' ? content : JSON.stringify(content)
                    });
                }
                exitSpan(runId);
            }
        },
        // Tool Error Handler
        handleToolError (error, runId) {
            const span = spanMap.get(runId);
            if (span?.isRecording()) {
                span.setStatus({
                    code: $g0XVK.SPAN_STATUS_ERROR,
                    message: 'internal_error'
                });
                exitSpan(runId);
            }
            $1XEa4.captureException(error, {
                mechanism: {
                    handled: false,
                    type: `${$kD0JT.LANGCHAIN_ORIGIN}.tool_error_handler`
                }
            });
        },
        // LangChain BaseCallbackHandler required methods
        copy () {
            return handler;
        },
        toJSON () {
            return {
                lc: 1,
                type: 'not_implemented',
                id: handler.lc_id
            };
        },
        toJSONNotImplemented () {
            return {
                lc: 1,
                type: 'not_implemented',
                id: handler.lc_id
            };
        }
    };
    return handler;
}
module.exports.createLangChainCallbackHandler = $62a4d55e6ed60e04$var$createLangChainCallbackHandler;

});
parcelRegister("kD0JT", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $f04805fba6c4cf44$var$LANGCHAIN_INTEGRATION_NAME = 'LangChain';
const $f04805fba6c4cf44$var$LANGCHAIN_ORIGIN = 'auto.ai.langchain';
const $f04805fba6c4cf44$var$ROLE_MAP = {
    human: 'user',
    ai: 'assistant',
    assistant: 'assistant',
    system: 'system',
    function: 'function',
    tool: 'tool'
};
module.exports.LANGCHAIN_INTEGRATION_NAME = $f04805fba6c4cf44$var$LANGCHAIN_INTEGRATION_NAME;
module.exports.LANGCHAIN_ORIGIN = $f04805fba6c4cf44$var$LANGCHAIN_ORIGIN;
module.exports.ROLE_MAP = $f04805fba6c4cf44$var$ROLE_MAP;

});

parcelRegister("jkIwU", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $5Wkkl = parcelRequire("5Wkkl");

var $fxLy8 = parcelRequire("fxLy8");

var $gGt5m = parcelRequire("gGt5m");

var $jZcA4 = parcelRequire("jZcA4");

var $kD0JT = parcelRequire("kD0JT");
/**
 * Assigns an attribute only when the value is neither `undefined` nor `null`.
 *
 * We keep this tiny helper because call sites are repetitive and easy to miswrite.
 * It also preserves falsy-but-valid values like `0` and `""`.
 */ const $e1326d41b35d7f69$var$setIfDefined = (target, key, value)=>{
    if (value != null) target[key] = value;
};
/**
 * Like `setIfDefined`, but converts the value with `Number()` and skips only when the
 * result is `NaN`. This ensures numeric 0 makes it through (unlike truthy checks).
 */ const $e1326d41b35d7f69$var$setNumberIfDefined = (target, key, value)=>{
    const n = Number(value);
    if (!Number.isNaN(n)) target[key] = n;
};
/**
 * Converts a value to a string. Avoids double-quoted JSON strings where a plain
 * string is desired, but still handles objects/arrays safely.
 */ function $e1326d41b35d7f69$var$asString(v) {
    if (typeof v === 'string') return v;
    try {
        return JSON.stringify(v);
    } catch  {
        return String(v);
    }
}
/**
 * Converts message content to a string, stripping inline media (base64 images, audio, etc.)
 * from multimodal content before stringification so downstream media stripping can't miss it.
 *
 * @example
 * // String content passes through unchanged:
 * normalizeContent("Hello") // => "Hello"
 *
 * // Multimodal array content — media is replaced with "[Blob substitute]" before JSON.stringify:
 * normalizeContent([
 *   { type: "text", text: "What color?" },
 *   { type: "image_url", image_url: { url: "data:image/png;base64,iVBOR..." } }
 * ])
 * // => '[{"type":"text","text":"What color?"},{"type":"image_url","image_url":{"url":"[Blob substitute]"}}]'
 *
 * // Without this, asString() would JSON.stringify the raw array and the base64 blob
 * // would end up in span attributes, since downstream stripping only works on objects.
 */ function $e1326d41b35d7f69$var$normalizeContent(v) {
    if (Array.isArray(v)) try {
        const stripped = v.map((part)=>part && typeof part === 'object' && $gGt5m.isContentMedia(part) ? $gGt5m.stripInlineMediaFromSingleMessage(part) : part);
        return JSON.stringify(stripped);
    } catch  {
        return String(v);
    }
    return $e1326d41b35d7f69$var$asString(v);
}
/**
 * Normalizes a single role token to our canonical set.
 *
 * @param role Incoming role value (free-form, any casing)
 * @returns Canonical role: 'user' | 'assistant' | 'system' | 'function' | 'tool' | <passthrough>
 */ function $e1326d41b35d7f69$var$normalizeMessageRole(role) {
    const normalized = role.toLowerCase();
    return $kD0JT.ROLE_MAP[normalized] ?? normalized;
}
/**
 * Infers a role from a LangChain message constructor name.
 *
 * Checks for substrings like "System", "Human", "AI", etc.
 */ function $e1326d41b35d7f69$var$normalizeRoleNameFromCtor(name) {
    if (name.includes('System')) return 'system';
    if (name.includes('Human')) return 'user';
    if (name.includes('AI') || name.includes('Assistant')) return 'assistant';
    if (name.includes('Function')) return 'function';
    if (name.includes('Tool')) return 'tool';
    return 'user';
}
/**
 * Returns invocation params from a LangChain `tags` object.
 *
 * LangChain often passes runtime parameters (model, temperature, etc.) via the
 * `tags.invocation_params` bag. If `tags` is an array (LangChain sometimes uses
 * string tags), we return `undefined`.
 *
 * @param tags LangChain tags (string[] or record)
 * @returns The `invocation_params` object, if present
 */ function $e1326d41b35d7f69$var$getInvocationParams(tags) {
    if (!tags || Array.isArray(tags)) return undefined;
    return tags.invocation_params;
}
/**
 * Normalizes a heterogeneous set of LangChain messages to `{ role, content }`.
 *
 * Why so many branches? LangChain messages can arrive in several shapes:
 *  - Message classes with `_getType()` (most reliable)
 *  - Classes with meaningful constructor names (e.g. `SystemMessage`)
 *  - Plain objects with `type`, or `{ role, content }`
 *  - Serialized format with `{ lc: 1, id: [...], kwargs: { content } }`
 * We preserve the prioritization to minimize behavioral drift.
 *
 * @param messages Mixed LangChain messages
 * @returns Array of normalized `{ role, content }`
 */ function $e1326d41b35d7f69$var$normalizeLangChainMessages(messages) {
    return messages.map((message)=>{
        // 1) Prefer _getType() when present
        const maybeGetType = message._getType;
        if (typeof maybeGetType === 'function') {
            const messageType = maybeGetType.call(message);
            return {
                role: $e1326d41b35d7f69$var$normalizeMessageRole(messageType),
                content: $e1326d41b35d7f69$var$normalizeContent(message.content)
            };
        }
        // 2) Serialized LangChain format (lc: 1) - check before constructor name
        // This is more reliable than constructor.name which can be lost during serialization
        if (message.lc === 1 && message.kwargs) {
            const id = message.id;
            const messageType = Array.isArray(id) && id.length > 0 ? id[id.length - 1] : '';
            const role = typeof messageType === 'string' ? $e1326d41b35d7f69$var$normalizeRoleNameFromCtor(messageType) : 'user';
            return {
                role: $e1326d41b35d7f69$var$normalizeMessageRole(role),
                content: $e1326d41b35d7f69$var$normalizeContent(message.kwargs?.content)
            };
        }
        // 3) Then objects with `type`
        if (message.type) {
            const role = String(message.type).toLowerCase();
            return {
                role: $e1326d41b35d7f69$var$normalizeMessageRole(role),
                content: $e1326d41b35d7f69$var$normalizeContent(message.content)
            };
        }
        // 4) Then objects with `{ role, content }` - check before constructor name
        // Plain objects have constructor.name="Object" which would incorrectly default to "user"
        if (message.role) return {
            role: $e1326d41b35d7f69$var$normalizeMessageRole(String(message.role)),
            content: $e1326d41b35d7f69$var$normalizeContent(message.content)
        };
        // 5) Then try constructor name (SystemMessage / HumanMessage / ...)
        // Only use this if we haven't matched a more specific case
        const ctor = message.constructor?.name;
        if (ctor && ctor !== 'Object') return {
            role: $e1326d41b35d7f69$var$normalizeMessageRole($e1326d41b35d7f69$var$normalizeRoleNameFromCtor(ctor)),
            content: $e1326d41b35d7f69$var$normalizeContent(message.content)
        };
        // 6) Fallback: treat as user text
        return {
            role: 'user',
            content: $e1326d41b35d7f69$var$normalizeContent(message.content)
        };
    });
}
/**
 * Extracts request attributes common to both LLM and ChatModel invocations.
 *
 * Source precedence:
 * 1) `invocationParams` (highest)
 * 2) `langSmithMetadata`
 *
 * Numeric values are set even when 0 (e.g. `temperature: 0`), but skipped if `NaN`.
 */ function $e1326d41b35d7f69$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata) {
    const attrs = {};
    // Get kwargs if available (from constructor type)
    const kwargs = 'kwargs' in serialized ? serialized.kwargs : undefined;
    const temperature = invocationParams?.temperature ?? langSmithMetadata?.ls_temperature ?? kwargs?.temperature;
    $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_REQUEST_TEMPERATURE_ATTRIBUTE, temperature);
    const maxTokens = invocationParams?.max_tokens ?? langSmithMetadata?.ls_max_tokens ?? kwargs?.max_tokens;
    $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_REQUEST_MAX_TOKENS_ATTRIBUTE, maxTokens);
    const topP = invocationParams?.top_p ?? kwargs?.top_p;
    $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_REQUEST_TOP_P_ATTRIBUTE, topP);
    const frequencyPenalty = invocationParams?.frequency_penalty;
    $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_REQUEST_FREQUENCY_PENALTY_ATTRIBUTE, frequencyPenalty);
    const presencePenalty = invocationParams?.presence_penalty;
    $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_REQUEST_PRESENCE_PENALTY_ATTRIBUTE, presencePenalty);
    // LangChain uses `stream`. We only set the attribute if the key actually exists
    // (some callbacks report `false` even on streamed requests, this stems from LangChain's callback handler).
    if (invocationParams && 'stream' in invocationParams) $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_REQUEST_STREAM_ATTRIBUTE, Boolean(invocationParams.stream));
    return attrs;
}
/**
 * Small helper to assemble boilerplate attributes shared by both request extractors.
 * Always uses 'chat' as the operation type for all LLM and chat model operations.
 */ function $e1326d41b35d7f69$var$baseRequestAttributes(system, modelName, serialized, invocationParams, langSmithMetadata) {
    return {
        [$fxLy8.GEN_AI_SYSTEM_ATTRIBUTE]: $e1326d41b35d7f69$var$asString(system ?? 'langchain'),
        [$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'chat',
        [$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: $e1326d41b35d7f69$var$asString(modelName),
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $kD0JT.LANGCHAIN_ORIGIN,
        ...$e1326d41b35d7f69$var$extractCommonRequestAttributes(serialized, invocationParams, langSmithMetadata)
    };
}
/**
 * Extracts attributes for plain LLM invocations (string prompts).
 *
 * - Operation is tagged as `chat` following OpenTelemetry semantic conventions.
 *   LangChain LLM operations are treated as chat operations.
 * - When `recordInputs` is true, string prompts are wrapped into `{role:"user"}`
 *   messages to align with the chat schema used elsewhere.
 */ function $e1326d41b35d7f69$var$extractLLMRequestAttributes(llm, prompts, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider;
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? 'unknown';
    const attrs = $e1326d41b35d7f69$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(prompts) && prompts.length > 0) {
        $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, prompts.length);
        const messages = prompts.map((p)=>({
                role: 'user',
                content: p
            }));
        $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $jZcA4.getTruncatedJsonString(messages) : $jZcA4.getJsonString(messages));
    }
    return attrs;
}
/**
 * Extracts attributes for ChatModel invocations (array-of-arrays of messages).
 *
 * - Operation is tagged as `chat` following OpenTelemetry semantic conventions.
 *   LangChain chat model operations are chat operations.
 * - We flatten LangChain's `LangChainMessage[][]` and normalize shapes into a
 *   consistent `{ role, content }` array when `recordInputs` is true.
 * - Provider system value falls back to `serialized.id?.[2]`.
 */ function $e1326d41b35d7f69$var$extractChatModelRequestAttributes(llm, langChainMessages, recordInputs, enableTruncation, invocationParams, langSmithMetadata) {
    const system = langSmithMetadata?.ls_provider ?? llm.id?.[2];
    const modelName = invocationParams?.model ?? langSmithMetadata?.ls_model_name ?? 'unknown';
    const attrs = $e1326d41b35d7f69$var$baseRequestAttributes(system, modelName, llm, invocationParams, langSmithMetadata);
    if (recordInputs && Array.isArray(langChainMessages) && langChainMessages.length > 0) {
        const normalized = $e1326d41b35d7f69$var$normalizeLangChainMessages(langChainMessages.flat());
        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $jZcA4.extractSystemInstructions(normalized);
        if (systemInstructions) $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
        $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE, filteredLength);
        $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE, enableTruncation ? $jZcA4.getTruncatedJsonString(filteredMessages) : $jZcA4.getJsonString(filteredMessages));
    }
    return attrs;
}
/**
 * Extracts tool calls from generations and records them on the span attributes.
 * Prefers message.tool_calls (LangChain's normalized format). Falls back to
 * scanning message.content for Anthropic-style tool_use items in older versions
 * where tool_calls may not be populated.
 */ function $e1326d41b35d7f69$var$addToolCallsAttributes(generations, attrs) {
    const toolCalls = [];
    const flatGenerations = generations.flat();
    for (const gen of flatGenerations){
        const msg = gen.message;
        const msgToolCalls = msg?.tool_calls;
        if (Array.isArray(msgToolCalls) && msgToolCalls.length > 0) toolCalls.push(...msgToolCalls);
        else {
            // Fallback for older LangChain versions: scan message.content for Anthropic-style tool_use
            const content = gen.message?.content;
            if (Array.isArray(content)) for (const item of content){
                const t = item;
                if (t.type === 'tool_use') toolCalls.push(t);
            }
        }
    }
    if (toolCalls.length > 0) $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, $e1326d41b35d7f69$var$asString(toolCalls));
}
/**
 * Adds token usage attributes, supporting both OpenAI (`tokenUsage`) and Anthropic (`usage`) formats.
 * - Preserve zero values (0 tokens) by avoiding truthy checks.
 * - Compute a total for Anthropic when not explicitly provided.
 * - Include cache token metrics when present.
 */ function $e1326d41b35d7f69$var$addTokenUsageAttributes(llmOutput, attrs) {
    if (!llmOutput) return;
    const tokenUsage = llmOutput.tokenUsage;
    const anthropicUsage = llmOutput.usage;
    if (tokenUsage) {
        $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, tokenUsage.promptTokens);
        $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, tokenUsage.completionTokens);
        $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, tokenUsage.totalTokens);
    } else if (anthropicUsage) {
        $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.input_tokens);
        $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, anthropicUsage.output_tokens);
        // Compute total when not provided by the provider.
        const input = Number(anthropicUsage.input_tokens);
        const output = Number(anthropicUsage.output_tokens);
        const total = (Number.isNaN(input) ? 0 : input) + (Number.isNaN(output) ? 0 : output);
        if (total > 0) $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, total);
        // Extra Anthropic cache metrics (present only when caching is enabled)
        if (anthropicUsage.cache_creation_input_tokens !== undefined) $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_USAGE_CACHE_CREATION_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_creation_input_tokens);
        if (anthropicUsage.cache_read_input_tokens !== undefined) $e1326d41b35d7f69$var$setNumberIfDefined(attrs, $fxLy8.GEN_AI_USAGE_CACHE_READ_INPUT_TOKENS_ATTRIBUTE, anthropicUsage.cache_read_input_tokens);
    }
}
/**
 * Extracts response-related attributes based on a `LangChainLLMResult`.
 *
 * - Records finish reasons when present on generations (e.g., OpenAI)
 * - When `recordOutputs` is true, captures textual response content and any
 *   tool calls.
 * - Also propagates model name (`model_name` or `model`), response `id`, and
 *   `stop_reason` (for providers that use it).
 */ function $e1326d41b35d7f69$var$extractLlmResponseAttributes(llmResult, recordOutputs) {
    if (!llmResult) return;
    const attrs = {};
    if (Array.isArray(llmResult.generations)) {
        const finishReasons = llmResult.generations.flat().map((g)=>{
            // v1 uses generationInfo.finish_reason
            if (g.generationInfo?.finish_reason) return g.generationInfo.finish_reason;
            // v0.3+ uses generation_info.finish_reason
            if (g.generation_info?.finish_reason) return g.generation_info.finish_reason;
            return null;
        }).filter((r)=>typeof r === 'string');
        if (finishReasons.length > 0) $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, $e1326d41b35d7f69$var$asString(finishReasons));
        // Tool calls metadata (names, IDs) are not PII, so capture them regardless of recordOutputs
        $e1326d41b35d7f69$var$addToolCallsAttributes(llmResult.generations, attrs);
        if (recordOutputs) {
            const texts = llmResult.generations.flat().map((gen)=>gen.text ?? gen.message?.content).filter((t)=>typeof t === 'string');
            if (texts.length > 0) $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, $e1326d41b35d7f69$var$asString(texts));
        }
    }
    $e1326d41b35d7f69$var$addTokenUsageAttributes(llmResult.llmOutput, attrs);
    const llmOutput = llmResult.llmOutput;
    // Extract from v1 generations structure if available
    const firstGeneration = llmResult.generations?.[0]?.[0];
    const v1Message = firstGeneration?.message;
    // Provider model identifier: `model_name` (OpenAI-style) or `model` (others)
    // v1 stores this in message.response_metadata.model_name
    const modelName = llmOutput?.model_name ?? llmOutput?.model ?? v1Message?.response_metadata?.model_name;
    if (modelName) $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, modelName);
    // Response ID: v1 stores this in message.id
    const responseId = llmOutput?.id ?? v1Message?.id;
    if (responseId) $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_RESPONSE_ID_ATTRIBUTE, responseId);
    // Stop reason: v1 stores this in message.response_metadata.finish_reason
    const stopReason = llmOutput?.stop_reason ?? v1Message?.response_metadata?.finish_reason;
    if (stopReason) $e1326d41b35d7f69$var$setIfDefined(attrs, $fxLy8.GEN_AI_RESPONSE_STOP_REASON_ATTRIBUTE, $e1326d41b35d7f69$var$asString(stopReason));
    return attrs;
}
function $e1326d41b35d7f69$var$getAgentNameFromMetadata(metadata) {
    const attrs = {};
    // lc_agent_name is injected by instrumentCompiledGraphInvoke (langgraph integration)
    const agentName = metadata?.lc_agent_name;
    if (typeof agentName === 'string') attrs[$fxLy8.GEN_AI_AGENT_NAME_ATTRIBUTE] = agentName;
    return attrs;
}
function $e1326d41b35d7f69$var$extractToolDefinitions(extraParams) {
    const tools = extraParams?.invocation_params?.tools ?? extraParams?.options?.tools;
    if (!Array.isArray(tools) || tools.length === 0) return undefined;
    const toolDefs = tools.map((tool)=>{
        const fn = tool.function;
        return {
            type: 'function',
            name: tool.name ?? fn?.name ?? '',
            description: tool.description ?? fn?.description
        };
    });
    return JSON.stringify(toolDefs);
}
module.exports.extractChatModelRequestAttributes = $e1326d41b35d7f69$var$extractChatModelRequestAttributes;
module.exports.extractLLMRequestAttributes = $e1326d41b35d7f69$var$extractLLMRequestAttributes;
module.exports.extractLlmResponseAttributes = $e1326d41b35d7f69$var$extractLlmResponseAttributes;
module.exports.extractToolDefinitions = $e1326d41b35d7f69$var$extractToolDefinitions;
module.exports.getAgentNameFromMetadata = $e1326d41b35d7f69$var$getAgentNameFromMetadata;
module.exports.getInvocationParams = $e1326d41b35d7f69$var$getInvocationParams;
module.exports.normalizeLangChainMessages = $e1326d41b35d7f69$var$normalizeLangChainMessages;

});


parcelRegister("ggJiZ", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $5Wkkl = parcelRequire("5Wkkl");

var $g0XVK = parcelRequire("g0XVK");

var $jLFhR = parcelRequire("jLFhR");

var $fxLy8 = parcelRequire("fxLy8");

var $jZcA4 = parcelRequire("jZcA4");

var $8t4TU = parcelRequire("8t4TU");

var $jkIwU = parcelRequire("jkIwU");

var $J7Vkx = parcelRequire("J7Vkx");

var $iWGQr = parcelRequire("iWGQr");
let $bd8148a51331c226$var$_insideCreateReactAgent = false;
const $bd8148a51331c226$var$SENTRY_PATCHED = '__sentry_patched__';
/**
 * Instruments StateGraph's compile method to create spans for agent creation and invocation
 *
 * Wraps the compile() method to:
 * - Create a `gen_ai.create_agent` span when compile() is called
 * - Automatically wrap the invoke() method on the returned compiled graph with a `gen_ai.invoke_agent` span
 *
 */ function $bd8148a51331c226$var$instrumentStateGraphCompile(originalCompile, options) {
    if (Object.prototype.hasOwnProperty.call(originalCompile, $bd8148a51331c226$var$SENTRY_PATCHED)) return originalCompile;
    const sentryHandler = $8t4TU.createLangChainCallbackHandler(options);
    const wrapped = new Proxy(originalCompile, {
        apply (target, thisArg, args) {
            // Skip when called from within createReactAgent to avoid duplicate instrumentation
            if ($bd8148a51331c226$var$_insideCreateReactAgent) return Reflect.apply(target, thisArg, args);
            return $jLFhR.startSpan({
                op: 'gen_ai.create_agent',
                name: 'create_agent',
                attributes: {
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $J7Vkx.LANGGRAPH_ORIGIN,
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: 'gen_ai.create_agent',
                    [$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'create_agent'
                }
            }, (span)=>{
                try {
                    const compiledGraph = Reflect.apply(target, thisArg, args);
                    const compileOptions = args.length > 0 ? args[0] : {};
                    // Extract graph name
                    if (compileOptions?.name && typeof compileOptions.name === 'string') {
                        span.setAttribute($fxLy8.GEN_AI_AGENT_NAME_ATTRIBUTE, compileOptions.name);
                        span.updateName(`create_agent ${compileOptions.name}`);
                    }
                    // Instrument agent invoke method on the compiled graph
                    const originalInvoke = compiledGraph.invoke;
                    if (originalInvoke && typeof originalInvoke === 'function') compiledGraph.invoke = $bd8148a51331c226$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, options, undefined, sentryHandler);
                    return compiledGraph;
                } catch (error) {
                    span.setStatus({
                        code: $g0XVK.SPAN_STATUS_ERROR,
                        message: 'internal_error'
                    });
                    $1XEa4.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.langgraph.error'
                        }
                    });
                    throw error;
                }
            });
        }
    });
    Object.defineProperty(wrapped, $bd8148a51331c226$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
/**
 * Instruments CompiledGraph's invoke method to create spans for agent invocation
 *
 * Creates a `gen_ai.invoke_agent` span when invoke() is called
 */ function $bd8148a51331c226$var$instrumentCompiledGraphInvoke(originalInvoke, graphInstance, compileOptions, options, llm, sentryCallbackHandler) {
    return new Proxy(originalInvoke, {
        apply (target, thisArg, args) {
            const modelName = llm?.modelName ?? llm?.model;
            return $jLFhR.startSpan({
                op: 'gen_ai.invoke_agent',
                name: 'invoke_agent',
                attributes: {
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $J7Vkx.LANGGRAPH_ORIGIN,
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $fxLy8.GEN_AI_INVOKE_AGENT_OPERATION_ATTRIBUTE,
                    [$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'invoke_agent'
                }
            }, async (span)=>{
                try {
                    const graphName = compileOptions?.name;
                    if (graphName && typeof graphName === 'string') {
                        span.setAttribute($fxLy8.GEN_AI_PIPELINE_NAME_ATTRIBUTE, graphName);
                        span.setAttribute($fxLy8.GEN_AI_AGENT_NAME_ATTRIBUTE, graphName);
                        span.updateName(`invoke_agent ${graphName}`);
                    }
                    if (modelName) span.setAttribute($fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE, modelName);
                    // Extract thread_id from the config (second argument)
                    // LangGraph uses config.configurable.thread_id for conversation/session linking
                    const config = args.length > 1 ? args[1] : undefined;
                    const configurable = config?.configurable;
                    const threadId = configurable?.thread_id;
                    if (threadId && typeof threadId === 'string') span.setAttribute($fxLy8.GEN_AI_CONVERSATION_ID_ATTRIBUTE, threadId);
                    // Inject callback handler and agent name into invoke config
                    if (sentryCallbackHandler) {
                        const invokeConfig = args[1] ?? {};
                        args[1] = invokeConfig;
                        const existingMetadata = invokeConfig.metadata ?? {};
                        invokeConfig.metadata = {
                            ...existingMetadata,
                            __sentry_langgraph__: true,
                            ...typeof graphName === 'string' ? {
                                lc_agent_name: graphName
                            } : {}
                        };
                        invokeConfig.callbacks = $iWGQr.mergeSentryCallback(invokeConfig.callbacks, sentryCallbackHandler);
                    }
                    // Extract available tools from the graph instance
                    const tools = $iWGQr.extractToolsFromCompiledGraph(graphInstance);
                    if (tools) span.setAttribute($fxLy8.GEN_AI_REQUEST_AVAILABLE_TOOLS_ATTRIBUTE, JSON.stringify(tools));
                    // Parse input messages
                    const recordInputs = options.recordInputs;
                    const recordOutputs = options.recordOutputs;
                    const inputMessages = args.length > 0 ? args[0]?.messages ?? [] : [];
                    if (inputMessages && recordInputs) {
                        const normalizedMessages = $jkIwU.normalizeLangChainMessages(inputMessages);
                        const { systemInstructions: systemInstructions, filteredMessages: filteredMessages } = $jZcA4.extractSystemInstructions(normalizedMessages);
                        if (systemInstructions) span.setAttribute($fxLy8.GEN_AI_SYSTEM_INSTRUCTIONS_ATTRIBUTE, systemInstructions);
                        const enableTruncation = $jZcA4.shouldEnableTruncation(options.enableTruncation);
                        const filteredLength = Array.isArray(filteredMessages) ? filteredMessages.length : 0;
                        span.setAttributes({
                            [$fxLy8.GEN_AI_INPUT_MESSAGES_ATTRIBUTE]: enableTruncation ? $jZcA4.getTruncatedJsonString(filteredMessages) : $jZcA4.getJsonString(filteredMessages),
                            [$fxLy8.GEN_AI_INPUT_MESSAGES_ORIGINAL_LENGTH_ATTRIBUTE]: filteredLength
                        });
                    }
                    // Call original invoke
                    const result = await Reflect.apply(target, thisArg, args);
                    if (recordOutputs) $iWGQr.setResponseAttributes(span, inputMessages ?? null, result);
                    return result;
                } catch (error) {
                    span.setStatus({
                        code: $g0XVK.SPAN_STATUS_ERROR,
                        message: 'internal_error'
                    });
                    $1XEa4.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.langgraph.error'
                        }
                    });
                    throw error;
                }
            });
        }
    });
}
/**
 * Instruments createReactAgent to create invoke_agent and execute_tool spans.
 */ function $bd8148a51331c226$var$instrumentCreateReactAgent(originalCreateReactAgent, options) {
    if (Object.prototype.hasOwnProperty.call(originalCreateReactAgent, $bd8148a51331c226$var$SENTRY_PATCHED)) return originalCreateReactAgent;
    const resolvedOptions = $jZcA4.resolveAIRecordingOptions(options);
    const sentryHandler = $8t4TU.createLangChainCallbackHandler(resolvedOptions);
    const wrapped = new Proxy(originalCreateReactAgent, {
        apply (target, thisArg, args) {
            const llm = $iWGQr.extractLLMFromParams(args);
            const agentName = $iWGQr.extractAgentNameFromParams(args);
            // Wrap tools with execute_tool spans (direct access gives us name, type, description)
            const params = args[0];
            if (params && Array.isArray(params.tools) && params.tools.length > 0) $iWGQr.wrapToolsWithSpans(params.tools, resolvedOptions, agentName ?? undefined);
            // Suppress StateGraph.compile instrumentation inside createReactAgent
            $bd8148a51331c226$var$_insideCreateReactAgent = true;
            let compiledGraph;
            try {
                compiledGraph = Reflect.apply(target, thisArg, args);
            } finally{
                $bd8148a51331c226$var$_insideCreateReactAgent = false;
            }
            // Wrap invoke() on the returned compiled graph
            const originalInvoke = compiledGraph.invoke;
            if (originalInvoke && typeof originalInvoke === 'function') {
                const compileOptions = {};
                if (agentName) compileOptions.name = agentName;
                compiledGraph.invoke = $bd8148a51331c226$var$instrumentCompiledGraphInvoke(originalInvoke.bind(compiledGraph), compiledGraph, compileOptions, resolvedOptions, llm, sentryHandler);
            }
            return compiledGraph;
        }
    });
    Object.defineProperty(wrapped, $bd8148a51331c226$var$SENTRY_PATCHED, {
        value: true,
        enumerable: false
    });
    return wrapped;
}
/**
 * Directly instruments a StateGraph instance to add tracing spans
 *
 * This function can be used to manually instrument LangGraph StateGraph instances
 * in environments where automatic instrumentation is not available or desired.
 *
 * @param stateGraph - The StateGraph instance to instrument
 * @param options - Optional configuration for recording inputs/outputs
 *
 * @example
 * ```typescript
 * import { instrumentLangGraph } from '@sentry/cloudflare';
 * import { StateGraph } from '@langchain/langgraph';
 *
 * const graph = new StateGraph(MessagesAnnotation)
 *   .addNode('agent', mockLlm)
 *   .addEdge(START, 'agent')
 *   .addEdge('agent', END);
 *
 * instrumentLangGraph(graph, { recordInputs: true, recordOutputs: true });
 * const compiled = graph.compile({ name: 'my_agent' });
 * ```
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bd8148a51331c226$var$instrumentLangGraph(stateGraph, options) {
    stateGraph.compile = $bd8148a51331c226$var$instrumentStateGraphCompile(stateGraph.compile, $jZcA4.resolveAIRecordingOptions(options));
    return stateGraph;
}
module.exports.instrumentCreateReactAgent = $bd8148a51331c226$var$instrumentCreateReactAgent;
module.exports.instrumentLangGraph = $bd8148a51331c226$var$instrumentLangGraph;
module.exports.instrumentStateGraphCompile = $bd8148a51331c226$var$instrumentStateGraphCompile;

});
parcelRegister("J7Vkx", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
const $087a598fd53db897$var$LANGGRAPH_INTEGRATION_NAME = 'LangGraph';
const $087a598fd53db897$var$LANGGRAPH_ORIGIN = 'auto.ai.langgraph';
module.exports.LANGGRAPH_INTEGRATION_NAME = $087a598fd53db897$var$LANGGRAPH_INTEGRATION_NAME;
module.exports.LANGGRAPH_ORIGIN = $087a598fd53db897$var$LANGGRAPH_ORIGIN;

});

parcelRegister("iWGQr", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $5Wkkl = parcelRequire("5Wkkl");

var $g0XVK = parcelRequire("g0XVK");

var $jLFhR = parcelRequire("jLFhR");

var $fxLy8 = parcelRequire("fxLy8");

var $jkIwU = parcelRequire("jkIwU");

var $J7Vkx = parcelRequire("J7Vkx");
/**
 * Extract LLM model object from createReactAgent params
 */ function $dcaee0e34fe8f912$var$extractLLMFromParams(args) {
    const arg = args[0];
    if (typeof arg !== 'object' || !arg || !('llm' in arg) || !arg.llm || typeof arg.llm !== 'object') return null;
    const llm = arg.llm;
    if (typeof llm.modelName !== 'string' && typeof llm.model !== 'string') return null;
    return llm;
}
/**
 * Extract agent name from createReactAgent params
 */ function $dcaee0e34fe8f912$var$extractAgentNameFromParams(args) {
    const arg = args[0];
    if (typeof arg === 'object' && !!arg && 'name' in arg && typeof arg.name === 'string') return arg.name;
    return null;
}
/**
 * Wraps an array of LangChain tools so each invocation creates a gen_ai.execute_tool span.
 *
 * Wraps each tool's invoke() method in place. A marker prevents double-wrapping.
 */ function $dcaee0e34fe8f912$var$wrapToolsWithSpans(tools, options, agentName) {
    const SENTRY_WRAPPED = '__sentry_tool_wrapped__';
    for (const tool of tools){
        if (!tool || typeof tool !== 'object') continue;
        const t = tool;
        const originalInvoke = t.invoke;
        if (typeof originalInvoke !== 'function' || Object.prototype.hasOwnProperty.call(t, SENTRY_WRAPPED)) continue;
        const toolName = typeof t.name === 'string' ? t.name : 'unknown_tool';
        const toolDescription = typeof t.description === 'string' ? t.description : undefined;
        const wrappedInvoke = new Proxy(originalInvoke, {
            apply (target, thisArg, args) {
                const spanAttributes = {
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $J7Vkx.LANGGRAPH_ORIGIN,
                    [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $fxLy8.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    [$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'execute_tool',
                    [$fxLy8.GEN_AI_TOOL_NAME_ATTRIBUTE]: toolName,
                    [$fxLy8.GEN_AI_TOOL_TYPE_ATTRIBUTE]: 'function'
                };
                // Read agent name from LangChain's propagated config metadata at call time,
                // so shared tools get the correct agent name for each invocation
                const callConfig = args[1];
                const callAgentName = callConfig?.metadata?.lc_agent_name ?? agentName;
                if (typeof callAgentName === 'string') spanAttributes[$fxLy8.GEN_AI_AGENT_NAME_ATTRIBUTE] = callAgentName;
                if (toolDescription) spanAttributes[$fxLy8.GEN_AI_TOOL_DESCRIPTION_ATTRIBUTE] = toolDescription;
                // LangGraph ToolNode passes { name, args, id, type: "tool_call" }
                const input = args[0];
                if (typeof input === 'object' && !!input) {
                    if ('id' in input && typeof input.id === 'string') spanAttributes[$fxLy8.GEN_AI_TOOL_CALL_ID_ATTRIBUTE] = input.id;
                    if (options.recordInputs) {
                        const toolArgs = 'args' in input && typeof input.args === 'object' ? input.args : input;
                        try {
                            spanAttributes[$fxLy8.GEN_AI_TOOL_INPUT_ATTRIBUTE] = JSON.stringify(toolArgs);
                        } catch  {
                        // skip if not serializable
                        }
                    }
                }
                return $jLFhR.startSpan({
                    op: $fxLy8.GEN_AI_EXECUTE_TOOL_OPERATION_ATTRIBUTE,
                    name: `execute_tool ${toolName}`,
                    attributes: spanAttributes
                }, async (span)=>{
                    try {
                        const result = await Reflect.apply(target, thisArg, args);
                        if (options.recordOutputs) try {
                            // ToolMessage objects wrap the result in .content
                            const resultObj = result;
                            const content = resultObj && typeof resultObj === 'object' && 'content' in resultObj ? resultObj.content : result;
                            span.setAttribute($fxLy8.GEN_AI_TOOL_OUTPUT_ATTRIBUTE, typeof content === 'string' ? content : JSON.stringify(content));
                        } catch  {
                        // skip if not serializable
                        }
                        return result;
                    } catch (error) {
                        span.setStatus({
                            code: $g0XVK.SPAN_STATUS_ERROR,
                            message: 'internal_error'
                        });
                        $1XEa4.captureException(error, {
                            mechanism: {
                                handled: false,
                                type: 'auto.ai.langgraph.error'
                            }
                        });
                        throw error;
                    }
                });
            }
        });
        t.invoke = wrappedInvoke;
        Object.defineProperty(t, SENTRY_WRAPPED, {
            value: true,
            enumerable: false
        });
    }
    return tools;
}
/**
 * Extract tool calls from messages
 */ function $dcaee0e34fe8f912$var$extractToolCalls(messages) {
    if (!messages || messages.length === 0) return null;
    const toolCalls = [];
    for (const message of messages)if (message && typeof message === 'object') {
        const msgToolCalls = message.tool_calls;
        if (msgToolCalls && Array.isArray(msgToolCalls)) toolCalls.push(...msgToolCalls);
    }
    return toolCalls.length > 0 ? toolCalls : null;
}
/**
 * Extract token usage from a message's usage_metadata or response_metadata
 * Returns token counts without setting span attributes
 */ function $dcaee0e34fe8f912$var$extractTokenUsageFromMessage(message) {
    const msg = message;
    let inputTokens = 0;
    let outputTokens = 0;
    let totalTokens = 0;
    // Extract from usage_metadata (newer format)
    if (msg.usage_metadata && typeof msg.usage_metadata === 'object') {
        const usage = msg.usage_metadata;
        if (typeof usage.input_tokens === 'number') inputTokens = usage.input_tokens;
        if (typeof usage.output_tokens === 'number') outputTokens = usage.output_tokens;
        if (typeof usage.total_tokens === 'number') totalTokens = usage.total_tokens;
        return {
            inputTokens: inputTokens,
            outputTokens: outputTokens,
            totalTokens: totalTokens
        };
    }
    // Fallback: Extract from response_metadata.tokenUsage
    if (msg.response_metadata && typeof msg.response_metadata === 'object') {
        const metadata = msg.response_metadata;
        if (metadata.tokenUsage && typeof metadata.tokenUsage === 'object') {
            const tokenUsage = metadata.tokenUsage;
            if (typeof tokenUsage.promptTokens === 'number') inputTokens = tokenUsage.promptTokens;
            if (typeof tokenUsage.completionTokens === 'number') outputTokens = tokenUsage.completionTokens;
            if (typeof tokenUsage.totalTokens === 'number') totalTokens = tokenUsage.totalTokens;
        }
    }
    return {
        inputTokens: inputTokens,
        outputTokens: outputTokens,
        totalTokens: totalTokens
    };
}
/**
 * Extract model and finish reason from a message's response_metadata
 */ function $dcaee0e34fe8f912$var$extractModelMetadata(span, message) {
    const msg = message;
    if (msg.response_metadata && typeof msg.response_metadata === 'object') {
        const metadata = msg.response_metadata;
        if (metadata.model_name && typeof metadata.model_name === 'string') span.setAttribute($fxLy8.GEN_AI_RESPONSE_MODEL_ATTRIBUTE, metadata.model_name);
        if (metadata.finish_reason && typeof metadata.finish_reason === 'string') span.setAttribute($fxLy8.GEN_AI_RESPONSE_FINISH_REASONS_ATTRIBUTE, [
            metadata.finish_reason
        ]);
    }
}
/**
 * Extract tools from compiled graph structure
 *
 * Tools are stored in: compiledGraph.builder.nodes.tools.runnable.tools
 */ function $dcaee0e34fe8f912$var$extractToolsFromCompiledGraph(compiledGraph) {
    if (!compiledGraph.builder?.nodes?.tools?.runnable?.tools) return null;
    const tools = compiledGraph.builder?.nodes?.tools?.runnable?.tools;
    if (!tools || !Array.isArray(tools) || tools.length === 0) return null;
    // Extract name, description, and schema from each tool's lc_kwargs
    return tools.map((tool)=>({
            name: tool.lc_kwargs?.name,
            description: tool.lc_kwargs?.description,
            schema: tool.lc_kwargs?.schema
        }));
}
/**
 * Set response attributes on the span
 */ function $dcaee0e34fe8f912$var$setResponseAttributes(span, inputMessages, result) {
    // Extract messages from result
    const resultObj = result;
    const outputMessages = resultObj?.messages;
    if (!outputMessages || !Array.isArray(outputMessages)) return;
    // Get new messages (delta between input and output)
    const inputCount = inputMessages?.length ?? 0;
    const newMessages = outputMessages.length > inputCount ? outputMessages.slice(inputCount) : [];
    if (newMessages.length === 0) return;
    // Extract and set tool calls from new messages BEFORE normalization
    // (normalization strips tool_calls, so we need to extract them first)
    const toolCalls = $dcaee0e34fe8f912$var$extractToolCalls(newMessages);
    if (toolCalls) span.setAttribute($fxLy8.GEN_AI_RESPONSE_TOOL_CALLS_ATTRIBUTE, JSON.stringify(toolCalls));
    // Normalize the new messages
    const normalizedNewMessages = $jkIwU.normalizeLangChainMessages(newMessages);
    span.setAttribute($fxLy8.GEN_AI_RESPONSE_TEXT_ATTRIBUTE, JSON.stringify(normalizedNewMessages));
    // Accumulate token usage across all messages
    let totalInputTokens = 0;
    let totalOutputTokens = 0;
    let totalTokens = 0;
    // Extract metadata from messages
    for (const message of newMessages){
        // Accumulate token usage
        const tokens = $dcaee0e34fe8f912$var$extractTokenUsageFromMessage(message);
        totalInputTokens += tokens.inputTokens;
        totalOutputTokens += tokens.outputTokens;
        totalTokens += tokens.totalTokens;
        // Extract model metadata (last message's metadata wins for model/finish_reason)
        $dcaee0e34fe8f912$var$extractModelMetadata(span, message);
    }
    // Set accumulated token usage on span
    if (totalInputTokens > 0) span.setAttribute($fxLy8.GEN_AI_USAGE_INPUT_TOKENS_ATTRIBUTE, totalInputTokens);
    if (totalOutputTokens > 0) span.setAttribute($fxLy8.GEN_AI_USAGE_OUTPUT_TOKENS_ATTRIBUTE, totalOutputTokens);
    if (totalTokens > 0) span.setAttribute($fxLy8.GEN_AI_USAGE_TOTAL_TOKENS_ATTRIBUTE, totalTokens);
}
/** Merge `sentryHandler` into a langchain `callbacks` value (`BaseCallbackHandler[]` or `BaseCallbackManager`). */ function $dcaee0e34fe8f912$var$mergeSentryCallback(existing, sentryHandler) {
    if (!existing) return [
        sentryHandler
    ];
    if (Array.isArray(existing)) {
        if (existing.includes(sentryHandler)) return existing;
        return [
            ...existing,
            sentryHandler
        ];
    }
    const manager = existing;
    if (typeof manager.addHandler === 'function') {
        const alreadyAdded = Array.isArray(manager.handlers) && manager.handlers.includes(sentryHandler);
        if (!alreadyAdded) manager.addHandler(sentryHandler);
    }
    return existing;
}
module.exports.extractAgentNameFromParams = $dcaee0e34fe8f912$var$extractAgentNameFromParams;
module.exports.extractLLMFromParams = $dcaee0e34fe8f912$var$extractLLMFromParams;
module.exports.extractModelMetadata = $dcaee0e34fe8f912$var$extractModelMetadata;
module.exports.extractTokenUsageFromMessage = $dcaee0e34fe8f912$var$extractTokenUsageFromMessage;
module.exports.extractToolCalls = $dcaee0e34fe8f912$var$extractToolCalls;
module.exports.extractToolsFromCompiledGraph = $dcaee0e34fe8f912$var$extractToolsFromCompiledGraph;
module.exports.mergeSentryCallback = $dcaee0e34fe8f912$var$mergeSentryCallback;
module.exports.setResponseAttributes = $dcaee0e34fe8f912$var$setResponseAttributes;
module.exports.wrapToolsWithSpans = $dcaee0e34fe8f912$var$wrapToolsWithSpans;

});


parcelRegister("aXwQY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $8RtxL = parcelRequire("8RtxL");

var $i9ydA = parcelRequire("i9ydA");

var $55glY = parcelRequire("55glY");

var $1c0ty = parcelRequire("1c0ty");
/**
 * We must not send more than 1000 spans in one envelope.
 * Otherwise the envelope is dropped by Relay.
 */ const $7fa8e6110649fef0$var$MAX_SPANS_PER_ENVELOPE = 1000;
const $7fa8e6110649fef0$var$MAX_TRACE_WEIGHT_IN_BYTES = 5000000;
/**
 * A buffer for serialized streamed span JSON objects that flushes them to Sentry in Span v2 envelopes.
 * Handles per-trace timeout-based flushing, size thresholds, and graceful shutdown.
 * Also handles computation of the Dynamic Sampling Context (DSC) for the trace, if it wasn't yet
 * frozen onto the segment span.
 *
 * For this, we need the reference to the segment span instance, from
 * which we compute the DSC. Doing this in the buffer ensures that we compute the DSC as late as possible,
 * allowing span name and data updates up to this point. Worth noting here that the segment span is likely
 * still active and modifyable when child spans are added to the buffer.
 */ class $7fa8e6110649fef0$var$SpanBuffer {
    /* Bucket spans by their trace id, along with accumulated size and a per-trace flush timeout */ constructor(client, options){
        this._traceBuckets = new Map();
        this._client = client;
        const { maxSpanLimit: maxSpanLimit, flushInterval: flushInterval, maxTraceWeightInBytes: maxTraceWeightInBytes } = options ?? {};
        this._maxSpanLimit = maxSpanLimit && maxSpanLimit > 0 && maxSpanLimit <= $7fa8e6110649fef0$var$MAX_SPANS_PER_ENVELOPE ? maxSpanLimit : $7fa8e6110649fef0$var$MAX_SPANS_PER_ENVELOPE;
        this._flushInterval = flushInterval && flushInterval > 0 ? flushInterval : 5000;
        this._maxTraceWeight = maxTraceWeightInBytes && maxTraceWeightInBytes > 0 ? maxTraceWeightInBytes : $7fa8e6110649fef0$var$MAX_TRACE_WEIGHT_IN_BYTES;
        this._client.on('flush', ()=>{
            this.drain();
        });
        this._client.on('close', ()=>{
            // No need to drain the buffer here as `Client.close()` internally already calls `Client.flush()`
            // which already invokes the `flush` hook and thus drains the buffer.
            this._traceBuckets.forEach((bucket)=>{
                clearTimeout(bucket.timeout);
            });
            this._traceBuckets.clear();
        });
    }
    /**
   * Add a span to the buffer.
   */ add(spanJSON) {
        const traceId = spanJSON.trace_id;
        let bucket = this._traceBuckets.get(traceId);
        if (!bucket) {
            bucket = {
                spans: new Set(),
                size: 0,
                timeout: $8RtxL.safeUnref(setTimeout(()=>{
                    this.flush(traceId);
                }, this._flushInterval))
            };
            this._traceBuckets.set(traceId, bucket);
        }
        bucket.spans.add(spanJSON);
        bucket.size += $1c0ty.estimateSerializedSpanSizeInBytes(spanJSON);
        if (bucket.spans.size >= this._maxSpanLimit || bucket.size >= this._maxTraceWeight) this.flush(traceId);
    }
    /**
   * Drain and flush all buffered traces.
   */ drain() {
        if (!this._traceBuckets.size) return;
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`Flushing span tree map with ${this._traceBuckets.size} traces`);
        this._traceBuckets.forEach((_, traceId)=>{
            this.flush(traceId);
        });
    }
    /**
   * Flush spans of a specific trace.
   * In contrast to {@link SpanBuffer.drain}, this method does not flush all traces, but only the one with the given traceId.
   */ flush(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (!bucket) return;
        if (!bucket.spans.size) {
            // we should never get here, given we always add a span when we create a new bucket
            // and delete the bucket once we flush out the trace
            this._removeTrace(traceId);
            return;
        }
        const spans = Array.from(bucket.spans);
        const segmentSpan = spans[0]?._segmentSpan;
        if (!segmentSpan) {
            $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('No segment span reference found on span JSON, cannot compute DSC');
            this._removeTrace(traceId);
            return;
        }
        const dsc = $i9ydA.getDynamicSamplingContextFromSpan(segmentSpan);
        const cleanedSpans = spans.map((spanJSON)=>{
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { _segmentSpan: _segmentSpan, ...cleanSpanJSON } = spanJSON;
            return cleanSpanJSON;
        });
        const envelope$1 = $55glY.createStreamedSpanEnvelope(cleanedSpans, dsc, this._client);
        $kcA99.DEBUG_BUILD && $8xCk9.debug.log(`Sending span envelope for trace ${traceId} with ${cleanedSpans.length} spans`);
        this._client.sendEnvelope(envelope$1).then(null, (reason)=>{
            $kcA99.DEBUG_BUILD && $8xCk9.debug.error('Error while sending streamed span envelope:', reason);
        });
        this._removeTrace(traceId);
    }
    _removeTrace(traceId) {
        const bucket = this._traceBuckets.get(traceId);
        if (bucket) clearTimeout(bucket.timeout);
        this._traceBuckets.delete(traceId);
    }
}
module.exports.SpanBuffer = $7fa8e6110649fef0$var$SpanBuffer;

});
parcelRegister("55glY", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9FnMD = parcelRequire("9FnMD");

var $SMVsN = parcelRequire("SMVsN");

var $93iOd = parcelRequire("93iOd");
/**
 * Creates a span v2 span streaming envelope
 */ function $3b3a1ada4b954f54$var$createStreamedSpanEnvelope(serializedSpans, dsc, client) {
    const options = client.getOptions();
    const dsn$1 = client.getDsn();
    const tunnel = options.tunnel;
    const sdk = $SMVsN.getSdkMetadataForEnvelopeHeader(options._metadata);
    const headers = {
        sent_at: new Date().toISOString(),
        ...$3b3a1ada4b954f54$var$dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...sdk && {
            sdk: sdk
        },
        ...!!tunnel && dsn$1 && {
            dsn: $9FnMD.dsnToString(dsn$1)
        }
    };
    const inferSetting = options.sendDefaultPii ? 'auto' : 'never';
    const spanContainer = [
        {
            type: 'span',
            item_count: serializedSpans.length,
            content_type: 'application/vnd.sentry.items.span.v2+json'
        },
        {
            version: 2,
            ...$93iOd.isBrowser() && {
                ingest_settings: {
                    infer_ip: inferSetting,
                    infer_user_agent: inferSetting
                }
            },
            items: serializedSpans
        }
    ];
    return $SMVsN.createEnvelope(headers, [
        spanContainer
    ]);
}
function $3b3a1ada4b954f54$var$dscHasRequiredProps(dsc) {
    return !!dsc.trace_id && !!dsc.public_key;
}
module.exports.createStreamedSpanEnvelope = $3b3a1ada4b954f54$var$createStreamedSpanEnvelope;

});

parcelRegister("1c0ty", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $i1sH5 = parcelRequire("i1sH5");
/**
 * Estimates the serialized byte size of a {@link SerializedStreamedSpan}.
 *
 * Uses 2 bytes per character as a UTF-16 approximation, and 8 bytes per number.
 * The estimate is intentionally conservative and may be slightly lower than the
 * actual byte size on the wire.
 * We compensate for this by setting the span buffers internal limit well below the limit
 * of how large an actual span v2 envelope may be.
 */ function $0de747e1c0a1d811$var$estimateSerializedSpanSizeInBytes(span) {
    /*
   * Fixed-size fields are pre-computed as a constant for performance:
   * - two timestamps (8 bytes each = 16)
   * - is_segment boolean (5 bytes, assumed false for most spans)
   * - trace_id  – always 32 hex chars (64 bytes)
   * - span_id   – always 16 hex chars (32 bytes)
   * - parent_span_id – 16 hex chars, assumed present for most spans (32 bytes)
   * - status "ok" – most common value (8 bytes)
   * = 156 bytes total base
   */ let weight = 156;
    weight += span.name.length * 2;
    weight += $i1sH5.estimateTypedAttributesSizeInBytes(span.attributes);
    if (span.links && span.links.length > 0) {
        // Assumption: Links are roughly equal in number of attributes
        // probably not always true but allows us to cut down on runtime
        const firstLink = span.links[0];
        const attributes$1 = firstLink?.attributes;
        // Fixed size 100 due to span_id, trace_id and sampled flag (see above)
        const linkWeight = 100 + (attributes$1 ? $i1sH5.estimateTypedAttributesSizeInBytes(attributes$1) : 0);
        weight += linkWeight * span.links.length;
    }
    return weight;
}
module.exports.estimateSerializedSpanSizeInBytes = $0de747e1c0a1d811$var$estimateSerializedSpanSizeInBytes;

});


parcelRegister("lsSpE", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $41JP2 = parcelRequire("41JP2");

var $dh5pl = parcelRequire("dh5pl");

var $ei9kR = parcelRequire("ei9kR");

var $akELB = parcelRequire("akELB");

var $aXwQY = parcelRequire("aXwQY");

var $8xCk9 = parcelRequire("8xCk9");

var $awmvd = parcelRequire("awmvd");
const $fa066bbd4acc88bf$var$spanStreamingIntegration = $41JP2.defineIntegration(()=>{
    return {
        name: 'SpanStreaming',
        setup (client) {
            const initialMessage = 'SpanStreaming integration requires';
            const fallbackMsg = 'Falling back to static trace lifecycle.';
            const clientOptions = client.getOptions();
            if (!$akELB.hasSpanStreamingEnabled(client)) {
                clientOptions.traceLifecycle = 'static';
                $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`${initialMessage} \`traceLifecycle\` to be set to "stream"! ${fallbackMsg}`);
                return;
            }
            const beforeSendSpan$1 = clientOptions.beforeSendSpan;
            if (beforeSendSpan$1 && !$dh5pl.isStreamedBeforeSendSpanCallback(beforeSendSpan$1)) {
                clientOptions.traceLifecycle = 'static';
                $kcA99.DEBUG_BUILD && $8xCk9.debug.warn(`${initialMessage} a beforeSendSpan callback using \`withStreamedSpan\`! ${fallbackMsg}`);
                return;
            }
            const buffer = new $aXwQY.SpanBuffer(client);
            client.on('afterSpanEnd', (span)=>{
                if (!$awmvd.spanIsSampled(span)) return;
                buffer.add($ei9kR.captureSpan(span, client));
            });
        }
    };
});
module.exports.spanStreamingIntegration = $fa066bbd4acc88bf$var$spanStreamingIntegration;

});

parcelRegister("cSoH4", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $95fdaed01e52d722$var$getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}
module.exports.getBreadcrumbLogLevelFromHttpStatusCode = $95fdaed01e52d722$var$getBreadcrumbLogLevelFromHttpStatusCode;

});

parcelRegister("dbwDf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * An error emitted by Sentry SDKs and related utilities.
 * @deprecated This class is no longer used and will be removed in a future version. Use `Error` instead.
 */ class $99959d7723971304$var$SentryError extends Error {
    constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}
module.exports.SentryError = $99959d7723971304$var$SentryError;

});

parcelRegister("bGovw", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $9BwS8 = parcelRequire("9BwS8");

var $8wdL3 = parcelRequire("8wdL3");

var $2Ufnj = parcelRequire("2Ufnj");

var $5IHEa = parcelRequire("5IHEa");

var $j8mWA = parcelRequire("j8mWA");

var $4onm8 = parcelRequire("4onm8");

var $4SNSv = parcelRequire("4SNSv");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 * Returns a function to remove the handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8816a09a10db2e53$var$addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    const removeHandler = $4SNSv.addHandler(type, handler);
    $4SNSv.maybeInstrument(type, ()=>$8816a09a10db2e53$var$instrumentFetch(undefined, skipNativeFetchCheck));
    return removeHandler;
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 * Returns a function to remove the handler.
 *
 * Only used internally
 * @hidden
 */ function $8816a09a10db2e53$var$addFetchEndInstrumentationHandler(handler) {
    const type = 'fetch-body-resolved';
    const removeHandler = $4SNSv.addHandler(type, handler);
    $4SNSv.maybeInstrument(type, ()=>$8816a09a10db2e53$var$instrumentFetch($8816a09a10db2e53$var$streamHandler));
    return removeHandler;
}
function $8816a09a10db2e53$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !$5IHEa.supportsNativeFetch()) return;
    $2Ufnj.fill($4onm8.GLOBAL_OBJ, 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $8816a09a10db2e53$var$parseFetchArgs(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: $j8mWA.timestampInSeconds() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $8816a09a10db2e53$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) $4SNSv.triggerHandlers('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($4onm8.GLOBAL_OBJ, args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else $4SNSv.triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: $j8mWA.timestampInSeconds() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                $4SNSv.triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: $j8mWA.timestampInSeconds() * 1000,
                    error: error
                });
                if ($8wdL3.isError(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    $2Ufnj.addNonEnumerableProperty(error, 'framesToPop', 1);
                }
                // We enhance fetch error messages with hostname information based on the configuration.
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                const client = $9BwS8.getClient();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? 'always';
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    const hostname = url.host;
                    if (enhanceOption === 'always') // Modify the error message directly
                    error.message = `${error.message} (${hostname})`;
                    else // Store hostname as non-enumerable property for Sentry-only enhancement
                    // This preserves the original error message for third-party packages
                    $2Ufnj.addNonEnumerableProperty(error, '__sentry_fetch_url_host__', hostname);
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $8816a09a10db2e53$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $8816a09a10db2e53$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $8816a09a10db2e53$var$resolveResponse(clonedResponseForResolving, ()=>{
        $4SNSv.triggerHandlers('fetch-body-resolved', {
            endTimestamp: $j8mWA.timestampInSeconds() * 1000,
            response: response
        });
    });
}
function $8816a09a10db2e53$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $8816a09a10db2e53$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($8816a09a10db2e53$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $8816a09a10db2e53$var$parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $8816a09a10db2e53$var$getUrlFromResource(resource),
            method: $8816a09a10db2e53$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : $8wdL3.isRequest(resource) && $8816a09a10db2e53$var$hasProp(resource, 'method') ? String(resource.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $8816a09a10db2e53$var$getUrlFromResource(arg),
        method: $8816a09a10db2e53$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $8816a09a10db2e53$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ($8wdL3.isRequest(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}
module.exports.addFetchEndInstrumentationHandler = $8816a09a10db2e53$var$addFetchEndInstrumentationHandler;
module.exports.addFetchInstrumentationHandler = $8816a09a10db2e53$var$addFetchInstrumentationHandler;
module.exports.parseFetchArgs = $8816a09a10db2e53$var$parseFetchArgs;

});
parcelRegister("5IHEa", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $kcA99 = parcelRequire("kcA99");

var $8xCk9 = parcelRequire("8xCk9");

var $4onm8 = parcelRequire("4onm8");
const $42a2eb2536a2019b$var$WINDOW = $4onm8.GLOBAL_OBJ;
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $42a2eb2536a2019b$var$supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $42a2eb2536a2019b$var$supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $42a2eb2536a2019b$var$supportsDOMException() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $42a2eb2536a2019b$var$supportsHistory() {
    return 'history' in $42a2eb2536a2019b$var$WINDOW && !!$42a2eb2536a2019b$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $42a2eb2536a2019b$var$supportsFetch = $42a2eb2536a2019b$var$_isFetchSupported;
function $42a2eb2536a2019b$var$_isFetchSupported() {
    if (!('fetch' in $42a2eb2536a2019b$var$WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $42a2eb2536a2019b$var$isNativeFunction(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $42a2eb2536a2019b$var$supportsNativeFetch() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$42a2eb2536a2019b$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($42a2eb2536a2019b$var$isNativeFunction($42a2eb2536a2019b$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $42a2eb2536a2019b$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $42a2eb2536a2019b$var$isNativeFunction(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        $kcA99.DEBUG_BUILD && $8xCk9.debug.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $42a2eb2536a2019b$var$supportsReportingObserver() {
    return 'ReportingObserver' in $42a2eb2536a2019b$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $42a2eb2536a2019b$var$supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$42a2eb2536a2019b$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}
module.exports.isNativeFunction = $42a2eb2536a2019b$var$isNativeFunction;
module.exports.supportsDOMError = $42a2eb2536a2019b$var$supportsDOMError;
module.exports.supportsDOMException = $42a2eb2536a2019b$var$supportsDOMException;
module.exports.supportsErrorEvent = $42a2eb2536a2019b$var$supportsErrorEvent;
module.exports.supportsFetch = $42a2eb2536a2019b$var$supportsFetch;
module.exports.supportsHistory = $42a2eb2536a2019b$var$supportsHistory;
module.exports.supportsNativeFetch = $42a2eb2536a2019b$var$supportsNativeFetch;
module.exports.supportsReferrerPolicy = $42a2eb2536a2019b$var$supportsReferrerPolicy;
module.exports.supportsReportingObserver = $42a2eb2536a2019b$var$supportsReportingObserver;

});


parcelRegister("iaBGl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/**
 * Replaces constructor functions in module exports, handling read-only properties,
 * and both default and named exports by wrapping them with the constructor.
 *
 * @param exports The module exports object to modify
 * @param exportName The name of the export to replace (e.g., 'GoogleGenAI', 'Anthropic', 'OpenAI')
 * @param wrappedConstructor The wrapped constructor function to replace the original with
 * @returns void
 */ function $d3a66400462195e9$var$replaceExports(exports1, exportName, wrappedConstructor) {
    const original = exports1[exportName];
    if (typeof original !== 'function') return;
    // Replace the named export - handle read-only properties
    try {
        exports1[exportName] = wrappedConstructor;
    } catch  {
        // If direct assignment fails, override the property descriptor
        Object.defineProperty(exports1, exportName, {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
    // Replace the default export if it points to the original constructor
    if (exports1.default === original) try {
        exports1.default = wrappedConstructor;
    } catch  {
        Object.defineProperty(exports1, 'default', {
            value: wrappedConstructor,
            writable: true,
            configurable: true,
            enumerable: true
        });
    }
}
module.exports.replaceExports = $d3a66400462195e9$var$replaceExports;

});

parcelRegister("dmdSl", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
/** A simple Least Recently Used map */ class $9b9817ce79145730$var$LRUMap {
    constructor(_maxSize){
        this._maxSize = _maxSize;
        this._cache = new Map();
    }
    /** Get the current size of the cache */ get size() {
        return this._cache.size;
    }
    /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ get(key) {
        const value = this._cache.get(key);
        if (value === undefined) return undefined;
        // Remove and re-insert to update the order
        this._cache.delete(key);
        this._cache.set(key, value);
        return value;
    }
    /** Insert an entry and evict an older entry if we've reached maxSize */ set(key, value) {
        if (this._cache.size >= this._maxSize) {
            // keys() returns an iterator in insertion order so keys().next() gives us the oldest key
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const nextKey = this._cache.keys().next().value;
            this._cache.delete(nextKey);
        }
        this._cache.set(key, value);
    }
    /** Remove an entry and return the entry if it was in the cache */ remove(key) {
        const value = this._cache.get(key);
        if (value) this._cache.delete(key);
        return value;
    }
    /** Clear all entries */ clear() {
        this._cache.clear();
    }
    /** Get all the keys */ keys() {
        return Array.from(this._cache.keys());
    }
    /** Get all the values */ values() {
        const values = [];
        this._cache.forEach((value)=>values.push(value));
        return values;
    }
}
module.exports.LRUMap = $9b9817ce79145730$var$LRUMap;

});

parcelRegister("3UXib", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});
// Based on https://github.com/sindresorhus/escape-string-regexp but with modifications to:
//   a) reduce the size by skipping the runtime type - checking
//   b) ensure it gets down - compiled for old versions of Node(the published package only supports Node 14+).
//
// MIT License
//
// Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
// documentation files(the "Software"), to deal in the Software without restriction, including without limitation
// the rights to use, copy, modify, merge, publish, distribute, sublicense, and / or sell copies of the Software, and
// to permit persons to whom the Software is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of
// the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
// THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
// IN THE SOFTWARE.
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ function $2da49846d1fbaf5e$var$escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
module.exports.escapeStringForRegex = $2da49846d1fbaf5e$var$escapeStringForRegex;

});

parcelRegister("7iVdf", function(module, exports) {
Object.defineProperty(module.exports, Symbol.toStringTag, {
    value: 'Module'
});

var $1XEa4 = parcelRequire("1XEa4");

var $5Wkkl = parcelRequire("5Wkkl");

var $jLFhR = parcelRequire("jLFhR");

var $fxLy8 = parcelRequire("fxLy8");

var $jZcA4 = parcelRequire("jZcA4");

var $kD0JT = parcelRequire("kD0JT");
/**
 * Infers the AI provider system name from the embedding class instance.
 */ function $55169818cfd83d11$var$inferSystemFromInstance(instance) {
    const name = instance.constructor?.name ?? '';
    if (name.includes('OpenAI')) return 'openai';
    if (name.includes('Google')) return 'google_genai';
    if (name.includes('Mistral')) return 'mistralai';
    if (name.includes('Vertex')) return 'google_vertexai';
    if (name.includes('Bedrock')) return 'aws_bedrock';
    if (name.includes('Ollama')) return 'ollama';
    if (name.includes('Cloudflare')) return 'cloudflare';
    if (name.includes('Cohere')) return 'cohere';
    return 'langchain';
}
/**
 * Extracts span attributes from a LangChain embedding class instance.
 */ function $55169818cfd83d11$var$extractEmbeddingAttributes(instance) {
    const embeddingsInstance = instance ?? {};
    const attributes = {
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: $kD0JT.LANGCHAIN_ORIGIN,
        [$5Wkkl.SEMANTIC_ATTRIBUTE_SENTRY_OP]: $fxLy8.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
        [$fxLy8.GEN_AI_OPERATION_NAME_ATTRIBUTE]: 'embeddings',
        [$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE]: embeddingsInstance.model ?? 'unknown'
    };
    attributes[$fxLy8.GEN_AI_SYSTEM_ATTRIBUTE] = $55169818cfd83d11$var$inferSystemFromInstance(embeddingsInstance);
    if ('dimensions' in embeddingsInstance) attributes[$fxLy8.GEN_AI_REQUEST_DIMENSIONS_ATTRIBUTE] = embeddingsInstance.dimensions;
    if ('encodingFormat' in embeddingsInstance) attributes[$fxLy8.GEN_AI_REQUEST_ENCODING_FORMAT_ATTRIBUTE] = embeddingsInstance.encodingFormat;
    return attributes;
}
/**
 * Wraps a LangChain embedding method (embedQuery or embedDocuments) to create Sentry spans.
 *
 * Used internally by the Node.js auto-instrumentation to patch embedding class prototypes.
 */ function $55169818cfd83d11$var$instrumentEmbeddingMethod(originalMethod, options = {}) {
    const { recordInputs: recordInputs } = $jZcA4.resolveAIRecordingOptions(options);
    return new Proxy(originalMethod, {
        apply (target, thisArg, args) {
            const attributes = $55169818cfd83d11$var$extractEmbeddingAttributes(thisArg);
            const modelName = attributes[$fxLy8.GEN_AI_REQUEST_MODEL_ATTRIBUTE] || 'unknown';
            if (recordInputs) {
                const input = args[0];
                if (input != null) attributes[$fxLy8.GEN_AI_EMBEDDINGS_INPUT_ATTRIBUTE] = typeof input === 'string' ? input : JSON.stringify(input);
            }
            return $jLFhR.startSpan({
                name: `embeddings ${modelName}`,
                op: $fxLy8.GEN_AI_EMBEDDINGS_OPERATION_ATTRIBUTE,
                attributes: attributes
            }, ()=>{
                return Reflect.apply(target, thisArg, args).then(undefined, (error)=>{
                    $1XEa4.captureException(error, {
                        mechanism: {
                            handled: false,
                            type: 'auto.ai.langchain'
                        }
                    });
                    throw error;
                });
            });
        }
    });
}
/**
 * Wraps a LangChain embeddings instance to create Sentry spans for `embedQuery` and `embedDocuments` calls.
 *
 * Use this in non-Node runtimes (Cloudflare, browser, etc.) where auto-instrumentation is not available.
 *
 * @example
 * ```javascript
 * import * as Sentry from '@sentry/cloudflare';
 * import { OpenAIEmbeddings } from '@langchain/openai';
 *
 * const embeddings = Sentry.instrumentLangChainEmbeddings(
 *   new OpenAIEmbeddings({ model: 'text-embedding-3-small' })
 * );
 *
 * await embeddings.embedQuery('Hello world');
 * await embeddings.embedDocuments(['doc1', 'doc2']);
 * ```
 */ function $55169818cfd83d11$var$instrumentLangChainEmbeddings(instance, options) {
    const embeddingsInstance = instance;
    if (typeof embeddingsInstance.embedQuery === 'function') embeddingsInstance.embedQuery = $55169818cfd83d11$var$instrumentEmbeddingMethod(embeddingsInstance.embedQuery, options);
    if (typeof embeddingsInstance.embedDocuments === 'function') embeddingsInstance.embedDocuments = $55169818cfd83d11$var$instrumentEmbeddingMethod(embeddingsInstance.embedDocuments, options);
    return instance;
}
module.exports.instrumentEmbeddingMethod = $55169818cfd83d11$var$instrumentEmbeddingMethod;
module.exports.instrumentLangChainEmbeddings = $55169818cfd83d11$var$instrumentLangChainEmbeddings;

});


parcelRegister("bCpAf", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $ivs4E = parcelRequire("ivs4E");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the `debug` singleton, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $ivs4E.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @param existingModule module to use for requiring
 * @returns possibly required module
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {
    // no-empty
    }
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, 'process');
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {
    // no-empty
    }
    return mod;
}

});
parcelRegister("ivs4E", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $d790e62b003cae32$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $d790e62b003cae32$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $d790e62b003cae32$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});


// main.js

/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $adfdd3111f594bc3$exports = {};

$parcel$export($adfdd3111f594bc3$exports, "popperGenerator", () => $5968de398423c62c$export$ed5e13716264f202);
$parcel$export($adfdd3111f594bc3$exports, "detectOverflow", () => $0a06619e00ab1013$export$2e2bcd8739ae039);
$parcel$export($adfdd3111f594bc3$exports, "createPopperBase", () => $5968de398423c62c$export$8f7491d57c8f97a9);
$parcel$export($adfdd3111f594bc3$exports, "createPopper", () => $543d309e6238ef10$export$8f7491d57c8f97a9);
$parcel$export($adfdd3111f594bc3$exports, "createPopperLite", () => $54666614edba354a$export$8f7491d57c8f97a9);
var $1a865effa673d7ef$exports = {};

$parcel$export($1a865effa673d7ef$exports, "top", () => $1a865effa673d7ef$export$1e95b668f3b82d);
$parcel$export($1a865effa673d7ef$exports, "bottom", () => $1a865effa673d7ef$export$40e543e69a8b3fbb);
$parcel$export($1a865effa673d7ef$exports, "right", () => $1a865effa673d7ef$export$79ffe56a765070d2);
$parcel$export($1a865effa673d7ef$exports, "left", () => $1a865effa673d7ef$export$eabcd2c8791e7bf4);
$parcel$export($1a865effa673d7ef$exports, "auto", () => $1a865effa673d7ef$export$dfb5619354ba860);
$parcel$export($1a865effa673d7ef$exports, "basePlacements", () => $1a865effa673d7ef$export$aec2ce47c367b8c3);
$parcel$export($1a865effa673d7ef$exports, "start", () => $1a865effa673d7ef$export$b3571188c770cc5a);
$parcel$export($1a865effa673d7ef$exports, "end", () => $1a865effa673d7ef$export$bd5df0f255a350f8);
$parcel$export($1a865effa673d7ef$exports, "clippingParents", () => $1a865effa673d7ef$export$390fd549c5303b4d);
$parcel$export($1a865effa673d7ef$exports, "viewport", () => $1a865effa673d7ef$export$d7b7311ec04a3e8f);
$parcel$export($1a865effa673d7ef$exports, "popper", () => $1a865effa673d7ef$export$ae5ab1c730825774);
$parcel$export($1a865effa673d7ef$exports, "reference", () => $1a865effa673d7ef$export$ca50aac9f3ba507f);
$parcel$export($1a865effa673d7ef$exports, "variationPlacements", () => $1a865effa673d7ef$export$368f9a87e87fa4e1);
$parcel$export($1a865effa673d7ef$exports, "placements", () => $1a865effa673d7ef$export$803cd8101b6c182b);
$parcel$export($1a865effa673d7ef$exports, "beforeRead", () => $1a865effa673d7ef$export$421679a7c3d56e);
$parcel$export($1a865effa673d7ef$exports, "read", () => $1a865effa673d7ef$export$aafa59e2e03f2942);
$parcel$export($1a865effa673d7ef$exports, "afterRead", () => $1a865effa673d7ef$export$6964f6c886723980);
$parcel$export($1a865effa673d7ef$exports, "beforeMain", () => $1a865effa673d7ef$export$c65e99957a05207c);
$parcel$export($1a865effa673d7ef$exports, "main", () => $1a865effa673d7ef$export$f22da7240b7add18);
$parcel$export($1a865effa673d7ef$exports, "afterMain", () => $1a865effa673d7ef$export$bab79516f2d662fe);
$parcel$export($1a865effa673d7ef$exports, "beforeWrite", () => $1a865effa673d7ef$export$8d4d2d70e7d46032);
$parcel$export($1a865effa673d7ef$exports, "write", () => $1a865effa673d7ef$export$68d8715fc104d294);
$parcel$export($1a865effa673d7ef$exports, "afterWrite", () => $1a865effa673d7ef$export$70a6e5159acce2e6);
$parcel$export($1a865effa673d7ef$exports, "modifierPhases", () => $1a865effa673d7ef$export$d087d3878fdf71d5);
var $1a865effa673d7ef$export$1e95b668f3b82d = 'top';
var $1a865effa673d7ef$export$40e543e69a8b3fbb = 'bottom';
var $1a865effa673d7ef$export$79ffe56a765070d2 = 'right';
var $1a865effa673d7ef$export$eabcd2c8791e7bf4 = 'left';
var $1a865effa673d7ef$export$dfb5619354ba860 = 'auto';
var $1a865effa673d7ef$export$aec2ce47c367b8c3 = [
    $1a865effa673d7ef$export$1e95b668f3b82d,
    $1a865effa673d7ef$export$40e543e69a8b3fbb,
    $1a865effa673d7ef$export$79ffe56a765070d2,
    $1a865effa673d7ef$export$eabcd2c8791e7bf4
];
var $1a865effa673d7ef$export$b3571188c770cc5a = 'start';
var $1a865effa673d7ef$export$bd5df0f255a350f8 = 'end';
var $1a865effa673d7ef$export$390fd549c5303b4d = 'clippingParents';
var $1a865effa673d7ef$export$d7b7311ec04a3e8f = 'viewport';
var $1a865effa673d7ef$export$ae5ab1c730825774 = 'popper';
var $1a865effa673d7ef$export$ca50aac9f3ba507f = 'reference';
var $1a865effa673d7ef$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1a865effa673d7ef$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1a865effa673d7ef$export$b3571188c770cc5a,
        placement + "-" + $1a865effa673d7ef$export$bd5df0f255a350f8
    ]);
}, []);
var $1a865effa673d7ef$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1a865effa673d7ef$export$aec2ce47c367b8c3, [
    $1a865effa673d7ef$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1a865effa673d7ef$export$b3571188c770cc5a,
        placement + "-" + $1a865effa673d7ef$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1a865effa673d7ef$export$421679a7c3d56e = 'beforeRead';
var $1a865effa673d7ef$export$aafa59e2e03f2942 = 'read';
var $1a865effa673d7ef$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1a865effa673d7ef$export$c65e99957a05207c = 'beforeMain';
var $1a865effa673d7ef$export$f22da7240b7add18 = 'main';
var $1a865effa673d7ef$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1a865effa673d7ef$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1a865effa673d7ef$export$68d8715fc104d294 = 'write';
var $1a865effa673d7ef$export$70a6e5159acce2e6 = 'afterWrite';
var $1a865effa673d7ef$export$d087d3878fdf71d5 = [
    $1a865effa673d7ef$export$421679a7c3d56e,
    $1a865effa673d7ef$export$aafa59e2e03f2942,
    $1a865effa673d7ef$export$6964f6c886723980,
    $1a865effa673d7ef$export$c65e99957a05207c,
    $1a865effa673d7ef$export$f22da7240b7add18,
    $1a865effa673d7ef$export$bab79516f2d662fe,
    $1a865effa673d7ef$export$8d4d2d70e7d46032,
    $1a865effa673d7ef$export$68d8715fc104d294,
    $1a865effa673d7ef$export$70a6e5159acce2e6
];


var $8aa292e838b7fa60$exports = {};

$parcel$export($8aa292e838b7fa60$exports, "applyStyles", () => $d5591ea428204fc6$export$2e2bcd8739ae039);
$parcel$export($8aa292e838b7fa60$exports, "arrow", () => $6ea4846a0493804a$export$2e2bcd8739ae039);
$parcel$export($8aa292e838b7fa60$exports, "computeStyles", () => $aa73cd006ea2efd9$export$2e2bcd8739ae039);
$parcel$export($8aa292e838b7fa60$exports, "eventListeners", () => $1a88c2546fd8ca27$export$2e2bcd8739ae039);
$parcel$export($8aa292e838b7fa60$exports, "flip", () => $25bf80df604d56b9$export$2e2bcd8739ae039);
$parcel$export($8aa292e838b7fa60$exports, "hide", () => $c16b8bfe6b53211a$export$2e2bcd8739ae039);
$parcel$export($8aa292e838b7fa60$exports, "offset", () => $97f2ab77ff5bb32b$export$2e2bcd8739ae039);
$parcel$export($8aa292e838b7fa60$exports, "popperOffsets", () => $8deaafe3b63445cb$export$2e2bcd8739ae039);
$parcel$export($8aa292e838b7fa60$exports, "preventOverflow", () => $f52a37255b686aa1$export$2e2bcd8739ae039);
function $8f9603f92ad9df2e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $4b36e24b0e263bed$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $82eb46d7de1e9bf1$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $82eb46d7de1e9bf1$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $82eb46d7de1e9bf1$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $d5591ea428204fc6$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(element) || !(0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $d5591ea428204fc6$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(element) || !(0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $d5591ea428204fc6$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $d5591ea428204fc6$var$applyStyles,
    effect: $d5591ea428204fc6$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $0ed1c09ee45b6b9d$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $9bdb8f89d25ad73e$export$8960430cfd85939f = Math.max;
var $9bdb8f89d25ad73e$export$96ec731ed4dcb222 = Math.min;
var $9bdb8f89d25ad73e$export$2077e0241d6afd3c = Math.round;



function $2309ededdaf12a47$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $ace4dfe1be73da23$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $2309ededdaf12a47$export$2e2bcd8739ae039)());
}


function $d5bfaafc9d7f7364$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9bdb8f89d25ad73e$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9bdb8f89d25ad73e$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $82eb46d7de1e9bf1$export$45a5e7f76e0caa8d)(element) ? (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $ace4dfe1be73da23$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $e621448a96b09849$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $d5bfaafc9d7f7364$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $ad2283b83fe77e1f$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $82eb46d7de1e9bf1$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $6da924f68a2ff328$export$2e2bcd8739ae039(element) {
    return (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $92debd5e5e8c2c34$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $d96bc76888766dcf$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $82eb46d7de1e9bf1$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $77adc5ef69546af9$export$2e2bcd8739ae039(element) {
    if ((0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $82eb46d7de1e9bf1$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $d96bc76888766dcf$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $2bbf4f59d1971c3f$var$getTrueOffsetParent(element) {
    if (!(0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $6da924f68a2ff328$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $2bbf4f59d1971c3f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $2309ededdaf12a47$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $2309ededdaf12a47$export$2e2bcd8739ae039)());
    if (isIE && (0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $6da924f68a2ff328$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $77adc5ef69546af9$export$2e2bcd8739ae039)(element);
    if ((0, $82eb46d7de1e9bf1$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $6da924f68a2ff328$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $2bbf4f59d1971c3f$export$2e2bcd8739ae039(element) {
    var window = (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(element);
    var offsetParent = $2bbf4f59d1971c3f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $92debd5e5e8c2c34$export$2e2bcd8739ae039)(offsetParent) && (0, $6da924f68a2ff328$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $2bbf4f59d1971c3f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $6da924f68a2ff328$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $2bbf4f59d1971c3f$var$getContainingBlock(element) || window;
}


function $daacfcce61889b45$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $da8dccd643323927$export$f28d906d67a997f3(min, value, max) {
    return (0, $9bdb8f89d25ad73e$export$8960430cfd85939f)(min, (0, $9bdb8f89d25ad73e$export$96ec731ed4dcb222)(value, max));
}
function $da8dccd643323927$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $da8dccd643323927$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $275f8d6a6641063e$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $a73ff61d621039cc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $275f8d6a6641063e$export$2e2bcd8739ae039)(), paddingObject);
}


function $97bd2e8336b89772$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $6ea4846a0493804a$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $a73ff61d621039cc$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $97bd2e8336b89772$export$2e2bcd8739ae039)(padding, (0, $1a865effa673d7ef$export$aec2ce47c367b8c3)));
};
function $6ea4846a0493804a$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $daacfcce61889b45$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4),
        (0, $1a865effa673d7ef$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $6ea4846a0493804a$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $e621448a96b09849$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1a865effa673d7ef$export$1e95b668f3b82d) : (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1a865effa673d7ef$export$40e543e69a8b3fbb) : (0, $1a865effa673d7ef$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $2bbf4f59d1971c3f$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $da8dccd643323927$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $6ea4846a0493804a$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ad2283b83fe77e1f$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $6ea4846a0493804a$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $6ea4846a0493804a$var$arrow,
    effect: $6ea4846a0493804a$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $851619c1fa06999c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $aa73cd006ea2efd9$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $aa73cd006ea2efd9$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9bdb8f89d25ad73e$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $9bdb8f89d25ad73e$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $aa73cd006ea2efd9$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4);
    var sideY = (0, $1a865effa673d7ef$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $2bbf4f59d1971c3f$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $d96bc76888766dcf$export$2e2bcd8739ae039)(popper);
            if ((0, $6da924f68a2ff328$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1a865effa673d7ef$export$1e95b668f3b82d) || (placement === (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4) || placement === (0, $1a865effa673d7ef$export$79ffe56a765070d2)) && variation === (0, $1a865effa673d7ef$export$bd5df0f255a350f8)) {
            sideY = (0, $1a865effa673d7ef$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4) || (placement === (0, $1a865effa673d7ef$export$1e95b668f3b82d) || placement === (0, $1a865effa673d7ef$export$40e543e69a8b3fbb)) && variation === (0, $1a865effa673d7ef$export$bd5df0f255a350f8)) {
            sideX = (0, $1a865effa673d7ef$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $aa73cd006ea2efd9$var$unsetSides);
    var _ref4 = roundOffsets === true ? $aa73cd006ea2efd9$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $aa73cd006ea2efd9$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $851619c1fa06999c$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $aa73cd006ea2efd9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $aa73cd006ea2efd9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $aa73cd006ea2efd9$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $aa73cd006ea2efd9$var$computeStyles,
    data: {}
};



var $1a88c2546fd8ca27$var$passive = {
    passive: true
};
function $1a88c2546fd8ca27$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1a88c2546fd8ca27$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1a88c2546fd8ca27$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1a88c2546fd8ca27$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1a88c2546fd8ca27$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1a88c2546fd8ca27$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1a88c2546fd8ca27$var$effect,
    data: {}
};


var $338fde5f1fb77288$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $338fde5f1fb77288$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $338fde5f1fb77288$var$hash[matched];
    });
}



var $d483a97207d03231$var$hash = {
    start: 'end',
    end: 'start'
};
function $d483a97207d03231$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $d483a97207d03231$var$hash[matched];
    });
}








function $5d92f7625ff838be$export$2e2bcd8739ae039(node) {
    var win = (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $a377837da06563d1$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $d5bfaafc9d7f7364$export$2e2bcd8739ae039)((0, $d96bc76888766dcf$export$2e2bcd8739ae039)(element)).left + (0, $5d92f7625ff838be$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $6835da9693bf082d$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(element);
    var html = (0, $d96bc76888766dcf$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $ace4dfe1be73da23$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $a377837da06563d1$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $1d285b7da077f002$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $d96bc76888766dcf$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $5d92f7625ff838be$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9bdb8f89d25ad73e$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9bdb8f89d25ad73e$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $a377837da06563d1$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $6da924f68a2ff328$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $9bdb8f89d25ad73e$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $7dd5ec168d2a41e8$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $6da924f68a2ff328$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $5b6d93b8c8ae89ec$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(node) && (0, $7dd5ec168d2a41e8$export$2e2bcd8739ae039)(node)) return node;
    return $5b6d93b8c8ae89ec$export$2e2bcd8739ae039((0, $77adc5ef69546af9$export$2e2bcd8739ae039)(node));
}





function $caf374c7e24b4b02$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $5b6d93b8c8ae89ec$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $7dd5ec168d2a41e8$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($caf374c7e24b4b02$export$2e2bcd8739ae039((0, $77adc5ef69546af9$export$2e2bcd8739ae039)(target)));
}










function $3dfa6a2e38963907$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $228c32c72e9ff80e$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $d5bfaafc9d7f7364$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $228c32c72e9ff80e$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1a865effa673d7ef$export$d7b7311ec04a3e8f) ? (0, $3dfa6a2e38963907$export$2e2bcd8739ae039)((0, $6835da9693bf082d$export$2e2bcd8739ae039)(element, strategy)) : (0, $82eb46d7de1e9bf1$export$45a5e7f76e0caa8d)(clippingParent) ? $228c32c72e9ff80e$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $3dfa6a2e38963907$export$2e2bcd8739ae039)((0, $1d285b7da077f002$export$2e2bcd8739ae039)((0, $d96bc76888766dcf$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $228c32c72e9ff80e$var$getClippingParents(element) {
    var clippingParents = (0, $caf374c7e24b4b02$export$2e2bcd8739ae039)((0, $77adc5ef69546af9$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $6da924f68a2ff328$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(element) ? (0, $2bbf4f59d1971c3f$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $82eb46d7de1e9bf1$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $82eb46d7de1e9bf1$export$45a5e7f76e0caa8d)(clippingParent) && (0, $ad2283b83fe77e1f$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $228c32c72e9ff80e$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $228c32c72e9ff80e$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $228c32c72e9ff80e$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9bdb8f89d25ad73e$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $9bdb8f89d25ad73e$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $9bdb8f89d25ad73e$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9bdb8f89d25ad73e$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $228c32c72e9ff80e$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $06054c78b91d0c4d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $851619c1fa06999c$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1a865effa673d7ef$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1a865effa673d7ef$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1a865effa673d7ef$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1a865effa673d7ef$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $daacfcce61889b45$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1a865effa673d7ef$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1a865effa673d7ef$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $0a06619e00ab1013$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1a865effa673d7ef$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1a865effa673d7ef$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1a865effa673d7ef$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $a73ff61d621039cc$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $97bd2e8336b89772$export$2e2bcd8739ae039)(padding, (0, $1a865effa673d7ef$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1a865effa673d7ef$export$ae5ab1c730825774) ? (0, $1a865effa673d7ef$export$ca50aac9f3ba507f) : (0, $1a865effa673d7ef$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $228c32c72e9ff80e$export$2e2bcd8739ae039)((0, $82eb46d7de1e9bf1$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $d96bc76888766dcf$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $d5bfaafc9d7f7364$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $06054c78b91d0c4d$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $3dfa6a2e38963907$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1a865effa673d7ef$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1a865effa673d7ef$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1a865effa673d7ef$export$79ffe56a765070d2),
                (0, $1a865effa673d7ef$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1a865effa673d7ef$export$1e95b668f3b82d),
                (0, $1a865effa673d7ef$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $07d5fa03380aa8e1$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1a865effa673d7ef$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $851619c1fa06999c$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1a865effa673d7ef$export$368f9a87e87fa4e1) : (0, $1a865effa673d7ef$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $851619c1fa06999c$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1a865effa673d7ef$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $0a06619e00ab1013$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $25bf80df604d56b9$var$getExpandedFallbackPlacements(placement) {
    if ((0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(placement) === (0, $1a865effa673d7ef$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $338fde5f1fb77288$export$2e2bcd8739ae039)(placement);
    return [
        (0, $d483a97207d03231$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $d483a97207d03231$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $25bf80df604d56b9$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $338fde5f1fb77288$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $25bf80df604d56b9$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(placement) === (0, $1a865effa673d7ef$export$dfb5619354ba860) ? (0, $07d5fa03380aa8e1$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $851619c1fa06999c$export$2e2bcd8739ae039)(placement) === (0, $1a865effa673d7ef$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1a865effa673d7ef$export$1e95b668f3b82d),
            (0, $1a865effa673d7ef$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $0a06619e00ab1013$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1a865effa673d7ef$export$79ffe56a765070d2) : (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1a865effa673d7ef$export$40e543e69a8b3fbb) : (0, $1a865effa673d7ef$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $338fde5f1fb77288$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $338fde5f1fb77288$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $25bf80df604d56b9$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $25bf80df604d56b9$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $c16b8bfe6b53211a$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $c16b8bfe6b53211a$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1a865effa673d7ef$export$1e95b668f3b82d),
        (0, $1a865effa673d7ef$export$79ffe56a765070d2),
        (0, $1a865effa673d7ef$export$40e543e69a8b3fbb),
        (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $c16b8bfe6b53211a$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $0a06619e00ab1013$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $0a06619e00ab1013$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $c16b8bfe6b53211a$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $c16b8bfe6b53211a$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $c16b8bfe6b53211a$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $c16b8bfe6b53211a$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $c16b8bfe6b53211a$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $c16b8bfe6b53211a$var$hide
};




function $97f2ab77ff5bb32b$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4),
        (0, $1a865effa673d7ef$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4),
        (0, $1a865effa673d7ef$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $97f2ab77ff5bb32b$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1a865effa673d7ef$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $97f2ab77ff5bb32b$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $97f2ab77ff5bb32b$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $97f2ab77ff5bb32b$var$offset
};



function $8deaafe3b63445cb$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $06054c78b91d0c4d$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8deaafe3b63445cb$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8deaafe3b63445cb$var$popperOffsets,
    data: {}
};





function $80c5fcbcd70c6853$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $f52a37255b686aa1$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $0a06619e00ab1013$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $0ed1c09ee45b6b9d$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $851619c1fa06999c$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $daacfcce61889b45$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $80c5fcbcd70c6853$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1a865effa673d7ef$export$1e95b668f3b82d) : (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1a865effa673d7ef$export$40e543e69a8b3fbb) : (0, $1a865effa673d7ef$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1a865effa673d7ef$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1a865effa673d7ef$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $e621448a96b09849$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $275f8d6a6641063e$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $da8dccd643323927$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $2bbf4f59d1971c3f$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $da8dccd643323927$export$f28d906d67a997f3)(tether ? (0, $9bdb8f89d25ad73e$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $9bdb8f89d25ad73e$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1a865effa673d7ef$export$1e95b668f3b82d) : (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1a865effa673d7ef$export$40e543e69a8b3fbb) : (0, $1a865effa673d7ef$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1a865effa673d7ef$export$1e95b668f3b82d),
            (0, $1a865effa673d7ef$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $da8dccd643323927$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $da8dccd643323927$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f52a37255b686aa1$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $f52a37255b686aa1$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $5621403a98540a56$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $59b16cf6e0f6c4b9$export$2e2bcd8739ae039(node) {
    if (node === (0, $4b36e24b0e263bed$export$2e2bcd8739ae039)(node) || !(0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(node)) return (0, $5d92f7625ff838be$export$2e2bcd8739ae039)(node);
    else return (0, $5621403a98540a56$export$2e2bcd8739ae039)(node);
}








function $f60733b9bfac5281$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9bdb8f89d25ad73e$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9bdb8f89d25ad73e$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $f60733b9bfac5281$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(offsetParent) && $f60733b9bfac5281$var$isElementScaled(offsetParent);
    var documentElement = (0, $d96bc76888766dcf$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $d5bfaafc9d7f7364$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $8f9603f92ad9df2e$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $7dd5ec168d2a41e8$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $59b16cf6e0f6c4b9$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $82eb46d7de1e9bf1$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $d5bfaafc9d7f7364$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $a377837da06563d1$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $8a65814e1e5e35bd$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $8a65814e1e5e35bd$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $8a65814e1e5e35bd$var$order(modifiers); // order based on phase
    return (0, $1a865effa673d7ef$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $c4099b94a341cd7b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $94b11e3a74d12f43$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $5968de398423c62c$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $5968de398423c62c$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $5968de398423c62c$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $5968de398423c62c$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $5968de398423c62c$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $82eb46d7de1e9bf1$export$45a5e7f76e0caa8d)(reference) ? (0, $caf374c7e24b4b02$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $caf374c7e24b4b02$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $caf374c7e24b4b02$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $8a65814e1e5e35bd$export$2e2bcd8739ae039)((0, $94b11e3a74d12f43$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$5968de398423c62c$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $f60733b9bfac5281$export$2e2bcd8739ae039)(reference, (0, $2bbf4f59d1971c3f$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $e621448a96b09849$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $c4099b94a341cd7b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$5968de398423c62c$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $5968de398423c62c$export$8f7491d57c8f97a9 = /*#__PURE__*/ $5968de398423c62c$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $543d309e6238ef10$export$d34966752335dd47 = [
    (0, $1a88c2546fd8ca27$export$2e2bcd8739ae039),
    (0, $8deaafe3b63445cb$export$2e2bcd8739ae039),
    (0, $aa73cd006ea2efd9$export$2e2bcd8739ae039),
    (0, $d5591ea428204fc6$export$2e2bcd8739ae039),
    (0, $97f2ab77ff5bb32b$export$2e2bcd8739ae039),
    (0, $25bf80df604d56b9$export$2e2bcd8739ae039),
    (0, $f52a37255b686aa1$export$2e2bcd8739ae039),
    (0, $6ea4846a0493804a$export$2e2bcd8739ae039),
    (0, $c16b8bfe6b53211a$export$2e2bcd8739ae039)
];
var $543d309e6238ef10$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $5968de398423c62c$export$ed5e13716264f202)({
    defaultModifiers: $543d309e6238ef10$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $54666614edba354a$export$d34966752335dd47 = [
    (0, $1a88c2546fd8ca27$export$2e2bcd8739ae039),
    (0, $8deaafe3b63445cb$export$2e2bcd8739ae039),
    (0, $aa73cd006ea2efd9$export$2e2bcd8739ae039),
    (0, $d5591ea428204fc6$export$2e2bcd8739ae039)
];
var $54666614edba354a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $5968de398423c62c$export$ed5e13716264f202)({
    defaultModifiers: $54666614edba354a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($adfdd3111f594bc3$exports, $1a865effa673d7ef$exports);
$parcel$exportWildcard($adfdd3111f594bc3$exports, $8aa292e838b7fa60$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$elementMap = new Map();
const $cd5828f6ed3ced10$var$Data = {
    set (element, key, instance) {
        if (!$cd5828f6ed3ced10$var$elementMap.has(element)) $cd5828f6ed3ced10$var$elementMap.set(element, new Map());
        const instanceMap = $cd5828f6ed3ced10$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($cd5828f6ed3ced10$var$elementMap.has(element)) return $cd5828f6ed3ced10$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$cd5828f6ed3ced10$var$elementMap.has(element)) return;
        const instanceMap = $cd5828f6ed3ced10$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $cd5828f6ed3ced10$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $cd5828f6ed3ced10$var$MAX_UID = 1000000;
const $cd5828f6ed3ced10$var$MILLISECONDS_MULTIPLIER = 1000;
const $cd5828f6ed3ced10$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $cd5828f6ed3ced10$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $cd5828f6ed3ced10$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $cd5828f6ed3ced10$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $cd5828f6ed3ced10$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $cd5828f6ed3ced10$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $cd5828f6ed3ced10$var$MILLISECONDS_MULTIPLIER;
};
const $cd5828f6ed3ced10$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($cd5828f6ed3ced10$var$TRANSITION_END));
};
const $cd5828f6ed3ced10$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $cd5828f6ed3ced10$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($cd5828f6ed3ced10$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($cd5828f6ed3ced10$var$parseSelector(object));
    return null;
};
const $cd5828f6ed3ced10$var$isVisible = (element)=>{
    if (!$cd5828f6ed3ced10$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $cd5828f6ed3ced10$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $cd5828f6ed3ced10$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $cd5828f6ed3ced10$var$findShadowRoot(element.parentNode);
};
const $cd5828f6ed3ced10$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $cd5828f6ed3ced10$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $cd5828f6ed3ced10$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $cd5828f6ed3ced10$var$DOMContentLoadedCallbacks = [];
const $cd5828f6ed3ced10$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$cd5828f6ed3ced10$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $cd5828f6ed3ced10$var$DOMContentLoadedCallbacks)callback();
        });
        $cd5828f6ed3ced10$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $cd5828f6ed3ced10$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $cd5828f6ed3ced10$var$defineJQueryPlugin = (plugin)=>{
    $cd5828f6ed3ced10$var$onDOMContentLoaded(()=>{
        const $ = $cd5828f6ed3ced10$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $cd5828f6ed3ced10$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $cd5828f6ed3ced10$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $cd5828f6ed3ced10$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $cd5828f6ed3ced10$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($cd5828f6ed3ced10$var$TRANSITION_END, handler);
        $cd5828f6ed3ced10$var$execute(callback);
    };
    transitionElement.addEventListener($cd5828f6ed3ced10$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $cd5828f6ed3ced10$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $cd5828f6ed3ced10$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $cd5828f6ed3ced10$var$stripNameRegex = /\..*/;
const $cd5828f6ed3ced10$var$stripUidRegex = /::\d+$/;
const $cd5828f6ed3ced10$var$eventRegistry = {}; // Events storage
let $cd5828f6ed3ced10$var$uidEvent = 1;
const $cd5828f6ed3ced10$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $cd5828f6ed3ced10$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $cd5828f6ed3ced10$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$cd5828f6ed3ced10$var$uidEvent++}` || element.uidEvent || $cd5828f6ed3ced10$var$uidEvent++;
}
function $cd5828f6ed3ced10$var$getElementEvents(element) {
    const uid = $cd5828f6ed3ced10$var$makeEventUid(element);
    element.uidEvent = uid;
    $cd5828f6ed3ced10$var$eventRegistry[uid] = $cd5828f6ed3ced10$var$eventRegistry[uid] || {};
    return $cd5828f6ed3ced10$var$eventRegistry[uid];
}
function $cd5828f6ed3ced10$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $cd5828f6ed3ced10$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $cd5828f6ed3ced10$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $cd5828f6ed3ced10$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $cd5828f6ed3ced10$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $cd5828f6ed3ced10$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $cd5828f6ed3ced10$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $cd5828f6ed3ced10$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $cd5828f6ed3ced10$var$getTypeEvent(originalTypeEvent);
    if (!$cd5828f6ed3ced10$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $cd5828f6ed3ced10$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $cd5828f6ed3ced10$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $cd5828f6ed3ced10$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $cd5828f6ed3ced10$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $cd5828f6ed3ced10$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $cd5828f6ed3ced10$var$makeEventUid(callable, originalTypeEvent.replace($cd5828f6ed3ced10$var$namespaceRegex, ''));
    const fn = isDelegated ? $cd5828f6ed3ced10$var$bootstrapDelegationHandler(element, handler, callable) : $cd5828f6ed3ced10$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $cd5828f6ed3ced10$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $cd5828f6ed3ced10$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $cd5828f6ed3ced10$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $cd5828f6ed3ced10$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $cd5828f6ed3ced10$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($cd5828f6ed3ced10$var$stripNameRegex, '');
    return $cd5828f6ed3ced10$var$customEvents[event] || event;
}
const $cd5828f6ed3ced10$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $cd5828f6ed3ced10$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $cd5828f6ed3ced10$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $cd5828f6ed3ced10$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $cd5828f6ed3ced10$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $cd5828f6ed3ced10$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$cd5828f6ed3ced10$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($cd5828f6ed3ced10$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $cd5828f6ed3ced10$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $cd5828f6ed3ced10$var$getjQuery();
        const typeEvent = $cd5828f6ed3ced10$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $cd5828f6ed3ced10$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $cd5828f6ed3ced10$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $cd5828f6ed3ced10$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $cd5828f6ed3ced10$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $cd5828f6ed3ced10$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$cd5828f6ed3ced10$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$cd5828f6ed3ced10$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $cd5828f6ed3ced10$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $cd5828f6ed3ced10$var$normalizeData(element.getAttribute(`data-bs-${$cd5828f6ed3ced10$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $cd5828f6ed3ced10$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $cd5828f6ed3ced10$var$isElement(element) ? $cd5828f6ed3ced10$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$cd5828f6ed3ced10$var$isElement(element) ? $cd5828f6ed3ced10$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $cd5828f6ed3ced10$var$isElement(value) ? 'element' : $cd5828f6ed3ced10$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $cd5828f6ed3ced10$var$BaseComponent extends $cd5828f6ed3ced10$var$Config {
    constructor(element, config){
        super();
        element = $cd5828f6ed3ced10$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $cd5828f6ed3ced10$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $cd5828f6ed3ced10$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $cd5828f6ed3ced10$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $cd5828f6ed3ced10$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $cd5828f6ed3ced10$var$Data.get($cd5828f6ed3ced10$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $cd5828f6ed3ced10$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $cd5828f6ed3ced10$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$cd5828f6ed3ced10$var$parseSelector(sel)).join(',') : null;
};
const $cd5828f6ed3ced10$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$cd5828f6ed3ced10$var$isDisabled(el) && $cd5828f6ed3ced10$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $cd5828f6ed3ced10$var$getSelector(element);
        if (selector) return $cd5828f6ed3ced10$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $cd5828f6ed3ced10$var$getSelector(element);
        return selector ? $cd5828f6ed3ced10$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $cd5828f6ed3ced10$var$getSelector(element);
        return selector ? $cd5828f6ed3ced10$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $cd5828f6ed3ced10$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $cd5828f6ed3ced10$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($cd5828f6ed3ced10$var$isDisabled(this)) return;
        const target = $cd5828f6ed3ced10$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$f = 'alert';
const $cd5828f6ed3ced10$var$DATA_KEY$a = 'bs.alert';
const $cd5828f6ed3ced10$var$EVENT_KEY$b = `.${$cd5828f6ed3ced10$var$DATA_KEY$a}`;
const $cd5828f6ed3ced10$var$EVENT_CLOSE = `close${$cd5828f6ed3ced10$var$EVENT_KEY$b}`;
const $cd5828f6ed3ced10$var$EVENT_CLOSED = `closed${$cd5828f6ed3ced10$var$EVENT_KEY$b}`;
const $cd5828f6ed3ced10$var$CLASS_NAME_FADE$5 = 'fade';
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$caec2af78bcc877f extends $cd5828f6ed3ced10$var$BaseComponent {
    // Getters
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$enableDismissTrigger($cd5828f6ed3ced10$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$e = 'button';
const $cd5828f6ed3ced10$var$DATA_KEY$9 = 'bs.button';
const $cd5828f6ed3ced10$var$EVENT_KEY$a = `.${$cd5828f6ed3ced10$var$DATA_KEY$9}`;
const $cd5828f6ed3ced10$var$DATA_API_KEY$6 = '.data-api';
const $cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$3 = 'active';
const $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$6 = `click${$cd5828f6ed3ced10$var$EVENT_KEY$a}${$cd5828f6ed3ced10$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$353f5b6fc5456de1 extends $cd5828f6ed3ced10$var$BaseComponent {
    // Getters
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$6, $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$5);
    const data = $cd5828f6ed3ced10$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$d = 'swipe';
const $cd5828f6ed3ced10$var$EVENT_KEY$9 = '.bs.swipe';
const $cd5828f6ed3ced10$var$EVENT_TOUCHSTART = `touchstart${$cd5828f6ed3ced10$var$EVENT_KEY$9}`;
const $cd5828f6ed3ced10$var$EVENT_TOUCHMOVE = `touchmove${$cd5828f6ed3ced10$var$EVENT_KEY$9}`;
const $cd5828f6ed3ced10$var$EVENT_TOUCHEND = `touchend${$cd5828f6ed3ced10$var$EVENT_KEY$9}`;
const $cd5828f6ed3ced10$var$EVENT_POINTERDOWN = `pointerdown${$cd5828f6ed3ced10$var$EVENT_KEY$9}`;
const $cd5828f6ed3ced10$var$EVENT_POINTERUP = `pointerup${$cd5828f6ed3ced10$var$EVENT_KEY$9}`;
const $cd5828f6ed3ced10$var$POINTER_TYPE_TOUCH = 'touch';
const $cd5828f6ed3ced10$var$POINTER_TYPE_PEN = 'pen';
const $cd5828f6ed3ced10$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $cd5828f6ed3ced10$var$SWIPE_THRESHOLD = 40;
const $cd5828f6ed3ced10$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $cd5828f6ed3ced10$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$var$Swipe extends $cd5828f6ed3ced10$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$cd5828f6ed3ced10$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$c;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$c;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$d;
    }
    // Public
    dispose() {
        $cd5828f6ed3ced10$var$EventHandler.off(this._element, $cd5828f6ed3ced10$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $cd5828f6ed3ced10$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $cd5828f6ed3ced10$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $cd5828f6ed3ced10$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $cd5828f6ed3ced10$var$POINTER_TYPE_PEN || event.pointerType === $cd5828f6ed3ced10$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$c = 'carousel';
const $cd5828f6ed3ced10$var$DATA_KEY$8 = 'bs.carousel';
const $cd5828f6ed3ced10$var$EVENT_KEY$8 = `.${$cd5828f6ed3ced10$var$DATA_KEY$8}`;
const $cd5828f6ed3ced10$var$DATA_API_KEY$5 = '.data-api';
const $cd5828f6ed3ced10$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $cd5828f6ed3ced10$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $cd5828f6ed3ced10$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $cd5828f6ed3ced10$var$ORDER_NEXT = 'next';
const $cd5828f6ed3ced10$var$ORDER_PREV = 'prev';
const $cd5828f6ed3ced10$var$DIRECTION_LEFT = 'left';
const $cd5828f6ed3ced10$var$DIRECTION_RIGHT = 'right';
const $cd5828f6ed3ced10$var$EVENT_SLIDE = `slide${$cd5828f6ed3ced10$var$EVENT_KEY$8}`;
const $cd5828f6ed3ced10$var$EVENT_SLID = `slid${$cd5828f6ed3ced10$var$EVENT_KEY$8}`;
const $cd5828f6ed3ced10$var$EVENT_KEYDOWN$1 = `keydown${$cd5828f6ed3ced10$var$EVENT_KEY$8}`;
const $cd5828f6ed3ced10$var$EVENT_MOUSEENTER$1 = `mouseenter${$cd5828f6ed3ced10$var$EVENT_KEY$8}`;
const $cd5828f6ed3ced10$var$EVENT_MOUSELEAVE$1 = `mouseleave${$cd5828f6ed3ced10$var$EVENT_KEY$8}`;
const $cd5828f6ed3ced10$var$EVENT_DRAG_START = `dragstart${$cd5828f6ed3ced10$var$EVENT_KEY$8}`;
const $cd5828f6ed3ced10$var$EVENT_LOAD_DATA_API$3 = `load${$cd5828f6ed3ced10$var$EVENT_KEY$8}${$cd5828f6ed3ced10$var$DATA_API_KEY$5}`;
const $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$5 = `click${$cd5828f6ed3ced10$var$EVENT_KEY$8}${$cd5828f6ed3ced10$var$DATA_API_KEY$5}`;
const $cd5828f6ed3ced10$var$CLASS_NAME_CAROUSEL = 'carousel';
const $cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$2 = 'active';
const $cd5828f6ed3ced10$var$CLASS_NAME_SLIDE = 'slide';
const $cd5828f6ed3ced10$var$CLASS_NAME_END = 'carousel-item-end';
const $cd5828f6ed3ced10$var$CLASS_NAME_START = 'carousel-item-start';
const $cd5828f6ed3ced10$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $cd5828f6ed3ced10$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $cd5828f6ed3ced10$var$SELECTOR_ACTIVE = '.active';
const $cd5828f6ed3ced10$var$SELECTOR_ITEM = '.carousel-item';
const $cd5828f6ed3ced10$var$SELECTOR_ACTIVE_ITEM = $cd5828f6ed3ced10$var$SELECTOR_ACTIVE + $cd5828f6ed3ced10$var$SELECTOR_ITEM;
const $cd5828f6ed3ced10$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $cd5828f6ed3ced10$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $cd5828f6ed3ced10$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $cd5828f6ed3ced10$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $cd5828f6ed3ced10$var$KEY_TO_DIRECTION = {
    [$cd5828f6ed3ced10$var$ARROW_LEFT_KEY$1]: $cd5828f6ed3ced10$var$DIRECTION_RIGHT,
    [$cd5828f6ed3ced10$var$ARROW_RIGHT_KEY$1]: $cd5828f6ed3ced10$var$DIRECTION_LEFT
};
const $cd5828f6ed3ced10$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $cd5828f6ed3ced10$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$144901db2ea8e967 extends $cd5828f6ed3ced10$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $cd5828f6ed3ced10$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$b;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$b;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$c;
    }
    // Public
    next() {
        this._slide($cd5828f6ed3ced10$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $cd5828f6ed3ced10$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($cd5828f6ed3ced10$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $cd5828f6ed3ced10$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $cd5828f6ed3ced10$var$EventHandler.one(this._element, $cd5828f6ed3ced10$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $cd5828f6ed3ced10$var$EventHandler.one(this._element, $cd5828f6ed3ced10$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $cd5828f6ed3ced10$var$ORDER_NEXT : $cd5828f6ed3ced10$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $cd5828f6ed3ced10$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_ITEM_IMG, this._element))$cd5828f6ed3ced10$var$EventHandler.on(img, $cd5828f6ed3ced10$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $cd5828f6ed3ced10$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($cd5828f6ed3ced10$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($cd5828f6ed3ced10$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $cd5828f6ed3ced10$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $cd5828f6ed3ced10$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $cd5828f6ed3ced10$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $cd5828f6ed3ced10$var$ORDER_NEXT;
        const nextElement = element || $cd5828f6ed3ced10$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($cd5828f6ed3ced10$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $cd5828f6ed3ced10$var$CLASS_NAME_START : $cd5828f6ed3ced10$var$CLASS_NAME_END;
        const orderClassName = isNext ? $cd5828f6ed3ced10$var$CLASS_NAME_NEXT : $cd5828f6ed3ced10$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $cd5828f6ed3ced10$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($cd5828f6ed3ced10$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($cd5828f6ed3ced10$var$isRTL()) return direction === $cd5828f6ed3ced10$var$DIRECTION_LEFT ? $cd5828f6ed3ced10$var$ORDER_PREV : $cd5828f6ed3ced10$var$ORDER_NEXT;
        return direction === $cd5828f6ed3ced10$var$DIRECTION_LEFT ? $cd5828f6ed3ced10$var$ORDER_NEXT : $cd5828f6ed3ced10$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($cd5828f6ed3ced10$var$isRTL()) return order === $cd5828f6ed3ced10$var$ORDER_PREV ? $cd5828f6ed3ced10$var$DIRECTION_LEFT : $cd5828f6ed3ced10$var$DIRECTION_RIGHT;
        return order === $cd5828f6ed3ced10$var$ORDER_PREV ? $cd5828f6ed3ced10$var$DIRECTION_RIGHT : $cd5828f6ed3ced10$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$5, $cd5828f6ed3ced10$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $cd5828f6ed3ced10$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $cd5828f6ed3ced10$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($cd5828f6ed3ced10$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$cd5828f6ed3ced10$var$EventHandler.on(window, $cd5828f6ed3ced10$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$cd5828f6ed3ced10$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$b = 'collapse';
const $cd5828f6ed3ced10$var$DATA_KEY$7 = 'bs.collapse';
const $cd5828f6ed3ced10$var$EVENT_KEY$7 = `.${$cd5828f6ed3ced10$var$DATA_KEY$7}`;
const $cd5828f6ed3ced10$var$DATA_API_KEY$4 = '.data-api';
const $cd5828f6ed3ced10$var$EVENT_SHOW$6 = `show${$cd5828f6ed3ced10$var$EVENT_KEY$7}`;
const $cd5828f6ed3ced10$var$EVENT_SHOWN$6 = `shown${$cd5828f6ed3ced10$var$EVENT_KEY$7}`;
const $cd5828f6ed3ced10$var$EVENT_HIDE$6 = `hide${$cd5828f6ed3ced10$var$EVENT_KEY$7}`;
const $cd5828f6ed3ced10$var$EVENT_HIDDEN$6 = `hidden${$cd5828f6ed3ced10$var$EVENT_KEY$7}`;
const $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$4 = `click${$cd5828f6ed3ced10$var$EVENT_KEY$7}${$cd5828f6ed3ced10$var$DATA_API_KEY$4}`;
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$7 = 'show';
const $cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSE = 'collapse';
const $cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $cd5828f6ed3ced10$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSE} .${$cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSE}`;
const $cd5828f6ed3ced10$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $cd5828f6ed3ced10$var$WIDTH = 'width';
const $cd5828f6ed3ced10$var$HEIGHT = 'height';
const $cd5828f6ed3ced10$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $cd5828f6ed3ced10$var$Default$a = {
    parent: null,
    toggle: true
};
const $cd5828f6ed3ced10$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$78768a9af065a7b extends $cd5828f6ed3ced10$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $cd5828f6ed3ced10$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $cd5828f6ed3ced10$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$a;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$a;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($cd5828f6ed3ced10$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$cd5828f6ed3ced10$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSE, $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $cd5828f6ed3ced10$var$reflow(this._element);
        this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSE, $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $cd5828f6ed3ced10$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSE);
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $cd5828f6ed3ced10$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_HORIZONTAL) ? $cd5828f6ed3ced10$var$WIDTH : $cd5828f6ed3ced10$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $cd5828f6ed3ced10$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $cd5828f6ed3ced10$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($cd5828f6ed3ced10$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$4, $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $cd5828f6ed3ced10$var$SelectorEngine.getMultipleElementsFromSelector(this))$cd5828f6ed3ced10$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$a = 'dropdown';
const $cd5828f6ed3ced10$var$DATA_KEY$6 = 'bs.dropdown';
const $cd5828f6ed3ced10$var$EVENT_KEY$6 = `.${$cd5828f6ed3ced10$var$DATA_KEY$6}`;
const $cd5828f6ed3ced10$var$DATA_API_KEY$3 = '.data-api';
const $cd5828f6ed3ced10$var$ESCAPE_KEY$2 = 'Escape';
const $cd5828f6ed3ced10$var$TAB_KEY$1 = 'Tab';
const $cd5828f6ed3ced10$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $cd5828f6ed3ced10$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $cd5828f6ed3ced10$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $cd5828f6ed3ced10$var$EVENT_HIDE$5 = `hide${$cd5828f6ed3ced10$var$EVENT_KEY$6}`;
const $cd5828f6ed3ced10$var$EVENT_HIDDEN$5 = `hidden${$cd5828f6ed3ced10$var$EVENT_KEY$6}`;
const $cd5828f6ed3ced10$var$EVENT_SHOW$5 = `show${$cd5828f6ed3ced10$var$EVENT_KEY$6}`;
const $cd5828f6ed3ced10$var$EVENT_SHOWN$5 = `shown${$cd5828f6ed3ced10$var$EVENT_KEY$6}`;
const $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$3 = `click${$cd5828f6ed3ced10$var$EVENT_KEY$6}${$cd5828f6ed3ced10$var$DATA_API_KEY$3}`;
const $cd5828f6ed3ced10$var$EVENT_KEYDOWN_DATA_API = `keydown${$cd5828f6ed3ced10$var$EVENT_KEY$6}${$cd5828f6ed3ced10$var$DATA_API_KEY$3}`;
const $cd5828f6ed3ced10$var$EVENT_KEYUP_DATA_API = `keyup${$cd5828f6ed3ced10$var$EVENT_KEY$6}${$cd5828f6ed3ced10$var$DATA_API_KEY$3}`;
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$6 = 'show';
const $cd5828f6ed3ced10$var$CLASS_NAME_DROPUP = 'dropup';
const $cd5828f6ed3ced10$var$CLASS_NAME_DROPEND = 'dropend';
const $cd5828f6ed3ced10$var$CLASS_NAME_DROPSTART = 'dropstart';
const $cd5828f6ed3ced10$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $cd5828f6ed3ced10$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$3}.${$cd5828f6ed3ced10$var$CLASS_NAME_SHOW$6}`;
const $cd5828f6ed3ced10$var$SELECTOR_MENU = '.dropdown-menu';
const $cd5828f6ed3ced10$var$SELECTOR_NAVBAR = '.navbar';
const $cd5828f6ed3ced10$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $cd5828f6ed3ced10$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $cd5828f6ed3ced10$var$PLACEMENT_TOP = $cd5828f6ed3ced10$var$isRTL() ? 'top-end' : 'top-start';
const $cd5828f6ed3ced10$var$PLACEMENT_TOPEND = $cd5828f6ed3ced10$var$isRTL() ? 'top-start' : 'top-end';
const $cd5828f6ed3ced10$var$PLACEMENT_BOTTOM = $cd5828f6ed3ced10$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $cd5828f6ed3ced10$var$PLACEMENT_BOTTOMEND = $cd5828f6ed3ced10$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $cd5828f6ed3ced10$var$PLACEMENT_RIGHT = $cd5828f6ed3ced10$var$isRTL() ? 'left-start' : 'right-start';
const $cd5828f6ed3ced10$var$PLACEMENT_LEFT = $cd5828f6ed3ced10$var$isRTL() ? 'right-start' : 'left-start';
const $cd5828f6ed3ced10$var$PLACEMENT_TOPCENTER = 'top';
const $cd5828f6ed3ced10$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $cd5828f6ed3ced10$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $cd5828f6ed3ced10$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$931cbfb6bfb85fc extends $cd5828f6ed3ced10$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $cd5828f6ed3ced10$var$SelectorEngine.next(this._element, $cd5828f6ed3ced10$var$SELECTOR_MENU)[0] || $cd5828f6ed3ced10$var$SelectorEngine.prev(this._element, $cd5828f6ed3ced10$var$SELECTOR_MENU)[0] || $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$9;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$9;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($cd5828f6ed3ced10$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($cd5828f6ed3ced10$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$cd5828f6ed3ced10$var$EventHandler.on(element, 'mouseover', $cd5828f6ed3ced10$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$6);
        $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($cd5828f6ed3ced10$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$cd5828f6ed3ced10$var$EventHandler.off(element, 'mouseover', $cd5828f6ed3ced10$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $cd5828f6ed3ced10$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$cd5828f6ed3ced10$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$cd5828f6ed3ced10$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $adfdd3111f594bc3$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($cd5828f6ed3ced10$var$isElement(this._config.reference)) referenceElement = $cd5828f6ed3ced10$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $adfdd3111f594bc3$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_DROPEND)) return $cd5828f6ed3ced10$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_DROPSTART)) return $cd5828f6ed3ced10$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_DROPUP_CENTER)) return $cd5828f6ed3ced10$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_DROPDOWN_CENTER)) return $cd5828f6ed3ced10$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_DROPUP)) return isEnd ? $cd5828f6ed3ced10$var$PLACEMENT_TOPEND : $cd5828f6ed3ced10$var$PLACEMENT_TOP;
        return isEnd ? $cd5828f6ed3ced10$var$PLACEMENT_BOTTOMEND : $cd5828f6ed3ced10$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($cd5828f6ed3ced10$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $cd5828f6ed3ced10$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$cd5828f6ed3ced10$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$cd5828f6ed3ced10$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $cd5828f6ed3ced10$var$getNextActiveElement(items, target, key === $cd5828f6ed3ced10$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $cd5828f6ed3ced10$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $cd5828f6ed3ced10$var$TAB_KEY$1) return;
        const openToggles = $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $cd5828f6ed3ced10$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $cd5828f6ed3ced10$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $cd5828f6ed3ced10$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $cd5828f6ed3ced10$var$ARROW_UP_KEY$1,
            $cd5828f6ed3ced10$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$3) ? this : $cd5828f6ed3ced10$var$SelectorEngine.prev(this, $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$3)[0] || $cd5828f6ed3ced10$var$SelectorEngine.next(this, $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$3)[0] || $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $cd5828f6ed3ced10$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_KEYDOWN_DATA_API, $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$3, $cd5828f6ed3ced10$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_KEYDOWN_DATA_API, $cd5828f6ed3ced10$var$SELECTOR_MENU, $cd5828f6ed3ced10$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$3, $cd5828f6ed3ced10$export$931cbfb6bfb85fc.clearMenus);
$cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_KEYUP_DATA_API, $cd5828f6ed3ced10$export$931cbfb6bfb85fc.clearMenus);
$cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$3, $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $cd5828f6ed3ced10$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$9 = 'backdrop';
const $cd5828f6ed3ced10$var$CLASS_NAME_FADE$4 = 'fade';
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$5 = 'show';
const $cd5828f6ed3ced10$var$EVENT_MOUSEDOWN = `mousedown.bs.${$cd5828f6ed3ced10$var$NAME$9}`;
const $cd5828f6ed3ced10$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $cd5828f6ed3ced10$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$var$Backdrop extends $cd5828f6ed3ced10$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$8;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$8;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $cd5828f6ed3ced10$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $cd5828f6ed3ced10$var$reflow(element);
        element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $cd5828f6ed3ced10$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $cd5828f6ed3ced10$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $cd5828f6ed3ced10$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $cd5828f6ed3ced10$var$EventHandler.off(this._element, $cd5828f6ed3ced10$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $cd5828f6ed3ced10$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $cd5828f6ed3ced10$var$EventHandler.on(element, $cd5828f6ed3ced10$var$EVENT_MOUSEDOWN, ()=>{
            $cd5828f6ed3ced10$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $cd5828f6ed3ced10$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$8 = 'focustrap';
const $cd5828f6ed3ced10$var$DATA_KEY$5 = 'bs.focustrap';
const $cd5828f6ed3ced10$var$EVENT_KEY$5 = `.${$cd5828f6ed3ced10$var$DATA_KEY$5}`;
const $cd5828f6ed3ced10$var$EVENT_FOCUSIN$2 = `focusin${$cd5828f6ed3ced10$var$EVENT_KEY$5}`;
const $cd5828f6ed3ced10$var$EVENT_KEYDOWN_TAB = `keydown.tab${$cd5828f6ed3ced10$var$EVENT_KEY$5}`;
const $cd5828f6ed3ced10$var$TAB_KEY = 'Tab';
const $cd5828f6ed3ced10$var$TAB_NAV_FORWARD = 'forward';
const $cd5828f6ed3ced10$var$TAB_NAV_BACKWARD = 'backward';
const $cd5828f6ed3ced10$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $cd5828f6ed3ced10$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$var$FocusTrap extends $cd5828f6ed3ced10$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$7;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$7;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $cd5828f6ed3ced10$var$EventHandler.off(document, $cd5828f6ed3ced10$var$EVENT_KEY$5); // guard against infinite focus loop
        $cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $cd5828f6ed3ced10$var$EventHandler.off(document, $cd5828f6ed3ced10$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $cd5828f6ed3ced10$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $cd5828f6ed3ced10$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $cd5828f6ed3ced10$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $cd5828f6ed3ced10$var$TAB_NAV_BACKWARD : $cd5828f6ed3ced10$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $cd5828f6ed3ced10$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $cd5828f6ed3ced10$var$PROPERTY_PADDING = 'padding-right';
const $cd5828f6ed3ced10$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $cd5828f6ed3ced10$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $cd5828f6ed3ced10$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($cd5828f6ed3ced10$var$SELECTOR_FIXED_CONTENT, $cd5828f6ed3ced10$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($cd5828f6ed3ced10$var$SELECTOR_STICKY_CONTENT, $cd5828f6ed3ced10$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $cd5828f6ed3ced10$var$PROPERTY_PADDING);
        this._resetElementAttributes($cd5828f6ed3ced10$var$SELECTOR_FIXED_CONTENT, $cd5828f6ed3ced10$var$PROPERTY_PADDING);
        this._resetElementAttributes($cd5828f6ed3ced10$var$SELECTOR_STICKY_CONTENT, $cd5828f6ed3ced10$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $cd5828f6ed3ced10$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $cd5828f6ed3ced10$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $cd5828f6ed3ced10$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($cd5828f6ed3ced10$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $cd5828f6ed3ced10$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$7 = 'modal';
const $cd5828f6ed3ced10$var$DATA_KEY$4 = 'bs.modal';
const $cd5828f6ed3ced10$var$EVENT_KEY$4 = `.${$cd5828f6ed3ced10$var$DATA_KEY$4}`;
const $cd5828f6ed3ced10$var$DATA_API_KEY$2 = '.data-api';
const $cd5828f6ed3ced10$var$ESCAPE_KEY$1 = 'Escape';
const $cd5828f6ed3ced10$var$EVENT_HIDE$4 = `hide${$cd5828f6ed3ced10$var$EVENT_KEY$4}`;
const $cd5828f6ed3ced10$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$cd5828f6ed3ced10$var$EVENT_KEY$4}`;
const $cd5828f6ed3ced10$var$EVENT_HIDDEN$4 = `hidden${$cd5828f6ed3ced10$var$EVENT_KEY$4}`;
const $cd5828f6ed3ced10$var$EVENT_SHOW$4 = `show${$cd5828f6ed3ced10$var$EVENT_KEY$4}`;
const $cd5828f6ed3ced10$var$EVENT_SHOWN$4 = `shown${$cd5828f6ed3ced10$var$EVENT_KEY$4}`;
const $cd5828f6ed3ced10$var$EVENT_RESIZE$1 = `resize${$cd5828f6ed3ced10$var$EVENT_KEY$4}`;
const $cd5828f6ed3ced10$var$EVENT_CLICK_DISMISS = `click.dismiss${$cd5828f6ed3ced10$var$EVENT_KEY$4}`;
const $cd5828f6ed3ced10$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$cd5828f6ed3ced10$var$EVENT_KEY$4}`;
const $cd5828f6ed3ced10$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$cd5828f6ed3ced10$var$EVENT_KEY$4}`;
const $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$2 = `click${$cd5828f6ed3ced10$var$EVENT_KEY$4}${$cd5828f6ed3ced10$var$DATA_API_KEY$2}`;
const $cd5828f6ed3ced10$var$CLASS_NAME_OPEN = 'modal-open';
const $cd5828f6ed3ced10$var$CLASS_NAME_FADE$3 = 'fade';
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$4 = 'show';
const $cd5828f6ed3ced10$var$CLASS_NAME_STATIC = 'modal-static';
const $cd5828f6ed3ced10$var$OPEN_SELECTOR$1 = '.modal.show';
const $cd5828f6ed3ced10$var$SELECTOR_DIALOG = '.modal-dialog';
const $cd5828f6ed3ced10$var$SELECTOR_MODAL_BODY = '.modal-body';
const $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $cd5828f6ed3ced10$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $cd5828f6ed3ced10$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$2b77a92f1a5ad772 extends $cd5828f6ed3ced10$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $cd5828f6ed3ced10$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$6;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$6;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $cd5828f6ed3ced10$var$EventHandler.off(window, $cd5828f6ed3ced10$var$EVENT_KEY$4);
        $cd5828f6ed3ced10$var$EventHandler.off(this._dialog, $cd5828f6ed3ced10$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $cd5828f6ed3ced10$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $cd5828f6ed3ced10$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $cd5828f6ed3ced10$var$reflow(this._element);
        this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $cd5828f6ed3ced10$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $cd5828f6ed3ced10$var$EventHandler.on(window, $cd5828f6ed3ced10$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $cd5828f6ed3ced10$var$EventHandler.one(this._element, $cd5828f6ed3ced10$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $cd5828f6ed3ced10$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $cd5828f6ed3ced10$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$2, $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $cd5828f6ed3ced10$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $cd5828f6ed3ced10$var$EventHandler.one(target, $cd5828f6ed3ced10$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $cd5828f6ed3ced10$var$EventHandler.one(target, $cd5828f6ed3ced10$var$EVENT_HIDDEN$4, ()=>{
            if ($cd5828f6ed3ced10$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $cd5828f6ed3ced10$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $cd5828f6ed3ced10$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$cd5828f6ed3ced10$var$enableDismissTrigger($cd5828f6ed3ced10$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$6 = 'offcanvas';
const $cd5828f6ed3ced10$var$DATA_KEY$3 = 'bs.offcanvas';
const $cd5828f6ed3ced10$var$EVENT_KEY$3 = `.${$cd5828f6ed3ced10$var$DATA_KEY$3}`;
const $cd5828f6ed3ced10$var$DATA_API_KEY$1 = '.data-api';
const $cd5828f6ed3ced10$var$EVENT_LOAD_DATA_API$2 = `load${$cd5828f6ed3ced10$var$EVENT_KEY$3}${$cd5828f6ed3ced10$var$DATA_API_KEY$1}`;
const $cd5828f6ed3ced10$var$ESCAPE_KEY = 'Escape';
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$3 = 'show';
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOWING$1 = 'showing';
const $cd5828f6ed3ced10$var$CLASS_NAME_HIDING = 'hiding';
const $cd5828f6ed3ced10$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $cd5828f6ed3ced10$var$OPEN_SELECTOR = '.offcanvas.show';
const $cd5828f6ed3ced10$var$EVENT_SHOW$3 = `show${$cd5828f6ed3ced10$var$EVENT_KEY$3}`;
const $cd5828f6ed3ced10$var$EVENT_SHOWN$3 = `shown${$cd5828f6ed3ced10$var$EVENT_KEY$3}`;
const $cd5828f6ed3ced10$var$EVENT_HIDE$3 = `hide${$cd5828f6ed3ced10$var$EVENT_KEY$3}`;
const $cd5828f6ed3ced10$var$EVENT_HIDE_PREVENTED = `hidePrevented${$cd5828f6ed3ced10$var$EVENT_KEY$3}`;
const $cd5828f6ed3ced10$var$EVENT_HIDDEN$3 = `hidden${$cd5828f6ed3ced10$var$EVENT_KEY$3}`;
const $cd5828f6ed3ced10$var$EVENT_RESIZE = `resize${$cd5828f6ed3ced10$var$EVENT_KEY$3}`;
const $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$1 = `click${$cd5828f6ed3ced10$var$EVENT_KEY$3}${$cd5828f6ed3ced10$var$DATA_API_KEY$1}`;
const $cd5828f6ed3ced10$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$cd5828f6ed3ced10$var$EVENT_KEY$3}`;
const $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $cd5828f6ed3ced10$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $cd5828f6ed3ced10$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$591ca0244c9dfcd4 extends $cd5828f6ed3ced10$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$5;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$5;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $cd5828f6ed3ced10$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOWING$1);
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$3, $cd5828f6ed3ced10$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $cd5828f6ed3ced10$var$ScrollBarHelper().reset();
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $cd5828f6ed3ced10$var$Backdrop({
            className: $cd5828f6ed3ced10$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $cd5828f6ed3ced10$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $cd5828f6ed3ced10$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API$1, $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $cd5828f6ed3ced10$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($cd5828f6ed3ced10$var$isDisabled(this)) return;
    $cd5828f6ed3ced10$var$EventHandler.one(target, $cd5828f6ed3ced10$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($cd5828f6ed3ced10$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $cd5828f6ed3ced10$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $cd5828f6ed3ced10$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$cd5828f6ed3ced10$var$EventHandler.on(window, $cd5828f6ed3ced10$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$OPEN_SELECTOR))$cd5828f6ed3ced10$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$cd5828f6ed3ced10$var$EventHandler.on(window, $cd5828f6ed3ced10$var$EVENT_RESIZE, ()=>{
    for (const element of $cd5828f6ed3ced10$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $cd5828f6ed3ced10$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$cd5828f6ed3ced10$var$enableDismissTrigger($cd5828f6ed3ced10$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $cd5828f6ed3ced10$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $cd5828f6ed3ced10$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $cd5828f6ed3ced10$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $cd5828f6ed3ced10$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $cd5828f6ed3ced10$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $cd5828f6ed3ced10$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($cd5828f6ed3ced10$var$uriAttributes.has(attributeName)) return Boolean($cd5828f6ed3ced10$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $cd5828f6ed3ced10$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$cd5828f6ed3ced10$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$5 = 'TemplateFactory';
const $cd5828f6ed3ced10$var$Default$4 = {
    allowList: $cd5828f6ed3ced10$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $cd5828f6ed3ced10$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $cd5828f6ed3ced10$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$var$TemplateFactory extends $cd5828f6ed3ced10$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$4;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$4;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $cd5828f6ed3ced10$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $cd5828f6ed3ced10$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($cd5828f6ed3ced10$var$isElement(content)) {
            this._putElementInTemplate($cd5828f6ed3ced10$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $cd5828f6ed3ced10$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $cd5828f6ed3ced10$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$4 = 'tooltip';
const $cd5828f6ed3ced10$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $cd5828f6ed3ced10$var$CLASS_NAME_FADE$2 = 'fade';
const $cd5828f6ed3ced10$var$CLASS_NAME_MODAL = 'modal';
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$2 = 'show';
const $cd5828f6ed3ced10$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $cd5828f6ed3ced10$var$SELECTOR_MODAL = `.${$cd5828f6ed3ced10$var$CLASS_NAME_MODAL}`;
const $cd5828f6ed3ced10$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $cd5828f6ed3ced10$var$TRIGGER_HOVER = 'hover';
const $cd5828f6ed3ced10$var$TRIGGER_FOCUS = 'focus';
const $cd5828f6ed3ced10$var$TRIGGER_CLICK = 'click';
const $cd5828f6ed3ced10$var$TRIGGER_MANUAL = 'manual';
const $cd5828f6ed3ced10$var$EVENT_HIDE$2 = 'hide';
const $cd5828f6ed3ced10$var$EVENT_HIDDEN$2 = 'hidden';
const $cd5828f6ed3ced10$var$EVENT_SHOW$2 = 'show';
const $cd5828f6ed3ced10$var$EVENT_SHOWN$2 = 'shown';
const $cd5828f6ed3ced10$var$EVENT_INSERTED = 'inserted';
const $cd5828f6ed3ced10$var$EVENT_CLICK$1 = 'click';
const $cd5828f6ed3ced10$var$EVENT_FOCUSIN$1 = 'focusin';
const $cd5828f6ed3ced10$var$EVENT_FOCUSOUT$1 = 'focusout';
const $cd5828f6ed3ced10$var$EVENT_MOUSEENTER = 'mouseenter';
const $cd5828f6ed3ced10$var$EVENT_MOUSELEAVE = 'mouseleave';
const $cd5828f6ed3ced10$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $cd5828f6ed3ced10$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $cd5828f6ed3ced10$var$isRTL() ? 'right' : 'left'
};
const $cd5828f6ed3ced10$var$Default$3 = {
    allowList: $cd5828f6ed3ced10$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $cd5828f6ed3ced10$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$28c660c63b792dea extends $cd5828f6ed3ced10$var$BaseComponent {
    constructor(element, config){
        if (typeof $adfdd3111f594bc3$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$3;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$3;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $cd5828f6ed3ced10$var$EventHandler.off(this._element.closest($cd5828f6ed3ced10$var$SELECTOR_MODAL), $cd5828f6ed3ced10$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_SHOW$2));
        const shadowRoot = $cd5828f6ed3ced10$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$cd5828f6ed3ced10$var$EventHandler.on(element, 'mouseover', $cd5828f6ed3ced10$var$noop);
        const complete = ()=>{
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$cd5828f6ed3ced10$var$EventHandler.off(element, 'mouseover', $cd5828f6ed3ced10$var$noop);
        this._activeTrigger[$cd5828f6ed3ced10$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$cd5828f6ed3ced10$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$cd5828f6ed3ced10$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_FADE$2, $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $cd5828f6ed3ced10$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $cd5828f6ed3ced10$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$cd5828f6ed3ced10$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $cd5828f6ed3ced10$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $cd5828f6ed3ced10$var$AttachmentMap[placement.toUpperCase()];
        return $adfdd3111f594bc3$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $cd5828f6ed3ced10$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$cd5828f6ed3ced10$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $cd5828f6ed3ced10$var$EventHandler.on(this._element, this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$cd5828f6ed3ced10$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$cd5828f6ed3ced10$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $cd5828f6ed3ced10$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $cd5828f6ed3ced10$var$TRIGGER_HOVER ? this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_MOUSEENTER) : this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $cd5828f6ed3ced10$var$TRIGGER_HOVER ? this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_MOUSELEAVE) : this.constructor.eventName($cd5828f6ed3ced10$var$EVENT_FOCUSOUT$1);
                $cd5828f6ed3ced10$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $cd5828f6ed3ced10$var$TRIGGER_FOCUS : $cd5828f6ed3ced10$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $cd5828f6ed3ced10$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $cd5828f6ed3ced10$var$TRIGGER_FOCUS : $cd5828f6ed3ced10$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $cd5828f6ed3ced10$var$EventHandler.on(this._element.closest($cd5828f6ed3ced10$var$SELECTOR_MODAL), $cd5828f6ed3ced10$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $cd5828f6ed3ced10$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($cd5828f6ed3ced10$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $cd5828f6ed3ced10$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$3 = 'popover';
const $cd5828f6ed3ced10$var$SELECTOR_TITLE = '.popover-header';
const $cd5828f6ed3ced10$var$SELECTOR_CONTENT = '.popover-body';
const $cd5828f6ed3ced10$var$Default$2 = {
    ...$cd5828f6ed3ced10$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $cd5828f6ed3ced10$var$DefaultType$2 = {
    ...$cd5828f6ed3ced10$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$5b6b19405a83ff9d extends $cd5828f6ed3ced10$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$2;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$2;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$cd5828f6ed3ced10$var$SELECTOR_TITLE]: this._getTitle(),
            [$cd5828f6ed3ced10$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$2 = 'scrollspy';
const $cd5828f6ed3ced10$var$DATA_KEY$2 = 'bs.scrollspy';
const $cd5828f6ed3ced10$var$EVENT_KEY$2 = `.${$cd5828f6ed3ced10$var$DATA_KEY$2}`;
const $cd5828f6ed3ced10$var$DATA_API_KEY = '.data-api';
const $cd5828f6ed3ced10$var$EVENT_ACTIVATE = `activate${$cd5828f6ed3ced10$var$EVENT_KEY$2}`;
const $cd5828f6ed3ced10$var$EVENT_CLICK = `click${$cd5828f6ed3ced10$var$EVENT_KEY$2}`;
const $cd5828f6ed3ced10$var$EVENT_LOAD_DATA_API$1 = `load${$cd5828f6ed3ced10$var$EVENT_KEY$2}${$cd5828f6ed3ced10$var$DATA_API_KEY}`;
const $cd5828f6ed3ced10$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$1 = 'active';
const $cd5828f6ed3ced10$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $cd5828f6ed3ced10$var$SELECTOR_TARGET_LINKS = '[href]';
const $cd5828f6ed3ced10$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $cd5828f6ed3ced10$var$SELECTOR_NAV_LINKS = '.nav-link';
const $cd5828f6ed3ced10$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $cd5828f6ed3ced10$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $cd5828f6ed3ced10$var$SELECTOR_LINK_ITEMS = `${$cd5828f6ed3ced10$var$SELECTOR_NAV_LINKS}, ${$cd5828f6ed3ced10$var$SELECTOR_NAV_ITEMS} > ${$cd5828f6ed3ced10$var$SELECTOR_NAV_LINKS}, ${$cd5828f6ed3ced10$var$SELECTOR_LIST_ITEMS}`;
const $cd5828f6ed3ced10$var$SELECTOR_DROPDOWN = '.dropdown';
const $cd5828f6ed3ced10$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $cd5828f6ed3ced10$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $cd5828f6ed3ced10$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$a6472a5298a374be extends $cd5828f6ed3ced10$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default$1;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType$1;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $cd5828f6ed3ced10$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $cd5828f6ed3ced10$var$EventHandler.off(this._config.target, $cd5828f6ed3ced10$var$EVENT_CLICK);
        $cd5828f6ed3ced10$var$EventHandler.on(this._config.target, $cd5828f6ed3ced10$var$EVENT_CLICK, $cd5828f6ed3ced10$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $cd5828f6ed3ced10$var$isDisabled(anchor)) continue;
            const observableSection = $cd5828f6ed3ced10$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($cd5828f6ed3ced10$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($cd5828f6ed3ced10$var$SELECTOR_DROPDOWN)).classList.add($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $cd5828f6ed3ced10$var$SelectorEngine.parents(target, $cd5828f6ed3ced10$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $cd5828f6ed3ced10$var$SelectorEngine.prev(listGroup, $cd5828f6ed3ced10$var$SELECTOR_LINK_ITEMS))item.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $cd5828f6ed3ced10$var$SelectorEngine.find(`${$cd5828f6ed3ced10$var$SELECTOR_TARGET_LINKS}.${$cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$EventHandler.on(window, $cd5828f6ed3ced10$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_DATA_SPY))$cd5828f6ed3ced10$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME$1 = 'tab';
const $cd5828f6ed3ced10$var$DATA_KEY$1 = 'bs.tab';
const $cd5828f6ed3ced10$var$EVENT_KEY$1 = `.${$cd5828f6ed3ced10$var$DATA_KEY$1}`;
const $cd5828f6ed3ced10$var$EVENT_HIDE$1 = `hide${$cd5828f6ed3ced10$var$EVENT_KEY$1}`;
const $cd5828f6ed3ced10$var$EVENT_HIDDEN$1 = `hidden${$cd5828f6ed3ced10$var$EVENT_KEY$1}`;
const $cd5828f6ed3ced10$var$EVENT_SHOW$1 = `show${$cd5828f6ed3ced10$var$EVENT_KEY$1}`;
const $cd5828f6ed3ced10$var$EVENT_SHOWN$1 = `shown${$cd5828f6ed3ced10$var$EVENT_KEY$1}`;
const $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API = `click${$cd5828f6ed3ced10$var$EVENT_KEY$1}`;
const $cd5828f6ed3ced10$var$EVENT_KEYDOWN = `keydown${$cd5828f6ed3ced10$var$EVENT_KEY$1}`;
const $cd5828f6ed3ced10$var$EVENT_LOAD_DATA_API = `load${$cd5828f6ed3ced10$var$EVENT_KEY$1}`;
const $cd5828f6ed3ced10$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $cd5828f6ed3ced10$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $cd5828f6ed3ced10$var$ARROW_UP_KEY = 'ArrowUp';
const $cd5828f6ed3ced10$var$ARROW_DOWN_KEY = 'ArrowDown';
const $cd5828f6ed3ced10$var$HOME_KEY = 'Home';
const $cd5828f6ed3ced10$var$END_KEY = 'End';
const $cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE = 'active';
const $cd5828f6ed3ced10$var$CLASS_NAME_FADE$1 = 'fade';
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$1 = 'show';
const $cd5828f6ed3ced10$var$CLASS_DROPDOWN = 'dropdown';
const $cd5828f6ed3ced10$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $cd5828f6ed3ced10$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $cd5828f6ed3ced10$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$cd5828f6ed3ced10$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $cd5828f6ed3ced10$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $cd5828f6ed3ced10$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $cd5828f6ed3ced10$var$SELECTOR_INNER = `.nav-link${$cd5828f6ed3ced10$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$cd5828f6ed3ced10$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$cd5828f6ed3ced10$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $cd5828f6ed3ced10$var$SELECTOR_INNER_ELEM = `${$cd5828f6ed3ced10$var$SELECTOR_INNER}, ${$cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE}`;
const $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$3e41faf802a29e71 extends $cd5828f6ed3ced10$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($cd5828f6ed3ced10$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $cd5828f6ed3ced10$var$EventHandler.trigger(active, $cd5828f6ed3ced10$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(innerElem, $cd5828f6ed3ced10$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE);
        this._activate($cd5828f6ed3ced10$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $cd5828f6ed3ced10$var$EventHandler.trigger(element, $cd5828f6ed3ced10$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($cd5828f6ed3ced10$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $cd5828f6ed3ced10$var$EventHandler.trigger(element, $cd5828f6ed3ced10$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $cd5828f6ed3ced10$var$ARROW_LEFT_KEY,
            $cd5828f6ed3ced10$var$ARROW_RIGHT_KEY,
            $cd5828f6ed3ced10$var$ARROW_UP_KEY,
            $cd5828f6ed3ced10$var$ARROW_DOWN_KEY,
            $cd5828f6ed3ced10$var$HOME_KEY,
            $cd5828f6ed3ced10$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$cd5828f6ed3ced10$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $cd5828f6ed3ced10$var$HOME_KEY,
            $cd5828f6ed3ced10$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $cd5828f6ed3ced10$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $cd5828f6ed3ced10$var$ARROW_RIGHT_KEY,
                $cd5828f6ed3ced10$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $cd5828f6ed3ced10$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $cd5828f6ed3ced10$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $cd5828f6ed3ced10$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($cd5828f6ed3ced10$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $cd5828f6ed3ced10$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($cd5828f6ed3ced10$var$SELECTOR_DROPDOWN_TOGGLE, $cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE);
        toggle($cd5828f6ed3ced10$var$SELECTOR_DROPDOWN_MENU, $cd5828f6ed3ced10$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($cd5828f6ed3ced10$var$SELECTOR_INNER_ELEM) ? elem : $cd5828f6ed3ced10$var$SelectorEngine.findOne($cd5828f6ed3ced10$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($cd5828f6ed3ced10$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$EventHandler.on(document, $cd5828f6ed3ced10$var$EVENT_CLICK_DATA_API, $cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($cd5828f6ed3ced10$var$isDisabled(this)) return;
    $cd5828f6ed3ced10$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $cd5828f6ed3ced10$var$EventHandler.on(window, $cd5828f6ed3ced10$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $cd5828f6ed3ced10$var$SelectorEngine.find($cd5828f6ed3ced10$var$SELECTOR_DATA_TOGGLE_ACTIVE))$cd5828f6ed3ced10$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $cd5828f6ed3ced10$var$NAME = 'toast';
const $cd5828f6ed3ced10$var$DATA_KEY = 'bs.toast';
const $cd5828f6ed3ced10$var$EVENT_KEY = `.${$cd5828f6ed3ced10$var$DATA_KEY}`;
const $cd5828f6ed3ced10$var$EVENT_MOUSEOVER = `mouseover${$cd5828f6ed3ced10$var$EVENT_KEY}`;
const $cd5828f6ed3ced10$var$EVENT_MOUSEOUT = `mouseout${$cd5828f6ed3ced10$var$EVENT_KEY}`;
const $cd5828f6ed3ced10$var$EVENT_FOCUSIN = `focusin${$cd5828f6ed3ced10$var$EVENT_KEY}`;
const $cd5828f6ed3ced10$var$EVENT_FOCUSOUT = `focusout${$cd5828f6ed3ced10$var$EVENT_KEY}`;
const $cd5828f6ed3ced10$var$EVENT_HIDE = `hide${$cd5828f6ed3ced10$var$EVENT_KEY}`;
const $cd5828f6ed3ced10$var$EVENT_HIDDEN = `hidden${$cd5828f6ed3ced10$var$EVENT_KEY}`;
const $cd5828f6ed3ced10$var$EVENT_SHOW = `show${$cd5828f6ed3ced10$var$EVENT_KEY}`;
const $cd5828f6ed3ced10$var$EVENT_SHOWN = `shown${$cd5828f6ed3ced10$var$EVENT_KEY}`;
const $cd5828f6ed3ced10$var$CLASS_NAME_FADE = 'fade';
const $cd5828f6ed3ced10$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOW = 'show';
const $cd5828f6ed3ced10$var$CLASS_NAME_SHOWING = 'showing';
const $cd5828f6ed3ced10$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $cd5828f6ed3ced10$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $cd5828f6ed3ced10$export$8d8dc7d5f743331b extends $cd5828f6ed3ced10$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $cd5828f6ed3ced10$var$Default;
    }
    static get DefaultType() {
        return $cd5828f6ed3ced10$var$DefaultType;
    }
    static get NAME() {
        return $cd5828f6ed3ced10$var$NAME;
    }
    // Public
    show() {
        const showEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOWING);
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_HIDE); // @deprecated
        $cd5828f6ed3ced10$var$reflow(this._element);
        this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOW, $cd5828f6ed3ced10$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOWING, $cd5828f6ed3ced10$var$CLASS_NAME_SHOW);
            $cd5828f6ed3ced10$var$EventHandler.trigger(this._element, $cd5828f6ed3ced10$var$EVENT_HIDDEN);
        };
        this._element.classList.add($cd5828f6ed3ced10$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($cd5828f6ed3ced10$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($cd5828f6ed3ced10$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $cd5828f6ed3ced10$var$EventHandler.on(this._element, $cd5828f6ed3ced10$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $cd5828f6ed3ced10$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $cd5828f6ed3ced10$var$enableDismissTrigger($cd5828f6ed3ced10$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $cd5828f6ed3ced10$var$defineJQueryPlugin($cd5828f6ed3ced10$export$8d8dc7d5f743331b);




var $fde0330eb2207262$exports = {};
// This file is a compatibility shim for bundlers (e.g. webpack 4) that do not
// support the package.json `exports` field for resolving subpath exports.

$fde0330eb2207262$exports = (parcelRequire("7VAO1"));


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $434ad061ae625f3d$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


// This is a magic string replaced by rollup
const $c583f1158dc786e6$export$31499a9cd224b78c = "10.53.1";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db351febaeb5ade8$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db351febaeb5ade8$export$c8bfa33e4e8ae492((0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1));
    return 0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db351febaeb5ade8$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $c583f1158dc786e6$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $c583f1158dc786e6$export$31499a9cd224b78c] = __SENTRY__[0, $c583f1158dc786e6$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $db351febaeb5ade8$export$7e223ec222791509(name, creator, obj = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $c583f1158dc786e6$export$31499a9cd224b78c] = __SENTRY__[0, $c583f1158dc786e6$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}




const $dff4f20e1e252976$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $dff4f20e1e252976$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $dff4f20e1e252976$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $dff4f20e1e252976$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($dff4f20e1e252976$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $dff4f20e1e252976$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $dff4f20e1e252976$var$enable() {
    $dff4f20e1e252976$var$_getLoggerSettings().enabled = true;
}
function $dff4f20e1e252976$var$disable() {
    $dff4f20e1e252976$var$_getLoggerSettings().enabled = false;
}
function $dff4f20e1e252976$var$isEnabled() {
    return $dff4f20e1e252976$var$_getLoggerSettings().enabled;
}
function $dff4f20e1e252976$var$log(...args) {
    $dff4f20e1e252976$var$_maybeLog('log', ...args);
}
function $dff4f20e1e252976$var$warn(...args) {
    $dff4f20e1e252976$var$_maybeLog('warn', ...args);
}
function $dff4f20e1e252976$var$error(...args) {
    $dff4f20e1e252976$var$_maybeLog('error', ...args);
}
function $dff4f20e1e252976$var$_maybeLog(level, ...args) {
    if (!(0, $434ad061ae625f3d$export$16a28057038b10ef)) return;
    if ($dff4f20e1e252976$var$isEnabled()) $dff4f20e1e252976$export$cda52e2a8927a2ca(()=>{
        (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1).console[level](`${$dff4f20e1e252976$var$PREFIX}[${level}]:`, ...args);
    });
}
function $dff4f20e1e252976$var$_getLoggerSettings() {
    if (!(0, $434ad061ae625f3d$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $db351febaeb5ade8$export$7e223ec222791509)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $dff4f20e1e252976$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $dff4f20e1e252976$var$enable,
    disable: /** Disable logging. */ $dff4f20e1e252976$var$disable,
    isEnabled: /** Check if logging is enabled. */ $dff4f20e1e252976$var$isEnabled,
    log: /** Log a message. */ $dff4f20e1e252976$var$log,
    warn: /** Log a warning. */ $dff4f20e1e252976$var$warn,
    error: /** Log an error. */ $dff4f20e1e252976$var$error
};


const $b5f726c9e3580b87$var$STACKTRACE_FRAME_LIMIT = 50;
const $b5f726c9e3580b87$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $b5f726c9e3580b87$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $b5f726c9e3580b87$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $b5f726c9e3580b87$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $b5f726c9e3580b87$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($b5f726c9e3580b87$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            // Using includes() instead of a regex to avoid O(n²) backtracking on long lines
            // https://github.com/getsentry/sentry-javascript/issues/20052
            if (cleanedLine.includes('Error: ')) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $b5f726c9e3580b87$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $b5f726c9e3580b87$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $b5f726c9e3580b87$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $b5f726c9e3580b87$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $b5f726c9e3580b87$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($b5f726c9e3580b87$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($b5f726c9e3580b87$var$STRIP_FRAME_REGEXP.test($b5f726c9e3580b87$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($b5f726c9e3580b87$var$STRIP_FRAME_REGEXP.test($b5f726c9e3580b87$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $b5f726c9e3580b87$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $b5f726c9e3580b87$var$getLastStackFrame(localStack).filename,
            function: frame.function || $b5f726c9e3580b87$export$27c7e15d453fc0ac
        }));
}
function $b5f726c9e3580b87$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $b5f726c9e3580b87$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $b5f726c9e3580b87$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $b5f726c9e3580b87$var$defaultFunctionName;
        return fn.name || $b5f726c9e3580b87$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $b5f726c9e3580b87$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $b5f726c9e3580b87$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function $b5f726c9e3580b87$export$b6d9c5eb2330759f(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function $b5f726c9e3580b87$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith('file://') ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


// We keep the handlers globally
const $06902bc3616af5fd$var$handlers = {};
const $06902bc3616af5fd$var$instrumented = {};
/** Add a handler function. Returns a function to remove the handler. */ function $06902bc3616af5fd$export$a4e09611e30da72e(type, handler) {
    $06902bc3616af5fd$var$handlers[type] = $06902bc3616af5fd$var$handlers[type] || [];
    $06902bc3616af5fd$var$handlers[type].push(handler);
    return ()=>{
        const typeHandlers = $06902bc3616af5fd$var$handlers[type];
        if (typeHandlers) {
            const index = typeHandlers.indexOf(handler);
            if (index !== -1) typeHandlers.splice(index, 1);
        }
    };
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $06902bc3616af5fd$export$b17eab759a1cb5fe() {
    Object.keys($06902bc3616af5fd$var$handlers).forEach((key)=>{
        $06902bc3616af5fd$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $06902bc3616af5fd$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$06902bc3616af5fd$var$instrumented[type]) {
        $06902bc3616af5fd$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $06902bc3616af5fd$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $06902bc3616af5fd$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $b5f726c9e3580b87$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


// eslint-disable-next-line @typescript-eslint/unbound-method
const $8711648e54ceaa6b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$e6127cc7fe7395c3(wat) {
    switch($8711648e54ceaa6b$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $8711648e54ceaa6b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$var$isBuiltin(wat, className) {
    return $8711648e54ceaa6b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$9f9636d330b71954(wat) {
    return $8711648e54ceaa6b$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$ef9e2056653f0c8e(wat) {
    return $8711648e54ceaa6b$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$12e869b2a583f783(wat) {
    return $8711648e54ceaa6b$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$844ec244b1367d54(wat) {
    return $8711648e54ceaa6b$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$c3825b437cbdea5c(wat) {
    return wat === null || $8711648e54ceaa6b$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$53b83ca8eaab0383(wat) {
    return $8711648e54ceaa6b$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $8711648e54ceaa6b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $8711648e54ceaa6b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$49841c62b9eff15(wat) {
    return $8711648e54ceaa6b$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $8711648e54ceaa6b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$bc2894c7158efbac(wat) {
    return $8711648e54ceaa6b$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function $8711648e54ceaa6b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $8711648e54ceaa6b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $8711648e54ceaa6b$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $8711648e54ceaa6b$export$49034edbe6b62415(request, Request);
}



const $9971a806313be959$var$WINDOW = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1);
const $9971a806313be959$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $9971a806313be959$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $9971a806313be959$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $9971a806313be959$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $9971a806313be959$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($9971a806313be959$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $8711648e54ceaa6b$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $9971a806313be959$export$1cfafeee2987818b() {
    try {
        return $9971a806313be959$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $9971a806313be959$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$9971a806313be959$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}




/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $d727cbb61f53b6ae$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $d727cbb61f53b6ae$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $d727cbb61f53b6ae$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $d727cbb61f53b6ae$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $d727cbb61f53b6ae$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * Wrap a method on an object by name, only if it is not already wrapped.
 *
 * Note: to set the wrapped method as a non-enumerable property, pass
 * false as the `enumerable` argument. This could be detected, but only
 * by either walking up the prototype chain, or iterating over all fields
 * in a `for(in)` loop. Neither are an acceptable performance impact for
 * the rare case where we might patch a non-enumerable method.
 */ function $d727cbb61f53b6ae$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== 'function') throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($d727cbb61f53b6ae$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $d727cbb61f53b6ae$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $d727cbb61f53b6ae$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $d727cbb61f53b6ae$export$62ff257738bf57f5(value) {
    if ((0, $8711648e54ceaa6b$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$d727cbb61f53b6ae$var$getOwnProperties(value)
    };
    else if ((0, $8711648e54ceaa6b$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $d727cbb61f53b6ae$var$serializeEventTarget(value.target),
            currentTarget: $d727cbb61f53b6ae$var$serializeEventTarget(value.currentTarget),
            ...$d727cbb61f53b6ae$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $8711648e54ceaa6b$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $d727cbb61f53b6ae$var$serializeEventTarget(target) {
    try {
        return (0, $8711648e54ceaa6b$export$45a5e7f76e0caa8d)(target) ? (0, $9971a806313be959$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $d727cbb61f53b6ae$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $d727cbb61f53b6ae$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($d727cbb61f53b6ae$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $d727cbb61f53b6ae$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $d727cbb61f53b6ae$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $d727cbb61f53b6ae$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($d727cbb61f53b6ae$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($d727cbb61f53b6ae$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $d727cbb61f53b6ae$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $d727cbb61f53b6ae$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $d727cbb61f53b6ae$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $8711648e54ceaa6b$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




const $6f449ea8029de974$var$WINDOW = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $6f449ea8029de974$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $6f449ea8029de974$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $6f449ea8029de974$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $6f449ea8029de974$export$67fc34576016d6ec() {
    return 'history' in $6f449ea8029de974$var$WINDOW && !!$6f449ea8029de974$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $6f449ea8029de974$export$edf3cb81fd7d2a3e = $6f449ea8029de974$var$_isFetchSupported;
function $6f449ea8029de974$var$_isFetchSupported() {
    if (!('fetch' in $6f449ea8029de974$var$WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $6f449ea8029de974$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $6f449ea8029de974$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$6f449ea8029de974$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($6f449ea8029de974$export$d5f608b368e73f38($6f449ea8029de974$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $6f449ea8029de974$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $6f449ea8029de974$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $6f449ea8029de974$export$531055a6c684a70a() {
    return 'ReportingObserver' in $6f449ea8029de974$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $6f449ea8029de974$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$6f449ea8029de974$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}



const $35c456f1fd513008$export$56d8a8a25bd48b81 = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1);


let $ef4fb3eead0db2bd$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ef4fb3eead0db2bd$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $06902bc3616af5fd$export$a4e09611e30da72e)(type, handler);
    (0, $06902bc3616af5fd$export$e18d6c5462c01368)(type, $ef4fb3eead0db2bd$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $ef4fb3eead0db2bd$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $35c456f1fd513008$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $35c456f1fd513008$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $ef4fb3eead0db2bd$var$lastHref;
        $ef4fb3eead0db2bd$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $06902bc3616af5fd$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $6f449ea8029de974$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $ef4fb3eead0db2bd$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $ef4fb3eead0db2bd$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $ef4fb3eead0db2bd$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $06902bc3616af5fd$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $d727cbb61f53b6ae$export$9563e054e6f787fb)((0, $35c456f1fd513008$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $d727cbb61f53b6ae$export$9563e054e6f787fb)((0, $35c456f1fd513008$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}
function $ef4fb3eead0db2bd$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $35c456f1fd513008$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}


// undefined = not yet resolved, null = no runner found, function = runner found
let $dccfa60f681dae0e$var$RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function $dccfa60f681dae0e$export$ff239213cb80e2da(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if ($dccfa60f681dae0e$var$RESOLVED_RUNNER !== undefined) return $dccfa60f681dae0e$var$RESOLVED_RUNNER ? $dccfa60f681dae0e$var$RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for('__SENTRY_SAFE_RANDOM_ID_WRAPPER__');
    const globalWithSymbol = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === 'function') {
        $dccfa60f681dae0e$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $dccfa60f681dae0e$var$RESOLVED_RUNNER(cb);
    }
    $dccfa60f681dae0e$var$RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function $dccfa60f681dae0e$export$9869d72de32a3917() {
    return $dccfa60f681dae0e$export$ff239213cb80e2da(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function $dccfa60f681dae0e$export$65b1bada40c91b34() {
    return $dccfa60f681dae0e$export$ff239213cb80e2da(()=>Date.now());
}



const $52eaab10d44d3c9d$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $52eaab10d44d3c9d$export$7740643b9eeaf0c4() {
    return (0, $dccfa60f681dae0e$export$65b1bada40c91b34)() / $52eaab10d44d3c9d$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $52eaab10d44d3c9d$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $52eaab10d44d3c9d$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + (0, $dccfa60f681dae0e$export$ff239213cb80e2da)(()=>performance.now())) / $52eaab10d44d3c9d$var$ONE_SECOND_IN_MS;
    };
}
let $52eaab10d44d3c9d$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $52eaab10d44d3c9d$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $52eaab10d44d3c9d$var$_cachedTimestampInSeconds ?? ($52eaab10d44d3c9d$var$_cachedTimestampInSeconds = $52eaab10d44d3c9d$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $52eaab10d44d3c9d$var$cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function $52eaab10d44d3c9d$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1);
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = (0, $dccfa60f681dae0e$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $dccfa60f681dae0e$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === 'number') {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === 'number') {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $52eaab10d44d3c9d$export$baf075a948ffc0bf() {
    if ($52eaab10d44d3c9d$var$cachedTimeOrigin === null) $52eaab10d44d3c9d$var$cachedTimeOrigin = $52eaab10d44d3c9d$var$getBrowserTimeOrigin();
    return $52eaab10d44d3c9d$var$cachedTimeOrigin;
}








/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cb59d5f85403f0fd$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cb59d5f85403f0fd$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $cb59d5f85403f0fd$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line typescript/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $8711648e54ceaa6b$export$7916fad0ebc23f48)(value)) output.push((0, $b5f726c9e3580b87$export$b6d9c5eb2330759f)(value));
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cb59d5f85403f0fd$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $8711648e54ceaa6b$export$844ec244b1367d54)(value)) return false;
    if ((0, $8711648e54ceaa6b$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $8711648e54ceaa6b$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === 'function') return pattern(value);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cb59d5f85403f0fd$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    for (const pattern of patterns){
        if ($cb59d5f85403f0fd$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch)) return true;
    }
    return false;
}



function $d85cf031e838da82$var$getCrypto() {
    const gbl = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $d85cf031e838da82$var$emptyUuid;
function $d85cf031e838da82$var$getRandomByte() {
    return (0, $dccfa60f681dae0e$export$9869d72de32a3917)() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $d85cf031e838da82$export$19f53698e68b2496(crypto = $d85cf031e838da82$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $dccfa60f681dae0e$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, '');
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$d85cf031e838da82$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $d85cf031e838da82$var$emptyUuid = "10000000100040008000100000000000";
    return $d85cf031e838da82$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($d85cf031e838da82$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $d85cf031e838da82$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $d85cf031e838da82$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $d85cf031e838da82$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $d85cf031e838da82$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $d85cf031e838da82$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $d85cf031e838da82$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $d85cf031e838da82$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $d85cf031e838da82$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $d85cf031e838da82$export$d364f2020ab30578(input) {
    const match = input.match($d85cf031e838da82$var$SEMVER_REGEXP) || [];
    const major = $d85cf031e838da82$var$_parseInt(match[1]);
    const minor = $d85cf031e838da82$var$_parseInt(match[2]);
    const patch = $d85cf031e838da82$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $d85cf031e838da82$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $cb59d5f85403f0fd$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $cb59d5f85403f0fd$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $cb59d5f85403f0fd$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $d85cf031e838da82$export$6de4ffac6a2f1098(exception) {
    if ($d85cf031e838da82$export$4a38e013f66150b(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether we've already captured the given exception (note: not an identical exception - the very object).
 * It is considered already captured if it has the `__sentry_captured__` property set to `true`.
 *
 * @internal Only considered for internal usage
 */ function $d85cf031e838da82$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $b32aa6293d226b8c$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $d85cf031e838da82$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$b32aa6293d226b8c$var$sessionToJSON(session)
    };
    if (context) $b32aa6293d226b8c$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $b32aa6293d226b8c$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $d85cf031e838da82$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $b32aa6293d226b8c$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $b32aa6293d226b8c$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $b32aa6293d226b8c$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $8f2845ad3978edfd$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $8f2845ad3978edfd$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $abd12e78b754c30a$export$dc6d7ea554bcce10() {
    return (0, $d85cf031e838da82$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $abd12e78b754c30a$export$295213bc4d0c54ad() {
    return (0, $d85cf031e838da82$export$19f53698e68b2496)().substring(16);
}




const $7f119d045829b4a4$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $7f119d045829b4a4$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(scope, $7f119d045829b4a4$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$7f119d045829b4a4$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $7f119d045829b4a4$export$91f063ebb8eff307(scope) {
    return scope[$7f119d045829b4a4$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $e41e3e3a06073096$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $e41e3e3a06073096$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Attributes */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ /** Conversation ID */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $abd12e78b754c30a$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $dccfa60f681dae0e$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $e41e3e3a06073096$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $7f119d045829b4a4$export$3f25fa50c18e20ca)(newScope, (0, $7f119d045829b4a4$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $b32aa6293d226b8c$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || undefined;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $e41e3e3a06073096$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $8711648e54ceaa6b$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        this._conversationId = undefined;
        (0, $7f119d045829b4a4$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $abd12e78b754c30a$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $dccfa60f681dae0e$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $e41e3e3a06073096$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $52eaab10d44d3c9d$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $cb59d5f85403f0fd$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $7f119d045829b4a4$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $8f2845ad3978edfd$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $d85cf031e838da82$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $d85cf031e838da82$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $d85cf031e838da82$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $f64c0876a8258d18$export$6f1b9191db9c4d5() {
    return (0, $db351febaeb5ade8$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $e41e3e3a06073096$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $f64c0876a8258d18$export$de9862929b76bf57() {
    return (0, $db351febaeb5ade8$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $e41e3e3a06073096$export$775b6bb06e53a214)());
}



const $00945fc4fe582b3d$var$isActualPromise = (p)=>p instanceof Promise && !p[$00945fc4fe582b3d$var$kChainedCopy];
const $00945fc4fe582b3d$var$kChainedCopy = Symbol('chained PromiseLike');
/**
 * Copy the properties from a decorated promiselike object onto its chained
 * actual promise.
 */ const $00945fc4fe582b3d$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    // if we're just dealing with "normal" Promise objects, return the chain
    return $00945fc4fe582b3d$var$isActualPromise(chained) && $00945fc4fe582b3d$var$isActualPromise(original) ? chained : $00945fc4fe582b3d$var$copyProps(original, chained);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $00945fc4fe582b3d$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    //oxlint-disable-next-line guard-for-in
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === 'function') Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$00945fc4fe582b3d$var$kChainedCopy]: true
    });
    return chained;
};




/**
 * This is an object that holds a stack of scopes.
 */ class $4dba2c5ea79dbbd9$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $e41e3e3a06073096$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $e41e3e3a06073096$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $8711648e54ceaa6b$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $00945fc4fe582b3d$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $4dba2c5ea79dbbd9$var$getAsyncContextStack() {
    const registry = (0, $db351febaeb5ade8$export$19eade501500c6c1)();
    const sentry = (0, $db351febaeb5ade8$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $4dba2c5ea79dbbd9$export$d36ec451f120cfba((0, $f64c0876a8258d18$export$6f1b9191db9c4d5)(), (0, $f64c0876a8258d18$export$de9862929b76bf57)());
}
function $4dba2c5ea79dbbd9$var$withScope(callback) {
    return $4dba2c5ea79dbbd9$var$getAsyncContextStack().withScope(callback);
}
function $4dba2c5ea79dbbd9$var$withSetScope(scope, callback) {
    const stack = $4dba2c5ea79dbbd9$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $4dba2c5ea79dbbd9$var$withIsolationScope(callback) {
    return $4dba2c5ea79dbbd9$var$getAsyncContextStack().withScope(()=>{
        return callback($4dba2c5ea79dbbd9$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $4dba2c5ea79dbbd9$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $4dba2c5ea79dbbd9$var$withIsolationScope,
        withScope: $4dba2c5ea79dbbd9$var$withScope,
        withSetScope: $4dba2c5ea79dbbd9$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $4dba2c5ea79dbbd9$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$4dba2c5ea79dbbd9$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$4dba2c5ea79dbbd9$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $c87ccca6ff6fcb7d$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $db351febaeb5ade8$export$19eade501500c6c1)();
    const sentry = (0, $db351febaeb5ade8$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $c87ccca6ff6fcb7d$export$f639b0c2752203be(carrier) {
    const sentry = (0, $db351febaeb5ade8$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $4dba2c5ea79dbbd9$export$329d4d4d54e42710)();
}



/**
 * Type-guard: The attribute object has the shape the official attribute object (value, type, unit).
 * https://develop.sentry.dev/sdk/telemetry/scopes/#setting-attributes
 */ function $540615d8843eded4$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === 'object' && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes('value');
}
/**
 * Converts an attribute value to a typed attribute value.
 *
 * For now, we intentionally only support primitive values and attribute objects with primitive values.
 * If @param useFallback is true, we stringify non-primitive values to a string attribute value. Otherwise
 * we return `undefined` for unsupported values.
 *
 * @param value - The value of the passed attribute.
 * @param useFallback - If true, unsupported values will be stringified to a string attribute value.
 *                      Defaults to false. In this case, `undefined` is returned for unsupported values.
 * @returns The typed attribute.
 */ function $540615d8843eded4$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $540615d8843eded4$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: undefined
    };
    const attributeValue = $540615d8843eded4$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === 'string' ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === 'skip-undefined' && value === undefined) return;
    // Fallback: stringify the value
    // TODO(v11): be smarter here and use String constructor if stringify fails
    // (this is a breaking change for already existing attribute values)
    let stringValue = '';
    try {
        stringValue = JSON.stringify(value) ?? '';
    } catch  {
    // Do nothing
    }
    return {
        value: stringValue,
        type: 'string',
        ...checkedUnit
    };
}
/**
 * Serializes raw attributes to typed attributes as expected in our envelopes.
 *
 * @param attributes The raw attributes to serialize.
 * @param fallback   If true, unsupported values will be stringified to a string attribute value.
 *                   Defaults to false. In this case, `undefined` is returned for unsupported values.
 *
 * @returns The serialized attributes.
 */ function $540615d8843eded4$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $540615d8843eded4$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
/**
 * Estimates the serialized byte size of {@link Attributes},
 * with a couple of heuristics for performance.
 */ function $540615d8843eded4$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) // Assumption: Individual array items have the same type and roughly the same size
        // probably not always true but allows us to cut down on runtime
        weight += $540615d8843eded4$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $8711648e54ceaa6b$export$c3825b437cbdea5c)(val)) weight += $540615d8843eded4$var$estimatePrimitiveSizeInBytes(val);
        else // default fallback for anything else (objects)
        weight += 100;
    }
    return weight;
}
function $540615d8843eded4$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'boolean') return 4;
    else if (typeof value === 'number') return 8;
    return 0;
}
/**
 * NOTE: We intentionally do not return anything for non-primitive values:
 *  - array support will come in the future but if we stringify arrays now,
 *    sending arrays (unstringified) later will be a subtle breaking change.
 *  - Objects are not supported yet and product support is still TBD.
 *  - We still keep the type signature for TypedAttributeValue wider to avoid a
 *    breaking change once we add support for non-primitive values.
 *  - Once we go back to supporting arrays and stringifying all other values,
 *    we already implemented the serialization logic here:
 *    https://github.com/getsentry/sentry-javascript/pull/18165
 */ function $540615d8843eded4$var$getTypedAttributeValue(value) {
    const primitiveType = typeof value === 'string' ? 'string' : typeof value === 'boolean' ? 'boolean' : typeof value === 'number' && !Number.isNaN(value) ? Number.isInteger(value) ? 'integer' : 'double' : null;
    if (primitiveType) // @ts-expect-error - TS complains because {@link TypedAttributeValue} is strictly typed to
    // avoid setting the wrong `type` on the attribute value.
    // In this case, getPrimitiveType already does the check but TS doesn't know that.
    // The "clean" alternative is to return an object per `typeof value` case
    // but that would require more bundle size
    // Therefore, we ignore it.
    return {
        value: value,
        type: primitiveType
    };
}







let $9feed8e2dd0251ea$var$_externalPropagationContextProvider;
/**
 * Register an external propagation context provider function.
 * When registered, trace context will be read from the external source (e.g. OpenTelemetry)
 * instead of from the Sentry scope's propagation context.
 */ function $9feed8e2dd0251ea$export$b5defb3466e9689b(fn) {
    $9feed8e2dd0251ea$var$_externalPropagationContextProvider = fn;
}
/**
 * Get the external propagation context, if a provider has been registered.
 */ function $9feed8e2dd0251ea$export$92547f779c920a71() {
    return $9feed8e2dd0251ea$var$_externalPropagationContextProvider?.();
}
/**
 * Check if an external propagation context provider has been registered.
 */ function $9feed8e2dd0251ea$export$53f0ae651a1c4298() {
    return $9feed8e2dd0251ea$var$_externalPropagationContextProvider !== undefined;
}
/**
 * Get the currently active scope.
 */ function $9feed8e2dd0251ea$export$c7be4b0125a10cba() {
    const carrier = (0, $db351febaeb5ade8$export$19eade501500c6c1)();
    const acs = (0, $c87ccca6ff6fcb7d$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $9feed8e2dd0251ea$export$68f3af03034c9e90() {
    const carrier = (0, $db351febaeb5ade8$export$19eade501500c6c1)();
    const acs = (0, $c87ccca6ff6fcb7d$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $9feed8e2dd0251ea$export$aa55d5ab8e05984f() {
    return (0, $db351febaeb5ade8$export$7e223ec222791509)('globalScope', ()=>new (0, $e41e3e3a06073096$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $9feed8e2dd0251ea$export$ec58d9285c204497(...rest) {
    const carrier = (0, $db351febaeb5ade8$export$19eade501500c6c1)();
    const acs = (0, $c87ccca6ff6fcb7d$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $9feed8e2dd0251ea$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $db351febaeb5ade8$export$19eade501500c6c1)();
    const acs = (0, $c87ccca6ff6fcb7d$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $9feed8e2dd0251ea$export$6bb76d6eba7e258c() {
    return $9feed8e2dd0251ea$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $9feed8e2dd0251ea$export$1e83db7ee4876dc4(scope) {
    const externalContext = $9feed8e2dd0251ea$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $abd12e78b754c30a$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


/**
 * Use this attribute to represent the source of a span name.
 * Must be one of: custom, url, route, view, component, task
 * TODO(v11): rename this to sentry.span.source'
 */ const $b7026b2cd7685ea0$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $b7026b2cd7685ea0$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $b7026b2cd7685ea0$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $b7026b2cd7685ea0$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $b7026b2cd7685ea0$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $b7026b2cd7685ea0$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $b7026b2cd7685ea0$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $b7026b2cd7685ea0$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/** The release version of the application */ const $b7026b2cd7685ea0$export$f5cefb258679b29e = 'sentry.release';
/** The environment name (e.g., "production", "staging", "development") */ const $b7026b2cd7685ea0$export$d1b1dbb47f5ba57c = 'sentry.environment';
/** The segment name (e.g., "GET /users") */ const $b7026b2cd7685ea0$export$4626f2be16112c1c = 'sentry.segment.name';
/** The id of the segment that this span belongs to. */ const $b7026b2cd7685ea0$export$25fa4a1832d3736a = 'sentry.segment.id';
/** The name of the Sentry SDK (e.g., "sentry.php", "sentry.javascript") */ const $b7026b2cd7685ea0$export$87a4807042e1f1bb = 'sentry.sdk.name';
/** The version of the Sentry SDK */ const $b7026b2cd7685ea0$export$301ebe936458e291 = 'sentry.sdk.version';
/** The user ID */ const $b7026b2cd7685ea0$export$1f9cc1d34ea098a0 = 'user.id';
/** The user email */ const $b7026b2cd7685ea0$export$b7466609ef46c07e = 'user.email';
/** The user IP address */ const $b7026b2cd7685ea0$export$8d592bdaea63b930 = 'user.ip_address';
/** The user username */ const $b7026b2cd7685ea0$export$c05ee933d3f74b2b = 'user.name';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $b7026b2cd7685ea0$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $b7026b2cd7685ea0$export$1efec95406bbe327 = 'sentry.profile_id';
const $b7026b2cd7685ea0$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $b7026b2cd7685ea0$export$b016f89ac1066ec = 'cache.hit';
const $b7026b2cd7685ea0$export$3110e4c3f4386399 = 'cache.key';
const $b7026b2cd7685ea0$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $b7026b2cd7685ea0$export$be7a251980e7e946 = 'http.request.method';
const $b7026b2cd7685ea0$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $b7026b2cd7685ea0$export$ff77b5fd5b2d627b = 'sentry.link.type';
/**
 * =============================================================================
 * GEN AI ATTRIBUTES
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 * =============================================================================
 */ /**
 * The conversation ID for linking messages across API calls.
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $b7026b2cd7685ea0$export$71a4a707257f2774 = 'gen_ai.conversation.id';


const $4184b73679a4ffe0$export$136e25984ba4a383 = 0;
const $4184b73679a4ffe0$export$58f7963109c806fc = 1;
const $4184b73679a4ffe0$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $4184b73679a4ffe0$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $4184b73679a4ffe0$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $4184b73679a4ffe0$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $4184b73679a4ffe0$export$f966a0446ece71e,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $4184b73679a4ffe0$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $4184b73679a4ffe0$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}




/**
 * Interface representing a weak reference to an object.
 * This matches the standard WeakRef interface but is defined here
 * because WeakRef is not available in ES2020 type definitions.
 */ /**
 * Creates a weak reference to an object if WeakRef is available,
 * otherwise returns the object directly.
 *
 * This is useful for breaking circular references while maintaining
 * compatibility with environments that don't support WeakRef (e.g., older browsers).
 *
 * @param value - The object to create a weak reference to
 * @returns A WeakRef wrapper if available, or the original object as fallback
 */ function $9b8d1822a4d78cf0$export$f0b98edec95fcb33(value) {
    try {
        // @ts-expect-error - WeakRef may not be in the type definitions for older TS targets
        const WeakRefImpl = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === 'function') return new WeakRefImpl(value);
    } catch  {
    // WeakRef not available or construction failed
    }
    return value;
}
/**
 * Resolves a potentially weak reference, returning the underlying object
 * or undefined if the reference has been garbage collected.
 *
 * @param ref - A MaybeWeakRef or undefined
 * @returns The referenced object, or undefined if GC'd or ref was undefined
 */ function $9b8d1822a4d78cf0$export$a0592ad8c3586cf(ref) {
    if (!ref) return undefined;
    // Check if this is a WeakRef (has deref method)
    if (typeof ref === 'object' && 'deref' in ref && typeof ref.deref === 'function') try {
        return ref.deref();
    } catch  {
        // deref() failed - treat as GC'd
        return undefined;
    }
    // Direct reference fallback
    return ref;
}


const $e67d61e091c16e0d$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $e67d61e091c16e0d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $e67d61e091c16e0d$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(span, $e67d61e091c16e0d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $9b8d1822a4d78cf0$export$f0b98edec95fcb33)(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(span, $e67d61e091c16e0d$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function $e67d61e091c16e0d$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$e67d61e091c16e0d$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $9b8d1822a4d78cf0$export$a0592ad8c3586cf)(spanWithScopes[$e67d61e091c16e0d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}









const $261d23db97cfa84e$export$6e69537d67fa20f = 'sentry-';
const $261d23db97cfa84e$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $261d23db97cfa84e$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $261d23db97cfa84e$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $261d23db97cfa84e$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($261d23db97cfa84e$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($261d23db97cfa84e$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $261d23db97cfa84e$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$261d23db97cfa84e$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $261d23db97cfa84e$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $261d23db97cfa84e$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $8711648e54ceaa6b$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $261d23db97cfa84e$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $261d23db97cfa84e$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $261d23db97cfa84e$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $261d23db97cfa84e$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $261d23db97cfa84e$export$bdd844ddb2def819) {
            (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}
/**
 * Merge two baggage headers into one.
 * - Sentry-specific entries (keys starting with "sentry-") from the new
 *   baggage take precedence
 * - Non-Sentry entries from existing baggage take precedence
 *
 * The order of the existing baggage will be preserved, and new entries will
 * be added to the end.
 *
 * This matches the behavior of OTEL's propagation.inject() which uses
 * `baggage.setEntry()`  to overwrite existing entries with the same key.
 */ function $261d23db97cfa84e$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $261d23db97cfa84e$export$397de414d189db00(existing);
    const incomingEntries = $261d23db97cfa84e$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    // 1. All non-sentry entries from existing are kept
    // 2. All sentry- entries from the new baggage are retained
    // 3. If sentry- entries present in new, ignore from old, else keep from old.
    // 4. Non-sentry entries from new are only kept if not in existing.
    const merged = {};
    // partition incoming entries into sentry and non-sentry prefixed
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($261d23db97cfa84e$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    // If new baggage contains at least one sentry- value, we remove all old
    // sentry- values otherwise, we keep old sentry- values. If we don't remove
    // old sentry- values, we end up with an inconsistent dynamic sampling
    // context propagation.
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($261d23db97cfa84e$export$6e69537d67fa20f)) merged[key] = value;
    }
    // Assign new sentry fields.
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    // assign new non-sentry fields not found on existing object.
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ??= value;
    return $261d23db97cfa84e$export$12a7349a29a6e3c2(merged);
}




/** Regular expression used to extract org ID from a DSN host. */ const $519805124a6b4fa7$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $519805124a6b4fa7$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $519805124a6b4fa7$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $519805124a6b4fa7$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $519805124a6b4fa7$export$b892860177f70a30(str) {
    const match = $519805124a6b4fa7$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $dff4f20e1e252976$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $519805124a6b4fa7$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $519805124a6b4fa7$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $519805124a6b4fa7$var$validateDsn(dsn) {
    if (!(0, $434ad061ae625f3d$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $dff4f20e1e252976$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $dff4f20e1e252976$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$519805124a6b4fa7$var$isValidProtocol(protocol)) {
        (0, $dff4f20e1e252976$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $dff4f20e1e252976$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $519805124a6b4fa7$export$5914f4e7748c29c9(host) {
    const match = host.match($519805124a6b4fa7$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $519805124a6b4fa7$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $519805124a6b4fa7$export$5914f4e7748c29c9(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $519805124a6b4fa7$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $519805124a6b4fa7$export$b892860177f70a30(from) : $519805124a6b4fa7$var$dsnFromComponents(from);
    if (!components || !$519805124a6b4fa7$var$validateDsn(components)) return undefined;
    return components;
}


/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $4131862171d3666b$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}




// oxlint-disable-next-line sdk/no-regexp-constructor -- RegExp is used for readability here
const $a48eca9dcf573c0f$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $a48eca9dcf573c0f$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($a48eca9dcf573c0f$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $a48eca9dcf573c0f$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $a48eca9dcf573c0f$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $261d23db97cfa84e$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $abd12e78b754c30a$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $dccfa60f681dae0e$export$9869d72de32a3917)()
    };
    const sampleRand = $a48eca9dcf573c0f$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $a48eca9dcf573c0f$export$f35d907436da45cf(traceId = (0, $abd12e78b754c30a$export$dc6d7ea554bcce10)(), spanId = (0, $abd12e78b754c30a$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function $a48eca9dcf573c0f$export$1aff3752542747dd(traceId = (0, $abd12e78b754c30a$export$dc6d7ea554bcce10)(), spanId = (0, $abd12e78b754c30a$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? '01' : '00'}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $a48eca9dcf573c0f$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $4131862171d3666b$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $4131862171d3666b$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? (0, $dccfa60f681dae0e$export$9869d72de32a3917)() * parsedSampleRate : parsedSampleRate + (0, $dccfa60f681dae0e$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return (0, $dccfa60f681dae0e$export$9869d72de32a3917)();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $a48eca9dcf573c0f$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $519805124a6b4fa7$export$b7ac9b8efa4bb595)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




// These are aligned with OpenTelemetry trace flags
const $3af4f127b181b477$export$208d5b368507fb8b = 0x0;
const $3af4f127b181b477$export$eb571cd9b5d98de8 = 0x1;
let $3af4f127b181b477$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $3af4f127b181b477$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $3af4f127b181b477$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $3af4f127b181b477$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $3af4f127b181b477$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $e67d61e091c16e0d$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $abd12e78b754c30a$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $3af4f127b181b477$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $3af4f127b181b477$export$5caecac1caaf3a71(span);
    return (0, $a48eca9dcf573c0f$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function $3af4f127b181b477$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $3af4f127b181b477$export$5caecac1caaf3a71(span);
    return (0, $a48eca9dcf573c0f$export$1aff3752542747dd)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $3af4f127b181b477$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $3af4f127b181b477$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Converts the span links array to a flattened version with serialized attributes for V2 spans.
 *
 * If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $3af4f127b181b477$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $3af4f127b181b477$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $3af4f127b181b477$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $3af4f127b181b477$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $3af4f127b181b477$var$ensureTimestampInSeconds(input.getTime());
    return (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $3af4f127b181b477$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $3af4f127b181b477$export$92d8c23565496537(span) {
    if ($3af4f127b181b477$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($3af4f127b181b477$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $3af4f127b181b477$var$getOtelParentSpanId(span),
            start_timestamp: $3af4f127b181b477$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $3af4f127b181b477$export$3f7581298f56c6d7(endTime) || undefined,
            status: $3af4f127b181b477$export$e238a77ea3a8cd66(status),
            op: attributes[0, $b7026b2cd7685ea0$export$1a413bd9a88fdb09],
            origin: attributes[0, $b7026b2cd7685ea0$export$cca8dd30f57f805e],
            links: $3af4f127b181b477$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
/**
 * Convert a span to the intermediate {@link StreamedSpanJSON} representation.
 */ function $3af4f127b181b477$export$db0cad9e44f67af8(span) {
    if ($3af4f127b181b477$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($3af4f127b181b477$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $3af4f127b181b477$var$getOtelParentSpanId(span),
            start_timestamp: $3af4f127b181b477$export$3f7581298f56c6d7(startTime),
            end_timestamp: $3af4f127b181b477$export$3f7581298f56c6d7(endTime),
            is_segment: span === $3af4f127b181b477$export$7a3106f345d83bb6(span),
            status: $3af4f127b181b477$export$457dcd3df4e9f5c6(status),
            attributes: attributes,
            links: $3af4f127b181b477$export$9015adcf158ef3a5(links)
        };
    }
    // Finally, as a fallback, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: '',
        end_timestamp: 0,
        status: 'ok',
        is_segment: span === $3af4f127b181b477$export$7a3106f345d83bb6(span)
    };
}
/**
 * In preparation for the next major of OpenTelemetry, we want to support
 * looking up the parent span id according to the new API
 * In OTel v1, the parent span id is accessed as `parentSpanId`
 * In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
 */ function $3af4f127b181b477$var$getOtelParentSpanId(span) {
    return 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
}
/**
 * Converts a {@link StreamedSpanJSON} to a {@link SerializedSpan}.
 * This is the final serialized span format that is sent to Sentry.
 * The returned serilaized spans must not be consumed by users or SDK integrations.
 */ function $3af4f127b181b477$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $540615d8843eded4$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $540615d8843eded4$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $3af4f127b181b477$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $3af4f127b181b477$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $3af4f127b181b477$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $3af4f127b181b477$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $3af4f127b181b477$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $4184b73679a4ffe0$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $4184b73679a4ffe0$export$58f7963109c806fc)) return 'ok';
    return status.message || 'internal_error';
}
/**
 * Convert the various statuses to the simple ones expected by Sentry for streamed spans ('ok' is default).
 */ function $3af4f127b181b477$export$457dcd3df4e9f5c6(status) {
    return !status || status.code === (0, $4184b73679a4ffe0$export$58f7963109c806fc) || status.code === (0, $4184b73679a4ffe0$export$136e25984ba4a383) || status.message === 'cancelled' ? 'ok' : 'error';
}
const $3af4f127b181b477$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $3af4f127b181b477$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $3af4f127b181b477$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$3af4f127b181b477$var$ROOT_SPAN_FIELD] || span;
    (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(childSpan, $3af4f127b181b477$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$3af4f127b181b477$var$CHILD_SPANS_FIELD]) span[$3af4f127b181b477$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(span, $3af4f127b181b477$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $3af4f127b181b477$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$3af4f127b181b477$var$CHILD_SPANS_FIELD]) span[$3af4f127b181b477$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $3af4f127b181b477$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($3af4f127b181b477$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$3af4f127b181b477$var$CHILD_SPANS_FIELD] ? Array.from(span[$3af4f127b181b477$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ const $3af4f127b181b477$export$c4c6a79b1260ca1b = $3af4f127b181b477$export$7a3106f345d83bb6;
/**
 * Returns the segment span of a given span.
 */ function $3af4f127b181b477$export$7a3106f345d83bb6(span) {
    return span[$3af4f127b181b477$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $3af4f127b181b477$export$1be426a8e585c83e() {
    const carrier = (0, $db351febaeb5ade8$export$19eade501500c6c1)();
    const acs = (0, $c87ccca6ff6fcb7d$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $7f119d045829b4a4$export$91f063ebb8eff307)((0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $3af4f127b181b477$export$d11691ff45a3e535() {
    if (!$3af4f127b181b477$var$hasShownSpanDropWarning) {
        (0, $dff4f20e1e252976$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        $3af4f127b181b477$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $3af4f127b181b477$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $b7026b2cd7685ea0$export$d7a7d984b0791405)]: 'custom',
        [(0, $b7026b2cd7685ea0$export$165ce9a229f6f050)]: name
    });
}


// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $f8df15d2532bd8e1$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $f8df15d2532bd8e1$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $f8df15d2532bd8e1$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $f8df15d2532bd8e1$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $f8df15d2532bd8e1$export$5339fcdc8e2a427c(url) {
    if ($f8df15d2532bd8e1$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $f8df15d2532bd8e1$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $f8df15d2532bd8e1$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $f8df15d2532bd8e1$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $b7026b2cd7685ea0$export$d7a7d984b0791405)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $b7026b2cd7685ea0$export$d7a7d984b0791405] = 'route';
    }
    if (request?.method) attributes[0, $b7026b2cd7685ea0$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $b7026b2cd7685ea0$export$d7a7d984b0791405] = 'route';
        }
        if (!$f8df15d2532bd8e1$export$e258e13805402ba7(urlObject)) {
            attributes[0, $b7026b2cd7685ea0$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $f8df15d2532bd8e1$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $f8df15d2532bd8e1$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $f8df15d2532bd8e1$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $f8df15d2532bd8e1$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}
/**
 * Strips the content from a data URL, returning a placeholder with the MIME type.
 *
 * Data URLs can be very long (e.g. base64 encoded scripts for Web Workers),
 * with little valuable information, often leading to envelopes getting dropped due
 * to size limit violations. Therefore, we strip data URLs and replace them with a
 * placeholder.
 *
 * @param url - The URL to process
 * @param includeDataPrefix - If true, includes the first 10 characters of the data stream
 *                            for debugging (e.g., to identify magic bytes like WASM's AGFzbQ).
 *                            Defaults to true.
 * @returns For data URLs, returns a short format like `data:text/javascript;base64,SGVsbG8gV2... [truncated]`.
 *          For non-data URLs, returns the original URL unchanged.
 */ function $f8df15d2532bd8e1$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith('data:')) {
        // Match the MIME type (everything after 'data:' until the first ';' or ',')
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : 'text/plain';
        const isBase64 = url.includes(';base64,');
        // Find where the actual data starts (after the comma)
        const dataStart = url.indexOf(',');
        let dataPrefix = '';
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            // Include first 10 chars of data to help identify content (e.g., magic bytes)
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ',base64' : ''}${dataPrefix ? `,${dataPrefix}` : ''}`;
    }
    return url;
}





/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $8e3df96ad8a78c63$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $3af4f127b181b477$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $b7026b2cd7685ea0$export$69cd5c610c7bb96a)]: value,
            [(0, $b7026b2cd7685ea0$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $8e3df96ad8a78c63$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $b7026b2cd7685ea0$export$f5f95cff026507b5];
        const value = attributes[0, $b7026b2cd7685ea0$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4f59afc245df76a3$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





const $3b27883eaeb1dc49$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $3b27883eaeb1dc49$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $3b27883eaeb1dc49$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};




/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $ac5f61c2129cabc5$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $35c456f1fd513008$export$56d8a8a25bd48b81).performance?.getEntriesByType?.('navigation')[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases a zero value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // - https://github.com/GoogleChrome/web-vitals/issues/137
    // - https://github.com/GoogleChrome/web-vitals/issues/162
    // - https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5283a16626a69fa3$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $ac5f61c2129cabc5$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



/**
 * web-vitals 5.1.0 switched listeners to be added on the window rather than the document.
 * Instead of having to check for window/document every time we add a listener, we can use this function.
 */ function $e569939fdf3b2936$export$26d3d892edc56833(type, listener, options) {
    if ((0, $35c456f1fd513008$export$56d8a8a25bd48b81).document) (0, $35c456f1fd513008$export$56d8a8a25bd48b81).addEventListener(type, listener, options);
}
/**
 * web-vitals 5.1.0 switched listeners to be removed from the window rather than the document.
 * Instead of having to check for window/document every time we remove a listener, we can use this function.
 */ function $e569939fdf3b2936$export$324d7b4b46528191(type, listener, options) {
    if ((0, $35c456f1fd513008$export$56d8a8a25bd48b81).document) (0, $35c456f1fd513008$export$56d8a8a25bd48b81).removeEventListener(type, listener, options);
}


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $6518897f1b2f3c2b$var$firstHiddenTime = -1;
const $6518897f1b2f3c2b$var$onHiddenFunctions = new Set();
const $6518897f1b2f3c2b$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.visibilityState === 'hidden' && !(0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.prerendering ? 0 : Infinity;
};
const $6518897f1b2f3c2b$var$onVisibilityUpdate = (event)=>{
    // Handle changes to hidden state
    if ($6518897f1b2f3c2b$var$isPageHidden(event) && $6518897f1b2f3c2b$var$firstHiddenTime > -1) {
        // Sentry-specific change: Also call onHidden callbacks for pagehide events
        // to support older browsers (Safari <14.4) that don't properly fire visibilitychange
        if (event.type === 'visibilitychange' || event.type === 'pagehide') for (const onHiddenFunction of $6518897f1b2f3c2b$var$onHiddenFunctions)onHiddenFunction();
        // If the document is 'hidden' and no previous hidden timestamp has been
        // set (so is infinity), update it based on the current event data.
        if (!isFinite($6518897f1b2f3c2b$var$firstHiddenTime)) {
            // If the event is a 'visibilitychange' event, it means the page was
            // visible prior to this change, so the event timestamp is the first
            // hidden time.
            // However, if the event is not a 'visibilitychange' event, then it must
            // be a 'prerenderingchange' or 'pagehide' event, and the fact that the document is
            // still 'hidden' from the above check means the tab was activated
            // in a background state and so has always been hidden.
            $6518897f1b2f3c2b$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
            // We no longer need the `prerenderingchange` event listener now we've
            // set an initial init time so remove that
            // (we'll keep the visibilitychange and pagehide ones for onHiddenFunction above)
            (0, $e569939fdf3b2936$export$324d7b4b46528191)('prerenderingchange', $6518897f1b2f3c2b$var$onVisibilityUpdate, true);
        }
    }
};
const $6518897f1b2f3c2b$export$443f86b2c77012c4 = ()=>{
    if ((0, $35c456f1fd513008$export$56d8a8a25bd48b81).document && $6518897f1b2f3c2b$var$firstHiddenTime < 0) {
        // Check if we have a previous hidden `visibility-state` performance entry.
        const activationStart = (0, $5283a16626a69fa3$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $35c456f1fd513008$export$56d8a8a25bd48b81).document.prerendering ? globalThis.performance.getEntriesByType('visibility-state').filter((e)=>e.name === 'hidden' && e.startTime > activationStart)[0]?.startTime : undefined;
        // Prefer that, but if it's not available and the document is hidden when
        // this code runs, assume it was hidden since navigation start. This isn't
        // a perfect heuristic, but it's the best we can do until the
        // `visibility-state` performance entry becomes available in all browsers.
        $6518897f1b2f3c2b$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $6518897f1b2f3c2b$var$initHiddenTime();
        // Listen for visibility changes so we can handle things like bfcache
        // restores and/or prerender without having to examine individual
        // timestamps in detail and also for onHidden function calls.
        (0, $e569939fdf3b2936$export$26d3d892edc56833)('visibilitychange', $6518897f1b2f3c2b$var$onVisibilityUpdate, true);
        // Sentry-specific change: Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe. This is also required for older
        // Safari versions (<14.4) that we still support.
        (0, $e569939fdf3b2936$export$26d3d892edc56833)('pagehide', $6518897f1b2f3c2b$var$onVisibilityUpdate, true);
        // IMPORTANT: when a page is prerendering, its `visibilityState` is
        // 'hidden', so in order to account for cases where this module checks for
        // visibility during prerendering, an additional check after prerendering
        // completes is also required.
        (0, $e569939fdf3b2936$export$26d3d892edc56833)('prerenderingchange', $6518897f1b2f3c2b$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $6518897f1b2f3c2b$var$firstHiddenTime;
        },
        onHidden (cb) {
            $6518897f1b2f3c2b$var$onHiddenFunctions.add(cb);
        }
    };
};
/**
 * Check if the page is hidden, uses the `pagehide` event for older browsers support that we used to have in `onHidden` function.
 * Some browsers we still support (Safari <14.4) don't fully support `visibilitychange`
 * or have known bugs w.r.t the `visibilitychange` event.
 * // TODO (v11): If we decide to drop support for Safari 14.4, we can use the logic from web-vitals 4.2.4
 */ function $6518897f1b2f3c2b$var$isPageHidden(event) {
    return event.type === 'pagehide' || (0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.visibilityState === 'hidden';
}



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $4cc1544794ca7628$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $742ef70219ad6118$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $ac5f61c2129cabc5$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.prerendering || (0, $5283a16626a69fa3$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else if ((0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $4cc1544794ca7628$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a8dbca936c1be272$var$instanceMap = new WeakMap();
/**
 * A function that accepts and identity object and a class object and returns
 * either a new instance of that class or an existing instance, if the
 * identity object was previously used.
 */ function $a8dbca936c1be272$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$a8dbca936c1be272$var$instanceMap.get(identityObj)) $a8dbca936c1be272$var$instanceMap.set(identityObj, new ClassObj());
        return $a8dbca936c1be272$var$instanceMap.get(identityObj);
    } catch (_e) {
        // --- START Sentry-custom code (try/catch wrapping) ---
        // Fix for cases where identityObj is not a valid key for WeakMap (sometimes a problem in Safari)
        // Just return a new instance without caching it in instanceMap
        return new ClassObj();
    }
// --- END Sentry-custom code ---
}


/* eslint-disable jsdoc/require-jsdoc */ /*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5791ce2ce9552649$export$4050f7f955e19aa0 {
    constructor(){
        $5791ce2ce9552649$export$4050f7f955e19aa0.prototype.__init.call(this);
        $5791ce2ce9552649$export$4050f7f955e19aa0.prototype.__init2.call(this);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // oxlint-disable-next-line sdk/no-class-field-initializers
    __init() {
        this._sessionValue = 0;
    }
    // oxlint-disable-next-line sdk/no-class-field-initializers
    __init2() {
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        // Only count layout shifts without recent user input.
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        // This previously used `this._sessionEntries.at(-1)` but that is ES2022. We support ES2021 and earlier.
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        // If the entry occurred less than 1 second after the previous entry
        // and less than 5 seconds after the first entry in the session,
        // include the entry in the current session. Otherwise, start a new
        // session.
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $e148de782403136b$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {
    // Do nothing.
    }
    return;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2006c5b9eabf68f7$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};








/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8e22957e82acac43$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $8441a8c1807a4870$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $8441a8c1807a4870$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $8e22957e82acac43$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $6518897f1b2f3c2b$export$443f86b2c77012c4)();
        const metric = (0, $742ef70219ad6118$export$3c29b44508a0612b)('FCP');
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === 'first-contentful-paint') {
                po.disconnect();
                // Only report if the page wasn't hidden prior to the first paint.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The activationStart reference is used because FCP should be
                    // relative to page activation rather than navigation start if the
                    // page was prerendered. But in cases where `activationStart` occurs
                    // after the FCP, this time should be clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $5283a16626a69fa3$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $e148de782403136b$export$d1203567a167490e)('paint', handleEntries);
        if (po) report = (0, $3b27883eaeb1dc49$export$17679dccdd551979)(onReport, metric, $8441a8c1807a4870$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $faa872795caeb53d$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $faa872795caeb53d$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $8441a8c1807a4870$export$fe3c86b74e15d5de)((0, $2006c5b9eabf68f7$export$b841d51e31c12bab)(()=>{
        const metric = (0, $742ef70219ad6118$export$3c29b44508a0612b)('CLS', 0);
        let report;
        const visibilityWatcher = (0, $6518897f1b2f3c2b$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $a8dbca936c1be272$export$7c74c9b2462ddb3c)(opts, (0, $5791ce2ce9552649$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $e148de782403136b$export$d1203567a167490e)('layout-shift', handleEntries);
        if (po) {
            report = (0, $3b27883eaeb1dc49$export$17679dccdd551979)(onReport, metric, $faa872795caeb53d$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            (0, $35c456f1fd513008$export$56d8a8a25bd48b81)?.setTimeout?.(report);
        }
    }));
};







/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $b0f9370056c2557d$var$interactionCountEstimate = 0;
let $b0f9370056c2557d$var$minKnownInteractionId = Infinity;
let $b0f9370056c2557d$var$maxKnownInteractionId = 0;
const $b0f9370056c2557d$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $b0f9370056c2557d$var$minKnownInteractionId = Math.min($b0f9370056c2557d$var$minKnownInteractionId, e.interactionId);
            $b0f9370056c2557d$var$maxKnownInteractionId = Math.max($b0f9370056c2557d$var$maxKnownInteractionId, e.interactionId);
            $b0f9370056c2557d$var$interactionCountEstimate = $b0f9370056c2557d$var$maxKnownInteractionId ? ($b0f9370056c2557d$var$maxKnownInteractionId - $b0f9370056c2557d$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $b0f9370056c2557d$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $b0f9370056c2557d$export$8a962f2683a476d1 = ()=>{
    return $b0f9370056c2557d$var$po ? $b0f9370056c2557d$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $b0f9370056c2557d$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $b0f9370056c2557d$var$po) return;
    $b0f9370056c2557d$var$po = (0, $e148de782403136b$export$d1203567a167490e)('event', $b0f9370056c2557d$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $275581a39f22feac$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $275581a39f22feac$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $275581a39f22feac$var$getInteractionCountForNavigation = ()=>{
    return (0, $b0f9370056c2557d$export$8a962f2683a476d1)() - $275581a39f22feac$var$prevInteractionCount;
};
/**
 *
 */ class $275581a39f22feac$export$aaa80641d584351c {
    constructor(){
        $275581a39f22feac$export$aaa80641d584351c.prototype.__init.call(this);
        $275581a39f22feac$export$aaa80641d584351c.prototype.__init2.call(this);
    }
    /**
   * A list of longest interactions on the page (by latency) sorted so the
   * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
   * long.
   */ // oxlint-disable-next-line sdk/no-class-field-initializers
    __init() {
        this._longestInteractionList = [];
    }
    /**
   * A mapping of longest interactions by their interaction ID.
   * This is used for faster lookup.
   */ // oxlint-disable-next-line sdk/no-class-field-initializers
    __init2() {
        this._longestInteractionMap = new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $275581a39f22feac$var$prevInteractionCount = (0, $b0f9370056c2557d$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($275581a39f22feac$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        // Skip further processing for entries that cannot be INP candidates.
        if (!(entry.interactionId || entry.entryType === 'first-input')) return;
        // The least-long of the 10 longest interactions.
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        // Only process the entry if it's possibly one of the ten longest,
        // or if it's part of an existing interaction.
        if (interaction || this._longestInteractionList.length < $275581a39f22feac$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            // If the interaction already exists, update it. Otherwise create one.
            if (interaction) {
                // If the new entry has a longer duration, replace the old entries,
                // otherwise add to the array.
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            // Sort the entries by latency (descending) and keep only the top ten.
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $275581a39f22feac$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($275581a39f22feac$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction of removedInteractions)this._longestInteractionMap.delete(interaction.id);
            }
            // Call any post-processing on the interaction
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}








/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $95e1c140b7cce2ad$export$d3314d5863fc1fef = (cb)=>{
    const rIC = (0, $35c456f1fd513008$export$56d8a8a25bd48b81).requestIdleCallback || (0, $35c456f1fd513008$export$56d8a8a25bd48b81).setTimeout;
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.visibilityState === 'hidden') cb();
    else {
        // eslint-disable-next-line no-param-reassign
        cb = (0, $2006c5b9eabf68f7$export$b841d51e31c12bab)(cb);
        (0, $e569939fdf3b2936$export$26d3d892edc56833)('visibilitychange', cb, {
            once: true,
            capture: true
        });
        // sentry: we use pagehide instead of directly listening to visibilitychange
        // because some browsers we still support (Safari <14.4) don't fully support
        // `visibilitychange` or have known bugs w.r.t the `visibilitychange` event.
        // TODO(v11): remove this once we drop support for Safari <14.4
        (0, $e569939fdf3b2936$export$26d3d892edc56833)('pagehide', cb, {
            once: true,
            capture: true
        });
        rIC(()=>{
            cb();
            // Remove the above event listener since no longer required.
            // See: https://github.com/GoogleChrome/web-vitals/issues/622
            (0, $e569939fdf3b2936$export$324d7b4b46528191)('visibilitychange', cb, {
                capture: true
            });
            // TODO(v11): remove this once we drop support for Safari <14.4
            (0, $e569939fdf3b2936$export$324d7b4b46528191)('pagehide', cb, {
                capture: true
            });
        });
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $1177b0948a49d9bc$export$7f4cb060ded9173c = [
    200,
    500
];
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $1177b0948a49d9bc$var$DEFAULT_DURATION_THRESHOLD = 40;
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed
 * to control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 will not
 * be reported. To avoid reporting no interactions in these cases, the library
 * will fall back to the input delay of the first interaction. Note that this
 * will not affect your 75th percentile INP value unless that value is also
 * less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $1177b0948a49d9bc$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!(globalThis.PerformanceEventTiming && 'interactionId' in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $6518897f1b2f3c2b$export$443f86b2c77012c4)();
    (0, $8e22957e82acac43$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $b0f9370056c2557d$export$67d90cda6b78a2eb)();
        const metric = (0, $742ef70219ad6118$export$3c29b44508a0612b)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const interactionManager = (0, $a8dbca936c1be272$export$7c74c9b2462ddb3c)(opts, (0, $275581a39f22feac$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $95e1c140b7cce2ad$export$d3314d5863fc1fef)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $e148de782403136b$export$d1203567a167490e)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $1177b0948a49d9bc$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $3b27883eaeb1dc49$export$17679dccdd551979)(onReport, metric, $1177b0948a49d9bc$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: 'first-input',
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};








/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // eslint-disable-next-line jsdoc/require-jsdoc
class $88229cebea163f17$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $627ce29b7e94617a$export$948521ca5b0e1b17 = [
    2500,
    4000
];
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $627ce29b7e94617a$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $8e22957e82acac43$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $6518897f1b2f3c2b$export$443f86b2c77012c4)();
        const metric = (0, $742ef70219ad6118$export$3c29b44508a0612b)('LCP');
        let report;
        const lcpEntryManager = (0, $a8dbca936c1be272$export$7c74c9b2462ddb3c)(opts, (0, $88229cebea163f17$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $5283a16626a69fa3$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $e148de782403136b$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $3b27883eaeb1dc49$export$17679dccdd551979)(onReport, metric, $627ce29b7e94617a$export$948521ca5b0e1b17, opts.reportAllChanges);
            // Ensure this logic only runs once, since it can be triggered from
            // any of three different event listeners below.
            const stopListening = (0, $2006c5b9eabf68f7$export$b841d51e31c12bab)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            // Need a separate wrapper to ensure the `runOnce` function above is
            // common for all three functions
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    // Wrap the listener in an idle callback so it's run in a separate
                    // task to reduce potential INP impact.
                    // https://github.com/GoogleChrome/web-vitals/issues/383
                    (0, $95e1c140b7cce2ad$export$d3314d5863fc1fef)(stopListening);
                    (0, $e569939fdf3b2936$export$324d7b4b46528191)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            // Stop listening after input or visibilitychange.
            // Note: while scrolling is an input that stops LCP observation, it's
            // unreliable since it can be programmatically generated.
            // See: https://github.com/GoogleChrome/web-vitals/issues/75
            for (const type of [
                'keydown',
                'click',
                'visibilitychange'
            ])(0, $e569939fdf3b2936$export$26d3d892edc56833)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $b2e733ced3d0f01a$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $b2e733ced3d0f01a$var$whenReady = (callback)=>{
    if ((0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.prerendering) (0, $8e22957e82acac43$export$8bdb38a5671b594e)(()=>$b2e733ced3d0f01a$var$whenReady(callback));
    else if ((0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.readyState !== 'complete') addEventListener('load', ()=>$b2e733ced3d0f01a$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $b2e733ced3d0f01a$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $742ef70219ad6118$export$3c29b44508a0612b)('TTFB');
    const report = (0, $3b27883eaeb1dc49$export$17679dccdd551979)(onReport, metric, $b2e733ced3d0f01a$export$65c59ea8064668fc, opts.reportAllChanges);
    $b2e733ced3d0f01a$var$whenReady(()=>{
        const navigationEntry = (0, $ac5f61c2129cabc5$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $5283a16626a69fa3$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $5fd9244da26f7eb5$var$handlers = {};
const $5fd9244da26f7eb5$var$instrumented = {};
let $5fd9244da26f7eb5$var$_previousCls;
let $5fd9244da26f7eb5$var$_previousLcp;
let $5fd9244da26f7eb5$var$_previousTtfb;
let $5fd9244da26f7eb5$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $5fd9244da26f7eb5$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $5fd9244da26f7eb5$var$addMetricObserver('cls', callback, $5fd9244da26f7eb5$var$instrumentCls, $5fd9244da26f7eb5$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $5fd9244da26f7eb5$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $5fd9244da26f7eb5$var$addMetricObserver('lcp', callback, $5fd9244da26f7eb5$var$instrumentLcp, $5fd9244da26f7eb5$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a TTFD metric is available.
 */ function $5fd9244da26f7eb5$export$699d9529c099a797(callback) {
    return $5fd9244da26f7eb5$var$addMetricObserver('ttfb', callback, $5fd9244da26f7eb5$var$instrumentTtfb, $5fd9244da26f7eb5$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $5fd9244da26f7eb5$export$da3b76aa2022cbd7(callback) {
    return $5fd9244da26f7eb5$var$addMetricObserver('inp', callback, $5fd9244da26f7eb5$var$instrumentInp, $5fd9244da26f7eb5$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $5fd9244da26f7eb5$export$69816c1a049f8db6(type, callback) {
    $5fd9244da26f7eb5$var$addHandler(type, callback);
    if (!$5fd9244da26f7eb5$var$instrumented[type]) {
        $5fd9244da26f7eb5$var$instrumentPerformanceObserver(type);
        $5fd9244da26f7eb5$var$instrumented[type] = true;
    }
    return $5fd9244da26f7eb5$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $5fd9244da26f7eb5$var$triggerHandlers(type, data) {
    const typeHandlers = $5fd9244da26f7eb5$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $4f59afc245df76a3$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $b5f726c9e3580b87$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $5fd9244da26f7eb5$var$instrumentCls() {
    return (0, $faa872795caeb53d$export$a7873055838e5ad8)((metric)=>{
        $5fd9244da26f7eb5$var$triggerHandlers('cls', {
            metric: metric
        });
        $5fd9244da26f7eb5$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $5fd9244da26f7eb5$var$instrumentLcp() {
    return (0, $627ce29b7e94617a$export$947b1626ab8d5632)((metric)=>{
        $5fd9244da26f7eb5$var$triggerHandlers('lcp', {
            metric: metric
        });
        $5fd9244da26f7eb5$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $5fd9244da26f7eb5$var$instrumentTtfb() {
    return (0, $b2e733ced3d0f01a$export$33a01e6c5f2c7e33)((metric)=>{
        $5fd9244da26f7eb5$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $5fd9244da26f7eb5$var$_previousTtfb = metric;
    });
}
function $5fd9244da26f7eb5$var$instrumentInp() {
    return (0, $1177b0948a49d9bc$export$7df4b36ecaed99e1)((metric)=>{
        $5fd9244da26f7eb5$var$triggerHandlers('inp', {
            metric: metric
        });
        $5fd9244da26f7eb5$var$_previousInp = metric;
    });
}
function $5fd9244da26f7eb5$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $5fd9244da26f7eb5$var$addHandler(type, callback);
    let stopListening;
    if (!$5fd9244da26f7eb5$var$instrumented[type]) {
        stopListening = instrumentFn();
        $5fd9244da26f7eb5$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $5fd9244da26f7eb5$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $5fd9244da26f7eb5$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $e148de782403136b$export$d1203567a167490e)(type, (entries)=>{
        $5fd9244da26f7eb5$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $5fd9244da26f7eb5$var$addHandler(type, handler) {
    $5fd9244da26f7eb5$var$handlers[type] = $5fd9244da26f7eb5$var$handlers[type] || [];
    $5fd9244da26f7eb5$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $5fd9244da26f7eb5$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $5fd9244da26f7eb5$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $5fd9244da26f7eb5$export$7affb50b622d8714(entry) {
    return 'duration' in entry;
}











/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $824cebd24c79088d$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $824cebd24c79088d$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 *
 * For thenable objects with extra methods (like jQuery's jqXHR),
 * this function preserves those methods by wrapping the original thenable in a Proxy
 * that intercepts .then() calls to apply error handling while forwarding all other
 * properties to the original object.
 * This allows code like `startSpan(() => $.ajax(...)).abort()` to work correctly.
 */ function $824cebd24c79088d$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $8711648e54ceaa6b$export$f5b060c2914b97c8)(value)) return (0, $00945fc4fe582b3d$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    // Non-thenable value - call callbacks immediately and return as-is
    onFinally();
    onSuccess(value);
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $cea223cc34ca30b5$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





function $5d7f0e996d023f38$var$logIgnoredSpan(droppedSpan) {
    (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $5d7f0e996d023f38$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($5d7f0e996d023f38$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $cb59d5f85403f0fd$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $434ad061ae625f3d$export$16a28057038b10ef) && $5d7f0e996d023f38$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $cb59d5f85403f0fd$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $cb59d5f85403f0fd$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$5d7f0e996d023f38$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches`, `opMatches`, or `attrsMatch`. So in contrary to how this looks,
        // not all of op, name, and attributes actually have to match. This is the most efficient way to check
        // for all combinations of name, op, and attribute patterns.
        if (nameMatches && opMatches && attrsMatch) {
            (0, $434ad061ae625f3d$export$16a28057038b10ef) && $5d7f0e996d023f38$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $5d7f0e996d023f38$var$_matchesAttributeValue(actual, pat) {
    // String values support pattern matching
    if (typeof actual === 'string' && (typeof pat === 'string' || pat instanceof RegExp)) return (0, $cb59d5f85403f0fd$export$cdded5b28a5f8c6d)(actual, pat);
    // Arrays: element-wise strict equality
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    // Primitives: strict equality
    return actual === pat;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $5d7f0e996d023f38$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $5d7f0e996d023f38$var$isStringOrRegExp(value) {
    return typeof value === 'string' || value instanceof RegExp;
}


/**
 * Determines if span streaming is enabled for the given client
 */ function $8ed2e0baf98beef6$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === 'stream';
}








const $e2319ddaf8d9ed17$export$849dbeeeda01ae98 = 'production';
const $e2319ddaf8d9ed17$export$6829f580e78306fa = 'development';










/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $52f16f964d0c4a56$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $52f16f964d0c4a56$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(spanWithMaybeDsc, $52f16f964d0c4a56$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $52f16f964d0c4a56$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $e2319ddaf8d9ed17$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $519805124a6b4fa7$export$b7ac9b8efa4bb595)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $52f16f964d0c4a56$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $52f16f964d0c4a56$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $52f16f964d0c4a56$export$a117f995597e25df(span) {
    const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $3af4f127b181b477$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $b7026b2cd7685ea0$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $b7026b2cd7685ea0$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$52f16f964d0c4a56$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $261d23db97cfa84e$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $52f16f964d0c4a56$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    // TODO(v11): Only read `SEMANTIC_ATTRIBUTE_SENTRY_SOURCE` again, once we renamed it to `sentry.span.source`
    const source = rootSpanAttributes[0, $b7026b2cd7685ea0$export$d7a7d984b0791405] ?? rootSpanAttributes['sentry.span.source'];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $cea223cc34ca30b5$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $3af4f127b181b477$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $e67d61e091c16e0d$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $52f16f964d0c4a56$export$95cf936fdacaff7b(span) {
    const dsc = $52f16f964d0c4a56$export$a117f995597e25df(span);
    return (0, $261d23db97cfa84e$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $c8ec160f3fe35faf$export$2f3d84e767c9592b(span) {
    if (!(0, $434ad061ae625f3d$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $3af4f127b181b477$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $3af4f127b181b477$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $3af4f127b181b477$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $c8ec160f3fe35faf$export$b77c830667a4d630(span) {
    if (!(0, $434ad061ae625f3d$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $3af4f127b181b477$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $dff4f20e1e252976$export$1c9f709888824e05).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $95ff8194f02ebe17$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $cea223cc34ca30b5$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $4131862171d3666b$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $7a32c666d9124662$export$d6636b700b76c516 {
    /**
   * Reason why this span was dropped, if applicable ('ignored' or 'sample_rate').
   * Used to propagate the correct client report outcome to descendant spans
   * when span streaming is enabled.
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $abd12e78b754c30a$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $abd12e78b754c30a$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $3af4f127b181b477$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}






/**
 * A wrapper to use the new span format in your `beforeSendSpan` callback.
 *
 * When using `traceLifecycle: 'stream'`, wrap your callback with this function
 * to receive and return {@link StreamedSpanJSON} instead of the standard {@link SpanJSON}.
 *
 * @example
 *
 * Sentry.init({
 *   traceLifecycle: 'stream',
 *   beforeSendSpan: withStreamedSpan((span) => {
 *     // span is of type StreamedSpanJSON
 *     return span;
 *   }),
 * });
 *
 * @param callback - The callback function that receives and returns a {@link StreamedSpanJSON}.
 * @returns A callback that is compatible with the `beforeSendSpan` option when using `traceLifecycle: 'stream'`.
 */ function $edb30dd7dacee6c6$export$d3f49b33a1f44720(callback) {
    (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(callback, '_streamed', true);
    return callback;
}
/**
 * Typesafe check to identify if a `beforeSendSpan` callback expects the streamed span JSON format.
 *
 * @param callback - The `beforeSendSpan` callback to check.
 * @returns `true` if the callback was wrapped with {@link withStreamedSpan}.
 */ function $edb30dd7dacee6c6$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === 'function' && '_streamed' in callback && !!callback._streamed;
}







/**
 * Internal symbols for normalization behavior. JSON and other structured user payloads cannot
 * carry these keys, so they cannot spoof SDK-only normalization hints.
 * We use Symbol.for to ensure that the symbols are the same across different modules/files.
 */ const $b5b290cc11a634b2$var$SENTRY_SKIP_NORMALIZATION = Symbol.for('sentry.skipNormalization');
const $b5b290cc11a634b2$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH = Symbol.for('sentry.overrideNormalizationDepth');
/** Marks an object so `normalize` returns it unchanged (already-normalized SDK data). */ function $b5b290cc11a634b2$export$280812de8e91ea53(obj) {
    (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(obj, $b5b290cc11a634b2$var$SENTRY_SKIP_NORMALIZATION, true);
}
/** Overrides remaining normalization depth from this object downward (e.g. Redux / Pinia state). */ function $b5b290cc11a634b2$export$610d1422c4bdc4c1(obj, depth) {
    (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(obj, $b5b290cc11a634b2$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
/** @internal */ function $b5b290cc11a634b2$export$c8d26b7b28f926c7(value) {
    return Boolean(value[$b5b290cc11a634b2$var$SENTRY_SKIP_NORMALIZATION]);
}
/** @internal */ function $b5b290cc11a634b2$export$fe95a19841c4b155(value) {
    const v = value[$b5b290cc11a634b2$var$SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
    return typeof v === 'number' ? v : undefined;
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9a9da3a4e8f7687d$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $9a9da3a4e8f7687d$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $9a9da3a4e8f7687d$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $9a9da3a4e8f7687d$export$a3295358bff77e(object, depth);
    if ($9a9da3a4e8f7687d$var$jsonSize(normalized) > maxSize) return $9a9da3a4e8f7687d$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $9a9da3a4e8f7687d$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $9a9da3a4e8f7687d$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $9a9da3a4e8f7687d$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. Hints use internal symbols
    // (see normalizationHints.ts) so user-controlled JSON cannot spoof them.
    if ((0, $b5b290cc11a634b2$export$c8d26b7b28f926c7)(value)) return value;
    // Override remaining depth from this node (e.g. Redux / Pinia state). Set via setNormalizationDepthOverrideHint.
    const overrideDepth = (0, $b5b290cc11a634b2$export$fe95a19841c4b155)(value);
    const remainingDepth = overrideDepth !== undefined ? overrideDepth : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $9a9da3a4e8f7687d$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $d727cbb61f53b6ae$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $9a9da3a4e8f7687d$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $9a9da3a4e8f7687d$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $8711648e54ceaa6b$export$7916fad0ebc23f48)(value)) return (0, $b5f726c9e3580b87$export$b6d9c5eb2330759f)(value);
        // React's SyntheticEvent thingy
        if ((0, $8711648e54ceaa6b$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $b5f726c9e3580b87$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $9a9da3a4e8f7687d$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $9a9da3a4e8f7687d$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $9a9da3a4e8f7687d$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9a9da3a4e8f7687d$var$jsonSize(value) {
    return $9a9da3a4e8f7687d$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $9a9da3a4e8f7687d$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // oxlint-disable-next-line sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $9a9da3a4e8f7687d$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $10ec523d7aca4527$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $10ec523d7aca4527$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $10ec523d7aca4527$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $10ec523d7aca4527$export$604a45d95a155e2b(envelope, types) {
    return $10ec523d7aca4527$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $10ec523d7aca4527$var$encodeUTF8(input) {
    const carrier = (0, $db351febaeb5ade8$export$c8bfa33e4e8ae492)((0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $10ec523d7aca4527$var$decodeUTF8(input) {
    const carrier = (0, $db351febaeb5ade8$export$c8bfa33e4e8ae492)((0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $10ec523d7aca4527$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $10ec523d7aca4527$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $10ec523d7aca4527$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $9a9da3a4e8f7687d$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $10ec523d7aca4527$var$concatBuffers(parts);
}
function $10ec523d7aca4527$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $10ec523d7aca4527$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $10ec523d7aca4527$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($10ec523d7aca4527$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $10ec523d7aca4527$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $10ec523d7aca4527$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $10ec523d7aca4527$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
// Map of envelope item types to data categories where the category differs from the type.
// Types that map to themselves (session, attachment, transaction, profile, feedback, span, metric) fall through.
const $10ec523d7aca4527$var$DATA_CATEGORY_OVERRIDES = {
    sessions: 'session',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    raw_security: 'security',
    log: 'log_item',
    trace_metric: 'metric'
};
function $10ec523d7aca4527$var$_isOverriddenType(type) {
    return type in $10ec523d7aca4527$var$DATA_CATEGORY_OVERRIDES;
}
/**
 * Maps the type of an envelope item to a data category.
 */ function $10ec523d7aca4527$export$b11169581eeaf237(type) {
    return $10ec523d7aca4527$var$_isOverriddenType(type) ? $10ec523d7aca4527$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
/** Extracts the minimal SDK info from the metadata or an events */ function $10ec523d7aca4527$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $10ec523d7aca4527$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $519805124a6b4fa7$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $80024eb41c2cefa2$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function $80024eb41c2cefa2$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $10ec523d7aca4527$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $519805124a6b4fa7$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $10ec523d7aca4527$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $80024eb41c2cefa2$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $10ec523d7aca4527$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $80024eb41c2cefa2$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $10ec523d7aca4527$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $10ec523d7aca4527$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $80024eb41c2cefa2$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $52f16f964d0c4a56$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $519805124a6b4fa7$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $3af4f127b181b477$export$92d8c23565496537)(span);
        return !(0, $5d7f0e996d023f38$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent('before_send', 'span', droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $3af4f127b181b477$export$92d8c23565496537)(span);
        const processedSpan = !(0, $edb30dd7dacee6c6$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $3af4f127b181b477$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $3af4f127b181b477$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $10ec523d7aca4527$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $10ec523d7aca4527$export$f93f7f385160c44e)(headers, items);
}












/* eslint-disable max-lines */ const $016540ffc6cdbb33$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $016540ffc6cdbb33$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $abd12e78b754c30a$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $abd12e78b754c30a$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'manual',
            [(0, $b7026b2cd7685ea0$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $3af4f127b181b477$export$eb571cd9b5d98de8) : (0, $3af4f127b181b477$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $3af4f127b181b477$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $b7026b2cd7685ea0$export$d7a7d984b0791405), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $3af4f127b181b477$export$3f7581298f56c6d7)(endTimestamp);
        (0, $c8ec160f3fe35faf$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $b7026b2cd7685ea0$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $3af4f127b181b477$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $b7026b2cd7685ea0$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $b7026b2cd7685ea0$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $b7026b2cd7685ea0$export$fea48ba9f4550879],
            measurements: (0, $8e3df96ad8a78c63$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $3af4f127b181b477$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? '',
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(this),
            status: (0, $3af4f127b181b477$export$457dcd3df4e9f5c6)(this._status),
            attributes: this._attributes,
            links: (0, $3af4f127b181b477$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log('[Tracing] Adding an event to span:', name);
        const time = $016540ffc6cdbb33$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)();
        const attributes = $016540ffc6cdbb33$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $3af4f127b181b477$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit('spanEnd', this);
            // Guarding sending standalone v1 spans as v2 streamed spans for now.
            // Otherwise they'd be sent once as v1 spans and again as streamed spans.
            // We'll migrate CLS and LCP spans to streamed spans in a later PR and
            // INP spans in the next major of the SDK. At that point, we can fully remove
            // standalone v1 spans <3
            if (!this._isStandaloneSpan) client.emit('afterSpanEnd', this);
        }
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $016540ffc6cdbb33$var$sendSpanEnvelope((0, $80024eb41c2cefa2$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        } else if (client && (0, $8ed2e0baf98beef6$export$6ea47215d699c04a)(client)) {
            // TODO (spans): Remove standalone span custom logic in favor of sending simple v2 web vital spans
            client.emit('afterSegmentSpanEnd', this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $e67d61e091c16e0d$export$c08fbc656a245d03)(this).scope || (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$016540ffc6cdbb33$var$isFullFinishedSpan((0, $3af4f127b181b477$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $e67d61e091c16e0d$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $3af4f127b181b477$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$016540ffc6cdbb33$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $3af4f127b181b477$export$92d8c23565496537)(span)).filter($016540ffc6cdbb33$var$isFullFinishedSpan);
        const source = this._attributes[0, $b7026b2cd7685ea0$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $b7026b2cd7685ea0$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[0, $b7026b2cd7685ea0$export$165ce9a229f6f050];
            if (span.op?.startsWith('gen_ai.')) hasGenAiSpans = true;
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $3af4f127b181b477$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $016540ffc6cdbb33$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $016540ffc6cdbb33$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $52f16f964d0c4a56$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $8e3df96ad8a78c63$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $016540ffc6cdbb33$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $016540ffc6cdbb33$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $016540ffc6cdbb33$var$isStandaloneSpan(span) {
    return span instanceof $016540ffc6cdbb33$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $016540ffc6cdbb33$var$sendSpanEnvelope(envelope) {
    const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $adeacbae769fc647$export$61ab4e30f2201736 = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $adeacbae769fc647$export$a1bd95187356f372(options, callback) {
    const acs = $adeacbae769fc647$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $adeacbae769fc647$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $9feed8e2dd0251ea$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $adeacbae769fc647$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)();
            const parentSpan = $adeacbae769fc647$var$getParentSpan(scope, customParentSpan);
            const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $7a32c666d9124662$export$d6636b700b76c516)() : $adeacbae769fc647$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent('no_parent_span', 'span');
            // Ignored root spans still need to be set on scope so that `getActiveSpan()` returns them
            // and descendants are also non-recording. Ignored child spans don't need this because
            // the parent span is already on scope.
            if (!$adeacbae769fc647$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $7f119d045829b4a4$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $824cebd24c79088d$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $3af4f127b181b477$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $4184b73679a4ffe0$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $adeacbae769fc647$export$c10292ad04b92aea(options, callback) {
    const acs = $adeacbae769fc647$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $adeacbae769fc647$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $9feed8e2dd0251ea$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $adeacbae769fc647$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)();
            const parentSpan = $adeacbae769fc647$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $7a32c666d9124662$export$d6636b700b76c516)() : $adeacbae769fc647$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)()?.recordDroppedEvent('no_parent_span', 'span');
            // We don't set ignored child spans onto the scope because there likely is an active,
            // unignored span on the scope already.
            if (!$adeacbae769fc647$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $7f119d045829b4a4$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $824cebd24c79088d$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $3af4f127b181b477$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $4184b73679a4ffe0$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $adeacbae769fc647$export$63dbba021a6b4047(options) {
    const acs = $adeacbae769fc647$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $adeacbae769fc647$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $9feed8e2dd0251ea$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$adeacbae769fc647$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)();
        const parentSpan = $adeacbae769fc647$var$getParentSpan(scope, customParentSpan);
        const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent('no_parent_span', 'span');
            return new (0, $7a32c666d9124662$export$d6636b700b76c516)();
        }
        return $adeacbae769fc647$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $adeacbae769fc647$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $db351febaeb5ade8$export$19eade501500c6c1)();
    const acs = (0, $c87ccca6ff6fcb7d$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $261d23db97cfa84e$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $a48eca9dcf573c0f$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $adeacbae769fc647$export$f90b03291402f553(callback);
    return (0, $9feed8e2dd0251ea$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $a48eca9dcf573c0f$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $7f119d045829b4a4$export$3f25fa50c18e20ca)(scope, undefined);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $adeacbae769fc647$export$e57ac09b143d92a2(span, callback) {
    const acs = $adeacbae769fc647$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $9feed8e2dd0251ea$export$ec58d9285c204497)((scope)=>{
        (0, $7f119d045829b4a4$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $adeacbae769fc647$export$869298f9835abc68(callback) {
    const acs = $adeacbae769fc647$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $9feed8e2dd0251ea$export$ec58d9285c204497)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$adeacbae769fc647$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$adeacbae769fc647$export$61ab4e30f2201736]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $adeacbae769fc647$export$f90b03291402f553(callback) {
    const acs = $adeacbae769fc647$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $9feed8e2dd0251ea$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $abd12e78b754c30a$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $dccfa60f681dae0e$export$9869d72de32a3917)()
        });
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $adeacbae769fc647$export$e57ac09b143d92a2(null, callback);
    });
}
function $adeacbae769fc647$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $cea223cc34ca30b5$export$1f70765132c3c225)()) {
        const span = new (0, $7a32c666d9124662$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $52f16f964d0c4a56$export$a117f995597e25df)(span)
            };
            (0, $52f16f964d0c4a56$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
    if ($adeacbae769fc647$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$adeacbae769fc647$var$_isTracingSuppressed(scope)) // if tracing is actively suppressed (Sentry.suppressTracing(...)),
        // we don't want to record a client outcome for the ignored span
        client?.recordDroppedEvent('ignored', 'span');
        return new (0, $7a32c666d9124662$export$d6636b700b76c516)({
            dropReason: 'ignored',
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = (0, $9feed8e2dd0251ea$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $adeacbae769fc647$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $3af4f127b181b477$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $52f16f964d0c4a56$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $3af4f127b181b477$export$5caecac1caaf3a71)(parentSpan);
        span = $adeacbae769fc647$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $52f16f964d0c4a56$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $adeacbae769fc647$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $52f16f964d0c4a56$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $c8ec160f3fe35faf$export$2f3d84e767c9592b)(span);
    (0, $e67d61e091c16e0d$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $adeacbae769fc647$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $3af4f127b181b477$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $adeacbae769fc647$var$getAcs() {
    const carrier = (0, $db351febaeb5ade8$export$19eade501500c6c1)();
    return (0, $c87ccca6ff6fcb7d$export$f639b0c2752203be)(carrier);
}
function $adeacbae769fc647$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $adeacbae769fc647$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : (0, $95ff8194f02ebe17$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $4131862171d3666b$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $016540ffc6cdbb33$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $b7026b2cd7685ea0$export$d7a7d984b0791405)]: 'custom',
            [(0, $b7026b2cd7685ea0$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        (0, $434ad061ae625f3d$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', (0, $8ed2e0baf98beef6$export$6ea47215d699c04a)(client) ? 'span' : 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $adeacbae769fc647$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $adeacbae769fc647$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : (0, $3af4f127b181b477$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $016540ffc6cdbb33$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $7a32c666d9124662$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $3af4f127b181b477$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $8ed2e0baf98beef6$export$6ea47215d699c04a)(client) && childSpan instanceof (0, $7a32c666d9124662$export$d6636b700b76c516)) {
        if (parentSpan instanceof (0, $7a32c666d9124662$export$d6636b700b76c516) && parentSpan.dropReason) {
            // We land here if the parent span was a segment span that was ignored (`ignoreSpans`).
            // In this case, the child was also ignored (see `sampled` above) but we need to
            // record a client outcome for the child.
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, 'span');
        } else if (!isTracingSuppressed) {
            // Otherwise, the child is not sampled due to sampling of the parent span,
            // hence we record a sample_rate client outcome for the child.
            childSpan.dropReason = 'sample_rate';
            client.recordDroppedEvent('sample_rate', 'span');
        }
    }
    client.emit('spanStart', childSpan);
    // If it has an endTimestamp, it's already ended
    if (spanArguments.endTimestamp) {
        client.emit('spanEnd', childSpan);
        client.emit('afterSpanEnd', childSpan);
    }
    return childSpan;
}
function $adeacbae769fc647$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = (0, $7f119d045829b4a4$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $adeacbae769fc647$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $adeacbae769fc647$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
/* Checks if `ignoreSpans` applies (extracted for bundle size)*/ function $adeacbae769fc647$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $8ed2e0baf98beef6$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $5d7f0e996d023f38$export$5d569ac97c389400)({
        description: spanArguments.name || '',
        op: spanArguments.attributes?.[0, $b7026b2cd7685ea0$export$1a413bd9a88fdb09] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $adeacbae769fc647$var$_isIgnoredSpan(span) {
    return span instanceof (0, $7a32c666d9124662$export$d6636b700b76c516) && span.dropReason === 'ignored';
}
function $adeacbae769fc647$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$adeacbae769fc647$export$61ab4e30f2201736] === true;
}





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentry-specific change:
 *
 * This function's logic was NOT updated to web-vitals 4.2.4 or 5.x but we continue
 * to use the web-vitals 3.5.2 version due to having stricter browser support.
 *
 * PR with context that made the changes:
 * https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
 *
 * The PR removed listening to the `pagehide` event, in favour of only listening to
 * the `visibilitychange` event. This is "more correct" but some browsers we still
 * support (Safari <14.4) don't fully support `visibilitychange` or have known bugs
 * with respect to the `visibilitychange` event.
 *
 * TODO (v11): If we decide to drop support for Safari 14.4, we can use the logic
 * from web-vitals 4.2.4. In this case, we also need to update the integration tests
 * that currently trigger the `pagehide` event to simulate the page being hidden.
 *
 * @param {OnHiddenCallback} cb - Callback to be executed when the page is hidden or unloaded.
 *
 * @deprecated use `whenIdleOrHidden` or `addPageListener('visibilitychange')` instead
 */ const $d2fd620cdb95d044$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $35c456f1fd513008$export$56d8a8a25bd48b81).document?.visibilityState === 'hidden') cb(event);
    };
    (0, $e569939fdf3b2936$export$26d3d892edc56833)('visibilitychange', onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    (0, $e569939fdf3b2936$export$26d3d892edc56833)('pagehide', onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


/**
 * Checks if a given value is a valid measurement value.
 */ function $ecaab4a963a2ea86$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $ecaab4a963a2ea86$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $3af4f127b181b477$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $adeacbae769fc647$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $adeacbae769fc647$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $ecaab4a963a2ea86$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $9feed8e2dd0251ea$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment, sendDefaultPii: sendDefaultPii } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId();
    const scope = (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        'user_agent.original': (0, $35c456f1fd513008$export$56d8a8a25bd48b81).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        'client.address': sendDefaultPii ? '{{auto}}' : undefined,
        ...passedAttributes
    };
    return (0, $adeacbae769fc647$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $ecaab4a963a2ea86$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $35c456f1fd513008$export$56d8a8a25bd48b81).addEventListener && (0, $35c456f1fd513008$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $ecaab4a963a2ea86$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $ecaab4a963a2ea86$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
/**
 * Generic support check for web vitals
 */ function $ecaab4a963a2ea86$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch  {
        return false;
    }
}
/**
 * Listens for events on which we want to collect a previously accumulated web vital value.
 * Currently, this includes:
 *
 * - pagehide (i.e. user minimizes browser window, hides tab, etc)
 * - soft navigation (we only care about the vital of the initially loaded route)
 *
 * As a "side-effect", this function will also collect the span id of the pageload span.
 *
 * @param collectorCallback the callback to be called when the first of these events is triggered. Parameters:
 * - event: the event that triggered the reporting of the web vital value.
 * - pageloadSpanId: the span id of the pageload span. This is used to link the web vital span to the pageload span.
 * - pageloadSpan: the pageload span instance. This is used for full access to the pageload span for span streaming.
 */ function $ecaab4a963a2ea86$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpan;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpan) collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
        collected = true;
    }
    // eslint-disable-next-line deprecation/deprecation
    (0, $d2fd620cdb95d044$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce('pagehide');
    });
    const unsubscribeStartNavigation = client.on('beforeStartNavigationSpan', (_, options)=>{
        // we only want to collect LCP if we actually navigate. Redirects should be ignored.
        if (!options?.isRedirect) {
            _runCollectorCallbackOnce('navigation');
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on('afterStartPageLoadSpan', (span)=>{
        pageloadSpan = span;
        unsubscribeAfterStartPageLoadSpan();
    });
}


/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $d0d01f9b746e1332$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $ecaab4a963a2ea86$export$c7533a7b4a9f2e94)('layout-shift')) return;
    const cleanupClsHandler = (0, $5fd9244da26f7eb5$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $ecaab4a963a2ea86$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $d0d01f9b746e1332$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
/**
 * Exported only for testing!
 */ function $d0d01f9b746e1332$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    (0, $4f59afc245df76a3$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)();
    const routeName = (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $9971a806313be959$export$5647df6b7814ac86)(entry.sources[0]?.node) : 'Layout shift';
    const attributes = {
        [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.http.browser.cls',
        [(0, $b7026b2cd7685ea0$export$1a413bd9a88fdb09)]: 'ui.webvital.cls',
        [(0, $b7026b2cd7685ea0$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId,
        // describes what triggered the web vital to be reported
        'sentry.report_event': reportEvent
    };
    // Add CLS sources as span attributes to help with debugging layout shifts
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift/sources
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $9971a806313be959$export$5647df6b7814ac86)(source.node);
    });
    const span = (0, $ecaab4a963a2ea86$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('cls', {
            [(0, $b7026b2cd7685ea0$export$f5f95cff026507b5)]: '',
            [(0, $b7026b2cd7685ea0$export$69cd5c610c7bb96a)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}







/**
 * 60 seconds is the maximum for a plausible LCP value.
 */ const $3d50e3fc2f39c0b2$export$ccce4d286bdc973b = 60000;
function $3d50e3fc2f39c0b2$export$e59775b7d17699ba(lcpValue) {
    return lcpValue != null && lcpValue > 0 && lcpValue <= $3d50e3fc2f39c0b2$export$ccce4d286bdc973b;
}
/**
 * Starts tracking the Largest Contentful Paint on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop LCP measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the LCP value is sent as a standalone span and we stop
 * measuring LCP for subsequent routes.
 */ function $3d50e3fc2f39c0b2$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $ecaab4a963a2ea86$export$c7533a7b4a9f2e94)('largest-contentful-paint')) return;
    const cleanupLcpHandler = (0, $5fd9244da26f7eb5$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !$3d50e3fc2f39c0b2$export$e59775b7d17699ba(metric.value)) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $ecaab4a963a2ea86$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $3d50e3fc2f39c0b2$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
/**
 * Exported only for testing!
 */ function $3d50e3fc2f39c0b2$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    if (!$3d50e3fc2f39c0b2$export$e59775b7d17699ba(lcpValue)) return;
    (0, $4f59afc245df76a3$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $9971a806313be959$export$5647df6b7814ac86)(entry.element) : 'Largest contentful paint';
    const attributes = {
        [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.http.browser.lcp',
        [(0, $b7026b2cd7685ea0$export$1a413bd9a88fdb09)]: 'ui.webvital.lcp',
        [(0, $b7026b2cd7685ea0$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the LCP span so that we can link them in the UI
        'sentry.pageload.span_id': pageloadSpanId,
        // describes what triggered the web vital to be reported
        'sentry.report_event': reportEvent
    };
    if (entry) {
        entry.element && (attributes['lcp.element'] = (0, $9971a806313be959$export$5647df6b7814ac86)(entry.element));
        entry.id && (attributes['lcp.id'] = entry.id);
        entry.url && (attributes['lcp.url'] = entry.url);
        // loadTime is the time of LCP that's related to receiving the LCP element response..
        entry.loadTime != null && (attributes['lcp.loadTime'] = entry.loadTime);
        // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        entry.renderTime != null && (attributes['lcp.renderTime'] = entry.renderTime);
        entry.size != null && (attributes['lcp.size'] = entry.size);
    }
    const span = (0, $ecaab4a963a2ea86$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('lcp', {
            [(0, $b7026b2cd7685ea0$export$f5f95cff026507b5)]: 'millisecond',
            [(0, $b7026b2cd7685ea0$export$69cd5c610c7bb96a)]: lcpValue
        });
        // LCP is a point-in-time metric, so we end the span immediately
        span.end(startTime);
    }
}




function $bb4bbc60bde7fd85$var$getAbsoluteTime(time) {
    // falsy values should be preserved so that we can later on drop undefined values and
    // preserve 0 vals for cross-origin resources without proper `Timing-Allow-Origin` header.
    return time ? (((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1000 : time;
}
/**
 * Converts a PerformanceResourceTiming entry to span data for the resource span. Most importantly,
 * it converts the timing values from timestamps relative to the `performance.timeOrigin` to absolute timestamps
 * in seconds.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming#timestamps
 *
 * @param resourceTiming
 * @returns An array where the first element is the attribute name and the second element is the attribute value.
 */ function $bb4bbc60bde7fd85$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = {};
    // Checking for only `undefined` and `null` is intentional because it's
    // valid for `nextHopProtocol` to be an empty string.
    if (resourceTiming.nextHopProtocol != undefined) {
        const { name: name, version: version } = (0, $ecaab4a963a2ea86$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData['network.protocol.version'] = version;
        timingSpanData['network.protocol.name'] = name;
    }
    if (!((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() || (0, $ecaab4a963a2ea86$export$f72a13c439a30cab)()?.timeOrigin)) return timingSpanData;
    return $bb4bbc60bde7fd85$var$dropUndefinedKeysFromObject({
        ...timingSpanData,
        'http.request.redirect_start': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.redirectStart),
        'http.request.redirect_end': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.redirectEnd),
        'http.request.worker_start': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.workerStart),
        'http.request.fetch_start': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.fetchStart),
        'http.request.domain_lookup_start': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        'http.request.domain_lookup_end': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        'http.request.connect_start': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.connectStart),
        'http.request.secure_connection_start': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        'http.request.connection_end': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.connectEnd),
        'http.request.request_start': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.requestStart),
        'http.request.response_start': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.responseStart),
        'http.request.response_end': $bb4bbc60bde7fd85$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        'http.request.time_to_first_byte': resourceTiming.responseStart != null ? resourceTiming.responseStart / 1000 : undefined
    });
}
/**
 * Remove properties with `undefined` as value from an object.
 * In contrast to `dropUndefinedKeys` in core this funciton only works on first-level
 * key-value objects and does not recursively go into object properties or arrays.
 */ function $bb4bbc60bde7fd85$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}







const $aaa56fe7e1ac31ed$var$MAX_INT_AS_BYTES = 2147483647;
let $aaa56fe7e1ac31ed$var$_performanceCursor = 0;
let $aaa56fe7e1ac31ed$var$_measurements = {};
let $aaa56fe7e1ac31ed$var$_lcpEntry;
let $aaa56fe7e1ac31ed$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @deprecated this function will be removed and streamlined once we stop supporting standalone v1
 * @returns A function that forces web vitals collection
 */ function $aaa56fe7e1ac31ed$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $ecaab4a963a2ea86$export$f72a13c439a30cab)();
    if (performance && (0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)()) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $35c456f1fd513008$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $3d50e3fc2f39c0b2$export$485112b2cb5f79dc)(client) : recordLcpStandaloneSpans === false ? $aaa56fe7e1ac31ed$var$_trackLCP() : undefined;
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $d0d01f9b746e1332$export$585bab03c6c18c45)(client) : recordClsStandaloneSpans === false ? $aaa56fe7e1ac31ed$var$_trackCLS() : undefined;
        const ttfbCleanupCallback = $aaa56fe7e1ac31ed$var$_trackTtfb();
        return ()=>{
            ttfbCleanupCallback();
            lcpCleanupCallback?.();
            clsCleanupCallback?.();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $aaa56fe7e1ac31ed$export$f396d19077034ad2() {
    (0, $5fd9244da26f7eb5$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        const parent = (0, $3af4f127b181b477$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $3af4f127b181b477$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $ecaab4a963a2ea86$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                attributes: {
                    [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $aaa56fe7e1ac31ed$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $3af4f127b181b477$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $3af4f127b181b477$export$92d8c23565496537)(parent);
            if (parentOp === 'navigation' && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes['browser.script.invoker'] = invoker;
            attributes['browser.script.invoker_type'] = invokerType;
            if (sourceURL) attributes['code.filepath'] = sourceURL;
            if (sourceFunctionName) attributes['code.function'] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes['browser.script.source_char_position'] = sourceCharPosition;
            (0, $ecaab4a963a2ea86$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: 'Main UI thread blocked',
                op: 'ui.long-animation-frame',
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: 'long-animation-frame',
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $aaa56fe7e1ac31ed$export$e27543e0976315e4() {
    (0, $5fd9244da26f7eb5$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        const parent = (0, $3af4f127b181b477$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === 'click') {
            const startTime = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $9971a806313be959$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            };
            const componentName = (0, $9971a806313be959$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
            (0, $ecaab4a963a2ea86$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $aaa56fe7e1ac31ed$var$_trackCLS() {
    return (0, $5fd9244da26f7eb5$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $aaa56fe7e1ac31ed$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $aaa56fe7e1ac31ed$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $aaa56fe7e1ac31ed$var$_trackLCP() {
    return (0, $5fd9244da26f7eb5$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $3d50e3fc2f39c0b2$export$e59775b7d17699ba)(metric.value)) return;
        $aaa56fe7e1ac31ed$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $aaa56fe7e1ac31ed$var$_lcpEntry = entry;
    }, true);
}
function $aaa56fe7e1ac31ed$var$_trackTtfb() {
    return (0, $5fd9244da26f7eb5$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $aaa56fe7e1ac31ed$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $aaa56fe7e1ac31ed$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $ecaab4a963a2ea86$export$f72a13c439a30cab)();
    const origin = (0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)();
    if (!performance?.getEntries || !origin) // Gatekeeper if performance API not available
    return;
    const { spanStreamingEnabled: spanStreamingEnabled, ignorePerformanceApiSpans: ignorePerformanceApiSpans, ignoreResourceSpans: ignoreResourceSpans, recordClsOnPageloadSpan: recordClsOnPageloadSpan, recordLcpOnPageloadSpan: recordLcpOnPageloadSpan } = options;
    const timeOrigin = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $3af4f127b181b477$export$92d8c23565496537)(span);
    performanceEntries.slice($aaa56fe7e1ac31ed$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $aaa56fe7e1ac31ed$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $aaa56fe7e1ac31ed$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
                    // capture web vitals
                    const firstHidden = (0, $6518897f1b2f3c2b$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) $aaa56fe7e1ac31ed$var$_measurements['fp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    if (entry.name === 'first-contentful-paint' && shouldRecord) $aaa56fe7e1ac31ed$var$_measurements['fcp'] = {
                        value: entry.startTime,
                        unit: 'millisecond'
                    };
                    break;
                }
            case 'resource':
                $aaa56fe7e1ac31ed$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, ignoreResourceSpans);
                break;
        }
    });
    $aaa56fe7e1ac31ed$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $aaa56fe7e1ac31ed$var$_trackNavigator(span, spanStreamingEnabled);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $aaa56fe7e1ac31ed$var$_addTtfbRequestTimeToMeasurements($aaa56fe7e1ac31ed$var$_measurements);
        if (spanStreamingEnabled) {
            const setAttr = (shortWebVitalName, value, customAttrName)=>{
                const attrKey = customAttrName ?? `browser.web_vital.${shortWebVitalName}.value`;
                span.setAttribute(attrKey, value);
                (0, $4f59afc245df76a3$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log('Setting web vital attribute', {
                    [attrKey]: value
                }, 'on pageload span');
            };
            // for streamed pageload spans, we add the web vital measurements as attributes.
            // We omit LCP, CLS and INP because they're tracked separately as spans
            [
                'ttfb',
                'fp',
                'fcp'
            ].forEach((measurementName)=>{
                if ($aaa56fe7e1ac31ed$var$_measurements[measurementName]) setAttr(measurementName, $aaa56fe7e1ac31ed$var$_measurements[measurementName].value);
            });
            if ($aaa56fe7e1ac31ed$var$_measurements['ttfb.requestTime']) setAttr('ttfb.requestTime', $aaa56fe7e1ac31ed$var$_measurements['ttfb.requestTime'].value, 'browser.web_vital.ttfb.request_time');
        } else {
            // TODO (V11): Remove this else branch once we remove v1 standalone spans and transactions
            // If CLS standalone spans are enabled, don't record CLS as a measurement
            if (!recordClsOnPageloadSpan) delete $aaa56fe7e1ac31ed$var$_measurements.cls;
            // If LCP standalone spans are enabled, don't record LCP as a measurement
            if (!recordLcpOnPageloadSpan) delete $aaa56fe7e1ac31ed$var$_measurements.lcp;
            Object.entries($aaa56fe7e1ac31ed$var$_measurements).forEach(([measurementName, measurement])=>{
                (0, $8e3df96ad8a78c63$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
            });
            $aaa56fe7e1ac31ed$var$_setWebVitalAttributes(span, options);
        }
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute(spanStreamingEnabled ? 'browser.performance.time_origin' : 'performance.timeOrigin', timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute(spanStreamingEnabled ? 'browser.performance.navigation.activation_start' : 'performance.activationStart', (0, $5283a16626a69fa3$export$d3e828b3c7b5b845)());
    }
    $aaa56fe7e1ac31ed$var$_lcpEntry = undefined;
    $aaa56fe7e1ac31ed$var$_clsEntry = undefined;
    $aaa56fe7e1ac31ed$var$_measurements = {};
}
/**
 * React 19.2+ creates performance.measure entries for component renders.
 * We can identify them by the `detail.devtools.track` property being set to 'Components ⚛'.
 * see: https://react.dev/reference/dev-tools/react-performance-tracks
 * see: https://github.com/facebook/react/blob/06fcc8f380c6a905c7bc18d94453f623cf8cbc81/packages/react-reconciler/src/ReactFiberPerformanceTrack.js#L454-L473
 */ function $aaa56fe7e1ac31ed$var$isReact19MeasureEntry(entry) {
    if (entry?.entryType !== 'measure') return;
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return entry.detail.devtools.track === "Components \u269B";
    } catch  {
        return;
    }
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $aaa56fe7e1ac31ed$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($aaa56fe7e1ac31ed$var$isReact19MeasureEntry(entry)) return;
    if ([
        'mark',
        'measure'
    ].includes(entry.entryType) && (0, $cb59d5f85403f0fd$export$a7a5ec66062ea5d)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $ac5f61c2129cabc5$export$6431553786c94949)(false);
    const requestTime = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes['sentry.browser.measure_happened_before_request'] = true;
        attributes['sentry.browser.measure_start_time'] = measureStartTimestamp;
    }
    $aaa56fe7e1ac31ed$var$_addDetailToSpanAttributes(attributes, entry);
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, $ecaab4a963a2ea86$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $aaa56fe7e1ac31ed$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        // Accessing detail might throw in some browsers (e.g., Firefox) due to security restrictions
        const detail = performanceMeasure.detail;
        if (!detail) return;
        // Process detail based on its type
        if (typeof detail === 'object') {
            // Handle object details
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $8711648e54ceaa6b$export$c3825b437cbdea5c)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== undefined) try {
                    // This is user defined so we can't guarantee it's serializable
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {
                // Skip values that can't be stringified
                }
            }
            return;
        }
        if ((0, $8711648e54ceaa6b$export$c3825b437cbdea5c)(detail)) {
            // Handle primitive details
            attributes['sentry.browser.measure.detail'] = detail;
            return;
        }
        try {
            attributes['sentry.browser.measure.detail'] = JSON.stringify(detail);
        } catch  {
        // Skip if stringification fails
        }
    } catch  {
    // Silently ignore any errors when accessing detail
    // This handles the Firefox "Permission denied to access object" error
    }
}
/**
 * Instrument navigation entries
 * exported only for tests
 */ function $aaa56fe7e1ac31ed$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $aaa56fe7e1ac31ed$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $aaa56fe7e1ac31ed$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL');
    $aaa56fe7e1ac31ed$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache');
    $aaa56fe7e1ac31ed$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $aaa56fe7e1ac31ed$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $aaa56fe7e1ac31ed$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $aaa56fe7e1ac31ed$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $ecaab4a963a2ea86$export$7567a67bdb69a23d)(span, timeOrigin + (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics',
            ...event === 'redirect' && entry.redirectCount != null ? {
                'http.redirect_count': entry.redirectCount
            } : {}
        }
    });
}
function $aaa56fe7e1ac31ed$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === 'secureConnection') return 'connectEnd';
    if (event === 'fetch') return 'domainLookupStart';
    return `${event}End`;
}
/** Create request and response related spans */ function $aaa56fe7e1ac31ed$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $ecaab4a963a2ea86$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: 'browser.request',
            name: entry.name,
            attributes: {
                [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $ecaab4a963a2ea86$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: 'browser.response',
            name: entry.name,
            attributes: {
                [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $aaa56fe7e1ac31ed$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other';
    if (ignoredResourceSpanOps?.includes(op)) return;
    const attributes = {
        [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    const parsedUrl = (0, $f8df15d2532bd8e1$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $35c456f1fd513008$export$56d8a8a25bd48b81).location.origin);
    $aaa56fe7e1ac31ed$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            'responseStatus',
            'http.response.status_code'
        ],
        [
            'transferSize',
            'http.response_transfer_size'
        ],
        [
            'encodedBodySize',
            'http.response_content_length'
        ],
        [
            'decodedBodySize',
            'http.decoded_response_content_length'
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            'renderBlockingStatus',
            'resource.render_blocking_status'
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            'deliveryType',
            'http.response_delivery_type'
        ]
    ]);
    const attributesWithResourceTiming = {
        ...attributes,
        ...(0, $bb4bbc60bde7fd85$export$ec50b091612e7e00)(entry)
    };
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $ecaab4a963a2ea86$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $35c456f1fd513008$export$56d8a8a25bd48b81).location.origin, ''),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
/**
 * Capture the information of the user agent.
 * TODO v11: Remove non-span-streaming attributes and measurements once we removed transactions
 */ function $aaa56fe7e1ac31ed$var$_trackNavigator(span, spanStreamingEnabled) {
    const navigator = (0, $35c456f1fd513008$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute(spanStreamingEnabled ? 'network.connection.effective_type' : 'effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute(spanStreamingEnabled ? 'network.connection.type' : 'connectionType', connection.type);
        if ((0, $ecaab4a963a2ea86$export$27169ccae1b439e3)(connection.rtt)) {
            $aaa56fe7e1ac31ed$var$_measurements['connection.rtt'] = {
                value: connection.rtt,
                unit: 'millisecond'
            };
            if (spanStreamingEnabled) span.setAttribute('network.connection.rtt', connection.rtt);
        }
    }
    if ((0, $ecaab4a963a2ea86$export$27169ccae1b439e3)(navigator.deviceMemory)) {
        if (spanStreamingEnabled) span.setAttribute('device.memory.estimated_capacity', navigator.deviceMemory);
        else span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    }
    if ((0, $ecaab4a963a2ea86$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) {
        if (spanStreamingEnabled) span.setAttribute('device.processor_count', navigator.hardwareConcurrency);
        else span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
    }
}
/** Add LCP / CLS data to span to allow debugging */ function $aaa56fe7e1ac31ed$var$_setWebVitalAttributes(span, options) {
    // Only add LCP attributes if LCP is being recorded on the pageload span
    if ($aaa56fe7e1ac31ed$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($aaa56fe7e1ac31ed$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $9971a806313be959$export$5647df6b7814ac86)($aaa56fe7e1ac31ed$var$_lcpEntry.element));
        if ($aaa56fe7e1ac31ed$var$_lcpEntry.id) span.setAttribute('lcp.id', $aaa56fe7e1ac31ed$var$_lcpEntry.id);
        if ($aaa56fe7e1ac31ed$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $aaa56fe7e1ac31ed$var$_lcpEntry.url.trim().slice(0, 200));
        if ($aaa56fe7e1ac31ed$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute('lcp.loadTime', $aaa56fe7e1ac31ed$var$_lcpEntry.loadTime);
        if ($aaa56fe7e1ac31ed$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute('lcp.renderTime', $aaa56fe7e1ac31ed$var$_lcpEntry.renderTime);
        span.setAttribute('lcp.size', $aaa56fe7e1ac31ed$var$_lcpEntry.size);
    }
    // Only add CLS attributes if CLS is being recorded on the pageload span
    if ($aaa56fe7e1ac31ed$var$_clsEntry?.sources && options.recordClsOnPageloadSpan) $aaa56fe7e1ac31ed$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $9971a806313be959$export$5647df6b7814ac86)(source.node)));
}
/**
 * Use this to set any attributes we can take directly form the PerformanceResourceTiming entry.
 *
 * This is just a mapping function for entry->attribute to keep bundle-size minimal.
 * Experimental properties are also accepted (see {@link ExperimentalResourceTimingProperty}).
 * Assumes that all entry properties might be undefined for browser-specific differences.
 * Only accepts string and number values for now and also sets 0-values.
 */ function $aaa56fe7e1ac31ed$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === 'number' && entryVal < $aaa56fe7e1ac31ed$var$MAX_INT_AS_BYTES || typeof entryVal === 'string')) attributes[attributeKey] = entryVal;
    });
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $aaa56fe7e1ac31ed$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $ac5f61c2129cabc5$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements['ttfb.requestTime'] = {
        value: responseStart - requestStart,
        unit: 'millisecond'
    };
}


var $bCpAf = parcelRequire("bCpAf");

/**
 * Returns true if we are in the browser.
 */ function $374c28f22bd17152$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $bCpAf.isNodeEnv)() || $374c28f22bd17152$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $374c28f22bd17152$var$isElectronNodeRenderer() {
    const process = (0, $eb3eceb31c6a9ea7$export$f1a6cdb1459e81d1).process;
    return process?.type === 'renderer';
}





const $3f9d3a2d5a57108e$var$LAST_INTERACTIONS = [];
const $3f9d3a2d5a57108e$var$INTERACTIONS_SPAN_MAP = new Map();
// Map to store element names by timestamp, since we get the DOM event before the PerformanceObserver entry
const $3f9d3a2d5a57108e$var$ELEMENT_NAME_TIMESTAMP_MAP = new Map();
/**
 * 60 seconds is the maximum for a plausible INP value
 * (source: Me)
 */ const $3f9d3a2d5a57108e$export$619786413bcce1e1 = 60;
/**
 * Start tracking INP webvital events.
 */ function $3f9d3a2d5a57108e$export$f17d06681a4744a3() {
    const performance = (0, $ecaab4a963a2ea86$export$f72a13c439a30cab)();
    if (performance && (0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)()) {
        const inpCallback = $3f9d3a2d5a57108e$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $3f9d3a2d5a57108e$export$7cd941f925ded42f = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. #
 * exported only for testing
 */ function $3f9d3a2d5a57108e$export$eeab203db0ed99a9() {
    return (0, $5fd9244da26f7eb5$export$da3b76aa2022cbd7)($3f9d3a2d5a57108e$export$7bcb98fe01441521);
}
/**
 * exported only for testing
 */ const $3f9d3a2d5a57108e$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == undefined) return;
    const duration = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(metric.value);
    // We received occasional reports of hour-long INP values.
    // Therefore, we add a sanity check to avoid creating spans for
    // unrealistically long INP durations.
    if (duration > $3f9d3a2d5a57108e$export$619786413bcce1e1) return;
    const entry = metric.entries.find((entry)=>entry.duration === metric.value && $3f9d3a2d5a57108e$export$7cd941f925ded42f[entry.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $3f9d3a2d5a57108e$export$7cd941f925ded42f[entry.name];
    /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() + entry.startTime);
    const activeSpan = (0, $3af4f127b181b477$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
    // We first try to lookup the interaction context from our INTERACTIONS_SPAN_MAP,
    // where we cache the route and element name per interactionId
    const cachedInteractionContext = interactionId != null ? $3f9d3a2d5a57108e$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
    const spanToUse = cachedInteractionContext?.span || rootSpan;
    // Else, we try to use the active span.
    // Finally, we fall back to look at the transactionName on the scope
    const routeName = spanToUse ? (0, $3af4f127b181b477$export$92d8c23565496537)(spanToUse).description : (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedInteractionContext?.elementName || (0, $9971a806313be959$export$5647df6b7814ac86)(entry.target);
    const attributes = {
        [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: 'auto.http.browser.inp',
        [(0, $b7026b2cd7685ea0$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $b7026b2cd7685ea0$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $ecaab4a963a2ea86$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent('inp', {
            [(0, $b7026b2cd7685ea0$export$f5f95cff026507b5)]: 'millisecond',
            [(0, $b7026b2cd7685ea0$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
/**
 * Look up a cached interaction context (element name + root span) by interactionId.
 * Returns undefined if no context was cached for this interaction.
 */ function $3f9d3a2d5a57108e$export$e4a670d077ebcfef(interactionId) {
    return interactionId != null ? $3f9d3a2d5a57108e$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
}
/**
 * Register a listener to cache route information for INP interactions.
 */ function $3f9d3a2d5a57108e$export$e4e04d43e223cce2() {
    // Listen for all interaction events that could contribute to INP
    const interactionEvents = Object.keys($3f9d3a2d5a57108e$export$7cd941f925ded42f);
    if ((0, $374c28f22bd17152$export$4e09c449d6c407f7)()) interactionEvents.forEach((eventType)=>{
        (0, $35c456f1fd513008$export$56d8a8a25bd48b81).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    /**
   * Captures the element name from a DOM event and stores it in the ELEMENT_NAME_TIMESTAMP_MAP.
   */ function captureElementFromEvent(event) {
        const target = event.target;
        if (!target) return;
        const elementName = (0, $9971a806313be959$export$5647df6b7814ac86)(target);
        const timestamp = Math.round(event.timeStamp);
        // Store the element name by timestamp so we can match it with the PerformanceEntry
        $3f9d3a2d5a57108e$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        // Clean up old
        if ($3f9d3a2d5a57108e$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            const firstKey = $3f9d3a2d5a57108e$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== undefined) $3f9d3a2d5a57108e$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    /**
   * Tries to get the element name from the timestamp map.
   */ function resolveElementNameFromEntry(entry) {
        const timestamp = Math.round(entry.startTime);
        let elementName = $3f9d3a2d5a57108e$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        // try nearby timestamps (±5ms)
        if (!elementName) for(let offset = -5; offset <= 5; offset++){
            const nearbyName = $3f9d3a2d5a57108e$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || '<unknown>';
    }
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $3af4f127b181b477$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $5fd9244da26f7eb5$export$7affb50b622d8714)(entry)) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($3f9d3a2d5a57108e$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            const elementName = entry.target ? (0, $9971a806313be959$export$5647df6b7814ac86)(entry.target) : resolveElementNameFromEntry(entry);
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($3f9d3a2d5a57108e$var$LAST_INTERACTIONS.length > 10) {
                const last = $3f9d3a2d5a57108e$var$LAST_INTERACTIONS.shift();
                $3f9d3a2d5a57108e$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store both the span and element name for this interaction
            $3f9d3a2d5a57108e$var$LAST_INTERACTIONS.push(interactionId);
            $3f9d3a2d5a57108e$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $5fd9244da26f7eb5$export$69816c1a049f8db6)('event', handleEntries);
    (0, $5fd9244da26f7eb5$export$69816c1a049f8db6)('first-input', handleEntries);
}








// Locally-defined interfaces to avoid leaking bare global type references into the
// generated .d.ts. The `declare global` augmentations in web-vitals/types.ts make these
// available during this package's compilation but are NOT carried to consumers.
// This mirrors the pattern used for PerformanceEventTiming in instrument.ts.
/**
 * Emits a web vital span that flows through the span streaming pipeline.
 */ function $e5c69d079f32e2b2$export$f4adb23e57c1dac6(options) {
    const { name: name, op: op, origin: origin, metricName: metricName, value: value, attributes: passedAttributes, parentSpan: parentSpan, reportEvent: reportEvent, startTime: startTime, endTime: endTime } = options;
    const routeName = (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const attributes = {
        [(0, $b7026b2cd7685ea0$export$cca8dd30f57f805e)]: origin,
        [(0, $b7026b2cd7685ea0$export$1a413bd9a88fdb09)]: op,
        [(0, $b7026b2cd7685ea0$export$fea48ba9f4550879)]: 0,
        [`browser.web_vital.${metricName}.value`]: value,
        'sentry.transaction': routeName,
        // Web vital score calculation relies on the user agent
        'user_agent.original': (0, $35c456f1fd513008$export$56d8a8a25bd48b81).navigator?.userAgent,
        ...passedAttributes
    };
    if (parentSpan && (0, $3af4f127b181b477$export$db0cad9e44f67af8)(parentSpan).attributes?.[0, $b7026b2cd7685ea0$export$1a413bd9a88fdb09] === 'pageload') // for LCP and CLS, we collect the pageload span id as an attribute
    attributes['sentry.pageload.span_id'] = parentSpan.spanContext().spanId;
    if (reportEvent) attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
    const span = (0, $adeacbae769fc647$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        // if we have a pageload span, we let the web vital span start as its parent. This ensures that
        // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
        // that has `segment: false` but no actual parent span.
        parentSpan: parentSpan
    });
    if (span) span.end(endTime ?? startTime);
}
/**
 * Tracks LCP as a streamed span.
 */ function $e5c69d079f32e2b2$export$73747c030e2325c0(client) {
    let lcpValue = 0;
    let lcpEntry;
    if (!(0, $ecaab4a963a2ea86$export$c7533a7b4a9f2e94)('largest-contentful-paint')) return;
    const cleanupLcpHandler = (0, $5fd9244da26f7eb5$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $3d50e3fc2f39c0b2$export$e59775b7d17699ba)(metric.value)) return;
        lcpValue = metric.value;
        lcpEntry = entry;
    }, true);
    (0, $ecaab4a963a2ea86$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $e5c69d079f32e2b2$export$1adcb85d073cd594(lcpValue, lcpEntry, pageloadSpan, reportEvent);
        cleanupLcpHandler();
    });
}
/**
 * Exported only for testing.
 */ function $e5c69d079f32e2b2$export$1adcb85d073cd594(lcpValue, entry, pageloadSpan, reportEvent) {
    if (!(0, $3d50e3fc2f39c0b2$export$e59775b7d17699ba)(lcpValue)) return;
    (0, $4f59afc245df76a3$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Sending LCP span (${lcpValue})`);
    const performanceTimeOrigin = (0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() || 0;
    const timeOrigin = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(performanceTimeOrigin);
    const endTime = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(performanceTimeOrigin + (entry?.startTime || 0));
    const name = entry ? (0, $9971a806313be959$export$5647df6b7814ac86)(entry.element) : 'Largest contentful paint';
    const attributes = {};
    entry?.element && (attributes['browser.web_vital.lcp.element'] = (0, $9971a806313be959$export$5647df6b7814ac86)(entry.element));
    entry?.id && (attributes['browser.web_vital.lcp.id'] = entry.id);
    entry?.url && (attributes['browser.web_vital.lcp.url'] = entry.url);
    entry?.loadTime != null && (attributes['browser.web_vital.lcp.load_time'] = entry.loadTime);
    entry?.renderTime != null && (attributes['browser.web_vital.lcp.render_time'] = entry.renderTime);
    entry?.size != null && (attributes['browser.web_vital.lcp.size'] = entry.size);
    $e5c69d079f32e2b2$export$f4adb23e57c1dac6({
        name: name,
        op: 'ui.webvital.lcp',
        origin: 'auto.http.browser.lcp',
        metricName: 'lcp',
        value: lcpValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: timeOrigin,
        endTime: endTime
    });
}
/**
 * Tracks CLS as a streamed span.
 */ function $e5c69d079f32e2b2$export$f2ca9ed704743eb2(client) {
    let clsValue = 0;
    let clsEntry;
    if (!(0, $ecaab4a963a2ea86$export$c7533a7b4a9f2e94)('layout-shift')) return;
    const cleanupClsHandler = (0, $5fd9244da26f7eb5$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        clsValue = metric.value;
        clsEntry = entry;
    }, true);
    (0, $ecaab4a963a2ea86$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $e5c69d079f32e2b2$export$736c846d4f7aff83(clsValue, clsEntry, pageloadSpan, reportEvent);
        cleanupClsHandler();
    });
}
/**
 * Exported only for testing.
 */ function $e5c69d079f32e2b2$export$736c846d4f7aff83(clsValue, entry, pageloadSpan, reportEvent) {
    (0, $4f59afc245df76a3$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() || 0) + entry.startTime) : (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)();
    const name = entry ? (0, $9971a806313be959$export$5647df6b7814ac86)(entry.sources[0]?.node) : 'Layout shift';
    const attributes = {};
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`browser.web_vital.cls.source.${index + 1}`] = (0, $9971a806313be959$export$5647df6b7814ac86)(source.node);
    });
    $e5c69d079f32e2b2$export$f4adb23e57c1dac6({
        name: name,
        op: 'ui.webvital.cls',
        origin: 'auto.http.browser.cls',
        metricName: 'cls',
        value: clsValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: startTime
    });
}
/**
 * Tracks INP as a streamed span.
 *
 * This mirrors the standalone INP tracking logic (`startTrackingINP`) but emits
 * spans through the streaming pipeline instead of as standalone spans.
 * Requires `registerInpInteractionListener()` to be called separately for
 * cached element names and root spans per interaction.
 */ function $e5c69d079f32e2b2$export$4a8cbc644515d57b() {
    const performance = (0, $ecaab4a963a2ea86$export$f72a13c439a30cab)();
    if (!performance || !(0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)()) return;
    const onInp = ({ metric: metric })=>{
        if (metric.value == null) return;
        const duration = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(metric.value);
        if (duration > (0, $3f9d3a2d5a57108e$export$619786413bcce1e1)) return;
        const entry = metric.entries.find((e)=>e.duration === metric.value && (0, $3f9d3a2d5a57108e$export$7cd941f925ded42f)[e.name]);
        if (!entry) return;
        $e5c69d079f32e2b2$export$bd315e549441b68a(metric.value, entry);
    };
    (0, $5fd9244da26f7eb5$export$da3b76aa2022cbd7)(onInp);
}
/**
 * Exported only for testing.
 */ function $e5c69d079f32e2b2$export$bd315e549441b68a(inpValue, entry) {
    (0, $4f59afc245df76a3$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).log(`Sending INP span (${inpValue})`);
    const startTime = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)((0, $52eaab10d44d3c9d$export$baf075a948ffc0bf)() + entry.startTime);
    const duration = (0, $ecaab4a963a2ea86$export$b4785dbd4a81b33f)(inpValue);
    const interactionType = (0, $3f9d3a2d5a57108e$export$7cd941f925ded42f)[entry.name];
    const cachedContext = (0, $3f9d3a2d5a57108e$export$e4a670d077ebcfef)(entry.interactionId);
    const activeSpan = (0, $3af4f127b181b477$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $3af4f127b181b477$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
    const spanToUse = cachedContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $3af4f127b181b477$export$db0cad9e44f67af8)(spanToUse).name : (0, $9feed8e2dd0251ea$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedContext?.elementName || (0, $9971a806313be959$export$5647df6b7814ac86)(entry.target);
    $e5c69d079f32e2b2$export$f4adb23e57c1dac6({
        name: name,
        op: `ui.interaction.${interactionType}`,
        origin: 'auto.http.browser.inp',
        metricName: 'inp',
        value: inpValue,
        attributes: {
            [(0, $b7026b2cd7685ea0$export$fea48ba9f4550879)]: entry.duration,
            'sentry.transaction': routeName
        },
        startTime: startTime,
        endTime: startTime + duration,
        parentSpan: spanToUse
    });
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $124d907e35e89f75$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $8282d53d03c1861c$export$56d8a8a25bd48b81 = (0, $fde0330eb2207262$exports.GLOBAL_OBJ);
let $8282d53d03c1861c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $8282d53d03c1861c$export$b79738ab10c590b2() {
    return $8282d53d03c1861c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $8282d53d03c1861c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $8282d53d03c1861c$var$ignoreOnError++;
    setTimeout(()=>{
        $8282d53d03c1861c$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $8282d53d03c1861c$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $fde0330eb2207262$exports.getOriginalFunction)(fn)) return fn;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$8282d53d03c1861c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $8282d53d03c1861c$export$1265a142ff5ba165();
            (0, $fde0330eb2207262$exports.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $fde0330eb2207262$exports.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $fde0330eb2207262$exports.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, $fde0330eb2207262$exports.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $fde0330eb2207262$exports.markFunctionWrapped)(sentryWrapped, fn);
    (0, $fde0330eb2207262$exports.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $8282d53d03c1861c$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $fde0330eb2207262$exports.getLocationHref)();
    const { referrer: referrer } = $8282d53d03c1861c$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $8282d53d03c1861c$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}





/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $2ac9d29ce81993a2$export$6f18f55521af71a1() {
    if ((0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document) (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $fde0330eb2207262$exports.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $fde0330eb2207262$exports.getRootSpan)(activeSpan);
        if ((0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $fde0330eb2207262$exports.spanToJSON)(rootSpan);
            if (0, $124d907e35e89f75$export$16a28057038b10ef) (0, $fde0330eb2207262$exports.debug).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $fde0330eb2207262$exports.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}















// 1h in seconds
const $707cb3e901bff946$export$c8d616af96ac729f = 3600;
// session storage key
const $707cb3e901bff946$export$16b6aa13b3c0f075 = 'sentry_previous_trace';
const $707cb3e901bff946$export$237518aee8726f02 = 'sentry.previous_trace';
/**
 * Takes care of linking traces and applying the (consistent) sampling behavoiour based on the passed options
 * @param options - options for linking traces and consistent trace sampling (@see BrowserTracingOptions)
 * @param client - Sentry client
 */ function $707cb3e901bff946$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === 'session-storage';
    let inMemoryPreviousTraceInfo = useSessionStorage ? $707cb3e901bff946$export$ef546bba8a402d99() : undefined;
    client.on('spanStart', (span)=>{
        if ((0, $fde0330eb2207262$exports.getRootSpan)(span) !== span) return;
        const oldPropagationContext = (0, $fde0330eb2207262$exports.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = $707cb3e901bff946$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $707cb3e901bff946$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) /*
    When users opt into `consistentTraceSampling`, we need to ensure that we propagate
    the previous trace's sample rate and rand to the current trace. This is necessary because otherwise, span
    metric extrapolation is inaccurate, as we'd propagate too high of a sample rate for the subsequent traces.

    So therefore, we pretend that the previous trace was the parent trace of the newly started trace. To do that,
    we mutate the propagation context of the current trace and set the sample rate and sample rand of the previous trace.
    Timing-wise, it is fine because it happens before we even sample the root span.

    @see https://github.com/getsentry/sentry-javascript/issues/15754
    */ client.on('beforeSampling', (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $fde0330eb2207262$exports.getCurrentScope)();
        const currentPropagationContext = scope.getPropagationContext();
        // We do not want to force-continue the sampling decision if we continue a trace
        // that was started on the backend. Most prominently, this will happen in MPAs where
        // users hard-navigate between pages. In this case, the sampling decision of a potentially
        // started trace on the server takes precedence.
        // Why? We want to prioritize inter-trace consistency over intra-trace consistency.
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($707cb3e901bff946$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $707cb3e901bff946$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
/**
 * Adds a previous_trace span link to the passed span if the passed
 * previousTraceInfo is still valid.
 *
 * @returns the updated previous trace info (based on the current span/trace) to
 * be used on the next call
 */ function $707cb3e901bff946$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $fde0330eb2207262$exports.spanToJSON)(span);
    function getSampleRate() {
        try {
            return Number(oldPropagationContext.dsc?.sample_rate) ?? Number(spanJson.data?.[0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]);
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) // This means, we're still in the same trace so let's not update the previous trace info
    // or add a link to the current span.
    // Once we move away from the long-lived, route-based trace model, we can remove this cases
    return previousTraceInfo;
    // Only add the link if the startTimeStamp of the previous trace's root span is within
    // PREVIOUS_TRACE_MAX_DURATION (1h) of the current root span's startTimestamp
    // This is done to
    // - avoid adding links to "stale" traces
    // - enable more efficient querying for previous/next traces in Sentry
    if (Date.now() / 1000 - previousTraceInfo.startTimestamp <= $707cb3e901bff946$export$c8d616af96ac729f) {
        if (0, $124d907e35e89f75$export$16a28057038b10ef) (0, $fde0330eb2207262$exports.debug).log(`Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
            op: spanJson.op,
            ...span.spanContext()
        })}\``);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $fde0330eb2207262$exports.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: 'previous_trace'
            }
        });
        // TODO: Remove this once EAP can store span links. We currently only set this attribute so that we
        // can obtain the previous trace information from the EAP store. Long-term, EAP will handle
        // span links and then we should remove this again. Also throwing in a TODO(v11), to remind us
        // to check this at v11 time :)
        span.setAttribute($707cb3e901bff946$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$707cb3e901bff946$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
/**
 * Stores @param previousTraceInfo in sessionStorage.
 */ function $707cb3e901bff946$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).sessionStorage.setItem($707cb3e901bff946$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        // Ignore potential errors (e.g. if sessionStorage is not available)
        (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).warn('Could not store previous trace in sessionStorage', e);
    }
}
/**
 * Retrieves the previous trace from sessionStorage if available.
 */ function $707cb3e901bff946$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).sessionStorage?.getItem($707cb3e901bff946$export$16b6aa13b3c0f075);
        // @ts-expect-error - intentionally risking JSON.parse throwing when previousTraceInfo is null to save bundle size
        return JSON.parse(previousTraceInfo);
    } catch  {
        return undefined;
    }
}
/**
 * see {@link import('@sentry/core/browser').spanIsSampled}
 */ function $707cb3e901bff946$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 0x1;
}





const $7d3287ffd4022864$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7d3287ffd4022864$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $06902bc3616af5fd$export$a4e09611e30da72e)(type, handler);
    (0, $06902bc3616af5fd$export$e18d6c5462c01368)(type, $7d3287ffd4022864$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $7d3287ffd4022864$export$c67d533bf77cbf54() {
    if (!(0, $35c456f1fd513008$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $8711648e54ceaa6b$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $7d3287ffd4022864$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$7d3287ffd4022864$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$7d3287ffd4022864$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $06902bc3616af5fd$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$7d3287ffd4022864$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $8711648e54ceaa6b$export$844ec244b1367d54)(header) && (0, $8711648e54ceaa6b$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$7d3287ffd4022864$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $52eaab10d44d3c9d$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $06902bc3616af5fd$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $7d3287ffd4022864$var$parseXhrUrlArg(url) {
    if ((0, $8711648e54ceaa6b$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}



// Symbol used by e.g. the Replay integration to store original body on Request objects
const $230d280c9d4c22ab$export$363d064b9116000e = Symbol.for('sentry__originalRequestBody');
/**
 * Serializes FormData.
 *
 * This is a bit simplified, but gives us a decent estimate.
 * This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'.
 *
 */ function $230d280c9d4c22ab$export$2f1b0f57f243f270(formData) {
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
/** Get the string representation of a body. */ function $230d280c9d4c22ab$export$945a2d5364608d5(body, _debug = (0, $dff4f20e1e252976$export$1c9f709888824e05)) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $230d280c9d4c22ab$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (error) {
        (0, $4f59afc245df76a3$export$16a28057038b10ef) && _debug.error(error, 'Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    (0, $4f59afc245df76a3$export$16a28057038b10ef) && _debug.log('Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/**
 * Parses the fetch arguments to extract the request payload.
 *
 * In case of a Request object, this function attempts to retrieve the original body by looking for a Sentry-patched symbol.
 */ function $230d280c9d4c22ab$export$ad44edf8012ec314(fetchArgs = []) {
    // Second argument with body options takes precedence
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === 'object' && 'body' in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        /* The Request interface's body is a ReadableStream, which we cannot directly access.
       Some integrations (e.g. Replay) patch the Request object to store the original body. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        const originalBody = request[$230d280c9d4c22ab$export$363d064b9116000e];
        if (originalBody !== undefined) return originalBody;
        return undefined; // Fall back to returning undefined (as we don't want to return a ReadableStream)
    }
    return undefined;
}
/**
 * Parses XMLHttpRequest response headers into a Record.
 * Extracted from replay internals to be reusable.
 */ function $230d280c9d4c22ab$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $4f59afc245df76a3$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).error(error, 'Failed to get xhr response headers', xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



/**
 * Checks if the baggage header has Sentry values.
 */ function $5d02b181c3516b55$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(',').some((value)=>value.trim().startsWith('sentry-'));
}
/**
 * Gets the full URL from a given URL string.
 */ function $5d02b181c3516b55$export$f2a087db7564c909(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch  {
        return undefined;
    }
}
/**
 * Checks if the entry is a PerformanceResourceTiming.
 */ function $5d02b181c3516b55$export$5803eedf1027ce61(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a Headers object from a record of string key-value pairs, and returns undefined if it fails.
 */ function $5d02b181c3516b55$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch  {
        // noop
        return undefined;
    }
}


/** Options for Request Instrumentation */ const $9c28f88f8cad1748$var$responseToSpanId = new WeakMap();
const $9c28f88f8cad1748$var$spanIdToEndTimestamp = new Map();
const $9c28f88f8cad1748$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $9c28f88f8cad1748$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$9c28f88f8cad1748$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$9c28f88f8cad1748$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === 'transaction' && event.spans) event.spans.forEach((span)=>{
                if (span.op === 'http.client') {
                    const updatedTimestamp = $9c28f88f8cad1748$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $9c28f88f8cad1748$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $fde0330eb2207262$exports.addFetchEndInstrumentationHandler)((handlerData)=>{
            if (handlerData.response) {
                const span = $9c28f88f8cad1748$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $9c28f88f8cad1748$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $fde0330eb2207262$exports.addFetchInstrumentationHandler)((handlerData)=>{
            const createdSpan = (0, $fde0330eb2207262$exports.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
                propagateTraceparent: propagateTraceparent,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (handlerData.response && handlerData.fetchData.__span) $9c28f88f8cad1748$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = (0, $5d02b181c3516b55$export$f2a087db7564c909)(handlerData.fetchData.url);
                const host = fullUrl ? (0, $fde0330eb2207262$exports.parseUrl)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    'http.url': fullUrl ? (0, $fde0330eb2207262$exports.stripDataUrlContent)(fullUrl) : undefined,
                    'server.address': host
                });
                if (enableHTTPTimings) $9c28f88f8cad1748$var$addHTTPTimings(createdSpan, client);
                onRequestSpanStart?.(createdSpan, {
                    headers: handlerData.headers
                });
            }
        });
    }
    if (traceXHR) (0, $7d3287ffd4022864$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $9c28f88f8cad1748$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            if (enableHTTPTimings) $9c28f88f8cad1748$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: (0, $5d02b181c3516b55$export$9dc5b8b2fb320da0)(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
            });
        }
    });
}
/**
 * The maximum time (ms) to wait for PerformanceResourceTiming data before ending the span.
 * Same approach is used by OTel's browser fetch instrumentation:
 * See {@link https://github.com/open-telemetry/opentelemetry-js/blob/30f94fe99339287b1e4d3c8bb90172c2523f06f4/experimental/packages/opentelemetry-instrumentation-fetch/src/fetch.ts#L352-L372}
 */ const $9c28f88f8cad1748$var$HTTP_TIMING_WAIT_MS = 300;
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $9c28f88f8cad1748$var$addHTTPTimings(span, client) {
    const { url: url } = (0, $fde0330eb2207262$exports.spanToJSON)(span).data;
    if (!url || typeof url !== 'string') return;
    // Clean up the performance observer and other resources
    // We have to wait here because otherwise this cleans itself up before it is fully done.
    // Default (non-streaming): just deregister the observer.
    let onEntryFound = ()=>void setTimeout(unsubscribePerformanceObsever);
    // For streamed spans, we have to artificially delay the ending of the span until we
    // either receive the timing data, or HTTP_TIMING_WAIT_MS elapses.
    if ((0, $fde0330eb2207262$exports.hasSpanStreamingEnabled)(client)) {
        const originalEnd = span.end.bind(span);
        span.end = (endTimestamp)=>{
            const capturedEndTimestamp = endTimestamp ?? (0, $fde0330eb2207262$exports.timestampInSeconds)();
            let isEnded = false;
            const endSpanAndCleanup = ()=>{
                if (isEnded) return;
                isEnded = true;
                setTimeout(unsubscribePerformanceObsever);
                originalEnd(capturedEndTimestamp);
                clearTimeout(fallbackTimeout);
            };
            onEntryFound = endSpanAndCleanup;
            // Fallback: always end the span after HTTP_TIMING_WAIT_MS even if no
            // PerformanceResourceTiming entry arrives (e.g. cross-origin without
            // Timing-Allow-Origin, or the browser didn't fire the observer in time).
            const fallbackTimeout = setTimeout(endSpanAndCleanup, $9c28f88f8cad1748$var$HTTP_TIMING_WAIT_MS);
        };
    }
    const unsubscribePerformanceObsever = (0, $5fd9244da26f7eb5$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $5d02b181c3516b55$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $bb4bbc60bde7fd85$export$ec50b091612e7e00)(entry));
                onEntryFound();
            }
        });
    });
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $9c28f88f8cad1748$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $fde0330eb2207262$exports.getLocationHref)();
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $fde0330eb2207262$exports.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch  {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $fde0330eb2207262$exports.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $fde0330eb2207262$exports.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $9c28f88f8cad1748$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $7d3287ffd4022864$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $fde0330eb2207262$exports.hasSpansEnabled)() && shouldCreateSpan(url);
    // Handle XHR completion - clean up spans from the record
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== undefined) {
                (0, $fde0330eb2207262$exports.setHttpStatus)(span, sentryXhrData.status_code);
                span.end();
                onRequestSpanEnd?.(span, {
                    headers: (0, $5d02b181c3516b55$export$9dc5b8b2fb320da0)((0, $230d280c9d4c22ab$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = (0, $5d02b181c3516b55$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $fde0330eb2207262$exports.parseUrl)(fullUrl) : (0, $fde0330eb2207262$exports.parseUrl)(url);
    const urlForSpanName = (0, $fde0330eb2207262$exports.stripDataUrlContent)((0, $fde0330eb2207262$exports.stripUrlQueryAndFragment)(url));
    const client = (0, $fde0330eb2207262$exports.getClient)();
    const hasParent = !!(0, $fde0330eb2207262$exports.getActiveSpan)();
    // With span streaming, we always emit http.client spans, even without a parent span
    const shouldEmitSpan = hasParent || !!client && (0, $fde0330eb2207262$exports.hasSpanStreamingEnabled)(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? (0, $fde0330eb2207262$exports.startInactiveSpan)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: (0, $fde0330eb2207262$exports.stripDataUrlContent)(url),
            type: 'xhr',
            'http.method': method,
            'http.url': fullUrl ? (0, $fde0330eb2207262$exports.stripDataUrlContent)(fullUrl) : undefined,
            'server.address': parsedUrl?.host,
            [(0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.http.browser',
            [(0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: 'http.client',
            ...parsedUrl?.search && {
                'http.query': parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                'http.fragment': parsedUrl?.hash
            }
        }
    }) : new (0, $fde0330eb2207262$exports.SentryNonRecordingSpan)();
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent('no_parent_span', 'span');
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(url)) $9c28f88f8cad1748$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $fde0330eb2207262$exports.hasSpansEnabled)() && shouldEmitSpan ? span : undefined, propagateTraceparent);
    if (client) client.emit('beforeOutgoingRequestSpan', span, handlerData);
    return span;
}
function $9c28f88f8cad1748$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { 'sentry-trace': sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $fde0330eb2207262$exports.getTraceData)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $9c28f88f8cad1748$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $9c28f88f8cad1748$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.['sentry-trace'] || !xhr.setRequestHeader) // bail if a sentry-trace header is already set
    return;
    try {
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (traceparentHeader && !originalHeaders?.['traceparent']) xhr.setRequestHeader('traceparent', traceparentHeader);
        if (sentryBaggageHeader) {
            // only add our headers if
            // - no pre-existing baggage header exists
            // - or it is set and doesn't yet contain sentry values
            const originalBaggageHeader = originalHeaders?.['baggage'];
            if (!originalBaggageHeader || !(0, $5d02b181c3516b55$export$8193ac587e359dc0)(originalBaggageHeader)) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            xhr.setRequestHeader('baggage', sentryBaggageHeader);
        }
    } catch  {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}


const $8bc13e8f9b2f488c$export$bbd2089f30bd3708 = 'BrowserTracing';
/**
 * We don't want to start a bunch of idle timers and PerformanceObservers
 * for web crawlers, as they may prevent the page from being seen as "idle"
 * by the crawler's rendering engine (e.g. Googlebot's headless Chromium).
 */ const $8bc13e8f9b2f488c$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $8bc13e8f9b2f488c$export$e189d11d152c4191() {
    const nav = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).navigator;
    if (!nav?.userAgent) return false;
    return $8bc13e8f9b2f488c$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
const $8bc13e8f9b2f488c$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $fde0330eb2207262$exports.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: 'in-memory',
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {},
    ...(0, $9c28f88f8cad1748$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $8bc13e8f9b2f488c$export$b4109253475213e9 = (options = {})=>{
    if ('enableElementTiming' in options) (0, $fde0330eb2207262$exports.consoleSandbox)(()=>{
        // oxlint-disable-next-line no-console
        console.warn('[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.');
    });
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$8bc13e8f9b2f488c$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ...options
    };
    const _isBot = $8bc13e8f9b2f488c$export$e189d11d152c4191();
    let _collectWebVitals;
    let lastInteractionTimestamp;
    let _pageloadSpan;
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions, makeActive = true) {
        const isPageloadSpan = startSpanOptions.op === 'pageload';
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (initialSpanName !== finalStartSpanOptions.name) {
            attributes[0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        if (!makeActive) {
            // We want to ensure this has 0s duration
            const now = (0, $fde0330eb2207262$exports.dateTimestampInSeconds)();
            (0, $fde0330eb2207262$exports.startInactiveSpan)({
                ...finalStartSpanOptions,
                startTime: now
            }).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $fde0330eb2207262$exports.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                // This will generally always be defined here, because it is set in `setup()` of the integration
                // but technically, it is optional, so we guard here to be extra safe
                _collectWebVitals?.();
                const spanStreamingEnabled = (0, $fde0330eb2207262$exports.hasSpanStreamingEnabled)(client);
                (0, $aaa56fe7e1ac31ed$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !spanStreamingEnabled && !enableStandaloneClsSpans,
                    recordLcpOnPageloadSpan: !spanStreamingEnabled && !enableStandaloneLcpSpans,
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans,
                    spanStreamingEnabled: spanStreamingEnabled
                });
                $8bc13e8f9b2f488c$var$setActiveIdleSpan(client, undefined);
                // A trace should stay consistent over the entire timespan of one route - even after the pageload/navigation ended.
                // Only when another navigation happens, we want to create a new trace.
                // This way, e.g. errors that occur after the pageload span ended are still associated to the pageload trace.
                const scope = (0, $fde0330eb2207262$exports.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $fde0330eb2207262$exports.spanIsSampled)(idleSpan),
                    dsc: (0, $fde0330eb2207262$exports.getDynamicSamplingContextFromSpan)(span)
                });
                if (isPageloadSpan) // clean up the stored pageload span on the intergration.
                _pageloadSpan = undefined;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $8bc13e8f9b2f488c$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                'interactive',
                'complete'
            ].includes(optionalWindowDocument.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        // Enable auto finish of the pageload span if users are not explicitly ending it
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: $8bc13e8f9b2f488c$export$bbd2089f30bd3708,
        setup (client) {
            if (_isBot) {
                (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).log('[Tracing] Skipping browserTracingIntegration setup for bot user agent.');
                return;
            }
            (0, $fde0330eb2207262$exports.registerSpanErrorInstrumentation)();
            const spanStreamingEnabled = (0, $fde0330eb2207262$exports.hasSpanStreamingEnabled)(client);
            _collectWebVitals = (0, $aaa56fe7e1ac31ed$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: spanStreamingEnabled ? undefined : enableStandaloneClsSpans || false,
                recordLcpStandaloneSpans: spanStreamingEnabled ? undefined : enableStandaloneLcpSpans || false,
                client: client
            });
            if (spanStreamingEnabled) {
                (0, $e5c69d079f32e2b2$export$73747c030e2325c0)(client);
                (0, $e5c69d079f32e2b2$export$f2ca9ed704743eb2)(client);
                if (enableInp) (0, $e5c69d079f32e2b2$export$4a8cbc644515d57b)();
            } else if (enableInp) (0, $3f9d3a2d5a57108e$export$f17d06681a4744a3)();
            if (enableLongAnimationFrame && (0, $fde0330eb2207262$exports.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes('long-animation-frame')) (0, $aaa56fe7e1ac31ed$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $aaa56fe7e1ac31ed$export$f396d19077034ad2)();
            if (enableInteractions) (0, $aaa56fe7e1ac31ed$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $fde0330eb2207262$exports.timestampInSeconds)();
                };
                addEventListener('click', interactionHandler, {
                    capture: true
                });
                addEventListener('keydown', interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $8bc13e8f9b2f488c$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $fde0330eb2207262$exports.spanToJSON)(activeSpan).timestamp) {
                    (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).log(`[Tracing] Finishing current active span with op: ${(0, $fde0330eb2207262$exports.spanToJSON)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.setAttribute((0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'cancelled');
                    activeSpan.end();
                }
            }
            client.on('startNavigationSpan', (startSpanOptions, navigationOptions)=>{
                if ((0, $fde0330eb2207262$exports.getClient)() !== client) return;
                if (navigationOptions?.isRedirect) {
                    (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).warn('[Tracing] Detected redirect, navigation span will not be the root span, but a child span.');
                    _createRouteSpan(client, {
                        op: 'navigation.redirect',
                        ...startSpanOptions
                    }, false);
                    return;
                }
                // Reset the last interaction timestamp since we now start a new navigation.
                // Any subsequent navigation span starts could again be a redirect, so we
                // should reset our heuristic detectors.
                lastInteractionTimestamp = undefined;
                maybeEndActiveSpan();
                (0, $fde0330eb2207262$exports.getIsolationScope)().setPropagationContext({
                    traceId: (0, $fde0330eb2207262$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $fde0330eb2207262$exports.hasSpansEnabled)() ? undefined : (0, $fde0330eb2207262$exports.generateSpanId)()
                });
                const scope = (0, $fde0330eb2207262$exports.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, $fde0330eb2207262$exports.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $fde0330eb2207262$exports.hasSpansEnabled)() ? undefined : (0, $fde0330eb2207262$exports.generateSpanId)()
                });
                // We reset this to ensure we do not have lingering incorrect data here
                // places that call this hook may set this where appropriate - else, the URL at span sending time is used
                scope.setSDKProcessingMetadata({
                    normalizedRequest: undefined
                });
                _createRouteSpan(client, {
                    op: 'navigation',
                    ...startSpanOptions,
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                });
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $fde0330eb2207262$exports.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $8bc13e8f9b2f488c$export$f147b32b03c9cf11('sentry-trace') || $8bc13e8f9b2f488c$export$5bb9693b37f7c2ae('sentry-trace');
                const baggage = traceOptions.baggage || $8bc13e8f9b2f488c$export$f147b32b03c9cf11('baggage') || $8bc13e8f9b2f488c$export$5bb9693b37f7c2ae('baggage');
                const propagationContext = (0, $fde0330eb2207262$exports.propagationContextFromHeaders)(sentryTrace, baggage);
                const scope = (0, $fde0330eb2207262$exports.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $fde0330eb2207262$exports.hasSpansEnabled)()) // for browser, we wanna keep the spanIds consistent during the entire lifetime of the trace
                // this works by setting the propagationSpanId to a random spanId so that we have a consistent
                // span id to propagate in TwP mode (!hasSpansEnabled())
                scope.getPropagationContext().propagationSpanId = (0, $fde0330eb2207262$exports.generateSpanId)();
                // We store the normalized request data on the scope, so we get the request data at time of span creation
                // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $8282d53d03c1861c$export$a3c4a8453e8936f0)()
                });
                _createRouteSpan(client, {
                    op: 'pageload',
                    ...startSpanOptions
                });
            });
            client.on('endPageloadSpan', ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'reportPageLoaded');
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            if (_isBot) return;
            let startingUrl = (0, $fde0330eb2207262$exports.getLocationHref)();
            if (linkPreviousTrace !== 'off') (0, $707cb3e901bff946$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $8282d53d03c1861c$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $fde0330eb2207262$exports.browserPerformanceTimeOrigin)();
                    $8bc13e8f9b2f488c$export$aa44a07f82af519f(client, {
                        name: (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1000 : undefined,
                        attributes: {
                            [(0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url',
                            [(0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.pageload.browser'
                        }
                    });
                }
                if (instrumentNavigation) (0, $ef4fb3eead0db2bd$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    startingUrl = undefined;
                    const parsed = (0, $fde0330eb2207262$exports.parseStringToURLObject)(to);
                    const activeSpan = $8bc13e8f9b2f488c$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $8bc13e8f9b2f488c$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $8bc13e8f9b2f488c$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).location.pathname,
                        attributes: {
                            [(0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url',
                            [(0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'auto.navigation.browser'
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $2ac9d29ce81993a2$export$6f18f55521af71a1)();
            if (enableInteractions) $8bc13e8f9b2f488c$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $3f9d3a2d5a57108e$export$e4e04d43e223cce2)();
            (0, $9c28f88f8cad1748$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $8bc13e8f9b2f488c$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $fde0330eb2207262$exports.getCurrentScope)().setTransactionName(spanOptions.name);
    const pageloadSpan = $8bc13e8f9b2f488c$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit('afterStartPageLoadSpan', pageloadSpan);
    return pageloadSpan;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $8bc13e8f9b2f488c$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect } = options || {};
    client.emit('beforeStartNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    client.emit('startNavigationSpan', spanOptions, {
        isRedirect: isRedirect
    });
    const scope = (0, $fde0330eb2207262$exports.getCurrentScope)();
    scope.setTransactionName(spanOptions.name);
    // We store the normalized request data on the scope, so we get the request data at time of span creation
    // otherwise, the URL etc. may already be of the following navigation, and we'd report the wrong URL
    if (url && !isRedirect) scope.setSDKProcessingMetadata({
        normalizedRequest: {
            ...(0, $8282d53d03c1861c$export$a3c4a8453e8936f0)(),
            url: url
        }
    });
    return $8bc13e8f9b2f488c$var$getActiveIdleSpan(client);
}
/** Returns the value of a meta tag */ function $8bc13e8f9b2f488c$export$f147b32b03c9cf11(metaName) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute('content') || undefined;
}
/** Returns the description of a server timing entry */ function $8bc13e8f9b2f488c$export$5bb9693b37f7c2ae(name) {
    const navigation = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).performance?.getEntriesByType?.('navigation')[0];
    const entry = navigation?.serverTiming?.find((entry)=>entry.name === name);
    return entry?.description;
}
/** Start listener for interaction transactions */ function $8bc13e8f9b2f488c$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeIdleSpan = $8bc13e8f9b2f488c$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $fde0330eb2207262$exports.spanToJSON)(activeIdleSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $fde0330eb2207262$exports.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $fde0330eb2207262$exports.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener('click', registerInteractionTransaction, {
        capture: true
    });
}
// We store the active idle span on the client object, so we can access it from exported functions
const $8bc13e8f9b2f488c$var$ACTIVE_IDLE_SPAN_PROPERTY = '_sentry_idleSpan';
function $8bc13e8f9b2f488c$var$getActiveIdleSpan(client) {
    return client[$8bc13e8f9b2f488c$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $8bc13e8f9b2f488c$var$setActiveIdleSpan(client, span) {
    (0, $fde0330eb2207262$exports.addNonEnumerableProperty)(client, $8bc13e8f9b2f488c$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
// The max. time in seconds between two pageload/navigation spans that makes us consider the second one a redirect
const $8bc13e8f9b2f488c$var$REDIRECT_THRESHOLD = 1.5;
function $8bc13e8f9b2f488c$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $fde0330eb2207262$exports.spanToJSON)(activeSpan);
    const now = (0, $fde0330eb2207262$exports.dateTimestampInSeconds)();
    // More than REDIRECT_THRESHOLD seconds since last navigation/pageload span?
    // --> never consider this a redirect
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $8bc13e8f9b2f488c$var$REDIRECT_THRESHOLD) return false;
    // A click happened in the last REDIRECT_THRESHOLD seconds?
    // --> never consider this a redirect
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $8bc13e8f9b2f488c$var$REDIRECT_THRESHOLD) return false;
    return true;
}




/**
 * This function creates an exception from a JavaScript Error
 */ function $0900382e0c500c5a$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $0900382e0c500c5a$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $0900382e0c500c5a$export$2e9ae379995d99e3(ex),
        value: $0900382e0c500c5a$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $0900382e0c500c5a$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $fde0330eb2207262$exports.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $0900382e0c500c5a$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $fde0330eb2207262$exports.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $0900382e0c500c5a$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $fde0330eb2207262$exports.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $0900382e0c500c5a$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $0900382e0c500c5a$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $0900382e0c500c5a$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $0900382e0c500c5a$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $0900382e0c500c5a$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $0900382e0c500c5a$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $0900382e0c500c5a$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $0900382e0c500c5a$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $0900382e0c500c5a$var$getSkipFirstStackStringLines(ex) {
    if (ex && $0900382e0c500c5a$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $0900382e0c500c5a$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $0900382e0c500c5a$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    // oxlint-disable-next-line typescript/prefer-optional-chain
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $0900382e0c500c5a$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $0900382e0c500c5a$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $0900382e0c500c5a$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($0900382e0c500c5a$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return (0, $fde0330eb2207262$exports._INTERNAL_enhanceErrorWithSentryInfo)(message.error);
    return (0, $fde0330eb2207262$exports._INTERNAL_enhanceErrorWithSentryInfo)(ex);
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $0900382e0c500c5a$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $0900382e0c500c5a$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $fde0330eb2207262$exports.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $fde0330eb2207262$exports.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $0900382e0c500c5a$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $0900382e0c500c5a$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $fde0330eb2207262$exports.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $0900382e0c500c5a$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $fde0330eb2207262$exports.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $0900382e0c500c5a$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $fde0330eb2207262$exports.isDOMError)(exception) || (0, $fde0330eb2207262$exports.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $0900382e0c500c5a$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $fde0330eb2207262$exports.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $0900382e0c500c5a$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $fde0330eb2207262$exports.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $fde0330eb2207262$exports.isError)(exception)) // we have a real Error object, do nothing
    return $0900382e0c500c5a$var$eventFromError(stackParser, exception);
    if ((0, $fde0330eb2207262$exports.isPlainObject)(exception) || (0, $fde0330eb2207262$exports.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $0900382e0c500c5a$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $fde0330eb2207262$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $0900382e0c500c5a$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $fde0330eb2207262$exports.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $fde0330eb2207262$exports.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $0900382e0c500c5a$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $0900382e0c500c5a$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $fde0330eb2207262$exports.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $fde0330eb2207262$exports.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $0900382e0c500c5a$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $fde0330eb2207262$exports.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $fde0330eb2207262$exports.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $fde0330eb2207262$exports.isEvent)(exception)) {
        const className = $0900382e0c500c5a$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $0900382e0c500c5a$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $0900382e0c500c5a$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}



/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $d57f8ceef264332d$export$1df9218a526d318d extends (0, $fde0330eb2207262$exports.Client) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $d57f8ceef264332d$export$4e107b20a7f977(options);
        const sdkSource = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $fde0330eb2207262$exports.getSDKSource)();
        (0, $fde0330eb2207262$exports.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            infer_ip: opts.sendDefaultPii ? 'auto' : 'never',
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        // Flush logs and metrics when page becomes hidden (e.g., tab switch, navigation)
        // todo(v11): Remove the experimental flag
        if ((0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $fde0330eb2207262$exports._INTERNAL_flushLogsBuffer)(this);
                if (enableMetrics) (0, $fde0330eb2207262$exports._INTERNAL_flushMetricsBuffer)(this);
            }
        });
        if (sendDefaultPii) this.on('beforeSendSession', (0, $fde0330eb2207262$exports.addAutoIpAddressToSession));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $0900382e0c500c5a$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $0900382e0c500c5a$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $d57f8ceef264332d$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}





const $ebfef9000b1ad5b0$var$DEBOUNCE_DURATION = 1000;
let $ebfef9000b1ad5b0$var$debounceTimerID;
let $ebfef9000b1ad5b0$var$lastCapturedEventType;
let $ebfef9000b1ad5b0$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ebfef9000b1ad5b0$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $06902bc3616af5fd$export$a4e09611e30da72e)(type, handler);
    (0, $06902bc3616af5fd$export$e18d6c5462c01368)(type, $ebfef9000b1ad5b0$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $ebfef9000b1ad5b0$export$3014bbf0af0e1d4a() {
    if (!(0, $35c456f1fd513008$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $06902bc3616af5fd$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $ebfef9000b1ad5b0$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $35c456f1fd513008$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $35c456f1fd513008$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $35c456f1fd513008$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $d727cbb61f53b6ae$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $ebfef9000b1ad5b0$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $d727cbb61f53b6ae$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $ebfef9000b1ad5b0$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $ebfef9000b1ad5b0$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $ebfef9000b1ad5b0$var$lastCapturedEventTargetId) return false;
    } catch  {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $ebfef9000b1ad5b0$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $ebfef9000b1ad5b0$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $ebfef9000b1ad5b0$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($ebfef9000b1ad5b0$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $d727cbb61f53b6ae$export$e73679ffaf56810e)(target, '_sentryId', (0, $d85cf031e838da82$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$ebfef9000b1ad5b0$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $ebfef9000b1ad5b0$var$lastCapturedEventType = event.type;
            $ebfef9000b1ad5b0$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($ebfef9000b1ad5b0$var$debounceTimerID);
        $ebfef9000b1ad5b0$var$debounceTimerID = (0, $35c456f1fd513008$export$56d8a8a25bd48b81).setTimeout(()=>{
            $ebfef9000b1ad5b0$var$lastCapturedEventTargetId = undefined;
            $ebfef9000b1ad5b0$var$lastCapturedEventType = undefined;
        }, $ebfef9000b1ad5b0$var$DEBOUNCE_DURATION);
    };
}
function $ebfef9000b1ad5b0$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $ef0460b54de0774b$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $ef0460b54de0774b$var$INTEGRATION_NAME = 'Breadcrumbs';
const $ef0460b54de0774b$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $ef0460b54de0774b$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $fde0330eb2207262$exports.addConsoleInstrumentationHandler)($ef0460b54de0774b$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $ebfef9000b1ad5b0$export$5aeffd3db2cf9df7)($ef0460b54de0774b$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $7d3287ffd4022864$export$26ace48dd54c9aea)($ef0460b54de0774b$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $fde0330eb2207262$exports.addFetchInstrumentationHandler)($ef0460b54de0774b$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $ef4fb3eead0db2bd$export$3f18c56c58114e75)($ef0460b54de0774b$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $ef0460b54de0774b$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $ef0460b54de0774b$export$c079d904b326663a = (0, $fde0330eb2207262$exports.defineIntegration)($ef0460b54de0774b$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $ef0460b54de0774b$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $fde0330eb2207262$exports.getClient)() !== client) return;
        (0, $fde0330eb2207262$exports.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $fde0330eb2207262$exports.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $ef0460b54de0774b$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $fde0330eb2207262$exports.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $ef0460b54de0774b$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$ef0460b54de0774b$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$ef0460b54de0774b$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $ef0460b54de0774b$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $ef0460b54de0774b$var$_isEvent(event) ? event.target : event;
            target = (0, $fde0330eb2207262$exports.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $fde0330eb2207262$exports.getComponentName)(element);
        } catch  {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $fde0330eb2207262$exports.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $ef0460b54de0774b$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $fde0330eb2207262$exports.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $fde0330eb2207262$exports.severityLevelFromString)(handlerData.level),
            message: (0, $fde0330eb2207262$exports.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $fde0330eb2207262$exports.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $fde0330eb2207262$exports.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $ef0460b54de0774b$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $fde0330eb2207262$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $7d3287ffd4022864$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $fde0330eb2207262$exports.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $fde0330eb2207262$exports.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $ef0460b54de0774b$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $fde0330eb2207262$exports.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: handlerData.fetchData,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $fde0330eb2207262$exports.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $fde0330eb2207262$exports.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $fde0330eb2207262$exports.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $ef0460b54de0774b$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $fde0330eb2207262$exports.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $fde0330eb2207262$exports.parseUrl)((0, $8282d53d03c1861c$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $fde0330eb2207262$exports.parseUrl)(from) : undefined;
        const parsedTo = (0, $fde0330eb2207262$exports.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $fde0330eb2207262$exports.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $ef0460b54de0774b$var$_isEvent(event) {
    return !!event && !!event.target;
}




// Using a comma-separated string and split for smaller bundle size vs an array literal
const $27270046f4e5f9b9$var$DEFAULT_EVENT_TARGET = 'EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload'.split(',');
const $27270046f4e5f9b9$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $27270046f4e5f9b9$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $27270046f4e5f9b9$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $fde0330eb2207262$exports.fill)((0, $8282d53d03c1861c$export$56d8a8a25bd48b81), 'setTimeout', $27270046f4e5f9b9$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $fde0330eb2207262$exports.fill)((0, $8282d53d03c1861c$export$56d8a8a25bd48b81), 'setInterval', $27270046f4e5f9b9$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $fde0330eb2207262$exports.fill)((0, $8282d53d03c1861c$export$56d8a8a25bd48b81), 'requestAnimationFrame', $27270046f4e5f9b9$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $8282d53d03c1861c$export$56d8a8a25bd48b81)) (0, $fde0330eb2207262$exports.fill)(XMLHttpRequest.prototype, 'send', $27270046f4e5f9b9$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $27270046f4e5f9b9$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$27270046f4e5f9b9$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $27270046f4e5f9b9$export$59bfe9f1c76150e = (0, $fde0330eb2207262$exports.defineIntegration)($27270046f4e5f9b9$var$_browserApiErrorsIntegration);
function $27270046f4e5f9b9$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $8282d53d03c1861c$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $fde0330eb2207262$exports.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $27270046f4e5f9b9$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $8282d53d03c1861c$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $fde0330eb2207262$exports.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'auto.browser.browserapierrors.requestAnimationFrame'
                }
            })
        ]);
    };
}
function $27270046f4e5f9b9$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $fde0330eb2207262$exports.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $fde0330eb2207262$exports.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $fde0330eb2207262$exports.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $fde0330eb2207262$exports.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $8282d53d03c1861c$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $27270046f4e5f9b9$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $fde0330eb2207262$exports.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($27270046f4e5f9b9$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $8282d53d03c1861c$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $fde0330eb2207262$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.handleEvent'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $27270046f4e5f9b9$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $8282d53d03c1861c$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $fde0330eb2207262$exports.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.addEventListener'
                    }
                }),
                options
            ]);
        };
    });
    (0, $fde0330eb2207262$exports.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $27270046f4e5f9b9$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $27270046f4e5f9b9$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $2509716ac35fc461$export$1baa7880e357371c = (0, $fde0330eb2207262$exports.defineIntegration)((options = {})=>{
    const lifecycle = options.lifecycle ?? 'route';
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $fde0330eb2207262$exports.startSession)({
                ignoreDuration: true
            });
            (0, $fde0330eb2207262$exports.captureSession)();
            // User data can be set at any time, for example async after Sentry.init has run and the initial session
            // envelope was already sent, but still on the initial page.
            // Therefore, we have to update the ongoing session with the new user data if it exists, to send the `did`.
            // In theory, sessions, as well as user data is always put onto the isolation scope. So we listen to the
            // isolation scope for changes and update the session with the new user data if it exists.
            // This will not catch users set onto other scopes, like the current scope. For now, we'll accept this limitation.
            // The alternative is to update and capture the session from within the scope. This could be too costly or would not
            // play well with session aggregates on the server side. Since this happens in the scope class, we'd need change
            // scope behaviour in the browser.
            const isolationScope = (0, $fde0330eb2207262$exports.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                // sessions only care about user id and ip address, so we only need to capture the session if the user has changed
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    // the scope class already writes the user to its session, so we only need to capture the session here
                    (0, $fde0330eb2207262$exports.captureSession)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === 'route') // We want to create a session for every navigation as well
            (0, $ef4fb3eead0db2bd$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== to) {
                    (0, $fde0330eb2207262$exports.startSession)({
                        ignoreDuration: true
                    });
                    (0, $fde0330eb2207262$exports.captureSession)();
                }
            });
        }
    };
});




const $ec00a0a9787c379a$var$INTEGRATION_NAME = 'CultureContext';
const $ec00a0a9787c379a$var$_cultureContextIntegration = ()=>{
    return {
        name: $ec00a0a9787c379a$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $ec00a0a9787c379a$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $ec00a0a9787c379a$var$getCultureContext();
            if (culture) (0, $fde0330eb2207262$exports.safeSetSpanJSONAttributes)(span, {
                'culture.locale': culture.locale,
                'culture.timezone': culture.timezone,
                'culture.calendar': culture.calendar
            });
        }
    };
};
/**
 * Captures culture context from the browser.
 *
 * Enabled by default.
 *
 * @example
 * ```js
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   integrations: [Sentry.cultureContextIntegration()],
 * });
 * ```
 */ const $ec00a0a9787c379a$export$ec5976aacdc85985 = (0, $fde0330eb2207262$exports.defineIntegration)($ec00a0a9787c379a$var$_cultureContextIntegration);
/**
 * Returns the culture context from the browser's Intl API.
 */ function $ec00a0a9787c379a$var$getCultureContext() {
    try {
        const intl = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).Intl;
        if (!intl) return undefined;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        // Ignore errors
        return undefined;
    }
}






const $64d9d2ec39473c28$var$INTEGRATION_NAME = 'GlobalHandlers';
const $64d9d2ec39473c28$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $64d9d2ec39473c28$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $64d9d2ec39473c28$var$_installGlobalOnErrorHandler(client);
                $64d9d2ec39473c28$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $64d9d2ec39473c28$var$_installGlobalOnUnhandledRejectionHandler(client);
                $64d9d2ec39473c28$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $64d9d2ec39473c28$export$66acc70e8cf2b71a = (0, $fde0330eb2207262$exports.defineIntegration)($64d9d2ec39473c28$var$_globalHandlersIntegration);
function $64d9d2ec39473c28$var$_installGlobalOnErrorHandler(client) {
    (0, $fde0330eb2207262$exports.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $64d9d2ec39473c28$var$getOptions();
        if ((0, $fde0330eb2207262$exports.getClient)() !== client || (0, $8282d53d03c1861c$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $64d9d2ec39473c28$var$_enhanceEventWithInitialFrame((0, $0900382e0c500c5a$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $fde0330eb2207262$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onerror'
            }
        });
    });
}
function $64d9d2ec39473c28$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $fde0330eb2207262$exports.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $64d9d2ec39473c28$var$getOptions();
        if ((0, $fde0330eb2207262$exports.getClient)() !== client || (0, $8282d53d03c1861c$export$b79738ab10c590b2)()) return;
        const error = $64d9d2ec39473c28$export$b2cc40fa8241780(e);
        const event = (0, $fde0330eb2207262$exports.isPrimitive)(error) ? $64d9d2ec39473c28$export$1353b5b36844a9ed(error) : (0, $0900382e0c500c5a$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $fde0330eb2207262$exports.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onunhandledrejection'
            }
        });
    });
}
/**
 *
 */ function $64d9d2ec39473c28$export$b2cc40fa8241780(error) {
    if ((0, $fde0330eb2207262$exports.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $64d9d2ec39473c28$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $64d9d2ec39473c28$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $64d9d2ec39473c28$var$getFilenameFromUrl(url) ?? (0, $fde0330eb2207262$exports.getLocationHref)(),
        function: (0, $fde0330eb2207262$exports.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $64d9d2ec39473c28$var$globalHandlerLog(type) {
    (0, $124d907e35e89f75$export$16a28057038b10ef) && (0, $fde0330eb2207262$exports.debug).log(`Global Handler attached: ${type}`);
}
function $64d9d2ec39473c28$var$getOptions() {
    const client = (0, $fde0330eb2207262$exports.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $64d9d2ec39473c28$var$getFilenameFromUrl(url) {
    if (!(0, $fde0330eb2207262$exports.isString)(url) || url.length === 0) return undefined;
    // Strip data URL content to avoid long base64 strings in stack frames
    // (e.g. when initializing a Worker with a base64 encoded script)
    // Don't include data prefix for filenames as it's not useful for stack traces
    // Wrap with < > to indicate it's a placeholder
    if (url.startsWith('data:')) return `<${(0, $fde0330eb2207262$exports.stripDataUrlContent)(url, false)}>`;
    return url;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $a3ffe0312fbd9bbc$export$1378794447170364 = (0, $fde0330eb2207262$exports.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $8282d53d03c1861c$export$56d8a8a25bd48b81).navigator && !(0, $8282d53d03c1861c$export$56d8a8a25bd48b81).location && !(0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $8282d53d03c1861c$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        },
        processSegmentSpan (span) {
            // if none of the information we want exists, don't bother
            if (!(0, $8282d53d03c1861c$export$56d8a8a25bd48b81).navigator && !(0, $8282d53d03c1861c$export$56d8a8a25bd48b81).location && !(0, $8282d53d03c1861c$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $8282d53d03c1861c$export$a3c4a8453e8936f0)();
            (0, $fde0330eb2207262$exports.safeSetSpanJSONAttributes)(span, {
                // Coerce empty string to undefined so the helper's nullish check drops it,
                // rather than writing an empty `url.full` attribute onto the span.
                'url.full': reqData.url || undefined,
                'http.request.header.user_agent': reqData.headers['User-Agent'],
                'http.request.header.referer': reqData.headers['Referer']
            });
        }
    };
});




const $630b37a4a0936056$var$DEFAULT_KEY = 'cause';
const $630b37a4a0936056$var$DEFAULT_LIMIT = 5;
const $630b37a4a0936056$var$INTEGRATION_NAME = 'LinkedErrors';
const $630b37a4a0936056$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $630b37a4a0936056$var$DEFAULT_LIMIT;
    const key = options.key || $630b37a4a0936056$var$DEFAULT_KEY;
    return {
        name: $630b37a4a0936056$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $fde0330eb2207262$exports.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $0900382e0c500c5a$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $630b37a4a0936056$export$ebabb00eb7f3a395 = (0, $fde0330eb2207262$exports.defineIntegration)($630b37a4a0936056$var$_linkedErrorsIntegration);




const $f00d34dee032deac$var$OPERA10_PRIORITY = 10;
const $f00d34dee032deac$var$OPERA11_PRIORITY = 20;
const $f00d34dee032deac$var$CHROME_PRIORITY = 30;
const $f00d34dee032deac$var$WINJS_PRIORITY = 40;
const $f00d34dee032deac$var$GECKO_PRIORITY = 50;
function $f00d34dee032deac$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $fde0330eb2207262$exports.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $f00d34dee032deac$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $f00d34dee032deac$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $f00d34dee032deac$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
const $f00d34dee032deac$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $f00d34dee032deac$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($f00d34dee032deac$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $f00d34dee032deac$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $f00d34dee032deac$var$createFrame(filename, (0, $fde0330eb2207262$exports.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $f00d34dee032deac$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $f00d34dee032deac$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $f00d34dee032deac$var$extractSafariExtensionDetails(parts[1] || (0, $fde0330eb2207262$exports.UNKNOWN_FUNCTION), parts[2]);
        return $f00d34dee032deac$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $f00d34dee032deac$export$263a749fff749872 = [
    $f00d34dee032deac$var$CHROME_PRIORITY,
    $f00d34dee032deac$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $f00d34dee032deac$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $f00d34dee032deac$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $f00d34dee032deac$var$gecko = (line)=>{
    const parts = $f00d34dee032deac$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $f00d34dee032deac$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $fde0330eb2207262$exports.UNKNOWN_FUNCTION);
        [func, filename] = $f00d34dee032deac$var$extractSafariExtensionDetails(func, filename);
        return $f00d34dee032deac$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $f00d34dee032deac$export$cdba47a5dd2804d = [
    $f00d34dee032deac$var$GECKO_PRIORITY,
    $f00d34dee032deac$var$gecko
];
const $f00d34dee032deac$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $f00d34dee032deac$var$winjs = (line)=>{
    const parts = $f00d34dee032deac$var$winjsRegex.exec(line);
    return parts ? $f00d34dee032deac$var$createFrame(parts[2], parts[1] || (0, $fde0330eb2207262$exports.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $f00d34dee032deac$export$179460296da408e8 = [
    $f00d34dee032deac$var$WINJS_PRIORITY,
    $f00d34dee032deac$var$winjs
];
const $f00d34dee032deac$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $f00d34dee032deac$var$opera10 = (line)=>{
    const parts = $f00d34dee032deac$var$opera10Regex.exec(line);
    return parts ? $f00d34dee032deac$var$createFrame(parts[2], parts[3] || (0, $fde0330eb2207262$exports.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $f00d34dee032deac$export$f892b52c880ffc7a = [
    $f00d34dee032deac$var$OPERA10_PRIORITY,
    $f00d34dee032deac$var$opera10
];
const $f00d34dee032deac$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $f00d34dee032deac$var$opera11 = (line)=>{
    const parts = $f00d34dee032deac$var$opera11Regex.exec(line);
    return parts ? $f00d34dee032deac$var$createFrame(parts[5], parts[3] || parts[4] || (0, $fde0330eb2207262$exports.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $f00d34dee032deac$export$af11af13f09fb0dc = [
    $f00d34dee032deac$var$OPERA11_PRIORITY,
    $f00d34dee032deac$var$opera11
];
const $f00d34dee032deac$export$7197c0fe6554c079 = [
    $f00d34dee032deac$export$263a749fff749872,
    $f00d34dee032deac$export$cdba47a5dd2804d
];
const $f00d34dee032deac$export$2b2b997d81bf3907 = (0, $fde0330eb2207262$exports.createStackParser)(...$f00d34dee032deac$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $f00d34dee032deac$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $fde0330eb2207262$exports.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};






/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $699447487e941ddd$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $699447487e941ddd$export$e464f4a514ac28a8(name) {
    const cached = $699447487e941ddd$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $35c456f1fd513008$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $6f449ea8029de974$export$d5f608b368e73f38)(impl)) return $699447487e941ddd$var$cachedImplementations[name] = impl.bind((0, $35c456f1fd513008$export$56d8a8a25bd48b81));
    const document = (0, $35c456f1fd513008$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $4f59afc245df76a3$export$16a28057038b10ef) && (0, $dff4f20e1e252976$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $699447487e941ddd$var$cachedImplementations[name] = impl.bind((0, $35c456f1fd513008$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $699447487e941ddd$export$8aa36702e8c8978(name) {
    $699447487e941ddd$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $699447487e941ddd$export$e7aa7bc5c1b3cfb3(...rest) {
    return $699447487e941ddd$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $699447487e941ddd$export$831dc9f2ab0a617b(...rest) {
    return $699447487e941ddd$export$e464f4a514ac28a8('setTimeout')(...rest);
}


const $279e9883e00d9890$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $279e9883e00d9890$export$b2311068c46d7cc8(options, nativeFetch = (0, $699447487e941ddd$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            // Note: We do not need to suppress tracing here, because we are using the native fetch, instead of our wrapped one.
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After')
                }
            };
        } catch (e) {
            (0, $699447487e941ddd$export$8aa36702e8c8978)('fetch');
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $fde0330eb2207262$exports.createTransport)(options, makeRequest, (0, $fde0330eb2207262$exports.makePromiseBuffer)(options.bufferSize || $279e9883e00d9890$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}





/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $c92f26bdb31fe147$export$dc236a86065879fc() {
    if ($c92f26bdb31fe147$var$_isEmbeddedBrowserExtension()) {
        if (0, $124d907e35e89f75$export$16a28057038b10ef) (0, $fde0330eb2207262$exports.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $c92f26bdb31fe147$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $fde0330eb2207262$exports.getLocationHref)();
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $8282d53d03c1861c$export$56d8a8a25bd48b81) === (0, $8282d53d03c1861c$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $7d4c0370f4ae1e04$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $fde0330eb2207262$exports.inboundFiltersIntegration)(),
        (0, $fde0330eb2207262$exports.functionToStringIntegration)(),
        (0, $fde0330eb2207262$exports.conversationIdIntegration)(),
        (0, $27270046f4e5f9b9$export$59bfe9f1c76150e)(),
        (0, $ef0460b54de0774b$export$c079d904b326663a)(),
        (0, $64d9d2ec39473c28$export$66acc70e8cf2b71a)(),
        (0, $630b37a4a0936056$export$ebabb00eb7f3a395)(),
        (0, $fde0330eb2207262$exports.dedupeIntegration)(),
        (0, $a3ffe0312fbd9bbc$export$1378794447170364)(),
        (0, $ec00a0a9787c379a$export$ec5976aacdc85985)(),
        (0, $2509716ac35fc461$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $7d4c0370f4ae1e04$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $c92f26bdb31fe147$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $7d4c0370f4ae1e04$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $fde0330eb2207262$exports.stackParserFromStackParserOptions)(options.stackParser || (0, $f00d34dee032deac$export$2b2b997d81bf3907)),
        integrations: (0, $fde0330eb2207262$exports.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $279e9883e00d9890$export$b2311068c46d7cc8)
    };
    return (0, $fde0330eb2207262$exports.initAndBind)((0, $d57f8ceef264332d$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $7d4c0370f4ae1e04$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $7d4c0370f4ae1e04$export$4e4d8b287d028b6b(callback) {
    callback();
}


const $7ba68a4aa3259968$export$3dd5973b7da73e99 = (within)=>(message, level)=>{
        const base = document.createElement('div');
        base.classList.add('alert', `alert-${level}`);
        base.setAttribute('role', 'alert');
        const text = document.createTextNode(message);
        base.appendChild(text);
        within.append(base);
    };


const $015fb139fe640229$export$306a681a1fc87013 = (el)=>(hidden)=>{
        if (hidden) el.classList.add('d-none');
        else el.classList.remove('d-none');
    };


const $1fd3c7d1cf184b80$export$cd09ce48f3054f09 = (el)=>({
        setProgress: (value)=>{
            el.style.width = `${value.toFixed(0)}%`;
            el.setAttribute('aria-valuenow', value.toFixed(0));
        },
        setHidden: (0, $015fb139fe640229$export$306a681a1fc87013)(el.parentElement)
    });




'use strict';
function $76abc644fe90a927$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $b487538a08a1351e$var$toString } = Object.prototype;
const { getPrototypeOf: $b487538a08a1351e$var$getPrototypeOf } = Object;
const { iterator: $b487538a08a1351e$var$iterator, toStringTag: $b487538a08a1351e$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $b487538a08a1351e$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $b487538a08a1351e$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($b487538a08a1351e$var$hasOwnProperty(obj, prop)) return true;
        obj = $b487538a08a1351e$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $b487538a08a1351e$var$getSafeProp = (obj, prop)=>obj != null && $b487538a08a1351e$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $b487538a08a1351e$var$kindOf = ((cache)=>(thing)=>{
        const str = $b487538a08a1351e$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $b487538a08a1351e$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$b487538a08a1351e$var$kindOf(thing) === type;
};
const $b487538a08a1351e$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $b487538a08a1351e$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $b487538a08a1351e$var$isUndefined = $b487538a08a1351e$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $b487538a08a1351e$var$isBuffer(val) {
    return val !== null && !$b487538a08a1351e$var$isUndefined(val) && val.constructor !== null && !$b487538a08a1351e$var$isUndefined(val.constructor) && $b487538a08a1351e$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $b487538a08a1351e$var$isArrayBuffer = $b487538a08a1351e$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $b487538a08a1351e$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $b487538a08a1351e$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $b487538a08a1351e$var$isString = $b487538a08a1351e$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $b487538a08a1351e$var$isFunction = $b487538a08a1351e$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $b487538a08a1351e$var$isNumber = $b487538a08a1351e$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $b487538a08a1351e$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $b487538a08a1351e$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $b487538a08a1351e$var$isPlainObject = (val)=>{
    if (!$b487538a08a1351e$var$isObject(val)) return false;
    const prototype = $b487538a08a1351e$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $b487538a08a1351e$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$b487538a08a1351e$var$hasOwnInPrototypeChain(val, $b487538a08a1351e$var$toStringTag) && !$b487538a08a1351e$var$hasOwnInPrototypeChain(val, $b487538a08a1351e$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $b487538a08a1351e$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$b487538a08a1351e$var$isObject(val) || $b487538a08a1351e$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $b487538a08a1351e$var$isDate = $b487538a08a1351e$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $b487538a08a1351e$var$isFile = $b487538a08a1351e$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $b487538a08a1351e$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $b487538a08a1351e$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $b487538a08a1351e$var$isBlob = $b487538a08a1351e$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $b487538a08a1351e$var$isFileList = $b487538a08a1351e$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $b487538a08a1351e$var$isStream = (val)=>$b487538a08a1351e$var$isObject(val) && $b487538a08a1351e$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $b487538a08a1351e$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $b487538a08a1351e$var$G = $b487538a08a1351e$var$getGlobal();
const $b487538a08a1351e$var$FormDataCtor = typeof $b487538a08a1351e$var$G.FormData !== 'undefined' ? $b487538a08a1351e$var$G.FormData : undefined;
const $b487538a08a1351e$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($b487538a08a1351e$var$FormDataCtor && thing instanceof $b487538a08a1351e$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $b487538a08a1351e$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$b487538a08a1351e$var$isFunction(thing.append)) return false;
    const kind = $b487538a08a1351e$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $b487538a08a1351e$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $b487538a08a1351e$var$isURLSearchParams = $b487538a08a1351e$var$kindOfTest('URLSearchParams');
const [$b487538a08a1351e$var$isReadableStream, $b487538a08a1351e$var$isRequest, $b487538a08a1351e$var$isResponse, $b487538a08a1351e$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($b487538a08a1351e$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $b487538a08a1351e$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $b487538a08a1351e$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($b487538a08a1351e$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($b487538a08a1351e$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $b487538a08a1351e$var$findKey(obj, key) {
    if ($b487538a08a1351e$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $b487538a08a1351e$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $b487538a08a1351e$var$isContextDefined = (context)=>!$b487538a08a1351e$var$isUndefined(context) && context !== $b487538a08a1351e$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $b487538a08a1351e$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $b487538a08a1351e$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $b487538a08a1351e$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $b487538a08a1351e$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($b487538a08a1351e$var$isPlainObject(existing) && $b487538a08a1351e$var$isPlainObject(val)) result[targetKey] = $b487538a08a1351e$var$merge(existing, val);
        else if ($b487538a08a1351e$var$isPlainObject(val)) result[targetKey] = $b487538a08a1351e$var$merge({}, val);
        else if ($b487538a08a1351e$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$b487538a08a1351e$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $b487538a08a1351e$var$isBuffer(source)) continue;
        $b487538a08a1351e$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $b487538a08a1351e$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($b487538a08a1351e$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $b487538a08a1351e$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $b487538a08a1351e$var$forEach(b, (val, key)=>{
        if (thisArg && $b487538a08a1351e$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $76abc644fe90a927$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $b487538a08a1351e$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $b487538a08a1351e$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $b487538a08a1351e$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $b487538a08a1351e$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $b487538a08a1351e$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $b487538a08a1351e$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($b487538a08a1351e$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$b487538a08a1351e$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $b487538a08a1351e$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $b487538a08a1351e$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $b487538a08a1351e$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$b487538a08a1351e$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $b487538a08a1351e$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $b487538a08a1351e$var$isHTMLForm = $b487538a08a1351e$var$kindOfTest('HTMLFormElement');
const $b487538a08a1351e$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $b487538a08a1351e$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $b487538a08a1351e$var$isRegExp = $b487538a08a1351e$var$kindOfTest('RegExp');
const $b487538a08a1351e$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $b487538a08a1351e$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $b487538a08a1351e$var$freezeMethods = (obj)=>{
    $b487538a08a1351e$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($b487538a08a1351e$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$b487538a08a1351e$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $b487538a08a1351e$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $b487538a08a1351e$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $b487538a08a1351e$var$noop = ()=>{};
const $b487538a08a1351e$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $b487538a08a1351e$var$isSpecCompliantForm(thing) {
    return !!(thing && $b487538a08a1351e$var$isFunction(thing.append) && thing[$b487538a08a1351e$var$toStringTag] === 'FormData' && thing[$b487538a08a1351e$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $b487538a08a1351e$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($b487538a08a1351e$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($b487538a08a1351e$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $b487538a08a1351e$var$isArray(source) ? [] : {};
                $b487538a08a1351e$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$b487538a08a1351e$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $b487538a08a1351e$var$isAsyncFn = $b487538a08a1351e$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $b487538a08a1351e$var$isThenable = (thing)=>thing && ($b487538a08a1351e$var$isObject(thing) || $b487538a08a1351e$var$isFunction(thing)) && $b487538a08a1351e$var$isFunction(thing.then) && $b487538a08a1351e$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $b487538a08a1351e$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $b487538a08a1351e$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $b487538a08a1351e$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $b487538a08a1351e$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $b487538a08a1351e$var$isFunction($b487538a08a1351e$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $b487538a08a1351e$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($b487538a08a1351e$var$_global) : $b487538a08a1351e$var$_setImmediate;
// *********************
const $b487538a08a1351e$var$isIterable = (thing)=>thing != null && $b487538a08a1351e$var$isFunction(thing[$b487538a08a1351e$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $b487538a08a1351e$var$isSafeIterable = (thing)=>thing != null && $b487538a08a1351e$var$hasOwnInPrototypeChain(thing, $b487538a08a1351e$var$iterator) && $b487538a08a1351e$var$isIterable(thing);
var $b487538a08a1351e$export$2e2bcd8739ae039 = {
    isArray: $b487538a08a1351e$var$isArray,
    isArrayBuffer: $b487538a08a1351e$var$isArrayBuffer,
    isBuffer: $b487538a08a1351e$var$isBuffer,
    isFormData: $b487538a08a1351e$var$isFormData,
    isArrayBufferView: $b487538a08a1351e$var$isArrayBufferView,
    isString: $b487538a08a1351e$var$isString,
    isNumber: $b487538a08a1351e$var$isNumber,
    isBoolean: $b487538a08a1351e$var$isBoolean,
    isObject: $b487538a08a1351e$var$isObject,
    isPlainObject: $b487538a08a1351e$var$isPlainObject,
    isEmptyObject: $b487538a08a1351e$var$isEmptyObject,
    isReadableStream: $b487538a08a1351e$var$isReadableStream,
    isRequest: $b487538a08a1351e$var$isRequest,
    isResponse: $b487538a08a1351e$var$isResponse,
    isHeaders: $b487538a08a1351e$var$isHeaders,
    isUndefined: $b487538a08a1351e$var$isUndefined,
    isDate: $b487538a08a1351e$var$isDate,
    isFile: $b487538a08a1351e$var$isFile,
    isReactNativeBlob: $b487538a08a1351e$var$isReactNativeBlob,
    isReactNative: $b487538a08a1351e$var$isReactNative,
    isBlob: $b487538a08a1351e$var$isBlob,
    isRegExp: $b487538a08a1351e$var$isRegExp,
    isFunction: $b487538a08a1351e$var$isFunction,
    isStream: $b487538a08a1351e$var$isStream,
    isURLSearchParams: $b487538a08a1351e$var$isURLSearchParams,
    isTypedArray: $b487538a08a1351e$var$isTypedArray,
    isFileList: $b487538a08a1351e$var$isFileList,
    forEach: $b487538a08a1351e$var$forEach,
    merge: $b487538a08a1351e$var$merge,
    extend: $b487538a08a1351e$var$extend,
    trim: $b487538a08a1351e$var$trim,
    stripBOM: $b487538a08a1351e$var$stripBOM,
    inherits: $b487538a08a1351e$var$inherits,
    toFlatObject: $b487538a08a1351e$var$toFlatObject,
    kindOf: $b487538a08a1351e$var$kindOf,
    kindOfTest: $b487538a08a1351e$var$kindOfTest,
    endsWith: $b487538a08a1351e$var$endsWith,
    toArray: $b487538a08a1351e$var$toArray,
    forEachEntry: $b487538a08a1351e$var$forEachEntry,
    matchAll: $b487538a08a1351e$var$matchAll,
    isHTMLForm: $b487538a08a1351e$var$isHTMLForm,
    hasOwnProperty: $b487538a08a1351e$var$hasOwnProperty,
    hasOwnProp: $b487538a08a1351e$var$hasOwnProperty,
    hasOwnInPrototypeChain: $b487538a08a1351e$var$hasOwnInPrototypeChain,
    getSafeProp: $b487538a08a1351e$var$getSafeProp,
    reduceDescriptors: $b487538a08a1351e$var$reduceDescriptors,
    freezeMethods: $b487538a08a1351e$var$freezeMethods,
    toObjectSet: $b487538a08a1351e$var$toObjectSet,
    toCamelCase: $b487538a08a1351e$var$toCamelCase,
    noop: $b487538a08a1351e$var$noop,
    toFiniteNumber: $b487538a08a1351e$var$toFiniteNumber,
    findKey: $b487538a08a1351e$var$findKey,
    global: $b487538a08a1351e$var$_global,
    isContextDefined: $b487538a08a1351e$var$isContextDefined,
    isSpecCompliantForm: $b487538a08a1351e$var$isSpecCompliantForm,
    toJSONObject: $b487538a08a1351e$var$toJSONObject,
    isAsyncFn: $b487538a08a1351e$var$isAsyncFn,
    isThenable: $b487538a08a1351e$var$isThenable,
    setImmediate: $b487538a08a1351e$var$_setImmediate,
    asap: $b487538a08a1351e$var$asap,
    isIterable: $b487538a08a1351e$var$isIterable,
    isSafeIterable: $b487538a08a1351e$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $07bfbf72940f8b09$var$ignoreDuplicateOf = (0, $b487538a08a1351e$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $07bfbf72940f8b09$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $07bfbf72940f8b09$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $630a485ed5b43d02$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $630a485ed5b43d02$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $630a485ed5b43d02$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $630a485ed5b43d02$var$sanitizeValue(value, invalidChars) {
    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$630a485ed5b43d02$var$sanitizeValue(item, invalidChars));
    return $630a485ed5b43d02$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $630a485ed5b43d02$export$9e344cffce061a22 = (value)=>$630a485ed5b43d02$var$sanitizeValue(value, $630a485ed5b43d02$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $630a485ed5b43d02$export$59dd66c2a12d8f62 = (value)=>$630a485ed5b43d02$var$sanitizeValue(value, $630a485ed5b43d02$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $630a485ed5b43d02$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $630a485ed5b43d02$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $3a63528aa42f3c9f$var$$internals = Symbol('internals');
function $3a63528aa42f3c9f$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $3a63528aa42f3c9f$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(value) ? value.map($3a63528aa42f3c9f$var$normalizeValue) : (0, $630a485ed5b43d02$export$9e344cffce061a22)(String(value));
}
function $3a63528aa42f3c9f$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $3a63528aa42f3c9f$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $3a63528aa42f3c9f$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $3a63528aa42f3c9f$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $3a63528aa42f3c9f$var$buildAccessors(obj, header) {
    const accessorName = (0, $b487538a08a1351e$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $3a63528aa42f3c9f$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $3a63528aa42f3c9f$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $b487538a08a1351e$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $3a63528aa42f3c9f$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$3a63528aa42f3c9f$var$isValidHeaderName(header)) setHeaders((0, $07bfbf72940f8b09$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isObject(header) && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $3a63528aa42f3c9f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $b487538a08a1351e$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $3a63528aa42f3c9f$var$parseTokens(value);
                if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $3a63528aa42f3c9f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $b487538a08a1351e$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $3a63528aa42f3c9f$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $3a63528aa42f3c9f$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $b487538a08a1351e$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $3a63528aa42f3c9f$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $3a63528aa42f3c9f$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $b487538a08a1351e$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $3a63528aa42f3c9f$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $3a63528aa42f3c9f$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $3a63528aa42f3c9f$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$3a63528aa42f3c9f$var$$internals] = this[$3a63528aa42f3c9f$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $3a63528aa42f3c9f$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $3a63528aa42f3c9f$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$3a63528aa42f3c9f$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $b487538a08a1351e$export$2e2bcd8739ae039).reduceDescriptors($3a63528aa42f3c9f$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $b487538a08a1351e$export$2e2bcd8739ae039).freezeMethods($3a63528aa42f3c9f$var$AxiosHeaders);
var $3a63528aa42f3c9f$export$2e2bcd8739ae039 = $3a63528aa42f3c9f$var$AxiosHeaders;


'use strict';
const $697573f19416c0aa$var$REDACTED = '[REDACTED ****]';
function $697573f19416c0aa$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $697573f19416c0aa$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isPlainObject(source) && $697573f19416c0aa$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $697573f19416c0aa$var$REDACTED : visit(value);
                if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $697573f19416c0aa$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $697573f19416c0aa$var$AxiosError(error.message, code || error.code, config, request, response);
        axiosError.cause = error;
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $697573f19416c0aa$var$redactConfig(config, redactKeys) : (0, $b487538a08a1351e$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$697573f19416c0aa$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$697573f19416c0aa$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$697573f19416c0aa$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$697573f19416c0aa$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$697573f19416c0aa$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$697573f19416c0aa$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$697573f19416c0aa$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$697573f19416c0aa$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$697573f19416c0aa$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$697573f19416c0aa$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$697573f19416c0aa$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$697573f19416c0aa$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$697573f19416c0aa$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$697573f19416c0aa$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $697573f19416c0aa$export$2e2bcd8739ae039 = $697573f19416c0aa$var$AxiosError;


// eslint-disable-next-line strict
var $b5d429f404daf86c$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $6244dbbcc75346bb$export$a143d493d941bafc;
var $6244dbbcc75346bb$export$e4cf37d7f6fb9e0a;
var $6244dbbcc75346bb$export$f99ded8fe4b79145;
var $6244dbbcc75346bb$export$599f31c3813fae4d;
'use strict';
var $dce3f776d68704ea$export$a48f0734ac7c2329;
var $dce3f776d68704ea$export$d622b2ad8d90c771;
var $dce3f776d68704ea$export$6100ba28696e12de;
'use strict';
$dce3f776d68704ea$export$a48f0734ac7c2329 = $dce3f776d68704ea$var$byteLength;
$dce3f776d68704ea$export$d622b2ad8d90c771 = $dce3f776d68704ea$var$toByteArray;
$dce3f776d68704ea$export$6100ba28696e12de = $dce3f776d68704ea$var$fromByteArray;
var $dce3f776d68704ea$var$lookup = [];
var $dce3f776d68704ea$var$revLookup = [];
var $dce3f776d68704ea$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $dce3f776d68704ea$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $dce3f776d68704ea$var$i = 0, $dce3f776d68704ea$var$len = $dce3f776d68704ea$var$code.length; $dce3f776d68704ea$var$i < $dce3f776d68704ea$var$len; ++$dce3f776d68704ea$var$i){
    $dce3f776d68704ea$var$lookup[$dce3f776d68704ea$var$i] = $dce3f776d68704ea$var$code[$dce3f776d68704ea$var$i];
    $dce3f776d68704ea$var$revLookup[$dce3f776d68704ea$var$code.charCodeAt($dce3f776d68704ea$var$i)] = $dce3f776d68704ea$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$dce3f776d68704ea$var$revLookup['-'.charCodeAt(0)] = 62;
$dce3f776d68704ea$var$revLookup['_'.charCodeAt(0)] = 63;
function $dce3f776d68704ea$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $dce3f776d68704ea$var$byteLength(b64) {
    var lens = $dce3f776d68704ea$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $dce3f776d68704ea$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $dce3f776d68704ea$var$toByteArray(b64) {
    var tmp;
    var lens = $dce3f776d68704ea$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $dce3f776d68704ea$var$Arr($dce3f776d68704ea$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $dce3f776d68704ea$var$revLookup[b64.charCodeAt(i)] << 18 | $dce3f776d68704ea$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $dce3f776d68704ea$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $dce3f776d68704ea$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $dce3f776d68704ea$var$revLookup[b64.charCodeAt(i)] << 2 | $dce3f776d68704ea$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $dce3f776d68704ea$var$revLookup[b64.charCodeAt(i)] << 10 | $dce3f776d68704ea$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $dce3f776d68704ea$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $dce3f776d68704ea$var$tripletToBase64(num) {
    return $dce3f776d68704ea$var$lookup[num >> 18 & 0x3F] + $dce3f776d68704ea$var$lookup[num >> 12 & 0x3F] + $dce3f776d68704ea$var$lookup[num >> 6 & 0x3F] + $dce3f776d68704ea$var$lookup[num & 0x3F];
}
function $dce3f776d68704ea$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($dce3f776d68704ea$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $dce3f776d68704ea$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($dce3f776d68704ea$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($dce3f776d68704ea$var$lookup[tmp >> 2] + $dce3f776d68704ea$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($dce3f776d68704ea$var$lookup[tmp >> 10] + $dce3f776d68704ea$var$lookup[tmp >> 4 & 0x3F] + $dce3f776d68704ea$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $959c83ad5005dc13$export$aafa59e2e03f2942;
var $959c83ad5005dc13$export$68d8715fc104d294;
$959c83ad5005dc13$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$959c83ad5005dc13$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $6244dbbcc75346bb$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6244dbbcc75346bb$export$a143d493d941bafc = $6244dbbcc75346bb$var$Buffer;
$6244dbbcc75346bb$export$e4cf37d7f6fb9e0a = $6244dbbcc75346bb$var$SlowBuffer;
$6244dbbcc75346bb$export$f99ded8fe4b79145 = 50;
const $6244dbbcc75346bb$var$K_MAX_LENGTH = 0x7fffffff;
$6244dbbcc75346bb$export$599f31c3813fae4d = $6244dbbcc75346bb$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6244dbbcc75346bb$var$Buffer.TYPED_ARRAY_SUPPORT = $6244dbbcc75346bb$var$typedArraySupport();
if (!$6244dbbcc75346bb$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6244dbbcc75346bb$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6244dbbcc75346bb$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$6244dbbcc75346bb$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6244dbbcc75346bb$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$6244dbbcc75346bb$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6244dbbcc75346bb$var$createBuffer(length) {
    if (length > $6244dbbcc75346bb$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6244dbbcc75346bb$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6244dbbcc75346bb$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6244dbbcc75346bb$var$allocUnsafe(arg);
    }
    return $6244dbbcc75346bb$var$from(arg, encodingOrOffset, length);
}
$6244dbbcc75346bb$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6244dbbcc75346bb$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6244dbbcc75346bb$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6244dbbcc75346bb$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($6244dbbcc75346bb$var$isInstance(value, ArrayBuffer) || value && $6244dbbcc75346bb$var$isInstance(value.buffer, ArrayBuffer)) return $6244dbbcc75346bb$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6244dbbcc75346bb$var$isInstance(value, SharedArrayBuffer) || value && $6244dbbcc75346bb$var$isInstance(value.buffer, SharedArrayBuffer))) return $6244dbbcc75346bb$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6244dbbcc75346bb$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $6244dbbcc75346bb$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6244dbbcc75346bb$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6244dbbcc75346bb$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6244dbbcc75346bb$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6244dbbcc75346bb$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6244dbbcc75346bb$var$Buffer, Uint8Array);
function $6244dbbcc75346bb$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6244dbbcc75346bb$var$alloc(size, fill, encoding) {
    $6244dbbcc75346bb$var$assertSize(size);
    if (size <= 0) return $6244dbbcc75346bb$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6244dbbcc75346bb$var$createBuffer(size).fill(fill, encoding) : $6244dbbcc75346bb$var$createBuffer(size).fill(fill);
    return $6244dbbcc75346bb$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6244dbbcc75346bb$var$Buffer.alloc = function(size, fill, encoding) {
    return $6244dbbcc75346bb$var$alloc(size, fill, encoding);
};
function $6244dbbcc75346bb$var$allocUnsafe(size) {
    $6244dbbcc75346bb$var$assertSize(size);
    return $6244dbbcc75346bb$var$createBuffer(size < 0 ? 0 : $6244dbbcc75346bb$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6244dbbcc75346bb$var$Buffer.allocUnsafe = function(size) {
    return $6244dbbcc75346bb$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6244dbbcc75346bb$var$Buffer.allocUnsafeSlow = function(size) {
    return $6244dbbcc75346bb$var$allocUnsafe(size);
};
function $6244dbbcc75346bb$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6244dbbcc75346bb$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $6244dbbcc75346bb$var$byteLength(string, encoding) | 0;
    let buf = $6244dbbcc75346bb$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6244dbbcc75346bb$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $6244dbbcc75346bb$var$checked(array.length) | 0;
    const buf = $6244dbbcc75346bb$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6244dbbcc75346bb$var$fromArrayView(arrayView) {
    if ($6244dbbcc75346bb$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $6244dbbcc75346bb$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6244dbbcc75346bb$var$fromArrayLike(arrayView);
}
function $6244dbbcc75346bb$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6244dbbcc75346bb$var$Buffer.prototype);
    return buf;
}
function $6244dbbcc75346bb$var$fromObject(obj) {
    if ($6244dbbcc75346bb$var$Buffer.isBuffer(obj)) {
        const len = $6244dbbcc75346bb$var$checked(obj.length) | 0;
        const buf = $6244dbbcc75346bb$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6244dbbcc75346bb$var$numberIsNaN(obj.length)) return $6244dbbcc75346bb$var$createBuffer(0);
        return $6244dbbcc75346bb$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6244dbbcc75346bb$var$fromArrayLike(obj.data);
}
function $6244dbbcc75346bb$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6244dbbcc75346bb$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6244dbbcc75346bb$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6244dbbcc75346bb$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6244dbbcc75346bb$var$Buffer.alloc(+length);
}
$6244dbbcc75346bb$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6244dbbcc75346bb$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6244dbbcc75346bb$var$Buffer.compare = function compare(a, b) {
    if ($6244dbbcc75346bb$var$isInstance(a, Uint8Array)) a = $6244dbbcc75346bb$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6244dbbcc75346bb$var$isInstance(b, Uint8Array)) b = $6244dbbcc75346bb$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6244dbbcc75346bb$var$Buffer.isBuffer(a) || !$6244dbbcc75346bb$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6244dbbcc75346bb$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6244dbbcc75346bb$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6244dbbcc75346bb$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $6244dbbcc75346bb$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($6244dbbcc75346bb$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6244dbbcc75346bb$var$Buffer.isBuffer(buf)) buf = $6244dbbcc75346bb$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6244dbbcc75346bb$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6244dbbcc75346bb$var$byteLength(string, encoding) {
    if ($6244dbbcc75346bb$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6244dbbcc75346bb$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6244dbbcc75346bb$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6244dbbcc75346bb$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6244dbbcc75346bb$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6244dbbcc75346bb$var$Buffer.byteLength = $6244dbbcc75346bb$var$byteLength;
function $6244dbbcc75346bb$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6244dbbcc75346bb$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6244dbbcc75346bb$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6244dbbcc75346bb$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6244dbbcc75346bb$var$latin1Slice(this, start, end);
        case 'base64':
            return $6244dbbcc75346bb$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6244dbbcc75346bb$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6244dbbcc75346bb$var$Buffer.prototype._isBuffer = true;
function $6244dbbcc75346bb$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6244dbbcc75346bb$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$6244dbbcc75346bb$var$swap(this, i, i + 1);
    return this;
};
$6244dbbcc75346bb$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $6244dbbcc75346bb$var$swap(this, i, i + 3);
        $6244dbbcc75346bb$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6244dbbcc75346bb$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $6244dbbcc75346bb$var$swap(this, i, i + 7);
        $6244dbbcc75346bb$var$swap(this, i + 1, i + 6);
        $6244dbbcc75346bb$var$swap(this, i + 2, i + 5);
        $6244dbbcc75346bb$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6244dbbcc75346bb$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6244dbbcc75346bb$var$utf8Slice(this, 0, length);
    return $6244dbbcc75346bb$var$slowToString.apply(this, arguments);
};
$6244dbbcc75346bb$var$Buffer.prototype.toLocaleString = $6244dbbcc75346bb$var$Buffer.prototype.toString;
$6244dbbcc75346bb$var$Buffer.prototype.equals = function equals(b) {
    if (!$6244dbbcc75346bb$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6244dbbcc75346bb$var$Buffer.compare(this, b) === 0;
};
$6244dbbcc75346bb$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $6244dbbcc75346bb$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6244dbbcc75346bb$var$customInspectSymbol) $6244dbbcc75346bb$var$Buffer.prototype[$6244dbbcc75346bb$var$customInspectSymbol] = $6244dbbcc75346bb$var$Buffer.prototype.inspect;
$6244dbbcc75346bb$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6244dbbcc75346bb$var$isInstance(target, Uint8Array)) target = $6244dbbcc75346bb$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6244dbbcc75346bb$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6244dbbcc75346bb$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6244dbbcc75346bb$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6244dbbcc75346bb$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6244dbbcc75346bb$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6244dbbcc75346bb$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6244dbbcc75346bb$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6244dbbcc75346bb$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6244dbbcc75346bb$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6244dbbcc75346bb$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6244dbbcc75346bb$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6244dbbcc75346bb$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6244dbbcc75346bb$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6244dbbcc75346bb$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6244dbbcc75346bb$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6244dbbcc75346bb$var$utf8Write(buf, string, offset, length) {
    return $6244dbbcc75346bb$var$blitBuffer($6244dbbcc75346bb$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6244dbbcc75346bb$var$asciiWrite(buf, string, offset, length) {
    return $6244dbbcc75346bb$var$blitBuffer($6244dbbcc75346bb$var$asciiToBytes(string), buf, offset, length);
}
function $6244dbbcc75346bb$var$base64Write(buf, string, offset, length) {
    return $6244dbbcc75346bb$var$blitBuffer($6244dbbcc75346bb$var$base64ToBytes(string), buf, offset, length);
}
function $6244dbbcc75346bb$var$ucs2Write(buf, string, offset, length) {
    return $6244dbbcc75346bb$var$blitBuffer($6244dbbcc75346bb$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6244dbbcc75346bb$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6244dbbcc75346bb$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6244dbbcc75346bb$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6244dbbcc75346bb$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6244dbbcc75346bb$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6244dbbcc75346bb$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6244dbbcc75346bb$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6244dbbcc75346bb$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $dce3f776d68704ea$export$6100ba28696e12de(buf);
    else return $dce3f776d68704ea$export$6100ba28696e12de(buf.slice(start, end));
}
function $6244dbbcc75346bb$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6244dbbcc75346bb$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $6244dbbcc75346bb$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6244dbbcc75346bb$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $6244dbbcc75346bb$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6244dbbcc75346bb$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6244dbbcc75346bb$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6244dbbcc75346bb$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6244dbbcc75346bb$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $6244dbbcc75346bb$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6244dbbcc75346bb$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6244dbbcc75346bb$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6244dbbcc75346bb$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6244dbbcc75346bb$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6244dbbcc75346bb$var$Buffer.prototype.readUintLE = $6244dbbcc75346bb$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6244dbbcc75346bb$var$Buffer.prototype.readUintBE = $6244dbbcc75346bb$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6244dbbcc75346bb$var$Buffer.prototype.readUint8 = $6244dbbcc75346bb$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6244dbbcc75346bb$var$Buffer.prototype.readUint16LE = $6244dbbcc75346bb$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6244dbbcc75346bb$var$Buffer.prototype.readUint16BE = $6244dbbcc75346bb$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6244dbbcc75346bb$var$Buffer.prototype.readUint32LE = $6244dbbcc75346bb$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6244dbbcc75346bb$var$Buffer.prototype.readUint32BE = $6244dbbcc75346bb$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6244dbbcc75346bb$var$Buffer.prototype.readBigUInt64LE = $6244dbbcc75346bb$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6244dbbcc75346bb$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6244dbbcc75346bb$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6244dbbcc75346bb$var$Buffer.prototype.readBigUInt64BE = $6244dbbcc75346bb$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6244dbbcc75346bb$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6244dbbcc75346bb$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6244dbbcc75346bb$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6244dbbcc75346bb$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6244dbbcc75346bb$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6244dbbcc75346bb$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6244dbbcc75346bb$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6244dbbcc75346bb$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6244dbbcc75346bb$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6244dbbcc75346bb$var$Buffer.prototype.readBigInt64LE = $6244dbbcc75346bb$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6244dbbcc75346bb$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6244dbbcc75346bb$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$6244dbbcc75346bb$var$Buffer.prototype.readBigInt64BE = $6244dbbcc75346bb$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6244dbbcc75346bb$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $6244dbbcc75346bb$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$6244dbbcc75346bb$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 4, this.length);
    return $959c83ad5005dc13$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$6244dbbcc75346bb$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 4, this.length);
    return $959c83ad5005dc13$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$6244dbbcc75346bb$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 8, this.length);
    return $959c83ad5005dc13$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$6244dbbcc75346bb$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkOffset(offset, 8, this.length);
    return $959c83ad5005dc13$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $6244dbbcc75346bb$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6244dbbcc75346bb$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6244dbbcc75346bb$var$Buffer.prototype.writeUintLE = $6244dbbcc75346bb$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6244dbbcc75346bb$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeUintBE = $6244dbbcc75346bb$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6244dbbcc75346bb$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeUint8 = $6244dbbcc75346bb$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeUint16LE = $6244dbbcc75346bb$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeUint16BE = $6244dbbcc75346bb$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeUint32LE = $6244dbbcc75346bb$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeUint32BE = $6244dbbcc75346bb$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6244dbbcc75346bb$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6244dbbcc75346bb$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6244dbbcc75346bb$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6244dbbcc75346bb$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6244dbbcc75346bb$var$Buffer.prototype.writeBigUInt64LE = $6244dbbcc75346bb$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $6244dbbcc75346bb$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6244dbbcc75346bb$var$Buffer.prototype.writeBigUInt64BE = $6244dbbcc75346bb$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $6244dbbcc75346bb$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6244dbbcc75346bb$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6244dbbcc75346bb$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $6244dbbcc75346bb$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6244dbbcc75346bb$var$Buffer.prototype.writeBigInt64LE = $6244dbbcc75346bb$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $6244dbbcc75346bb$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6244dbbcc75346bb$var$Buffer.prototype.writeBigInt64BE = $6244dbbcc75346bb$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $6244dbbcc75346bb$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6244dbbcc75346bb$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6244dbbcc75346bb$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $959c83ad5005dc13$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6244dbbcc75346bb$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6244dbbcc75346bb$var$writeFloat(this, value, offset, true, noAssert);
};
$6244dbbcc75346bb$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6244dbbcc75346bb$var$writeFloat(this, value, offset, false, noAssert);
};
function $6244dbbcc75346bb$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6244dbbcc75346bb$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $959c83ad5005dc13$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6244dbbcc75346bb$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6244dbbcc75346bb$var$writeDouble(this, value, offset, true, noAssert);
};
$6244dbbcc75346bb$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6244dbbcc75346bb$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6244dbbcc75346bb$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6244dbbcc75346bb$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6244dbbcc75346bb$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6244dbbcc75346bb$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $6244dbbcc75346bb$var$Buffer.isBuffer(val) ? val : $6244dbbcc75346bb$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $6244dbbcc75346bb$var$errors = {};
function $6244dbbcc75346bb$var$E(sym, getMessage, Base) {
    $6244dbbcc75346bb$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$6244dbbcc75346bb$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6244dbbcc75346bb$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$6244dbbcc75346bb$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $6244dbbcc75346bb$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $6244dbbcc75346bb$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $6244dbbcc75346bb$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $6244dbbcc75346bb$var$checkBounds(buf, offset, byteLength) {
    $6244dbbcc75346bb$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6244dbbcc75346bb$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6244dbbcc75346bb$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $6244dbbcc75346bb$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6244dbbcc75346bb$var$checkBounds(buf, offset, byteLength);
}
function $6244dbbcc75346bb$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6244dbbcc75346bb$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6244dbbcc75346bb$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6244dbbcc75346bb$var$validateNumber(value, type);
        throw new $6244dbbcc75346bb$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6244dbbcc75346bb$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6244dbbcc75346bb$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $6244dbbcc75346bb$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6244dbbcc75346bb$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6244dbbcc75346bb$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6244dbbcc75346bb$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6244dbbcc75346bb$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6244dbbcc75346bb$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6244dbbcc75346bb$var$base64ToBytes(str) {
    return $dce3f776d68704ea$export$d622b2ad8d90c771($6244dbbcc75346bb$var$base64clean(str));
}
function $6244dbbcc75346bb$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6244dbbcc75346bb$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6244dbbcc75346bb$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $6244dbbcc75346bb$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6244dbbcc75346bb$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6244dbbcc75346bb$var$BufferBigIntNotDefined : fn;
}
function $6244dbbcc75346bb$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $412f318447e877cd$require$Buffer = $6244dbbcc75346bb$export$a143d493d941bafc;
'use strict';
const $412f318447e877cd$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $412f318447e877cd$var$isVisitable(thing) {
    return (0, $b487538a08a1351e$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $412f318447e877cd$var$removeBrackets(key) {
    return (0, $b487538a08a1351e$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $412f318447e877cd$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $412f318447e877cd$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $412f318447e877cd$var$isFlatArray(arr) {
    return (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(arr) && !arr.some($412f318447e877cd$var$isVisitable);
}
const $412f318447e877cd$var$predicates = (0, $b487538a08a1351e$export$2e2bcd8739ae039).toFlatObject((0, $b487538a08a1351e$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $412f318447e877cd$var$toFormData(obj, formData, options) {
    if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $b5d429f404daf86c$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $b487538a08a1351e$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $412f318447e877cd$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $412f318447e877cd$require$Buffer.from(value);
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isReactNative(formData) && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($412f318447e877cd$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(value) && $412f318447e877cd$var$isFlatArray(value) || ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFileList(value) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $b487538a08a1351e$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $412f318447e877cd$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $412f318447e877cd$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($412f318447e877cd$var$isVisitable(value)) return true;
        formData.append($412f318447e877cd$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($412f318447e877cd$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $412f318447e877cd$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $412f318447e877cd$export$2e2bcd8739ae039 = $412f318447e877cd$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $ef380d28b1ab23a5$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $ef380d28b1ab23a5$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $412f318447e877cd$export$2e2bcd8739ae039)(params, this, options);
}
const $ef380d28b1ab23a5$var$prototype = $ef380d28b1ab23a5$var$AxiosURLSearchParams.prototype;
$ef380d28b1ab23a5$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$ef380d28b1ab23a5$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $ef380d28b1ab23a5$var$encode);
    } : $ef380d28b1ab23a5$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $ef380d28b1ab23a5$export$2e2bcd8739ae039 = $ef380d28b1ab23a5$var$AxiosURLSearchParams;


'use strict';
function $46a9d0d95b84a102$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $46a9d0d95b84a102$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    const _options = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $b487538a08a1351e$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $46a9d0d95b84a102$export$c564cdbbe6da493;
    const serializeFn = (0, $b487538a08a1351e$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $ef380d28b1ab23a5$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $7ebd5cf73800538b$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $7ebd5cf73800538b$export$2e2bcd8739ae039 = $7ebd5cf73800538b$var$InterceptorManager;





'use strict';
var $68a27a90af53459c$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






'use strict';
var $9adbf055052d0e5f$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $ef380d28b1ab23a5$export$2e2bcd8739ae039);


'use strict';
var $73aaba707559687a$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $6991dbeac2087bbe$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $b352acafeb3040bf$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9adbf055052d0e5f$export$2e2bcd8739ae039,
        FormData: $73aaba707559687a$export$2e2bcd8739ae039,
        Blob: $6991dbeac2087bbe$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $46c682bc7e7515f9$exports = {};

$parcel$export($46c682bc7e7515f9$exports, "hasBrowserEnv", () => $46c682bc7e7515f9$export$c4996c4b7b93b0bf);
$parcel$export($46c682bc7e7515f9$exports, "navigator", () => $46c682bc7e7515f9$export$ec7c8efa7f5790ae);
$parcel$export($46c682bc7e7515f9$exports, "hasStandardBrowserEnv", () => $46c682bc7e7515f9$export$c0bcc9250309d66);
$parcel$export($46c682bc7e7515f9$exports, "hasStandardBrowserWebWorkerEnv", () => $46c682bc7e7515f9$export$c81692cf5af97dac);
$parcel$export($46c682bc7e7515f9$exports, "origin", () => $46c682bc7e7515f9$export$f710a83a91838a36);
const $46c682bc7e7515f9$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $46c682bc7e7515f9$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $46c682bc7e7515f9$export$c0bcc9250309d66 = $46c682bc7e7515f9$export$c4996c4b7b93b0bf && (!$46c682bc7e7515f9$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($46c682bc7e7515f9$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $46c682bc7e7515f9$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $46c682bc7e7515f9$export$f710a83a91838a36 = $46c682bc7e7515f9$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $256c565c39f621a6$export$2e2bcd8739ae039 = {
    ...$46c682bc7e7515f9$exports,
    ...(0, $b352acafeb3040bf$export$2e2bcd8739ae039)
};


'use strict';
function $6bbf4b78557c377b$export$2e2bcd8739ae039(data, options) {
    return (0, $412f318447e877cd$export$2e2bcd8739ae039)(data, new (0, $256c565c39f621a6$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $256c565c39f621a6$export$2e2bcd8739ae039).isNode && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






'use strict';
const $60b6ebd2215ac304$var$MAX_DEPTH = (0, $412f318447e877cd$export$659081b45d03227d);
function $60b6ebd2215ac304$var$throwIfDepthExceeded(index) {
    if (index > $60b6ebd2215ac304$var$MAX_DEPTH) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $60b6ebd2215ac304$var$MAX_DEPTH, (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $60b6ebd2215ac304$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    const path = [];
    const pattern = /\w+|\[(\w*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $60b6ebd2215ac304$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $60b6ebd2215ac304$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $60b6ebd2215ac304$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $60b6ebd2215ac304$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $b487538a08a1351e$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $60b6ebd2215ac304$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFormData(formData) && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($60b6ebd2215ac304$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $60b6ebd2215ac304$export$2e2bcd8739ae039 = $60b6ebd2215ac304$var$formDataToJSON;


'use strict';
const $966890dfa02571bc$var$own = (obj, key)=>obj != null && (0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $966890dfa02571bc$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $b487538a08a1351e$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $966890dfa02571bc$var$defaults = {
    transitional: (0, $68a27a90af53459c$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $60b6ebd2215ac304$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isBuffer(data) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isStream(data) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isFile(data) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isBlob(data) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $966890dfa02571bc$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $6bbf4b78557c377b$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $966890dfa02571bc$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $412f318447e877cd$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $966890dfa02571bc$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $966890dfa02571bc$var$own(this, 'transitional') || $966890dfa02571bc$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $966890dfa02571bc$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isResponse(data) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $966890dfa02571bc$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $697573f19416c0aa$export$2e2bcd8739ae039).from(e, (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $966890dfa02571bc$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $256c565c39f621a6$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $256c565c39f621a6$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $966890dfa02571bc$var$defaults.headers[method] = {};
});
var $966890dfa02571bc$export$2e2bcd8739ae039 = $966890dfa02571bc$var$defaults;



'use strict';
function $d763a51e15574565$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $966890dfa02571bc$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $ccb703ad03b087d8$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $b0680ace6420d8fc$var$CanceledError extends (0, $697573f19416c0aa$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $b0680ace6420d8fc$export$2e2bcd8739ae039 = $b0680ace6420d8fc$var$CanceledError;







'use strict';
function $54cc3531aeac82f1$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $a9e2cdf14cb0dd26$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $b3f3971b83aac102$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $b3f3971b83aac102$export$2e2bcd8739ae039 = $b3f3971b83aac102$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $afb7f22f4508f363$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $afb7f22f4508f363$export$2e2bcd8739ae039 = $afb7f22f4508f363$var$throttle;



const $55d55c39e3554650$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $b3f3971b83aac102$export$2e2bcd8739ae039)(50, 250);
    return (0, $afb7f22f4508f363$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $55d55c39e3554650$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $55d55c39e3554650$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $b487538a08a1351e$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $554880082ab6b6c0$export$2e2bcd8739ae039 = (0, $256c565c39f621a6$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $256c565c39f621a6$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $256c565c39f621a6$export$2e2bcd8739ae039).origin), (0, $256c565c39f621a6$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $256c565c39f621a6$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $a25c3848e2437e6c$export$2e2bcd8739ae039 = (0, $256c565c39f621a6$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return decodeURIComponent(cookie.slice(eq + 1));
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $afbc357b71843c08$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $6a2721704817554b$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
const $6793fa3bb934c644$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $6793fa3bb934c644$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $6793fa3bb934c644$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $6793fa3bb934c644$var$normalizeURLForProtocolCheck(url) {
    return $6793fa3bb934c644$var$stripLeadingC0ControlOrSpace(url).replace($6793fa3bb934c644$var$httpProtocolControlCharacters, '');
}
function $6793fa3bb934c644$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string' && $6793fa3bb934c644$var$malformedHttpProtocol.test($6793fa3bb934c644$var$normalizeURLForProtocolCheck(url))) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Invalid URL: missing "//" after protocol', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
}
function $6793fa3bb934c644$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $6793fa3bb934c644$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $afbc357b71843c08$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $6793fa3bb934c644$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $6a2721704817554b$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




'use strict';
const $0be56928fb9be645$var$headersToObject = (thing)=>thing instanceof (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $0be56928fb9be645$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isPlainObject(target) && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $b487538a08a1351e$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $b487538a08a1351e$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($0be56928fb9be645$var$headersToObject(a), $0be56928fb9be645$var$headersToObject(b), prop, true)
    };
    (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}




const $2214552615fd75ff$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $2214552615fd75ff$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders).forEach(([key, val])=>{
        if ($2214552615fd75ff$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $2214552615fd75ff$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $2214552615fd75ff$var$resolveConfig(config) {
    const newConfig = (0, $0be56928fb9be645$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $46a9d0d95b84a102$export$2e2bcd8739ae039)((0, $6793fa3bb934c644$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $b487538a08a1351e$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $b487538a08a1351e$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $2214552615fd75ff$var$encodeUTF8(password) : '')));
    }
    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $256c565c39f621a6$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $256c565c39f621a6$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $2214552615fd75ff$var$setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $256c565c39f621a6$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $554880082ab6b6c0$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $a25c3848e2437e6c$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $2214552615fd75ff$export$2e2bcd8739ae039 = $2214552615fd75ff$var$resolveConfig;



const $cd5dc8810b491205$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $cd5dc8810b491205$export$2e2bcd8739ae039 = $cd5dc8810b491205$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $2214552615fd75ff$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $54cc3531aeac82f1$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Request aborted', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $697573f19416c0aa$export$2e2bcd8739ae039)(msg, (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $68a27a90af53459c$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $697573f19416c0aa$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $697573f19416c0aa$export$2e2bcd8739ae039).ETIMEDOUT : (0, $697573f19416c0aa$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach((0, $630a485ed5b43d02$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $55d55c39e3554650$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $55d55c39e3554650$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $b0680ace6420d8fc$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $a9e2cdf14cb0dd26$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $256c565c39f621a6$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $dcb64f80d7958b2e$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $697573f19416c0aa$export$2e2bcd8739ae039) ? err : new (0, $b0680ace6420d8fc$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $697573f19416c0aa$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $697573f19416c0aa$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $b487538a08a1351e$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $dcb64f80d7958b2e$export$2e2bcd8739ae039 = $dcb64f80d7958b2e$var$composeSignals;


const $7474fff59bd0154d$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $7474fff59bd0154d$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $7474fff59bd0154d$var$readStream(iterable))yield* $7474fff59bd0154d$export$71b051935044bd5d(chunk, chunkSize);
};
const $7474fff59bd0154d$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $7474fff59bd0154d$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $7474fff59bd0154d$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: compute the exact percent-decoded UTF-8 byte length.
 *
 * @param {string} url
 * @returns {number}
 */ const $bb07c1de466cede5$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $bb07c1de466cede5$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $bb07c1de466cede5$var$isHexDigit(str.charCodeAt(i + 1)) && $bb07c1de466cede5$var$isHexDigit(str.charCodeAt(i + 2));
function $bb07c1de466cede5$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = $bb07c1de466cede5$var$isHexDigit(a) && $bb07c1de466cede5$var$isHexDigit(b);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $bb07c1de466cede5$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $a503074bfd861541$export$a4ad2735b021c132 = "1.18.0";



const $a0cbd28a460a32c1$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $a0cbd28a460a32c1$var$isFunction } = (0, $b487538a08a1351e$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $a0cbd28a460a32c1$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $a0cbd28a460a32c1$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $a0cbd28a460a32c1$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $a0cbd28a460a32c1$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $a0cbd28a460a32c1$var$factory = (env)=>{
    const globalObject = (0, $b487538a08a1351e$export$2e2bcd8739ae039).global !== undefined && (0, $b487538a08a1351e$export$2e2bcd8739ae039).global !== null ? (0, $b487538a08a1351e$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $b487538a08a1351e$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $a0cbd28a460a32c1$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $a0cbd28a460a32c1$var$isFunction(Request);
    const isResponseSupported = $a0cbd28a460a32c1$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $a0cbd28a460a32c1$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $a0cbd28a460a32c1$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $256c565c39f621a6$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $a0cbd28a460a32c1$var$test(()=>(0, $b487538a08a1351e$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $256c565c39f621a6$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $b487538a08a1351e$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $2214552615fd75ff$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $dcb64f80d7958b2e$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $b487538a08a1351e$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $b487538a08a1351e$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($a0cbd28a460a32c1$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $256c565c39f621a6$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $a0cbd28a460a32c1$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $a0cbd28a460a32c1$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($a0cbd28a460a32c1$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $bb07c1de466cede5$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isReadableStream(data) || (0, $b487538a08a1351e$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $7474fff59bd0154d$export$b0119225647bd83)(stream, $a0cbd28a460a32c1$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $55d55c39e3554650$export$d9fadd12586c18d6)(requestContentLength, (0, $55d55c39e3554650$export$c1b28109d46c3592)((0, $55d55c39e3554650$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $b487538a08a1351e$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $a503074bfd861541$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $630a485ed5b43d02$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $b487538a08a1351e$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $b487538a08a1351e$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $55d55c39e3554650$export$d9fadd12586c18d6)(responseContentLength, (0, $55d55c39e3554650$export$c1b28109d46c3592)((0, $55d55c39e3554650$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $7474fff59bd0154d$export$b0119225647bd83)(response.body, $a0cbd28a460a32c1$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $b487538a08a1351e$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $54cc3531aeac82f1$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $697573f19416c0aa$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                err !== canceledError && (canceledError.cause = err);
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $697573f19416c0aa$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Network Error', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response), {
                cause: err.cause || err
            });
            throw (0, $697573f19416c0aa$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $a0cbd28a460a32c1$var$seedCache = new Map();
const $a0cbd28a460a32c1$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $a0cbd28a460a32c1$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $a0cbd28a460a32c1$var$factory(env));
        map = target;
    }
    return target;
};
const $a0cbd28a460a32c1$var$adapter = $a0cbd28a460a32c1$export$3105c6651375d4fa();
var $a0cbd28a460a32c1$export$2e2bcd8739ae039 = $a0cbd28a460a32c1$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $3562c2f83e7e3bc3$var$knownAdapters = {
    http: (0, $b5d429f404daf86c$export$2e2bcd8739ae039),
    xhr: (0, $cd5dc8810b491205$export$2e2bcd8739ae039),
    fetch: {
        get: $a0cbd28a460a32c1$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach($3562c2f83e7e3bc3$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $3562c2f83e7e3bc3$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $3562c2f83e7e3bc3$var$isResolvedHandle = (adapter)=>(0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $3562c2f83e7e3bc3$var$getAdapter(adapters, config) {
    adapters = (0, $b487538a08a1351e$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$3562c2f83e7e3bc3$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $3562c2f83e7e3bc3$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($3562c2f83e7e3bc3$var$renderReason).join('\n') : ' ' + $3562c2f83e7e3bc3$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $3562c2f83e7e3bc3$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $3562c2f83e7e3bc3$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $3562c2f83e7e3bc3$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $262f59d035a6e030$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $b0680ace6420d8fc$export$2e2bcd8739ae039)(null, config);
}
function $262f59d035a6e030$export$2e2bcd8739ae039(config) {
    $262f59d035a6e030$var$throwIfCancellationRequested(config);
    config.headers = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $d763a51e15574565$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $3562c2f83e7e3bc3$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $966890dfa02571bc$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $262f59d035a6e030$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $d763a51e15574565$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ccb703ad03b087d8$export$2e2bcd8739ae039)(reason)) {
            $262f59d035a6e030$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $d763a51e15574565$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $eba1f65cff107c92$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $eba1f65cff107c92$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $eba1f65cff107c92$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $eba1f65cff107c92$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $a503074bfd861541$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$eba1f65cff107c92$var$deprecatedWarnings[opt]) {
            $eba1f65cff107c92$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$eba1f65cff107c92$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $eba1f65cff107c92$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('options must be an object', (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $697573f19416c0aa$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $697573f19416c0aa$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $eba1f65cff107c92$export$2e2bcd8739ae039 = {
    assertOptions: $eba1f65cff107c92$var$assertOptions,
    validators: $eba1f65cff107c92$var$validators
};




'use strict';
const $48ad44a7479d3275$var$validators = (0, $eba1f65cff107c92$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $48ad44a7479d3275$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $7ebd5cf73800538b$export$2e2bcd8739ae039)(),
            response: new (0, $7ebd5cf73800538b$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $0be56928fb9be645$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $eba1f65cff107c92$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $48ad44a7479d3275$var$validators.transitional($48ad44a7479d3275$var$validators.boolean),
            forcedJSONParsing: $48ad44a7479d3275$var$validators.transitional($48ad44a7479d3275$var$validators.boolean),
            clarifyTimeoutError: $48ad44a7479d3275$var$validators.transitional($48ad44a7479d3275$var$validators.boolean),
            legacyInterceptorReqResOrdering: $48ad44a7479d3275$var$validators.transitional($48ad44a7479d3275$var$validators.boolean),
            advertiseZstdAcceptEncoding: $48ad44a7479d3275$var$validators.transitional($48ad44a7479d3275$var$validators.boolean),
            validateStatusUndefinedResolves: $48ad44a7479d3275$var$validators.transitional($48ad44a7479d3275$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $b487538a08a1351e$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $eba1f65cff107c92$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $48ad44a7479d3275$var$validators.function,
                serialize: $48ad44a7479d3275$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $eba1f65cff107c92$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $48ad44a7479d3275$var$validators.spelling('baseURL'),
            withXsrfToken: $48ad44a7479d3275$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $b487538a08a1351e$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $68a27a90af53459c$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $262f59d035a6e030$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $262f59d035a6e030$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $0be56928fb9be645$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $6793fa3bb934c644$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $46a9d0d95b84a102$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $48ad44a7479d3275$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $0be56928fb9be645$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $b487538a08a1351e$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $b487538a08a1351e$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $0be56928fb9be645$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $48ad44a7479d3275$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $48ad44a7479d3275$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $48ad44a7479d3275$export$2e2bcd8739ae039 = $48ad44a7479d3275$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $ef3c4b272ec3103c$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $b0680ace6420d8fc$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $ef3c4b272ec3103c$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $ef3c4b272ec3103c$export$2e2bcd8739ae039 = $ef3c4b272ec3103c$var$CancelToken;






'use strict';
function $e2dd7599cdcdf8c0$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $75b444234730cb6a$export$2e2bcd8739ae039(payload) {
    return (0, $b487538a08a1351e$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $d8b478c6a837fd39$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($d8b478c6a837fd39$var$HttpStatusCode).forEach(([key, value])=>{
    $d8b478c6a837fd39$var$HttpStatusCode[value] = key;
});
var $d8b478c6a837fd39$export$2e2bcd8739ae039 = $d8b478c6a837fd39$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $f8a4f6b3df7eeb0a$var$createInstance(defaultConfig) {
    const context = new (0, $48ad44a7479d3275$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $76abc644fe90a927$export$2e2bcd8739ae039)((0, $48ad44a7479d3275$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $b487538a08a1351e$export$2e2bcd8739ae039).extend(instance, (0, $48ad44a7479d3275$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $b487538a08a1351e$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $f8a4f6b3df7eeb0a$var$createInstance((0, $0be56928fb9be645$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $f8a4f6b3df7eeb0a$var$axios = $f8a4f6b3df7eeb0a$var$createInstance((0, $966890dfa02571bc$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$f8a4f6b3df7eeb0a$var$axios.Axios = (0, $48ad44a7479d3275$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$f8a4f6b3df7eeb0a$var$axios.CanceledError = (0, $b0680ace6420d8fc$export$2e2bcd8739ae039);
$f8a4f6b3df7eeb0a$var$axios.CancelToken = (0, $ef3c4b272ec3103c$export$2e2bcd8739ae039);
$f8a4f6b3df7eeb0a$var$axios.isCancel = (0, $ccb703ad03b087d8$export$2e2bcd8739ae039);
$f8a4f6b3df7eeb0a$var$axios.VERSION = (0, $a503074bfd861541$export$a4ad2735b021c132);
$f8a4f6b3df7eeb0a$var$axios.toFormData = (0, $412f318447e877cd$export$2e2bcd8739ae039);
// Expose AxiosError class
$f8a4f6b3df7eeb0a$var$axios.AxiosError = (0, $697573f19416c0aa$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$f8a4f6b3df7eeb0a$var$axios.Cancel = $f8a4f6b3df7eeb0a$var$axios.CanceledError;
// Expose all/spread
$f8a4f6b3df7eeb0a$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$f8a4f6b3df7eeb0a$var$axios.spread = (0, $e2dd7599cdcdf8c0$export$2e2bcd8739ae039);
// Expose isAxiosError
$f8a4f6b3df7eeb0a$var$axios.isAxiosError = (0, $75b444234730cb6a$export$2e2bcd8739ae039);
// Expose mergeConfig
$f8a4f6b3df7eeb0a$var$axios.mergeConfig = (0, $0be56928fb9be645$export$2e2bcd8739ae039);
$f8a4f6b3df7eeb0a$var$axios.AxiosHeaders = (0, $3a63528aa42f3c9f$export$2e2bcd8739ae039);
$f8a4f6b3df7eeb0a$var$axios.formToJSON = (thing)=>(0, $60b6ebd2215ac304$export$2e2bcd8739ae039)((0, $b487538a08a1351e$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$f8a4f6b3df7eeb0a$var$axios.getAdapter = (0, $3562c2f83e7e3bc3$export$2e2bcd8739ae039).getAdapter;
$f8a4f6b3df7eeb0a$var$axios.HttpStatusCode = (0, $d8b478c6a837fd39$export$2e2bcd8739ae039);
$f8a4f6b3df7eeb0a$var$axios.default = $f8a4f6b3df7eeb0a$var$axios;
var // this module should only have a default export
$f8a4f6b3df7eeb0a$export$2e2bcd8739ae039 = $f8a4f6b3df7eeb0a$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $554558d507581b53$export$1c00760e9e5a4e95, AxiosError: $554558d507581b53$export$c1fbed17c2f6a328, CanceledError: $554558d507581b53$export$1ab0c6b20d94fa14, isCancel: $554558d507581b53$export$3b22524397b493c6, CancelToken: $554558d507581b53$export$fd08e3cb425f0d61, VERSION: $554558d507581b53$export$a4ad2735b021c132, all: $554558d507581b53$export$84bf76cd7afc7469, Cancel: $554558d507581b53$export$848c9b7ead0df967, isAxiosError: $554558d507581b53$export$fbafdbe06a5b5a9a, spread: $554558d507581b53$export$3ae0fd4797ed47c8, toFormData: $554558d507581b53$export$10ae0d317ea97f8b, AxiosHeaders: $554558d507581b53$export$4e7d6ff0f3e6520, HttpStatusCode: $554558d507581b53$export$a972f69c851492b3, formToJSON: $554558d507581b53$export$86d7c59254d6a2c9, getAdapter: $554558d507581b53$export$17ddc20a97d669e2, mergeConfig: $554558d507581b53$export$7ec1ebcfa9d8bd6a, create: $554558d507581b53$export$185802fd694ee1f5 } = (0, $f8a4f6b3df7eeb0a$export$2e2bcd8739ae039);


const $5fbcd0fe8a297848$export$a841ecc3dcaeabc6 = async (debug, blob, partNumber, uploadUrl, onProgress)=>{
    if (debug) console.log(`Part #${partNumber} starting, ${blob.size} bytes.`);
    (0, $fde0330eb2207262$exports.addBreadcrumb)({
        category: 'uploadPart',
        message: `Uploading part ${partNumber}`,
        level: 'info'
    });
    const output = await (0, $f8a4f6b3df7eeb0a$export$2e2bcd8739ae039).put(uploadUrl, blob, {
        onUploadProgress: (progressEvent)=>onProgress(progressEvent.loaded)
    });
    const etag = output.headers.etag;
    if (!etag) {
        (0, $fde0330eb2207262$exports.addBreadcrumb)({
            category: 'uploadPart',
            message: `Uploading part ${partNumber} returned headers ${JSON.stringify(output.headers)}`,
            level: 'info'
        });
        throw new Error(`No etag returned with part ${partNumber}.`);
    }
    if (debug) console.log(`Part #${partNumber} done. Got headers:`, output.headers);
    return {
        ETag: etag,
        PartNumber: partNumber + 1
    };
};


/*
How it works:
`this.#head` is an instance of `Node` which keeps track of its current value and nests another instance of `Node` that keeps the value that comes after it. When a value is provided to `.enqueue()`, the code needs to iterate through `this.#head`, going deeper and deeper to find the last value. However, iterating through every single item is slow. This problem is solved by saving a reference to the last value as `this.#tail` so that it can reference it to add a new value.
*/ class $4812e2abb5165fd5$var$Node {
    value;
    next;
    constructor(value){
        this.value = value;
    }
}
class $4812e2abb5165fd5$export$2e2bcd8739ae039 {
    #head;
    #tail;
    #size;
    constructor(){
        this.clear();
    }
    enqueue(value) {
        const node = new $4812e2abb5165fd5$var$Node(value);
        if (this.#head) {
            this.#tail.next = node;
            this.#tail = node;
        } else {
            this.#head = node;
            this.#tail = node;
        }
        this.#size++;
    }
    dequeue() {
        const current = this.#head;
        if (!current) return;
        this.#head = this.#head.next;
        this.#size--;
        // Clean up tail reference when queue becomes empty
        if (!this.#head) this.#tail = undefined;
        return current.value;
    }
    peek() {
        if (!this.#head) return;
        return this.#head.value;
    // TODO: Node.js 18.
    // return this.#head?.value;
    }
    clear() {
        this.#head = undefined;
        this.#tail = undefined;
        this.#size = 0;
    }
    get size() {
        return this.#size;
    }
    *[Symbol.iterator]() {
        let current = this.#head;
        while(current){
            yield current.value;
            current = current.next;
        }
    }
    *drain() {
        while(this.#head)yield this.dequeue();
    }
}


function $0961ae91ac2868c2$export$2e2bcd8739ae039(concurrency) {
    let rejectOnClear = false;
    if (typeof concurrency === 'object') ({ concurrency: concurrency, rejectOnClear: rejectOnClear = false } = concurrency);
    $0961ae91ac2868c2$var$validateConcurrency(concurrency);
    if (typeof rejectOnClear !== 'boolean') throw new TypeError('Expected `rejectOnClear` to be a boolean');
    const queue = new (0, $4812e2abb5165fd5$export$2e2bcd8739ae039)();
    let activeCount = 0;
    const resumeNext = ()=>{
        // Process the next queued function if we're under the concurrency limit
        if (activeCount < concurrency && queue.size > 0) {
            activeCount++;
            queue.dequeue().run();
        }
    };
    const next = ()=>{
        activeCount--;
        resumeNext();
    };
    const run = async (function_, resolve, arguments_)=>{
        // Execute the function and capture the result promise
        const result = (async ()=>function_(...arguments_))();
        // Resolve immediately with the promise (don't wait for completion)
        resolve(result);
        // Wait for the function to complete (success or failure)
        // We catch errors here to prevent unhandled rejections,
        // but the original promise rejection is preserved for the caller
        try {
            await result;
        } catch  {}
        // Decrement active count and process next queued function
        next();
    };
    const enqueue = (function_, resolve, reject, arguments_)=>{
        const queueItem = {
            reject: reject
        };
        // Queue the internal resolve function instead of the run function
        // to preserve the asynchronous execution context.
        new Promise((internalResolve)=>{
            queueItem.run = internalResolve;
            queue.enqueue(queueItem);
        }).then(run.bind(undefined, function_, resolve, arguments_)); // eslint-disable-line promise/prefer-await-to-then
        // Start processing immediately if we haven't reached the concurrency limit
        if (activeCount < concurrency) resumeNext();
    };
    const generator = (function_, ...arguments_)=>new Promise((resolve, reject)=>{
            enqueue(function_, resolve, reject, arguments_);
        });
    Object.defineProperties(generator, {
        activeCount: {
            get: ()=>activeCount
        },
        pendingCount: {
            get: ()=>queue.size
        },
        clearQueue: {
            value () {
                if (!rejectOnClear) {
                    queue.clear();
                    return;
                }
                const abortError = AbortSignal.abort().reason;
                while(queue.size > 0)queue.dequeue().reject(abortError);
            }
        },
        concurrency: {
            get: ()=>concurrency,
            set (newConcurrency) {
                $0961ae91ac2868c2$var$validateConcurrency(newConcurrency);
                concurrency = newConcurrency;
                queueMicrotask(()=>{
                    // eslint-disable-next-line no-unmodified-loop-condition
                    while(activeCount < concurrency && queue.size > 0)resumeNext();
                });
            }
        },
        map: {
            async value (iterable, function_) {
                const promises = Array.from(iterable, (value, index)=>this(function_, value, index));
                return Promise.all(promises);
            }
        }
    });
    return generator;
}
function $0961ae91ac2868c2$export$9ee77266c10f66ac(function_, options) {
    const limit = $0961ae91ac2868c2$export$2e2bcd8739ae039(options);
    return (...arguments_)=>limit(()=>function_(...arguments_));
}
function $0961ae91ac2868c2$var$validateConcurrency(concurrency) {
    if (!((Number.isInteger(concurrency) || concurrency === Number.POSITIVE_INFINITY) && concurrency > 0)) throw new TypeError('Expected `concurrency` to be a number from 1 and up');
}


const $d7cb29757763b107$export$552b5ebb30950f43 = (possible)=>possible.ok !== true;
const $d7cb29757763b107$export$7f9256869ac7089d = async (remoteURL, body, token)=>{
    const response = await fetch(`${"/api"}${remoteURL}`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'content-type': 'application/json',
            ...token !== undefined && {
                authorization: 'Bearer ' + token
            }
        }
    });
    return response.json();
};
const $d7cb29757763b107$export$17c9ea52b1405864 = async (token, fileName, episode, draft)=>$d7cb29757763b107$export$7f9256869ac7089d('/begin', {
        fileName: fileName,
        episode: episode,
        draft: draft
    }, token);
const $d7cb29757763b107$export$7f325ef6fbbf58c2 = (token, partNumber)=>$d7cb29757763b107$export$7f9256869ac7089d('/part', {
        partNumber: partNumber
    }, token);
const $d7cb29757763b107$export$c5cca7b9958877f9 = async (token)=>$d7cb29757763b107$export$7f9256869ac7089d('/abandon', {}, token);
const $d7cb29757763b107$export$f00622a6ffafeaf6 = async (token, parts)=>$d7cb29757763b107$export$7f9256869ac7089d('/finish', {
        parts: parts
    }, token);
const $d7cb29757763b107$export$d5442555a9f185f8 = async (presenterId)=>$d7cb29757763b107$export$7f9256869ac7089d(`/presenter/${encodeURIComponent(presenterId)}`, {});



const $646fb5682e9718c3$var$FILE_CHUNK_SIZE = 10000000;
const $646fb5682e9718c3$var$calculateProgress = (allParts)=>allParts.reduce((prev, curr)=>prev + curr.uploadedBytes, 0);
const $646fb5682e9718c3$var$createUploadSliceTask = (debug, uploadToken, partNumber, file, onProgress)=>async ()=>{
        if (debug) console.log(`Requesting URL for ${partNumber}`);
        const partURLResponse = await (0, $d7cb29757763b107$export$7f325ef6fbbf58c2)(uploadToken, partNumber);
        if ((0, $d7cb29757763b107$export$552b5ebb30950f43)(partURLResponse)) throw new Error(partURLResponse.error);
        const slice = file.slice(partNumber * $646fb5682e9718c3$var$FILE_CHUNK_SIZE, Math.min((partNumber + 1) * $646fb5682e9718c3$var$FILE_CHUNK_SIZE, file.size));
        return (0, $5fbcd0fe8a297848$export$a841ecc3dcaeabc6)(debug, slice, partNumber, partURLResponse.partURL, onProgress);
    };
const $646fb5682e9718c3$export$a3c8e1472dc2ed84 = async (debug, token, file, episode, draft, onProgress)=>{
    const partCounts = Math.ceil(file.size / $646fb5682e9718c3$var$FILE_CHUNK_SIZE);
    (0, $fde0330eb2207262$exports.addBreadcrumb)({
        category: 'upload',
        message: 'Get Upload ID',
        level: 'info'
    });
    const uploadIdResponse = await (0, $d7cb29757763b107$export$17c9ea52b1405864)(token, file.name, episode, draft);
    if ((0, $d7cb29757763b107$export$552b5ebb30950f43)(uploadIdResponse)) throw new Error(uploadIdResponse.error);
    const uploadToken = uploadIdResponse.token;
    const promises = [];
    const partProgress = [];
    const updateTotalProgress = ()=>{
        const totalProgress = $646fb5682e9718c3$var$calculateProgress(partProgress);
        onProgress(totalProgress);
    };
    const limit = (0, $0961ae91ac2868c2$export$2e2bcd8739ae039)(4);
    for(let part = 0; part < partCounts; part++){
        partProgress[part] = {
            uploadedBytes: 0
        };
        promises.push(limit($646fb5682e9718c3$var$createUploadSliceTask(debug, uploadToken, part, file, (loadedBytes)=>{
            partProgress[part].uploadedBytes = loadedBytes;
            updateTotalProgress();
        })));
    }
    try {
        const completedParts = await Promise.all(promises);
        if (debug) console.log('completedParts', completedParts);
        (0, $fde0330eb2207262$exports.addBreadcrumb)({
            category: 'upload',
            message: `Uploaded parts ${completedParts.length}`,
            level: 'info'
        });
        const completeUploadResponse = await (0, $d7cb29757763b107$export$f00622a6ffafeaf6)(uploadToken, completedParts);
        if ((0, $d7cb29757763b107$export$552b5ebb30950f43)(completeUploadResponse)) {
            (0, $fde0330eb2207262$exports.addBreadcrumb)({
                category: 'upload',
                message: `Error completing the upload: ${completeUploadResponse.error}`,
                level: 'fatal'
            });
            throw new Error('Unable to complete upload.');
        }
    } catch (err) {
        if (debug) console.log('Abandoning because', err);
        await (0, $d7cb29757763b107$export$c5cca7b9958877f9)(uploadToken);
        throw err;
    }
};



const $89737a7620d92c12$export$4f9c77fda34ec347 = (progressBar, setFormBeingProcessed, showAlert, setSpinnerHidden, debug, token)=>async (file, episode, draft)=>{
        try {
            setSpinnerHidden(false);
            progressBar.setHidden(false);
            await (0, $646fb5682e9718c3$export$a3c8e1472dc2ed84)(debug, token, file, episode, draft, (loadedBytes)=>{
                if (debug) console.log('Updating progress...', loadedBytes, file.size, loadedBytes / file.size * 100);
                progressBar.setProgress(loadedBytes / file.size * 100);
            });
            setSpinnerHidden(true);
            progressBar.setHidden(true);
            showAlert('Upload finished succesfully', 'success');
        } catch (error) {
            if (debug) console.error('Error', error);
            $fde0330eb2207262$exports.captureException(error, {
                tags: {
                    episode: episode === null ? 'null' : `${episode}`,
                    draft: draft === null ? 'null' : `${draft}`,
                    fileName: file.name
                }
            });
            showAlert(error.message, 'danger');
            setFormBeingProcessed(false);
            setSpinnerHidden(true);
            progressBar.setHidden(true);
        }
    };



// Parse an integer URL parameter, returning null when the parameter is
// absent, empty, or non-numeric. Centralises the nullable-int parsing for
// optional query params like ?episode= and ?draft=.
const $ba285e92734dae2e$var$parseOptionalIntParam = (params, key)=>{
    const raw = params.get(key);
    if (raw === null) return null;
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : null;
};
console.log('process.env.SENTRY_DSN', "https://68da6aa779154e93953d4a75062f8b2e@o517038.ingest.sentry.io/5624259");
(0, $7d4c0370f4ae1e04$export$2cd8252107eb640b)({
    dsn: "https://68da6aa779154e93953d4a75062f8b2e@o517038.ingest.sentry.io/5624259",
    integrations: [
        (0, $8bc13e8f9b2f488c$export$b4109253475213e9)()
    ],
    tracesSampleRate: 0,
    release: `video-uploader@${""}`,
    environment: location.host
});
const $ba285e92734dae2e$var$setup = async ()=>{
    const presenterInput = document.getElementById('presenter-name');
    const presentationTitle = document.getElementById('presentation-title');
    const fileInput = document.getElementById('file-input');
    const formEl = document.getElementById('upload-form');
    const progressBar = (0, $1fd3c7d1cf184b80$export$cd09ce48f3054f09)(document.getElementById('upload-progress'));
    const showAlert = (0, $7ba68a4aa3259968$export$3dd5973b7da73e99)(formEl);
    const setSpinnerHidden = (0, $015fb139fe640229$export$306a681a1fc87013)(document.getElementById('upload-spinner'));
    const setPresenterNameHidden = (0, $015fb139fe640229$export$306a681a1fc87013)(presenterInput.parentElement);
    const setPresentationTitleHidden = (0, $015fb139fe640229$export$306a681a1fc87013)(presentationTitle.parentElement);
    const setFileHidden = (0, $015fb139fe640229$export$306a681a1fc87013)(fileInput.parentElement);
    const setSubmitHidden = (0, $015fb139fe640229$export$306a681a1fc87013)(document.getElementById('submit-button'));
    const setFormBeingProcessed = (hidden)=>{
        [
            setPresenterNameHidden,
            setPresentationTitleHidden,
            setFileHidden,
            setSubmitHidden
        ].forEach((setElHidden)=>setElHidden(hidden));
    };
    setFormBeingProcessed(true);
    setSpinnerHidden(false);
    try {
        const params = new URLSearchParams(window.location.search);
        const debug = params.has('debug');
        const presenter = params.get('presenter');
        // `episode` is the pk of the scheduled talk this upload is for. Optional:
        // the presenter portal's "Other Uploads" form lets presenters upload
        // sponsor ads / promo clips that aren't attached to a specific talk.
        // When absent (or malformed) we skip the presentation lookup entirely.
        //
        // `draft` is the pk of a pre-created VirtualEventPrerecordedFile row that
        // this upload should fill in. Forwarded to the portal as `draft_pk` at
        // finish-upload time. Optional — legacy talk-prerecord flow doesn't use
        // drafts.
        const episode = $ba285e92734dae2e$var$parseOptionalIntParam(params, 'episode');
        const draft = $ba285e92734dae2e$var$parseOptionalIntParam(params, 'draft');
        (0, $fde0330eb2207262$exports.addBreadcrumb)({
            category: 'setup',
            message: `Looking for ${presenter} episode ${episode ?? 'none'} draft ${draft ?? 'none'}. Debug is ${debug ? 'on' : 'off'}`,
            level: 'info'
        });
        const portalDetails = await (0, $d7cb29757763b107$export$d5442555a9f185f8)(presenter);
        if ((0, $d7cb29757763b107$export$552b5ebb30950f43)(portalDetails)) {
            if (portalDetails.error === 'Not found') {
                showAlert('Presenter not found', 'danger');
                setSpinnerHidden(true);
                return;
            }
            throw new Error(`Could not obtain presenter (${presenter}) details: ${portalDetails.error}`);
        }
        presenterInput.value = portalDetails.name;
        if (episode === null) // "Other" upload — no scheduled talk to look up. The presenter
        // already picked the file's kind/title in the portal, so show a
        // generic label here.
        presentationTitle.value = 'Other upload';
        else {
            const presentation = portalDetails.presentations.find(({ pk: pk })=>pk === episode);
            if (!presentation) throw new Error(`Could not find episode: ${episode}`);
            presentationTitle.value = presentation.name;
        }
        const uploadFile = (0, $89737a7620d92c12$export$4f9c77fda34ec347)(progressBar, setFormBeingProcessed, showAlert, setSpinnerHidden, debug, portalDetails.token);
        fileInput.addEventListener('change', ()=>{
            if (fileInput.files.length > 0) {
                fileInput.parentElement.querySelector('label').textContent = fileInput.files[0].name;
                (0, $fde0330eb2207262$exports.addBreadcrumb)({
                    category: 'file',
                    message: 'User picked a file',
                    level: 'info'
                });
            }
        });
        const submitForm = async ()=>{
            if (formEl.checkValidity() === false) {
                formEl.classList.add('was-validated');
                return;
            }
            setFormBeingProcessed(true);
            const file = fileInput.files[0];
            (0, $fde0330eb2207262$exports.addBreadcrumb)({
                category: 'file',
                message: 'Upload file...',
                level: 'info'
            });
            await uploadFile(file, episode, draft);
        };
        formEl.addEventListener('submit', (event)=>{
            event.preventDefault();
            event.stopPropagation();
            submitForm();
        }, false);
        setFormBeingProcessed(false);
        setSpinnerHidden(true);
    } catch (error) {
        (0, $fde0330eb2207262$exports.captureException)(error);
        showAlert(error.message, 'danger');
        setSpinnerHidden(true);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $ba285e92734dae2e$var$setup().catch((err)=>(0, $fde0330eb2207262$exports.captureException)(err));
});


//# sourceMappingURL=frontend.85a16714.js.map
